//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterOutput>(null as any);
    }
}

@Injectable()
export class ClientServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getClient(id: number | undefined): Observable<ClientDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetClient?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDto>;
        }));
    }

    protected processGetClient(response: HttpResponseBase): Observable<ClientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientDto>(null as any);
    }

    /**
     * @param clientId (optional) 
     * @return Success
     */
    getBranchesByClientId(clientId: number | undefined): Observable<Branch[]> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetBranchesByClientId?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchesByClientId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchesByClientId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Branch[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Branch[]>;
        }));
    }

    protected processGetBranchesByClientId(response: HttpResponseBase): Observable<Branch[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Branch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Branch[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param type (optional) 
     * @return Success
     */
    getClientListAll(companyId: number | undefined, type: number | undefined): Observable<ClientSmallDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetClientListAll?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientListAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientListAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientSmallDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientSmallDto[]>;
        }));
    }

    protected processGetClientListAll(response: HttpResponseBase): Observable<ClientSmallDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ClientSmallDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientSmallDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param code (optional) 
     * @param definition (optional) 
     * @param isDeleted (optional) 
     * @return Success
     */
    getClientList(companyId: number | undefined, code: string | null | undefined, definition: string | null | undefined, isDeleted: boolean | undefined): Observable<ClientDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetClientList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (definition !== undefined && definition !== null)
            url_ += "definition=" + encodeURIComponent("" + definition) + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDto[]>;
        }));
    }

    protected processGetClientList(response: HttpResponseBase): Observable<ClientDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ClientDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param code (optional) 
     * @param name (optional) 
     * @param isDeleted (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getClientListPaged(companyId: number | undefined, code: string | null | undefined, name: string | null | undefined, isDeleted: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ClientDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetClientListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDtoPagedResultDto>;
        }));
    }

    protected processGetClientListPaged(response: HttpResponseBase): Observable<ClientDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getClientExtended(id: number | undefined): Observable<ClientExtendedDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetClientExtended?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientExtended(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientExtended(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientExtendedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientExtendedDto>;
        }));
    }

    protected processGetClientExtended(response: HttpResponseBase): Observable<ClientExtendedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientExtendedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientExtendedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateClient(body: ClientExtendedDto | undefined): Observable<ClientExtendedDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/UpdateClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientExtendedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientExtendedDto>;
        }));
    }

    protected processUpdateClient(response: HttpResponseBase): Observable<ClientExtendedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientExtendedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientExtendedDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteClient(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/DeleteClient?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createClientBatch(body: BatchClientInsertDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/CreateClientBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateClientBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateClientBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateClientBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param code (optional) 
     * @param companyId (optional) 
     * @return Success
     */
    getClientByCode(code: string | null | undefined, companyId: number | undefined): Observable<Client> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetClientByCode?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Client>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Client>;
        }));
    }

    protected processGetClientByCode(response: HttpResponseBase): Observable<Client> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Client.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Client>(null as any);
    }
}

@Injectable()
export class CommonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined): Observable<CommonSetting> {
        let url_ = this.baseUrl + "/api/services/app/Common/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonSetting>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonSetting>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<CommonSetting> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonSetting.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommonSetting>(null as any);
    }

    /**
     * @param key (optional) 
     * @return Success
     */
    get(key: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Common/Get?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CommonSetting | undefined): Observable<CommonSetting> {
        let url_ = this.baseUrl + "/api/services/app/Common/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonSetting>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonSetting>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CommonSetting> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonSetting.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommonSetting>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insert(body: CommonSetting | undefined): Observable<CommonSetting> {
        let url_ = this.baseUrl + "/api/services/app/Common/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonSetting>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonSetting>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<CommonSetting> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonSetting.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommonSetting>(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<CommonSetting[]> {
        let url_ = this.baseUrl + "/api/services/app/Common/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonSetting[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonSetting[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CommonSetting[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CommonSetting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommonSetting[]>(null as any);
    }

    /**
     * @return Success
     */
    getPdaVersion(): Observable<PdaVersion> {
        let url_ = this.baseUrl + "/api/services/app/Common/GetPdaVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdaVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdaVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PdaVersion>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PdaVersion>;
        }));
    }

    protected processGetPdaVersion(response: HttpResponseBase): Observable<PdaVersion> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PdaVersion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PdaVersion>(null as any);
    }

    /**
     * @param version (optional) 
     * @param downloadLink (optional) 
     * @return Success
     */
    updatePdaVersion(version: string | null | undefined, downloadLink: string | null | undefined): Observable<PdaVersion> {
        let url_ = this.baseUrl + "/api/services/app/Common/UpdatePdaVersion?";
        if (version !== undefined && version !== null)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        if (downloadLink !== undefined && downloadLink !== null)
            url_ += "downloadLink=" + encodeURIComponent("" + downloadLink) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePdaVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePdaVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PdaVersion>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PdaVersion>;
        }));
    }

    protected processUpdatePdaVersion(response: HttpResponseBase): Observable<PdaVersion> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PdaVersion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PdaVersion>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    getCountryList(companyId: number | undefined): Observable<GeoLocationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Common/GetCountryList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeoLocationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeoLocationDto[]>;
        }));
    }

    protected processGetCountryList(response: HttpResponseBase): Observable<GeoLocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GeoLocationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeoLocationDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param country (optional) 
     * @return Success
     */
    getCityList(companyId: number | undefined, country: string | null | undefined): Observable<GeoLocationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Common/GetCityList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeoLocationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeoLocationDto[]>;
        }));
    }

    protected processGetCityList(response: HttpResponseBase): Observable<GeoLocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GeoLocationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeoLocationDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param country (optional) 
     * @param city (optional) 
     * @return Success
     */
    getTownList(companyId: number | undefined, country: string | null | undefined, city: string | null | undefined): Observable<GeoLocationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Common/GetTownList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (city !== undefined && city !== null)
            url_ += "city=" + encodeURIComponent("" + city) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTownList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTownList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeoLocationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeoLocationDto[]>;
        }));
    }

    protected processGetTownList(response: HttpResponseBase): Observable<GeoLocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GeoLocationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeoLocationDto[]>(null as any);
    }
}

@Injectable()
export class CompanyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCompanyList(): Observable<CompanyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto[]>;
        }));
    }

    protected processGetCompanyList(response: HttpResponseBase): Observable<CompanyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CompanyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCompany(id: number | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompany?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processGetCompany(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param code (optional) 
     * @param definition (optional) 
     * @return Success
     */
    updateCompany(id: number | undefined, code: string | null | undefined, definition: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Company/UpdateCompany?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (definition !== undefined && definition !== null)
            url_ += "definition=" + encodeURIComponent("" + definition) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param code (optional) 
     * @param definition (optional) 
     * @return Success
     */
    createCompany(code: string | null | undefined, definition: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Company/CreateCompany?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (definition !== undefined && definition !== null)
            url_ += "definition=" + encodeURIComponent("" + definition) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteCompany(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Company/DeleteCompany?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getCompanyDataSourceList(): Observable<CompanyDataSource[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyDataSourceList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyDataSourceList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyDataSourceList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDataSource[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDataSource[]>;
        }));
    }

    protected processGetCompanyDataSourceList(response: HttpResponseBase): Observable<CompanyDataSource[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CompanyDataSource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDataSource[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCompanyDataSource(id: number | undefined): Observable<CompanyDataSource> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyDataSource?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyDataSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyDataSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDataSource>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDataSource>;
        }));
    }

    protected processGetCompanyDataSource(response: HttpResponseBase): Observable<CompanyDataSource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDataSource.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDataSource>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCompanyDataSource(body: CompanyDataSource | undefined): Observable<CompanyDataSource> {
        let url_ = this.baseUrl + "/api/services/app/Company/CreateCompanyDataSource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCompanyDataSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCompanyDataSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDataSource>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDataSource>;
        }));
    }

    protected processCreateCompanyDataSource(response: HttpResponseBase): Observable<CompanyDataSource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDataSource.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDataSource>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCompanyDataSource(body: CompanyDataSource | undefined): Observable<CompanyDataSource> {
        let url_ = this.baseUrl + "/api/services/app/Company/UpdateCompanyDataSource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompanyDataSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompanyDataSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDataSource>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDataSource>;
        }));
    }

    protected processUpdateCompanyDataSource(response: HttpResponseBase): Observable<CompanyDataSource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDataSource.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDataSource>(null as any);
    }

    /**
     * @param id (optional) 
     * @param erptype (optional) 
     * @param database (optional) 
     * @param ip (optional) 
     * @param username (optional) 
     * @param password (optional) 
     * @param logoCompany (optional) 
     * @param logoTerm (optional) 
     * @param netsisBranchCode (optional) 
     * @param islogogo (optional) 
     * @return Success
     */
    updateErpDbConnection(id: number | undefined, erptype: string | null | undefined, database: string | null | undefined, ip: string | null | undefined, username: string | null | undefined, password: string | null | undefined, logoCompany: number | undefined, logoTerm: number | undefined, netsisBranchCode: number | undefined, islogogo: boolean | undefined): Observable<ErpDbConnection> {
        let url_ = this.baseUrl + "/api/services/app/Company/UpdateErpDbConnection?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (erptype !== undefined && erptype !== null)
            url_ += "erptype=" + encodeURIComponent("" + erptype) + "&";
        if (database !== undefined && database !== null)
            url_ += "database=" + encodeURIComponent("" + database) + "&";
        if (ip !== undefined && ip !== null)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (logoCompany === null)
            throw new Error("The parameter 'logoCompany' cannot be null.");
        else if (logoCompany !== undefined)
            url_ += "logoCompany=" + encodeURIComponent("" + logoCompany) + "&";
        if (logoTerm === null)
            throw new Error("The parameter 'logoTerm' cannot be null.");
        else if (logoTerm !== undefined)
            url_ += "logoTerm=" + encodeURIComponent("" + logoTerm) + "&";
        if (netsisBranchCode === null)
            throw new Error("The parameter 'netsisBranchCode' cannot be null.");
        else if (netsisBranchCode !== undefined)
            url_ += "netsisBranchCode=" + encodeURIComponent("" + netsisBranchCode) + "&";
        if (islogogo === null)
            throw new Error("The parameter 'islogogo' cannot be null.");
        else if (islogogo !== undefined)
            url_ += "islogogo=" + encodeURIComponent("" + islogogo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateErpDbConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateErpDbConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpDbConnection>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpDbConnection>;
        }));
    }

    protected processUpdateErpDbConnection(response: HttpResponseBase): Observable<ErpDbConnection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErpDbConnection.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpDbConnection>(null as any);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class DashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @return Success
     */
    getWayBillHeaderDashboardCount(companyId: number | undefined, warehouseId: number | undefined, dateStart: Date | null | undefined, dateEnd: Date | null | undefined): Observable<DashWaybillHeaderCountDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetWayBillHeaderDashboardCount?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (dateStart !== undefined && dateStart !== null)
            url_ += "dateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toISOString() : "") + "&";
        if (dateEnd !== undefined && dateEnd !== null)
            url_ += "dateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWayBillHeaderDashboardCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWayBillHeaderDashboardCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashWaybillHeaderCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashWaybillHeaderCountDto>;
        }));
    }

    protected processGetWayBillHeaderDashboardCount(response: HttpResponseBase): Observable<DashWaybillHeaderCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashWaybillHeaderCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashWaybillHeaderCountDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @return Success
     */
    getOrderHeaderDashboardCount(companyId: number | undefined, warehouseId: number | undefined, dateStart: Date | null | undefined, dateEnd: Date | null | undefined): Observable<DashOrderHeaderCountDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetOrderHeaderDashboardCount?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (dateStart !== undefined && dateStart !== null)
            url_ += "dateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toISOString() : "") + "&";
        if (dateEnd !== undefined && dateEnd !== null)
            url_ += "dateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderDashboardCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderDashboardCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashOrderHeaderCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashOrderHeaderCountDto>;
        }));
    }

    protected processGetOrderHeaderDashboardCount(response: HttpResponseBase): Observable<DashOrderHeaderCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashOrderHeaderCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashOrderHeaderCountDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @return Success
     */
    getDashboardOrderHeaderPickingPerformance(companyId: number | undefined, warehouseId: number | undefined, dateStart: Date | null | undefined, dateEnd: Date | null | undefined): Observable<DashOrderHeaderPickingPerformanceDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDashboardOrderHeaderPickingPerformance?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (dateStart !== undefined && dateStart !== null)
            url_ += "dateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toISOString() : "") + "&";
        if (dateEnd !== undefined && dateEnd !== null)
            url_ += "dateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardOrderHeaderPickingPerformance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardOrderHeaderPickingPerformance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashOrderHeaderPickingPerformanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashOrderHeaderPickingPerformanceDto>;
        }));
    }

    protected processGetDashboardOrderHeaderPickingPerformance(response: HttpResponseBase): Observable<DashOrderHeaderPickingPerformanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashOrderHeaderPickingPerformanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashOrderHeaderPickingPerformanceDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getControlPointDashboardCount(companyId: number | undefined, warehouseId: number | undefined): Observable<DashControlPointCountDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetControlPointDashboardCount?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlPointDashboardCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlPointDashboardCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashControlPointCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashControlPointCountDto>;
        }));
    }

    protected processGetControlPointDashboardCount(response: HttpResponseBase): Observable<DashControlPointCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashControlPointCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashControlPointCountDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @return Success
     */
    getOrderHeaderDashCountInandOut(companyId: number | undefined, warehouseId: number | undefined, dateStart: Date | null | undefined, dateEnd: Date | null | undefined): Observable<DashInAndOutOrderHeaderCountDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetOrderHeaderDashCountInandOut?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (dateStart !== undefined && dateStart !== null)
            url_ += "dateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toISOString() : "") + "&";
        if (dateEnd !== undefined && dateEnd !== null)
            url_ += "dateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderDashCountInandOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderDashCountInandOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashInAndOutOrderHeaderCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashInAndOutOrderHeaderCountDto>;
        }));
    }

    protected processGetOrderHeaderDashCountInandOut(response: HttpResponseBase): Observable<DashInAndOutOrderHeaderCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashInAndOutOrderHeaderCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashInAndOutOrderHeaderCountDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @return Success
     */
    getWastedTimeForOrderHeaders(companyId: number | undefined, warehouseId: number | undefined, dateStart: Date | null | undefined, dateEnd: Date | null | undefined): Observable<DashWastedTimeOrderHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetWastedTimeForOrderHeaders?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (dateStart !== undefined && dateStart !== null)
            url_ += "dateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toISOString() : "") + "&";
        if (dateEnd !== undefined && dateEnd !== null)
            url_ += "dateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWastedTimeForOrderHeaders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWastedTimeForOrderHeaders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashWastedTimeOrderHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashWastedTimeOrderHeaderDto>;
        }));
    }

    protected processGetWastedTimeForOrderHeaders(response: HttpResponseBase): Observable<DashWastedTimeOrderHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashWastedTimeOrderHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashWastedTimeOrderHeaderDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param sdate (optional) 
     * @param fdate (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getBestSellers(companyId: number | undefined, sdate: Date | undefined, fdate: Date | undefined, limit: number | undefined): Observable<DashControlBestSalesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetBestSellers?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (sdate === null)
            throw new Error("The parameter 'sdate' cannot be null.");
        else if (sdate !== undefined)
            url_ += "Sdate=" + encodeURIComponent(sdate ? "" + sdate.toISOString() : "") + "&";
        if (fdate === null)
            throw new Error("The parameter 'fdate' cannot be null.");
        else if (fdate !== undefined)
            url_ += "Fdate=" + encodeURIComponent(fdate ? "" + fdate.toISOString() : "") + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBestSellers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBestSellers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashControlBestSalesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashControlBestSalesDto[]>;
        }));
    }

    protected processGetBestSellers(response: HttpResponseBase): Observable<DashControlBestSalesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DashControlBestSalesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashControlBestSalesDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param sdate (optional) 
     * @param fdate (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getBestPurchasingClients(companyId: number | undefined, sdate: Date | undefined, fdate: Date | undefined, limit: number | undefined): Observable<DashControlType1Dto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetBestPurchasingClients?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (sdate === null)
            throw new Error("The parameter 'sdate' cannot be null.");
        else if (sdate !== undefined)
            url_ += "Sdate=" + encodeURIComponent(sdate ? "" + sdate.toISOString() : "") + "&";
        if (fdate === null)
            throw new Error("The parameter 'fdate' cannot be null.");
        else if (fdate !== undefined)
            url_ += "Fdate=" + encodeURIComponent(fdate ? "" + fdate.toISOString() : "") + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBestPurchasingClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBestPurchasingClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashControlType1Dto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashControlType1Dto[]>;
        }));
    }

    protected processGetBestPurchasingClients(response: HttpResponseBase): Observable<DashControlType1Dto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DashControlType1Dto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashControlType1Dto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param date (optional) 
     * @return Success
     */
    getToDayWarehouseOrderCount(companyId: number | undefined, date: Date | undefined): Observable<DashControlType1Dto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetToDayWarehouseOrderCount?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToDayWarehouseOrderCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToDayWarehouseOrderCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashControlType1Dto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashControlType1Dto[]>;
        }));
    }

    protected processGetToDayWarehouseOrderCount(response: HttpResponseBase): Observable<DashControlType1Dto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DashControlType1Dto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashControlType1Dto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param date (optional) 
     * @return Success
     */
    getToDayCityOrderCount(companyId: number | undefined, date: Date | undefined): Observable<DashControlType1Dto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetToDayCityOrderCount?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToDayCityOrderCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToDayCityOrderCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashControlType1Dto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashControlType1Dto[]>;
        }));
    }

    protected processGetToDayCityOrderCount(response: HttpResponseBase): Observable<DashControlType1Dto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DashControlType1Dto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashControlType1Dto[]>(null as any);
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    getToDayBestPicker(date: Date | undefined): Observable<DashControlType1Dto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetToDayBestPicker?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToDayBestPicker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToDayBestPicker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashControlType1Dto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashControlType1Dto[]>;
        }));
    }

    protected processGetToDayBestPicker(response: HttpResponseBase): Observable<DashControlType1Dto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DashControlType1Dto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashControlType1Dto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @return Success
     */
    getDashboardChartCountDto(companyId: number | undefined, warehouseId: number | undefined, startTime: Date | null | undefined, endTime: Date | null | undefined): Observable<DashboardChartCountDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDashboardChartCountDto?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardChartCountDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardChartCountDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardChartCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardChartCountDto>;
        }));
    }

    protected processGetDashboardChartCountDto(response: HttpResponseBase): Observable<DashboardChartCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardChartCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardChartCountDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @return Success
     */
    getDashboardChartWaybillCount(companyId: number | undefined, warehouseId: number | undefined, startTime: Date | null | undefined, endTime: Date | null | undefined): Observable<DashboardWaybillDapperDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDashboardChartWaybillCount?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardChartWaybillCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardChartWaybillCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardWaybillDapperDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardWaybillDapperDto[]>;
        }));
    }

    protected processGetDashboardChartWaybillCount(response: HttpResponseBase): Observable<DashboardWaybillDapperDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DashboardWaybillDapperDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardWaybillDapperDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @return Success
     */
    getDashboardChartOrderCount(companyId: number | undefined, warehouseId: number | undefined, startTime: Date | null | undefined, endTime: Date | null | undefined): Observable<DashboardChartOrderDapperDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDashboardChartOrderCount?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardChartOrderCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardChartOrderCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardChartOrderDapperDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardChartOrderDapperDto[]>;
        }));
    }

    protected processGetDashboardChartOrderCount(response: HttpResponseBase): Observable<DashboardChartOrderDapperDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DashboardChartOrderDapperDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardChartOrderDapperDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @return Success
     */
    getDashboardChartClientCount(companyId: number | undefined, warehouseId: number | undefined, startTime: Date | null | undefined, endTime: Date | null | undefined): Observable<DashboardClientSalesTopDapperDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDashboardChartClientCount?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardChartClientCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardChartClientCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardClientSalesTopDapperDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardClientSalesTopDapperDto[]>;
        }));
    }

    protected processGetDashboardChartClientCount(response: HttpResponseBase): Observable<DashboardClientSalesTopDapperDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DashboardClientSalesTopDapperDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardClientSalesTopDapperDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @return Success
     */
    getDashboardChartProductCount(companyId: number | undefined, warehouseId: number | undefined, startTime: Date | null | undefined, endTime: Date | null | undefined): Observable<DashboardProductSalesTopDapperDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDashboardChartProductCount?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardChartProductCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardChartProductCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardProductSalesTopDapperDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardProductSalesTopDapperDto[]>;
        }));
    }

    protected processGetDashboardChartProductCount(response: HttpResponseBase): Observable<DashboardProductSalesTopDapperDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DashboardProductSalesTopDapperDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardProductSalesTopDapperDto[]>(null as any);
    }
}

@Injectable()
export class DeliveryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDeliveryHeader(id: number | undefined): Observable<DeliveryHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/Delivery/GetDeliveryHeader?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryHeaderDto>;
        }));
    }

    protected processGetDeliveryHeader(response: HttpResponseBase): Observable<DeliveryHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryHeaderDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param shippingTypeId (optional) 
     * @param receiver (optional) 
     * @param receiverTel (optional) 
     * @param licensePlate (optional) 
     * @param documentNo (optional) 
     * @param deliveryHeaderStatusId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getDeliveryHeaderListAllPaged(companyId: number | undefined, warehouseId: number | undefined, shippingTypeId: number | undefined, receiver: string | null | undefined, receiverTel: string | null | undefined, licensePlate: string | null | undefined, documentNo: string | null | undefined, deliveryHeaderStatusId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DeliveryHeaderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Delivery/GetDeliveryHeaderListAllPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "ShippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (receiver !== undefined && receiver !== null)
            url_ += "Receiver=" + encodeURIComponent("" + receiver) + "&";
        if (receiverTel !== undefined && receiverTel !== null)
            url_ += "ReceiverTel=" + encodeURIComponent("" + receiverTel) + "&";
        if (licensePlate !== undefined && licensePlate !== null)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (deliveryHeaderStatusId === null)
            throw new Error("The parameter 'deliveryHeaderStatusId' cannot be null.");
        else if (deliveryHeaderStatusId !== undefined)
            url_ += "DeliveryHeaderStatusId=" + encodeURIComponent("" + deliveryHeaderStatusId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryHeaderListAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryHeaderListAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryHeaderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryHeaderDtoPagedResultDto>;
        }));
    }

    protected processGetDeliveryHeaderListAllPaged(response: HttpResponseBase): Observable<DeliveryHeaderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryHeaderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryHeaderDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getDeliveryHeaderListPda(companyId: number | undefined, warehouseId: number | undefined): Observable<DeliveryHeaderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Delivery/GetDeliveryHeaderListPda?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryHeaderListPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryHeaderListPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryHeaderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryHeaderDto[]>;
        }));
    }

    protected processGetDeliveryHeaderListPda(response: HttpResponseBase): Observable<DeliveryHeaderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DeliveryHeaderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryHeaderDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param receiver (optional) 
     * @param receiverTel (optional) 
     * @param licensePlate (optional) 
     * @param shippingTypeId (optional) 
     * @return Success
     */
    createDeliveryHeader(companyId: number | undefined, warehouseId: number | undefined, receiver: string | null | undefined, receiverTel: string | null | undefined, licensePlate: string | null | undefined, shippingTypeId: number | undefined): Observable<DeliveryHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/Delivery/CreateDeliveryHeader?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (receiver !== undefined && receiver !== null)
            url_ += "receiver=" + encodeURIComponent("" + receiver) + "&";
        if (receiverTel !== undefined && receiverTel !== null)
            url_ += "receiverTel=" + encodeURIComponent("" + receiverTel) + "&";
        if (licensePlate !== undefined && licensePlate !== null)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "shippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDeliveryHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDeliveryHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryHeaderDto>;
        }));
    }

    protected processCreateDeliveryHeader(response: HttpResponseBase): Observable<DeliveryHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryHeaderDto>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @param receiver (optional) 
     * @param receiverTel (optional) 
     * @param licencePlate (optional) 
     * @param shippingTypeId (optional) 
     * @return Success
     */
    updateDeliveryHeader(headerId: number | undefined, receiver: string | null | undefined, receiverTel: string | null | undefined, licencePlate: string | null | undefined, shippingTypeId: number | undefined): Observable<DeliveryHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/Delivery/UpdateDeliveryHeader?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        if (receiver !== undefined && receiver !== null)
            url_ += "receiver=" + encodeURIComponent("" + receiver) + "&";
        if (receiverTel !== undefined && receiverTel !== null)
            url_ += "receiverTel=" + encodeURIComponent("" + receiverTel) + "&";
        if (licencePlate !== undefined && licencePlate !== null)
            url_ += "licencePlate=" + encodeURIComponent("" + licencePlate) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "shippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDeliveryHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDeliveryHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryHeaderDto>;
        }));
    }

    protected processUpdateDeliveryHeader(response: HttpResponseBase): Observable<DeliveryHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryHeaderDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteDeliveryHeader(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Delivery/DeleteDeliveryHeader?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDeliveryHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDeliveryHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDeliveryHeader(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @return Success
     */
    finishDeliveryHeader(headerId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Delivery/FinishDeliveryHeader?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishDeliveryHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishDeliveryHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishDeliveryHeader(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param deliveryHeaderId (optional) 
     * @param orderHeaderId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param no (optional) 
     * @param barcode (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getDeliveryDetail(deliveryHeaderId: number | undefined, orderHeaderId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, no: number | undefined, barcode: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DeliveryDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Delivery/GetDeliveryDetail?";
        if (deliveryHeaderId === null)
            throw new Error("The parameter 'deliveryHeaderId' cannot be null.");
        else if (deliveryHeaderId !== undefined)
            url_ += "DeliveryHeaderId=" + encodeURIComponent("" + deliveryHeaderId) + "&";
        if (orderHeaderId === null)
            throw new Error("The parameter 'orderHeaderId' cannot be null.");
        else if (orderHeaderId !== undefined)
            url_ += "OrderHeaderId=" + encodeURIComponent("" + orderHeaderId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (no === null)
            throw new Error("The parameter 'no' cannot be null.");
        else if (no !== undefined)
            url_ += "No=" + encodeURIComponent("" + no) + "&";
        if (barcode !== undefined && barcode !== null)
            url_ += "Barcode=" + encodeURIComponent("" + barcode) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryDetailDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryDetailDtoPagedResultDto>;
        }));
    }

    protected processGetDeliveryDetail(response: HttpResponseBase): Observable<DeliveryDetailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryDetailDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryDetailDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param deliveryHeaderId (optional) 
     * @return Success
     */
    getDeliveryDetailListPda(companyId: number | undefined, warehouseId: number | undefined, deliveryHeaderId: number | undefined): Observable<DeliveryDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Delivery/GetDeliveryDetailListPda?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (deliveryHeaderId === null)
            throw new Error("The parameter 'deliveryHeaderId' cannot be null.");
        else if (deliveryHeaderId !== undefined)
            url_ += "deliveryHeaderId=" + encodeURIComponent("" + deliveryHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryDetailListPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryDetailListPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryDetailDto[]>;
        }));
    }

    protected processGetDeliveryDetailListPda(response: HttpResponseBase): Observable<DeliveryDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DeliveryDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryDetailDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param deliveryHeaderId (optional) 
     * @param barcode (optional) 
     * @return Success
     */
    createDeliveryDetailByBarcode(companyId: number | undefined, warehouseId: number | undefined, deliveryHeaderId: number | undefined, barcode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Delivery/CreateDeliveryDetailByBarcode?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (deliveryHeaderId === null)
            throw new Error("The parameter 'deliveryHeaderId' cannot be null.");
        else if (deliveryHeaderId !== undefined)
            url_ += "deliveryHeaderId=" + encodeURIComponent("" + deliveryHeaderId) + "&";
        if (barcode !== undefined && barcode !== null)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDeliveryDetailByBarcode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDeliveryDetailByBarcode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateDeliveryDetailByBarcode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteDeliveryDetail(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Delivery/DeleteDeliveryDetail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDeliveryDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDeliveryDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDeliveryDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ErpServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getErpSyncTransferTypeList(): Observable<ErpSyncTransferType[]> {
        let url_ = this.baseUrl + "/api/services/app/Erp/GetErpSyncTransferTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErpSyncTransferTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErpSyncTransferTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpSyncTransferType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpSyncTransferType[]>;
        }));
    }

    protected processGetErpSyncTransferTypeList(response: HttpResponseBase): Observable<ErpSyncTransferType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ErpSyncTransferType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpSyncTransferType[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getErpSyncSetting(id: number | undefined): Observable<ErpSyncSetting> {
        let url_ = this.baseUrl + "/api/services/app/Erp/GetErpSyncSetting?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErpSyncSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErpSyncSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpSyncSetting>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpSyncSetting>;
        }));
    }

    protected processGetErpSyncSetting(response: HttpResponseBase): Observable<ErpSyncSetting> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErpSyncSetting.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpSyncSetting>(null as any);
    }

    /**
     * @return Success
     */
    getErpSyncSettingList(): Observable<ErpSyncSetting[]> {
        let url_ = this.baseUrl + "/api/services/app/Erp/GetErpSyncSettingList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErpSyncSettingList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErpSyncSettingList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpSyncSetting[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpSyncSetting[]>;
        }));
    }

    protected processGetErpSyncSettingList(response: HttpResponseBase): Observable<ErpSyncSetting[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ErpSyncSetting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpSyncSetting[]>(null as any);
    }

    /**
     * @return Success
     */
    getErpSyncSettingDtoList(): Observable<ErpSyncSettingDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Erp/GetErpSyncSettingDtoList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErpSyncSettingDtoList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErpSyncSettingDtoList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpSyncSettingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpSyncSettingDto[]>;
        }));
    }

    protected processGetErpSyncSettingDtoList(response: HttpResponseBase): Observable<ErpSyncSettingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ErpSyncSettingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpSyncSettingDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    syncOrderAgainForList(companyId: number | undefined): Observable<Erp2Wms_OrderHeader[]> {
        let url_ = this.baseUrl + "/api/services/app/Erp/SyncOrderAgainForList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncOrderAgainForList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncOrderAgainForList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Erp2Wms_OrderHeader[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Erp2Wms_OrderHeader[]>;
        }));
    }

    protected processSyncOrderAgainForList(response: HttpResponseBase): Observable<Erp2Wms_OrderHeader[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Erp2Wms_OrderHeader.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Erp2Wms_OrderHeader[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    syncWaybillAgainForList(companyId: number | undefined): Observable<Erp2Wms_WaybillHeader[]> {
        let url_ = this.baseUrl + "/api/services/app/Erp/SyncWaybillAgainForList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncWaybillAgainForList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncWaybillAgainForList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Erp2Wms_WaybillHeader[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Erp2Wms_WaybillHeader[]>;
        }));
    }

    protected processSyncWaybillAgainForList(response: HttpResponseBase): Observable<Erp2Wms_WaybillHeader[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Erp2Wms_WaybillHeader.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Erp2Wms_WaybillHeader[]>(null as any);
    }

    /**
     * @param vname (optional) 
     * @return Success
     */
    getErpSyncSettingByViewName(vname: string | null | undefined): Observable<ErpSyncSetting> {
        let url_ = this.baseUrl + "/api/services/app/Erp/GetErpSyncSettingByViewName?";
        if (vname !== undefined && vname !== null)
            url_ += "vname=" + encodeURIComponent("" + vname) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErpSyncSettingByViewName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErpSyncSettingByViewName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpSyncSetting>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpSyncSetting>;
        }));
    }

    protected processGetErpSyncSettingByViewName(response: HttpResponseBase): Observable<ErpSyncSetting> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErpSyncSetting.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpSyncSetting>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createErpSyncSetting(body: ErpSyncSetting | undefined): Observable<ErpSyncSetting> {
        let url_ = this.baseUrl + "/api/services/app/Erp/CreateErpSyncSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateErpSyncSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateErpSyncSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpSyncSetting>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpSyncSetting>;
        }));
    }

    protected processCreateErpSyncSetting(response: HttpResponseBase): Observable<ErpSyncSetting> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErpSyncSetting.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpSyncSetting>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateErpSyncSetting(body: ErpSyncSetting | undefined): Observable<ErpSyncSetting> {
        let url_ = this.baseUrl + "/api/services/app/Erp/UpdateErpSyncSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateErpSyncSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateErpSyncSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpSyncSetting>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpSyncSetting>;
        }));
    }

    protected processUpdateErpSyncSetting(response: HttpResponseBase): Observable<ErpSyncSetting> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErpSyncSetting.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpSyncSetting>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isRunning (optional) 
     * @return Success
     */
    updateErpSyncSettingRunning(id: number | undefined, isRunning: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Erp/UpdateErpSyncSettingRunning?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isRunning === null)
            throw new Error("The parameter 'isRunning' cannot be null.");
        else if (isRunning !== undefined)
            url_ += "isRunning=" + encodeURIComponent("" + isRunning) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateErpSyncSettingRunning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateErpSyncSettingRunning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateErpSyncSettingRunning(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param erpSyncSettingId (optional) 
     * @param _checkRunningTime (optional) 
     * @return Success
     */
    runErpSyncSettingTransfer(erpSyncSettingId: number | undefined, _checkRunningTime: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Erp/RunErpSyncSettingTransfer?";
        if (erpSyncSettingId === null)
            throw new Error("The parameter 'erpSyncSettingId' cannot be null.");
        else if (erpSyncSettingId !== undefined)
            url_ += "erpSyncSettingId=" + encodeURIComponent("" + erpSyncSettingId) + "&";
        if (_checkRunningTime === null)
            throw new Error("The parameter '_checkRunningTime' cannot be null.");
        else if (_checkRunningTime !== undefined)
            url_ += "_checkRunningTime=" + encodeURIComponent("" + _checkRunningTime) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunErpSyncSettingTransfer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunErpSyncSettingTransfer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunErpSyncSettingTransfer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    runErpSyncSettingTransferForDummyData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Erp/RunErpSyncSettingTransferForDummyData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunErpSyncSettingTransferForDummyData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunErpSyncSettingTransferForDummyData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunErpSyncSettingTransferForDummyData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param erpSyncSettingId (optional) 
     * @param _checkRunningTime (optional) 
     * @return Success
     */
    runErpSyncSettingTransfer_Manuel(erpSyncSettingId: number | undefined, _checkRunningTime: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Erp/RunErpSyncSettingTransfer_Manuel?";
        if (erpSyncSettingId === null)
            throw new Error("The parameter 'erpSyncSettingId' cannot be null.");
        else if (erpSyncSettingId !== undefined)
            url_ += "erpSyncSettingId=" + encodeURIComponent("" + erpSyncSettingId) + "&";
        if (_checkRunningTime === null)
            throw new Error("The parameter '_checkRunningTime' cannot be null.");
        else if (_checkRunningTime !== undefined)
            url_ += "_checkRunningTime=" + encodeURIComponent("" + _checkRunningTime) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunErpSyncSettingTransfer_Manuel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunErpSyncSettingTransfer_Manuel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunErpSyncSettingTransfer_Manuel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getErpTypeList(): Observable<ErpType[]> {
        let url_ = this.baseUrl + "/api/services/app/Erp/GetErpTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErpTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErpTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpType[]>;
        }));
    }

    protected processGetErpTypeList(response: HttpResponseBase): Observable<ErpType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ErpType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpType[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getErpProcessHeader(id: number | undefined): Observable<ErpProcessHeader> {
        let url_ = this.baseUrl + "/api/services/app/Erp/GetErpProcessHeader?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErpProcessHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErpProcessHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpProcessHeader>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpProcessHeader>;
        }));
    }

    protected processGetErpProcessHeader(response: HttpResponseBase): Observable<ErpProcessHeader> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErpProcessHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpProcessHeader>(null as any);
    }

    /**
     * @param sourceId (optional) 
     * @return Success
     */
    getErpProcessHeaderBySourceId(sourceId: number | undefined): Observable<ErpProcessHeader> {
        let url_ = this.baseUrl + "/api/services/app/Erp/GetErpProcessHeaderBySourceId?";
        if (sourceId === null)
            throw new Error("The parameter 'sourceId' cannot be null.");
        else if (sourceId !== undefined)
            url_ += "sourceId=" + encodeURIComponent("" + sourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErpProcessHeaderBySourceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErpProcessHeaderBySourceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpProcessHeader>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpProcessHeader>;
        }));
    }

    protected processGetErpProcessHeaderBySourceId(response: HttpResponseBase): Observable<ErpProcessHeader> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErpProcessHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpProcessHeader>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param typeId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getErpProcessHeaderListPaged(companyId: number | undefined, typeId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ErpProcessHeaderPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Erp/GetErpProcessHeaderListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (typeId === null)
            throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErpProcessHeaderListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErpProcessHeaderListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpProcessHeaderPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpProcessHeaderPagedResultDto>;
        }));
    }

    protected processGetErpProcessHeaderListPaged(response: HttpResponseBase): Observable<ErpProcessHeaderPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErpProcessHeaderPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpProcessHeaderPagedResultDto>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @return Success
     */
    getErpProcessDetailList(headerId: number | undefined): Observable<ErpProcessDetail[]> {
        let url_ = this.baseUrl + "/api/services/app/Erp/GetErpProcessDetailList?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErpProcessDetailList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErpProcessDetailList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpProcessDetail[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpProcessDetail[]>;
        }));
    }

    protected processGetErpProcessDetailList(response: HttpResponseBase): Observable<ErpProcessDetail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ErpProcessDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpProcessDetail[]>(null as any);
    }

    /**
     * @return Success
     */
    getErpProcessTypeList(): Observable<ErpProcessType[]> {
        let url_ = this.baseUrl + "/api/services/app/Erp/GetErpProcessTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErpProcessTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErpProcessTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpProcessType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpProcessType[]>;
        }));
    }

    protected processGetErpProcessTypeList(response: HttpResponseBase): Observable<ErpProcessType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ErpProcessType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpProcessType[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getErpDbConnection(id: number | undefined): Observable<ErpDbConnection> {
        let url_ = this.baseUrl + "/api/services/app/Erp/GetErpDbConnection?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErpDbConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErpDbConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpDbConnection>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpDbConnection>;
        }));
    }

    protected processGetErpDbConnection(response: HttpResponseBase): Observable<ErpDbConnection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErpDbConnection.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpDbConnection>(null as any);
    }

    /**
     * @return Success
     */
    getErpDbConnectionList(): Observable<ErpDbConnection[]> {
        let url_ = this.baseUrl + "/api/services/app/Erp/GetErpDbConnectionList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErpDbConnectionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErpDbConnectionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpDbConnection[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpDbConnection[]>;
        }));
    }

    protected processGetErpDbConnectionList(response: HttpResponseBase): Observable<ErpDbConnection[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ErpDbConnection.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpDbConnection[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateZeusSetupSqlScripts(body: ZeusSetupSqlScripts | undefined): Observable<ZeusSetupSqlScripts> {
        let url_ = this.baseUrl + "/api/services/app/Erp/UpdateZeusSetupSqlScripts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateZeusSetupSqlScripts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateZeusSetupSqlScripts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZeusSetupSqlScripts>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZeusSetupSqlScripts>;
        }));
    }

    protected processUpdateZeusSetupSqlScripts(response: HttpResponseBase): Observable<ZeusSetupSqlScripts> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZeusSetupSqlScripts.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ZeusSetupSqlScripts>(null as any);
    }

    /**
     * @param erptypeid (optional) 
     * @param commandtype (optional) 
     * @param type (optional) 
     * @return Success
     */
    getZeusSetupSqlScriptsByParams(erptypeid: number | undefined, commandtype: number | undefined, type: number | undefined): Observable<ZeusSetupSqlScripts> {
        let url_ = this.baseUrl + "/api/services/app/Erp/GetZeusSetupSqlScriptsByParams?";
        if (erptypeid === null)
            throw new Error("The parameter 'erptypeid' cannot be null.");
        else if (erptypeid !== undefined)
            url_ += "erptypeid=" + encodeURIComponent("" + erptypeid) + "&";
        if (commandtype === null)
            throw new Error("The parameter 'commandtype' cannot be null.");
        else if (commandtype !== undefined)
            url_ += "commandtype=" + encodeURIComponent("" + commandtype) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZeusSetupSqlScriptsByParams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZeusSetupSqlScriptsByParams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZeusSetupSqlScripts>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZeusSetupSqlScripts>;
        }));
    }

    protected processGetZeusSetupSqlScriptsByParams(response: HttpResponseBase): Observable<ZeusSetupSqlScripts> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZeusSetupSqlScripts.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ZeusSetupSqlScripts>(null as any);
    }

    /**
     * @return Success
     */
    getZeusSetupSqlScriptsList(): Observable<ZeusSetupSqlScripts[]> {
        let url_ = this.baseUrl + "/api/services/app/Erp/GetZeusSetupSqlScriptsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZeusSetupSqlScriptsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZeusSetupSqlScriptsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZeusSetupSqlScripts[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZeusSetupSqlScripts[]>;
        }));
    }

    protected processGetZeusSetupSqlScriptsList(response: HttpResponseBase): Observable<ZeusSetupSqlScripts[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ZeusSetupSqlScripts.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ZeusSetupSqlScripts[]>(null as any);
    }

    /**
     * @return Success
     */
    insertZeusWiews(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Erp/InsertZeusWiews";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertZeusWiews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertZeusWiews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processInsertZeusWiews(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    insertZeusSqlScriptsForErp(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Erp/InsertZeusSqlScriptsForErp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertZeusSqlScriptsForErp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertZeusSqlScriptsForErp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsertZeusSqlScriptsForErp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param syncId (optional) 
     * @return Success
     */
    triggerSync(syncId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Erp/TriggerSync?";
        if (syncId === null)
            throw new Error("The parameter 'syncId' cannot be null.");
        else if (syncId !== undefined)
            url_ += "syncId=" + encodeURIComponent("" + syncId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriggerSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriggerSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processTriggerSync(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class FileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param waybillDetailId (optional) 
     * @param file (optional) 
     * @return Success
     */
    createPhotoWaybillForPda(waybillDetailId: number | undefined, file: FileParameter | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/File/CreatePhotoWaybillForPda?";
        if (waybillDetailId === null)
            throw new Error("The parameter 'waybillDetailId' cannot be null.");
        else if (waybillDetailId !== undefined)
            url_ += "waybillDetailId=" + encodeURIComponent("" + waybillDetailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePhotoWaybillForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePhotoWaybillForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreatePhotoWaybillForPda(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param clienId (optional) 
     * @param documentNo (optional) 
     * @param userId (optional) 
     * @param warehouseId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getImageUrl(clienId: number | undefined, documentNo: string | null | undefined, userId: number | undefined, warehouseId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedGetImagerUrlResponseDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/File/GetImageUrl?";
        if (clienId === null)
            throw new Error("The parameter 'clienId' cannot be null.");
        else if (clienId !== undefined)
            url_ += "ClienId=" + encodeURIComponent("" + clienId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImageUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImageUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedGetImagerUrlResponseDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedGetImagerUrlResponseDtoPagedResultDto>;
        }));
    }

    protected processGetImageUrl(response: HttpResponseBase): Observable<PagedGetImagerUrlResponseDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedGetImagerUrlResponseDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedGetImagerUrlResponseDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param headerId (optional) 
     * @param fileName (optional) 
     * @param file (optional) 
     * @return Success
     */
    createPhotoForWaybill(companyId: number | undefined, warehouseId: number | undefined, headerId: number | undefined, fileName: string | null | undefined, file: FileParameter | null | undefined): Observable<File> {
        let url_ = this.baseUrl + "/api/services/app/File/CreatePhotoForWaybill?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePhotoForWaybill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePhotoForWaybill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<File>;
                }
            } else
                return _observableThrow(response_) as any as Observable<File>;
        }));
    }

    protected processCreatePhotoForWaybill(response: HttpResponseBase): Observable<File> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = File.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<File>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param sourceId (optional) 
     * @return Success
     */
    getPhotoForWaybill(companyId: number | undefined, warehouseId: number | undefined, sourceId: number | undefined): Observable<PhotoForWaybillDto[]> {
        let url_ = this.baseUrl + "/api/services/app/File/GetPhotoForWaybill?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (sourceId === null)
            throw new Error("The parameter 'sourceId' cannot be null.");
        else if (sourceId !== undefined)
            url_ += "sourceId=" + encodeURIComponent("" + sourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPhotoForWaybill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPhotoForWaybill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhotoForWaybillDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhotoForWaybillDto[]>;
        }));
    }

    protected processGetPhotoForWaybill(response: HttpResponseBase): Observable<PhotoForWaybillDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PhotoForWaybillDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhotoForWaybillDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteFile(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/File/DeleteFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param headerId (optional) 
     * @return Success
     */
    getInvoice(headerId: number | undefined): Observable<InvoiceHeader> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoice?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceHeader>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceHeader>;
        }));
    }

    protected processGetInvoice(response: HttpResponseBase): Observable<InvoiceHeader> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceHeader>(null as any);
    }

    /**
     * @param docNo (optional) 
     * @return Success
     */
    getInvoiceByDocumentNo(docNo: string | null | undefined): Observable<InvoiceHeader> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceByDocumentNo?";
        if (docNo !== undefined && docNo !== null)
            url_ += "docNo=" + encodeURIComponent("" + docNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceByDocumentNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceByDocumentNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceHeader>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceHeader>;
        }));
    }

    protected processGetInvoiceByDocumentNo(response: HttpResponseBase): Observable<InvoiceHeader> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceHeader>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @return Success
     */
    getInvoiceByCombinedHeaderId(headerId: number | undefined): Observable<InvoiceHeader> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceByCombinedHeaderId?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceByCombinedHeaderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceByCombinedHeaderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceHeader>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceHeader>;
        }));
    }

    protected processGetInvoiceByCombinedHeaderId(response: HttpResponseBase): Observable<InvoiceHeader> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceHeader>(null as any);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param message (optional) 
     * @param body (optional) 
     * @return Success
     */
    sendMessageAllUsers(message: string | null | undefined, body: NotificationType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SendMessageAllUsers?";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMessageAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMessageAllUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMessageAllUsers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param message (optional) 
     * @param notificationGroupId (optional) 
     * @param body (optional) 
     * @return Success
     */
    sendMessageWithUserGroups(message: string | null | undefined, notificationGroupId: number | undefined, body: NotificationType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SendMessageWithUserGroups?";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (notificationGroupId === null)
            throw new Error("The parameter 'notificationGroupId' cannot be null.");
        else if (notificationGroupId !== undefined)
            url_ += "notificationGroupId=" + encodeURIComponent("" + notificationGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMessageWithUserGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMessageWithUserGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMessageWithUserGroups(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param message (optional) 
     * @param userId (optional) 
     * @param body (optional) 
     * @return Success
     */
    sendMessageWithUserId(message: string | null | undefined, userId: number | undefined, body: NotificationType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SendMessageWithUserId?";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMessageWithUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMessageWithUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMessageWithUserId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    updatePDAMessage(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdatePDAMessage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePDAMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePDAMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePDAMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllNotificationsPaged(skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserNotificationPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetAllNotificationsPaged?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNotificationsPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNotificationsPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNotificationPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNotificationPagedResultDto>;
        }));
    }

    protected processGetAllNotificationsPaged(response: HttpResponseBase): Observable<UserNotificationPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNotificationPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserNotificationPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    markAsRead(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/MarkAsRead?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getUnreadNotificationCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUnreadNotificationCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnreadNotificationCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnreadNotificationCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUnreadNotificationCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNotificationData(id: string | null | undefined): Observable<UserNotification> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationData?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNotification>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNotification>;
        }));
    }

    protected processGetNotificationData(response: HttpResponseBase): Observable<UserNotification> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNotification.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserNotification>(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    createNotificationGroup(name: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/CreateNotificationGroup?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNotificationGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNotificationGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateNotificationGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param newName (optional) 
     * @return Success
     */
    updateNotificationGroup(id: number | undefined, newName: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationGroup?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (newName !== undefined && newName !== null)
            url_ += "newName=" + encodeURIComponent("" + newName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNotificationGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNotificationGroup(id: number | undefined): Observable<NotificationGroup> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationGroup?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationGroup>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationGroup>;
        }));
    }

    protected processGetNotificationGroup(response: HttpResponseBase): Observable<NotificationGroup> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationGroup.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationGroup>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBatchNotificationGroupMember(body: NotificationGroupMemberBatchInsertRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/CreateBatchNotificationGroupMember";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBatchNotificationGroupMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBatchNotificationGroupMember(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateBatchNotificationGroupMember(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param notificationGroupId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    deleteNotificationGroupMemberFromGroup(notificationGroupId: number | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteNotificationGroupMemberFromGroup?";
        if (notificationGroupId === null)
            throw new Error("The parameter 'notificationGroupId' cannot be null.");
        else if (notificationGroupId !== undefined)
            url_ += "notificationGroupId=" + encodeURIComponent("" + notificationGroupId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNotificationGroupMemberFromGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNotificationGroupMemberFromGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNotificationGroupMemberFromGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getNotificationGroups(skipCount: number | undefined, maxResultCount: number | undefined): Observable<NotificationGroupPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationGroups?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationGroupPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationGroupPagedResultDto>;
        }));
    }

    protected processGetNotificationGroups(response: HttpResponseBase): Observable<NotificationGroupPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationGroupPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationGroupPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getNotificationGroupMembersByGroupId(id: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<NotificationGroupMemberPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationGroupMembersByGroupId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationGroupMembersByGroupId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationGroupMembersByGroupId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationGroupMemberPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationGroupMemberPagedResultDto>;
        }));
    }

    protected processGetNotificationGroupMembersByGroupId(response: HttpResponseBase): Observable<NotificationGroupMemberPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationGroupMemberPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationGroupMemberPagedResultDto>(null as any);
    }

    /**
     * @param notificationGroupId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAddableNotificationUsersOnly(notificationGroupId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetAddableNotificationUsersOnly?";
        if (notificationGroupId === null)
            throw new Error("The parameter 'notificationGroupId' cannot be null.");
        else if (notificationGroupId !== undefined)
            url_ += "NotificationGroupId=" + encodeURIComponent("" + notificationGroupId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddableNotificationUsersOnly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddableNotificationUsersOnly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAddableNotificationUsersOnly(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class OrderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param warehouseId (optional) 
     * @return Success
     */
    getShippingRouteList(warehouseId: number | undefined): Observable<ShippingRoute[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetShippingRouteList?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShippingRouteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShippingRouteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingRoute[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingRoute[]>;
        }));
    }

    protected processGetShippingRouteList(response: HttpResponseBase): Observable<ShippingRoute[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShippingRoute.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingRoute[]>(null as any);
    }

    /**
     * @param shippingRouteId (optional) 
     * @return Success
     */
    deleteShippingRoute(shippingRouteId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/DeleteShippingRoute?";
        if (shippingRouteId === null)
            throw new Error("The parameter 'shippingRouteId' cannot be null.");
        else if (shippingRouteId !== undefined)
            url_ += "shippingRouteId=" + encodeURIComponent("" + shippingRouteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteShippingRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteShippingRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteShippingRoute(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param code (optional) 
     * @return Success
     */
    createShippingRoute(warehouseId: number | undefined, code: string | null | undefined): Observable<ShippingRoute> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateShippingRoute?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShippingRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShippingRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingRoute>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingRoute>;
        }));
    }

    protected processCreateShippingRoute(response: HttpResponseBase): Observable<ShippingRoute> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingRoute.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingRoute>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateShippingRoute(warehouseId: number | undefined, body: ShippingRoute | undefined): Observable<ShippingRoute> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateShippingRoute?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShippingRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShippingRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingRoute>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingRoute>;
        }));
    }

    protected processUpdateShippingRoute(response: HttpResponseBase): Observable<ShippingRoute> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingRoute.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingRoute>(null as any);
    }

    /**
     * @param code (optional) 
     * @param shippingRouteId (optional) 
     * @param routeType (optional) 
     * @return Success
     */
    createOrderHeaderRoute(code: string | null | undefined, shippingRouteId: number | undefined, routeType: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateOrderHeaderRoute?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (shippingRouteId === null)
            throw new Error("The parameter 'shippingRouteId' cannot be null.");
        else if (shippingRouteId !== undefined)
            url_ += "shippingRouteId=" + encodeURIComponent("" + shippingRouteId) + "&";
        if (routeType === null)
            throw new Error("The parameter 'routeType' cannot be null.");
        else if (routeType !== undefined)
            url_ += "routeType=" + encodeURIComponent("" + routeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrderHeaderRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrderHeaderRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrderHeaderRoute(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param code (optional) 
     * @param shippingRouteId (optional) 
     * @param deliveredPerson (optional) 
     * @return Success
     */
    updateOrderHeaderRoute(code: string | null | undefined, shippingRouteId: number | undefined, deliveredPerson: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateOrderHeaderRoute?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (shippingRouteId === null)
            throw new Error("The parameter 'shippingRouteId' cannot be null.");
        else if (shippingRouteId !== undefined)
            url_ += "shippingRouteId=" + encodeURIComponent("" + shippingRouteId) + "&";
        if (deliveredPerson !== undefined && deliveredPerson !== null)
            url_ += "deliveredPerson=" + encodeURIComponent("" + deliveredPerson) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderHeaderRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderHeaderRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrderHeaderRoute(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param shippingRouteId (optional) 
     * @param orderHeaderId (optional) 
     * @return Success
     */
    getOrderHeaderRouteDetailList(shippingRouteId: number | undefined, orderHeaderId: number | undefined): Observable<OrderHeaderRouteDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderRouteDetailList?";
        if (shippingRouteId === null)
            throw new Error("The parameter 'shippingRouteId' cannot be null.");
        else if (shippingRouteId !== undefined)
            url_ += "shippingRouteId=" + encodeURIComponent("" + shippingRouteId) + "&";
        if (orderHeaderId === null)
            throw new Error("The parameter 'orderHeaderId' cannot be null.");
        else if (orderHeaderId !== undefined)
            url_ += "orderHeaderId=" + encodeURIComponent("" + orderHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderRouteDetailList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderRouteDetailList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderRouteDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderRouteDetailDto[]>;
        }));
    }

    protected processGetOrderHeaderRouteDetailList(response: HttpResponseBase): Observable<OrderHeaderRouteDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderHeaderRouteDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderRouteDetailDto[]>(null as any);
    }

    /**
     * @param orderHeaderId (optional) 
     * @return Success
     */
    getOrderDetailForRoute(orderHeaderId: number | undefined): Observable<OrderDetailForRouteDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderDetailForRoute?";
        if (orderHeaderId === null)
            throw new Error("The parameter 'orderHeaderId' cannot be null.");
        else if (orderHeaderId !== undefined)
            url_ += "orderHeaderId=" + encodeURIComponent("" + orderHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailForRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailForRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailForRouteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailForRouteDto[]>;
        }));
    }

    protected processGetOrderDetailForRoute(response: HttpResponseBase): Observable<OrderDetailForRouteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDetailForRouteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailForRouteDto[]>(null as any);
    }

    /**
     * @param shippingRouteId (optional) 
     * @return Success
     */
    getOrderHeaderRouteList(shippingRouteId: number | undefined): Observable<OrderHeaderRouteDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderRouteList?";
        if (shippingRouteId === null)
            throw new Error("The parameter 'shippingRouteId' cannot be null.");
        else if (shippingRouteId !== undefined)
            url_ += "shippingRouteId=" + encodeURIComponent("" + shippingRouteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderRouteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderRouteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderRouteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderRouteDto[]>;
        }));
    }

    protected processGetOrderHeaderRouteList(response: HttpResponseBase): Observable<OrderHeaderRouteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderHeaderRouteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderRouteDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getReportsGeoMapDto(companyId: number | undefined, warehouseId: number | undefined): Observable<ReportsGeoMapDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetReportsGeoMapDto?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportsGeoMapDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportsGeoMapDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportsGeoMapDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportsGeoMapDto[]>;
        }));
    }

    protected processGetReportsGeoMapDto(response: HttpResponseBase): Observable<ReportsGeoMapDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReportsGeoMapDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportsGeoMapDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param replaceQuantity (optional) 
     * @return Success
     */
    updateErpOrderDetailQuantity(id: number | undefined, replaceQuantity: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateErpOrderDetailQuantity?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (replaceQuantity === null)
            throw new Error("The parameter 'replaceQuantity' cannot be null.");
        else if (replaceQuantity !== undefined)
            url_ += "replaceQuantity=" + encodeURIComponent("" + replaceQuantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateErpOrderDetailQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateErpOrderDetailQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateErpOrderDetailQuantity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    pullOrderDetailAgain(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/PullOrderDetailAgain?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPullOrderDetailAgain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPullOrderDetailAgain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPullOrderDetailAgain(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @return Success
     */
    getShippingTypeList(warehouseId: number | undefined): Observable<ShippingType[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetShippingTypeList?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShippingTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShippingTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingType[]>;
        }));
    }

    protected processGetShippingTypeList(response: HttpResponseBase): Observable<ShippingType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShippingType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingType[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getShippingTypeListPaged(warehouseId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShippingTypePagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetShippingTypeListPaged?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShippingTypeListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShippingTypeListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingTypePagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingTypePagedResultDto>;
        }));
    }

    protected processGetShippingTypeListPaged(response: HttpResponseBase): Observable<ShippingTypePagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypePagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypePagedResultDto>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param code (optional) 
     * @param definition (optional) 
     * @return Success
     */
    createShippingType(warehouseId: number | undefined, code: string | null | undefined, definition: string | null | undefined): Observable<ShippingType> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateShippingType?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (definition !== undefined && definition !== null)
            url_ += "definition=" + encodeURIComponent("" + definition) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShippingType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShippingType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingType>;
        }));
    }

    protected processCreateShippingType(response: HttpResponseBase): Observable<ShippingType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingType>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateShippingType(body: ShippingType | undefined): Observable<ShippingType> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateShippingType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShippingType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShippingType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingType>;
        }));
    }

    protected processUpdateShippingType(response: HttpResponseBase): Observable<ShippingType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingType>(null as any);
    }

    /**
     * @param shippingTypeId (optional) 
     * @return Success
     */
    deleteShippingType(shippingTypeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/DeleteShippingType?";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "shippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteShippingType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteShippingType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteShippingType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param warehouseId (optional) 
     * @param shippingTypeId (optional) 
     * @param shippingTypeStatusId (optional) 
     * @param clientId (optional) 
     * @param orderHeaderStatusId (optional) 
     * @param productId (optional) 
     * @param workActivityCode (optional) 
     * @param country (optional) 
     * @param city (optional) 
     * @param town (optional) 
     * @param shippingTypeIdList (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param orderType (optional) 
     * @param cityList (optional) 
     * @param orderPlace (optional) 
     * @param activeSort (optional) 
     * @param sortDirection (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOrderHeaderListForWorkActivityPaged(companyId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, warehouseId: number | undefined, shippingTypeId: number | undefined, shippingTypeStatusId: number | undefined, clientId: number | undefined, orderHeaderStatusId: number | undefined, productId: number | undefined, workActivityCode: string | null | undefined, country: string | null | undefined, city: string | null | undefined, town: string | null | undefined, shippingTypeIdList: number[] | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, orderType: number | undefined, cityList: string[] | null | undefined, orderPlace: number | undefined, activeSort: string | null | undefined, sortDirection: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderHeaderForWorkAkctivityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderListForWorkActivityPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "ShippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (shippingTypeStatusId === null)
            throw new Error("The parameter 'shippingTypeStatusId' cannot be null.");
        else if (shippingTypeStatusId !== undefined)
            url_ += "ShippingTypeStatusId=" + encodeURIComponent("" + shippingTypeStatusId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (orderHeaderStatusId === null)
            throw new Error("The parameter 'orderHeaderStatusId' cannot be null.");
        else if (orderHeaderStatusId !== undefined)
            url_ += "OrderHeaderStatusId=" + encodeURIComponent("" + orderHeaderStatusId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (workActivityCode !== undefined && workActivityCode !== null)
            url_ += "WorkActivityCode=" + encodeURIComponent("" + workActivityCode) + "&";
        if (country !== undefined && country !== null)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (city !== undefined && city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (town !== undefined && town !== null)
            url_ += "Town=" + encodeURIComponent("" + town) + "&";
        if (shippingTypeIdList !== undefined && shippingTypeIdList !== null)
            shippingTypeIdList && shippingTypeIdList.forEach(item => { url_ += "ShippingTypeIdList=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (orderType === null)
            throw new Error("The parameter 'orderType' cannot be null.");
        else if (orderType !== undefined)
            url_ += "OrderType=" + encodeURIComponent("" + orderType) + "&";
        if (cityList !== undefined && cityList !== null)
            cityList && cityList.forEach(item => { url_ += "CityList=" + encodeURIComponent("" + item) + "&"; });
        if (orderPlace === null)
            throw new Error("The parameter 'orderPlace' cannot be null.");
        else if (orderPlace !== undefined)
            url_ += "OrderPlace=" + encodeURIComponent("" + orderPlace) + "&";
        if (activeSort !== undefined && activeSort !== null)
            url_ += "ActiveSort=" + encodeURIComponent("" + activeSort) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderListForWorkActivityPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderListForWorkActivityPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderForWorkAkctivityDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderForWorkAkctivityDtoPagedResultDto>;
        }));
    }

    protected processGetOrderHeaderListForWorkActivityPaged(response: HttpResponseBase): Observable<OrderHeaderForWorkAkctivityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderForWorkAkctivityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderForWorkAkctivityDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param warehouseId (optional) 
     * @param shippingTypeId (optional) 
     * @param shippingTypeStatusId (optional) 
     * @param clientId (optional) 
     * @param orderHeaderStatusId (optional) 
     * @param productId (optional) 
     * @param workActivityCode (optional) 
     * @param country (optional) 
     * @param city (optional) 
     * @param town (optional) 
     * @param shippingTypeIdList (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param orderType (optional) 
     * @param cityList (optional) 
     * @param orderPlace (optional) 
     * @param activeSort (optional) 
     * @param sortDirection (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOrderHeaderListForWorkActivityPagedDapper(companyId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, warehouseId: number | undefined, shippingTypeId: number | undefined, shippingTypeStatusId: number | undefined, clientId: number | undefined, orderHeaderStatusId: number | undefined, productId: number | undefined, workActivityCode: string | null | undefined, country: string | null | undefined, city: string | null | undefined, town: string | null | undefined, shippingTypeIdList: number[] | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, orderType: number | undefined, cityList: string[] | null | undefined, orderPlace: number | undefined, activeSort: string | null | undefined, sortDirection: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderHeaderWorkActivityDtoDapperPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderListForWorkActivityPagedDapper?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "ShippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (shippingTypeStatusId === null)
            throw new Error("The parameter 'shippingTypeStatusId' cannot be null.");
        else if (shippingTypeStatusId !== undefined)
            url_ += "ShippingTypeStatusId=" + encodeURIComponent("" + shippingTypeStatusId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (orderHeaderStatusId === null)
            throw new Error("The parameter 'orderHeaderStatusId' cannot be null.");
        else if (orderHeaderStatusId !== undefined)
            url_ += "OrderHeaderStatusId=" + encodeURIComponent("" + orderHeaderStatusId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (workActivityCode !== undefined && workActivityCode !== null)
            url_ += "WorkActivityCode=" + encodeURIComponent("" + workActivityCode) + "&";
        if (country !== undefined && country !== null)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (city !== undefined && city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (town !== undefined && town !== null)
            url_ += "Town=" + encodeURIComponent("" + town) + "&";
        if (shippingTypeIdList !== undefined && shippingTypeIdList !== null)
            shippingTypeIdList && shippingTypeIdList.forEach(item => { url_ += "ShippingTypeIdList=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (orderType === null)
            throw new Error("The parameter 'orderType' cannot be null.");
        else if (orderType !== undefined)
            url_ += "OrderType=" + encodeURIComponent("" + orderType) + "&";
        if (cityList !== undefined && cityList !== null)
            cityList && cityList.forEach(item => { url_ += "CityList=" + encodeURIComponent("" + item) + "&"; });
        if (orderPlace === null)
            throw new Error("The parameter 'orderPlace' cannot be null.");
        else if (orderPlace !== undefined)
            url_ += "OrderPlace=" + encodeURIComponent("" + orderPlace) + "&";
        if (activeSort !== undefined && activeSort !== null)
            url_ += "ActiveSort=" + encodeURIComponent("" + activeSort) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderListForWorkActivityPagedDapper(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderListForWorkActivityPagedDapper(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderWorkActivityDtoDapperPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderWorkActivityDtoDapperPagedResultDto>;
        }));
    }

    protected processGetOrderHeaderListForWorkActivityPagedDapper(response: HttpResponseBase): Observable<OrderHeaderWorkActivityDtoDapperPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderWorkActivityDtoDapperPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderWorkActivityDtoDapperPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getCityListForOrderWorkActivity(companyId: number | undefined, warehouseId: number | undefined): Observable<GeoLocationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetCityListForOrderWorkActivity?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCityListForOrderWorkActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCityListForOrderWorkActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeoLocationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeoLocationDto[]>;
        }));
    }

    protected processGetCityListForOrderWorkActivity(response: HttpResponseBase): Observable<GeoLocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GeoLocationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeoLocationDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getShippingTypeListForOrderWorkActivity(companyId: number | undefined, warehouseId: number | undefined): Observable<ShippingType[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetShippingTypeListForOrderWorkActivity?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShippingTypeListForOrderWorkActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShippingTypeListForOrderWorkActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingType[]>;
        }));
    }

    protected processGetShippingTypeListForOrderWorkActivity(response: HttpResponseBase): Observable<ShippingType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShippingType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingType[]>(null as any);
    }

    /**
     * @param orderHeaderId (optional) 
     * @param quantity (optional) 
     * @param productId (optional) 
     * @param isControlDoubleClick (optional) 
     * @param isPackage (optional) 
     * @param packageId (optional) 
     * @return Success
     */
    addQuantityForControl(orderHeaderId: number | undefined, quantity: number | undefined, productId: number | undefined, isControlDoubleClick: boolean | undefined, isPackage: boolean | undefined, packageId: number | undefined): Observable<OrderDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/AddQuantityForControl?";
        if (orderHeaderId === null)
            throw new Error("The parameter 'orderHeaderId' cannot be null.");
        else if (orderHeaderId !== undefined)
            url_ += "orderHeaderId=" + encodeURIComponent("" + orderHeaderId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (isControlDoubleClick === null)
            throw new Error("The parameter 'isControlDoubleClick' cannot be null.");
        else if (isControlDoubleClick !== undefined)
            url_ += "isControlDoubleClick=" + encodeURIComponent("" + isControlDoubleClick) + "&";
        if (isPackage === null)
            throw new Error("The parameter 'isPackage' cannot be null.");
        else if (isPackage !== undefined)
            url_ += "isPackage=" + encodeURIComponent("" + isPackage) + "&";
        if (packageId === null)
            throw new Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddQuantityForControl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddQuantityForControl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailDto[]>;
        }));
    }

    protected processAddQuantityForControl(response: HttpResponseBase): Observable<OrderDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailDto[]>(null as any);
    }

    /**
     * @param orderHeaderId (optional) 
     * @param quantityPackage (optional) 
     * @param shippingCost (optional) 
     * @param quantityBundle (optional) 
     * @param shippingTypeId (optional) 
     * @return Success
     */
    addQuantityForPackage(orderHeaderId: number | undefined, quantityPackage: number | undefined, shippingCost: number | undefined, quantityBundle: number | undefined, shippingTypeId: number | undefined): Observable<OrderHeader> {
        let url_ = this.baseUrl + "/api/services/app/Order/AddQuantityForPackage?";
        if (orderHeaderId === null)
            throw new Error("The parameter 'orderHeaderId' cannot be null.");
        else if (orderHeaderId !== undefined)
            url_ += "orderHeaderId=" + encodeURIComponent("" + orderHeaderId) + "&";
        if (quantityPackage === null)
            throw new Error("The parameter 'quantityPackage' cannot be null.");
        else if (quantityPackage !== undefined)
            url_ += "quantityPackage=" + encodeURIComponent("" + quantityPackage) + "&";
        if (shippingCost === null)
            throw new Error("The parameter 'shippingCost' cannot be null.");
        else if (shippingCost !== undefined)
            url_ += "shippingCost=" + encodeURIComponent("" + shippingCost) + "&";
        if (quantityBundle === null)
            throw new Error("The parameter 'quantityBundle' cannot be null.");
        else if (quantityBundle !== undefined)
            url_ += "quantityBundle=" + encodeURIComponent("" + quantityBundle) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "shippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddQuantityForPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddQuantityForPackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeader>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeader>;
        }));
    }

    protected processAddQuantityForPackage(response: HttpResponseBase): Observable<OrderHeader> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeader>(null as any);
    }

    /**
     * @param orderDetailId (optional) 
     * @param noteDeficiency (optional) 
     * @return Success
     */
    updateOrderDetailNoteDefiency(orderDetailId: number | undefined, noteDeficiency: string | null | undefined): Observable<OrderDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateOrderDetailNoteDefiency?";
        if (orderDetailId === null)
            throw new Error("The parameter 'orderDetailId' cannot be null.");
        else if (orderDetailId !== undefined)
            url_ += "orderDetailId=" + encodeURIComponent("" + orderDetailId) + "&";
        if (noteDeficiency !== undefined && noteDeficiency !== null)
            url_ += "noteDeficiency=" + encodeURIComponent("" + noteDeficiency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderDetailNoteDefiency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderDetailNoteDefiency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailDto>;
        }));
    }

    protected processUpdateOrderDetailNoteDefiency(response: HttpResponseBase): Observable<OrderDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailDto>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @return Success
     */
    createCrossDockRequestBatch(headerId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateCrossDockRequestBatch?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCrossDockRequestBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCrossDockRequestBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCrossDockRequestBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    showProductPicture(code: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Order/ShowProductPicture?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShowProductPicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShowProductPicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processShowProductPicture(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getOrderTrackingReport(companyId: number | undefined, warehouseId: number | undefined): Observable<InstantOrderTrackingReport[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderTrackingReport?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderTrackingReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderTrackingReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InstantOrderTrackingReport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InstantOrderTrackingReport[]>;
        }));
    }

    protected processGetOrderTrackingReport(response: HttpResponseBase): Observable<InstantOrderTrackingReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(InstantOrderTrackingReport.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InstantOrderTrackingReport[]>(null as any);
    }

    /**
     * @param workActionId (optional) 
     * @return Success
     */
    createCrossDockRequestByWorkActionId(workActionId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateCrossDockRequestByWorkActionId?";
        if (workActionId === null)
            throw new Error("The parameter 'workActionId' cannot be null.");
        else if (workActionId !== undefined)
            url_ += "workActionId=" + encodeURIComponent("" + workActionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCrossDockRequestByWorkActionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCrossDockRequestByWorkActionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCrossDockRequestByWorkActionId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param workActionId (optional) 
     * @return Success
     */
    checkCrossDockNeedByActionId(workActionId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Order/CheckCrossDockNeedByActionId?";
        if (workActionId === null)
            throw new Error("The parameter 'workActionId' cannot be null.");
        else if (workActionId !== undefined)
            url_ += "workActionId=" + encodeURIComponent("" + workActionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCrossDockNeedByActionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCrossDockNeedByActionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckCrossDockNeedByActionId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getCrossDockRequestForPlacing(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined): Observable<CrossDockCheckResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetCrossDockRequestForPlacing?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCrossDockRequestForPlacing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCrossDockRequestForPlacing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CrossDockCheckResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CrossDockCheckResponseDto>;
        }));
    }

    protected processGetCrossDockRequestForPlacing(response: HttpResponseBase): Observable<CrossDockCheckResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CrossDockCheckResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CrossDockCheckResponseDto>(null as any);
    }

    /**
     * @return Success
     */
    getOrderCountForControlPoint(): Observable<OrderFinishedCountForCtrlPntDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderCountForControlPoint";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderCountForControlPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderCountForControlPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderFinishedCountForCtrlPntDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderFinishedCountForCtrlPntDto>;
        }));
    }

    protected processGetOrderCountForControlPoint(response: HttpResponseBase): Observable<OrderFinishedCountForCtrlPntDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderFinishedCountForCtrlPntDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderFinishedCountForCtrlPntDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getReportCrossDockRequestList(companyId: number | undefined, warehouseId: number | undefined): Observable<CrossDockRequest[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetReportCrossDockRequestList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportCrossDockRequestList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportCrossDockRequestList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CrossDockRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CrossDockRequest[]>;
        }));
    }

    protected processGetReportCrossDockRequestList(response: HttpResponseBase): Observable<CrossDockRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CrossDockRequest.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CrossDockRequest[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param productId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportCrossDockRequestListPaged(companyId: number | undefined, warehouseId: number | undefined, productId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CrossDockRequestDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetReportCrossDockRequestListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportCrossDockRequestListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportCrossDockRequestListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CrossDockRequestDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CrossDockRequestDtoPagedResultDto>;
        }));
    }

    protected processGetReportCrossDockRequestListPaged(response: HttpResponseBase): Observable<CrossDockRequestDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CrossDockRequestDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CrossDockRequestDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isFinished (optional) 
     * @return Success
     */
    deleteCrossDockRequestByOrderHeaderId(id: number | undefined, isFinished: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/DeleteCrossDockRequestByOrderHeaderId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isFinished === null)
            throw new Error("The parameter 'isFinished' cannot be null.");
        else if (isFinished !== undefined)
            url_ += "isFinished=" + encodeURIComponent("" + isFinished) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCrossDockRequestByOrderHeaderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCrossDockRequestByOrderHeaderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCrossDockRequestByOrderHeaderId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isFinished (optional) 
     * @return Success
     */
    deleteCrossDockRequestByOrderDetailId(id: number | undefined, isFinished: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/DeleteCrossDockRequestByOrderDetailId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isFinished === null)
            throw new Error("The parameter 'isFinished' cannot be null.");
        else if (isFinished !== undefined)
            url_ += "isFinished=" + encodeURIComponent("" + isFinished) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCrossDockRequestByOrderDetailId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCrossDockRequestByOrderDetailId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCrossDockRequestByOrderDetailId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isFinished (optional) 
     * @return Success
     */
    deleteCrossDockRequest(id: number | undefined, isFinished: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/DeleteCrossDockRequest?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isFinished === null)
            throw new Error("The parameter 'isFinished' cannot be null.");
        else if (isFinished !== undefined)
            url_ += "isFinished=" + encodeURIComponent("" + isFinished) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCrossDockRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCrossDockRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCrossDockRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param clientId (optional) 
     * @param warehouseId (optional) 
     * @param productId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportPendingOrderHeaderListPagedForClient(companyId: number | undefined, clientId: number | undefined, warehouseId: number | undefined, productId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderHeaderPendingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetReportPendingOrderHeaderListPagedForClient?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportPendingOrderHeaderListPagedForClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportPendingOrderHeaderListPagedForClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderPendingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderPendingDtoPagedResultDto>;
        }));
    }

    protected processGetReportPendingOrderHeaderListPagedForClient(response: HttpResponseBase): Observable<OrderHeaderPendingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderPendingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderPendingDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param documentNo (optional) 
     * @param warehouseId (optional) 
     * @param productId (optional) 
     * @param clientId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportOrderHeaderMovementList(companyId: number | undefined, documentNo: string | null | undefined, warehouseId: number | undefined, productId: number | undefined, clientId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderHeaderPendingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetReportOrderHeaderMovementList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportOrderHeaderMovementList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportOrderHeaderMovementList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderPendingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderPendingDtoPagedResultDto>;
        }));
    }

    protected processGetReportOrderHeaderMovementList(response: HttpResponseBase): Observable<OrderHeaderPendingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderPendingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderPendingDtoPagedResultDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageIdFrom (optional) 
     * @param storageIdTo (optional) 
     * @param shelfIdTo (optional) 
     * @param shelfIdFrom (optional) 
     * @param transferTypeId (optional) 
     * @param creatorUserId (optional) 
     * @param clientId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportTransferListProduct(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageIdFrom: number | undefined, storageIdTo: number | undefined, shelfIdTo: number | undefined, shelfIdFrom: number | undefined, transferTypeId: number | undefined, creatorUserId: number | undefined, clientId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductTransferListDapperPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetReportTransferListProduct?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageIdFrom === null)
            throw new Error("The parameter 'storageIdFrom' cannot be null.");
        else if (storageIdFrom !== undefined)
            url_ += "StorageIdFrom=" + encodeURIComponent("" + storageIdFrom) + "&";
        if (storageIdTo === null)
            throw new Error("The parameter 'storageIdTo' cannot be null.");
        else if (storageIdTo !== undefined)
            url_ += "StorageIdTo=" + encodeURIComponent("" + storageIdTo) + "&";
        if (shelfIdTo === null)
            throw new Error("The parameter 'shelfIdTo' cannot be null.");
        else if (shelfIdTo !== undefined)
            url_ += "ShelfIdTo=" + encodeURIComponent("" + shelfIdTo) + "&";
        if (shelfIdFrom === null)
            throw new Error("The parameter 'shelfIdFrom' cannot be null.");
        else if (shelfIdFrom !== undefined)
            url_ += "ShelfIdFrom=" + encodeURIComponent("" + shelfIdFrom) + "&";
        if (transferTypeId === null)
            throw new Error("The parameter 'transferTypeId' cannot be null.");
        else if (transferTypeId !== undefined)
            url_ += "TransferTypeId=" + encodeURIComponent("" + transferTypeId) + "&";
        if (creatorUserId === null)
            throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportTransferListProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportTransferListProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductTransferListDapperPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductTransferListDapperPagedResultDto>;
        }));
    }

    protected processGetReportTransferListProduct(response: HttpResponseBase): Observable<ProductTransferListDapperPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductTransferListDapperPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductTransferListDapperPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param documentNo (optional) 
     * @param warehouseId (optional) 
     * @param productId (optional) 
     * @param clientId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportOrderHeaderMovementListForClient(companyId: number | undefined, documentNo: string | null | undefined, warehouseId: number | undefined, productId: number | undefined, clientId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderDetailListClientDapperPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetReportOrderHeaderMovementListForClient?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportOrderHeaderMovementListForClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportOrderHeaderMovementListForClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailListClientDapperPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailListClientDapperPagedResultDto>;
        }));
    }

    protected processGetReportOrderHeaderMovementListForClient(response: HttpResponseBase): Observable<OrderDetailListClientDapperPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDetailListClientDapperPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailListClientDapperPagedResultDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageIdFrom (optional) 
     * @param storageIdTo (optional) 
     * @param shelfIdTo (optional) 
     * @param shelfIdFrom (optional) 
     * @param transferTypeId (optional) 
     * @param creatorUserId (optional) 
     * @param clientId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportTransferListClient(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageIdFrom: number | undefined, storageIdTo: number | undefined, shelfIdTo: number | undefined, shelfIdFrom: number | undefined, transferTypeId: number | undefined, creatorUserId: number | undefined, clientId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ClientTransferListDapperPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetReportTransferListClient?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageIdFrom === null)
            throw new Error("The parameter 'storageIdFrom' cannot be null.");
        else if (storageIdFrom !== undefined)
            url_ += "StorageIdFrom=" + encodeURIComponent("" + storageIdFrom) + "&";
        if (storageIdTo === null)
            throw new Error("The parameter 'storageIdTo' cannot be null.");
        else if (storageIdTo !== undefined)
            url_ += "StorageIdTo=" + encodeURIComponent("" + storageIdTo) + "&";
        if (shelfIdTo === null)
            throw new Error("The parameter 'shelfIdTo' cannot be null.");
        else if (shelfIdTo !== undefined)
            url_ += "ShelfIdTo=" + encodeURIComponent("" + shelfIdTo) + "&";
        if (shelfIdFrom === null)
            throw new Error("The parameter 'shelfIdFrom' cannot be null.");
        else if (shelfIdFrom !== undefined)
            url_ += "ShelfIdFrom=" + encodeURIComponent("" + shelfIdFrom) + "&";
        if (transferTypeId === null)
            throw new Error("The parameter 'transferTypeId' cannot be null.");
        else if (transferTypeId !== undefined)
            url_ += "TransferTypeId=" + encodeURIComponent("" + transferTypeId) + "&";
        if (creatorUserId === null)
            throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportTransferListClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportTransferListClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientTransferListDapperPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientTransferListDapperPagedResultDto>;
        }));
    }

    protected processGetReportTransferListClient(response: HttpResponseBase): Observable<ClientTransferListDapperPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientTransferListDapperPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientTransferListDapperPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param clientId (optional) 
     * @param warehouseId (optional) 
     * @param productId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportPendingOrderHeaderListPagedForProduct(companyId: number | undefined, clientId: number | undefined, warehouseId: number | undefined, productId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderHeaderPendingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetReportPendingOrderHeaderListPagedForProduct?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportPendingOrderHeaderListPagedForProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportPendingOrderHeaderListPagedForProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderPendingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderPendingDtoPagedResultDto>;
        }));
    }

    protected processGetReportPendingOrderHeaderListPagedForProduct(response: HttpResponseBase): Observable<OrderHeaderPendingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderPendingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderPendingDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param clientId (optional) 
     * @param warehouseId (optional) 
     * @param productId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportControlOrderHeaderListPagedForClient(companyId: number | undefined, clientId: number | undefined, warehouseId: number | undefined, productId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderHeaderPendingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetReportControlOrderHeaderListPagedForClient?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportControlOrderHeaderListPagedForClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportControlOrderHeaderListPagedForClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderPendingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderPendingDtoPagedResultDto>;
        }));
    }

    protected processGetReportControlOrderHeaderListPagedForClient(response: HttpResponseBase): Observable<OrderHeaderPendingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderPendingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderPendingDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param clientId (optional) 
     * @param warehouseId (optional) 
     * @param productId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportControlOrderHeaderListPagedForProduct(companyId: number | undefined, clientId: number | undefined, warehouseId: number | undefined, productId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderHeaderPendingReportDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetReportControlOrderHeaderListPagedForProduct?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportControlOrderHeaderListPagedForProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportControlOrderHeaderListPagedForProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderPendingReportDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderPendingReportDtoPagedResultDto>;
        }));
    }

    protected processGetReportControlOrderHeaderListPagedForProduct(response: HttpResponseBase): Observable<OrderHeaderPendingReportDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderPendingReportDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderPendingReportDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param clientId (optional) 
     * @param warehouseId (optional) 
     * @param productId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportApprovedOrderHeaderListPagedForProduct(companyId: number | undefined, clientId: number | undefined, warehouseId: number | undefined, productId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderHeaderPendingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetReportApprovedOrderHeaderListPagedForProduct?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportApprovedOrderHeaderListPagedForProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportApprovedOrderHeaderListPagedForProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderPendingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderPendingDtoPagedResultDto>;
        }));
    }

    protected processGetReportApprovedOrderHeaderListPagedForProduct(response: HttpResponseBase): Observable<OrderHeaderPendingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderPendingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderPendingDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param clientId (optional) 
     * @param warehouseId (optional) 
     * @param productId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportApprovedOrderHeaderListPagedForClient(companyId: number | undefined, clientId: number | undefined, warehouseId: number | undefined, productId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderHeaderPendingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetReportApprovedOrderHeaderListPagedForClient?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportApprovedOrderHeaderListPagedForClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportApprovedOrderHeaderListPagedForClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderPendingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderPendingDtoPagedResultDto>;
        }));
    }

    protected processGetReportApprovedOrderHeaderListPagedForClient(response: HttpResponseBase): Observable<OrderHeaderPendingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderPendingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderPendingDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param warehouseId (optional) 
     * @param shippingTypeId (optional) 
     * @param shippingTypeStatusId (optional) 
     * @param clientId (optional) 
     * @param orderHeaderStatusId (optional) 
     * @param productId (optional) 
     * @param workActivityCode (optional) 
     * @param country (optional) 
     * @param city (optional) 
     * @param town (optional) 
     * @param shippingTypeIdList (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param orderType (optional) 
     * @param cityList (optional) 
     * @param orderPlace (optional) 
     * @param sortActive (optional) 
     * @param sortDirection (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportFulFillmentOrderHeaderListPagedForClient(companyId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, warehouseId: number | undefined, shippingTypeId: number | undefined, shippingTypeStatusId: number | undefined, clientId: number | undefined, orderHeaderStatusId: number | undefined, productId: number | undefined, workActivityCode: string | null | undefined, country: string | null | undefined, city: string | null | undefined, town: string | null | undefined, shippingTypeIdList: number[] | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, orderType: number | undefined, cityList: string[] | null | undefined, orderPlace: number | undefined, sortActive: string | null | undefined, sortDirection: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderHeaderCollectedDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetReportFulFillmentOrderHeaderListPagedForClient?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "ShippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (shippingTypeStatusId === null)
            throw new Error("The parameter 'shippingTypeStatusId' cannot be null.");
        else if (shippingTypeStatusId !== undefined)
            url_ += "ShippingTypeStatusId=" + encodeURIComponent("" + shippingTypeStatusId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (orderHeaderStatusId === null)
            throw new Error("The parameter 'orderHeaderStatusId' cannot be null.");
        else if (orderHeaderStatusId !== undefined)
            url_ += "OrderHeaderStatusId=" + encodeURIComponent("" + orderHeaderStatusId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (workActivityCode !== undefined && workActivityCode !== null)
            url_ += "WorkActivityCode=" + encodeURIComponent("" + workActivityCode) + "&";
        if (country !== undefined && country !== null)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (city !== undefined && city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (town !== undefined && town !== null)
            url_ += "Town=" + encodeURIComponent("" + town) + "&";
        if (shippingTypeIdList !== undefined && shippingTypeIdList !== null)
            shippingTypeIdList && shippingTypeIdList.forEach(item => { url_ += "ShippingTypeIdList=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (orderType === null)
            throw new Error("The parameter 'orderType' cannot be null.");
        else if (orderType !== undefined)
            url_ += "OrderType=" + encodeURIComponent("" + orderType) + "&";
        if (cityList !== undefined && cityList !== null)
            cityList && cityList.forEach(item => { url_ += "CityList=" + encodeURIComponent("" + item) + "&"; });
        if (orderPlace === null)
            throw new Error("The parameter 'orderPlace' cannot be null.");
        else if (orderPlace !== undefined)
            url_ += "OrderPlace=" + encodeURIComponent("" + orderPlace) + "&";
        if (sortActive !== undefined && sortActive !== null)
            url_ += "sortActive=" + encodeURIComponent("" + sortActive) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportFulFillmentOrderHeaderListPagedForClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportFulFillmentOrderHeaderListPagedForClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderCollectedDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderCollectedDtoPagedResultDto>;
        }));
    }

    protected processGetReportFulFillmentOrderHeaderListPagedForClient(response: HttpResponseBase): Observable<OrderHeaderCollectedDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderCollectedDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderCollectedDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param warehouseId (optional) 
     * @param shippingTypeId (optional) 
     * @param shippingTypeStatusId (optional) 
     * @param clientId (optional) 
     * @param orderHeaderStatusId (optional) 
     * @param productId (optional) 
     * @param workActivityCode (optional) 
     * @param country (optional) 
     * @param city (optional) 
     * @param town (optional) 
     * @param shippingTypeIdList (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param orderType (optional) 
     * @param cityList (optional) 
     * @param orderPlace (optional) 
     * @param sortActive (optional) 
     * @param sortDirection (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportFulFillmentOrderHeaderListPagedForProduct(companyId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, warehouseId: number | undefined, shippingTypeId: number | undefined, shippingTypeStatusId: number | undefined, clientId: number | undefined, orderHeaderStatusId: number | undefined, productId: number | undefined, workActivityCode: string | null | undefined, country: string | null | undefined, city: string | null | undefined, town: string | null | undefined, shippingTypeIdList: number[] | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, orderType: number | undefined, cityList: string[] | null | undefined, orderPlace: number | undefined, sortActive: string | null | undefined, sortDirection: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetReportFulFillmentOrderHeaderListPagedForProduct?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "ShippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (shippingTypeStatusId === null)
            throw new Error("The parameter 'shippingTypeStatusId' cannot be null.");
        else if (shippingTypeStatusId !== undefined)
            url_ += "ShippingTypeStatusId=" + encodeURIComponent("" + shippingTypeStatusId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (orderHeaderStatusId === null)
            throw new Error("The parameter 'orderHeaderStatusId' cannot be null.");
        else if (orderHeaderStatusId !== undefined)
            url_ += "OrderHeaderStatusId=" + encodeURIComponent("" + orderHeaderStatusId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (workActivityCode !== undefined && workActivityCode !== null)
            url_ += "WorkActivityCode=" + encodeURIComponent("" + workActivityCode) + "&";
        if (country !== undefined && country !== null)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (city !== undefined && city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (town !== undefined && town !== null)
            url_ += "Town=" + encodeURIComponent("" + town) + "&";
        if (shippingTypeIdList !== undefined && shippingTypeIdList !== null)
            shippingTypeIdList && shippingTypeIdList.forEach(item => { url_ += "ShippingTypeIdList=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (orderType === null)
            throw new Error("The parameter 'orderType' cannot be null.");
        else if (orderType !== undefined)
            url_ += "OrderType=" + encodeURIComponent("" + orderType) + "&";
        if (cityList !== undefined && cityList !== null)
            cityList && cityList.forEach(item => { url_ += "CityList=" + encodeURIComponent("" + item) + "&"; });
        if (orderPlace === null)
            throw new Error("The parameter 'orderPlace' cannot be null.");
        else if (orderPlace !== undefined)
            url_ += "OrderPlace=" + encodeURIComponent("" + orderPlace) + "&";
        if (sortActive !== undefined && sortActive !== null)
            url_ += "sortActive=" + encodeURIComponent("" + sortActive) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportFulFillmentOrderHeaderListPagedForProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportFulFillmentOrderHeaderListPagedForProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailDtoPagedResultDto>;
        }));
    }

    protected processGetReportFulFillmentOrderHeaderListPagedForProduct(response: HttpResponseBase): Observable<OrderDetailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDetailDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailDtoPagedResultDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param shelfId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param status (optional) 
     * @param documentNo (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportStockOutListForOrderDetail(productId: number | undefined, shelfId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, status: number | undefined, documentNo: string | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetReportStockOutListForOrderDetail?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "ShelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportStockOutListForOrderDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportStockOutListForOrderDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailDtoPagedResultDto>;
        }));
    }

    protected processGetReportStockOutListForOrderDetail(response: HttpResponseBase): Observable<OrderDetailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDetailDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    updateErpProcessHeaderTransfering(): Observable<ErpProcessHeader> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateErpProcessHeaderTransfering";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateErpProcessHeaderTransfering(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateErpProcessHeaderTransfering(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpProcessHeader>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpProcessHeader>;
        }));
    }

    protected processUpdateErpProcessHeaderTransfering(response: HttpResponseBase): Observable<ErpProcessHeader> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErpProcessHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpProcessHeader>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param documentNo (optional) 
     * @param invoiceNo (optional) 
     * @param clientId (optional) 
     * @param productId (optional) 
     * @param shippingTypeId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param isInvoiceCombined (optional) 
     * @return Success
     */
    getInvoiceReportPaged(companyId: number | undefined, warehouseId: number | undefined, documentNo: string | null | undefined, invoiceNo: string | null | undefined, clientId: number | undefined, productId: number | undefined, shippingTypeId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined, isInvoiceCombined: boolean | undefined): Observable<OrderHeaderInvoiceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetInvoiceReportPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (invoiceNo !== undefined && invoiceNo !== null)
            url_ += "InvoiceNo=" + encodeURIComponent("" + invoiceNo) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "ShippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (isInvoiceCombined === null)
            throw new Error("The parameter 'isInvoiceCombined' cannot be null.");
        else if (isInvoiceCombined !== undefined)
            url_ += "IsInvoiceCombined=" + encodeURIComponent("" + isInvoiceCombined) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceReportPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceReportPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderInvoiceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderInvoiceDtoPagedResultDto>;
        }));
    }

    protected processGetInvoiceReportPaged(response: HttpResponseBase): Observable<OrderHeaderInvoiceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderInvoiceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderInvoiceDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param documentNo (optional) 
     * @param invoiceNo (optional) 
     * @param clientId (optional) 
     * @param productId (optional) 
     * @param shippingTypeId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getInvoiceReportCount(companyId: number | undefined, warehouseId: number | undefined, documentNo: string | null | undefined, invoiceNo: string | null | undefined, clientId: number | undefined, productId: number | undefined, shippingTypeId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderCountByDate[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetInvoiceReportCount?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (invoiceNo !== undefined && invoiceNo !== null)
            url_ += "InvoiceNo=" + encodeURIComponent("" + invoiceNo) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "ShippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceReportCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceReportCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderCountByDate[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderCountByDate[]>;
        }));
    }

    protected processGetInvoiceReportCount(response: HttpResponseBase): Observable<OrderCountByDate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderCountByDate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderCountByDate[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param documentNo (optional) 
     * @param warehouseId (optional) 
     * @param clientId (optional) 
     * @param orderHeaderStatusId (optional) 
     * @param workActivityCode (optional) 
     * @param productId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOrderHeaderDetailForOrderHeaderProductReport(companyId: number | undefined, documentNo: string | null | undefined, warehouseId: number | undefined, clientId: number | undefined, orderHeaderStatusId: number | undefined, workActivityCode: string | null | undefined, productId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderHeaderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderDetailForOrderHeaderProductReport?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (orderHeaderStatusId === null)
            throw new Error("The parameter 'orderHeaderStatusId' cannot be null.");
        else if (orderHeaderStatusId !== undefined)
            url_ += "OrderHeaderStatusId=" + encodeURIComponent("" + orderHeaderStatusId) + "&";
        if (workActivityCode !== undefined && workActivityCode !== null)
            url_ += "WorkActivityCode=" + encodeURIComponent("" + workActivityCode) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderDetailForOrderHeaderProductReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderDetailForOrderHeaderProductReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDtoPagedResultDto>;
        }));
    }

    protected processGetOrderHeaderDetailForOrderHeaderProductReport(response: HttpResponseBase): Observable<OrderHeaderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDtoPagedResultDto>(null as any);
    }

    /**
     * @param shippingTypeId (optional) 
     * @param priority (optional) 
     * @param startHour (optional) 
     * @param startMinute (optional) 
     * @param finishHour (optional) 
     * @param finishMinute (optional) 
     * @return Success
     */
    createShippingTypePriority(shippingTypeId: number | undefined, priority: number | undefined, startHour: number | undefined, startMinute: number | undefined, finishHour: number | undefined, finishMinute: number | undefined): Observable<ShippingTypePriority> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateShippingTypePriority?";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "shippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (priority === null)
            throw new Error("The parameter 'priority' cannot be null.");
        else if (priority !== undefined)
            url_ += "priority=" + encodeURIComponent("" + priority) + "&";
        if (startHour === null)
            throw new Error("The parameter 'startHour' cannot be null.");
        else if (startHour !== undefined)
            url_ += "startHour=" + encodeURIComponent("" + startHour) + "&";
        if (startMinute === null)
            throw new Error("The parameter 'startMinute' cannot be null.");
        else if (startMinute !== undefined)
            url_ += "startMinute=" + encodeURIComponent("" + startMinute) + "&";
        if (finishHour === null)
            throw new Error("The parameter 'finishHour' cannot be null.");
        else if (finishHour !== undefined)
            url_ += "finishHour=" + encodeURIComponent("" + finishHour) + "&";
        if (finishMinute === null)
            throw new Error("The parameter 'finishMinute' cannot be null.");
        else if (finishMinute !== undefined)
            url_ += "finishMinute=" + encodeURIComponent("" + finishMinute) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShippingTypePriority(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShippingTypePriority(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingTypePriority>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingTypePriority>;
        }));
    }

    protected processCreateShippingTypePriority(response: HttpResponseBase): Observable<ShippingTypePriority> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypePriority.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypePriority>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateShippingTypePriority(body: ShippingTypePriority | undefined): Observable<ShippingTypePriority> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateShippingTypePriority";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShippingTypePriority(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShippingTypePriority(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingTypePriority>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingTypePriority>;
        }));
    }

    protected processUpdateShippingTypePriority(response: HttpResponseBase): Observable<ShippingTypePriority> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypePriority.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypePriority>(null as any);
    }

    /**
     * @param shippingTypePriorityId (optional) 
     * @return Success
     */
    deleteShippingTypePriority(shippingTypePriorityId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/DeleteShippingTypePriority?";
        if (shippingTypePriorityId === null)
            throw new Error("The parameter 'shippingTypePriorityId' cannot be null.");
        else if (shippingTypePriorityId !== undefined)
            url_ += "shippingTypePriorityId=" + encodeURIComponent("" + shippingTypePriorityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteShippingTypePriority(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteShippingTypePriority(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteShippingTypePriority(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @return Success
     */
    getShippingTypePriorityList(warehouseId: number | undefined): Observable<ShippingTypePriority[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetShippingTypePriorityList?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShippingTypePriorityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShippingTypePriorityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingTypePriority[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingTypePriority[]>;
        }));
    }

    protected processGetShippingTypePriorityList(response: HttpResponseBase): Observable<ShippingTypePriority[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShippingTypePriority.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypePriority[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getShippingTypePriorityListPaged(warehouseId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShippingTypePriorityPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetShippingTypePriorityListPaged?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShippingTypePriorityListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShippingTypePriorityListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingTypePriorityPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingTypePriorityPagedResultDto>;
        }));
    }

    protected processGetShippingTypePriorityListPaged(response: HttpResponseBase): Observable<ShippingTypePriorityPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypePriorityPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypePriorityPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getBackOrderClientList(companyId: number | undefined, warehouseId: number | undefined): Observable<Erp2Wms_BackOrder[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetBackOrderClientList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBackOrderClientList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBackOrderClientList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Erp2Wms_BackOrder[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Erp2Wms_BackOrder[]>;
        }));
    }

    protected processGetBackOrderClientList(response: HttpResponseBase): Observable<Erp2Wms_BackOrder[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Erp2Wms_BackOrder.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Erp2Wms_BackOrder[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param clientCode (optional) 
     * @return Success
     */
    getBackOrderClientAddressList(companyId: number | undefined, warehouseId: number | undefined, clientCode: string | null | undefined): Observable<Erp2Wms_BackOrder[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetBackOrderClientAddressList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (clientCode !== undefined && clientCode !== null)
            url_ += "clientCode=" + encodeURIComponent("" + clientCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBackOrderClientAddressList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBackOrderClientAddressList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Erp2Wms_BackOrder[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Erp2Wms_BackOrder[]>;
        }));
    }

    protected processGetBackOrderClientAddressList(response: HttpResponseBase): Observable<Erp2Wms_BackOrder[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Erp2Wms_BackOrder.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Erp2Wms_BackOrder[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param clientCode (optional) 
     * @param addressNo (optional) 
     * @return Success
     */
    getBackOrderList(companyId: number | undefined, warehouseId: number | undefined, clientCode: string | null | undefined, addressNo: number | undefined): Observable<Erp2Wms_BackOrder[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetBackOrderList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (clientCode !== undefined && clientCode !== null)
            url_ += "clientCode=" + encodeURIComponent("" + clientCode) + "&";
        if (addressNo === null)
            throw new Error("The parameter 'addressNo' cannot be null.");
        else if (addressNo !== undefined)
            url_ += "addressNo=" + encodeURIComponent("" + addressNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBackOrderList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBackOrderList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Erp2Wms_BackOrder[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Erp2Wms_BackOrder[]>;
        }));
    }

    protected processGetBackOrderList(response: HttpResponseBase): Observable<Erp2Wms_BackOrder[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Erp2Wms_BackOrder.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Erp2Wms_BackOrder[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param pickingCartCode (optional) 
     * @param workActionId (optional) 
     * @return Success
     */
    createPickingCartConnection(warehouseId: number | undefined, pickingCartCode: string | null | undefined, workActionId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreatePickingCartConnection?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (pickingCartCode !== undefined && pickingCartCode !== null)
            url_ += "pickingCartCode=" + encodeURIComponent("" + pickingCartCode) + "&";
        if (workActionId === null)
            throw new Error("The parameter 'workActionId' cannot be null.");
        else if (workActionId !== undefined)
            url_ += "workActionId=" + encodeURIComponent("" + workActionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePickingCartConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePickingCartConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreatePickingCartConnection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param code (optional) 
     * @return Success
     */
    getControlPointByPickingCartCode(warehouseId: number | undefined, code: string | null | undefined): Observable<ControlPoint> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetControlPointByPickingCartCode?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlPointByPickingCartCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlPointByPickingCartCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlPoint>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlPoint>;
        }));
    }

    protected processGetControlPointByPickingCartCode(response: HttpResponseBase): Observable<ControlPoint> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControlPoint.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControlPoint>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param code (optional) 
     * @return Success
     */
    finishPickingCart(warehouseId: number | undefined, code: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/FinishPickingCart?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishPickingCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishPickingCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishPickingCart(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param code (optional) 
     * @return Success
     */
    getOrderDetailListByPickingCartCode(warehouseId: number | undefined, code: string | null | undefined): Observable<PickingCartConnectionProcess[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderDetailListByPickingCartCode?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailListByPickingCartCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailListByPickingCartCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PickingCartConnectionProcess[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PickingCartConnectionProcess[]>;
        }));
    }

    protected processGetOrderDetailListByPickingCartCode(response: HttpResponseBase): Observable<PickingCartConnectionProcess[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PickingCartConnectionProcess.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickingCartConnectionProcess[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param code (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getPickingCartListPaged(warehouseId: number | undefined, code: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PickingCartDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetPickingCartListPaged?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPickingCartListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPickingCartListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PickingCartDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PickingCartDtoPagedResultDto>;
        }));
    }

    protected processGetPickingCartListPaged(response: HttpResponseBase): Observable<PickingCartDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PickingCartDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickingCartDtoPagedResultDto>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param workActionId (optional) 
     * @return Success
     */
    getPickingCartConnectionsByWorkActionId(warehouseId: number | undefined, workActionId: number | undefined): Observable<PickingCartConnectionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetPickingCartConnectionsByWorkActionId?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActionId === null)
            throw new Error("The parameter 'workActionId' cannot be null.");
        else if (workActionId !== undefined)
            url_ += "workActionId=" + encodeURIComponent("" + workActionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPickingCartConnectionsByWorkActionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPickingCartConnectionsByWorkActionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PickingCartConnectionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PickingCartConnectionDto[]>;
        }));
    }

    protected processGetPickingCartConnectionsByWorkActionId(response: HttpResponseBase): Observable<PickingCartConnectionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PickingCartConnectionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickingCartConnectionDto[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param connectionId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getPickingCartConnectionsByPickingCartId(warehouseId: number | undefined, connectionId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PickingCartConnectionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetPickingCartConnectionsByPickingCartId?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (connectionId === null)
            throw new Error("The parameter 'connectionId' cannot be null.");
        else if (connectionId !== undefined)
            url_ += "ConnectionId=" + encodeURIComponent("" + connectionId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPickingCartConnectionsByPickingCartId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPickingCartConnectionsByPickingCartId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PickingCartConnectionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PickingCartConnectionDtoPagedResultDto>;
        }));
    }

    protected processGetPickingCartConnectionsByPickingCartId(response: HttpResponseBase): Observable<PickingCartConnectionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PickingCartConnectionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PickingCartConnectionDtoPagedResultDto>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param code (optional) 
     * @return Success
     */
    getParameter(warehouseId: number | undefined, code: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetParameter?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParameter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParameter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetParameter(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param code (optional) 
     * @return Success
     */
    getParameter2(warehouseId: number | undefined, code: string | null | undefined): Observable<Parameter> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetParameter2?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParameter2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParameter2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Parameter>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Parameter>;
        }));
    }

    protected processGetParameter2(response: HttpResponseBase): Observable<Parameter> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Parameter.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Parameter>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @return Success
     */
    getParameterList(warehouseId: number | undefined): Observable<Parameter[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetParameterList?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParameterList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParameterList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Parameter[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Parameter[]>;
        }));
    }

    protected processGetParameterList(response: HttpResponseBase): Observable<Parameter[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Parameter.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Parameter[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @return Success
     */
    getParameterListByBoolean(warehouseId: number | undefined): Observable<Parameter[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetParameterListByBoolean?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParameterListByBoolean(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParameterListByBoolean(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Parameter[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Parameter[]>;
        }));
    }

    protected processGetParameterListByBoolean(response: HttpResponseBase): Observable<Parameter[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Parameter.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Parameter[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @return Success
     */
    getParameterListByNonBoolean(warehouseId: number | undefined): Observable<Parameter[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetParameterListByNonBoolean?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParameterListByNonBoolean(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParameterListByNonBoolean(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Parameter[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Parameter[]>;
        }));
    }

    protected processGetParameterListByNonBoolean(response: HttpResponseBase): Observable<Parameter[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Parameter.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Parameter[]>(null as any);
    }

    /**
     * @param type (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getParameterListByType(type: number | undefined, warehouseId: number | undefined): Observable<Parameter[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetParameterListByType?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParameterListByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParameterListByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Parameter[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Parameter[]>;
        }));
    }

    protected processGetParameterListByType(response: HttpResponseBase): Observable<Parameter[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Parameter.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Parameter[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param type (optional) 
     * @return Success
     */
    controlPointScreen(warehouseId: number | undefined, type: number | undefined): Observable<ControlPointScreenDapperDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/ControlPointScreen?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processControlPointScreen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processControlPointScreen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlPointScreenDapperDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlPointScreenDapperDto[]>;
        }));
    }

    protected processControlPointScreen(response: HttpResponseBase): Observable<ControlPointScreenDapperDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ControlPointScreenDapperDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControlPointScreenDapperDto[]>(null as any);
    }

    /**
     * @param warehouse (optional) 
     * @param type (optional) 
     * @return Success
     */
    getControlPointEmptyList(warehouse: number | undefined, type: number | undefined): Observable<ControlPointEmptyDapper[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetControlPointEmptyList?";
        if (warehouse === null)
            throw new Error("The parameter 'warehouse' cannot be null.");
        else if (warehouse !== undefined)
            url_ += "warehouse=" + encodeURIComponent("" + warehouse) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlPointEmptyList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlPointEmptyList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlPointEmptyDapper[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlPointEmptyDapper[]>;
        }));
    }

    protected processGetControlPointEmptyList(response: HttpResponseBase): Observable<ControlPointEmptyDapper[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ControlPointEmptyDapper.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControlPointEmptyDapper[]>(null as any);
    }

    /**
     * @param combinedOrdersHeaderId (optional) 
     * @return Success
     */
    getOrderHeaderListAllForCombinedOrders(combinedOrdersHeaderId: number | undefined): Observable<OrderHeaderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderListAllForCombinedOrders?";
        if (combinedOrdersHeaderId === null)
            throw new Error("The parameter 'combinedOrdersHeaderId' cannot be null.");
        else if (combinedOrdersHeaderId !== undefined)
            url_ += "combinedOrdersHeaderId=" + encodeURIComponent("" + combinedOrdersHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderListAllForCombinedOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderListAllForCombinedOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDto[]>;
        }));
    }

    protected processGetOrderHeaderListAllForCombinedOrders(response: HttpResponseBase): Observable<OrderHeaderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderHeaderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param documentNo (optional) 
     * @param invoiceNo (optional) 
     * @param clientId (optional) 
     * @param productId (optional) 
     * @param shippingTypeId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCombinedInvoiceReportPaged(companyId: number | undefined, warehouseId: number | undefined, documentNo: string | null | undefined, invoiceNo: string | null | undefined, clientId: number | undefined, productId: number | undefined, shippingTypeId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CombinedOrdersHeaderInvoiceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetCombinedInvoiceReportPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (invoiceNo !== undefined && invoiceNo !== null)
            url_ += "InvoiceNo=" + encodeURIComponent("" + invoiceNo) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "ShippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCombinedInvoiceReportPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCombinedInvoiceReportPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CombinedOrdersHeaderInvoiceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CombinedOrdersHeaderInvoiceDtoPagedResultDto>;
        }));
    }

    protected processGetCombinedInvoiceReportPaged(response: HttpResponseBase): Observable<CombinedOrdersHeaderInvoiceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CombinedOrdersHeaderInvoiceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CombinedOrdersHeaderInvoiceDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    updateCombinedOrdersHeaderInvoicing(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateCombinedOrdersHeaderInvoicing?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCombinedOrdersHeaderInvoicing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCombinedOrdersHeaderInvoicing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCombinedOrdersHeaderInvoicing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param orderHeaderIdList (optional) 
     * @return Success
     */
    getOrderHeadersSumQuantityPackage(companyId: number | undefined, warehouseId: number | undefined, orderHeaderIdList: number[] | null | undefined): Observable<CombinableQuantityDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeadersSumQuantityPackage?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (orderHeaderIdList !== undefined && orderHeaderIdList !== null)
            orderHeaderIdList && orderHeaderIdList.forEach(item => { url_ += "OrderHeaderIdList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeadersSumQuantityPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeadersSumQuantityPackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CombinableQuantityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CombinableQuantityDto>;
        }));
    }

    protected processGetOrderHeadersSumQuantityPackage(response: HttpResponseBase): Observable<CombinableQuantityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CombinableQuantityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CombinableQuantityDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCombinableOrdersAndInvoice(body: CreateCombinableOrdersAndInvoiceRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateCombinableOrdersAndInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCombinableOrdersAndInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCombinableOrdersAndInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCombinableOrdersAndInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param clientId (optional) 
     * @return Success
     */
    getOrderHeadersForCombine(companyId: number | undefined, warehouseId: number | undefined, clientId: number | undefined): Observable<OrderHeaderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeadersForCombine?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeadersForCombine(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeadersForCombine(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDto[]>;
        }));
    }

    protected processGetOrderHeadersForCombine(response: HttpResponseBase): Observable<OrderHeaderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderHeaderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param sortActive (optional) 
     * @param sortDirection (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCombinableOrdersGroupedClients(companyId: number | undefined, warehouseId: number | undefined, sortActive: string | null | undefined, sortDirection: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ClientDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetCombinableOrdersGroupedClients?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (sortActive !== undefined && sortActive !== null)
            url_ += "sortActive=" + encodeURIComponent("" + sortActive) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCombinableOrdersGroupedClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCombinableOrdersGroupedClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDtoPagedResultDto>;
        }));
    }

    protected processGetCombinableOrdersGroupedClients(response: HttpResponseBase): Observable<ClientDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param orderHeaderIdList (optional) 
     * @return Success
     */
    getWillBeShippingCostMultiple(companyId: number | undefined, warehouseId: number | undefined, orderHeaderIdList: number[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetWillBeShippingCostMultiple?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (orderHeaderIdList !== undefined && orderHeaderIdList !== null)
            orderHeaderIdList && orderHeaderIdList.forEach(item => { url_ += "OrderHeaderIdList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWillBeShippingCostMultiple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWillBeShippingCostMultiple(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetWillBeShippingCostMultiple(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getMinimumShippingCost(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetMinimumShippingCost";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMinimumShippingCost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMinimumShippingCost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetMinimumShippingCost(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param shippingTypeId (optional) 
     * @return Success
     */
    getShippingTypeAreaListByShippingType(warehouseId: number | undefined, shippingTypeId: number | undefined): Observable<ShippingTypeArea[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetShippingTypeAreaListByShippingType?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "shippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShippingTypeAreaListByShippingType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShippingTypeAreaListByShippingType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingTypeArea[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingTypeArea[]>;
        }));
    }

    protected processGetShippingTypeAreaListByShippingType(response: HttpResponseBase): Observable<ShippingTypeArea[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShippingTypeArea.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypeArea[]>(null as any);
    }

    /**
     * @return Success
     */
    getD2DCheck(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetD2DCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetD2DCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetD2DCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetD2DCheck(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param shippingTypeId (optional) 
     * @param code (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getShippingTypeAreaListPaged(warehouseId: number | undefined, shippingTypeId: number | undefined, code: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShippingTypeAreaPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetShippingTypeAreaListPaged?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "ShippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShippingTypeAreaListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShippingTypeAreaListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingTypeAreaPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingTypeAreaPagedResultDto>;
        }));
    }

    protected processGetShippingTypeAreaListPaged(response: HttpResponseBase): Observable<ShippingTypeAreaPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypeAreaPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypeAreaPagedResultDto>(null as any);
    }

    /**
     * @param orderHeaderId (optional) 
     * @param shippingTypeAreaId (optional) 
     * @param clientWillBeUpdate (optional) 
     * @return Success
     */
    updateClientOrderShippingTypeArea(orderHeaderId: number | undefined, shippingTypeAreaId: number | undefined, clientWillBeUpdate: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateClientOrderShippingTypeArea?";
        if (orderHeaderId === null)
            throw new Error("The parameter 'orderHeaderId' cannot be null.");
        else if (orderHeaderId !== undefined)
            url_ += "orderHeaderId=" + encodeURIComponent("" + orderHeaderId) + "&";
        if (shippingTypeAreaId === null)
            throw new Error("The parameter 'shippingTypeAreaId' cannot be null.");
        else if (shippingTypeAreaId !== undefined)
            url_ += "shippingTypeAreaId=" + encodeURIComponent("" + shippingTypeAreaId) + "&";
        if (clientWillBeUpdate === null)
            throw new Error("The parameter 'clientWillBeUpdate' cannot be null.");
        else if (clientWillBeUpdate !== undefined)
            url_ += "clientWillBeUpdate=" + encodeURIComponent("" + clientWillBeUpdate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClientOrderShippingTypeArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClientOrderShippingTypeArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateClientOrderShippingTypeArea(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param shippingTypeId (optional) 
     * @param code (optional) 
     * @return Success
     */
    createShippingTypeArea(warehouseId: number | undefined, shippingTypeId: number | undefined, code: string | null | undefined): Observable<ShippingTypeArea> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateShippingTypeArea?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "shippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShippingTypeArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShippingTypeArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingTypeArea>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingTypeArea>;
        }));
    }

    protected processCreateShippingTypeArea(response: HttpResponseBase): Observable<ShippingTypeArea> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypeArea.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypeArea>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateShippingTypeArea(body: ShippingTypeArea | undefined): Observable<ShippingTypeArea> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateShippingTypeArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShippingTypeArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShippingTypeArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingTypeArea>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingTypeArea>;
        }));
    }

    protected processUpdateShippingTypeArea(response: HttpResponseBase): Observable<ShippingTypeArea> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingTypeArea.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingTypeArea>(null as any);
    }

    /**
     * @param shippingTypeAreaId (optional) 
     * @return Success
     */
    deleteShippingTypeArea(shippingTypeAreaId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/DeleteShippingTypeArea?";
        if (shippingTypeAreaId === null)
            throw new Error("The parameter 'shippingTypeAreaId' cannot be null.");
        else if (shippingTypeAreaId !== undefined)
            url_ += "shippingTypeAreaId=" + encodeURIComponent("" + shippingTypeAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteShippingTypeArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteShippingTypeArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteShippingTypeArea(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notCreateErpProcessHeaderForOrder(body: NotErpProcessHeaderRequestDto | undefined): Observable<NotErpProcessHeaderForOrderPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/NotCreateErpProcessHeaderForOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotCreateErpProcessHeaderForOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotCreateErpProcessHeaderForOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotErpProcessHeaderForOrderPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotErpProcessHeaderForOrderPagedResultDto>;
        }));
    }

    protected processNotCreateErpProcessHeaderForOrder(response: HttpResponseBase): Observable<NotErpProcessHeaderForOrderPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotErpProcessHeaderForOrderPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotErpProcessHeaderForOrderPagedResultDto>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getShippingRouteListPaged(warehouseId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShippingRoutePagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetShippingRouteListPaged?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShippingRouteListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShippingRouteListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingRoutePagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingRoutePagedResultDto>;
        }));
    }

    protected processGetShippingRouteListPaged(response: HttpResponseBase): Observable<ShippingRoutePagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShippingRoutePagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShippingRoutePagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrderHeader(id: number | undefined): Observable<OrderHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeader?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDto>;
        }));
    }

    protected processGetOrderHeader(response: HttpResponseBase): Observable<OrderHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrderHeaderForControl(id: number | undefined): Observable<OrderHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderForControl?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderForControl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderForControl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDto>;
        }));
    }

    protected processGetOrderHeaderForControl(response: HttpResponseBase): Observable<OrderHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrderHeaderForPrinting(id: number | undefined): Observable<OrderHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderForPrinting?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderForPrinting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderForPrinting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDto>;
        }));
    }

    protected processGetOrderHeaderForPrinting(response: HttpResponseBase): Observable<OrderHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCombinedOrdersHeaderForPrinting(id: number | undefined): Observable<CombinedOrdersHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetCombinedOrdersHeaderForPrinting?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCombinedOrdersHeaderForPrinting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCombinedOrdersHeaderForPrinting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CombinedOrdersHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CombinedOrdersHeaderDto>;
        }));
    }

    protected processGetCombinedOrdersHeaderForPrinting(response: HttpResponseBase): Observable<CombinedOrdersHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CombinedOrdersHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CombinedOrdersHeaderDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param warehouseId (optional) 
     * @param shippingTypeId (optional) 
     * @param shippingTypeStatusId (optional) 
     * @param clientId (optional) 
     * @param orderHeaderStatusId (optional) 
     * @param productId (optional) 
     * @param workActivityCode (optional) 
     * @param country (optional) 
     * @param city (optional) 
     * @param town (optional) 
     * @param shippingTypeIdList (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param orderType (optional) 
     * @param cityList (optional) 
     * @param orderPlace (optional) 
     * @param sortActive (optional) 
     * @param sortDirection (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOrderHeaderListPaged(companyId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, warehouseId: number | undefined, shippingTypeId: number | undefined, shippingTypeStatusId: number | undefined, clientId: number | undefined, orderHeaderStatusId: number | undefined, productId: number | undefined, workActivityCode: string | null | undefined, country: string | null | undefined, city: string | null | undefined, town: string | null | undefined, shippingTypeIdList: number[] | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, orderType: number | undefined, cityList: string[] | null | undefined, orderPlace: number | undefined, sortActive: string | null | undefined, sortDirection: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderHeaderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "ShippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (shippingTypeStatusId === null)
            throw new Error("The parameter 'shippingTypeStatusId' cannot be null.");
        else if (shippingTypeStatusId !== undefined)
            url_ += "ShippingTypeStatusId=" + encodeURIComponent("" + shippingTypeStatusId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (orderHeaderStatusId === null)
            throw new Error("The parameter 'orderHeaderStatusId' cannot be null.");
        else if (orderHeaderStatusId !== undefined)
            url_ += "OrderHeaderStatusId=" + encodeURIComponent("" + orderHeaderStatusId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (workActivityCode !== undefined && workActivityCode !== null)
            url_ += "WorkActivityCode=" + encodeURIComponent("" + workActivityCode) + "&";
        if (country !== undefined && country !== null)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (city !== undefined && city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (town !== undefined && town !== null)
            url_ += "Town=" + encodeURIComponent("" + town) + "&";
        if (shippingTypeIdList !== undefined && shippingTypeIdList !== null)
            shippingTypeIdList && shippingTypeIdList.forEach(item => { url_ += "ShippingTypeIdList=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (orderType === null)
            throw new Error("The parameter 'orderType' cannot be null.");
        else if (orderType !== undefined)
            url_ += "OrderType=" + encodeURIComponent("" + orderType) + "&";
        if (cityList !== undefined && cityList !== null)
            cityList && cityList.forEach(item => { url_ += "CityList=" + encodeURIComponent("" + item) + "&"; });
        if (orderPlace === null)
            throw new Error("The parameter 'orderPlace' cannot be null.");
        else if (orderPlace !== undefined)
            url_ += "OrderPlace=" + encodeURIComponent("" + orderPlace) + "&";
        if (sortActive !== undefined && sortActive !== null)
            url_ += "sortActive=" + encodeURIComponent("" + sortActive) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDtoPagedResultDto>;
        }));
    }

    protected processGetOrderHeaderListPaged(response: HttpResponseBase): Observable<OrderHeaderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param warehouseId (optional) 
     * @param shippingTypeId (optional) 
     * @param shippingTypeStatusId (optional) 
     * @param clientId (optional) 
     * @param orderHeaderStatusId (optional) 
     * @param productId (optional) 
     * @param workActivityCode (optional) 
     * @param country (optional) 
     * @param city (optional) 
     * @param town (optional) 
     * @param shippingTypeIdList (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param orderType (optional) 
     * @param cityList (optional) 
     * @param orderPlace (optional) 
     * @param sortActive (optional) 
     * @param sortDirection (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOrderHeaderListAllPaged(companyId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, warehouseId: number | undefined, shippingTypeId: number | undefined, shippingTypeStatusId: number | undefined, clientId: number | undefined, orderHeaderStatusId: number | undefined, productId: number | undefined, workActivityCode: string | null | undefined, country: string | null | undefined, city: string | null | undefined, town: string | null | undefined, shippingTypeIdList: number[] | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, orderType: number | undefined, cityList: string[] | null | undefined, orderPlace: number | undefined, sortActive: string | null | undefined, sortDirection: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderHeaderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderListAllPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "ShippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (shippingTypeStatusId === null)
            throw new Error("The parameter 'shippingTypeStatusId' cannot be null.");
        else if (shippingTypeStatusId !== undefined)
            url_ += "ShippingTypeStatusId=" + encodeURIComponent("" + shippingTypeStatusId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (orderHeaderStatusId === null)
            throw new Error("The parameter 'orderHeaderStatusId' cannot be null.");
        else if (orderHeaderStatusId !== undefined)
            url_ += "OrderHeaderStatusId=" + encodeURIComponent("" + orderHeaderStatusId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (workActivityCode !== undefined && workActivityCode !== null)
            url_ += "WorkActivityCode=" + encodeURIComponent("" + workActivityCode) + "&";
        if (country !== undefined && country !== null)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (city !== undefined && city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (town !== undefined && town !== null)
            url_ += "Town=" + encodeURIComponent("" + town) + "&";
        if (shippingTypeIdList !== undefined && shippingTypeIdList !== null)
            shippingTypeIdList && shippingTypeIdList.forEach(item => { url_ += "ShippingTypeIdList=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (orderType === null)
            throw new Error("The parameter 'orderType' cannot be null.");
        else if (orderType !== undefined)
            url_ += "OrderType=" + encodeURIComponent("" + orderType) + "&";
        if (cityList !== undefined && cityList !== null)
            cityList && cityList.forEach(item => { url_ += "CityList=" + encodeURIComponent("" + item) + "&"; });
        if (orderPlace === null)
            throw new Error("The parameter 'orderPlace' cannot be null.");
        else if (orderPlace !== undefined)
            url_ += "OrderPlace=" + encodeURIComponent("" + orderPlace) + "&";
        if (sortActive !== undefined && sortActive !== null)
            url_ += "sortActive=" + encodeURIComponent("" + sortActive) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderListAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderListAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDtoPagedResultDto>;
        }));
    }

    protected processGetOrderHeaderListAllPaged(response: HttpResponseBase): Observable<OrderHeaderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDtoPagedResultDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param documentNo (optional) 
     * @param warrantyNo (optional) 
     * @param shippingTypeId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getFinishedOrderListPaged(startDate: Date | null | undefined, endDate: Date | null | undefined, documentNo: string | null | undefined, warrantyNo: string | null | undefined, shippingTypeId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FinishedOrderListItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetFinishedOrderListPaged?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (warrantyNo !== undefined && warrantyNo !== null)
            url_ += "WarrantyNo=" + encodeURIComponent("" + warrantyNo) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "ShippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinishedOrderListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinishedOrderListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinishedOrderListItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinishedOrderListItemDtoPagedResultDto>;
        }));
    }

    protected processGetFinishedOrderListPaged(response: HttpResponseBase): Observable<FinishedOrderListItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinishedOrderListItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FinishedOrderListItemDtoPagedResultDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param documentNo (optional) 
     * @param warrantyNo (optional) 
     * @param shippingTypeId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getFinishedWarrantyOrderListPaged(startDate: Date | null | undefined, endDate: Date | null | undefined, documentNo: string | null | undefined, warrantyNo: string | null | undefined, clientId: number | undefined, shippingTypeId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FinishedWarrantyOrderListItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetFinishedWarrantyOrderListPaged?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (warrantyNo !== undefined && warrantyNo !== null)
            url_ += "WarrantyNo=" + encodeURIComponent("" + warrantyNo) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "ShippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinishedWarrantyOrderListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinishedWarrantyOrderListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinishedWarrantyOrderListItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinishedWarrantyOrderListItemDtoPagedResultDto>;
        }));
    }

    protected processGetFinishedWarrantyOrderListPaged(response: HttpResponseBase): Observable<FinishedWarrantyOrderListItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinishedWarrantyOrderListItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FinishedWarrantyOrderListItemDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param documentNo (optional) 
     * @return Success
     */
    getOrderHeaderByDocumentNo(companyId: number | undefined, warehouseId: number | undefined, documentNo: string | null | undefined): Observable<OrderHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderByDocumentNo?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "documentNo=" + encodeURIComponent("" + documentNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderByDocumentNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderByDocumentNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDto>;
        }));
    }

    protected processGetOrderHeaderByDocumentNo(response: HttpResponseBase): Observable<OrderHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDto>(null as any);
    }

    /**
     * @return Success
     */
    createOrder(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateOrder";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param controlPointId (optional) 
     * @return Success
     */
    getOrderHeaderListByControlPointId(controlPointId: number | undefined): Observable<OrderHeaderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderListByControlPointId?";
        if (controlPointId === null)
            throw new Error("The parameter 'controlPointId' cannot be null.");
        else if (controlPointId !== undefined)
            url_ += "controlPointId=" + encodeURIComponent("" + controlPointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderListByControlPointId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderListByControlPointId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDto[]>;
        }));
    }

    protected processGetOrderHeaderListByControlPointId(response: HttpResponseBase): Observable<OrderHeaderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderHeaderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDto[]>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getOrderHeaderListByActivityId(workActivityId: number | undefined): Observable<OrderHeaderPdaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderListByActivityId?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderListByActivityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderListByActivityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderPdaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderPdaDto[]>;
        }));
    }

    protected processGetOrderHeaderListByActivityId(response: HttpResponseBase): Observable<OrderHeaderPdaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderHeaderPdaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderPdaDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteOrderHeader(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/DeleteOrderHeader?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrderHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrderHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOrderHeader(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param orderHeaderId (optional) 
     * @return Success
     */
    downloadPackingReport(orderHeaderId: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/Order/DownloadPackingReport?";
        if (orderHeaderId === null)
            throw new Error("The parameter 'orderHeaderId' cannot be null.");
        else if (orderHeaderId !== undefined)
            url_ += "orderHeaderId=" + encodeURIComponent("" + orderHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPackingReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPackingReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadPackingReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    orderWarrantyControl(orderId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Order/OrderWarrantyControl?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderWarrantyControl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderWarrantyControl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processOrderWarrantyControl(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    finishOrderHeaderWithAllParameters(body: FinishOrderHeaderWithAllParametersRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/FinishOrderHeaderWithAllParameters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishOrderHeaderWithAllParameters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishOrderHeaderWithAllParameters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishOrderHeaderWithAllParameters(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param cancelReason (optional) 
     * @return Success
     */
    cancelOrderHeader(id: number | undefined, cancelReason: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CancelOrderHeader?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (cancelReason !== undefined && cancelReason !== null)
            url_ += "cancelReason=" + encodeURIComponent("" + cancelReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelOrderHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelOrderHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelOrderHeader(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    updateErpProcessHeaderForReProcess(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateErpProcessHeaderForReProcess?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateErpProcessHeaderForReProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateErpProcessHeaderForReProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateErpProcessHeaderForReProcess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param orderDetailId (optional) 
     * @param quantity (optional) 
     * @param isDeleteQuantity (optional) 
     * @return Success
     */
    cancelOrderHeaderPartly(orderDetailId: number | undefined, quantity: number | undefined, isDeleteQuantity: boolean | undefined): Observable<ShelfDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/CancelOrderHeaderPartly?";
        if (orderDetailId === null)
            throw new Error("The parameter 'orderDetailId' cannot be null.");
        else if (orderDetailId !== undefined)
            url_ += "orderDetailId=" + encodeURIComponent("" + orderDetailId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (isDeleteQuantity === null)
            throw new Error("The parameter 'isDeleteQuantity' cannot be null.");
        else if (isDeleteQuantity !== undefined)
            url_ += "isDeleteQuantity=" + encodeURIComponent("" + isDeleteQuantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelOrderHeaderPartly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelOrderHeaderPartly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShelfDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShelfDto>;
        }));
    }

    protected processCancelOrderHeaderPartly(response: HttpResponseBase): Observable<ShelfDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShelfDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShelfDto>(null as any);
    }

    /**
     * @param orderHeaderId (optional) 
     * @return Success
     */
    createErpProcessHeaderForNotInvoice(orderHeaderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateErpProcessHeaderForNotInvoice?";
        if (orderHeaderId === null)
            throw new Error("The parameter 'orderHeaderId' cannot be null.");
        else if (orderHeaderId !== undefined)
            url_ += "orderHeaderId=" + encodeURIComponent("" + orderHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateErpProcessHeaderForNotInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateErpProcessHeaderForNotInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateErpProcessHeaderForNotInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param orderHeaderId (optional) 
     * @return Success
     */
    createInvoice(orderHeaderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateInvoice?";
        if (orderHeaderId === null)
            throw new Error("The parameter 'orderHeaderId' cannot be null.");
        else if (orderHeaderId !== undefined)
            url_ += "orderHeaderId=" + encodeURIComponent("" + orderHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param clientCode (optional) 
     * @return Success
     */
    getClientPayBackByClientCode(clientCode: string | null | undefined): Observable<Erp2Wms_ClientPayBack[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetClientPayBackByClientCode?";
        if (clientCode !== undefined && clientCode !== null)
            url_ += "clientCode=" + encodeURIComponent("" + clientCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientPayBackByClientCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientPayBackByClientCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Erp2Wms_ClientPayBack[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Erp2Wms_ClientPayBack[]>;
        }));
    }

    protected processGetClientPayBackByClientCode(response: HttpResponseBase): Observable<Erp2Wms_ClientPayBack[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Erp2Wms_ClientPayBack.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Erp2Wms_ClientPayBack[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param documentNo (optional) 
     * @param clientCode (optional) 
     * @return Success
     */
    getOrderHeaderListForPrinting(warehouseId: number | undefined, documentNo: string | null | undefined, clientCode: string | null | undefined): Observable<OrderHeaderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderListForPrinting?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "documentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (clientCode !== undefined && clientCode !== null)
            url_ += "clientCode=" + encodeURIComponent("" + clientCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderListForPrinting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderListForPrinting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDto[]>;
        }));
    }

    protected processGetOrderHeaderListForPrinting(response: HttpResponseBase): Observable<OrderHeaderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderHeaderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDto[]>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @param shippingName (optional) 
     * @param shippingAdress (optional) 
     * @return Success
     */
    updateOrderHeaderShippingAdress(headerId: number | undefined, shippingName: string | null | undefined, shippingAdress: string | null | undefined): Observable<OrderHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateOrderHeaderShippingAdress?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        if (shippingName !== undefined && shippingName !== null)
            url_ += "shippingName=" + encodeURIComponent("" + shippingName) + "&";
        if (shippingAdress !== undefined && shippingAdress !== null)
            url_ += "shippingAdress=" + encodeURIComponent("" + shippingAdress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderHeaderShippingAdress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderHeaderShippingAdress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDto>;
        }));
    }

    protected processUpdateOrderHeaderShippingAdress(response: HttpResponseBase): Observable<OrderHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getOrderHeaderForStats(companyId: number | undefined, warehouseId: number | undefined): Observable<OrderHeaderStatsDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderForStats?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderForStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderForStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderStatsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderStatsDto>;
        }));
    }

    protected processGetOrderHeaderForStats(response: HttpResponseBase): Observable<OrderHeaderStatsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderStatsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderStatsDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param warehouseId (optional) 
     * @param shippingTypeId (optional) 
     * @param shippingTypeStatusId (optional) 
     * @param clientId (optional) 
     * @param orderHeaderStatusId (optional) 
     * @param productId (optional) 
     * @param workActivityCode (optional) 
     * @param country (optional) 
     * @param city (optional) 
     * @param town (optional) 
     * @param shippingTypeIdList (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param orderType (optional) 
     * @param cityList (optional) 
     * @param orderPlace (optional) 
     * @param sortActive (optional) 
     * @param sortDirection (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOrderHeaderListFinishedForHour(companyId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, warehouseId: number | undefined, shippingTypeId: number | undefined, shippingTypeStatusId: number | undefined, clientId: number | undefined, orderHeaderStatusId: number | undefined, productId: number | undefined, workActivityCode: string | null | undefined, country: string | null | undefined, city: string | null | undefined, town: string | null | undefined, shippingTypeIdList: number[] | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, orderType: number | undefined, cityList: string[] | null | undefined, orderPlace: number | undefined, sortActive: string | null | undefined, sortDirection: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderHeaderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderListFinishedForHour?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "ShippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (shippingTypeStatusId === null)
            throw new Error("The parameter 'shippingTypeStatusId' cannot be null.");
        else if (shippingTypeStatusId !== undefined)
            url_ += "ShippingTypeStatusId=" + encodeURIComponent("" + shippingTypeStatusId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (orderHeaderStatusId === null)
            throw new Error("The parameter 'orderHeaderStatusId' cannot be null.");
        else if (orderHeaderStatusId !== undefined)
            url_ += "OrderHeaderStatusId=" + encodeURIComponent("" + orderHeaderStatusId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (workActivityCode !== undefined && workActivityCode !== null)
            url_ += "WorkActivityCode=" + encodeURIComponent("" + workActivityCode) + "&";
        if (country !== undefined && country !== null)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (city !== undefined && city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (town !== undefined && town !== null)
            url_ += "Town=" + encodeURIComponent("" + town) + "&";
        if (shippingTypeIdList !== undefined && shippingTypeIdList !== null)
            shippingTypeIdList && shippingTypeIdList.forEach(item => { url_ += "ShippingTypeIdList=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (orderType === null)
            throw new Error("The parameter 'orderType' cannot be null.");
        else if (orderType !== undefined)
            url_ += "OrderType=" + encodeURIComponent("" + orderType) + "&";
        if (cityList !== undefined && cityList !== null)
            cityList && cityList.forEach(item => { url_ += "CityList=" + encodeURIComponent("" + item) + "&"; });
        if (orderPlace === null)
            throw new Error("The parameter 'orderPlace' cannot be null.");
        else if (orderPlace !== undefined)
            url_ += "OrderPlace=" + encodeURIComponent("" + orderPlace) + "&";
        if (sortActive !== undefined && sortActive !== null)
            url_ += "sortActive=" + encodeURIComponent("" + sortActive) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderListFinishedForHour(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderListFinishedForHour(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDtoPagedResultDto>;
        }));
    }

    protected processGetOrderHeaderListFinishedForHour(response: HttpResponseBase): Observable<OrderHeaderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param controllerId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportOrderHeaderControlTime(companyId: number | undefined, warehouseId: number | undefined, controllerId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderHeaderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetReportOrderHeaderControlTime?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (controllerId === null)
            throw new Error("The parameter 'controllerId' cannot be null.");
        else if (controllerId !== undefined)
            url_ += "ControllerId=" + encodeURIComponent("" + controllerId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportOrderHeaderControlTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportOrderHeaderControlTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDtoPagedResultDto>;
        }));
    }

    protected processGetReportOrderHeaderControlTime(response: HttpResponseBase): Observable<OrderHeaderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    updateOrderHeaderInvoicing(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateOrderHeaderInvoicing?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderHeaderInvoicing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderHeaderInvoicing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrderHeaderInvoicing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param invoiceNo (optional) 
     * @param invoiceNoGib (optional) 
     * @return Success
     */
    updateOrderHeaderInvoiceNo(id: number | undefined, invoiceNo: string | null | undefined, invoiceNoGib: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateOrderHeaderInvoiceNo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (invoiceNo !== undefined && invoiceNo !== null)
            url_ += "invoiceNo=" + encodeURIComponent("" + invoiceNo) + "&";
        if (invoiceNoGib !== undefined && invoiceNoGib !== null)
            url_ += "invoiceNoGib=" + encodeURIComponent("" + invoiceNoGib) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderHeaderInvoiceNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderHeaderInvoiceNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrderHeaderInvoiceNo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param priority (optional) 
     * @return Success
     */
    updateOrderHeaderPriority(id: number | undefined, priority: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateOrderHeaderPriority?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (priority === null)
            throw new Error("The parameter 'priority' cannot be null.");
        else if (priority !== undefined)
            url_ += "priority=" + encodeURIComponent("" + priority) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderHeaderPriority(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderHeaderPriority(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrderHeaderPriority(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isLocked (optional) 
     * @return Success
     */
    updateOrderHeaderLocked(id: number | undefined, isLocked: boolean | undefined): Observable<OrderHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateOrderHeaderLocked?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isLocked === null)
            throw new Error("The parameter 'isLocked' cannot be null.");
        else if (isLocked !== undefined)
            url_ += "isLocked=" + encodeURIComponent("" + isLocked) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderHeaderLocked(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderHeaderLocked(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDto>;
        }));
    }

    protected processUpdateOrderHeaderLocked(response: HttpResponseBase): Observable<OrderHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getOrderHeaderListPerHour(companyId: number | undefined, warehouseId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined): Observable<OrderHeaderFinishedCountPerHourDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderListPerHour?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderListPerHour(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderListPerHour(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderFinishedCountPerHourDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderFinishedCountPerHourDto>;
        }));
    }

    protected processGetOrderHeaderListPerHour(response: HttpResponseBase): Observable<OrderHeaderFinishedCountPerHourDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderFinishedCountPerHourDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderFinishedCountPerHourDto>(null as any);
    }

    /**
     * @param orderHeaderId (optional) 
     * @param note (optional) 
     * @return Success
     */
    updateBulkNoteDeficiency(orderHeaderId: number | undefined, note: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateBulkNoteDeficiency?";
        if (orderHeaderId === null)
            throw new Error("The parameter 'orderHeaderId' cannot be null.");
        else if (orderHeaderId !== undefined)
            url_ += "orderHeaderId=" + encodeURIComponent("" + orderHeaderId) + "&";
        if (note !== undefined && note !== null)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBulkNoteDeficiency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBulkNoteDeficiency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBulkNoteDeficiency(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrderHeaderForUnite(body: CreateWorkActivityDetailRequestDto | undefined): Observable<OrderHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateOrderHeaderForUnite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrderHeaderForUnite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrderHeaderForUnite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDto>;
        }));
    }

    protected processCreateOrderHeaderForUnite(response: HttpResponseBase): Observable<OrderHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBackOrderHeaderForUnite(body: CreateWorkActivityDetailRequestDto | undefined): Observable<OrderHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateBackOrderHeaderForUnite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBackOrderHeaderForUnite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBackOrderHeaderForUnite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDto>;
        }));
    }

    protected processCreateBackOrderHeaderForUnite(response: HttpResponseBase): Observable<OrderHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param documentNo (optional) 
     * @param warehouseId (optional) 
     * @param clientId (optional) 
     * @param startdate (optional) 
     * @param enddate (optional) 
     * @return Success
     */
    getOrderHeaderCounts(companyId: number | undefined, documentNo: string | null | undefined, warehouseId: number | undefined, clientId: number | undefined, startdate: Date | undefined, enddate: Date | undefined): Observable<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderCounts?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (startdate === null)
            throw new Error("The parameter 'startdate' cannot be null.");
        else if (startdate !== undefined)
            url_ += "Startdate=" + encodeURIComponent(startdate ? "" + startdate.toISOString() : "") + "&";
        if (enddate === null)
            throw new Error("The parameter 'enddate' cannot be null.");
        else if (enddate !== undefined)
            url_ += "Enddate=" + encodeURIComponent(enddate ? "" + enddate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: number; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: number; }>;
        }));
    }

    protected processGetOrderHeaderCounts(response: HttpResponseBase): Observable<{ [key: string]: number; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)[key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: number; }>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @param newControlPointId (optional) 
     * @return Success
     */
    updateOrderHeaderControlPoint(headerId: number | undefined, newControlPointId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateOrderHeaderControlPoint?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        if (newControlPointId === null)
            throw new Error("The parameter 'newControlPointId' cannot be null.");
        else if (newControlPointId !== undefined)
            url_ += "newControlPointId=" + encodeURIComponent("" + newControlPointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderHeaderControlPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderHeaderControlPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrderHeaderControlPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param quantity (optional) 
     * @return Success
     */
    updateOrderDetailShippedQuantity(id: number | undefined, quantity: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateOrderDetailShippedQuantity?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderDetailShippedQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderDetailShippedQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrderDetailShippedQuantity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @param productId (optional) 
     * @param quantity (optional) 
     * @param entegreId (optional) 
     * @param priceNet (optional) 
     * @param currency (optional) 
     * @param quantityKit (optional) 
     * @param productionRecipeHeaderId (optional) 
     * @return Success
     */
    createOrderDetail(headerId: number | undefined, productId: number | undefined, quantity: number | undefined, entegreId: string | null | undefined, priceNet: number | undefined, currency: string | null | undefined, quantityKit: number | undefined, productionRecipeHeaderId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateOrderDetail?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (entegreId !== undefined && entegreId !== null)
            url_ += "entegreId=" + encodeURIComponent("" + entegreId) + "&";
        if (priceNet === null)
            throw new Error("The parameter 'priceNet' cannot be null.");
        else if (priceNet !== undefined)
            url_ += "priceNet=" + encodeURIComponent("" + priceNet) + "&";
        if (currency !== undefined && currency !== null)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (quantityKit === null)
            throw new Error("The parameter 'quantityKit' cannot be null.");
        else if (quantityKit !== undefined)
            url_ += "quantityKit=" + encodeURIComponent("" + quantityKit) + "&";
        if (productionRecipeHeaderId !== undefined && productionRecipeHeaderId !== null)
            url_ += "productionRecipeHeaderId=" + encodeURIComponent("" + productionRecipeHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrderDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrderDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrderDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param row (optional) 
     * @param clientId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param allCollectable (optional) 
     * @return Success
     */
    createTestOrder(row: number | undefined, clientId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, allCollectable: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateTestOrder?";
        if (row === null)
            throw new Error("The parameter 'row' cannot be null.");
        else if (row !== undefined)
            url_ += "row=" + encodeURIComponent("" + row) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        if (allCollectable === null)
            throw new Error("The parameter 'allCollectable' cannot be null.");
        else if (allCollectable !== undefined)
            url_ += "allCollectable=" + encodeURIComponent("" + allCollectable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTestOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTestOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTestOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param detailId (optional) 
     * @param noteDeficiency (optional) 
     * @return Success
     */
    deleteOrderDetail(detailId: number | undefined, noteDeficiency: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/DeleteOrderDetail?";
        if (detailId === null)
            throw new Error("The parameter 'detailId' cannot be null.");
        else if (detailId !== undefined)
            url_ += "detailId=" + encodeURIComponent("" + detailId) + "&";
        if (noteDeficiency !== undefined && noteDeficiency !== null)
            url_ += "noteDeficiency=" + encodeURIComponent("" + noteDeficiency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrderDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrderDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOrderDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param detailId (optional) 
     * @param newQuantity (optional) 
     * @param newShippingQuantity (optional) 
     * @param newQuantityCollected (optional) 
     * @return Success
     */
    updateOrderDetailQuantity(detailId: number | undefined, newQuantity: number | undefined, newShippingQuantity: number | undefined, newQuantityCollected: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateOrderDetailQuantity?";
        if (detailId === null)
            throw new Error("The parameter 'detailId' cannot be null.");
        else if (detailId !== undefined)
            url_ += "detailId=" + encodeURIComponent("" + detailId) + "&";
        if (newQuantity === null)
            throw new Error("The parameter 'newQuantity' cannot be null.");
        else if (newQuantity !== undefined)
            url_ += "newQuantity=" + encodeURIComponent("" + newQuantity) + "&";
        if (newShippingQuantity === null)
            throw new Error("The parameter 'newShippingQuantity' cannot be null.");
        else if (newShippingQuantity !== undefined)
            url_ += "newShippingQuantity=" + encodeURIComponent("" + newShippingQuantity) + "&";
        if (newQuantityCollected === null)
            throw new Error("The parameter 'newQuantityCollected' cannot be null.");
        else if (newQuantityCollected !== undefined)
            url_ += "newQuantityCollected=" + encodeURIComponent("" + newQuantityCollected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderDetailQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderDetailQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrderDetailQuantity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @return Success
     */
    getOrderDetailList(headerId: number | undefined): Observable<OrderDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderDetailList?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailDto[]>;
        }));
    }

    protected processGetOrderDetailList(response: HttpResponseBase): Observable<OrderDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailDto[]>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @return Success
     */
    getOrderDetailListAll(headerId: number | undefined): Observable<OrderDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderDetailListAll?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailListAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailListAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailDto[]>;
        }));
    }

    protected processGetOrderDetailListAll(response: HttpResponseBase): Observable<OrderDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailDto[]>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @return Success
     */
    getOrderDetailListAllForCombined(headerId: number | undefined): Observable<OrderDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderDetailListAllForCombined?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailListAllForCombined(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailListAllForCombined(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailDto[]>;
        }));
    }

    protected processGetOrderDetailListAllForCombined(response: HttpResponseBase): Observable<OrderDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailDto[]>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getOrderDetailPickingListForPda(workActivityId: number | undefined, userId: number | undefined): Observable<OrderPickingDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderDetailPickingListForPda?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailPickingListForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailPickingListForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderPickingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderPickingDto>;
        }));
    }

    protected processGetOrderDetailPickingListForPda(response: HttpResponseBase): Observable<OrderPickingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderPickingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderPickingDto>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getOrderDetailListForPda(workActivityId: number | undefined): Observable<OrderDetailPdaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderDetailListForPda?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailListForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailListForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailPdaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailPdaDto[]>;
        }));
    }

    protected processGetOrderDetailListForPda(response: HttpResponseBase): Observable<OrderDetailPdaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDetailPdaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailPdaDto[]>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getOrderCancelReplacementList(workActivityId: number | undefined): Observable<OrderCancelReplacementDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderCancelReplacementList?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderCancelReplacementList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderCancelReplacementList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderCancelReplacementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderCancelReplacementDto[]>;
        }));
    }

    protected processGetOrderCancelReplacementList(response: HttpResponseBase): Observable<OrderCancelReplacementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderCancelReplacementDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderCancelReplacementDto[]>(null as any);
    }

    /**
     * @param detailId (optional) 
     * @return Success
     */
    getOrderDetail(detailId: number | undefined): Observable<OrderDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderDetail?";
        if (detailId === null)
            throw new Error("The parameter 'detailId' cannot be null.");
        else if (detailId !== undefined)
            url_ += "detailId=" + encodeURIComponent("" + detailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailDto>;
        }));
    }

    protected processGetOrderDetail(response: HttpResponseBase): Observable<OrderDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getInvoiceTotalPrice(companyId: number | undefined, warehouseId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined): Observable<InvoiceTotalByDate[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetInvoiceTotalPrice?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceTotalPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceTotalPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceTotalByDate[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceTotalByDate[]>;
        }));
    }

    protected processGetInvoiceTotalPrice(response: HttpResponseBase): Observable<InvoiceTotalByDate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(InvoiceTotalByDate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceTotalByDate[]>(null as any);
    }

    /**
     * @param workActionId (optional) 
     * @param productId (optional) 
     * @param shelfId (optional) 
     * @param containerId (optional) 
     * @param quantity (optional) 
     * @param orderdetailId (optional) 
     * @param fifocode (optional) 
     * @return Success
     */
    updateOrderDetailCollectedAddQuantityForPda(workActionId: number | undefined, productId: number | undefined, shelfId: number | undefined, containerId: number | undefined, quantity: number | undefined, orderdetailId: number | undefined, fifocode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateOrderDetailCollectedAddQuantityForPda?";
        if (workActionId === null)
            throw new Error("The parameter 'workActionId' cannot be null.");
        else if (workActionId !== undefined)
            url_ += "workActionId=" + encodeURIComponent("" + workActionId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (containerId === null)
            throw new Error("The parameter 'containerId' cannot be null.");
        else if (containerId !== undefined)
            url_ += "containerId=" + encodeURIComponent("" + containerId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (orderdetailId === null)
            throw new Error("The parameter 'orderdetailId' cannot be null.");
        else if (orderdetailId !== undefined)
            url_ += "orderdetailId=" + encodeURIComponent("" + orderdetailId) + "&";
        if (fifocode !== undefined && fifocode !== null)
            url_ += "fifocode=" + encodeURIComponent("" + fifocode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderDetailCollectedAddQuantityForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderDetailCollectedAddQuantityForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrderDetailCollectedAddQuantityForPda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param orderDetailId (optional) 
     * @param productId (optional) 
     * @param shelfId (optional) 
     * @param quantity (optional) 
     * @return Success
     */
    updateOrderDetailCollectedDeleteQuantity(orderDetailId: number | undefined, productId: number | undefined, shelfId: number | undefined, quantity: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateOrderDetailCollectedDeleteQuantity?";
        if (orderDetailId === null)
            throw new Error("The parameter 'orderDetailId' cannot be null.");
        else if (orderDetailId !== undefined)
            url_ += "orderDetailId=" + encodeURIComponent("" + orderDetailId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderDetailCollectedDeleteQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderDetailCollectedDeleteQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrderDetailCollectedDeleteQuantity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param orderDetailId (optional) 
     * @return Success
     */
    getWorkActionProcessDtos(orderDetailId: number | undefined): Observable<WorkActionProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetWorkActionProcessDtos?";
        if (orderDetailId === null)
            throw new Error("The parameter 'orderDetailId' cannot be null.");
        else if (orderDetailId !== undefined)
            url_ += "orderDetailId=" + encodeURIComponent("" + orderDetailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActionProcessDtos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActionProcessDtos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionProcessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionProcessDto[]>;
        }));
    }

    protected processGetWorkActionProcessDtos(response: HttpResponseBase): Observable<WorkActionProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActionProcessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionProcessDto[]>(null as any);
    }

    /**
     * @param actionId (optional) 
     * @param productId (optional) 
     * @param quantity (optional) 
     * @param shelfId (optional) 
     * @param containerId (optional) 
     * @param crossDockId (optional) 
     * @return Success
     */
    updateOrderReplacementAddQuantityForPda(actionId: number | undefined, productId: number | undefined, quantity: number | undefined, shelfId: number | undefined, containerId: number | undefined, crossDockId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateOrderReplacementAddQuantityForPda?";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (containerId === null)
            throw new Error("The parameter 'containerId' cannot be null.");
        else if (containerId !== undefined)
            url_ += "containerId=" + encodeURIComponent("" + containerId) + "&";
        if (crossDockId === null)
            throw new Error("The parameter 'crossDockId' cannot be null.");
        else if (crossDockId !== undefined)
            url_ += "crossDockId=" + encodeURIComponent("" + crossDockId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderReplacementAddQuantityForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderReplacementAddQuantityForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrderReplacementAddQuantityForPda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param actionId (optional) 
     * @param productId (optional) 
     * @return Success
     */
    getOrderDetailQuantityWaitingForPlacement(actionId: number | undefined, productId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderDetailQuantityWaitingForPlacement?";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailQuantityWaitingForPlacement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailQuantityWaitingForPlacement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetOrderDetailQuantityWaitingForPlacement(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param packageId (optional) 
     * @return Success
     */
    getPackageDetailListlByPackageId(packageId: number | undefined): Observable<PackageDetail[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetPackageDetailListlByPackageId?";
        if (packageId === null)
            throw new Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackageDetailListlByPackageId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackageDetailListlByPackageId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDetail[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDetail[]>;
        }));
    }

    protected processGetPackageDetailListlByPackageId(response: HttpResponseBase): Observable<PackageDetail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PackageDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageDetail[]>(null as any);
    }

    /**
     * @param orderheaderId (optional) 
     * @param sizeHeight (optional) 
     * @param sizeLength (optional) 
     * @param sizeWidth (optional) 
     * @param deci (optional) 
     * @param tareWeight (optional) 
     * @param packageNo (optional) 
     * @return Success
     */
    createPackage(orderheaderId: number | undefined, sizeHeight: number | undefined, sizeLength: number | undefined, sizeWidth: number | undefined, deci: number | undefined, tareWeight: number | undefined, packageNo: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreatePackage?";
        if (orderheaderId === null)
            throw new Error("The parameter 'orderheaderId' cannot be null.");
        else if (orderheaderId !== undefined)
            url_ += "orderheaderId=" + encodeURIComponent("" + orderheaderId) + "&";
        if (sizeHeight === null)
            throw new Error("The parameter 'sizeHeight' cannot be null.");
        else if (sizeHeight !== undefined)
            url_ += "sizeHeight=" + encodeURIComponent("" + sizeHeight) + "&";
        if (sizeLength === null)
            throw new Error("The parameter 'sizeLength' cannot be null.");
        else if (sizeLength !== undefined)
            url_ += "sizeLength=" + encodeURIComponent("" + sizeLength) + "&";
        if (sizeWidth === null)
            throw new Error("The parameter 'sizeWidth' cannot be null.");
        else if (sizeWidth !== undefined)
            url_ += "sizeWidth=" + encodeURIComponent("" + sizeWidth) + "&";
        if (deci === null)
            throw new Error("The parameter 'deci' cannot be null.");
        else if (deci !== undefined)
            url_ += "deci=" + encodeURIComponent("" + deci) + "&";
        if (tareWeight === null)
            throw new Error("The parameter 'tareWeight' cannot be null.");
        else if (tareWeight !== undefined)
            url_ += "tareWeight=" + encodeURIComponent("" + tareWeight) + "&";
        if (packageNo === null)
            throw new Error("The parameter 'packageNo' cannot be null.");
        else if (packageNo !== undefined)
            url_ += "packageNo=" + encodeURIComponent("" + packageNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreatePackage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param packageId (optional) 
     * @param sizeHeight (optional) 
     * @param sizeLength (optional) 
     * @param sizeWidth (optional) 
     * @param deci (optional) 
     * @param tareWeight (optional) 
     * @return Success
     */
    updatePackage(packageId: number | undefined, sizeHeight: number | undefined, sizeLength: number | undefined, sizeWidth: number | undefined, deci: number | undefined, tareWeight: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdatePackage?";
        if (packageId === null)
            throw new Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        if (sizeHeight === null)
            throw new Error("The parameter 'sizeHeight' cannot be null.");
        else if (sizeHeight !== undefined)
            url_ += "sizeHeight=" + encodeURIComponent("" + sizeHeight) + "&";
        if (sizeLength === null)
            throw new Error("The parameter 'sizeLength' cannot be null.");
        else if (sizeLength !== undefined)
            url_ += "sizeLength=" + encodeURIComponent("" + sizeLength) + "&";
        if (sizeWidth === null)
            throw new Error("The parameter 'sizeWidth' cannot be null.");
        else if (sizeWidth !== undefined)
            url_ += "sizeWidth=" + encodeURIComponent("" + sizeWidth) + "&";
        if (deci === null)
            throw new Error("The parameter 'deci' cannot be null.");
        else if (deci !== undefined)
            url_ += "deci=" + encodeURIComponent("" + deci) + "&";
        if (tareWeight === null)
            throw new Error("The parameter 'tareWeight' cannot be null.");
        else if (tareWeight !== undefined)
            url_ += "tareWeight=" + encodeURIComponent("" + tareWeight) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePackage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param packageDetailId (optional) 
     * @return Success
     */
    deletePackageDetail(packageDetailId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/DeletePackageDetail?";
        if (packageDetailId === null)
            throw new Error("The parameter 'packageDetailId' cannot be null.");
        else if (packageDetailId !== undefined)
            url_ += "packageDetailId=" + encodeURIComponent("" + packageDetailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePackageDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePackageDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePackageDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param orderheaderId (optional) 
     * @return Success
     */
    getPackageCount(orderheaderId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetPackageCount?";
        if (orderheaderId === null)
            throw new Error("The parameter 'orderheaderId' cannot be null.");
        else if (orderheaderId !== undefined)
            url_ += "orderheaderId=" + encodeURIComponent("" + orderheaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackageCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackageCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPackageCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param orderheaderId (optional) 
     * @return Success
     */
    getFindingEmptyPackageNo(orderheaderId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetFindingEmptyPackageNo?";
        if (orderheaderId === null)
            throw new Error("The parameter 'orderheaderId' cannot be null.");
        else if (orderheaderId !== undefined)
            url_ += "orderheaderId=" + encodeURIComponent("" + orderheaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFindingEmptyPackageNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFindingEmptyPackageNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFindingEmptyPackageNo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param orderheaderId (optional) 
     * @param packageId (optional) 
     * @return Success
     */
    deletePackage(orderheaderId: number | undefined, packageId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/DeletePackage?";
        if (orderheaderId === null)
            throw new Error("The parameter 'orderheaderId' cannot be null.");
        else if (orderheaderId !== undefined)
            url_ += "orderheaderId=" + encodeURIComponent("" + orderheaderId) + "&";
        if (packageId === null)
            throw new Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePackage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param orderHeaderId (optional) 
     * @param inputMail (optional) 
     * @return Success
     */
    orderControlMailReport(orderHeaderId: number | undefined, inputMail: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/OrderControlMailReport?";
        if (orderHeaderId === null)
            throw new Error("The parameter 'orderHeaderId' cannot be null.");
        else if (orderHeaderId !== undefined)
            url_ += "orderHeaderId=" + encodeURIComponent("" + orderHeaderId) + "&";
        if (inputMail !== undefined && inputMail !== null)
            url_ += "inputMail=" + encodeURIComponent("" + inputMail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderControlMailReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderControlMailReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrderControlMailReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param packageId (optional) 
     * @return Success
     */
    getPackage(packageId: number | undefined): Observable<Package> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetPackage?";
        if (packageId === null)
            throw new Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Package>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Package>;
        }));
    }

    protected processGetPackage(response: HttpResponseBase): Observable<Package> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Package.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Package>(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getPackageDetailList(orderId: number | undefined): Observable<PackageDetail[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetPackageDetailList?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackageDetailList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackageDetailList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDetail[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDetail[]>;
        }));
    }

    protected processGetPackageDetailList(response: HttpResponseBase): Observable<PackageDetail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PackageDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageDetail[]>(null as any);
    }

    /**
     * @param orderheaderId (optional) 
     * @return Success
     */
    getPackageList(orderheaderId: number | undefined): Observable<Package[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetPackageList?";
        if (orderheaderId === null)
            throw new Error("The parameter 'orderheaderId' cannot be null.");
        else if (orderheaderId !== undefined)
            url_ += "orderheaderId=" + encodeURIComponent("" + orderheaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackageList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackageList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Package[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Package[]>;
        }));
    }

    protected processGetPackageList(response: HttpResponseBase): Observable<Package[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Package.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Package[]>(null as any);
    }

    /**
     * @return Success
     */
    getOrderHeaderCancelListPda(): Observable<OrderHeaderPdaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderCancelListPda";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderCancelListPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderCancelListPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderPdaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderPdaDto[]>;
        }));
    }

    protected processGetOrderHeaderCancelListPda(response: HttpResponseBase): Observable<OrderHeaderPdaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderHeaderPdaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderPdaDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param documentNo (optional) 
     * @param warehouseId (optional) 
     * @param productId (optional) 
     * @param clientId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOrderDetailListPaged(companyId: number | undefined, documentNo: string | null | undefined, warehouseId: number | undefined, productId: number | undefined, clientId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderDetailListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailDtoPagedResultDto>;
        }));
    }

    protected processGetOrderDetailListPaged(response: HttpResponseBase): Observable<OrderDetailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDetailDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param warehouseId (optional) 
     * @param shippingTypeId (optional) 
     * @param shippingTypeStatusId (optional) 
     * @param clientId (optional) 
     * @param orderHeaderStatusId (optional) 
     * @param productId (optional) 
     * @param workActivityCode (optional) 
     * @param country (optional) 
     * @param city (optional) 
     * @param town (optional) 
     * @param shippingTypeIdList (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param orderType (optional) 
     * @param cityList (optional) 
     * @param orderPlace (optional) 
     * @param sortActive (optional) 
     * @param sortDirection (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOrderHeaderPendingReplacementList(companyId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, warehouseId: number | undefined, shippingTypeId: number | undefined, shippingTypeStatusId: number | undefined, clientId: number | undefined, orderHeaderStatusId: number | undefined, productId: number | undefined, workActivityCode: string | null | undefined, country: string | null | undefined, city: string | null | undefined, town: string | null | undefined, shippingTypeIdList: number[] | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, orderType: number | undefined, cityList: string[] | null | undefined, orderPlace: number | undefined, sortActive: string | null | undefined, sortDirection: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderHeaderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderPendingReplacementList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "ShippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (shippingTypeStatusId === null)
            throw new Error("The parameter 'shippingTypeStatusId' cannot be null.");
        else if (shippingTypeStatusId !== undefined)
            url_ += "ShippingTypeStatusId=" + encodeURIComponent("" + shippingTypeStatusId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (orderHeaderStatusId === null)
            throw new Error("The parameter 'orderHeaderStatusId' cannot be null.");
        else if (orderHeaderStatusId !== undefined)
            url_ += "OrderHeaderStatusId=" + encodeURIComponent("" + orderHeaderStatusId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (workActivityCode !== undefined && workActivityCode !== null)
            url_ += "WorkActivityCode=" + encodeURIComponent("" + workActivityCode) + "&";
        if (country !== undefined && country !== null)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (city !== undefined && city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (town !== undefined && town !== null)
            url_ += "Town=" + encodeURIComponent("" + town) + "&";
        if (shippingTypeIdList !== undefined && shippingTypeIdList !== null)
            shippingTypeIdList && shippingTypeIdList.forEach(item => { url_ += "ShippingTypeIdList=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (orderType === null)
            throw new Error("The parameter 'orderType' cannot be null.");
        else if (orderType !== undefined)
            url_ += "OrderType=" + encodeURIComponent("" + orderType) + "&";
        if (cityList !== undefined && cityList !== null)
            cityList && cityList.forEach(item => { url_ += "CityList=" + encodeURIComponent("" + item) + "&"; });
        if (orderPlace === null)
            throw new Error("The parameter 'orderPlace' cannot be null.");
        else if (orderPlace !== undefined)
            url_ += "OrderPlace=" + encodeURIComponent("" + orderPlace) + "&";
        if (sortActive !== undefined && sortActive !== null)
            url_ += "sortActive=" + encodeURIComponent("" + sortActive) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderPendingReplacementList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderPendingReplacementList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDtoPagedResultDto>;
        }));
    }

    protected processGetOrderHeaderPendingReplacementList(response: HttpResponseBase): Observable<OrderHeaderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param productCode (optional) 
     * @return Success
     */
    getControlPointForProduct(companyId: number | undefined, warehouseId: number | undefined, productCode: string | null | undefined): Observable<ControlPoint[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetControlPointForProduct?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (productCode !== undefined && productCode !== null)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlPointForProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlPointForProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlPoint[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlPoint[]>;
        }));
    }

    protected processGetControlPointForProduct(response: HttpResponseBase): Observable<ControlPoint[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ControlPoint.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControlPoint[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param userId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getOrderHeaderListController(companyId: number | undefined, warehouseId: number | undefined, userId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined): Observable<ControllerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderListController?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderListController(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderListController(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControllerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControllerDto[]>;
        }));
    }

    protected processGetOrderHeaderListController(response: HttpResponseBase): Observable<ControllerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ControllerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControllerDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param userId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getOrderHeaderListPickerPerHour(companyId: number | undefined, warehouseId: number | undefined, userId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined): Observable<ControllerPerHourDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderListPickerPerHour?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderListPickerPerHour(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderListPickerPerHour(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControllerPerHourDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControllerPerHourDto[]>;
        }));
    }

    protected processGetOrderHeaderListPickerPerHour(response: HttpResponseBase): Observable<ControllerPerHourDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ControllerPerHourDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControllerPerHourDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param userId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getOrderHeaderListPicker(companyId: number | undefined, warehouseId: number | undefined, userId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined): Observable<ControllerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderListPicker?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderListPicker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderListPicker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControllerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControllerDto[]>;
        }));
    }

    protected processGetOrderHeaderListPicker(response: HttpResponseBase): Observable<ControllerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ControllerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControllerDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param userId (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @return Success
     */
    getOrderHeaderDispatchControlToday(companyId: number | undefined, warehouseId: number | undefined, userId: number | undefined, dateStart: Date | null | undefined, dateEnd: Date | null | undefined): Observable<ControllerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderDispatchControlToday?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (dateStart !== undefined && dateStart !== null)
            url_ += "dateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toISOString() : "") + "&";
        if (dateEnd !== undefined && dateEnd !== null)
            url_ += "dateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderDispatchControlToday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderDispatchControlToday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControllerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControllerDto[]>;
        }));
    }

    protected processGetOrderHeaderDispatchControlToday(response: HttpResponseBase): Observable<ControllerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ControllerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControllerDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param userId (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @return Success
     */
    getOrderHeaderListPickerToday(companyId: number | undefined, warehouseId: number | undefined, userId: number | undefined, dateStart: Date | null | undefined, dateEnd: Date | null | undefined): Observable<ControllerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderListPickerToday?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (dateStart !== undefined && dateStart !== null)
            url_ += "dateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toISOString() : "") + "&";
        if (dateEnd !== undefined && dateEnd !== null)
            url_ += "dateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderListPickerToday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderListPickerToday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControllerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControllerDto[]>;
        }));
    }

    protected processGetOrderHeaderListPickerToday(response: HttpResponseBase): Observable<ControllerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ControllerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControllerDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getOrderHeaderListControllerForToday(companyId: number | undefined, warehouseId: number | undefined, userId: number | undefined): Observable<ControllerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderListControllerForToday?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderListControllerForToday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderListControllerForToday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControllerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControllerDto[]>;
        }));
    }

    protected processGetOrderHeaderListControllerForToday(response: HttpResponseBase): Observable<ControllerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ControllerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControllerDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param warehouseId (optional) 
     * @param shippingTypeId (optional) 
     * @param shippingTypeStatusId (optional) 
     * @param clientId (optional) 
     * @param orderHeaderStatusId (optional) 
     * @param productId (optional) 
     * @param workActivityCode (optional) 
     * @param country (optional) 
     * @param city (optional) 
     * @param town (optional) 
     * @param shippingTypeIdList (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param orderType (optional) 
     * @param cityList (optional) 
     * @param orderPlace (optional) 
     * @param sortActive (optional) 
     * @param sortDirection (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOrderHeaderListForBundle(companyId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, warehouseId: number | undefined, shippingTypeId: number | undefined, shippingTypeStatusId: number | undefined, clientId: number | undefined, orderHeaderStatusId: number | undefined, productId: number | undefined, workActivityCode: string | null | undefined, country: string | null | undefined, city: string | null | undefined, town: string | null | undefined, shippingTypeIdList: number[] | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, orderType: number | undefined, cityList: string[] | null | undefined, orderPlace: number | undefined, sortActive: string | null | undefined, sortDirection: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderHeaderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHeaderListForBundle?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "ShippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (shippingTypeStatusId === null)
            throw new Error("The parameter 'shippingTypeStatusId' cannot be null.");
        else if (shippingTypeStatusId !== undefined)
            url_ += "ShippingTypeStatusId=" + encodeURIComponent("" + shippingTypeStatusId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (orderHeaderStatusId === null)
            throw new Error("The parameter 'orderHeaderStatusId' cannot be null.");
        else if (orderHeaderStatusId !== undefined)
            url_ += "OrderHeaderStatusId=" + encodeURIComponent("" + orderHeaderStatusId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (workActivityCode !== undefined && workActivityCode !== null)
            url_ += "WorkActivityCode=" + encodeURIComponent("" + workActivityCode) + "&";
        if (country !== undefined && country !== null)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (city !== undefined && city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (town !== undefined && town !== null)
            url_ += "Town=" + encodeURIComponent("" + town) + "&";
        if (shippingTypeIdList !== undefined && shippingTypeIdList !== null)
            shippingTypeIdList && shippingTypeIdList.forEach(item => { url_ += "ShippingTypeIdList=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (orderType === null)
            throw new Error("The parameter 'orderType' cannot be null.");
        else if (orderType !== undefined)
            url_ += "OrderType=" + encodeURIComponent("" + orderType) + "&";
        if (cityList !== undefined && cityList !== null)
            cityList && cityList.forEach(item => { url_ += "CityList=" + encodeURIComponent("" + item) + "&"; });
        if (orderPlace === null)
            throw new Error("The parameter 'orderPlace' cannot be null.");
        else if (orderPlace !== undefined)
            url_ += "OrderPlace=" + encodeURIComponent("" + orderPlace) + "&";
        if (sortActive !== undefined && sortActive !== null)
            url_ += "sortActive=" + encodeURIComponent("" + sortActive) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderListForBundle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderListForBundle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDtoPagedResultDto>;
        }));
    }

    protected processGetOrderHeaderListForBundle(response: HttpResponseBase): Observable<OrderHeaderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDtoPagedResultDto>(null as any);
    }

    /**
     * @param orderHeaderId (optional) 
     * @return Success
     */
    getOrderDetailListForPrinting(orderHeaderId: number | undefined): Observable<OrderDetailPdaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderDetailListForPrinting?";
        if (orderHeaderId === null)
            throw new Error("The parameter 'orderHeaderId' cannot be null.");
        else if (orderHeaderId !== undefined)
            url_ += "orderHeaderId=" + encodeURIComponent("" + orderHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailListForPrinting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailListForPrinting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailPdaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailPdaDto[]>;
        }));
    }

    protected processGetOrderDetailListForPrinting(response: HttpResponseBase): Observable<OrderDetailPdaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDetailPdaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailPdaDto[]>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @return Success
     */
    getOrderDetailAllCollected(headerId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetOrderDetailAllCollected?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailAllCollected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailAllCollected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetOrderDetailAllCollected(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    pullOrderHeaderAgain(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/PullOrderHeaderAgain?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPullOrderHeaderAgain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPullOrderHeaderAgain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPullOrderHeaderAgain(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PrintingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param printRequestId (optional) 
     * @return Success
     */
    createPrintRequestForPrint(printRequestId: number | undefined): Observable<PrintRequestFromPrintingDto> {
        let url_ = this.baseUrl + "/api/services/app/Printing/CreatePrintRequestForPrint?";
        if (printRequestId === null)
            throw new Error("The parameter 'printRequestId' cannot be null.");
        else if (printRequestId !== undefined)
            url_ += "printRequestId=" + encodeURIComponent("" + printRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePrintRequestForPrint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePrintRequestForPrint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintRequestFromPrintingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintRequestFromPrintingDto>;
        }));
    }

    protected processCreatePrintRequestForPrint(response: HttpResponseBase): Observable<PrintRequestFromPrintingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintRequestFromPrintingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrintRequestFromPrintingDto>(null as any);
    }

    /**
     * @param printRequestId (optional) 
     * @return Success
     */
    createPrintRequestForPrintList(printRequestId: number | undefined): Observable<PrintRequestFromPrintingDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Printing/CreatePrintRequestForPrintList?";
        if (printRequestId === null)
            throw new Error("The parameter 'printRequestId' cannot be null.");
        else if (printRequestId !== undefined)
            url_ += "printRequestId=" + encodeURIComponent("" + printRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePrintRequestForPrintList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePrintRequestForPrintList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintRequestFromPrintingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintRequestFromPrintingDto[]>;
        }));
    }

    protected processCreatePrintRequestForPrintList(response: HttpResponseBase): Observable<PrintRequestFromPrintingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PrintRequestFromPrintingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrintRequestFromPrintingDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    updatePrintRequestPrinted(id: number | undefined): Observable<PrintRequest> {
        let url_ = this.baseUrl + "/api/services/app/Printing/UpdatePrintRequestPrinted?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePrintRequestPrinted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePrintRequestPrinted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintRequest>;
        }));
    }

    protected processUpdatePrintRequestPrinted(response: HttpResponseBase): Observable<PrintRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrintRequest>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    updatePrintRequestPrinting(id: number | undefined): Observable<PrintRequest> {
        let url_ = this.baseUrl + "/api/services/app/Printing/UpdatePrintRequestPrinting?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePrintRequestPrinting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePrintRequestPrinting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintRequest>;
        }));
    }

    protected processUpdatePrintRequestPrinting(response: HttpResponseBase): Observable<PrintRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrintRequest>(null as any);
    }

    /**
     * @param printPointName (optional) 
     * @return Success
     */
    updatePrintRequestPrintingStatus(printPointName: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Printing/UpdatePrintRequestPrintingStatus?";
        if (printPointName !== undefined && printPointName !== null)
            url_ += "printPointName=" + encodeURIComponent("" + printPointName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePrintRequestPrintingStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePrintRequestPrintingStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePrintRequestPrintingStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deletePrintRequest(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Printing/DeletePrintRequest?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePrintRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePrintRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePrintRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getD2DCheck(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Printing/GetD2DCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetD2DCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetD2DCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetD2DCheck(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param typeList (optional) 
     * @return Success
     */
    getPrintRequestListNotPrinted(warehouseId: number | undefined, typeList: string | null | undefined): Observable<PrintRequestDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Printing/GetPrintRequestListNotPrinted?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (typeList !== undefined && typeList !== null)
            url_ += "typeList=" + encodeURIComponent("" + typeList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrintRequestListNotPrinted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrintRequestListNotPrinted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintRequestDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintRequestDto[]>;
        }));
    }

    protected processGetPrintRequestListNotPrinted(response: HttpResponseBase): Observable<PrintRequestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PrintRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrintRequestDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPrintRequestBatchForShelf(body: BatchPrintRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Printing/CreatePrintRequestBatchForShelf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePrintRequestBatchForShelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePrintRequestBatchForShelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreatePrintRequestBatchForShelf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPrintRequestBatchForBarcode(body: BatchBarcodePrintRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Printing/CreatePrintRequestBatchForBarcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePrintRequestBatchForBarcode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePrintRequestBatchForBarcode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreatePrintRequestBatchForBarcode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param type (optional) 
     * @param objectId (optional) 
     * @param code (optional) 
     * @param quantity (optional) 
     * @param printSize (optional) 
     * @param printPointName (optional) 
     * @return Success
     */
    createPrintRequest(companyId: number | undefined, warehouseId: number | undefined, type: number | undefined, objectId: number | undefined, code: string | null | undefined, quantity: number | undefined, printSize: string | null | undefined, printPointName: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Printing/CreatePrintRequest?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (objectId === null)
            throw new Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (printSize !== undefined && printSize !== null)
            url_ += "printSize=" + encodeURIComponent("" + printSize) + "&";
        if (printPointName !== undefined && printPointName !== null)
            url_ += "printPointName=" + encodeURIComponent("" + printPointName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePrintRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePrintRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreatePrintRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param name (optional) 
     * @return Success
     */
    createPrintPoint(warehouseId: number | undefined, name: string | null | undefined): Observable<PrintPoint> {
        let url_ = this.baseUrl + "/api/services/app/Printing/CreatePrintPoint?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePrintPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePrintPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintPoint>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintPoint>;
        }));
    }

    protected processCreatePrintPoint(response: HttpResponseBase): Observable<PrintPoint> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintPoint.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrintPoint>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deletePrintPoint(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Printing/DeletePrintPoint?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePrintPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePrintPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePrintPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param name (optional) 
     * @return Success
     */
    getPrintPointList(warehouseId: number | undefined, name: string | null | undefined): Observable<PrintPoint[]> {
        let url_ = this.baseUrl + "/api/services/app/Printing/GetPrintPointList?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrintPointList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrintPointList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintPoint[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintPoint[]>;
        }));
    }

    protected processGetPrintPointList(response: HttpResponseBase): Observable<PrintPoint[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PrintPoint.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrintPoint[]>(null as any);
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    getPrintSizeList(type: number | undefined): Observable<PrintSize[]> {
        let url_ = this.baseUrl + "/api/services/app/Printing/GetPrintSizeList?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrintSizeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrintSizeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintSize[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintSize[]>;
        }));
    }

    protected processGetPrintSizeList(response: HttpResponseBase): Observable<PrintSize[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PrintSize.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrintSize[]>(null as any);
    }
}

@Injectable()
export class ProductServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param depo1Id (optional) 
     * @param depo2Id (optional) 
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param sortActive (optional) 
     * @param sortDirection (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportStockDiffListbyWarehouse(depo1Id: number | undefined, depo2Id: number | undefined, productId: number | undefined, companyId: number | undefined, sortActive: string | null | undefined, sortDirection: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductQuantityWarehouseDifferenceDapperPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportStockDiffListbyWarehouse?";
        if (depo1Id === null)
            throw new Error("The parameter 'depo1Id' cannot be null.");
        else if (depo1Id !== undefined)
            url_ += "Depo1Id=" + encodeURIComponent("" + depo1Id) + "&";
        if (depo2Id === null)
            throw new Error("The parameter 'depo2Id' cannot be null.");
        else if (depo2Id !== undefined)
            url_ += "Depo2Id=" + encodeURIComponent("" + depo2Id) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (sortActive !== undefined && sortActive !== null)
            url_ += "sortActive=" + encodeURIComponent("" + sortActive) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportStockDiffListbyWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportStockDiffListbyWarehouse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductQuantityWarehouseDifferenceDapperPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductQuantityWarehouseDifferenceDapperPagedResultDto>;
        }));
    }

    protected processGetReportStockDiffListbyWarehouse(response: HttpResponseBase): Observable<ProductQuantityWarehouseDifferenceDapperPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductQuantityWarehouseDifferenceDapperPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductQuantityWarehouseDifferenceDapperPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param stockMovementTypeId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportStockDiffList(filter: number | undefined, productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, stockMovementTypeId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReportProductQuantityDiffDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportStockDiffList?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (stockMovementTypeId === null)
            throw new Error("The parameter 'stockMovementTypeId' cannot be null.");
        else if (stockMovementTypeId !== undefined)
            url_ += "StockMovementTypeId=" + encodeURIComponent("" + stockMovementTypeId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportStockDiffList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportStockDiffList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportProductQuantityDiffDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportProductQuantityDiffDtoPagedResultDto>;
        }));
    }

    protected processGetReportStockDiffList(response: HttpResponseBase): Observable<ReportProductQuantityDiffDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportProductQuantityDiffDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportProductQuantityDiffDtoPagedResultDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param shelfId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param stockMovementTypeId (optional) 
     * @return Success
     */
    getReportStockMovementShelfList(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, shelfId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, stockMovementTypeId: number | undefined): Observable<StockMovementShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportStockMovementShelfList?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "ShelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (stockMovementTypeId === null)
            throw new Error("The parameter 'stockMovementTypeId' cannot be null.");
        else if (stockMovementTypeId !== undefined)
            url_ += "StockMovementTypeId=" + encodeURIComponent("" + stockMovementTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportStockMovementShelfList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportStockMovementShelfList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockMovementShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockMovementShelfDto[]>;
        }));
    }

    protected processGetReportStockMovementShelfList(response: HttpResponseBase): Observable<StockMovementShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockMovementShelfDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockMovementShelfDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param shelfId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param stockMovementTypeId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportStockMovementShelfListPaged(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, shelfId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, stockMovementTypeId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StockMovementShelfDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportStockMovementShelfListPaged?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "ShelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (stockMovementTypeId === null)
            throw new Error("The parameter 'stockMovementTypeId' cannot be null.");
        else if (stockMovementTypeId !== undefined)
            url_ += "StockMovementTypeId=" + encodeURIComponent("" + stockMovementTypeId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportStockMovementShelfListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportStockMovementShelfListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockMovementShelfDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockMovementShelfDtoPagedResultDto>;
        }));
    }

    protected processGetReportStockMovementShelfListPaged(response: HttpResponseBase): Observable<StockMovementShelfDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockMovementShelfDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockMovementShelfDtoPagedResultDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param shelfId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param stockMovementTypeId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportStockMovementShelfListPagedForOrder(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, shelfId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, stockMovementTypeId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StockMovementShelfDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportStockMovementShelfListPagedForOrder?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "ShelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (stockMovementTypeId === null)
            throw new Error("The parameter 'stockMovementTypeId' cannot be null.");
        else if (stockMovementTypeId !== undefined)
            url_ += "StockMovementTypeId=" + encodeURIComponent("" + stockMovementTypeId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportStockMovementShelfListPagedForOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportStockMovementShelfListPagedForOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockMovementShelfDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockMovementShelfDtoPagedResultDto>;
        }));
    }

    protected processGetReportStockMovementShelfListPagedForOrder(response: HttpResponseBase): Observable<StockMovementShelfDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockMovementShelfDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockMovementShelfDtoPagedResultDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param shelfId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param stockMovementTypeId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportStockMovementShelfListForQuantityPaged(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, shelfId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, stockMovementTypeId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductQuantityShelfPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportStockMovementShelfListForQuantityPaged?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "ShelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (stockMovementTypeId === null)
            throw new Error("The parameter 'stockMovementTypeId' cannot be null.");
        else if (stockMovementTypeId !== undefined)
            url_ += "StockMovementTypeId=" + encodeURIComponent("" + stockMovementTypeId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportStockMovementShelfListForQuantityPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportStockMovementShelfListForQuantityPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductQuantityShelfPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductQuantityShelfPagedResultDto>;
        }));
    }

    protected processGetReportStockMovementShelfListForQuantityPaged(response: HttpResponseBase): Observable<ProductQuantityShelfPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductQuantityShelfPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductQuantityShelfPagedResultDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param shelfId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param stockMovementTypeId (optional) 
     * @return Success
     */
    getReportStockMovementShelfListForReplenishmentProductDistribution(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, shelfId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, stockMovementTypeId: number | undefined): Observable<StockMovementShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportStockMovementShelfListForReplenishmentProductDistribution?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "ShelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (stockMovementTypeId === null)
            throw new Error("The parameter 'stockMovementTypeId' cannot be null.");
        else if (stockMovementTypeId !== undefined)
            url_ += "StockMovementTypeId=" + encodeURIComponent("" + stockMovementTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportStockMovementShelfListForReplenishmentProductDistribution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportStockMovementShelfListForReplenishmentProductDistribution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockMovementShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockMovementShelfDto[]>;
        }));
    }

    protected processGetReportStockMovementShelfListForReplenishmentProductDistribution(response: HttpResponseBase): Observable<StockMovementShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockMovementShelfDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockMovementShelfDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param shelfId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param stockMovementTypeId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportStockMovementEmptyShelfList(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, shelfId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, stockMovementTypeId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<EmptyShelfDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportStockMovementEmptyShelfList?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "ShelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (stockMovementTypeId === null)
            throw new Error("The parameter 'stockMovementTypeId' cannot be null.");
        else if (stockMovementTypeId !== undefined)
            url_ += "StockMovementTypeId=" + encodeURIComponent("" + stockMovementTypeId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportStockMovementEmptyShelfList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportStockMovementEmptyShelfList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmptyShelfDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmptyShelfDtoPagedResultDto>;
        }));
    }

    protected processGetReportStockMovementEmptyShelfList(response: HttpResponseBase): Observable<EmptyShelfDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmptyShelfDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmptyShelfDtoPagedResultDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param shelfId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param stockMovementTypeId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportStockMovementFullShelfList(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, shelfId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, stockMovementTypeId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FullShelfDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportStockMovementFullShelfList?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "ShelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (stockMovementTypeId === null)
            throw new Error("The parameter 'stockMovementTypeId' cannot be null.");
        else if (stockMovementTypeId !== undefined)
            url_ += "StockMovementTypeId=" + encodeURIComponent("" + stockMovementTypeId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportStockMovementFullShelfList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportStockMovementFullShelfList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FullShelfDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FullShelfDtoPagedResultDto>;
        }));
    }

    protected processGetReportStockMovementFullShelfList(response: HttpResponseBase): Observable<FullShelfDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FullShelfDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FullShelfDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param overall_count (optional) 
     * @param productId (optional) 
     * @param productCode (optional) 
     * @param productName (optional) 
     * @param productManufacturer (optional) 
     * @param companyId (optional) 
     * @param companyCode (optional) 
     * @param warehouseId (optional) 
     * @param warehouseCode (optional) 
     * @param warehouseName (optional) 
     * @param storageId (optional) 
     * @param storageCode (optional) 
     * @param storageName (optional) 
     * @param shelfId (optional) 
     * @param shelfAddress (optional) 
     * @param shelfTypePriority (optional) 
     * @param shelfUserType (optional) 
     * @param shelfRegion (optional) 
     * @param shelfFloorNo (optional) 
     * @param shelfSequenceNo (optional) 
     * @param quantity (optional) 
     * @param quantityIn (optional) 
     * @param quantityOut (optional) 
     * @return Success
     */
    getReportStockMovementShelfListForQuantityForPda(id: number | undefined, overall_count: number | undefined, productId: number | undefined, productCode: string | null | undefined, productName: string | null | undefined, productManufacturer: string | null | undefined, companyId: number | undefined, companyCode: string | null | undefined, warehouseId: number | undefined, warehouseCode: string | null | undefined, warehouseName: string | null | undefined, storageId: number | undefined, storageCode: string | null | undefined, storageName: string | null | undefined, shelfId: number | undefined, shelfAddress: string | null | undefined, shelfTypePriority: number | undefined, shelfUserType: string | null | undefined, shelfRegion: string | null | undefined, shelfFloorNo: number | undefined, shelfSequenceNo: number | undefined, quantity: number | undefined, quantityIn: number | undefined, quantityOut: number | undefined): Observable<ProductQuantityShelf[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportStockMovementShelfListForQuantityForPda?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (overall_count === null)
            throw new Error("The parameter 'overall_count' cannot be null.");
        else if (overall_count !== undefined)
            url_ += "overall_count=" + encodeURIComponent("" + overall_count) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (productCode !== undefined && productCode !== null)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        if (productName !== undefined && productName !== null)
            url_ += "ProductName=" + encodeURIComponent("" + productName) + "&";
        if (productManufacturer !== undefined && productManufacturer !== null)
            url_ += "ProductManufacturer=" + encodeURIComponent("" + productManufacturer) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (companyCode !== undefined && companyCode !== null)
            url_ += "CompanyCode=" + encodeURIComponent("" + companyCode) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (warehouseCode !== undefined && warehouseCode !== null)
            url_ += "WarehouseCode=" + encodeURIComponent("" + warehouseCode) + "&";
        if (warehouseName !== undefined && warehouseName !== null)
            url_ += "WarehouseName=" + encodeURIComponent("" + warehouseName) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (storageCode !== undefined && storageCode !== null)
            url_ += "StorageCode=" + encodeURIComponent("" + storageCode) + "&";
        if (storageName !== undefined && storageName !== null)
            url_ += "StorageName=" + encodeURIComponent("" + storageName) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "ShelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (shelfAddress !== undefined && shelfAddress !== null)
            url_ += "ShelfAddress=" + encodeURIComponent("" + shelfAddress) + "&";
        if (shelfTypePriority === null)
            throw new Error("The parameter 'shelfTypePriority' cannot be null.");
        else if (shelfTypePriority !== undefined)
            url_ += "ShelfTypePriority=" + encodeURIComponent("" + shelfTypePriority) + "&";
        if (shelfUserType !== undefined && shelfUserType !== null)
            url_ += "ShelfUserType=" + encodeURIComponent("" + shelfUserType) + "&";
        if (shelfRegion !== undefined && shelfRegion !== null)
            url_ += "ShelfRegion=" + encodeURIComponent("" + shelfRegion) + "&";
        if (shelfFloorNo === null)
            throw new Error("The parameter 'shelfFloorNo' cannot be null.");
        else if (shelfFloorNo !== undefined)
            url_ += "ShelfFloorNo=" + encodeURIComponent("" + shelfFloorNo) + "&";
        if (shelfSequenceNo === null)
            throw new Error("The parameter 'shelfSequenceNo' cannot be null.");
        else if (shelfSequenceNo !== undefined)
            url_ += "ShelfSequenceNo=" + encodeURIComponent("" + shelfSequenceNo) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "Quantity=" + encodeURIComponent("" + quantity) + "&";
        if (quantityIn === null)
            throw new Error("The parameter 'quantityIn' cannot be null.");
        else if (quantityIn !== undefined)
            url_ += "QuantityIn=" + encodeURIComponent("" + quantityIn) + "&";
        if (quantityOut === null)
            throw new Error("The parameter 'quantityOut' cannot be null.");
        else if (quantityOut !== undefined)
            url_ += "QuantityOut=" + encodeURIComponent("" + quantityOut) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportStockMovementShelfListForQuantityForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportStockMovementShelfListForQuantityForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductQuantityShelf[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductQuantityShelf[]>;
        }));
    }

    protected processGetReportStockMovementShelfListForQuantityForPda(response: HttpResponseBase): Observable<ProductQuantityShelf[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductQuantityShelf.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductQuantityShelf[]>(null as any);
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    getStockMovementTypeList(type: number | undefined): Observable<StockMovementType[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetStockMovementTypeList?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockMovementTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockMovementTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockMovementType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockMovementType[]>;
        }));
    }

    protected processGetStockMovementTypeList(response: HttpResponseBase): Observable<StockMovementType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockMovementType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockMovementType[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param shelfId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param status (optional) 
     * @param documentNo (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStockOutList(productId: number | undefined, shelfId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, status: number | undefined, documentNo: string | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StockOutDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetStockOutList?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "ShelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockOutList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockOutList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockOutDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockOutDtoPagedResultDto>;
        }));
    }

    protected processGetStockOutList(response: HttpResponseBase): Observable<StockOutDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockOutDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockOutDtoPagedResultDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param shelfId (optional) 
     * @return Success
     */
    createStockOut(productId: number | undefined, shelfId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateStockOut?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStockOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStockOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateStockOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageIdFrom (optional) 
     * @param storageIdTo (optional) 
     * @param shelfIdTo (optional) 
     * @param shelfIdFrom (optional) 
     * @param transferTypeId (optional) 
     * @param creatorUserId (optional) 
     * @param clientId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportStorageTransferListPaged(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageIdFrom: number | undefined, storageIdTo: number | undefined, shelfIdTo: number | undefined, shelfIdFrom: number | undefined, transferTypeId: number | undefined, creatorUserId: number | undefined, clientId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TransferDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportStorageTransferListPaged?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageIdFrom === null)
            throw new Error("The parameter 'storageIdFrom' cannot be null.");
        else if (storageIdFrom !== undefined)
            url_ += "StorageIdFrom=" + encodeURIComponent("" + storageIdFrom) + "&";
        if (storageIdTo === null)
            throw new Error("The parameter 'storageIdTo' cannot be null.");
        else if (storageIdTo !== undefined)
            url_ += "StorageIdTo=" + encodeURIComponent("" + storageIdTo) + "&";
        if (shelfIdTo === null)
            throw new Error("The parameter 'shelfIdTo' cannot be null.");
        else if (shelfIdTo !== undefined)
            url_ += "ShelfIdTo=" + encodeURIComponent("" + shelfIdTo) + "&";
        if (shelfIdFrom === null)
            throw new Error("The parameter 'shelfIdFrom' cannot be null.");
        else if (shelfIdFrom !== undefined)
            url_ += "ShelfIdFrom=" + encodeURIComponent("" + shelfIdFrom) + "&";
        if (transferTypeId === null)
            throw new Error("The parameter 'transferTypeId' cannot be null.");
        else if (transferTypeId !== undefined)
            url_ += "TransferTypeId=" + encodeURIComponent("" + transferTypeId) + "&";
        if (creatorUserId === null)
            throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportStorageTransferListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportStorageTransferListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferDetailDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferDetailDtoPagedResultDto>;
        }));
    }

    protected processGetReportStorageTransferListPaged(response: HttpResponseBase): Observable<TransferDetailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferDetailDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferDetailDtoPagedResultDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageIdFrom (optional) 
     * @param storageIdTo (optional) 
     * @param shelfIdTo (optional) 
     * @param shelfIdFrom (optional) 
     * @param transferTypeId (optional) 
     * @param creatorUserId (optional) 
     * @param clientId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportShelfTransferListPaged(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageIdFrom: number | undefined, storageIdTo: number | undefined, shelfIdTo: number | undefined, shelfIdFrom: number | undefined, transferTypeId: number | undefined, creatorUserId: number | undefined, clientId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TransferDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportShelfTransferListPaged?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageIdFrom === null)
            throw new Error("The parameter 'storageIdFrom' cannot be null.");
        else if (storageIdFrom !== undefined)
            url_ += "StorageIdFrom=" + encodeURIComponent("" + storageIdFrom) + "&";
        if (storageIdTo === null)
            throw new Error("The parameter 'storageIdTo' cannot be null.");
        else if (storageIdTo !== undefined)
            url_ += "StorageIdTo=" + encodeURIComponent("" + storageIdTo) + "&";
        if (shelfIdTo === null)
            throw new Error("The parameter 'shelfIdTo' cannot be null.");
        else if (shelfIdTo !== undefined)
            url_ += "ShelfIdTo=" + encodeURIComponent("" + shelfIdTo) + "&";
        if (shelfIdFrom === null)
            throw new Error("The parameter 'shelfIdFrom' cannot be null.");
        else if (shelfIdFrom !== undefined)
            url_ += "ShelfIdFrom=" + encodeURIComponent("" + shelfIdFrom) + "&";
        if (transferTypeId === null)
            throw new Error("The parameter 'transferTypeId' cannot be null.");
        else if (transferTypeId !== undefined)
            url_ += "TransferTypeId=" + encodeURIComponent("" + transferTypeId) + "&";
        if (creatorUserId === null)
            throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportShelfTransferListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportShelfTransferListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferDetailDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferDetailDtoPagedResultDto>;
        }));
    }

    protected processGetReportShelfTransferListPaged(response: HttpResponseBase): Observable<TransferDetailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferDetailDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferDetailDtoPagedResultDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageIdFrom (optional) 
     * @param storageIdTo (optional) 
     * @param shelfIdTo (optional) 
     * @param shelfIdFrom (optional) 
     * @param transferTypeId (optional) 
     * @param creatorUserId (optional) 
     * @param clientId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportTransferListPagedForClient(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageIdFrom: number | undefined, storageIdTo: number | undefined, shelfIdTo: number | undefined, shelfIdFrom: number | undefined, transferTypeId: number | undefined, creatorUserId: number | undefined, clientId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TransferDetailPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportTransferListPagedForClient?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageIdFrom === null)
            throw new Error("The parameter 'storageIdFrom' cannot be null.");
        else if (storageIdFrom !== undefined)
            url_ += "StorageIdFrom=" + encodeURIComponent("" + storageIdFrom) + "&";
        if (storageIdTo === null)
            throw new Error("The parameter 'storageIdTo' cannot be null.");
        else if (storageIdTo !== undefined)
            url_ += "StorageIdTo=" + encodeURIComponent("" + storageIdTo) + "&";
        if (shelfIdTo === null)
            throw new Error("The parameter 'shelfIdTo' cannot be null.");
        else if (shelfIdTo !== undefined)
            url_ += "ShelfIdTo=" + encodeURIComponent("" + shelfIdTo) + "&";
        if (shelfIdFrom === null)
            throw new Error("The parameter 'shelfIdFrom' cannot be null.");
        else if (shelfIdFrom !== undefined)
            url_ += "ShelfIdFrom=" + encodeURIComponent("" + shelfIdFrom) + "&";
        if (transferTypeId === null)
            throw new Error("The parameter 'transferTypeId' cannot be null.");
        else if (transferTypeId !== undefined)
            url_ += "TransferTypeId=" + encodeURIComponent("" + transferTypeId) + "&";
        if (creatorUserId === null)
            throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportTransferListPagedForClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportTransferListPagedForClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferDetailPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferDetailPagedResultDto>;
        }));
    }

    protected processGetReportTransferListPagedForClient(response: HttpResponseBase): Observable<TransferDetailPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferDetailPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferDetailPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getTransferTypeList(): Observable<TransferType[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetTransferTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferType[]>;
        }));
    }

    protected processGetTransferTypeList(response: HttpResponseBase): Observable<TransferType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransferType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferType[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageIdFrom (optional) 
     * @param storageIdTo (optional) 
     * @param shelfIdTo (optional) 
     * @param shelfIdFrom (optional) 
     * @param transferTypeId (optional) 
     * @param creatorUserId (optional) 
     * @param clientId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportTransferListDetailPaged(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageIdFrom: number | undefined, storageIdTo: number | undefined, shelfIdTo: number | undefined, shelfIdFrom: number | undefined, transferTypeId: number | undefined, creatorUserId: number | undefined, clientId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TransferListByTypeDapperPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportTransferListDetailPaged?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageIdFrom === null)
            throw new Error("The parameter 'storageIdFrom' cannot be null.");
        else if (storageIdFrom !== undefined)
            url_ += "StorageIdFrom=" + encodeURIComponent("" + storageIdFrom) + "&";
        if (storageIdTo === null)
            throw new Error("The parameter 'storageIdTo' cannot be null.");
        else if (storageIdTo !== undefined)
            url_ += "StorageIdTo=" + encodeURIComponent("" + storageIdTo) + "&";
        if (shelfIdTo === null)
            throw new Error("The parameter 'shelfIdTo' cannot be null.");
        else if (shelfIdTo !== undefined)
            url_ += "ShelfIdTo=" + encodeURIComponent("" + shelfIdTo) + "&";
        if (shelfIdFrom === null)
            throw new Error("The parameter 'shelfIdFrom' cannot be null.");
        else if (shelfIdFrom !== undefined)
            url_ += "ShelfIdFrom=" + encodeURIComponent("" + shelfIdFrom) + "&";
        if (transferTypeId === null)
            throw new Error("The parameter 'transferTypeId' cannot be null.");
        else if (transferTypeId !== undefined)
            url_ += "TransferTypeId=" + encodeURIComponent("" + transferTypeId) + "&";
        if (creatorUserId === null)
            throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportTransferListDetailPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportTransferListDetailPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferListByTypeDapperPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferListByTypeDapperPagedResultDto>;
        }));
    }

    protected processGetReportTransferListDetailPaged(response: HttpResponseBase): Observable<TransferListByTypeDapperPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferListByTypeDapperPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferListByTypeDapperPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCorrectionBatch(body: BatchCorrectionInsertDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateCorrectionBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCorrectionBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCorrectionBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCorrectionBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCorrectionBatch2(body: BatchCorrectionInsertDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateCorrectionBatch2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCorrectionBatch2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCorrectionBatch2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCorrectionBatch2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCorrectionBatchWithExcelOutput(body: BatchCorrectionInsertDto | undefined): Observable<BatchCorrectionOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateCorrectionBatchWithExcelOutput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCorrectionBatchWithExcelOutput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCorrectionBatchWithExcelOutput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchCorrectionOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchCorrectionOutputDto>;
        }));
    }

    protected processCreateCorrectionBatchWithExcelOutput(response: HttpResponseBase): Observable<BatchCorrectionOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchCorrectionOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchCorrectionOutputDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProduct(id: number | undefined): Observable<ProductExtendedDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProduct?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductExtendedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductExtendedDto>;
        }));
    }

    protected processGetProduct(response: HttpResponseBase): Observable<ProductExtendedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductExtendedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductExtendedDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param activeStatus (optional) 
     * @return Success
     */
    changeIsDeleted(id: number | undefined, activeStatus: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/ChangeIsDeleted?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (activeStatus === null)
            throw new Error("The parameter 'activeStatus' cannot be null.");
        else if (activeStatus !== undefined)
            url_ += "activeStatus=" + encodeURIComponent("" + activeStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeIsDeleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeIsDeleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeIsDeleted(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param code (optional) 
     * @return Success
     */
    getProductByCode(companyId: number | undefined, code: string | null | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductByCode?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processGetProductByCode(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param searchText (optional) 
     * @return Success
     */
    getProductList(companyId: number | undefined, searchText: string | null | undefined): Observable<ProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto[]>;
        }));
    }

    protected processGetProductList(response: HttpResponseBase): Observable<ProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    getProductListAllSmall(companyId: number | undefined): Observable<ProductSmallDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductListAllSmall?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductListAllSmall(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductListAllSmall(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSmallDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSmallDto[]>;
        }));
    }

    protected processGetProductListAllSmall(response: HttpResponseBase): Observable<ProductSmallDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductSmallDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSmallDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    getProductCodeListAll(companyId: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductCodeListAll?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductCodeListAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductCodeListAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetProductCodeListAll(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param searchText (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getProductListSearchLimited(companyId: number | undefined, searchText: string | null | undefined, limit: number | undefined): Observable<ProductSmallDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductListSearchLimited?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductListSearchLimited(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductListSearchLimited(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSmallDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSmallDto[]>;
        }));
    }

    protected processGetProductListSearchLimited(response: HttpResponseBase): Observable<ProductSmallDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductSmallDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSmallDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProduct(body: ProductDto | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/UpdateProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processUpdateProduct(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param shelfId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param stockMovementTypeId (optional) 
     * @return Success
     */
    getProductDistribution(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, shelfId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, stockMovementTypeId: number | undefined): Observable<ProductQuantityShelf[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductDistribution?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "ShelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (stockMovementTypeId === null)
            throw new Error("The parameter 'stockMovementTypeId' cannot be null.");
        else if (stockMovementTypeId !== undefined)
            url_ += "StockMovementTypeId=" + encodeURIComponent("" + stockMovementTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductDistribution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductDistribution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductQuantityShelf[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductQuantityShelf[]>;
        }));
    }

    protected processGetProductDistribution(response: HttpResponseBase): Observable<ProductQuantityShelf[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductQuantityShelf.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductQuantityShelf[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param code (optional) 
     * @param definition (optional) 
     * @param definition2 (optional) 
     * @param manufacturer (optional) 
     * @param isDeleted (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getProductListPaged(companyId: number | undefined, code: string | null | undefined, definition: string | null | undefined, definition2: string | null | undefined, manufacturer: string | null | undefined, isDeleted: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (definition !== undefined && definition !== null)
            url_ += "Definition=" + encodeURIComponent("" + definition) + "&";
        if (definition2 !== undefined && definition2 !== null)
            url_ += "Definition2=" + encodeURIComponent("" + definition2) + "&";
        if (manufacturer !== undefined && manufacturer !== null)
            url_ += "Manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDtoPagedResultDto>;
        }));
    }

    protected processGetProductListPaged(response: HttpResponseBase): Observable<ProductDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param status (optional) 
     * @param code (optional) 
     * @param definition (optional) 
     * @param manufacturer (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReplenishmentProductListPaged(companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, status: number | undefined, code: string | null | undefined, definition: string | null | undefined, manufacturer: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReplenishmentProductListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (definition !== undefined && definition !== null)
            url_ += "Definition=" + encodeURIComponent("" + definition) + "&";
        if (manufacturer !== undefined && manufacturer !== null)
            url_ += "Manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReplenishmentProductListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReplenishmentProductListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDtoPagedResultDto>;
        }));
    }

    protected processGetReplenishmentProductListPaged(response: HttpResponseBase): Observable<ProductDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param code (optional) 
     * @param definition (optional) 
     * @param manufacturer (optional) 
     * @return Success
     */
    createProduct(companyId: number | undefined, code: string | null | undefined, definition: string | null | undefined, manufacturer: string | null | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateProduct?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (definition !== undefined && definition !== null)
            url_ += "definition=" + encodeURIComponent("" + definition) + "&";
        if (manufacturer !== undefined && manufacturer !== null)
            url_ += "manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processCreateProduct(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProductBatch(body: BatchProductInsertDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateProductBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProductBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateProductBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getProductListNonBarcodePaged(companyId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductNoBarcodeDapperPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductListNonBarcodePaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductListNonBarcodePaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductListNonBarcodePaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductNoBarcodeDapperPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductNoBarcodeDapperPagedResultDto>;
        }));
    }

    protected processGetProductListNonBarcodePaged(response: HttpResponseBase): Observable<ProductNoBarcodeDapperPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductNoBarcodeDapperPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductNoBarcodeDapperPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getProductListDuplicateBarcodePaged(companyId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductDuplicateBarcodeDapperPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductListDuplicateBarcodePaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductListDuplicateBarcodePaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductListDuplicateBarcodePaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDuplicateBarcodeDapperPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDuplicateBarcodeDapperPagedResultDto>;
        }));
    }

    protected processGetProductListDuplicateBarcodePaged(response: HttpResponseBase): Observable<ProductDuplicateBarcodeDapperPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDuplicateBarcodeDapperPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDuplicateBarcodeDapperPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    getManufacturerList(companyId: number | undefined): Observable<Manufacturer[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetManufacturerList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManufacturerList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManufacturerList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Manufacturer[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Manufacturer[]>;
        }));
    }

    protected processGetManufacturerList(response: HttpResponseBase): Observable<Manufacturer[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Manufacturer.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Manufacturer[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param status (optional) 
     * @param code (optional) 
     * @param definition (optional) 
     * @param manufacturer (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReplenishmentManufacturerList(companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, status: number | undefined, code: string | null | undefined, definition: string | null | undefined, manufacturer: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<Manufacturer[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReplenishmentManufacturerList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (definition !== undefined && definition !== null)
            url_ += "Definition=" + encodeURIComponent("" + definition) + "&";
        if (manufacturer !== undefined && manufacturer !== null)
            url_ += "Manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReplenishmentManufacturerList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReplenishmentManufacturerList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Manufacturer[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Manufacturer[]>;
        }));
    }

    protected processGetReplenishmentManufacturerList(response: HttpResponseBase): Observable<Manufacturer[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Manufacturer.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Manufacturer[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    trasnferProductStockReset(body: BatchProductStockResetRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/TrasnferProductStockReset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrasnferProductStockReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrasnferProductStockReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrasnferProductStockReset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    getBarcodeListByProduct(productId: number | undefined): Observable<BarcodeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetBarcodeListByProduct?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBarcodeListByProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBarcodeListByProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarcodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarcodeDto[]>;
        }));
    }

    protected processGetBarcodeListByProduct(response: HttpResponseBase): Observable<BarcodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BarcodeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BarcodeDto[]>(null as any);
    }

    /**
     * @param code (optional) 
     * @param companyId (optional) 
     * @return Success
     */
    getBarcodeByCode(code: string | null | undefined, companyId: number | undefined): Observable<BarcodeDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetBarcodeByCode?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBarcodeByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBarcodeByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarcodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarcodeDto>;
        }));
    }

    protected processGetBarcodeByCode(response: HttpResponseBase): Observable<BarcodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarcodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BarcodeDto>(null as any);
    }

    /**
     * @param code (optional) 
     * @param companyId (optional) 
     * @return Success
     */
    getBarcodeByCodeNew(code: string | null | undefined, companyId: number | undefined): Observable<BarcodeDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetBarcodeByCodeNew?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBarcodeByCodeNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBarcodeByCodeNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarcodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarcodeDto>;
        }));
    }

    protected processGetBarcodeByCodeNew(response: HttpResponseBase): Observable<BarcodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarcodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BarcodeDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBarcode(id: number | undefined): Observable<BarcodeDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetBarcode?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBarcode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBarcode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarcodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarcodeDto>;
        }));
    }

    protected processGetBarcode(response: HttpResponseBase): Observable<BarcodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarcodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BarcodeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBarcode(body: BarcodeInsertDto | undefined): Observable<BarcodeDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateBarcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBarcode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBarcode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarcodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarcodeDto>;
        }));
    }

    protected processCreateBarcode(response: HttpResponseBase): Observable<BarcodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarcodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BarcodeDto>(null as any);
    }

    /**
     * @param code (optional) 
     * @param companyId (optional) 
     * @return Success
     */
    getProductDefinitionByCode(code: string | null | undefined, companyId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductDefinitionByCode?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductDefinitionByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductDefinitionByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetProductDefinitionByCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param code (optional) 
     * @param companyId (optional) 
     * @return Success
     */
    getProductByBarcodeCode(code: string | null | undefined, companyId: number | undefined): Observable<Product> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductByBarcodeCode?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductByBarcodeCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductByBarcodeCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Product>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Product>;
        }));
    }

    protected processGetProductByBarcodeCode(response: HttpResponseBase): Observable<Product> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Product.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Product>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBarcode(body: BarcodeUpdateDto | undefined): Observable<BarcodeDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/UpdateBarcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBarcode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBarcode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarcodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarcodeDto>;
        }));
    }

    protected processUpdateBarcode(response: HttpResponseBase): Observable<BarcodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarcodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BarcodeDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteBarcode(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/DeleteBarcode?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBarcode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBarcode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBarcode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBarcodeBatch(body: BatchBarcodeInsertDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateBarcodeBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBarcodeBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBarcodeBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateBarcodeBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    transferProductRecodeBatch(body: BatchProductRecodeRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/TransferProductRecodeBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransferProductRecodeBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferProductRecodeBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTransferProductRecodeBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getShelfList(): Observable<Shelf[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetShelfList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf[]>;
        }));
    }

    protected processGetShelfList(response: HttpResponseBase): Observable<Shelf[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Shelf.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createShelf(body: Shelf | undefined): Observable<Shelf> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateShelf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf>;
        }));
    }

    protected processCreateShelf(response: HttpResponseBase): Observable<Shelf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Shelf.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf>(null as any);
    }

    /**
     * @param storageId (optional) 
     * @param shelfTypeId (optional) 
     * @param fullAddress (optional) 
     * @return Success
     */
    createShelfWithFullAdress(storageId: number | undefined, shelfTypeId: number | undefined, fullAddress: string | null | undefined): Observable<Shelf> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateShelfWithFullAdress?";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfTypeId === null)
            throw new Error("The parameter 'shelfTypeId' cannot be null.");
        else if (shelfTypeId !== undefined)
            url_ += "shelfTypeId=" + encodeURIComponent("" + shelfTypeId) + "&";
        if (fullAddress !== undefined && fullAddress !== null)
            url_ += "fullAddress=" + encodeURIComponent("" + fullAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShelfWithFullAdress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShelfWithFullAdress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf>;
        }));
    }

    protected processCreateShelfWithFullAdress(response: HttpResponseBase): Observable<Shelf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Shelf.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf>(null as any);
    }

    /**
     * @return Success
     */
    getUserShelfTypeList(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetUserShelfTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserShelfTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserShelfTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetUserShelfTypeList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createShelfBatch(body: BatchShelfInsertDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateShelfBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShelfBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShelfBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateShelfBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param fullAddressList (optional) 
     * @param storageId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    deleteShelfBatch(fullAddressList: string[] | null | undefined, storageId: number | undefined, warehouseId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/DeleteShelfBatch?";
        if (fullAddressList !== undefined && fullAddressList !== null)
            fullAddressList && fullAddressList.forEach(item => { url_ += "FullAddressList=" + encodeURIComponent("" + item) + "&"; });
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteShelfBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteShelfBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteShelfBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateShelf(body: Shelf | undefined): Observable<Shelf> {
        let url_ = this.baseUrl + "/api/services/app/Product/UpdateShelf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf>;
        }));
    }

    protected processUpdateShelf(response: HttpResponseBase): Observable<Shelf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Shelf.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf>(null as any);
    }

    /**
     * @param code (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @return Success
     */
    getShelfByCode(code: string | null | undefined, warehouseId: number | undefined, storageId: number | undefined): Observable<Shelf> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetShelfByCode?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf>;
        }));
    }

    protected processGetShelfByCode(response: HttpResponseBase): Observable<Shelf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Shelf.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param includeOld (optional) 
     * @param actionId (optional) 
     * @return Success
     */
    getShelfListForPlacement(productId: number | undefined, includeOld: boolean | undefined, actionId: number | undefined): Observable<Shelf[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetShelfListForPlacement?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (includeOld === null)
            throw new Error("The parameter 'includeOld' cannot be null.");
        else if (includeOld !== undefined)
            url_ += "includeOld=" + encodeURIComponent("" + includeOld) + "&";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfListForPlacement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfListForPlacement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf[]>;
        }));
    }

    protected processGetShelfListForPlacement(response: HttpResponseBase): Observable<Shelf[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Shelf.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param includeOld (optional) 
     * @param actionId (optional) 
     * @return Success
     */
    getShelfListForPlacementForPda(productId: number | undefined, includeOld: boolean | undefined, actionId: number | undefined): Observable<ShelfPdaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetShelfListForPlacementForPda?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (includeOld === null)
            throw new Error("The parameter 'includeOld' cannot be null.");
        else if (includeOld !== undefined)
            url_ += "includeOld=" + encodeURIComponent("" + includeOld) + "&";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfListForPlacementForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfListForPlacementForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShelfPdaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShelfPdaDto[]>;
        }));
    }

    protected processGetShelfListForPlacementForPda(response: HttpResponseBase): Observable<ShelfPdaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShelfPdaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShelfPdaDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param shelfTypeId (optional) 
     * @param fullAddress (optional) 
     * @param region (optional) 
     * @param street (optional) 
     * @param apartment (optional) 
     * @param apartmentNo (optional) 
     * @param floor (optional) 
     * @param floorNo (optional) 
     * @param sequence (optional) 
     * @param sequenceNo (optional) 
     * @param hasPriority (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getShelfListPaged(companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, shelfTypeId: number | undefined, fullAddress: string | null | undefined, region: string | null | undefined, street: string | null | undefined, apartment: string | null | undefined, apartmentNo: string | null | undefined, floor: string | null | undefined, floorNo: string | null | undefined, sequence: string | null | undefined, sequenceNo: string | null | undefined, hasPriority: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShelfPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetShelfListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfTypeId === null)
            throw new Error("The parameter 'shelfTypeId' cannot be null.");
        else if (shelfTypeId !== undefined)
            url_ += "ShelfTypeId=" + encodeURIComponent("" + shelfTypeId) + "&";
        if (fullAddress !== undefined && fullAddress !== null)
            url_ += "FullAddress=" + encodeURIComponent("" + fullAddress) + "&";
        if (region !== undefined && region !== null)
            url_ += "Region=" + encodeURIComponent("" + region) + "&";
        if (street !== undefined && street !== null)
            url_ += "Street=" + encodeURIComponent("" + street) + "&";
        if (apartment !== undefined && apartment !== null)
            url_ += "Apartment=" + encodeURIComponent("" + apartment) + "&";
        if (apartmentNo !== undefined && apartmentNo !== null)
            url_ += "ApartmentNo=" + encodeURIComponent("" + apartmentNo) + "&";
        if (floor !== undefined && floor !== null)
            url_ += "Floor=" + encodeURIComponent("" + floor) + "&";
        if (floorNo !== undefined && floorNo !== null)
            url_ += "FloorNo=" + encodeURIComponent("" + floorNo) + "&";
        if (sequence !== undefined && sequence !== null)
            url_ += "Sequence=" + encodeURIComponent("" + sequence) + "&";
        if (sequenceNo !== undefined && sequenceNo !== null)
            url_ += "SequenceNo=" + encodeURIComponent("" + sequenceNo) + "&";
        if (hasPriority === null)
            throw new Error("The parameter 'hasPriority' cannot be null.");
        else if (hasPriority !== undefined)
            url_ += "HasPriority=" + encodeURIComponent("" + hasPriority) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShelfPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShelfPagedResultDto>;
        }));
    }

    protected processGetShelfListPaged(response: HttpResponseBase): Observable<ShelfPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShelfPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShelfPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getShelfListOrdered(): Observable<Shelf[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetShelfListOrdered";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfListOrdered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfListOrdered(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf[]>;
        }));
    }

    protected processGetShelfListOrdered(response: HttpResponseBase): Observable<Shelf[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Shelf.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf[]>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @return Success
     */
    getStockTakingUnassignedShelfList(stHeaderId: number | undefined): Observable<Shelf[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetStockTakingUnassignedShelfList?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingUnassignedShelfList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingUnassignedShelfList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf[]>;
        }));
    }

    protected processGetStockTakingUnassignedShelfList(response: HttpResponseBase): Observable<Shelf[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Shelf.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf[]>(null as any);
    }

    /**
     * @param stockTakingHeaderId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param shelfTypeId (optional) 
     * @param fullAddress (optional) 
     * @param region (optional) 
     * @param street (optional) 
     * @param apartment (optional) 
     * @param apartmentNo (optional) 
     * @param floor (optional) 
     * @param floorNo (optional) 
     * @param sequence (optional) 
     * @param sequenceNo (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStockTakingUnassignedShelfListPaged(stockTakingHeaderId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, shelfTypeId: number | undefined, fullAddress: string | null | undefined, region: string | null | undefined, street: string | null | undefined, apartment: string | null | undefined, apartmentNo: string | null | undefined, floor: string | null | undefined, floorNo: string | null | undefined, sequence: string | null | undefined, sequenceNo: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShelfPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetStockTakingUnassignedShelfListPaged?";
        if (stockTakingHeaderId === null)
            throw new Error("The parameter 'stockTakingHeaderId' cannot be null.");
        else if (stockTakingHeaderId !== undefined)
            url_ += "StockTakingHeaderId=" + encodeURIComponent("" + stockTakingHeaderId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfTypeId === null)
            throw new Error("The parameter 'shelfTypeId' cannot be null.");
        else if (shelfTypeId !== undefined)
            url_ += "ShelfTypeId=" + encodeURIComponent("" + shelfTypeId) + "&";
        if (fullAddress !== undefined && fullAddress !== null)
            url_ += "FullAddress=" + encodeURIComponent("" + fullAddress) + "&";
        if (region !== undefined && region !== null)
            url_ += "Region=" + encodeURIComponent("" + region) + "&";
        if (street !== undefined && street !== null)
            url_ += "Street=" + encodeURIComponent("" + street) + "&";
        if (apartment !== undefined && apartment !== null)
            url_ += "Apartment=" + encodeURIComponent("" + apartment) + "&";
        if (apartmentNo !== undefined && apartmentNo !== null)
            url_ += "ApartmentNo=" + encodeURIComponent("" + apartmentNo) + "&";
        if (floor !== undefined && floor !== null)
            url_ += "Floor=" + encodeURIComponent("" + floor) + "&";
        if (floorNo !== undefined && floorNo !== null)
            url_ += "FloorNo=" + encodeURIComponent("" + floorNo) + "&";
        if (sequence !== undefined && sequence !== null)
            url_ += "Sequence=" + encodeURIComponent("" + sequence) + "&";
        if (sequenceNo !== undefined && sequenceNo !== null)
            url_ += "SequenceNo=" + encodeURIComponent("" + sequenceNo) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingUnassignedShelfListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingUnassignedShelfListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShelfPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShelfPagedResultDto>;
        }));
    }

    protected processGetStockTakingUnassignedShelfListPaged(response: HttpResponseBase): Observable<ShelfPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShelfPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShelfPagedResultDto>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @return Success
     */
    getStockTakingAssignedShelfList(stHeaderId: number | undefined): Observable<Shelf[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetStockTakingAssignedShelfList?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingAssignedShelfList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingAssignedShelfList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf[]>;
        }));
    }

    protected processGetStockTakingAssignedShelfList(response: HttpResponseBase): Observable<Shelf[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Shelf.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param productCode (optional) 
     * @param barcode (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getBarcodeListForBarcodeReport(companyId: number | undefined, productCode: string | null | undefined, barcode: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<BarcodeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetBarcodeListForBarcodeReport?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (productCode !== undefined && productCode !== null)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        if (barcode !== undefined && barcode !== null)
            url_ += "Barcode=" + encodeURIComponent("" + barcode) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBarcodeListForBarcodeReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBarcodeListForBarcodeReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarcodeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarcodeDtoPagedResultDto>;
        }));
    }

    protected processGetBarcodeListForBarcodeReport(response: HttpResponseBase): Observable<BarcodeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarcodeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BarcodeDtoPagedResultDto>(null as any);
    }

    /**
     * @param stockTakingHeaderId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param shelfTypeId (optional) 
     * @param fullAddress (optional) 
     * @param region (optional) 
     * @param street (optional) 
     * @param apartment (optional) 
     * @param apartmentNo (optional) 
     * @param floor (optional) 
     * @param floorNo (optional) 
     * @param sequence (optional) 
     * @param sequenceNo (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStockTakingAssignedShelfListPaged(stockTakingHeaderId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, shelfTypeId: number | undefined, fullAddress: string | null | undefined, region: string | null | undefined, street: string | null | undefined, apartment: string | null | undefined, apartmentNo: string | null | undefined, floor: string | null | undefined, floorNo: string | null | undefined, sequence: string | null | undefined, sequenceNo: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShelfPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetStockTakingAssignedShelfListPaged?";
        if (stockTakingHeaderId === null)
            throw new Error("The parameter 'stockTakingHeaderId' cannot be null.");
        else if (stockTakingHeaderId !== undefined)
            url_ += "StockTakingHeaderId=" + encodeURIComponent("" + stockTakingHeaderId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfTypeId === null)
            throw new Error("The parameter 'shelfTypeId' cannot be null.");
        else if (shelfTypeId !== undefined)
            url_ += "ShelfTypeId=" + encodeURIComponent("" + shelfTypeId) + "&";
        if (fullAddress !== undefined && fullAddress !== null)
            url_ += "FullAddress=" + encodeURIComponent("" + fullAddress) + "&";
        if (region !== undefined && region !== null)
            url_ += "Region=" + encodeURIComponent("" + region) + "&";
        if (street !== undefined && street !== null)
            url_ += "Street=" + encodeURIComponent("" + street) + "&";
        if (apartment !== undefined && apartment !== null)
            url_ += "Apartment=" + encodeURIComponent("" + apartment) + "&";
        if (apartmentNo !== undefined && apartmentNo !== null)
            url_ += "ApartmentNo=" + encodeURIComponent("" + apartmentNo) + "&";
        if (floor !== undefined && floor !== null)
            url_ += "Floor=" + encodeURIComponent("" + floor) + "&";
        if (floorNo !== undefined && floorNo !== null)
            url_ += "FloorNo=" + encodeURIComponent("" + floorNo) + "&";
        if (sequence !== undefined && sequence !== null)
            url_ += "Sequence=" + encodeURIComponent("" + sequence) + "&";
        if (sequenceNo !== undefined && sequenceNo !== null)
            url_ += "SequenceNo=" + encodeURIComponent("" + sequenceNo) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingAssignedShelfListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingAssignedShelfListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShelfPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShelfPagedResultDto>;
        }));
    }

    protected processGetStockTakingAssignedShelfListPaged(response: HttpResponseBase): Observable<ShelfPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShelfPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShelfPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getShelfById(id: number | undefined): Observable<Shelf> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetShelfById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf>;
        }));
    }

    protected processGetShelfById(response: HttpResponseBase): Observable<Shelf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Shelf.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf>(null as any);
    }

    /**
     * @return Success
     */
    getShelfTypeList(): Observable<ShelfType[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetShelfTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShelfType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShelfType[]>;
        }));
    }

    protected processGetShelfTypeList(response: HttpResponseBase): Observable<ShelfType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShelfType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShelfType[]>(null as any);
    }

    /**
     * @param shelfId (optional) 
     * @return Success
     */
    deleteShelf(shelfId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/DeleteShelf?";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteShelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteShelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteShelf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param productShelfId (optional) 
     * @return Success
     */
    getProductSpecialShelfById(productShelfId: number | undefined): Observable<ProductSpecialShelfDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductSpecialShelfById?";
        if (productShelfId === null)
            throw new Error("The parameter 'productShelfId' cannot be null.");
        else if (productShelfId !== undefined)
            url_ += "ProductShelfId=" + encodeURIComponent("" + productShelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductSpecialShelfById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductSpecialShelfById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSpecialShelfDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSpecialShelfDto>;
        }));
    }

    protected processGetProductSpecialShelfById(response: HttpResponseBase): Observable<ProductSpecialShelfDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductSpecialShelfDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSpecialShelfDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param productIdList (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param shelfId (optional) 
     * @param companyId (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @param startIndex (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getProductShelfQuantityListInActive_Dapper(productId: number | undefined, productIdList: number[] | null | undefined, warehouseId: number | undefined, storageId: number | undefined, shelfId: number | undefined, companyId: number | undefined, dateStart: Date | null | undefined, dateEnd: Date | null | undefined, startIndex: number | undefined, limit: number | undefined): Observable<ProductQuantityShelfDapper[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductShelfQuantityListInActive_Dapper?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (productIdList !== undefined && productIdList !== null)
            productIdList && productIdList.forEach(item => { url_ += "productIdList=" + encodeURIComponent("" + item) + "&"; });
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (dateStart !== undefined && dateStart !== null)
            url_ += "dateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toISOString() : "") + "&";
        if (dateEnd !== undefined && dateEnd !== null)
            url_ += "dateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toISOString() : "") + "&";
        if (startIndex === null)
            throw new Error("The parameter 'startIndex' cannot be null.");
        else if (startIndex !== undefined)
            url_ += "startIndex=" + encodeURIComponent("" + startIndex) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductShelfQuantityListInActive_Dapper(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductShelfQuantityListInActive_Dapper(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductQuantityShelfDapper[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductQuantityShelfDapper[]>;
        }));
    }

    protected processGetProductShelfQuantityListInActive_Dapper(response: HttpResponseBase): Observable<ProductQuantityShelfDapper[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductQuantityShelfDapper.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductQuantityShelfDapper[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param shelfTypeId (optional) 
     * @return Success
     */
    getProductSpecialShelfList(productId: number | undefined, shelfTypeId: number | undefined): Observable<ProductSpecialShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductSpecialShelfList?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (shelfTypeId === null)
            throw new Error("The parameter 'shelfTypeId' cannot be null.");
        else if (shelfTypeId !== undefined)
            url_ += "shelfTypeId=" + encodeURIComponent("" + shelfTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductSpecialShelfList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductSpecialShelfList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSpecialShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSpecialShelfDto[]>;
        }));
    }

    protected processGetProductSpecialShelfList(response: HttpResponseBase): Observable<ProductSpecialShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductSpecialShelfDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSpecialShelfDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getProductVarietyShelf(productId: number | undefined, warehouseId: number | undefined): Observable<ProductSpecialShelfDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductVarietyShelf?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductVarietyShelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductVarietyShelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSpecialShelfDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSpecialShelfDto>;
        }));
    }

    protected processGetProductVarietyShelf(response: HttpResponseBase): Observable<ProductSpecialShelfDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductSpecialShelfDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSpecialShelfDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @return Success
     */
    getProductVarietyShelfPerWarehouse(productId: number | undefined, companyId: number | undefined): Observable<ProductShelfVarietyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductVarietyShelfPerWarehouse?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductVarietyShelfPerWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductVarietyShelfPerWarehouse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductShelfVarietyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductShelfVarietyDto[]>;
        }));
    }

    protected processGetProductVarietyShelfPerWarehouse(response: HttpResponseBase): Observable<ProductShelfVarietyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductShelfVarietyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductShelfVarietyDto[]>(null as any);
    }

    /**
     * @param shelfId (optional) 
     * @return Success
     */
    getProductVarietyShelfListByShelfId(shelfId: number | undefined): Observable<ProductSpecialShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductVarietyShelfListByShelfId?";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductVarietyShelfListByShelfId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductVarietyShelfListByShelfId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSpecialShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSpecialShelfDto[]>;
        }));
    }

    protected processGetProductVarietyShelfListByShelfId(response: HttpResponseBase): Observable<ProductSpecialShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductSpecialShelfDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSpecialShelfDto[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param companyId (optional) 
     * @param storageId (optional) 
     * @param productId (optional) 
     * @param shelfId (optional) 
     * @param status (optional) 
     * @param listOnlyReplenishables (optional) 
     * @param productIdList (optional) 
     * @param nonReplenishRegionsList (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportProductShelfListPaged(warehouseId: number | undefined, companyId: number | undefined, storageId: number | undefined, productId: number | undefined, shelfId: number | undefined, status: number | undefined, listOnlyReplenishables: boolean | undefined, productIdList: number[] | null | undefined, nonReplenishRegionsList: string[] | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductSpecialShelfDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportProductShelfListPaged?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "ShelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (listOnlyReplenishables === null)
            throw new Error("The parameter 'listOnlyReplenishables' cannot be null.");
        else if (listOnlyReplenishables !== undefined)
            url_ += "ListOnlyReplenishables=" + encodeURIComponent("" + listOnlyReplenishables) + "&";
        if (productIdList !== undefined && productIdList !== null)
            productIdList && productIdList.forEach(item => { url_ += "ProductIdList=" + encodeURIComponent("" + item) + "&"; });
        if (nonReplenishRegionsList !== undefined && nonReplenishRegionsList !== null)
            nonReplenishRegionsList && nonReplenishRegionsList.forEach(item => { url_ += "NonReplenishRegionsList=" + encodeURIComponent("" + item) + "&"; });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportProductShelfListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportProductShelfListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSpecialShelfDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSpecialShelfDtoPagedResultDto>;
        }));
    }

    protected processGetReportProductShelfListPaged(response: HttpResponseBase): Observable<ProductSpecialShelfDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductSpecialShelfDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSpecialShelfDtoPagedResultDto>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param companyId (optional) 
     * @param storageId (optional) 
     * @param productId (optional) 
     * @param shelfId (optional) 
     * @param status (optional) 
     * @param listOnlyReplenishables (optional) 
     * @param productIdList (optional) 
     * @param nonReplenishRegionsList (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportProductShelfListForWorkActivityPaged(warehouseId: number | undefined, companyId: number | undefined, storageId: number | undefined, productId: number | undefined, shelfId: number | undefined, status: number | undefined, listOnlyReplenishables: boolean | undefined, productIdList: number[] | null | undefined, nonReplenishRegionsList: string[] | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductSpecialShelfDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportProductShelfListForWorkActivityPaged?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "ShelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (listOnlyReplenishables === null)
            throw new Error("The parameter 'listOnlyReplenishables' cannot be null.");
        else if (listOnlyReplenishables !== undefined)
            url_ += "ListOnlyReplenishables=" + encodeURIComponent("" + listOnlyReplenishables) + "&";
        if (productIdList !== undefined && productIdList !== null)
            productIdList && productIdList.forEach(item => { url_ += "ProductIdList=" + encodeURIComponent("" + item) + "&"; });
        if (nonReplenishRegionsList !== undefined && nonReplenishRegionsList !== null)
            nonReplenishRegionsList && nonReplenishRegionsList.forEach(item => { url_ += "NonReplenishRegionsList=" + encodeURIComponent("" + item) + "&"; });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportProductShelfListForWorkActivityPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportProductShelfListForWorkActivityPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSpecialShelfDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSpecialShelfDtoPagedResultDto>;
        }));
    }

    protected processGetReportProductShelfListForWorkActivityPaged(response: HttpResponseBase): Observable<ProductSpecialShelfDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductSpecialShelfDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSpecialShelfDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getShelfRegionListOfProductShelfForNonReplenishSelection(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetShelfRegionListOfProductShelfForNonReplenishSelection";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfRegionListOfProductShelfForNonReplenishSelection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfRegionListOfProductShelfForNonReplenishSelection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetShelfRegionListOfProductShelfForNonReplenishSelection(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param status (optional) 
     * @param listOnlyReplenishables (optional) 
     * @return Success
     */
    getReportProductShelfListForPda(companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, status: number | undefined, listOnlyReplenishables: boolean | undefined): Observable<ProductSpecialShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportProductShelfListForPda?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (listOnlyReplenishables === null)
            throw new Error("The parameter 'listOnlyReplenishables' cannot be null.");
        else if (listOnlyReplenishables !== undefined)
            url_ += "listOnlyReplenishables=" + encodeURIComponent("" + listOnlyReplenishables) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportProductShelfListForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportProductShelfListForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSpecialShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSpecialShelfDto[]>;
        }));
    }

    protected processGetReportProductShelfListForPda(response: HttpResponseBase): Observable<ProductSpecialShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductSpecialShelfDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSpecialShelfDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param status (optional) 
     * @param listOnlyReplenishables (optional) 
     * @return Success
     */
    getReportProductShelfListForWorkActivityForPda(companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, status: number | undefined, listOnlyReplenishables: boolean | undefined): Observable<ProductSpecialShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportProductShelfListForWorkActivityForPda?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (listOnlyReplenishables === null)
            throw new Error("The parameter 'listOnlyReplenishables' cannot be null.");
        else if (listOnlyReplenishables !== undefined)
            url_ += "listOnlyReplenishables=" + encodeURIComponent("" + listOnlyReplenishables) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportProductShelfListForWorkActivityForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportProductShelfListForWorkActivityForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSpecialShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSpecialShelfDto[]>;
        }));
    }

    protected processGetReportProductShelfListForWorkActivityForPda(response: HttpResponseBase): Observable<ProductSpecialShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductSpecialShelfDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSpecialShelfDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProductShelfBatch(body: BatchProductShelfInsertDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateProductShelfBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProductShelfBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductShelfBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateProductShelfBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProductShelf(body: ProductShelfInsertDto | undefined): Observable<ProductSpecialShelfDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateProductShelf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProductShelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductShelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSpecialShelfDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSpecialShelfDto>;
        }));
    }

    protected processCreateProductShelf(response: HttpResponseBase): Observable<ProductSpecialShelfDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductSpecialShelfDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSpecialShelfDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProductShelf(body: ProductShelfUpdateDto | undefined): Observable<ProductSpecialShelfDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/UpdateProductShelf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProductShelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductShelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSpecialShelfDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSpecialShelfDto>;
        }));
    }

    protected processUpdateProductShelf(response: HttpResponseBase): Observable<ProductSpecialShelfDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductSpecialShelfDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSpecialShelfDto>(null as any);
    }

    /**
     * @param typeId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getErpProcessHeaderFailListPaged(typeId: number | undefined, startDate: Date | undefined, endDate: Date | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ErpProcessHeaderFailDapperPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetErpProcessHeaderFailListPaged?";
        if (typeId === null)
            throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErpProcessHeaderFailListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErpProcessHeaderFailListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpProcessHeaderFailDapperPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpProcessHeaderFailDapperPagedResultDto>;
        }));
    }

    protected processGetErpProcessHeaderFailListPaged(response: HttpResponseBase): Observable<ErpProcessHeaderFailDapperPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErpProcessHeaderFailDapperPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpProcessHeaderFailDapperPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteProductShelf(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/DeleteProductShelf?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProductShelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProductShelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProductShelf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getReplenishmentStockMovementShelfListByWorkActivityId(workActivityId: number | undefined): Observable<StockMovementShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReplenishmentStockMovementShelfListByWorkActivityId?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReplenishmentStockMovementShelfListByWorkActivityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReplenishmentStockMovementShelfListByWorkActivityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockMovementShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockMovementShelfDto[]>;
        }));
    }

    protected processGetReplenishmentStockMovementShelfListByWorkActivityId(response: HttpResponseBase): Observable<StockMovementShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockMovementShelfDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockMovementShelfDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getVarietyShelfWithViewFromDB(): Observable<ProductShelfFromViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetVarietyShelfWithViewFromDB";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVarietyShelfWithViewFromDB(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVarietyShelfWithViewFromDB(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductShelfFromViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductShelfFromViewDto[]>;
        }));
    }

    protected processGetVarietyShelfWithViewFromDB(response: HttpResponseBase): Observable<ProductShelfFromViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductShelfFromViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductShelfFromViewDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @return Success
     */
    getProductShelfListBelowSafetyPercentIkmalForPda(companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined): Observable<ProductSpecialShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductShelfListBelowSafetyPercentIkmalForPda?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductShelfListBelowSafetyPercentIkmalForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductShelfListBelowSafetyPercentIkmalForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSpecialShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSpecialShelfDto[]>;
        }));
    }

    protected processGetProductShelfListBelowSafetyPercentIkmalForPda(response: HttpResponseBase): Observable<ProductSpecialShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductSpecialShelfDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSpecialShelfDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @return Success
     */
    getProductShelfQuantityListForProductShelfIkmalForPda(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined): Observable<StockMovementShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductShelfQuantityListForProductShelfIkmalForPda?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductShelfQuantityListForProductShelfIkmalForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductShelfQuantityListForProductShelfIkmalForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockMovementShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockMovementShelfDto[]>;
        }));
    }

    protected processGetProductShelfQuantityListForProductShelfIkmalForPda(response: HttpResponseBase): Observable<StockMovementShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockMovementShelfDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockMovementShelfDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAvailableIkmalShelvesListForPda(): Observable<ShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetAvailableIkmalShelvesListForPda";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableIkmalShelvesListForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableIkmalShelvesListForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShelfDto[]>;
        }));
    }

    protected processGetAvailableIkmalShelvesListForPda(response: HttpResponseBase): Observable<ShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShelfDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShelfDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param companyId (optional) 
     * @return Success
     */
    getProductStorageQuantityList(productId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, companyId: number | undefined): Observable<ProductQuantityStorageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductStorageQuantityList?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductStorageQuantityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductStorageQuantityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductQuantityStorageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductQuantityStorageDto[]>;
        }));
    }

    protected processGetProductStorageQuantityList(response: HttpResponseBase): Observable<ProductQuantityStorageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductQuantityStorageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductQuantityStorageDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param shelfId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @return Success
     */
    getProductShelfQuantityList(productId: number | undefined, shelfId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined): Observable<ProductQuantityShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductShelfQuantityList?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductShelfQuantityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductShelfQuantityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductQuantityShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductQuantityShelfDto[]>;
        }));
    }

    protected processGetProductShelfQuantityList(response: HttpResponseBase): Observable<ProductQuantityShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductQuantityShelfDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductQuantityShelfDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param shelfId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @return Success
     */
    getProductShelfQuantityListForPda(productId: number | undefined, shelfId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined): Observable<ProductQuantityShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductShelfQuantityListForPda?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductShelfQuantityListForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductShelfQuantityListForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductQuantityShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductQuantityShelfDto[]>;
        }));
    }

    protected processGetProductShelfQuantityListForPda(response: HttpResponseBase): Observable<ProductQuantityShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductQuantityShelfDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductQuantityShelfDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getProductWarehouseQuantityList(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined): Observable<ProductQuantityWarehouseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductWarehouseQuantityList?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductWarehouseQuantityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductWarehouseQuantityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductQuantityWarehouseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductQuantityWarehouseDto[]>;
        }));
    }

    protected processGetProductWarehouseQuantityList(response: HttpResponseBase): Observable<ProductQuantityWarehouseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductQuantityWarehouseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductQuantityWarehouseDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getShelfStorageQuantityDifference(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductShelfStorageQuantityDifferenceDapperPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetShelfStorageQuantityDifference?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfStorageQuantityDifference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfStorageQuantityDifference(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductShelfStorageQuantityDifferenceDapperPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductShelfStorageQuantityDifferenceDapperPagedResultDto>;
        }));
    }

    protected processGetShelfStorageQuantityDifference(response: HttpResponseBase): Observable<ProductShelfStorageQuantityDifferenceDapperPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductShelfStorageQuantityDifferenceDapperPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductShelfStorageQuantityDifferenceDapperPagedResultDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param shelfId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param stHeaderId (optional) 
     * @return Success
     */
    getProductQuantityListWithShelfForCounting(productId: number | undefined, shelfId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, stHeaderId: number | undefined): Observable<ProductShelfQuantityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductQuantityListWithShelfForCounting?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductQuantityListWithShelfForCounting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductQuantityListWithShelfForCounting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductShelfQuantityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductShelfQuantityDto[]>;
        }));
    }

    protected processGetProductQuantityListWithShelfForCounting(response: HttpResponseBase): Observable<ProductShelfQuantityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductShelfQuantityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductShelfQuantityDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportProductStorageQuantityListPaged(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductQuantityStoragePagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportProductStorageQuantityListPaged?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportProductStorageQuantityListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportProductStorageQuantityListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductQuantityStoragePagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductQuantityStoragePagedResultDto>;
        }));
    }

    protected processGetReportProductStorageQuantityListPaged(response: HttpResponseBase): Observable<ProductQuantityStoragePagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductQuantityStoragePagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductQuantityStoragePagedResultDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportProductStorageQuantityForZeroListPaged(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductQuantityStoragePagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportProductStorageQuantityForZeroListPaged?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportProductStorageQuantityForZeroListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportProductStorageQuantityForZeroListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductQuantityStoragePagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductQuantityStoragePagedResultDto>;
        }));
    }

    protected processGetReportProductStorageQuantityForZeroListPaged(response: HttpResponseBase): Observable<ProductQuantityStoragePagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductQuantityStoragePagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductQuantityStoragePagedResultDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param productIdList (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportProductWarehouseQuantityListPaged(productId: number | undefined, productIdList: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductQuantityWarehousePagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportProductWarehouseQuantityListPaged?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (productIdList === null)
            throw new Error("The parameter 'productIdList' cannot be null.");
        else if (productIdList !== undefined)
            url_ += "ProductIdList=" + encodeURIComponent("" + productIdList) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportProductWarehouseQuantityListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportProductWarehouseQuantityListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductQuantityWarehousePagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductQuantityWarehousePagedResultDto>;
        }));
    }

    protected processGetReportProductWarehouseQuantityListPaged(response: HttpResponseBase): Observable<ProductQuantityWarehousePagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductQuantityWarehousePagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductQuantityWarehousePagedResultDto>(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getContainerFromCode(code: string | null | undefined): Observable<ContainerDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetContainerFromCode?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContainerFromCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContainerFromCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContainerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContainerDto>;
        }));
    }

    protected processGetContainerFromCode(response: HttpResponseBase): Observable<ContainerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContainerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContainerDto>(null as any);
    }

    /**
     * @return Success
     */
    getContainerList(): Observable<ContainerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetContainerList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContainerList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContainerList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContainerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContainerDto[]>;
        }));
    }

    protected processGetContainerList(response: HttpResponseBase): Observable<ContainerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ContainerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContainerDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param productId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getContainerListPaged(companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, productId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ContainerDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetContainerListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContainerListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContainerListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContainerDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContainerDtoPagedResultDto>;
        }));
    }

    protected processGetContainerListPaged(response: HttpResponseBase): Observable<ContainerDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContainerDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContainerDtoPagedResultDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param stockMovementTypeId (optional) 
     * @return Success
     */
    getReportStockMovementList(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, stockMovementTypeId: number | undefined): Observable<StockMovementDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportStockMovementList?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (stockMovementTypeId === null)
            throw new Error("The parameter 'stockMovementTypeId' cannot be null.");
        else if (stockMovementTypeId !== undefined)
            url_ += "StockMovementTypeId=" + encodeURIComponent("" + stockMovementTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportStockMovementList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportStockMovementList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockMovementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockMovementDto[]>;
        }));
    }

    protected processGetReportStockMovementList(response: HttpResponseBase): Observable<StockMovementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockMovementDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockMovementDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param stockMovementTypeId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportStockMovementListPaged(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, stockMovementTypeId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StockMovementDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetReportStockMovementListPaged?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (stockMovementTypeId === null)
            throw new Error("The parameter 'stockMovementTypeId' cannot be null.");
        else if (stockMovementTypeId !== undefined)
            url_ += "StockMovementTypeId=" + encodeURIComponent("" + stockMovementTypeId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportStockMovementListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportStockMovementListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockMovementDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockMovementDtoPagedResultDto>;
        }));
    }

    protected processGetReportStockMovementListPaged(response: HttpResponseBase): Observable<StockMovementDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockMovementDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockMovementDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ProductionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProductionHeader(id: number | undefined): Observable<ProductionHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/Production/GetProductionHeader?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductionHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductionHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionHeaderDto>;
        }));
    }

    protected processGetProductionHeader(response: HttpResponseBase): Observable<ProductionHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductionHeaderDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param code (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getProductionListPaged(companyId: number | undefined, warehouseId: number | undefined, code: string | null | undefined, dateStart: Date | null | undefined, dateEnd: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductionHeaderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Production/GetProductionListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (dateStart !== undefined && dateStart !== null)
            url_ += "DateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toISOString() : "") + "&";
        if (dateEnd !== undefined && dateEnd !== null)
            url_ += "DateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductionListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductionListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionHeaderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionHeaderDtoPagedResultDto>;
        }));
    }

    protected processGetProductionListPaged(response: HttpResponseBase): Observable<ProductionHeaderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionHeaderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductionHeaderDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    createProductionHeaderAndDetail(companyId: number | undefined, warehouseId: number | undefined): Observable<ProductionHeader> {
        let url_ = this.baseUrl + "/api/services/app/Production/CreateProductionHeaderAndDetail?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProductionHeaderAndDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductionHeaderAndDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionHeader>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionHeader>;
        }));
    }

    protected processCreateProductionHeaderAndDetail(response: HttpResponseBase): Observable<ProductionHeader> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductionHeader>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProductionDetail(id: number | undefined): Observable<ProductionDetail> {
        let url_ = this.baseUrl + "/api/services/app/Production/GetProductionDetail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductionDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductionDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionDetail>;
        }));
    }

    protected processGetProductionDetail(response: HttpResponseBase): Observable<ProductionDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductionDetail>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @return Success
     */
    getProductionDetailList(headerId: number | undefined): Observable<ProductionDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Production/GetProductionDetailList?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductionDetailList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductionDetailList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionDetailDto[]>;
        }));
    }

    protected processGetProductionDetailList(response: HttpResponseBase): Observable<ProductionDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductionDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductionDetailDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProductionDetails(body: BatchProductionInsertDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Production/CreateProductionDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProductionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateProductionDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteProductionHeader(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Production/DeleteProductionHeader?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProductionHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProductionHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProductionHeader(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param productionDetailId (optional) 
     * @return Success
     */
    deleteProductionDetail(productionDetailId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Production/DeleteProductionDetail?";
        if (productionDetailId === null)
            throw new Error("The parameter 'productionDetailId' cannot be null.");
        else if (productionDetailId !== undefined)
            url_ += "productionDetailId=" + encodeURIComponent("" + productionDetailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProductionDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProductionDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProductionDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @param productId (optional) 
     * @param quantity (optional) 
     * @param type (optional) 
     * @return Success
     */
    createProductionDetail(headerId: number | undefined, productId: number | undefined, quantity: number | undefined, type: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Production/CreateProductionDetail?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProductionDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductionDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateProductionDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @return Success
     */
    finishProduction(headerId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Production/FinishProduction?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishProduction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishProduction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishProduction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param productionHeaderId (optional) 
     * @return Success
     */
    createWaybillHeaderAndWorkActivityForProduction(productionHeaderId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Production/CreateWaybillHeaderAndWorkActivityForProduction?";
        if (productionHeaderId === null)
            throw new Error("The parameter 'productionHeaderId' cannot be null.");
        else if (productionHeaderId !== undefined)
            url_ += "productionHeaderId=" + encodeURIComponent("" + productionHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWaybillHeaderAndWorkActivityForProduction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWaybillHeaderAndWorkActivityForProduction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateWaybillHeaderAndWorkActivityForProduction(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param recipeHeaderId (optional) 
     * @param quantity (optional) 
     * @return Success
     */
    createProductionWithRecipeHeaderAndDetail(companyId: number | undefined, warehouseId: number | undefined, recipeHeaderId: number | undefined, quantity: number | undefined): Observable<ProductionHeader> {
        let url_ = this.baseUrl + "/api/services/app/Production/CreateProductionWithRecipeHeaderAndDetail?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (recipeHeaderId === null)
            throw new Error("The parameter 'recipeHeaderId' cannot be null.");
        else if (recipeHeaderId !== undefined)
            url_ += "recipeHeaderId=" + encodeURIComponent("" + recipeHeaderId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProductionWithRecipeHeaderAndDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductionWithRecipeHeaderAndDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionHeader>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionHeader>;
        }));
    }

    protected processCreateProductionWithRecipeHeaderAndDetail(response: HttpResponseBase): Observable<ProductionHeader> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductionHeader>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param code (optional) 
     * @param definition (optional) 
     * @param explanation (optional) 
     * @return Success
     */
    createProductionRecipeHeader(companyId: number | undefined, warehouseId: number | undefined, code: string | null | undefined, definition: string | null | undefined, explanation: string | null | undefined): Observable<ProductionRecipeHeader> {
        let url_ = this.baseUrl + "/api/services/app/Production/CreateProductionRecipeHeader?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (definition !== undefined && definition !== null)
            url_ += "definition=" + encodeURIComponent("" + definition) + "&";
        if (explanation !== undefined && explanation !== null)
            url_ += "explanation=" + encodeURIComponent("" + explanation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProductionRecipeHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductionRecipeHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionRecipeHeader>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionRecipeHeader>;
        }));
    }

    protected processCreateProductionRecipeHeader(response: HttpResponseBase): Observable<ProductionRecipeHeader> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionRecipeHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductionRecipeHeader>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProductionRecipeHeader(body: ProductionRecipeHeader | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Production/UpdateProductionRecipeHeader";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProductionRecipeHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductionRecipeHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProductionRecipeHeader(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteProductionRecipeHeader(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Production/DeleteProductionRecipeHeader?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProductionRecipeHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProductionRecipeHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProductionRecipeHeader(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param code (optional) 
     * @param definition (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getProductionRecipeListPaged(companyId: number | undefined, code: string | null | undefined, definition: string | null | undefined, dateStart: Date | null | undefined, dateEnd: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductionRecipeHeaderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Production/GetProductionRecipeListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (definition !== undefined && definition !== null)
            url_ += "Definition=" + encodeURIComponent("" + definition) + "&";
        if (dateStart !== undefined && dateStart !== null)
            url_ += "DateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toISOString() : "") + "&";
        if (dateEnd !== undefined && dateEnd !== null)
            url_ += "DateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductionRecipeListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductionRecipeListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionRecipeHeaderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionRecipeHeaderDtoPagedResultDto>;
        }));
    }

    protected processGetProductionRecipeListPaged(response: HttpResponseBase): Observable<ProductionRecipeHeaderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionRecipeHeaderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductionRecipeHeaderDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProductionRecipeHeader(id: number | undefined): Observable<ProductionRecipeHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/Production/GetProductionRecipeHeader?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductionRecipeHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductionRecipeHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionRecipeHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionRecipeHeaderDto>;
        }));
    }

    protected processGetProductionRecipeHeader(response: HttpResponseBase): Observable<ProductionRecipeHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionRecipeHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductionRecipeHeaderDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param code (optional) 
     * @param definition (optional) 
     * @return Success
     */
    getProductionRecipeHeaderList(companyId: number | undefined, code: string | null | undefined, definition: string | null | undefined): Observable<ProductionRecipeHeaderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Production/GetProductionRecipeHeaderList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (definition !== undefined && definition !== null)
            url_ += "definition=" + encodeURIComponent("" + definition) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductionRecipeHeaderList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductionRecipeHeaderList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionRecipeHeaderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionRecipeHeaderDto[]>;
        }));
    }

    protected processGetProductionRecipeHeaderList(response: HttpResponseBase): Observable<ProductionRecipeHeaderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductionRecipeHeaderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductionRecipeHeaderDto[]>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @return Success
     */
    getProductionRecipeDetailList(headerId: number | undefined): Observable<ProductionRecipeDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Production/GetProductionRecipeDetailList?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductionRecipeDetailList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductionRecipeDetailList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionRecipeDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionRecipeDetailDto[]>;
        }));
    }

    protected processGetProductionRecipeDetailList(response: HttpResponseBase): Observable<ProductionRecipeDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductionRecipeDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductionRecipeDetailDto[]>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @param productId (optional) 
     * @param quantity (optional) 
     * @param type (optional) 
     * @return Success
     */
    createProductionRecipeDetail(headerId: number | undefined, productId: number | undefined, quantity: number | undefined, type: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Production/CreateProductionRecipeDetail?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProductionRecipeDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductionRecipeDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateProductionRecipeDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param productionRecipeDetailId (optional) 
     * @return Success
     */
    deleteProductionRecipeDetail(productionRecipeDetailId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Production/DeleteProductionRecipeDetail?";
        if (productionRecipeDetailId === null)
            throw new Error("The parameter 'productionRecipeDetailId' cannot be null.");
        else if (productionRecipeDetailId !== undefined)
            url_ += "productionRecipeDetailId=" + encodeURIComponent("" + productionRecipeDetailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProductionRecipeDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProductionRecipeDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProductionRecipeDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProductionRecipeDetails(body: BatchProductionRecipeInsertDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Production/CreateProductionRecipeDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProductionRecipeDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductionRecipeDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateProductionRecipeDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | null | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission !== undefined && permission !== null)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleListDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionDtoListResultDto>(null as any);
    }

    /**
     * @return Success
     */
    giveAllPermissionsForInitial(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/GiveAllPermissionsForInitial";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGiveAllPermissionsForInitial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGiveAllPermissionsForInitial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGiveAllPermissionsForInitial(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getPermissionsForPermissionTreeUser(userId: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetPermissionsForPermissionTreeUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermissionsForPermissionTreeUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissionsForPermissionTreeUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetPermissionsForPermissionTreeUser(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param roleId (optional) 
     * @return Success
     */
    getPermissionsForPermissionTreeRole(roleId: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetPermissionsForPermissionTreeRole?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermissionsForPermissionTreeRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissionsForPermissionTreeRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetPermissionsForPermissionTreeRole(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param roleNames (optional) 
     * @return Success
     */
    getPermissionsForRoles(roleNames: string[] | null | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetPermissionsForRoles?";
        if (roleNames !== undefined && roleNames !== null)
            roleNames && roleNames.forEach(item => { url_ += "RoleNames=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermissionsForRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissionsForRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetPermissionsForRoles(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isDeleted (optional) 
     * @return Success
     */
    updateRoleIsDeleted(id: number | undefined, isDeleted: boolean | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/UpdateRoleIsDeleted?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRoleIsDeleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRoleIsDeleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdateRoleIsDeleted(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(null as any);
    }

    /**
     * @param role (optional) 
     * @return Success
     */
    getCurrentLoginHasRole(role: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginHasRole?";
        if (role !== undefined && role !== null)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginHasRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginHasRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetCurrentLoginHasRole(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getCurrentLoginHasPermission(permission: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginHasPermission?";
        if (permission !== undefined && permission !== null)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginHasPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginHasPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetCurrentLoginHasPermission(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getCurrentLoginHasPermissionsForPDAMenu(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginHasPermissionsForPDAMenu";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginHasPermissionsForPDAMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginHasPermissionsForPDAMenu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetCurrentLoginHasPermissionsForPDAMenu(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }
}

@Injectable()
export class ShippingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param packNo (optional) 
     * @param deci (optional) 
     * @param width (optional) 
     * @param length (optional) 
     * @param height (optional) 
     * @param kg (optional) 
     * @param paymentMethod (optional) 
     * @param body (optional) 
     * @return Success
     */
    entegrate(packNo: number | undefined, deci: number | undefined, width: number | undefined, length: number | undefined, height: number | undefined, kg: number | undefined, paymentMethod: string | null | undefined, body: OrderHeader | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Shipping/Entegrate?";
        if (packNo === null)
            throw new Error("The parameter 'packNo' cannot be null.");
        else if (packNo !== undefined)
            url_ += "packNo=" + encodeURIComponent("" + packNo) + "&";
        if (deci === null)
            throw new Error("The parameter 'deci' cannot be null.");
        else if (deci !== undefined)
            url_ += "deci=" + encodeURIComponent("" + deci) + "&";
        if (width === null)
            throw new Error("The parameter 'width' cannot be null.");
        else if (width !== undefined)
            url_ += "width=" + encodeURIComponent("" + width) + "&";
        if (length === null)
            throw new Error("The parameter 'length' cannot be null.");
        else if (length !== undefined)
            url_ += "length=" + encodeURIComponent("" + length) + "&";
        if (height === null)
            throw new Error("The parameter 'height' cannot be null.");
        else if (height !== undefined)
            url_ += "height=" + encodeURIComponent("" + height) + "&";
        if (kg === null)
            throw new Error("The parameter 'kg' cannot be null.");
        else if (kg !== undefined)
            url_ += "kg=" + encodeURIComponent("" + kg) + "&";
        if (paymentMethod !== undefined && paymentMethod !== null)
            url_ += "paymentMethod=" + encodeURIComponent("" + paymentMethod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntegrate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntegrate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEntegrate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class StepServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param startStepDate (optional) 
     * @return Success
     */
    getGeneralStepsByUserId(startStepDate: Date | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Step/GetGeneralStepsByUserId?";
        if (startStepDate === null)
            throw new Error("The parameter 'startStepDate' cannot be null.");
        else if (startStepDate !== undefined)
            url_ += "StartStepDate=" + encodeURIComponent(startStepDate ? "" + startStepDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralStepsByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralStepsByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetGeneralStepsByUserId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateGeneralStepByUserId(body: CreateStepCountRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Step/UpdateGeneralStepByUserId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGeneralStepByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGeneralStepByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateGeneralStepByUserId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class StockTakingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBatchSupervisorList(body: BatchSupervisorListCreationSTAPDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/CreateBatchSupervisorList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBatchSupervisorList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBatchSupervisorList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateBatchSupervisorList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param shelvesIdList (optional) 
     * @return Success
     */
    getChecklistSelectedShelvesListByShelfIdList(shelvesIdList: number[] | null | undefined): Observable<ShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetChecklistSelectedShelvesListByShelfIdList?";
        if (shelvesIdList !== undefined && shelvesIdList !== null)
            shelvesIdList && shelvesIdList.forEach(item => { url_ += "shelvesIdList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChecklistSelectedShelvesListByShelfIdList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChecklistSelectedShelvesListByShelfIdList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShelfDto[]>;
        }));
    }

    protected processGetChecklistSelectedShelvesListByShelfIdList(response: HttpResponseBase): Observable<ShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShelfDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShelfDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getIncompleteStockTakingHeaderListforPda(companyId: number | undefined, warehouseId: number | undefined): Observable<StockTakingHeaderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetIncompleteStockTakingHeaderListforPda?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncompleteStockTakingHeaderListforPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncompleteStockTakingHeaderListforPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingHeaderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingHeaderDto[]>;
        }));
    }

    protected processGetIncompleteStockTakingHeaderListforPda(response: HttpResponseBase): Observable<StockTakingHeaderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockTakingHeaderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingHeaderDto[]>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param processUserId (optional) 
     * @return Success
     */
    getAllAssignedDetailsToUserForPda(stHeaderId: number | undefined, processUserId: number | undefined): Observable<StockTakingDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetAllAssignedDetailsToUserForPda?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (processUserId === null)
            throw new Error("The parameter 'processUserId' cannot be null.");
        else if (processUserId !== undefined)
            url_ += "ProcessUserId=" + encodeURIComponent("" + processUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssignedDetailsToUserForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssignedDetailsToUserForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingDetailDto[]>;
        }));
    }

    protected processGetAllAssignedDetailsToUserForPda(response: HttpResponseBase): Observable<StockTakingDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockTakingDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingDetailDto[]>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param processUserId (optional) 
     * @return Success
     */
    getAllAssignedShelvesToUserForPda(stHeaderId: number | undefined, processUserId: number | undefined): Observable<StockTakingDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetAllAssignedShelvesToUserForPda?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (processUserId === null)
            throw new Error("The parameter 'processUserId' cannot be null.");
        else if (processUserId !== undefined)
            url_ += "ProcessUserId=" + encodeURIComponent("" + processUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssignedShelvesToUserForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssignedShelvesToUserForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingDetailDto[]>;
        }));
    }

    protected processGetAllAssignedShelvesToUserForPda(response: HttpResponseBase): Observable<StockTakingDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockTakingDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingDetailDto[]>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param processUserId (optional) 
     * @param shelfId (optional) 
     * @return Success
     */
    getShelfIsOnAssignedUserAfterBarcodeScanForStockTakingForPda(stHeaderId: number | undefined, processUserId: number | undefined, shelfId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetShelfIsOnAssignedUserAfterBarcodeScanForStockTakingForPda?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (processUserId === null)
            throw new Error("The parameter 'processUserId' cannot be null.");
        else if (processUserId !== undefined)
            url_ += "ProcessUserId=" + encodeURIComponent("" + processUserId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfIsOnAssignedUserAfterBarcodeScanForStockTakingForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfIsOnAssignedUserAfterBarcodeScanForStockTakingForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetShelfIsOnAssignedUserAfterBarcodeScanForStockTakingForPda(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param processUserId (optional) 
     * @param shelfId (optional) 
     * @return Success
     */
    getShelfIsOnAssignedUserAfterBarcodeScanForStockTakingForPdaNew(stHeaderId: number | undefined, processUserId: number | undefined, shelfId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetShelfIsOnAssignedUserAfterBarcodeScanForStockTakingForPdaNew?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (processUserId === null)
            throw new Error("The parameter 'processUserId' cannot be null.");
        else if (processUserId !== undefined)
            url_ += "ProcessUserId=" + encodeURIComponent("" + processUserId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfIsOnAssignedUserAfterBarcodeScanForStockTakingForPdaNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfIsOnAssignedUserAfterBarcodeScanForStockTakingForPdaNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetShelfIsOnAssignedUserAfterBarcodeScanForStockTakingForPdaNew(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStockTakingWorkActivity(body: WorkActivityDto | undefined): Observable<WorkActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/UpdateStockTakingWorkActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStockTakingWorkActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStockTakingWorkActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto>;
        }));
    }

    protected processUpdateStockTakingWorkActivity(response: HttpResponseBase): Observable<WorkActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    createProductQtyErp2WmsBeforeStockTaking(workActivityId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/CreateProductQtyErp2WmsBeforeStockTaking?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProductQtyErp2WmsBeforeStockTaking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductQtyErp2WmsBeforeStockTaking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateProductQtyErp2WmsBeforeStockTaking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getErpProductQuantityOfStockTaking(workActivityId: number | undefined): Observable<ErpProductQuantityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetErpProductQuantityOfStockTaking?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErpProductQuantityOfStockTaking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErpProductQuantityOfStockTaking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpProductQuantityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpProductQuantityDto[]>;
        }));
    }

    protected processGetErpProductQuantityOfStockTaking(response: HttpResponseBase): Observable<ErpProductQuantityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ErpProductQuantityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErpProductQuantityDto[]>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @return Success
     */
    createStockMovementShelfWithSTReportingStockTakingActionProcessDto(stHeaderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/CreateStockMovementShelfWithSTReportingStockTakingActionProcessDto?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStockMovementShelfWithSTReportingStockTakingActionProcessDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStockMovementShelfWithSTReportingStockTakingActionProcessDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateStockMovementShelfWithSTReportingStockTakingActionProcessDto(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @return Success
     */
    createStockMovementWithSTReportingCompletionProductTotalQuantityDto(stHeaderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/CreateStockMovementWithSTReportingCompletionProductTotalQuantityDto?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStockMovementWithSTReportingCompletionProductTotalQuantityDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStockMovementWithSTReportingCompletionProductTotalQuantityDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateStockMovementWithSTReportingCompletionProductTotalQuantityDto(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getControlListForDashBoard(workActivityId: number | undefined): Observable<ReportingStockTakingDetailPerUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetControlListForDashBoard?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlListForDashBoard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlListForDashBoard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingStockTakingDetailPerUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingStockTakingDetailPerUserDto[]>;
        }));
    }

    protected processGetControlListForDashBoard(response: HttpResponseBase): Observable<ReportingStockTakingDetailPerUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReportingStockTakingDetailPerUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingStockTakingDetailPerUserDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getPdaPartialStockTakingWorkActivityAndSTHeader(companyId: number | undefined, warehouseId: number | undefined): Observable<StockTakingHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetPdaPartialStockTakingWorkActivityAndSTHeader?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdaPartialStockTakingWorkActivityAndSTHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdaPartialStockTakingWorkActivityAndSTHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingHeaderDto>;
        }));
    }

    protected processGetPdaPartialStockTakingWorkActivityAndSTHeader(response: HttpResponseBase): Observable<StockTakingHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockTakingHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingHeaderDto>(null as any);
    }

    /**
     * @param stDetailId (optional) 
     * @return Success
     */
    nextPartialStockTackingDetail(stDetailId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/NextPartialStockTackingDetail?";
        if (stDetailId === null)
            throw new Error("The parameter 'stDetailId' cannot be null.");
        else if (stDetailId !== undefined)
            url_ += "stDetailId=" + encodeURIComponent("" + stDetailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNextPartialStockTackingDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNextPartialStockTackingDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNextPartialStockTackingDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @return Success
     */
    finishPartialStockTacking(stHeaderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/FinishPartialStockTacking?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishPartialStockTacking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishPartialStockTacking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishPartialStockTacking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param assignedUserId (optional) 
     * @param shelfId (optional) 
     * @return Success
     */
    createSTDetailWithUserAndShelvesPartial(stHeaderId: number | undefined, assignedUserId: number | undefined, shelfId: number | undefined): Observable<StockTakingDetail> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/CreateSTDetailWithUserAndShelvesPartial?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (assignedUserId === null)
            throw new Error("The parameter 'assignedUserId' cannot be null.");
        else if (assignedUserId !== undefined)
            url_ += "assignedUserId=" + encodeURIComponent("" + assignedUserId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSTDetailWithUserAndShelvesPartial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSTDetailWithUserAndShelvesPartial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingDetail>;
        }));
    }

    protected processCreateSTDetailWithUserAndShelvesPartial(response: HttpResponseBase): Observable<StockTakingDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockTakingDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingDetail>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param stDetailId (optional) 
     * @param productId (optional) 
     * @param newShelfCurrentQuantity (optional) 
     * @return Success
     */
    createSTActionProcessFromPartialStockTaking(stHeaderId: number | undefined, stDetailId: number | undefined, productId: number | undefined, newShelfCurrentQuantity: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/CreateSTActionProcessFromPartialStockTaking?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (stDetailId === null)
            throw new Error("The parameter 'stDetailId' cannot be null.");
        else if (stDetailId !== undefined)
            url_ += "stDetailId=" + encodeURIComponent("" + stDetailId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (newShelfCurrentQuantity === null)
            throw new Error("The parameter 'newShelfCurrentQuantity' cannot be null.");
        else if (newShelfCurrentQuantity !== undefined)
            url_ += "newShelfCurrentQuantity=" + encodeURIComponent("" + newShelfCurrentQuantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSTActionProcessFromPartialStockTaking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSTActionProcessFromPartialStockTaking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateSTActionProcessFromPartialStockTaking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param shelfId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getProductShelfQuantityPartialStockTacking(productId: number | undefined, shelfId: number | undefined, companyId: number | undefined, warehouseId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetProductShelfQuantityPartialStockTacking?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductShelfQuantityPartialStockTacking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductShelfQuantityPartialStockTacking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetProductShelfQuantityPartialStockTacking(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getSupervisorListForDashBoard(workActivityId: number | undefined): Observable<ReportingStockTakingDetailPerUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetSupervisorListForDashBoard?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupervisorListForDashBoard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupervisorListForDashBoard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingStockTakingDetailPerUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingStockTakingDetailPerUserDto[]>;
        }));
    }

    protected processGetSupervisorListForDashBoard(response: HttpResponseBase): Observable<ReportingStockTakingDetailPerUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReportingStockTakingDetailPerUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingStockTakingDetailPerUserDto[]>(null as any);
    }

    /**
     * @param activityTypeId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    createStockTakingWorkActivityAndSTHeader(activityTypeId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined): Observable<StockTakingHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/CreateStockTakingWorkActivityAndSTHeader?";
        if (activityTypeId === null)
            throw new Error("The parameter 'activityTypeId' cannot be null.");
        else if (activityTypeId !== undefined)
            url_ += "activityTypeId=" + encodeURIComponent("" + activityTypeId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStockTakingWorkActivityAndSTHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStockTakingWorkActivityAndSTHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingHeaderDto>;
        }));
    }

    protected processCreateStockTakingWorkActivityAndSTHeader(response: HttpResponseBase): Observable<StockTakingHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockTakingHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingHeaderDto>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @return Success
     */
    getStockTakingHeader(stHeaderId: number | undefined): Observable<StockTakingHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetStockTakingHeader?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingHeaderDto>;
        }));
    }

    protected processGetStockTakingHeader(response: HttpResponseBase): Observable<StockTakingHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockTakingHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingHeaderDto>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getStockTakingHeaderByWorkActivityId(workActivityId: number | undefined): Observable<StockTakingHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetStockTakingHeaderByWorkActivityId?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingHeaderByWorkActivityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingHeaderByWorkActivityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingHeaderDto>;
        }));
    }

    protected processGetStockTakingHeaderByWorkActivityId(response: HttpResponseBase): Observable<StockTakingHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockTakingHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingHeaderDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getStockTakingHeaderList(companyId: number | undefined, warehouseId: number | undefined): Observable<StockTakingHeaderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetStockTakingHeaderList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingHeaderList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingHeaderList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingHeaderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingHeaderDto[]>;
        }));
    }

    protected processGetStockTakingHeaderList(response: HttpResponseBase): Observable<StockTakingHeaderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockTakingHeaderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingHeaderDto[]>(null as any);
    }

    /**
     * @param assignedShelfId (optional) 
     * @param productId (optional) 
     * @return Success
     */
    getStockTakingActionProcessByShelfProduct(assignedShelfId: number | undefined, productId: number | undefined): Observable<StockTakingActionProcess> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetStockTakingActionProcessByShelfProduct?";
        if (assignedShelfId === null)
            throw new Error("The parameter 'assignedShelfId' cannot be null.");
        else if (assignedShelfId !== undefined)
            url_ += "AssignedShelfId=" + encodeURIComponent("" + assignedShelfId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingActionProcessByShelfProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingActionProcessByShelfProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingActionProcess>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingActionProcess>;
        }));
    }

    protected processGetStockTakingActionProcessByShelfProduct(response: HttpResponseBase): Observable<StockTakingActionProcess> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockTakingActionProcess.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingActionProcess>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param stockTakingType (optional) 
     * @param creationDate (optional) 
     * @param stockTakingStatusId (optional) 
     * @param plannedStartDate (optional) 
     * @param plannedFinishDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStockTakingHeaderListPaged(companyId: number | undefined, warehouseId: number | undefined, stockTakingType: number | undefined, creationDate: Date | null | undefined, stockTakingStatusId: number | undefined, plannedStartDate: Date | null | undefined, plannedFinishDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StockTakingHeaderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetStockTakingHeaderListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (stockTakingType === null)
            throw new Error("The parameter 'stockTakingType' cannot be null.");
        else if (stockTakingType !== undefined)
            url_ += "StockTakingType=" + encodeURIComponent("" + stockTakingType) + "&";
        if (creationDate !== undefined && creationDate !== null)
            url_ += "CreationDate=" + encodeURIComponent(creationDate ? "" + creationDate.toISOString() : "") + "&";
        if (stockTakingStatusId === null)
            throw new Error("The parameter 'stockTakingStatusId' cannot be null.");
        else if (stockTakingStatusId !== undefined)
            url_ += "StockTakingStatusId=" + encodeURIComponent("" + stockTakingStatusId) + "&";
        if (plannedStartDate !== undefined && plannedStartDate !== null)
            url_ += "PlannedStartDate=" + encodeURIComponent(plannedStartDate ? "" + plannedStartDate.toISOString() : "") + "&";
        if (plannedFinishDate !== undefined && plannedFinishDate !== null)
            url_ += "PlannedFinishDate=" + encodeURIComponent(plannedFinishDate ? "" + plannedFinishDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingHeaderListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingHeaderListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingHeaderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingHeaderDtoPagedResultDto>;
        }));
    }

    protected processGetStockTakingHeaderListPaged(response: HttpResponseBase): Observable<StockTakingHeaderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockTakingHeaderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingHeaderDtoPagedResultDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param shelfId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @return Success
     */
    getProductQuantityListWithShelfStockTaking(productId: number | undefined, shelfId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined): Observable<ProductShelfQuantityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetProductQuantityListWithShelfStockTaking?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductQuantityListWithShelfStockTaking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductQuantityListWithShelfStockTaking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductShelfQuantityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductShelfQuantityDto[]>;
        }));
    }

    protected processGetProductQuantityListWithShelfStockTaking(response: HttpResponseBase): Observable<ProductShelfQuantityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductShelfQuantityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductShelfQuantityDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param shelfId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @return Success
     */
    getProductQuantityListWithShelfStockTakingFastCounting(productId: number | undefined, shelfId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined): Observable<ProductShelfQuantityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetProductQuantityListWithShelfStockTakingFastCounting?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductQuantityListWithShelfStockTakingFastCounting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductQuantityListWithShelfStockTakingFastCounting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductShelfQuantityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductShelfQuantityDto[]>;
        }));
    }

    protected processGetProductQuantityListWithShelfStockTakingFastCounting(response: HttpResponseBase): Observable<ProductShelfQuantityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductShelfQuantityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductShelfQuantityDto[]>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param shelfId (optional) 
     * @return Success
     */
    isSuitableShelfForFastStockTaking(stHeaderId: number | undefined, shelfId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/IsSuitableShelfForFastStockTaking?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsSuitableShelfForFastStockTaking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsSuitableShelfForFastStockTaking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsSuitableShelfForFastStockTaking(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    finishFastStocktakingDetail(body: FastCountingProcessDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/FinishFastStocktakingDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishFastStocktakingDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishFastStocktakingDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishFastStocktakingDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @return Success
     */
    deleteStockTakingHeaderAndWorkActivity(stHeaderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/DeleteStockTakingHeaderAndWorkActivity?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteStockTakingHeaderAndWorkActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteStockTakingHeaderAndWorkActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteStockTakingHeaderAndWorkActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stDetailId (optional) 
     * @return Success
     */
    updateReCountSTDetail(stDetailId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/UpdateReCountSTDetail?";
        if (stDetailId === null)
            throw new Error("The parameter 'stDetailId' cannot be null.");
        else if (stDetailId !== undefined)
            url_ += "stDetailId=" + encodeURIComponent("" + stDetailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReCountSTDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReCountSTDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateReCountSTDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param userId (optional) 
     * @param shelfId (optional) 
     * @return Success
     */
    getAllAssignedDetailsToUserForPdaForReCounting(stHeaderId: number | undefined, userId: number | undefined, shelfId: number | undefined): Observable<StockTakingDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetAllAssignedDetailsToUserForPdaForReCounting?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssignedDetailsToUserForPdaForReCounting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssignedDetailsToUserForPdaForReCounting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingDetailDto[]>;
        }));
    }

    protected processGetAllAssignedDetailsToUserForPdaForReCounting(response: HttpResponseBase): Observable<StockTakingDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockTakingDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingDetailDto[]>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param stActionTypeCode (optional) 
     * @param assignedUserId (optional) 
     * @param detailGroup (optional) 
     * @param startShelfId (optional) 
     * @param endShelfId (optional) 
     * @return Success
     */
    createSTDetailWithUserFastStocktakingWithShelf(stHeaderId: number | undefined, stActionTypeCode: string | null | undefined, assignedUserId: number | undefined, detailGroup: string | null | undefined, startShelfId: number | undefined, endShelfId: number | undefined): Observable<StockTakingDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/CreateSTDetailWithUserFastStocktakingWithShelf?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (stActionTypeCode !== undefined && stActionTypeCode !== null)
            url_ += "stActionTypeCode=" + encodeURIComponent("" + stActionTypeCode) + "&";
        if (assignedUserId === null)
            throw new Error("The parameter 'assignedUserId' cannot be null.");
        else if (assignedUserId !== undefined)
            url_ += "assignedUserId=" + encodeURIComponent("" + assignedUserId) + "&";
        if (detailGroup !== undefined && detailGroup !== null)
            url_ += "detailGroup=" + encodeURIComponent("" + detailGroup) + "&";
        if (startShelfId === null)
            throw new Error("The parameter 'startShelfId' cannot be null.");
        else if (startShelfId !== undefined)
            url_ += "startShelfId=" + encodeURIComponent("" + startShelfId) + "&";
        if (endShelfId === null)
            throw new Error("The parameter 'endShelfId' cannot be null.");
        else if (endShelfId !== undefined)
            url_ += "endShelfId=" + encodeURIComponent("" + endShelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSTDetailWithUserFastStocktakingWithShelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSTDetailWithUserFastStocktakingWithShelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingDetailDto[]>;
        }));
    }

    protected processCreateSTDetailWithUserFastStocktakingWithShelf(response: HttpResponseBase): Observable<StockTakingDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockTakingDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingDetailDto[]>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param stActionTypeCode (optional) 
     * @param assignedUserId (optional) 
     * @param detailGroup (optional) 
     * @return Success
     */
    createSTDetailWithUserFastStocktaking(stHeaderId: number | undefined, stActionTypeCode: string | null | undefined, assignedUserId: number | undefined, detailGroup: string | null | undefined): Observable<StockTakingDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/CreateSTDetailWithUserFastStocktaking?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (stActionTypeCode !== undefined && stActionTypeCode !== null)
            url_ += "stActionTypeCode=" + encodeURIComponent("" + stActionTypeCode) + "&";
        if (assignedUserId === null)
            throw new Error("The parameter 'assignedUserId' cannot be null.");
        else if (assignedUserId !== undefined)
            url_ += "assignedUserId=" + encodeURIComponent("" + assignedUserId) + "&";
        if (detailGroup !== undefined && detailGroup !== null)
            url_ += "detailGroup=" + encodeURIComponent("" + detailGroup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSTDetailWithUserFastStocktaking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSTDetailWithUserFastStocktaking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingDetailDto[]>;
        }));
    }

    protected processCreateSTDetailWithUserFastStocktaking(response: HttpResponseBase): Observable<StockTakingDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockTakingDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingDetailDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @return Success
     */
    getReportingNonCountedShelves(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetReportingNonCountedShelves?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportingNonCountedShelves(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportingNonCountedShelves(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetReportingNonCountedShelves(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStockTakingDetailListBySTHeaderIdPaged(headerId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StockTakingDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetStockTakingDetailListBySTHeaderIdPaged?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "HeaderId=" + encodeURIComponent("" + headerId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingDetailListBySTHeaderIdPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingDetailListBySTHeaderIdPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingDetailDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingDetailDtoPagedResultDto>;
        }));
    }

    protected processGetStockTakingDetailListBySTHeaderIdPaged(response: HttpResponseBase): Observable<StockTakingDetailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockTakingDetailDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingDetailDtoPagedResultDto>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @return Success
     */
    getStockTakingDetailListBySTHeaderId(stHeaderId: number | undefined): Observable<StockTakingDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetStockTakingDetailListBySTHeaderId?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingDetailListBySTHeaderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingDetailListBySTHeaderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingDetailDto[]>;
        }));
    }

    protected processGetStockTakingDetailListBySTHeaderId(response: HttpResponseBase): Observable<StockTakingDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockTakingDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingDetailDto[]>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param stActionTypeCode (optional) 
     * @param assignedUserId (optional) 
     * @param detailGroup (optional) 
     * @param startShelfId (optional) 
     * @param endShelfId (optional) 
     * @return Success
     */
    createSTDetailWithUserAndShelves(stHeaderId: number | undefined, stActionTypeCode: string | null | undefined, assignedUserId: number | undefined, detailGroup: string | null | undefined, startShelfId: number | undefined, endShelfId: number | undefined): Observable<StockTakingDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/CreateSTDetailWithUserAndShelves?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (stActionTypeCode !== undefined && stActionTypeCode !== null)
            url_ += "stActionTypeCode=" + encodeURIComponent("" + stActionTypeCode) + "&";
        if (assignedUserId === null)
            throw new Error("The parameter 'assignedUserId' cannot be null.");
        else if (assignedUserId !== undefined)
            url_ += "assignedUserId=" + encodeURIComponent("" + assignedUserId) + "&";
        if (detailGroup !== undefined && detailGroup !== null)
            url_ += "detailGroup=" + encodeURIComponent("" + detailGroup) + "&";
        if (startShelfId === null)
            throw new Error("The parameter 'startShelfId' cannot be null.");
        else if (startShelfId !== undefined)
            url_ += "startShelfId=" + encodeURIComponent("" + startShelfId) + "&";
        if (endShelfId === null)
            throw new Error("The parameter 'endShelfId' cannot be null.");
        else if (endShelfId !== undefined)
            url_ += "endShelfId=" + encodeURIComponent("" + endShelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSTDetailWithUserAndShelves(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSTDetailWithUserAndShelves(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingDetailDto[]>;
        }));
    }

    protected processCreateSTDetailWithUserAndShelves(response: HttpResponseBase): Observable<StockTakingDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockTakingDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingDetailDto[]>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param stActionTypeCode (optional) 
     * @param assignedUserId (optional) 
     * @param detailGroup (optional) 
     * @param body (optional) 
     * @return Success
     */
    createSTDetailWithUserAndCheckListShelves(stHeaderId: number | undefined, stActionTypeCode: string | null | undefined, assignedUserId: number | undefined, detailGroup: string | null | undefined, body: number[] | null | undefined): Observable<StockTakingDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/CreateSTDetailWithUserAndCheckListShelves?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (stActionTypeCode !== undefined && stActionTypeCode !== null)
            url_ += "stActionTypeCode=" + encodeURIComponent("" + stActionTypeCode) + "&";
        if (assignedUserId === null)
            throw new Error("The parameter 'assignedUserId' cannot be null.");
        else if (assignedUserId !== undefined)
            url_ += "assignedUserId=" + encodeURIComponent("" + assignedUserId) + "&";
        if (detailGroup !== undefined && detailGroup !== null)
            url_ += "detailGroup=" + encodeURIComponent("" + detailGroup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSTDetailWithUserAndCheckListShelves(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSTDetailWithUserAndCheckListShelves(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingDetailDto[]>;
        }));
    }

    protected processCreateSTDetailWithUserAndCheckListShelves(response: HttpResponseBase): Observable<StockTakingDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockTakingDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingDetailDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSTDetailWithUserAndBatchShelfList(body: BatchCreateDetailDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/CreateSTDetailWithUserAndBatchShelfList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSTDetailWithUserAndBatchShelfList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSTDetailWithUserAndBatchShelfList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateSTDetailWithUserAndBatchShelfList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSTDetailWithUserAndBatchShelfList(body: BatchUpdateDetailDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/UpdateSTDetailWithUserAndBatchShelfList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSTDetailWithUserAndBatchShelfList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSTDetailWithUserAndBatchShelfList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSTDetailWithUserAndBatchShelfList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @param groupName (optional) 
     * @param userId (optional) 
     * @return Success
     */
    updateSTDetailWithUserAndDetailGroup(headerId: number | undefined, groupName: string | null | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/UpdateSTDetailWithUserAndDetailGroup?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        if (groupName !== undefined && groupName !== null)
            url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSTDetailWithUserAndDetailGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSTDetailWithUserAndDetailGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSTDetailWithUserAndDetailGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @return Success
     */
    getDetailGroupListPda(stHeaderId: number | undefined): Observable<DetailGroupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetDetailGroupListPda?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailGroupListPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailGroupListPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DetailGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DetailGroupDto[]>;
        }));
    }

    protected processGetDetailGroupListPda(response: HttpResponseBase): Observable<DetailGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DetailGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DetailGroupDto[]>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param detailGroup (optional) 
     * @return Success
     */
    getStockTakingDetailListBySTDetailGroupForPda(stHeaderId: number | undefined, detailGroup: string | null | undefined): Observable<StockTakingDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetStockTakingDetailListBySTDetailGroupForPda?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (detailGroup !== undefined && detailGroup !== null)
            url_ += "detailGroup=" + encodeURIComponent("" + detailGroup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingDetailListBySTDetailGroupForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingDetailListBySTDetailGroupForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingDetailDto[]>;
        }));
    }

    protected processGetStockTakingDetailListBySTDetailGroupForPda(response: HttpResponseBase): Observable<StockTakingDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockTakingDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingDetailDto[]>(null as any);
    }

    /**
     * @param stDetailId (optional) 
     * @return Success
     */
    getStockTakingDetailBySTDetailId(stDetailId: number | undefined): Observable<StockTakingDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetStockTakingDetailBySTDetailId?";
        if (stDetailId === null)
            throw new Error("The parameter 'stDetailId' cannot be null.");
        else if (stDetailId !== undefined)
            url_ += "stDetailId=" + encodeURIComponent("" + stDetailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingDetailBySTDetailId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingDetailBySTDetailId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingDetailDto>;
        }));
    }

    protected processGetStockTakingDetailBySTDetailId(response: HttpResponseBase): Observable<StockTakingDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockTakingDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingDetailDto>(null as any);
    }

    /**
     * @param stDetailId (optional) 
     * @return Success
     */
    deleteSTDetail(stDetailId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/DeleteSTDetail?";
        if (stDetailId === null)
            throw new Error("The parameter 'stDetailId' cannot be null.");
        else if (stDetailId !== undefined)
            url_ += "stDetailId=" + encodeURIComponent("" + stDetailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSTDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSTDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSTDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stDetailIdList (optional) 
     * @return Success
     */
    deleteSTDetailWithStDetailIdList(stDetailIdList: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/DeleteSTDetailWithStDetailIdList?";
        if (stDetailIdList !== undefined && stDetailIdList !== null)
            stDetailIdList && stDetailIdList.forEach(item => { url_ += "stDetailIdList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSTDetailWithStDetailIdList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSTDetailWithStDetailIdList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSTDetailWithStDetailIdList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stDetailId (optional) 
     * @return Success
     */
    updateSTDetailRevertDeletionForReAssignment(stDetailId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/UpdateSTDetailRevertDeletionForReAssignment?";
        if (stDetailId === null)
            throw new Error("The parameter 'stDetailId' cannot be null.");
        else if (stDetailId !== undefined)
            url_ += "stDetailId=" + encodeURIComponent("" + stDetailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSTDetailRevertDeletionForReAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSTDetailRevertDeletionForReAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSTDetailRevertDeletionForReAssignment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stDetailId (optional) 
     * @param newAssignedShelfId (optional) 
     * @param newAssingedUserId (optional) 
     * @param newGroup (optional) 
     * @return Success
     */
    updateSTDetailWithNewUserOrShelf(stDetailId: number | undefined, newAssignedShelfId: number | undefined, newAssingedUserId: number | undefined, newGroup: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/UpdateSTDetailWithNewUserOrShelf?";
        if (stDetailId === null)
            throw new Error("The parameter 'stDetailId' cannot be null.");
        else if (stDetailId !== undefined)
            url_ += "stDetailId=" + encodeURIComponent("" + stDetailId) + "&";
        if (newAssignedShelfId === null)
            throw new Error("The parameter 'newAssignedShelfId' cannot be null.");
        else if (newAssignedShelfId !== undefined)
            url_ += "newAssignedShelfId=" + encodeURIComponent("" + newAssignedShelfId) + "&";
        if (newAssingedUserId === null)
            throw new Error("The parameter 'newAssingedUserId' cannot be null.");
        else if (newAssingedUserId !== undefined)
            url_ += "newAssingedUserId=" + encodeURIComponent("" + newAssingedUserId) + "&";
        if (newGroup !== undefined && newGroup !== null)
            url_ += "newGroup=" + encodeURIComponent("" + newGroup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSTDetailWithNewUserOrShelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSTDetailWithNewUserOrShelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSTDetailWithNewUserOrShelf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param stocktakingHeaderId (optional) 
     * @param assignedShelfId (optional) 
     * @param processUserId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStockTakingDetailListPaged(companyId: number | undefined, warehouseId: number | undefined, stocktakingHeaderId: number | undefined, assignedShelfId: number | undefined, processUserId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StockTakingDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetStockTakingDetailListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (stocktakingHeaderId === null)
            throw new Error("The parameter 'stocktakingHeaderId' cannot be null.");
        else if (stocktakingHeaderId !== undefined)
            url_ += "StocktakingHeaderId=" + encodeURIComponent("" + stocktakingHeaderId) + "&";
        if (assignedShelfId === null)
            throw new Error("The parameter 'assignedShelfId' cannot be null.");
        else if (assignedShelfId !== undefined)
            url_ += "AssignedShelfId=" + encodeURIComponent("" + assignedShelfId) + "&";
        if (processUserId === null)
            throw new Error("The parameter 'processUserId' cannot be null.");
        else if (processUserId !== undefined)
            url_ += "ProcessUserId=" + encodeURIComponent("" + processUserId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingDetailListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingDetailListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingDetailDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingDetailDtoPagedResultDto>;
        }));
    }

    protected processGetStockTakingDetailListPaged(response: HttpResponseBase): Observable<StockTakingDetailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockTakingDetailDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingDetailDtoPagedResultDto>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param assignedShelfId (optional) 
     * @param processUserId (optional) 
     * @return Success
     */
    createSTActionProcessFromSTDetailShelfScanForPda(stHeaderId: number | undefined, assignedShelfId: number | undefined, processUserId: number | undefined): Observable<StockTakingActionProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/CreateSTActionProcessFromSTDetailShelfScanForPda?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (assignedShelfId === null)
            throw new Error("The parameter 'assignedShelfId' cannot be null.");
        else if (assignedShelfId !== undefined)
            url_ += "AssignedShelfId=" + encodeURIComponent("" + assignedShelfId) + "&";
        if (processUserId === null)
            throw new Error("The parameter 'processUserId' cannot be null.");
        else if (processUserId !== undefined)
            url_ += "ProcessUserId=" + encodeURIComponent("" + processUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSTActionProcessFromSTDetailShelfScanForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSTActionProcessFromSTDetailShelfScanForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingActionProcessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingActionProcessDto[]>;
        }));
    }

    protected processCreateSTActionProcessFromSTDetailShelfScanForPda(response: HttpResponseBase): Observable<StockTakingActionProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockTakingActionProcessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingActionProcessDto[]>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param assignedShelfId (optional) 
     * @param processUserId (optional) 
     * @return Success
     */
    createSTActionProcessFromSTDetailShelfScanForPdaNew(stHeaderId: number | undefined, assignedShelfId: number | undefined, processUserId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/CreateSTActionProcessFromSTDetailShelfScanForPdaNew?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (assignedShelfId === null)
            throw new Error("The parameter 'assignedShelfId' cannot be null.");
        else if (assignedShelfId !== undefined)
            url_ += "AssignedShelfId=" + encodeURIComponent("" + assignedShelfId) + "&";
        if (processUserId === null)
            throw new Error("The parameter 'processUserId' cannot be null.");
        else if (processUserId !== undefined)
            url_ += "ProcessUserId=" + encodeURIComponent("" + processUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSTActionProcessFromSTDetailShelfScanForPdaNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSTActionProcessFromSTDetailShelfScanForPdaNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateSTActionProcessFromSTDetailShelfScanForPdaNew(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param assignedShelfId (optional) 
     * @param processUserId (optional) 
     * @param productId (optional) 
     * @param countedQuantity (optional) 
     * @return Success
     */
    updateSTActionProcessAddQuantityForPda(stHeaderId: number | undefined, assignedShelfId: number | undefined, processUserId: number | undefined, productId: number | undefined, countedQuantity: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/UpdateSTActionProcessAddQuantityForPda?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (assignedShelfId === null)
            throw new Error("The parameter 'assignedShelfId' cannot be null.");
        else if (assignedShelfId !== undefined)
            url_ += "AssignedShelfId=" + encodeURIComponent("" + assignedShelfId) + "&";
        if (processUserId === null)
            throw new Error("The parameter 'processUserId' cannot be null.");
        else if (processUserId !== undefined)
            url_ += "ProcessUserId=" + encodeURIComponent("" + processUserId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (countedQuantity === null)
            throw new Error("The parameter 'countedQuantity' cannot be null.");
        else if (countedQuantity !== undefined)
            url_ += "CountedQuantity=" + encodeURIComponent("" + countedQuantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSTActionProcessAddQuantityForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSTActionProcessAddQuantityForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSTActionProcessAddQuantityForPda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param assignedShelfId (optional) 
     * @return Success
     */
    getSTActionProcessListForShelfForPda(stHeaderId: number | undefined, assignedShelfId: number | undefined): Observable<StockTakingActionProcessDtoForPda[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetSTActionProcessListForShelfForPda?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (assignedShelfId === null)
            throw new Error("The parameter 'assignedShelfId' cannot be null.");
        else if (assignedShelfId !== undefined)
            url_ += "AssignedShelfId=" + encodeURIComponent("" + assignedShelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSTActionProcessListForShelfForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSTActionProcessListForShelfForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingActionProcessDtoForPda[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingActionProcessDtoForPda[]>;
        }));
    }

    protected processGetSTActionProcessListForShelfForPda(response: HttpResponseBase): Observable<StockTakingActionProcessDtoForPda[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockTakingActionProcessDtoForPda.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingActionProcessDtoForPda[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSTActionProcessByProcessId(id: number | undefined): Observable<StockTakingActionProcessDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetSTActionProcessByProcessId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSTActionProcessByProcessId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSTActionProcessByProcessId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingActionProcessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingActionProcessDto>;
        }));
    }

    protected processGetSTActionProcessByProcessId(response: HttpResponseBase): Observable<StockTakingActionProcessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockTakingActionProcessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingActionProcessDto>(null as any);
    }

    /**
     * @param stActionProcessId (optional) 
     * @param assignedShelfId (optional) 
     * @param productId (optional) 
     * @param countedQuantity (optional) 
     * @return Success
     */
    updateSTActionProcesstoCorrectQuantityForPda(stActionProcessId: number | undefined, assignedShelfId: number | undefined, productId: number | undefined, countedQuantity: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/UpdateSTActionProcesstoCorrectQuantityForPda?";
        if (stActionProcessId === null)
            throw new Error("The parameter 'stActionProcessId' cannot be null.");
        else if (stActionProcessId !== undefined)
            url_ += "stActionProcessId=" + encodeURIComponent("" + stActionProcessId) + "&";
        if (assignedShelfId === null)
            throw new Error("The parameter 'assignedShelfId' cannot be null.");
        else if (assignedShelfId !== undefined)
            url_ += "AssignedShelfId=" + encodeURIComponent("" + assignedShelfId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (countedQuantity === null)
            throw new Error("The parameter 'countedQuantity' cannot be null.");
        else if (countedQuantity !== undefined)
            url_ += "CountedQuantity=" + encodeURIComponent("" + countedQuantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSTActionProcesstoCorrectQuantityForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSTActionProcesstoCorrectQuantityForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSTActionProcesstoCorrectQuantityForPda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stActionProcessId (optional) 
     * @return Success
     */
    deleteSTActionProcessAtWrongProductRecordForPda(stActionProcessId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/DeleteSTActionProcessAtWrongProductRecordForPda?";
        if (stActionProcessId === null)
            throw new Error("The parameter 'stActionProcessId' cannot be null.");
        else if (stActionProcessId !== undefined)
            url_ += "stActionProcessId=" + encodeURIComponent("" + stActionProcessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSTActionProcessAtWrongProductRecordForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSTActionProcessAtWrongProductRecordForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSTActionProcessAtWrongProductRecordForPda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stDetailId (optional) 
     * @param processUserId (optional) 
     * @return Success
     */
    finishSTDetailAfterShelfCountFinishedForPda(stDetailId: number | undefined, processUserId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/FinishSTDetailAfterShelfCountFinishedForPda?";
        if (stDetailId === null)
            throw new Error("The parameter 'stDetailId' cannot be null.");
        else if (stDetailId !== undefined)
            url_ += "stDetailId=" + encodeURIComponent("" + stDetailId) + "&";
        if (processUserId === null)
            throw new Error("The parameter 'processUserId' cannot be null.");
        else if (processUserId !== undefined)
            url_ += "ProcessUserId=" + encodeURIComponent("" + processUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishSTDetailAfterShelfCountFinishedForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishSTDetailAfterShelfCountFinishedForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishSTDetailAfterShelfCountFinishedForPda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stDetailId (optional) 
     * @param processUserId (optional) 
     * @return Success
     */
    finishSTDetailAfterShelfCountFinishedForEmptyShelfSpotCheckForPda(stDetailId: number | undefined, processUserId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/FinishSTDetailAfterShelfCountFinishedForEmptyShelfSpotCheckForPda?";
        if (stDetailId === null)
            throw new Error("The parameter 'stDetailId' cannot be null.");
        else if (stDetailId !== undefined)
            url_ += "stDetailId=" + encodeURIComponent("" + stDetailId) + "&";
        if (processUserId === null)
            throw new Error("The parameter 'processUserId' cannot be null.");
        else if (processUserId !== undefined)
            url_ += "ProcessUserId=" + encodeURIComponent("" + processUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishSTDetailAfterShelfCountFinishedForEmptyShelfSpotCheckForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishSTDetailAfterShelfCountFinishedForEmptyShelfSpotCheckForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishSTDetailAfterShelfCountFinishedForEmptyShelfSpotCheckForPda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @return Success
     */
    finishStockTakingWorkActivityAndSTHeader(stHeaderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/FinishStockTakingWorkActivityAndSTHeader?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishStockTakingWorkActivityAndSTHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishStockTakingWorkActivityAndSTHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishStockTakingWorkActivityAndSTHeader(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stActionProcessId (optional) 
     * @return Success
     */
    updateSTActionProcessAddToControlChecklist(stActionProcessId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/UpdateSTActionProcessAddToControlChecklist?";
        if (stActionProcessId === null)
            throw new Error("The parameter 'stActionProcessId' cannot be null.");
        else if (stActionProcessId !== undefined)
            url_ += "stActionProcessId=" + encodeURIComponent("" + stActionProcessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSTActionProcessAddToControlChecklist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSTActionProcessAddToControlChecklist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSTActionProcessAddToControlChecklist(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stActionProcessId (optional) 
     * @return Success
     */
    updateSTActionProcessAddToSupervisorChecklist(stActionProcessId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/UpdateSTActionProcessAddToSupervisorChecklist?";
        if (stActionProcessId === null)
            throw new Error("The parameter 'stActionProcessId' cannot be null.");
        else if (stActionProcessId !== undefined)
            url_ += "stActionProcessId=" + encodeURIComponent("" + stActionProcessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSTActionProcessAddToSupervisorChecklist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSTActionProcessAddToSupervisorChecklist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSTActionProcessAddToSupervisorChecklist(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @return Success
     */
    getSTActionProcessOnControlListForPda(stHeaderId: number | undefined): Observable<StockTakingActionProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetSTActionProcessOnControlListForPda?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSTActionProcessOnControlListForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSTActionProcessOnControlListForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingActionProcessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingActionProcessDto[]>;
        }));
    }

    protected processGetSTActionProcessOnControlListForPda(response: HttpResponseBase): Observable<StockTakingActionProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockTakingActionProcessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingActionProcessDto[]>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @return Success
     */
    getSTActionProcessOnSupervisorListForPda(stHeaderId: number | undefined): Observable<StockTakingActionProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetSTActionProcessOnSupervisorListForPda?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSTActionProcessOnSupervisorListForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSTActionProcessOnSupervisorListForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingActionProcessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingActionProcessDto[]>;
        }));
    }

    protected processGetSTActionProcessOnSupervisorListForPda(response: HttpResponseBase): Observable<StockTakingActionProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockTakingActionProcessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingActionProcessDto[]>(null as any);
    }

    /**
     * @param stActionProcessId (optional) 
     * @param productId (optional) 
     * @param controlCount (optional) 
     * @param processUserId (optional) 
     * @return Success
     */
    updateSTActionProcessControlCountForPda(stActionProcessId: number | undefined, productId: number | undefined, controlCount: number | undefined, processUserId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/UpdateSTActionProcessControlCountForPda?";
        if (stActionProcessId === null)
            throw new Error("The parameter 'stActionProcessId' cannot be null.");
        else if (stActionProcessId !== undefined)
            url_ += "stActionProcessId=" + encodeURIComponent("" + stActionProcessId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (controlCount === null)
            throw new Error("The parameter 'controlCount' cannot be null.");
        else if (controlCount !== undefined)
            url_ += "ControlCount=" + encodeURIComponent("" + controlCount) + "&";
        if (processUserId === null)
            throw new Error("The parameter 'processUserId' cannot be null.");
        else if (processUserId !== undefined)
            url_ += "ProcessUserId=" + encodeURIComponent("" + processUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSTActionProcessControlCountForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSTActionProcessControlCountForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSTActionProcessControlCountForPda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stActionProcessId (optional) 
     * @param productId (optional) 
     * @param supervisorCount (optional) 
     * @param processUserId (optional) 
     * @return Success
     */
    updateSTActionProcessSupervisorCountForPda(stActionProcessId: number | undefined, productId: number | undefined, supervisorCount: number | undefined, processUserId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/UpdateSTActionProcessSupervisorCountForPda?";
        if (stActionProcessId === null)
            throw new Error("The parameter 'stActionProcessId' cannot be null.");
        else if (stActionProcessId !== undefined)
            url_ += "stActionProcessId=" + encodeURIComponent("" + stActionProcessId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (supervisorCount === null)
            throw new Error("The parameter 'supervisorCount' cannot be null.");
        else if (supervisorCount !== undefined)
            url_ += "SupervisorCount=" + encodeURIComponent("" + supervisorCount) + "&";
        if (processUserId === null)
            throw new Error("The parameter 'processUserId' cannot be null.");
        else if (processUserId !== undefined)
            url_ += "ProcessUserId=" + encodeURIComponent("" + processUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSTActionProcessSupervisorCountForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSTActionProcessSupervisorCountForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSTActionProcessSupervisorCountForPda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stActionProcessId (optional) 
     * @return Success
     */
    updateSTActionProcessAfterSupervisorConfirm(stActionProcessId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/UpdateSTActionProcessAfterSupervisorConfirm?";
        if (stActionProcessId === null)
            throw new Error("The parameter 'stActionProcessId' cannot be null.");
        else if (stActionProcessId !== undefined)
            url_ += "stActionProcessId=" + encodeURIComponent("" + stActionProcessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSTActionProcessAfterSupervisorConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSTActionProcessAfterSupervisorConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSTActionProcessAfterSupervisorConfirm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stActionProcessId (optional) 
     * @param newShelfCurrentQuantity (optional) 
     * @param newControlCount (optional) 
     * @param newSupervisorCount (optional) 
     * @return Success
     */
    updateSTActionProcessQuantitiesFromWebUI(stActionProcessId: number | undefined, newShelfCurrentQuantity: number | undefined, newControlCount: number | undefined, newSupervisorCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/UpdateSTActionProcessQuantitiesFromWebUI?";
        if (stActionProcessId === null)
            throw new Error("The parameter 'stActionProcessId' cannot be null.");
        else if (stActionProcessId !== undefined)
            url_ += "stActionProcessId=" + encodeURIComponent("" + stActionProcessId) + "&";
        if (newShelfCurrentQuantity === null)
            throw new Error("The parameter 'newShelfCurrentQuantity' cannot be null.");
        else if (newShelfCurrentQuantity !== undefined)
            url_ += "newShelfCurrentQuantity=" + encodeURIComponent("" + newShelfCurrentQuantity) + "&";
        if (newControlCount === null)
            throw new Error("The parameter 'newControlCount' cannot be null.");
        else if (newControlCount !== undefined)
            url_ += "newControlCount=" + encodeURIComponent("" + newControlCount) + "&";
        if (newSupervisorCount === null)
            throw new Error("The parameter 'newSupervisorCount' cannot be null.");
        else if (newSupervisorCount !== undefined)
            url_ += "newSupervisorCount=" + encodeURIComponent("" + newSupervisorCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSTActionProcessQuantitiesFromWebUI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSTActionProcessQuantitiesFromWebUI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSTActionProcessQuantitiesFromWebUI(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @param sTShelfId (optional) 
     * @param productId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSTActionProcessByStHeaderId(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined, sTShelfId: number | undefined, productId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StockTakingActionProcessDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetAllSTActionProcessByStHeaderId?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (sTShelfId === null)
            throw new Error("The parameter 'sTShelfId' cannot be null.");
        else if (sTShelfId !== undefined)
            url_ += "STShelfId=" + encodeURIComponent("" + sTShelfId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSTActionProcessByStHeaderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSTActionProcessByStHeaderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingActionProcessDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingActionProcessDtoPagedResultDto>;
        }));
    }

    protected processGetAllSTActionProcessByStHeaderId(response: HttpResponseBase): Observable<StockTakingActionProcessDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockTakingActionProcessDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingActionProcessDtoPagedResultDto>(null as any);
    }

    /**
     * @param stActionProcessId (optional) 
     * @param newProductId (optional) 
     * @param newShelfCurrentQuantity (optional) 
     * @param newControlCount (optional) 
     * @param newSupervisorCount (optional) 
     * @return Success
     */
    updateSTActionProcessEmptyShelfToProductFromWebUI(stActionProcessId: number | undefined, newProductId: number | undefined, newShelfCurrentQuantity: number | undefined, newControlCount: number | undefined, newSupervisorCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/UpdateSTActionProcessEmptyShelfToProductFromWebUI?";
        if (stActionProcessId === null)
            throw new Error("The parameter 'stActionProcessId' cannot be null.");
        else if (stActionProcessId !== undefined)
            url_ += "stActionProcessId=" + encodeURIComponent("" + stActionProcessId) + "&";
        if (newProductId === null)
            throw new Error("The parameter 'newProductId' cannot be null.");
        else if (newProductId !== undefined)
            url_ += "newProductId=" + encodeURIComponent("" + newProductId) + "&";
        if (newShelfCurrentQuantity === null)
            throw new Error("The parameter 'newShelfCurrentQuantity' cannot be null.");
        else if (newShelfCurrentQuantity !== undefined)
            url_ += "newShelfCurrentQuantity=" + encodeURIComponent("" + newShelfCurrentQuantity) + "&";
        if (newControlCount === null)
            throw new Error("The parameter 'newControlCount' cannot be null.");
        else if (newControlCount !== undefined)
            url_ += "newControlCount=" + encodeURIComponent("" + newControlCount) + "&";
        if (newSupervisorCount === null)
            throw new Error("The parameter 'newSupervisorCount' cannot be null.");
        else if (newSupervisorCount !== undefined)
            url_ += "newSupervisorCount=" + encodeURIComponent("" + newSupervisorCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSTActionProcessEmptyShelfToProductFromWebUI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSTActionProcessEmptyShelfToProductFromWebUI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSTActionProcessEmptyShelfToProductFromWebUI(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param shelfId (optional) 
     * @return Success
     */
    getSTDetailBySTHeaderIdAndShelfId(stHeaderId: number | undefined, shelfId: number | undefined): Observable<StockTakingDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetSTDetailBySTHeaderIdAndShelfId?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSTDetailBySTHeaderIdAndShelfId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSTDetailBySTHeaderIdAndShelfId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingDetailDto>;
        }));
    }

    protected processGetSTDetailBySTHeaderIdAndShelfId(response: HttpResponseBase): Observable<StockTakingDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockTakingDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingDetailDto>(null as any);
    }

    /**
     * @param stDetailId (optional) 
     * @param productId (optional) 
     * @return Success
     */
    getSTAPWithSelectedProductAndSelectedShelf(stDetailId: number | undefined, productId: number | undefined): Observable<StockTakingActionProcessDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetSTAPWithSelectedProductAndSelectedShelf?";
        if (stDetailId === null)
            throw new Error("The parameter 'stDetailId' cannot be null.");
        else if (stDetailId !== undefined)
            url_ += "stDetailId=" + encodeURIComponent("" + stDetailId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSTAPWithSelectedProductAndSelectedShelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSTAPWithSelectedProductAndSelectedShelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingActionProcessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingActionProcessDto>;
        }));
    }

    protected processGetSTAPWithSelectedProductAndSelectedShelf(response: HttpResponseBase): Observable<StockTakingActionProcessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockTakingActionProcessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingActionProcessDto>(null as any);
    }

    /**
     * @param stDetailId (optional) 
     * @param shelfId (optional) 
     * @return Success
     */
    getWhetherShelfIsEmpty(stDetailId: number | undefined, shelfId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetWhetherShelfIsEmpty?";
        if (stDetailId === null)
            throw new Error("The parameter 'stDetailId' cannot be null.");
        else if (stDetailId !== undefined)
            url_ += "stDetailId=" + encodeURIComponent("" + stDetailId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWhetherShelfIsEmpty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWhetherShelfIsEmpty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetWhetherShelfIsEmpty(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param stDetailId (optional) 
     * @param productId (optional) 
     * @param newShelfCurrentQuantity (optional) 
     * @param newControlCount (optional) 
     * @param newSupervisorCount (optional) 
     * @return Success
     */
    createSTActionProcessFromWebUI(stHeaderId: number | undefined, stDetailId: number | undefined, productId: number | undefined, newShelfCurrentQuantity: number | undefined, newControlCount: number | undefined, newSupervisorCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/CreateSTActionProcessFromWebUI?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (stDetailId === null)
            throw new Error("The parameter 'stDetailId' cannot be null.");
        else if (stDetailId !== undefined)
            url_ += "stDetailId=" + encodeURIComponent("" + stDetailId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (newShelfCurrentQuantity === null)
            throw new Error("The parameter 'newShelfCurrentQuantity' cannot be null.");
        else if (newShelfCurrentQuantity !== undefined)
            url_ += "newShelfCurrentQuantity=" + encodeURIComponent("" + newShelfCurrentQuantity) + "&";
        if (newControlCount === null)
            throw new Error("The parameter 'newControlCount' cannot be null.");
        else if (newControlCount !== undefined)
            url_ += "newControlCount=" + encodeURIComponent("" + newControlCount) + "&";
        if (newSupervisorCount === null)
            throw new Error("The parameter 'newSupervisorCount' cannot be null.");
        else if (newSupervisorCount !== undefined)
            url_ += "newSupervisorCount=" + encodeURIComponent("" + newSupervisorCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSTActionProcessFromWebUI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSTActionProcessFromWebUI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateSTActionProcessFromWebUI(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stapId (optional) 
     * @return Success
     */
    deleteSTActionProcessFromWebUI(stapId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/DeleteSTActionProcessFromWebUI?";
        if (stapId === null)
            throw new Error("The parameter 'stapId' cannot be null.");
        else if (stapId !== undefined)
            url_ += "stapId=" + encodeURIComponent("" + stapId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSTActionProcessFromWebUI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSTActionProcessFromWebUI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSTActionProcessFromWebUI(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @param sTShelfId (optional) 
     * @param productId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportingStockTakingActionProcessPaged(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined, sTShelfId: number | undefined, productId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReportingStockTakingActionProcessDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetReportingStockTakingActionProcessPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (sTShelfId === null)
            throw new Error("The parameter 'sTShelfId' cannot be null.");
        else if (sTShelfId !== undefined)
            url_ += "STShelfId=" + encodeURIComponent("" + sTShelfId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportingStockTakingActionProcessPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportingStockTakingActionProcessPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingStockTakingActionProcessDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingStockTakingActionProcessDtoPagedResultDto>;
        }));
    }

    protected processGetReportingStockTakingActionProcessPaged(response: HttpResponseBase): Observable<ReportingStockTakingActionProcessDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportingStockTakingActionProcessDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingStockTakingActionProcessDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @param sTShelfId (optional) 
     * @param productId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportingAddressBasedListStockTakingActionProcessPaged(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined, sTShelfId: number | undefined, productId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReportingStockTakingActionProcessDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetReportingAddressBasedListStockTakingActionProcessPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (sTShelfId === null)
            throw new Error("The parameter 'sTShelfId' cannot be null.");
        else if (sTShelfId !== undefined)
            url_ += "STShelfId=" + encodeURIComponent("" + sTShelfId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportingAddressBasedListStockTakingActionProcessPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportingAddressBasedListStockTakingActionProcessPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingStockTakingActionProcessDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingStockTakingActionProcessDtoPagedResultDto>;
        }));
    }

    protected processGetReportingAddressBasedListStockTakingActionProcessPaged(response: HttpResponseBase): Observable<ReportingStockTakingActionProcessDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportingStockTakingActionProcessDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingStockTakingActionProcessDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @param sTShelfId (optional) 
     * @param productId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getNEWReportingAddressBasedListStockTakingActionProcessPaged(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined, sTShelfId: number | undefined, productId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReportingStockTakingActionProcessDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetNEWReportingAddressBasedListStockTakingActionProcessPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (sTShelfId === null)
            throw new Error("The parameter 'sTShelfId' cannot be null.");
        else if (sTShelfId !== undefined)
            url_ += "STShelfId=" + encodeURIComponent("" + sTShelfId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNEWReportingAddressBasedListStockTakingActionProcessPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNEWReportingAddressBasedListStockTakingActionProcessPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingStockTakingActionProcessDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingStockTakingActionProcessDtoPagedResultDto>;
        }));
    }

    protected processGetNEWReportingAddressBasedListStockTakingActionProcessPaged(response: HttpResponseBase): Observable<ReportingStockTakingActionProcessDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportingStockTakingActionProcessDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingStockTakingActionProcessDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @param sTShelfId (optional) 
     * @param productId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportingProductBasedStockTakingActionProcessPaged(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined, sTShelfId: number | undefined, productId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReportingStockTakingActionProcessDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetReportingProductBasedStockTakingActionProcessPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (sTShelfId === null)
            throw new Error("The parameter 'sTShelfId' cannot be null.");
        else if (sTShelfId !== undefined)
            url_ += "STShelfId=" + encodeURIComponent("" + sTShelfId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportingProductBasedStockTakingActionProcessPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportingProductBasedStockTakingActionProcessPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingStockTakingActionProcessDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingStockTakingActionProcessDtoPagedResultDto>;
        }));
    }

    protected processGetReportingProductBasedStockTakingActionProcessPaged(response: HttpResponseBase): Observable<ReportingStockTakingActionProcessDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportingStockTakingActionProcessDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingStockTakingActionProcessDtoPagedResultDto>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getReportingStockTakingDetailProgress(workActivityId: number | undefined): Observable<StockTakingDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetReportingStockTakingDetailProgress?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportingStockTakingDetailProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportingStockTakingDetailProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingDetailDto[]>;
        }));
    }

    protected processGetReportingStockTakingDetailProgress(response: HttpResponseBase): Observable<StockTakingDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockTakingDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingDetailDto[]>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getReportingStockTakingDetailProgressPerUser(workActivityId: number | undefined): Observable<ReportingStockTakingDetailPerUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetReportingStockTakingDetailProgressPerUser?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportingStockTakingDetailProgressPerUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportingStockTakingDetailProgressPerUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingStockTakingDetailPerUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingStockTakingDetailPerUserDto[]>;
        }));
    }

    protected processGetReportingStockTakingDetailProgressPerUser(response: HttpResponseBase): Observable<ReportingStockTakingDetailPerUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReportingStockTakingDetailPerUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingStockTakingDetailPerUserDto[]>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getShelfQty(workActivityId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetShelfQty?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfQty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfQty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetShelfQty(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @param sTShelfId (optional) 
     * @param productId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportingCompletionProductTotalStockTakingActionProcessPaged(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined, sTShelfId: number | undefined, productId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReportingCompletionProductTotalQuantityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetReportingCompletionProductTotalStockTakingActionProcessPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (sTShelfId === null)
            throw new Error("The parameter 'sTShelfId' cannot be null.");
        else if (sTShelfId !== undefined)
            url_ += "STShelfId=" + encodeURIComponent("" + sTShelfId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportingCompletionProductTotalStockTakingActionProcessPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportingCompletionProductTotalStockTakingActionProcessPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingCompletionProductTotalQuantityDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingCompletionProductTotalQuantityDtoPagedResultDto>;
        }));
    }

    protected processGetReportingCompletionProductTotalStockTakingActionProcessPaged(response: HttpResponseBase): Observable<ReportingCompletionProductTotalQuantityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportingCompletionProductTotalQuantityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingCompletionProductTotalQuantityDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @return Success
     */
    getReportingCompletionActionProcessListProductQuantityAddressBased(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined): Observable<ReportingStockTakingActionProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetReportingCompletionActionProcessListProductQuantityAddressBased?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportingCompletionActionProcessListProductQuantityAddressBased(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportingCompletionActionProcessListProductQuantityAddressBased(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingStockTakingActionProcessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingStockTakingActionProcessDto[]>;
        }));
    }

    protected processGetReportingCompletionActionProcessListProductQuantityAddressBased(response: HttpResponseBase): Observable<ReportingStockTakingActionProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReportingStockTakingActionProcessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingStockTakingActionProcessDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @return Success
     */
    getReportingCompletionAllProductsTotalStockTakingActionProcessList(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined): Observable<ReportingCompletionProductTotalQuantityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetReportingCompletionAllProductsTotalStockTakingActionProcessList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportingCompletionAllProductsTotalStockTakingActionProcessList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportingCompletionAllProductsTotalStockTakingActionProcessList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingCompletionProductTotalQuantityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingCompletionProductTotalQuantityDto[]>;
        }));
    }

    protected processGetReportingCompletionAllProductsTotalStockTakingActionProcessList(response: HttpResponseBase): Observable<ReportingCompletionProductTotalQuantityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReportingCompletionProductTotalQuantityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingCompletionProductTotalQuantityDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @return Success
     */
    getReportingCompletionEmptyShelves(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined): Observable<ReportingStockTakingActionProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetReportingCompletionEmptyShelves?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportingCompletionEmptyShelves(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportingCompletionEmptyShelves(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingStockTakingActionProcessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingStockTakingActionProcessDto[]>;
        }));
    }

    protected processGetReportingCompletionEmptyShelves(response: HttpResponseBase): Observable<ReportingStockTakingActionProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReportingStockTakingActionProcessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingStockTakingActionProcessDto[]>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @param processUserId (optional) 
     * @param spotCheckShelfId (optional) 
     * @return Success
     */
    createSpotCheckSTDetailAndActionProcessForPda(stHeaderId: number | undefined, processUserId: number | undefined, spotCheckShelfId: number | undefined): Observable<StockTakingActionProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/CreateSpotCheckSTDetailAndActionProcessForPda?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        if (processUserId === null)
            throw new Error("The parameter 'processUserId' cannot be null.");
        else if (processUserId !== undefined)
            url_ += "ProcessUserId=" + encodeURIComponent("" + processUserId) + "&";
        if (spotCheckShelfId === null)
            throw new Error("The parameter 'spotCheckShelfId' cannot be null.");
        else if (spotCheckShelfId !== undefined)
            url_ += "SpotCheckShelfId=" + encodeURIComponent("" + spotCheckShelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSpotCheckSTDetailAndActionProcessForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSpotCheckSTDetailAndActionProcessForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingActionProcessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingActionProcessDto[]>;
        }));
    }

    protected processCreateSpotCheckSTDetailAndActionProcessForPda(response: HttpResponseBase): Observable<StockTakingActionProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockTakingActionProcessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingActionProcessDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @return Success
     */
    getStockTakingActionProcessListWithStockQuanShelfQuanDiff(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined): Observable<ReportingStockTakingActionProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetStockTakingActionProcessListWithStockQuanShelfQuanDiff?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingActionProcessListWithStockQuanShelfQuanDiff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingActionProcessListWithStockQuanShelfQuanDiff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingStockTakingActionProcessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingStockTakingActionProcessDto[]>;
        }));
    }

    protected processGetStockTakingActionProcessListWithStockQuanShelfQuanDiff(response: HttpResponseBase): Observable<ReportingStockTakingActionProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReportingStockTakingActionProcessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingStockTakingActionProcessDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @param sTShelfId (optional) 
     * @param productId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStockTakingActionProcessListPagedWithStockQuanShelfQuanDiff(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined, sTShelfId: number | undefined, productId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReportingStockTakingActionProcessDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetStockTakingActionProcessListPagedWithStockQuanShelfQuanDiff?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (sTShelfId === null)
            throw new Error("The parameter 'sTShelfId' cannot be null.");
        else if (sTShelfId !== undefined)
            url_ += "STShelfId=" + encodeURIComponent("" + sTShelfId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingActionProcessListPagedWithStockQuanShelfQuanDiff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingActionProcessListPagedWithStockQuanShelfQuanDiff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingStockTakingActionProcessDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingStockTakingActionProcessDtoPagedResultDto>;
        }));
    }

    protected processGetStockTakingActionProcessListPagedWithStockQuanShelfQuanDiff(response: HttpResponseBase): Observable<ReportingStockTakingActionProcessDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportingStockTakingActionProcessDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingStockTakingActionProcessDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBatchControlList(body: BatchControlListCreationSTAPDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/CreateBatchControlList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBatchControlList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBatchControlList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateBatchControlList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @return Success
     */
    getSTActionProcessOnControlList(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined): Observable<ReportingStockTakingActionProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetSTActionProcessOnControlList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSTActionProcessOnControlList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSTActionProcessOnControlList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingStockTakingActionProcessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingStockTakingActionProcessDto[]>;
        }));
    }

    protected processGetSTActionProcessOnControlList(response: HttpResponseBase): Observable<ReportingStockTakingActionProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReportingStockTakingActionProcessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingStockTakingActionProcessDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @param sTShelfId (optional) 
     * @param productId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSTActionProcessOnControlListPaged(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined, sTShelfId: number | undefined, productId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReportingStockTakingActionProcessDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetSTActionProcessOnControlListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (sTShelfId === null)
            throw new Error("The parameter 'sTShelfId' cannot be null.");
        else if (sTShelfId !== undefined)
            url_ += "STShelfId=" + encodeURIComponent("" + sTShelfId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSTActionProcessOnControlListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSTActionProcessOnControlListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingStockTakingActionProcessDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingStockTakingActionProcessDtoPagedResultDto>;
        }));
    }

    protected processGetSTActionProcessOnControlListPaged(response: HttpResponseBase): Observable<ReportingStockTakingActionProcessDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportingStockTakingActionProcessDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingStockTakingActionProcessDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @return Success
     */
    getControlGroupListBystHeaderForPda(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetControlGroupListBystHeaderForPda?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlGroupListBystHeaderForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlGroupListBystHeaderForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetControlGroupListBystHeaderForPda(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @return Success
     */
    getControlGroupListBystHeaderForPdaWithDto(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined): Observable<ControlGrouptDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetControlGroupListBystHeaderForPdaWithDto?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlGroupListBystHeaderForPdaWithDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlGroupListBystHeaderForPdaWithDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlGrouptDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlGrouptDto[]>;
        }));
    }

    protected processGetControlGroupListBystHeaderForPdaWithDto(response: HttpResponseBase): Observable<ControlGrouptDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ControlGrouptDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControlGrouptDto[]>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @param controlGroup (optional) 
     * @param processUserId (optional) 
     * @return Success
     */
    updateAssignShelvesToUserinControlGroupForPda(workActivityId: number | undefined, controlGroup: number | undefined, processUserId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/UpdateAssignShelvesToUserinControlGroupForPda?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (controlGroup === null)
            throw new Error("The parameter 'controlGroup' cannot be null.");
        else if (controlGroup !== undefined)
            url_ += "controlGroup=" + encodeURIComponent("" + controlGroup) + "&";
        if (processUserId === null)
            throw new Error("The parameter 'processUserId' cannot be null.");
        else if (processUserId !== undefined)
            url_ += "processUserId=" + encodeURIComponent("" + processUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssignShelvesToUserinControlGroupForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssignShelvesToUserinControlGroupForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAssignShelvesToUserinControlGroupForPda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @param controlGroup (optional) 
     * @return Success
     */
    getSTAPListForControlGroupForPda(workActivityId: number | undefined, controlGroup: number | undefined): Observable<StockTakingActionProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetSTAPListForControlGroupForPda?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (controlGroup === null)
            throw new Error("The parameter 'controlGroup' cannot be null.");
        else if (controlGroup !== undefined)
            url_ += "controlGroup=" + encodeURIComponent("" + controlGroup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSTAPListForControlGroupForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSTAPListForControlGroupForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockTakingActionProcessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockTakingActionProcessDto[]>;
        }));
    }

    protected processGetSTAPListForControlGroupForPda(response: HttpResponseBase): Observable<StockTakingActionProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockTakingActionProcessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTakingActionProcessDto[]>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @param controlGroup (optional) 
     * @return Success
     */
    getSTAPListForControlGroup(workActivityId: number | undefined, controlGroup: number | undefined): Observable<ReportingStockTakingActionProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetSTAPListForControlGroup?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (controlGroup === null)
            throw new Error("The parameter 'controlGroup' cannot be null.");
        else if (controlGroup !== undefined)
            url_ += "controlGroup=" + encodeURIComponent("" + controlGroup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSTAPListForControlGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSTAPListForControlGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingStockTakingActionProcessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingStockTakingActionProcessDto[]>;
        }));
    }

    protected processGetSTAPListForControlGroup(response: HttpResponseBase): Observable<ReportingStockTakingActionProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReportingStockTakingActionProcessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingStockTakingActionProcessDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @return Success
     */
    getControlGroupListBystHeader(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetControlGroupListBystHeader?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlGroupListBystHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlGroupListBystHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetControlGroupListBystHeader(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @param contolGroup (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportingControlListByControlGroupPaged(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined, contolGroup: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReportingStockTakingActionProcessDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetReportingControlListByControlGroupPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (contolGroup === null)
            throw new Error("The parameter 'contolGroup' cannot be null.");
        else if (contolGroup !== undefined)
            url_ += "ContolGroup=" + encodeURIComponent("" + contolGroup) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportingControlListByControlGroupPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportingControlListByControlGroupPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingStockTakingActionProcessDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingStockTakingActionProcessDtoPagedResultDto>;
        }));
    }

    protected processGetReportingControlListByControlGroupPaged(response: HttpResponseBase): Observable<ReportingStockTakingActionProcessDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportingStockTakingActionProcessDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingStockTakingActionProcessDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @param contolGroup (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportingControlListAll(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined, contolGroup: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReportingStockTakingActionProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetReportingControlListAll?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (contolGroup === null)
            throw new Error("The parameter 'contolGroup' cannot be null.");
        else if (contolGroup !== undefined)
            url_ += "ContolGroup=" + encodeURIComponent("" + contolGroup) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportingControlListAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportingControlListAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingStockTakingActionProcessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingStockTakingActionProcessDto[]>;
        }));
    }

    protected processGetReportingControlListAll(response: HttpResponseBase): Observable<ReportingStockTakingActionProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReportingStockTakingActionProcessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingStockTakingActionProcessDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @param sTShelfId (optional) 
     * @param productId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportingSupervisorControlListPaged(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined, sTShelfId: number | undefined, productId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReportingStockTakingActionProcessDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetReportingSupervisorControlListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (sTShelfId === null)
            throw new Error("The parameter 'sTShelfId' cannot be null.");
        else if (sTShelfId !== undefined)
            url_ += "STShelfId=" + encodeURIComponent("" + sTShelfId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportingSupervisorControlListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportingSupervisorControlListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingStockTakingActionProcessDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingStockTakingActionProcessDtoPagedResultDto>;
        }));
    }

    protected processGetReportingSupervisorControlListPaged(response: HttpResponseBase): Observable<ReportingStockTakingActionProcessDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportingStockTakingActionProcessDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingStockTakingActionProcessDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityId (optional) 
     * @param sTShelfId (optional) 
     * @param productId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportingSupervisorControlListAll(companyId: number | undefined, warehouseId: number | undefined, workActivityId: number | undefined, sTShelfId: number | undefined, productId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReportingStockTakingActionProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTaking/GetReportingSupervisorControlListAll?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "WorkActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (sTShelfId === null)
            throw new Error("The parameter 'sTShelfId' cannot be null.");
        else if (sTShelfId !== undefined)
            url_ += "STShelfId=" + encodeURIComponent("" + sTShelfId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportingSupervisorControlListAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportingSupervisorControlListAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingStockTakingActionProcessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingStockTakingActionProcessDto[]>;
        }));
    }

    protected processGetReportingSupervisorControlListAll(response: HttpResponseBase): Observable<ReportingStockTakingActionProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReportingStockTakingActionProcessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingStockTakingActionProcessDto[]>(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param type (optional) 
     * @return Success
     */
    updateUserShelfType(id: number | undefined, type: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserShelfType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserShelfType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserShelfType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserShelfType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param companyId (optional) 
     * @param name (optional) 
     * @return Success
     */
    getUserList(warehouseId: number | undefined, companyId: number | undefined, name: string | null | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserList?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetUserList(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isDeleted (optional) 
     * @return Success
     */
    updateUserIsDeleted(id: number | undefined, isDeleted: boolean | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserIsDeleted?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserIsDeleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserIsDeleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdateUserIsDeleted(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @return Success
     */
    getOnlineUsers(): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetOnlineUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnlineUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnlineUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetOnlineUsers(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getOnlineUsersWithDuration(): Observable<OnlineUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetOnlineUsersWithDuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnlineUsersWithDuration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnlineUsersWithDuration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnlineUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnlineUserDto[]>;
        }));
    }

    protected processGetOnlineUsersWithDuration(response: HttpResponseBase): Observable<OnlineUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OnlineUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnlineUserDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param warehouseId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, isActive: boolean | null | undefined, warehouseId: number | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (warehouseId !== undefined && warehouseId !== null)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class WarehouseServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    getWarehouseList(companyId: number | undefined): Observable<WarehouseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetWarehouseList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWarehouseList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehouseList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseDto[]>;
        }));
    }

    protected processGetWarehouseList(response: HttpResponseBase): Observable<WarehouseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWarehouseListPaged(companyId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WarehouseDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetWarehouseListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWarehouseListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehouseListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseDtoPagedResultDto>;
        }));
    }

    protected processGetWarehouseListPaged(response: HttpResponseBase): Observable<WarehouseDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseDtoPagedResultDto>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param type (optional) 
     * @return Success
     */
    getControlPointListByType(warehouseId: number | undefined, type: number | undefined): Observable<ControlPoint[]> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetControlPointListByType?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlPointListByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlPointListByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlPoint[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlPoint[]>;
        }));
    }

    protected processGetControlPointListByType(response: HttpResponseBase): Observable<ControlPoint[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ControlPoint.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControlPoint[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getWarehouse(id: number | undefined): Observable<WarehouseDto> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetWarehouse?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehouse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseDto>;
        }));
    }

    protected processGetWarehouse(response: HttpResponseBase): Observable<WarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    getWarehouseListByCompany(companyId: number | undefined): Observable<Warehouse[]> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetWarehouseListByCompany?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWarehouseListByCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehouseListByCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Warehouse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Warehouse[]>;
        }));
    }

    protected processGetWarehouseListByCompany(response: HttpResponseBase): Observable<Warehouse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Warehouse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Warehouse[]>(null as any);
    }

    /**
     * @param code (optional) 
     * @param name (optional) 
     * @param orderingNo (optional) 
     * @return Success
     */
    createWarehouse(code: string | null | undefined, name: string | null | undefined, orderingNo: number | undefined): Observable<WarehouseDto> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/CreateWarehouse?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (orderingNo === null)
            throw new Error("The parameter 'orderingNo' cannot be null.");
        else if (orderingNo !== undefined)
            url_ += "orderingNo=" + encodeURIComponent("" + orderingNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWarehouse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseDto>;
        }));
    }

    protected processCreateWarehouse(response: HttpResponseBase): Observable<WarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseDto>(null as any);
    }

    /**
     * @param code (optional) 
     * @param name (optional) 
     * @param orderingNo (optional) 
     * @param companyId (optional) 
     * @return Success
     */
    createWarehouseandRelation(code: string | null | undefined, name: string | null | undefined, orderingNo: number | undefined, companyId: number | undefined): Observable<WarehouseDto> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/CreateWarehouseandRelation?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (orderingNo === null)
            throw new Error("The parameter 'orderingNo' cannot be null.");
        else if (orderingNo !== undefined)
            url_ += "orderingNo=" + encodeURIComponent("" + orderingNo) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWarehouseandRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWarehouseandRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseDto>;
        }));
    }

    protected processCreateWarehouseandRelation(response: HttpResponseBase): Observable<WarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param code (optional) 
     * @param name (optional) 
     * @param orderingNo (optional) 
     * @return Success
     */
    updateWarehouse(id: number | undefined, code: string | null | undefined, name: string | null | undefined, orderingNo: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/UpdateWarehouse?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (orderingNo === null)
            throw new Error("The parameter 'orderingNo' cannot be null.");
        else if (orderingNo !== undefined)
            url_ += "orderingNo=" + encodeURIComponent("" + orderingNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWarehouse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateWarehouse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteWarehouse(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/DeleteWarehouse?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWarehouse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWarehouse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @return Success
     */
    getStorageListByWarehouse(warehouseId: number | undefined): Observable<StorageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetStorageListByWarehouse?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorageListByWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorageListByWarehouse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StorageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StorageDto[]>;
        }));
    }

    protected processGetStorageListByWarehouse(response: HttpResponseBase): Observable<StorageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StorageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StorageDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAcceptenceStorage(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetAcceptenceStorage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcceptenceStorage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcceptenceStorage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAcceptenceStorage(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getStorageListByWarehouseAndCompany(companyId: number | undefined, warehouseId: number | undefined): Observable<StorageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetStorageListByWarehouseAndCompany?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorageListByWarehouseAndCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorageListByWarehouseAndCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StorageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StorageDto[]>;
        }));
    }

    protected processGetStorageListByWarehouseAndCompany(response: HttpResponseBase): Observable<StorageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StorageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StorageDto[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param companyId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStorageListByWarehousePaged(warehouseId: number | undefined, companyId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StorageCompanyRelationPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetStorageListByWarehousePaged?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorageListByWarehousePaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorageListByWarehousePaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StorageCompanyRelationPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StorageCompanyRelationPagedResultDto>;
        }));
    }

    protected processGetStorageListByWarehousePaged(response: HttpResponseBase): Observable<StorageCompanyRelationPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StorageCompanyRelationPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StorageCompanyRelationPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param warehouseId (optional) 
     * @param storageTypeId (optional) 
     * @param code (optional) 
     * @param definition (optional) 
     * @return Success
     */
    updateStorage(id: number | undefined, warehouseId: number | undefined, storageTypeId: number | undefined, code: string | null | undefined, definition: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/UpdateStorage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageTypeId === null)
            throw new Error("The parameter 'storageTypeId' cannot be null.");
        else if (storageTypeId !== undefined)
            url_ += "storageTypeId=" + encodeURIComponent("" + storageTypeId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (definition !== undefined && definition !== null)
            url_ += "definition=" + encodeURIComponent("" + definition) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStorage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStorage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStorage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param warehouseId (optional) 
     * @param storageTypeId (optional) 
     * @param code (optional) 
     * @param definition (optional) 
     * @param storageCompanyCode (optional) 
     * @param order (optional) 
     * @param acceptence (optional) 
     * @param returns (optional) 
     * @return Success
     */
    updateStorageandRelations(id: number | undefined, warehouseId: number | undefined, storageTypeId: number | undefined, code: string | null | undefined, definition: string | null | undefined, storageCompanyCode: string | null | undefined, order: boolean | undefined, acceptence: boolean | undefined, returns: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/UpdateStorageandRelations?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageTypeId === null)
            throw new Error("The parameter 'storageTypeId' cannot be null.");
        else if (storageTypeId !== undefined)
            url_ += "storageTypeId=" + encodeURIComponent("" + storageTypeId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (definition !== undefined && definition !== null)
            url_ += "definition=" + encodeURIComponent("" + definition) + "&";
        if (storageCompanyCode !== undefined && storageCompanyCode !== null)
            url_ += "storageCompanyCode=" + encodeURIComponent("" + storageCompanyCode) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (acceptence === null)
            throw new Error("The parameter 'acceptence' cannot be null.");
        else if (acceptence !== undefined)
            url_ += "acceptence=" + encodeURIComponent("" + acceptence) + "&";
        if (returns === null)
            throw new Error("The parameter 'returns' cannot be null.");
        else if (returns !== undefined)
            url_ += "returns=" + encodeURIComponent("" + returns) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStorageandRelations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStorageandRelations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStorageandRelations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteStorage(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/DeleteStorage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteStorage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteStorage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteStorage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param storageTypeId (optional) 
     * @param code (optional) 
     * @param definition (optional) 
     * @return Success
     */
    createStorage(warehouseId: number | undefined, storageTypeId: number | undefined, code: string | null | undefined, definition: string | null | undefined): Observable<StorageDto> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/CreateStorage?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageTypeId === null)
            throw new Error("The parameter 'storageTypeId' cannot be null.");
        else if (storageTypeId !== undefined)
            url_ += "storageTypeId=" + encodeURIComponent("" + storageTypeId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (definition !== undefined && definition !== null)
            url_ += "definition=" + encodeURIComponent("" + definition) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStorage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStorage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StorageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StorageDto>;
        }));
    }

    protected processCreateStorage(response: HttpResponseBase): Observable<StorageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StorageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StorageDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageTypeId (optional) 
     * @param code (optional) 
     * @param storageCompanyCode (optional) 
     * @param definition (optional) 
     * @param order (optional) 
     * @param acceptence (optional) 
     * @param returns (optional) 
     * @return Success
     */
    createStorageWithRelation(companyId: number | undefined, warehouseId: number | undefined, storageTypeId: number | undefined, code: string | null | undefined, storageCompanyCode: string | null | undefined, definition: string | null | undefined, order: boolean | undefined, acceptence: boolean | undefined, returns: boolean | undefined): Observable<StorageDto> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/CreateStorageWithRelation?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageTypeId === null)
            throw new Error("The parameter 'storageTypeId' cannot be null.");
        else if (storageTypeId !== undefined)
            url_ += "storageTypeId=" + encodeURIComponent("" + storageTypeId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (storageCompanyCode !== undefined && storageCompanyCode !== null)
            url_ += "storageCompanyCode=" + encodeURIComponent("" + storageCompanyCode) + "&";
        if (definition !== undefined && definition !== null)
            url_ += "definition=" + encodeURIComponent("" + definition) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (acceptence === null)
            throw new Error("The parameter 'acceptence' cannot be null.");
        else if (acceptence !== undefined)
            url_ += "acceptence=" + encodeURIComponent("" + acceptence) + "&";
        if (returns === null)
            throw new Error("The parameter 'returns' cannot be null.");
        else if (returns !== undefined)
            url_ += "returns=" + encodeURIComponent("" + returns) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStorageWithRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStorageWithRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StorageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StorageDto>;
        }));
    }

    protected processCreateStorageWithRelation(response: HttpResponseBase): Observable<StorageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StorageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StorageDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param code (optional) 
     * @return Success
     */
    getStorageCompanyRelationList(companyId: number | undefined, warehouseId: number | undefined, code: string | null | undefined): Observable<StorageCompanyRelation[]> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetStorageCompanyRelationList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorageCompanyRelationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorageCompanyRelationList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StorageCompanyRelation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StorageCompanyRelation[]>;
        }));
    }

    protected processGetStorageCompanyRelationList(response: HttpResponseBase): Observable<StorageCompanyRelation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StorageCompanyRelation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StorageCompanyRelation[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param code (optional) 
     * @param zeusCode (optional) 
     * @param desc (optional) 
     * @param descZeus (optional) 
     * @return Success
     */
    updateStorageCompanyRelation(id: number | undefined, code: string | null | undefined, zeusCode: string | null | undefined, desc: string | null | undefined, descZeus: string | null | undefined): Observable<StorageCompanyRelation> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/UpdateStorageCompanyRelation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (zeusCode !== undefined && zeusCode !== null)
            url_ += "zeusCode=" + encodeURIComponent("" + zeusCode) + "&";
        if (desc !== undefined && desc !== null)
            url_ += "desc=" + encodeURIComponent("" + desc) + "&";
        if (descZeus !== undefined && descZeus !== null)
            url_ += "descZeus=" + encodeURIComponent("" + descZeus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStorageCompanyRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStorageCompanyRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StorageCompanyRelation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StorageCompanyRelation>;
        }));
    }

    protected processUpdateStorageCompanyRelation(response: HttpResponseBase): Observable<StorageCompanyRelation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StorageCompanyRelation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StorageCompanyRelation>(null as any);
    }

    /**
     * @return Success
     */
    getStorageTypeList(): Observable<StorageType[]> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetStorageTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorageTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorageTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StorageType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StorageType[]>;
        }));
    }

    protected processGetStorageTypeList(response: HttpResponseBase): Observable<StorageType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StorageType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StorageType[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @return Success
     */
    getEmptyShelfList(warehouseId: number | undefined, storageId: number | undefined): Observable<ShelfSimpleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetEmptyShelfList?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmptyShelfList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmptyShelfList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShelfSimpleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShelfSimpleDto[]>;
        }));
    }

    protected processGetEmptyShelfList(response: HttpResponseBase): Observable<ShelfSimpleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShelfSimpleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShelfSimpleDto[]>(null as any);
    }

    /**
     * @return Success
     */
    checkDatabaseConnection(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/CheckDatabaseConnection";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDatabaseConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDatabaseConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckDatabaseConnection(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getShelfList(): Observable<Shelf[]> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetShelfList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf[]>;
        }));
    }

    protected processGetShelfList(response: HttpResponseBase): Observable<Shelf[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Shelf.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createShelf(body: Shelf | undefined): Observable<Shelf> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/CreateShelf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf>;
        }));
    }

    protected processCreateShelf(response: HttpResponseBase): Observable<Shelf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Shelf.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf>(null as any);
    }

    /**
     * @param storageId (optional) 
     * @param shelfTypeId (optional) 
     * @param fullAddress (optional) 
     * @return Success
     */
    createShelfWithFullAdress(storageId: number | undefined, shelfTypeId: number | undefined, fullAddress: string | null | undefined): Observable<Shelf> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/CreateShelfWithFullAdress?";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfTypeId === null)
            throw new Error("The parameter 'shelfTypeId' cannot be null.");
        else if (shelfTypeId !== undefined)
            url_ += "shelfTypeId=" + encodeURIComponent("" + shelfTypeId) + "&";
        if (fullAddress !== undefined && fullAddress !== null)
            url_ += "fullAddress=" + encodeURIComponent("" + fullAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShelfWithFullAdress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShelfWithFullAdress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf>;
        }));
    }

    protected processCreateShelfWithFullAdress(response: HttpResponseBase): Observable<Shelf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Shelf.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf>(null as any);
    }

    /**
     * @param fullAdress (optional) 
     * @param seperator (optional) 
     * @return Success
     */
    updateShelfFormatParameterbyShelfAdress(fullAdress: string | null | undefined, seperator: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/UpdateShelfFormatParameterbyShelfAdress?";
        if (fullAdress !== undefined && fullAdress !== null)
            url_ += "fullAdress=" + encodeURIComponent("" + fullAdress) + "&";
        if (seperator === null)
            throw new Error("The parameter 'seperator' cannot be null.");
        else if (seperator !== undefined)
            url_ += "seperator=" + encodeURIComponent("" + seperator) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShelfFormatParameterbyShelfAdress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShelfFormatParameterbyShelfAdress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateShelfFormatParameterbyShelfAdress(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param value (optional) 
     * @param code (optional) 
     * @return Success
     */
    updateParameter(value: string | null | undefined, code: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/UpdateParameter?";
        if (value !== undefined && value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateParameter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateParameter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateParameter(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createShelfBatch(body: BatchShelfInsertDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/CreateShelfBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShelfBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShelfBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateShelfBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param fullAddressList (optional) 
     * @param storageId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    deleteShelfBatch(fullAddressList: string[] | null | undefined, storageId: number | undefined, warehouseId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/DeleteShelfBatch?";
        if (fullAddressList !== undefined && fullAddressList !== null)
            fullAddressList && fullAddressList.forEach(item => { url_ += "FullAddressList=" + encodeURIComponent("" + item) + "&"; });
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteShelfBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteShelfBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteShelfBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateShelf(body: Shelf | undefined): Observable<Shelf> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/UpdateShelf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf>;
        }));
    }

    protected processUpdateShelf(response: HttpResponseBase): Observable<Shelf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Shelf.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf>(null as any);
    }

    /**
     * @param code (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @return Success
     */
    getShelfByCode(code: string | null | undefined, warehouseId: number | undefined, storageId: number | undefined): Observable<Shelf> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetShelfByCode?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf>;
        }));
    }

    protected processGetShelfByCode(response: HttpResponseBase): Observable<Shelf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Shelf.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param includeOld (optional) 
     * @param actionId (optional) 
     * @return Success
     */
    getShelfListForPlacement(productId: number | undefined, includeOld: boolean | undefined, actionId: number | undefined): Observable<Shelf[]> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetShelfListForPlacement?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (includeOld === null)
            throw new Error("The parameter 'includeOld' cannot be null.");
        else if (includeOld !== undefined)
            url_ += "includeOld=" + encodeURIComponent("" + includeOld) + "&";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfListForPlacement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfListForPlacement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf[]>;
        }));
    }

    protected processGetShelfListForPlacement(response: HttpResponseBase): Observable<Shelf[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Shelf.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param shelfTypeId (optional) 
     * @param fullAddress (optional) 
     * @param region (optional) 
     * @param street (optional) 
     * @param apartment (optional) 
     * @param apartmentNo (optional) 
     * @param floor (optional) 
     * @param floorNo (optional) 
     * @param sequence (optional) 
     * @param sequenceNo (optional) 
     * @param hasPriority (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getShelfListPaged(companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, shelfTypeId: number | undefined, fullAddress: string | null | undefined, region: string | null | undefined, street: string | null | undefined, apartment: string | null | undefined, apartmentNo: string | null | undefined, floor: string | null | undefined, floorNo: string | null | undefined, sequence: string | null | undefined, sequenceNo: string | null | undefined, hasPriority: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShelfPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetShelfListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfTypeId === null)
            throw new Error("The parameter 'shelfTypeId' cannot be null.");
        else if (shelfTypeId !== undefined)
            url_ += "ShelfTypeId=" + encodeURIComponent("" + shelfTypeId) + "&";
        if (fullAddress !== undefined && fullAddress !== null)
            url_ += "FullAddress=" + encodeURIComponent("" + fullAddress) + "&";
        if (region !== undefined && region !== null)
            url_ += "Region=" + encodeURIComponent("" + region) + "&";
        if (street !== undefined && street !== null)
            url_ += "Street=" + encodeURIComponent("" + street) + "&";
        if (apartment !== undefined && apartment !== null)
            url_ += "Apartment=" + encodeURIComponent("" + apartment) + "&";
        if (apartmentNo !== undefined && apartmentNo !== null)
            url_ += "ApartmentNo=" + encodeURIComponent("" + apartmentNo) + "&";
        if (floor !== undefined && floor !== null)
            url_ += "Floor=" + encodeURIComponent("" + floor) + "&";
        if (floorNo !== undefined && floorNo !== null)
            url_ += "FloorNo=" + encodeURIComponent("" + floorNo) + "&";
        if (sequence !== undefined && sequence !== null)
            url_ += "Sequence=" + encodeURIComponent("" + sequence) + "&";
        if (sequenceNo !== undefined && sequenceNo !== null)
            url_ += "SequenceNo=" + encodeURIComponent("" + sequenceNo) + "&";
        if (hasPriority === null)
            throw new Error("The parameter 'hasPriority' cannot be null.");
        else if (hasPriority !== undefined)
            url_ += "HasPriority=" + encodeURIComponent("" + hasPriority) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShelfPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShelfPagedResultDto>;
        }));
    }

    protected processGetShelfListPaged(response: HttpResponseBase): Observable<ShelfPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShelfPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShelfPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getShelfListOrdered(): Observable<Shelf[]> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetShelfListOrdered";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfListOrdered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfListOrdered(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf[]>;
        }));
    }

    protected processGetShelfListOrdered(response: HttpResponseBase): Observable<Shelf[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Shelf.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf[]>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @return Success
     */
    getStockTakingUnassignedShelfList(stHeaderId: number | undefined): Observable<Shelf[]> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetStockTakingUnassignedShelfList?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingUnassignedShelfList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingUnassignedShelfList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf[]>;
        }));
    }

    protected processGetStockTakingUnassignedShelfList(response: HttpResponseBase): Observable<Shelf[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Shelf.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf[]>(null as any);
    }

    /**
     * @param stockTakingHeaderId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param shelfTypeId (optional) 
     * @param fullAddress (optional) 
     * @param region (optional) 
     * @param street (optional) 
     * @param apartment (optional) 
     * @param apartmentNo (optional) 
     * @param floor (optional) 
     * @param floorNo (optional) 
     * @param sequence (optional) 
     * @param sequenceNo (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStockTakingUnassignedShelfListPaged(stockTakingHeaderId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, shelfTypeId: number | undefined, fullAddress: string | null | undefined, region: string | null | undefined, street: string | null | undefined, apartment: string | null | undefined, apartmentNo: string | null | undefined, floor: string | null | undefined, floorNo: string | null | undefined, sequence: string | null | undefined, sequenceNo: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShelfPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetStockTakingUnassignedShelfListPaged?";
        if (stockTakingHeaderId === null)
            throw new Error("The parameter 'stockTakingHeaderId' cannot be null.");
        else if (stockTakingHeaderId !== undefined)
            url_ += "StockTakingHeaderId=" + encodeURIComponent("" + stockTakingHeaderId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfTypeId === null)
            throw new Error("The parameter 'shelfTypeId' cannot be null.");
        else if (shelfTypeId !== undefined)
            url_ += "ShelfTypeId=" + encodeURIComponent("" + shelfTypeId) + "&";
        if (fullAddress !== undefined && fullAddress !== null)
            url_ += "FullAddress=" + encodeURIComponent("" + fullAddress) + "&";
        if (region !== undefined && region !== null)
            url_ += "Region=" + encodeURIComponent("" + region) + "&";
        if (street !== undefined && street !== null)
            url_ += "Street=" + encodeURIComponent("" + street) + "&";
        if (apartment !== undefined && apartment !== null)
            url_ += "Apartment=" + encodeURIComponent("" + apartment) + "&";
        if (apartmentNo !== undefined && apartmentNo !== null)
            url_ += "ApartmentNo=" + encodeURIComponent("" + apartmentNo) + "&";
        if (floor !== undefined && floor !== null)
            url_ += "Floor=" + encodeURIComponent("" + floor) + "&";
        if (floorNo !== undefined && floorNo !== null)
            url_ += "FloorNo=" + encodeURIComponent("" + floorNo) + "&";
        if (sequence !== undefined && sequence !== null)
            url_ += "Sequence=" + encodeURIComponent("" + sequence) + "&";
        if (sequenceNo !== undefined && sequenceNo !== null)
            url_ += "SequenceNo=" + encodeURIComponent("" + sequenceNo) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingUnassignedShelfListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingUnassignedShelfListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShelfPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShelfPagedResultDto>;
        }));
    }

    protected processGetStockTakingUnassignedShelfListPaged(response: HttpResponseBase): Observable<ShelfPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShelfPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShelfPagedResultDto>(null as any);
    }

    /**
     * @param stHeaderId (optional) 
     * @return Success
     */
    getStockTakingAssignedShelfList(stHeaderId: number | undefined): Observable<Shelf[]> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetStockTakingAssignedShelfList?";
        if (stHeaderId === null)
            throw new Error("The parameter 'stHeaderId' cannot be null.");
        else if (stHeaderId !== undefined)
            url_ += "stHeaderId=" + encodeURIComponent("" + stHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingAssignedShelfList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingAssignedShelfList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf[]>;
        }));
    }

    protected processGetStockTakingAssignedShelfList(response: HttpResponseBase): Observable<Shelf[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Shelf.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf[]>(null as any);
    }

    /**
     * @param stockTakingHeaderId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @param shelfTypeId (optional) 
     * @param fullAddress (optional) 
     * @param region (optional) 
     * @param street (optional) 
     * @param apartment (optional) 
     * @param apartmentNo (optional) 
     * @param floor (optional) 
     * @param floorNo (optional) 
     * @param sequence (optional) 
     * @param sequenceNo (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStockTakingAssignedShelfListPaged(stockTakingHeaderId: number | undefined, warehouseId: number | undefined, storageId: number | undefined, shelfTypeId: number | undefined, fullAddress: string | null | undefined, region: string | null | undefined, street: string | null | undefined, apartment: string | null | undefined, apartmentNo: string | null | undefined, floor: string | null | undefined, floorNo: string | null | undefined, sequence: string | null | undefined, sequenceNo: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShelfPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetStockTakingAssignedShelfListPaged?";
        if (stockTakingHeaderId === null)
            throw new Error("The parameter 'stockTakingHeaderId' cannot be null.");
        else if (stockTakingHeaderId !== undefined)
            url_ += "StockTakingHeaderId=" + encodeURIComponent("" + stockTakingHeaderId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "StorageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfTypeId === null)
            throw new Error("The parameter 'shelfTypeId' cannot be null.");
        else if (shelfTypeId !== undefined)
            url_ += "ShelfTypeId=" + encodeURIComponent("" + shelfTypeId) + "&";
        if (fullAddress !== undefined && fullAddress !== null)
            url_ += "FullAddress=" + encodeURIComponent("" + fullAddress) + "&";
        if (region !== undefined && region !== null)
            url_ += "Region=" + encodeURIComponent("" + region) + "&";
        if (street !== undefined && street !== null)
            url_ += "Street=" + encodeURIComponent("" + street) + "&";
        if (apartment !== undefined && apartment !== null)
            url_ += "Apartment=" + encodeURIComponent("" + apartment) + "&";
        if (apartmentNo !== undefined && apartmentNo !== null)
            url_ += "ApartmentNo=" + encodeURIComponent("" + apartmentNo) + "&";
        if (floor !== undefined && floor !== null)
            url_ += "Floor=" + encodeURIComponent("" + floor) + "&";
        if (floorNo !== undefined && floorNo !== null)
            url_ += "FloorNo=" + encodeURIComponent("" + floorNo) + "&";
        if (sequence !== undefined && sequence !== null)
            url_ += "Sequence=" + encodeURIComponent("" + sequence) + "&";
        if (sequenceNo !== undefined && sequenceNo !== null)
            url_ += "SequenceNo=" + encodeURIComponent("" + sequenceNo) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingAssignedShelfListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingAssignedShelfListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShelfPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShelfPagedResultDto>;
        }));
    }

    protected processGetStockTakingAssignedShelfListPaged(response: HttpResponseBase): Observable<ShelfPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShelfPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShelfPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getShelfById(id: number | undefined): Observable<Shelf> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetShelfById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shelf>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shelf>;
        }));
    }

    protected processGetShelfById(response: HttpResponseBase): Observable<Shelf> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Shelf.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shelf>(null as any);
    }

    /**
     * @return Success
     */
    getShelfTypeList(): Observable<ShelfType[]> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetShelfTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShelfTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShelfType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShelfType[]>;
        }));
    }

    protected processGetShelfTypeList(response: HttpResponseBase): Observable<ShelfType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShelfType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShelfType[]>(null as any);
    }

    /**
     * @param shelfId (optional) 
     * @return Success
     */
    deleteShelf(shelfId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/DeleteShelf?";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteShelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteShelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteShelf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @return Success
     */
    getControlPointList(warehouseId: number | undefined): Observable<ControlPoint[]> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetControlPointList?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlPointList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlPointList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlPoint[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlPoint[]>;
        }));
    }

    protected processGetControlPointList(response: HttpResponseBase): Observable<ControlPoint[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ControlPoint.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControlPoint[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param type (optional) 
     * @return Success
     */
    getControlPointListWithType(warehouseId: number | undefined, type: ControlPointType | undefined): Observable<ControlPoint[]> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetControlPointListWithType?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlPointListWithType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlPointListWithType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlPoint[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlPoint[]>;
        }));
    }

    protected processGetControlPointListWithType(response: HttpResponseBase): Observable<ControlPoint[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ControlPoint.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControlPoint[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getControlPointListPaged(warehouseId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ControlPointPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetControlPointListPaged?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlPointListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlPointListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlPointPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlPointPagedResultDto>;
        }));
    }

    protected processGetControlPointListPaged(response: HttpResponseBase): Observable<ControlPointPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControlPointPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControlPointPagedResultDto>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param code (optional) 
     * @param definition (optional) 
     * @param body (optional) 
     * @return Success
     */
    createControlPoint(warehouseId: number | undefined, code: string | null | undefined, definition: string | null | undefined, body: ControlPointType | undefined): Observable<ControlPoint> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/CreateControlPoint?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (definition !== undefined && definition !== null)
            url_ += "definition=" + encodeURIComponent("" + definition) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateControlPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateControlPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlPoint>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlPoint>;
        }));
    }

    protected processCreateControlPoint(response: HttpResponseBase): Observable<ControlPoint> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControlPoint.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControlPoint>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateControlPoint(body: ControlPoint | undefined): Observable<ControlPoint> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/UpdateControlPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateControlPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateControlPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlPoint>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlPoint>;
        }));
    }

    protected processUpdateControlPoint(response: HttpResponseBase): Observable<ControlPoint> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControlPoint.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControlPoint>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteControlPoint(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/DeleteControlPoint?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteControlPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteControlPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteControlPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class WaybillServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getWaybillHeaderList(companyId: number | undefined, warehouseId: number | undefined): Observable<WaybillHeaderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetWaybillHeaderList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaybillHeaderList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaybillHeaderList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillHeaderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillHeaderDto[]>;
        }));
    }

    protected processGetWaybillHeaderList(response: HttpResponseBase): Observable<WaybillHeaderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WaybillHeaderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillHeaderDto[]>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getWaybillHeaderListByWorkActivityId(workActivityId: number | undefined): Observable<WaybillHeaderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetWaybillHeaderListByWorkActivityId?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaybillHeaderListByWorkActivityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaybillHeaderListByWorkActivityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillHeaderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillHeaderDto[]>;
        }));
    }

    protected processGetWaybillHeaderListByWorkActivityId(response: HttpResponseBase): Observable<WaybillHeaderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WaybillHeaderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillHeaderDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param workActivityNo (optional) 
     * @param status (optional) 
     * @param type (optional) 
     * @param clientId (optional) 
     * @param productId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sortActive (optional) 
     * @param sortDirection (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWaybillHeaderListPaged(companyId: number | undefined, warehouseId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, workActivityNo: string | null | undefined, status: number | undefined, type: WaybillType | undefined, clientId: number | undefined, productId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, sortActive: string | null | undefined, sortDirection: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WaybillHeaderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetWaybillHeaderListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (workActivityNo !== undefined && workActivityNo !== null)
            url_ += "WorkActivityNo=" + encodeURIComponent("" + workActivityNo) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sortActive !== undefined && sortActive !== null)
            url_ += "sortActive=" + encodeURIComponent("" + sortActive) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaybillHeaderListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaybillHeaderListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillHeaderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillHeaderDtoPagedResultDto>;
        }));
    }

    protected processGetWaybillHeaderListPaged(response: HttpResponseBase): Observable<WaybillHeaderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WaybillHeaderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillHeaderDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param workActivityNo (optional) 
     * @param status (optional) 
     * @param type (optional) 
     * @param clientId (optional) 
     * @param productId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sortActive (optional) 
     * @param sortDirection (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWaybillHeaderListForExamionationPaged(companyId: number | undefined, warehouseId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, workActivityNo: string | null | undefined, status: number | undefined, type: WaybillType | undefined, clientId: number | undefined, productId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, sortActive: string | null | undefined, sortDirection: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WaybillHeaderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetWaybillHeaderListForExamionationPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (workActivityNo !== undefined && workActivityNo !== null)
            url_ += "WorkActivityNo=" + encodeURIComponent("" + workActivityNo) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sortActive !== undefined && sortActive !== null)
            url_ += "sortActive=" + encodeURIComponent("" + sortActive) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaybillHeaderListForExamionationPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaybillHeaderListForExamionationPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillHeaderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillHeaderDtoPagedResultDto>;
        }));
    }

    protected processGetWaybillHeaderListForExamionationPaged(response: HttpResponseBase): Observable<WaybillHeaderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WaybillHeaderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillHeaderDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getWaybillHeader(id: number | undefined): Observable<WaybillHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetWaybillHeader?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaybillHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaybillHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillHeaderDto>;
        }));
    }

    protected processGetWaybillHeader(response: HttpResponseBase): Observable<WaybillHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WaybillHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillHeaderDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isLocked (optional) 
     * @return Success
     */
    updateWaybillHeaderLocked(id: number | undefined, isLocked: boolean | undefined): Observable<WaybillHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/UpdateWaybillHeaderLocked?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isLocked === null)
            throw new Error("The parameter 'isLocked' cannot be null.");
        else if (isLocked !== undefined)
            url_ += "isLocked=" + encodeURIComponent("" + isLocked) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWaybillHeaderLocked(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWaybillHeaderLocked(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillHeaderDto>;
        }));
    }

    protected processUpdateWaybillHeaderLocked(response: HttpResponseBase): Observable<WaybillHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WaybillHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillHeaderDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteWaybillHeader(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/DeleteWaybillHeader?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWaybillHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWaybillHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWaybillHeader(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @return Success
     */
    getWaybillShelfAddressPlacedList(headerId: number | undefined): Observable<StockMovementShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetWaybillShelfAddressPlacedList?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaybillShelfAddressPlacedList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaybillShelfAddressPlacedList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockMovementShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockMovementShelfDto[]>;
        }));
    }

    protected processGetWaybillShelfAddressPlacedList(response: HttpResponseBase): Observable<StockMovementShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockMovementShelfDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockMovementShelfDto[]>(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getFifoDetailByCode(code: string | null | undefined): Observable<FifoDetail> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetFifoDetailByCode?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFifoDetailByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFifoDetailByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FifoDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FifoDetail>;
        }));
    }

    protected processGetFifoDetailByCode(response: HttpResponseBase): Observable<FifoDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FifoDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FifoDetail>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    finishWaybillHeader(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/FinishWaybillHeader?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishWaybillHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishWaybillHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishWaybillHeader(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    finishWaybillHeaderForExamination(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/FinishWaybillHeaderForExamination?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishWaybillHeaderForExamination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishWaybillHeaderForExamination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishWaybillHeaderForExamination(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param actionId (optional) 
     * @param productId (optional) 
     * @param quantity (optional) 
     * @param allowOverload (optional) 
     * @param serialNumber (optional) 
     * @param containerCount (optional) 
     * @param packqty (optional) 
     * @return Success
     */
    updateWaybillControlAddQuantity(actionId: number | undefined, productId: number | undefined, quantity: number | undefined, allowOverload: boolean | undefined, serialNumber: string | null | undefined, containerCount: number | undefined, packqty: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/UpdateWaybillControlAddQuantity?";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (allowOverload === null)
            throw new Error("The parameter 'allowOverload' cannot be null.");
        else if (allowOverload !== undefined)
            url_ += "allowOverload=" + encodeURIComponent("" + allowOverload) + "&";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (containerCount === null)
            throw new Error("The parameter 'containerCount' cannot be null.");
        else if (containerCount !== undefined)
            url_ += "containerCount=" + encodeURIComponent("" + containerCount) + "&";
        if (packqty === null)
            throw new Error("The parameter 'packqty' cannot be null.");
        else if (packqty !== undefined)
            url_ += "packqty=" + encodeURIComponent("" + packqty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWaybillControlAddQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWaybillControlAddQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateWaybillControlAddQuantity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param actionId (optional) 
     * @param productId (optional) 
     * @param quantity (optional) 
     * @param allowOverload (optional) 
     * @param serialNumber (optional) 
     * @param containerCount (optional) 
     * @param packqty (optional) 
     * @return Success
     */
    updateWaybillControlAddQuantityForPdaNew(actionId: number | undefined, productId: number | undefined, quantity: number | undefined, allowOverload: boolean | undefined, serialNumber: string | null | undefined, containerCount: number | undefined, packqty: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/UpdateWaybillControlAddQuantityForPdaNew?";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (allowOverload === null)
            throw new Error("The parameter 'allowOverload' cannot be null.");
        else if (allowOverload !== undefined)
            url_ += "allowOverload=" + encodeURIComponent("" + allowOverload) + "&";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (containerCount === null)
            throw new Error("The parameter 'containerCount' cannot be null.");
        else if (containerCount !== undefined)
            url_ += "containerCount=" + encodeURIComponent("" + containerCount) + "&";
        if (packqty === null)
            throw new Error("The parameter 'packqty' cannot be null.");
        else if (packqty !== undefined)
            url_ += "packqty=" + encodeURIComponent("" + packqty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWaybillControlAddQuantityForPdaNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWaybillControlAddQuantityForPdaNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateWaybillControlAddQuantityForPdaNew(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param actionId (optional) 
     * @param productId (optional) 
     * @param quantity (optional) 
     * @param shelfId (optional) 
     * @param containerId (optional) 
     * @param crossDockId (optional) 
     * @return Success
     */
    updateWaybillPlacementAddQuantity(actionId: number | undefined, productId: number | undefined, quantity: number | undefined, shelfId: number | undefined, containerId: number | undefined, crossDockId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/UpdateWaybillPlacementAddQuantity?";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (containerId === null)
            throw new Error("The parameter 'containerId' cannot be null.");
        else if (containerId !== undefined)
            url_ += "containerId=" + encodeURIComponent("" + containerId) + "&";
        if (crossDockId === null)
            throw new Error("The parameter 'crossDockId' cannot be null.");
        else if (crossDockId !== undefined)
            url_ += "crossDockId=" + encodeURIComponent("" + crossDockId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWaybillPlacementAddQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWaybillPlacementAddQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateWaybillPlacementAddQuantity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param clientId (optional) 
     * @param warehouseId (optional) 
     * @param documentNo (optional) 
     * @param type (optional) 
     * @param isManuel (optional) 
     * @param isInspected (optional) 
     * @param documentDate (optional) 
     * @return Success
     */
    createWaybillHeader(companyId: number | undefined, clientId: number | undefined, warehouseId: number | undefined, documentNo: string | null | undefined, type: number | undefined, isManuel: boolean | undefined, isInspected: boolean | undefined, documentDate: Date | undefined): Observable<WaybillHeader> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/CreateWaybillHeader?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "documentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (isManuel === null)
            throw new Error("The parameter 'isManuel' cannot be null.");
        else if (isManuel !== undefined)
            url_ += "isManuel=" + encodeURIComponent("" + isManuel) + "&";
        if (isInspected === null)
            throw new Error("The parameter 'isInspected' cannot be null.");
        else if (isInspected !== undefined)
            url_ += "isInspected=" + encodeURIComponent("" + isInspected) + "&";
        if (documentDate === null)
            throw new Error("The parameter 'documentDate' cannot be null.");
        else if (documentDate !== undefined)
            url_ += "documentDate=" + encodeURIComponent(documentDate ? "" + documentDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWaybillHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWaybillHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillHeader>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillHeader>;
        }));
    }

    protected processCreateWaybillHeader(response: HttpResponseBase): Observable<WaybillHeader> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WaybillHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillHeader>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param clientId (optional) 
     * @param warehouseId (optional) 
     * @param documentNo (optional) 
     * @param isManuel (optional) 
     * @param isInspected (optional) 
     * @param documentDate (optional) 
     * @return Success
     */
    createWaybillHeaderForExamination(companyId: number | undefined, clientId: number | undefined, warehouseId: number | undefined, documentNo: string | null | undefined, isManuel: boolean | undefined, isInspected: boolean | undefined, documentDate: Date | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/CreateWaybillHeaderForExamination?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "documentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (isManuel === null)
            throw new Error("The parameter 'isManuel' cannot be null.");
        else if (isManuel !== undefined)
            url_ += "isManuel=" + encodeURIComponent("" + isManuel) + "&";
        if (isInspected === null)
            throw new Error("The parameter 'isInspected' cannot be null.");
        else if (isInspected !== undefined)
            url_ += "isInspected=" + encodeURIComponent("" + isInspected) + "&";
        if (documentDate === null)
            throw new Error("The parameter 'documentDate' cannot be null.");
        else if (documentDate !== undefined)
            url_ += "documentDate=" + encodeURIComponent(documentDate ? "" + documentDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWaybillHeaderForExamination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWaybillHeaderForExamination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateWaybillHeaderForExamination(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @return Success
     */
    createWorkActityForWaybillHeader(headerId: number | undefined): Observable<WorkActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/CreateWorkActityForWaybillHeader?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkActityForWaybillHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkActityForWaybillHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto>;
        }));
    }

    protected processCreateWorkActityForWaybillHeader(response: HttpResponseBase): Observable<WorkActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @return Success
     */
    getWaybillDetailList(headerId: number | undefined): Observable<WaybillDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetWaybillDetailList?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaybillDetailList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaybillDetailList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillDetailDto[]>;
        }));
    }

    protected processGetWaybillDetailList(response: HttpResponseBase): Observable<WaybillDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WaybillDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillDetailDto[]>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @param qtyStatus (optional) 
     * @param qtyPlacedStatus (optional) 
     * @param productCode (optional) 
     * @param sortdirection (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWaybillDetailListPaged(headerId: number | undefined, qtyStatus: number | undefined, qtyPlacedStatus: number | undefined, productCode: string | null | undefined, sortdirection: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WaybillDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetWaybillDetailListPaged?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        if (qtyStatus === null)
            throw new Error("The parameter 'qtyStatus' cannot be null.");
        else if (qtyStatus !== undefined)
            url_ += "qtyStatus=" + encodeURIComponent("" + qtyStatus) + "&";
        if (qtyPlacedStatus === null)
            throw new Error("The parameter 'qtyPlacedStatus' cannot be null.");
        else if (qtyPlacedStatus !== undefined)
            url_ += "qtyPlacedStatus=" + encodeURIComponent("" + qtyPlacedStatus) + "&";
        if (productCode !== undefined && productCode !== null)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        if (sortdirection !== undefined && sortdirection !== null)
            url_ += "sortdirection=" + encodeURIComponent("" + sortdirection) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaybillDetailListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaybillDetailListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillDetailDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillDetailDtoPagedResultDto>;
        }));
    }

    protected processGetWaybillDetailListPaged(response: HttpResponseBase): Observable<WaybillDetailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WaybillDetailDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillDetailDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param startDate (optional) 
     * @param finishDate (optional) 
     * @param productId (optional) 
     * @param clientId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWaybillDetailListUnderOver(companyId: number | undefined, warehouseId: number | undefined, startDate: Date | null | undefined, finishDate: Date | null | undefined, productId: number | undefined, clientId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WaybillDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetWaybillDetailListUnderOver?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (finishDate !== undefined && finishDate !== null)
            url_ += "FinishDate=" + encodeURIComponent(finishDate ? "" + finishDate.toISOString() : "") + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaybillDetailListUnderOver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaybillDetailListUnderOver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillDetailDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillDetailDtoPagedResultDto>;
        }));
    }

    protected processGetWaybillDetailListUnderOver(response: HttpResponseBase): Observable<WaybillDetailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WaybillDetailDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillDetailDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param startDate (optional) 
     * @param finishDate (optional) 
     * @param productId (optional) 
     * @param clientId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWaybillDetailListTimeBetweenControlPlacement(companyId: number | undefined, warehouseId: number | undefined, startDate: Date | null | undefined, finishDate: Date | null | undefined, productId: number | undefined, clientId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WaybillDetailTimeBetweenDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetWaybillDetailListTimeBetweenControlPlacement?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (finishDate !== undefined && finishDate !== null)
            url_ += "FinishDate=" + encodeURIComponent(finishDate ? "" + finishDate.toISOString() : "") + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaybillDetailListTimeBetweenControlPlacement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaybillDetailListTimeBetweenControlPlacement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillDetailTimeBetweenDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillDetailTimeBetweenDtoPagedResultDto>;
        }));
    }

    protected processGetWaybillDetailListTimeBetweenControlPlacement(response: HttpResponseBase): Observable<WaybillDetailTimeBetweenDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WaybillDetailTimeBetweenDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillDetailTimeBetweenDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param startDate (optional) 
     * @param finishDate (optional) 
     * @param productId (optional) 
     * @param clientId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWaybillHeaderListFinishedTime(companyId: number | undefined, warehouseId: number | undefined, startDate: Date | null | undefined, finishDate: Date | null | undefined, productId: number | undefined, clientId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WaybillHeaderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetWaybillHeaderListFinishedTime?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (finishDate !== undefined && finishDate !== null)
            url_ += "FinishDate=" + encodeURIComponent(finishDate ? "" + finishDate.toISOString() : "") + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaybillHeaderListFinishedTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaybillHeaderListFinishedTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillHeaderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillHeaderDtoPagedResultDto>;
        }));
    }

    protected processGetWaybillHeaderListFinishedTime(response: HttpResponseBase): Observable<WaybillHeaderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WaybillHeaderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillHeaderDtoPagedResultDto>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getWaybillDetailListByActivityId(activityId: number | undefined): Observable<WaybillDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetWaybillDetailListByActivityId?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaybillDetailListByActivityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaybillDetailListByActivityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillDetailDto[]>;
        }));
    }

    protected processGetWaybillDetailListByActivityId(response: HttpResponseBase): Observable<WaybillDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WaybillDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillDetailDto[]>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getWaybillDetailListForPdaReceiving(activityId: number | undefined): Observable<WaybillDetailReceivingDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetWaybillDetailListForPdaReceiving?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaybillDetailListForPdaReceiving(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaybillDetailListForPdaReceiving(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillDetailReceivingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillDetailReceivingDto[]>;
        }));
    }

    protected processGetWaybillDetailListForPdaReceiving(response: HttpResponseBase): Observable<WaybillDetailReceivingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WaybillDetailReceivingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillDetailReceivingDto[]>(null as any);
    }

    /**
     * @param detailId (optional) 
     * @param quantity (optional) 
     * @return Success
     */
    updateWaybillDetailAddQuantityProcessed(detailId: number | undefined, quantity: number | undefined): Observable<WaybillDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/UpdateWaybillDetailAddQuantityProcessed?";
        if (detailId === null)
            throw new Error("The parameter 'detailId' cannot be null.");
        else if (detailId !== undefined)
            url_ += "detailId=" + encodeURIComponent("" + detailId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWaybillDetailAddQuantityProcessed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWaybillDetailAddQuantityProcessed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillDetailDto>;
        }));
    }

    protected processUpdateWaybillDetailAddQuantityProcessed(response: HttpResponseBase): Observable<WaybillDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WaybillDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillDetailDto>(null as any);
    }

    /**
     * @param detailId (optional) 
     * @param isLocked (optional) 
     * @return Success
     */
    updateWaybillDetailLock(detailId: number | undefined, isLocked: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/UpdateWaybillDetailLock?";
        if (detailId === null)
            throw new Error("The parameter 'detailId' cannot be null.");
        else if (detailId !== undefined)
            url_ += "detailId=" + encodeURIComponent("" + detailId) + "&";
        if (isLocked === null)
            throw new Error("The parameter 'isLocked' cannot be null.");
        else if (isLocked !== undefined)
            url_ += "isLocked=" + encodeURIComponent("" + isLocked) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWaybillDetailLock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWaybillDetailLock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateWaybillDetailLock(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param actionId (optional) 
     * @param productId (optional) 
     * @return Success
     */
    getWaybillDetailQuantityWaitingForPlacement(actionId: number | undefined, productId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetWaybillDetailQuantityWaitingForPlacement?";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaybillDetailQuantityWaitingForPlacement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaybillDetailQuantityWaitingForPlacement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetWaybillDetailQuantityWaitingForPlacement(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param detailId (optional) 
     * @param newQuantity (optional) 
     * @param newQuantityProcessed (optional) 
     * @return Success
     */
    updateWaybillDetailQuantity(detailId: number | undefined, newQuantity: number | undefined, newQuantityProcessed: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/UpdateWaybillDetailQuantity?";
        if (detailId === null)
            throw new Error("The parameter 'detailId' cannot be null.");
        else if (detailId !== undefined)
            url_ += "detailId=" + encodeURIComponent("" + detailId) + "&";
        if (newQuantity === null)
            throw new Error("The parameter 'newQuantity' cannot be null.");
        else if (newQuantity !== undefined)
            url_ += "newQuantity=" + encodeURIComponent("" + newQuantity) + "&";
        if (newQuantityProcessed === null)
            throw new Error("The parameter 'newQuantityProcessed' cannot be null.");
        else if (newQuantityProcessed !== undefined)
            url_ += "newQuantityProcessed=" + encodeURIComponent("" + newQuantityProcessed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWaybillDetailQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWaybillDetailQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateWaybillDetailQuantity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    pullWaybillDetailAgain(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/PullWaybillDetailAgain?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPullWaybillDetailAgain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPullWaybillDetailAgain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPullWaybillDetailAgain(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param detailId (optional) 
     * @param newQuantity (optional) 
     * @param newQuantityProcessed (optional) 
     * @param newProductCode (optional) 
     * @return Success
     */
    updateWaybillDetailQuantityAndProductCode(detailId: number | undefined, newQuantity: number | undefined, newQuantityProcessed: number | undefined, newProductCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/UpdateWaybillDetailQuantityAndProductCode?";
        if (detailId === null)
            throw new Error("The parameter 'detailId' cannot be null.");
        else if (detailId !== undefined)
            url_ += "detailId=" + encodeURIComponent("" + detailId) + "&";
        if (newQuantity === null)
            throw new Error("The parameter 'newQuantity' cannot be null.");
        else if (newQuantity !== undefined)
            url_ += "newQuantity=" + encodeURIComponent("" + newQuantity) + "&";
        if (newQuantityProcessed === null)
            throw new Error("The parameter 'newQuantityProcessed' cannot be null.");
        else if (newQuantityProcessed !== undefined)
            url_ += "newQuantityProcessed=" + encodeURIComponent("" + newQuantityProcessed) + "&";
        if (newProductCode !== undefined && newProductCode !== null)
            url_ += "newProductCode=" + encodeURIComponent("" + newProductCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWaybillDetailQuantityAndProductCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWaybillDetailQuantityAndProductCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateWaybillDetailQuantityAndProductCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @param productId (optional) 
     * @param quantity (optional) 
     * @param erpEntegreId (optional) 
     * @return Success
     */
    createWaybillDetail(headerId: number | undefined, productId: number | undefined, quantity: number | undefined, erpEntegreId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/CreateWaybillDetail?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (erpEntegreId !== undefined && erpEntegreId !== null)
            url_ += "erpEntegreId=" + encodeURIComponent("" + erpEntegreId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWaybillDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWaybillDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateWaybillDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param clientId (optional) 
     * @param row (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageId (optional) 
     * @return Success
     */
    createTestWaybill(clientId: number | undefined, row: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/CreateTestWaybill?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (row === null)
            throw new Error("The parameter 'row' cannot be null.");
        else if (row !== undefined)
            url_ += "row=" + encodeURIComponent("" + row) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTestWaybill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTestWaybill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTestWaybill(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param detailId (optional) 
     * @return Success
     */
    deleteWaybillDetail(detailId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/DeleteWaybillDetail?";
        if (detailId === null)
            throw new Error("The parameter 'detailId' cannot be null.");
        else if (detailId !== undefined)
            url_ += "detailId=" + encodeURIComponent("" + detailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWaybillDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWaybillDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWaybillDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param detailId (optional) 
     * @return Success
     */
    deleteWaybillDetailForExamination(detailId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/DeleteWaybillDetailForExamination?";
        if (detailId === null)
            throw new Error("The parameter 'detailId' cannot be null.");
        else if (detailId !== undefined)
            url_ += "detailId=" + encodeURIComponent("" + detailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWaybillDetailForExamination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWaybillDetailForExamination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWaybillDetailForExamination(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param clientId (optional) 
     * @param productId (optional) 
     * @param manufacturer (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param status (optional) 
     * @param type (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWaybillDetailListReportControlPaged(companyId: number | undefined, warehouseId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, clientId: number | undefined, productId: number | undefined, manufacturer: string | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, status: number | undefined, type: WaybillType | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WaybillDetailReportDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetWaybillDetailListReportControlPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (manufacturer !== undefined && manufacturer !== null)
            url_ += "Manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaybillDetailListReportControlPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaybillDetailListReportControlPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillDetailReportDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillDetailReportDtoPagedResultDto>;
        }));
    }

    protected processGetWaybillDetailListReportControlPaged(response: HttpResponseBase): Observable<WaybillDetailReportDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WaybillDetailReportDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillDetailReportDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param clientId (optional) 
     * @param productId (optional) 
     * @param manufacturer (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param status (optional) 
     * @param type (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWaybillDetailListReportPlacementPaged(companyId: number | undefined, warehouseId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, clientId: number | undefined, productId: number | undefined, manufacturer: string | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, status: number | undefined, type: WaybillType | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WaybillDetailReportDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetWaybillDetailListReportPlacementPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (manufacturer !== undefined && manufacturer !== null)
            url_ += "Manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaybillDetailListReportPlacementPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaybillDetailListReportPlacementPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillDetailReportDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillDetailReportDtoPagedResultDto>;
        }));
    }

    protected processGetWaybillDetailListReportPlacementPaged(response: HttpResponseBase): Observable<WaybillDetailReportDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WaybillDetailReportDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillDetailReportDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param documentNo (optional) 
     * @param clientId (optional) 
     * @param productId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportPendingWaybillHeaderListPagedForClient(companyId: number | undefined, warehouseId: number | undefined, documentNo: string | null | undefined, clientId: number | undefined, productId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WaybillHeaderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetReportPendingWaybillHeaderListPagedForClient?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportPendingWaybillHeaderListPagedForClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportPendingWaybillHeaderListPagedForClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillHeaderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillHeaderDtoPagedResultDto>;
        }));
    }

    protected processGetReportPendingWaybillHeaderListPagedForClient(response: HttpResponseBase): Observable<WaybillHeaderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WaybillHeaderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillHeaderDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param documentNo (optional) 
     * @param clientId (optional) 
     * @param productId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportPendingWaybillHeaderListPagedForProduct(companyId: number | undefined, warehouseId: number | undefined, documentNo: string | null | undefined, clientId: number | undefined, productId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WaybillDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetReportPendingWaybillHeaderListPagedForProduct?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportPendingWaybillHeaderListPagedForProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportPendingWaybillHeaderListPagedForProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WaybillDetailDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WaybillDetailDtoPagedResultDto>;
        }));
    }

    protected processGetReportPendingWaybillHeaderListPagedForProduct(response: HttpResponseBase): Observable<WaybillDetailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WaybillDetailDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WaybillDetailDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createWaybillDetailBatchForExamination(body: BatchWaybillInsertDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/CreateWaybillDetailBatchForExamination";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWaybillDetailBatchForExamination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWaybillDetailBatchForExamination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateWaybillDetailBatchForExamination(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createWaybillDetailBatch(body: BatchWaybillInsertDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/CreateWaybillDetailBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWaybillDetailBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWaybillDetailBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateWaybillDetailBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param detailId (optional) 
     * @return Success
     */
    getPlacedStockMovementShelves(detailId: number | undefined): Observable<SelectedStockMovementShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/GetPlacedStockMovementShelves?";
        if (detailId === null)
            throw new Error("The parameter 'detailId' cannot be null.");
        else if (detailId !== undefined)
            url_ += "detailId=" + encodeURIComponent("" + detailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlacedStockMovementShelves(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlacedStockMovementShelves(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectedStockMovementShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectedStockMovementShelfDto[]>;
        }));
    }

    protected processGetPlacedStockMovementShelves(response: HttpResponseBase): Observable<SelectedStockMovementShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SelectedStockMovementShelfDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectedStockMovementShelfDto[]>(null as any);
    }

    /**
     * @param detailId (optional) 
     * @param shelves (optional) 
     * @param selectedQuantities (optional) 
     * @return Success
     */
    deleteWaybillDetailWithQuantityAndShelf(detailId: number | undefined, shelves: number[] | null | undefined, selectedQuantities: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Waybill/DeleteWaybillDetailWithQuantityAndShelf?";
        if (detailId === null)
            throw new Error("The parameter 'detailId' cannot be null.");
        else if (detailId !== undefined)
            url_ += "DetailId=" + encodeURIComponent("" + detailId) + "&";
        if (shelves !== undefined && shelves !== null)
            shelves && shelves.forEach(item => { url_ += "Shelves=" + encodeURIComponent("" + item) + "&"; });
        if (selectedQuantities !== undefined && selectedQuantities !== null)
            selectedQuantities && selectedQuantities.forEach(item => { url_ += "SelectedQuantities=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWaybillDetailWithQuantityAndShelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWaybillDetailWithQuantityAndShelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWaybillDetailWithQuantityAndShelf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class WorkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param detailId (optional) 
     * @param newQuantity (optional) 
     * @return Success
     */
    updateTransferRequestDetailQuantity(detailId: number | undefined, newQuantity: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/UpdateTransferRequestDetailQuantity?";
        if (detailId === null)
            throw new Error("The parameter 'detailId' cannot be null.");
        else if (detailId !== undefined)
            url_ += "detailId=" + encodeURIComponent("" + detailId) + "&";
        if (newQuantity === null)
            throw new Error("The parameter 'newQuantity' cannot be null.");
        else if (newQuantity !== undefined)
            url_ += "newQuantity=" + encodeURIComponent("" + newQuantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTransferRequestDetailQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTransferRequestDetailQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTransferRequestDetailQuantity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param transferRequestHeaderId (optional) 
     * @return Success
     */
    createWorkActivityTransferRequestHeader(companyId: number | undefined, warehouseId: number | undefined, transferRequestHeaderId: number | undefined): Observable<TransferHeaderRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateWorkActivityTransferRequestHeader?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (transferRequestHeaderId === null)
            throw new Error("The parameter 'transferRequestHeaderId' cannot be null.");
        else if (transferRequestHeaderId !== undefined)
            url_ += "transferRequestHeaderId=" + encodeURIComponent("" + transferRequestHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkActivityTransferRequestHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkActivityTransferRequestHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferHeaderRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferHeaderRequestDto>;
        }));
    }

    protected processCreateWorkActivityTransferRequestHeader(response: HttpResponseBase): Observable<TransferHeaderRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferHeaderRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferHeaderRequestDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTransferRequestDetailBatch(body: BatchTransferRequestDetailInsertDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateTransferRequestDetailBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTransferRequestDetailBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTransferRequestDetailBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTransferRequestDetailBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param transferRequestDetailId (optional) 
     * @return Success
     */
    deleteTransferRequestDetail(transferRequestDetailId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/DeleteTransferRequestDetail?";
        if (transferRequestDetailId === null)
            throw new Error("The parameter 'transferRequestDetailId' cannot be null.");
        else if (transferRequestDetailId !== undefined)
            url_ += "transferRequestDetailId=" + encodeURIComponent("" + transferRequestDetailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTransferRequestDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTransferRequestDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTransferRequestDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param workActionId (optional) 
     * @param transferRequestDetailId (optional) 
     * @param productId (optional) 
     * @param shelfId (optional) 
     * @param containerId (optional) 
     * @param quantity (optional) 
     * @return Success
     */
    updateTransferRequestDetailPickedAddQuantityForPda(workActionId: number | undefined, transferRequestDetailId: number | undefined, productId: number | undefined, shelfId: number | undefined, containerId: number | undefined, quantity: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/UpdateTransferRequestDetailPickedAddQuantityForPda?";
        if (workActionId === null)
            throw new Error("The parameter 'workActionId' cannot be null.");
        else if (workActionId !== undefined)
            url_ += "workActionId=" + encodeURIComponent("" + workActionId) + "&";
        if (transferRequestDetailId === null)
            throw new Error("The parameter 'transferRequestDetailId' cannot be null.");
        else if (transferRequestDetailId !== undefined)
            url_ += "transferRequestDetailId=" + encodeURIComponent("" + transferRequestDetailId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (containerId === null)
            throw new Error("The parameter 'containerId' cannot be null.");
        else if (containerId !== undefined)
            url_ += "containerId=" + encodeURIComponent("" + containerId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTransferRequestDetailPickedAddQuantityForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTransferRequestDetailPickedAddQuantityForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTransferRequestDetailPickedAddQuantityForPda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getTransferWarehouseWorkActivityListForPdaPicking(companyId: number | undefined, warehouseId: number | undefined): Observable<WorkActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferWarehouseWorkActivityListForPdaPicking?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferWarehouseWorkActivityListForPdaPicking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferWarehouseWorkActivityListForPdaPicking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto[]>;
        }));
    }

    protected processGetTransferWarehouseWorkActivityListForPdaPicking(response: HttpResponseBase): Observable<WorkActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getTransferWarehouseWorkActivityListForPdaControl(companyId: number | undefined, warehouseId: number | undefined): Observable<WorkActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferWarehouseWorkActivityListForPdaControl?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferWarehouseWorkActivityListForPdaControl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferWarehouseWorkActivityListForPdaControl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto[]>;
        }));
    }

    protected processGetTransferWarehouseWorkActivityListForPdaControl(response: HttpResponseBase): Observable<WorkActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto[]>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @param isOpenForAdd (optional) 
     * @return Success
     */
    updateTransferRequestHeaderIsOpenForAdd(headerId: number | undefined, isOpenForAdd: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/UpdateTransferRequestHeaderIsOpenForAdd?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        if (isOpenForAdd === null)
            throw new Error("The parameter 'isOpenForAdd' cannot be null.");
        else if (isOpenForAdd !== undefined)
            url_ += "isOpenForAdd=" + encodeURIComponent("" + isOpenForAdd) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTransferRequestHeaderIsOpenForAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTransferRequestHeaderIsOpenForAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTransferRequestHeaderIsOpenForAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param controlpointId (optional) 
     * @return Success
     */
    getTransferRequestHeaderListForControlPointId(controlpointId: number | undefined): Observable<TransferHeaderRequestDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferRequestHeaderListForControlPointId?";
        if (controlpointId === null)
            throw new Error("The parameter 'controlpointId' cannot be null.");
        else if (controlpointId !== undefined)
            url_ += "controlpointId=" + encodeURIComponent("" + controlpointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferRequestHeaderListForControlPointId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferRequestHeaderListForControlPointId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferHeaderRequestDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferHeaderRequestDto[]>;
        }));
    }

    protected processGetTransferRequestHeaderListForControlPointId(response: HttpResponseBase): Observable<TransferHeaderRequestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransferHeaderRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferHeaderRequestDto[]>(null as any);
    }

    /**
     * @param transferRequestDetailId (optional) 
     * @param quantity (optional) 
     * @param isDeleteQuantity (optional) 
     * @return Success
     */
    cancelTransferRequestDetailPartly(transferRequestDetailId: number | undefined, quantity: number | undefined, isDeleteQuantity: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CancelTransferRequestDetailPartly?";
        if (transferRequestDetailId === null)
            throw new Error("The parameter 'transferRequestDetailId' cannot be null.");
        else if (transferRequestDetailId !== undefined)
            url_ += "transferRequestDetailId=" + encodeURIComponent("" + transferRequestDetailId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (isDeleteQuantity === null)
            throw new Error("The parameter 'isDeleteQuantity' cannot be null.");
        else if (isDeleteQuantity !== undefined)
            url_ += "isDeleteQuantity=" + encodeURIComponent("" + isDeleteQuantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelTransferRequestDetailPartly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelTransferRequestDetailPartly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelTransferRequestDetailPartly(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param cancelReason (optional) 
     * @return Success
     */
    deleteTranferHeader(id: number | undefined, cancelReason: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/DeleteTranferHeader?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (cancelReason !== undefined && cancelReason !== null)
            url_ += "cancelReason=" + encodeURIComponent("" + cancelReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTranferHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTranferHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTranferHeader(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param transferDetailId (optional) 
     * @param noteDeficiency (optional) 
     * @return Success
     */
    updateTransferRequestDetailNoteDefiency(transferDetailId: number | undefined, noteDeficiency: string | null | undefined): Observable<TransferRequestDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/UpdateTransferRequestDetailNoteDefiency?";
        if (transferDetailId === null)
            throw new Error("The parameter 'transferDetailId' cannot be null.");
        else if (transferDetailId !== undefined)
            url_ += "transferDetailId=" + encodeURIComponent("" + transferDetailId) + "&";
        if (noteDeficiency !== undefined && noteDeficiency !== null)
            url_ += "noteDeficiency=" + encodeURIComponent("" + noteDeficiency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTransferRequestDetailNoteDefiency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTransferRequestDetailNoteDefiency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferRequestDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferRequestDetailDto>;
        }));
    }

    protected processUpdateTransferRequestDetailNoteDefiency(response: HttpResponseBase): Observable<TransferRequestDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferRequestDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferRequestDetailDto>(null as any);
    }

    /**
     * @param transferHeaderId (optional) 
     * @param quantity (optional) 
     * @param productId (optional) 
     * @return Success
     */
    addQuantityForTransferRequestDetailControl(transferHeaderId: number | undefined, quantity: number | undefined, productId: number | undefined): Observable<TransferRequestDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/AddQuantityForTransferRequestDetailControl?";
        if (transferHeaderId === null)
            throw new Error("The parameter 'transferHeaderId' cannot be null.");
        else if (transferHeaderId !== undefined)
            url_ += "transferHeaderId=" + encodeURIComponent("" + transferHeaderId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddQuantityForTransferRequestDetailControl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddQuantityForTransferRequestDetailControl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferRequestDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferRequestDetailDto[]>;
        }));
    }

    protected processAddQuantityForTransferRequestDetailControl(response: HttpResponseBase): Observable<TransferRequestDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransferRequestDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferRequestDetailDto[]>(null as any);
    }

    /**
     * @param workActivitySendingId (optional) 
     * @return Success
     */
    getTransferRequestHeaderListByWorkActivitySendingId(workActivitySendingId: number | undefined): Observable<TransferHeaderRequestDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferRequestHeaderListByWorkActivitySendingId?";
        if (workActivitySendingId === null)
            throw new Error("The parameter 'workActivitySendingId' cannot be null.");
        else if (workActivitySendingId !== undefined)
            url_ += "workActivitySendingId=" + encodeURIComponent("" + workActivitySendingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferRequestHeaderListByWorkActivitySendingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferRequestHeaderListByWorkActivitySendingId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferHeaderRequestDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferHeaderRequestDto[]>;
        }));
    }

    protected processGetTransferRequestHeaderListByWorkActivitySendingId(response: HttpResponseBase): Observable<TransferHeaderRequestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransferHeaderRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferHeaderRequestDto[]>(null as any);
    }

    /**
     * @param workActivityReceivingId (optional) 
     * @return Success
     */
    getTransferRequestHeaderListByWorkActivityReceivingId(workActivityReceivingId: number | undefined): Observable<TransferHeaderRequestDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferRequestHeaderListByWorkActivityReceivingId?";
        if (workActivityReceivingId === null)
            throw new Error("The parameter 'workActivityReceivingId' cannot be null.");
        else if (workActivityReceivingId !== undefined)
            url_ += "workActivityReceivingId=" + encodeURIComponent("" + workActivityReceivingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferRequestHeaderListByWorkActivityReceivingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferRequestHeaderListByWorkActivityReceivingId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferHeaderRequestDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferHeaderRequestDto[]>;
        }));
    }

    protected processGetTransferRequestHeaderListByWorkActivityReceivingId(response: HttpResponseBase): Observable<TransferHeaderRequestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransferHeaderRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferHeaderRequestDto[]>(null as any);
    }

    /**
     * @param workActivitySendingId (optional) 
     * @return Success
     */
    getTransferRequestDetailListByWorkActivitySendingId(workActivitySendingId: number | undefined): Observable<TransferRequestDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferRequestDetailListByWorkActivitySendingId?";
        if (workActivitySendingId === null)
            throw new Error("The parameter 'workActivitySendingId' cannot be null.");
        else if (workActivitySendingId !== undefined)
            url_ += "workActivitySendingId=" + encodeURIComponent("" + workActivitySendingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferRequestDetailListByWorkActivitySendingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferRequestDetailListByWorkActivitySendingId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferRequestDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferRequestDetailDto[]>;
        }));
    }

    protected processGetTransferRequestDetailListByWorkActivitySendingId(response: HttpResponseBase): Observable<TransferRequestDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransferRequestDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferRequestDetailDto[]>(null as any);
    }

    /**
     * @param workActivityReceivingId (optional) 
     * @return Success
     */
    getTransferRequestDetailListByWorkActivityReceivingId(workActivityReceivingId: number | undefined): Observable<TransferRequestDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferRequestDetailListByWorkActivityReceivingId?";
        if (workActivityReceivingId === null)
            throw new Error("The parameter 'workActivityReceivingId' cannot be null.");
        else if (workActivityReceivingId !== undefined)
            url_ += "workActivityReceivingId=" + encodeURIComponent("" + workActivityReceivingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferRequestDetailListByWorkActivityReceivingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferRequestDetailListByWorkActivityReceivingId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferRequestDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferRequestDetailDto[]>;
        }));
    }

    protected processGetTransferRequestDetailListByWorkActivityReceivingId(response: HttpResponseBase): Observable<TransferRequestDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransferRequestDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferRequestDetailDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    finishTransferRequestHeaderForShipping(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/FinishTransferRequestHeaderForShipping?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishTransferRequestHeaderForShipping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishTransferRequestHeaderForShipping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishTransferRequestHeaderForShipping(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param actionId (optional) 
     * @param productId (optional) 
     * @param quantity (optional) 
     * @param allowOverload (optional) 
     * @param serialLot (optional) 
     * @param containerCount (optional) 
     * @return Success
     */
    updateTransferRequestControlAddQuantity(actionId: number | undefined, productId: number | undefined, quantity: number | undefined, allowOverload: boolean | undefined, serialLot: string | null | undefined, containerCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/UpdateTransferRequestControlAddQuantity?";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (allowOverload === null)
            throw new Error("The parameter 'allowOverload' cannot be null.");
        else if (allowOverload !== undefined)
            url_ += "allowOverload=" + encodeURIComponent("" + allowOverload) + "&";
        if (serialLot !== undefined && serialLot !== null)
            url_ += "serialLot=" + encodeURIComponent("" + serialLot) + "&";
        if (containerCount === null)
            throw new Error("The parameter 'containerCount' cannot be null.");
        else if (containerCount !== undefined)
            url_ += "containerCount=" + encodeURIComponent("" + containerCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTransferRequestControlAddQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTransferRequestControlAddQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTransferRequestControlAddQuantity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param actionId (optional) 
     * @param productId (optional) 
     * @param quantity (optional) 
     * @param shelfId (optional) 
     * @param containerId (optional) 
     * @param crossDockId (optional) 
     * @return Success
     */
    updateTransferRequestPlacementAddQuantity(actionId: number | undefined, productId: number | undefined, quantity: number | undefined, shelfId: number | undefined, containerId: number | undefined, crossDockId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/UpdateTransferRequestPlacementAddQuantity?";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (containerId === null)
            throw new Error("The parameter 'containerId' cannot be null.");
        else if (containerId !== undefined)
            url_ += "containerId=" + encodeURIComponent("" + containerId) + "&";
        if (crossDockId === null)
            throw new Error("The parameter 'crossDockId' cannot be null.");
        else if (crossDockId !== undefined)
            url_ += "crossDockId=" + encodeURIComponent("" + crossDockId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTransferRequestPlacementAddQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTransferRequestPlacementAddQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTransferRequestPlacementAddQuantity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getTransferRequestReceivingWorkActivityListForPdaControl(companyId: number | undefined, warehouseId: number | undefined): Observable<WorkActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferRequestReceivingWorkActivityListForPdaControl?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferRequestReceivingWorkActivityListForPdaControl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferRequestReceivingWorkActivityListForPdaControl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto[]>;
        }));
    }

    protected processGetTransferRequestReceivingWorkActivityListForPdaControl(response: HttpResponseBase): Observable<WorkActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getTransferRequestReceivingWorkActivityListForPdaPlacement(companyId: number | undefined, warehouseId: number | undefined): Observable<WorkActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferRequestReceivingWorkActivityListForPdaPlacement?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferRequestReceivingWorkActivityListForPdaPlacement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferRequestReceivingWorkActivityListForPdaPlacement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto[]>;
        }));
    }

    protected processGetTransferRequestReceivingWorkActivityListForPdaPlacement(response: HttpResponseBase): Observable<WorkActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto[]>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getTransferRequestDetailListForPdaReceiving(activityId: number | undefined): Observable<TransferRequestDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferRequestDetailListForPdaReceiving?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferRequestDetailListForPdaReceiving(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferRequestDetailListForPdaReceiving(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferRequestDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferRequestDetailDto[]>;
        }));
    }

    protected processGetTransferRequestDetailListForPdaReceiving(response: HttpResponseBase): Observable<TransferRequestDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransferRequestDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferRequestDetailDto[]>(null as any);
    }

    /**
     * @param actionId (optional) 
     * @param productId (optional) 
     * @return Success
     */
    getTransferRequestDetailQuantityWaitingForPlacement(actionId: number | undefined, productId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferRequestDetailQuantityWaitingForPlacement?";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferRequestDetailQuantityWaitingForPlacement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferRequestDetailQuantityWaitingForPlacement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTransferRequestDetailQuantityWaitingForPlacement(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    finishTransferRequestHeaderForReceiving(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/FinishTransferRequestHeaderForReceiving?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishTransferRequestHeaderForReceiving(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishTransferRequestHeaderForReceiving(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishTransferRequestHeaderForReceiving(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getTransferDetailPickingListForPda(workActivityId: number | undefined): Observable<TransferPickingDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferDetailPickingListForPda?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferDetailPickingListForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferDetailPickingListForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferPickingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferPickingDto>;
        }));
    }

    protected processGetTransferDetailPickingListForPda(response: HttpResponseBase): Observable<TransferPickingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferPickingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferPickingDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param transferRequestHeaderId (optional) 
     * @return Success
     */
    createWorkActivityTransferRequestHeaderForReceiving(companyId: number | undefined, warehouseId: number | undefined, transferRequestHeaderId: number | undefined): Observable<TransferHeaderRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateWorkActivityTransferRequestHeaderForReceiving?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (transferRequestHeaderId === null)
            throw new Error("The parameter 'transferRequestHeaderId' cannot be null.");
        else if (transferRequestHeaderId !== undefined)
            url_ += "transferRequestHeaderId=" + encodeURIComponent("" + transferRequestHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkActivityTransferRequestHeaderForReceiving(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkActivityTransferRequestHeaderForReceiving(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferHeaderRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferHeaderRequestDto>;
        }));
    }

    protected processCreateWorkActivityTransferRequestHeaderForReceiving(response: HttpResponseBase): Observable<TransferHeaderRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferHeaderRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferHeaderRequestDto>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getTransferRequestDetailListForPda(workActivityId: number | undefined): Observable<TransferRequestDetailPdaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferRequestDetailListForPda?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferRequestDetailListForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferRequestDetailListForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferRequestDetailPdaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferRequestDetailPdaDto[]>;
        }));
    }

    protected processGetTransferRequestDetailListForPda(response: HttpResponseBase): Observable<TransferRequestDetailPdaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransferRequestDetailPdaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferRequestDetailPdaDto[]>(null as any);
    }

    /**
     * @param workActionId (optional) 
     * @return Success
     */
    checkTransferRequestDetailNeedPickingByActionId(workActionId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Work/CheckTransferRequestDetailNeedPickingByActionId?";
        if (workActionId === null)
            throw new Error("The parameter 'workActionId' cannot be null.");
        else if (workActionId !== undefined)
            url_ += "workActionId=" + encodeURIComponent("" + workActionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckTransferRequestDetailNeedPickingByActionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckTransferRequestDetailNeedPickingByActionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckTransferRequestDetailNeedPickingByActionId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getCancelTransferPlacementWorkActivityListForPda(companyId: number | undefined, warehouseId: number | undefined): Observable<WorkActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetCancelTransferPlacementWorkActivityListForPda?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCancelTransferPlacementWorkActivityListForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCancelTransferPlacementWorkActivityListForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto[]>;
        }));
    }

    protected processGetCancelTransferPlacementWorkActivityListForPda(response: HttpResponseBase): Observable<WorkActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto[]>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getTransferCancelReplacementList(workActivityId: number | undefined): Observable<OrderCancelReplacementDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferCancelReplacementList?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferCancelReplacementList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferCancelReplacementList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderCancelReplacementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderCancelReplacementDto[]>;
        }));
    }

    protected processGetTransferCancelReplacementList(response: HttpResponseBase): Observable<OrderCancelReplacementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderCancelReplacementDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderCancelReplacementDto[]>(null as any);
    }

    /**
     * @param actionId (optional) 
     * @param productId (optional) 
     * @param quantity (optional) 
     * @param shelfId (optional) 
     * @param containerId (optional) 
     * @return Success
     */
    updateTransferReplacementAddQuantityForPda(actionId: number | undefined, productId: number | undefined, quantity: number | undefined, shelfId: number | undefined, containerId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/UpdateTransferReplacementAddQuantityForPda?";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (containerId === null)
            throw new Error("The parameter 'containerId' cannot be null.");
        else if (containerId !== undefined)
            url_ += "containerId=" + encodeURIComponent("" + containerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTransferReplacementAddQuantityForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTransferReplacementAddQuantityForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTransferReplacementAddQuantityForPda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param actionId (optional) 
     * @param productId (optional) 
     * @return Success
     */
    getTransferDetailQuantityWaitingForPlacement(actionId: number | undefined, productId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferDetailQuantityWaitingForPlacement?";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferDetailQuantityWaitingForPlacement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferDetailQuantityWaitingForPlacement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTransferDetailQuantityWaitingForPlacement(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param transferRequestDetailId (optional) 
     * @return Success
     */
    getTransferRequestDetail(transferRequestDetailId: number | undefined): Observable<TransferRequestDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferRequestDetail?";
        if (transferRequestDetailId === null)
            throw new Error("The parameter 'transferRequestDetailId' cannot be null.");
        else if (transferRequestDetailId !== undefined)
            url_ += "transferRequestDetailId=" + encodeURIComponent("" + transferRequestDetailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferRequestDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferRequestDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferRequestDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferRequestDetailDto>;
        }));
    }

    protected processGetTransferRequestDetail(response: HttpResponseBase): Observable<TransferRequestDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferRequestDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferRequestDetailDto>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getTransferDetailControlListForPda(activityId: number | undefined): Observable<TransferRequestDetailPdaAllDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferDetailControlListForPda?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferDetailControlListForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferDetailControlListForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferRequestDetailPdaAllDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferRequestDetailPdaAllDto>;
        }));
    }

    protected processGetTransferDetailControlListForPda(response: HttpResponseBase): Observable<TransferRequestDetailPdaAllDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferRequestDetailPdaAllDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferRequestDetailPdaAllDto>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getTransferRequestDetailListForPdaControl(activityId: number | undefined): Observable<TransferRequestDetailPdaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferRequestDetailListForPdaControl?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferRequestDetailListForPdaControl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferRequestDetailListForPdaControl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferRequestDetailPdaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferRequestDetailPdaDto[]>;
        }));
    }

    protected processGetTransferRequestDetailListForPdaControl(response: HttpResponseBase): Observable<TransferRequestDetailPdaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransferRequestDetailPdaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferRequestDetailPdaDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProductShelfWorkActivity(body: ProductShelfWorkActivityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateProductShelfWorkActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProductShelfWorkActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductShelfWorkActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateProductShelfWorkActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProductShelfWorkActivityForPda(body: ProductShelfWorkActivityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateProductShelfWorkActivityForPda";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProductShelfWorkActivityForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductShelfWorkActivityForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateProductShelfWorkActivityForPda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProductShelfWorkActivity(body: ProductShelfWorkActivityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/UpdateProductShelfWorkActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProductShelfWorkActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductShelfWorkActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProductShelfWorkActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getUnfinishedReplenishmentWorkActivityList(): Observable<WorkActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetUnfinishedReplenishmentWorkActivityList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnfinishedReplenishmentWorkActivityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnfinishedReplenishmentWorkActivityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto[]>;
        }));
    }

    protected processGetUnfinishedReplenishmentWorkActivityList(response: HttpResponseBase): Observable<WorkActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityTypeId (optional) 
     * @param creationDate (optional) 
     * @param workActivityStatusId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param workActivityCode (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReplenishmentWorkActivityListPaged(companyId: number | undefined, warehouseId: number | undefined, workActivityTypeId: number | undefined, creationDate: Date | null | undefined, workActivityStatusId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, workActivityCode: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WorkActivityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetReplenishmentWorkActivityListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityTypeId === null)
            throw new Error("The parameter 'workActivityTypeId' cannot be null.");
        else if (workActivityTypeId !== undefined)
            url_ += "WorkActivityTypeId=" + encodeURIComponent("" + workActivityTypeId) + "&";
        if (creationDate !== undefined && creationDate !== null)
            url_ += "CreationDate=" + encodeURIComponent(creationDate ? "" + creationDate.toISOString() : "") + "&";
        if (workActivityStatusId === null)
            throw new Error("The parameter 'workActivityStatusId' cannot be null.");
        else if (workActivityStatusId !== undefined)
            url_ += "WorkActivityStatusId=" + encodeURIComponent("" + workActivityStatusId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (workActivityCode !== undefined && workActivityCode !== null)
            url_ += "WorkActivityCode=" + encodeURIComponent("" + workActivityCode) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReplenishmentWorkActivityListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReplenishmentWorkActivityListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDtoPagedResultDto>;
        }));
    }

    protected processGetReplenishmentWorkActivityListPaged(response: HttpResponseBase): Observable<WorkActivityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActivityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getUnfinishedReplenishmentWorkActivityListForPda(): Observable<WorkActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetUnfinishedReplenishmentWorkActivityListForPda";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnfinishedReplenishmentWorkActivityListForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnfinishedReplenishmentWorkActivityListForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto[]>;
        }));
    }

    protected processGetUnfinishedReplenishmentWorkActivityListForPda(response: HttpResponseBase): Observable<WorkActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto[]>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @param assignedUserId (optional) 
     * @param replenishmentShelfId (optional) 
     * @return Success
     */
    createReplenishmentWorkAction(workActivityId: number | undefined, assignedUserId: number | undefined, replenishmentShelfId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateReplenishmentWorkAction?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (assignedUserId === null)
            throw new Error("The parameter 'assignedUserId' cannot be null.");
        else if (assignedUserId !== undefined)
            url_ += "assignedUserId=" + encodeURIComponent("" + assignedUserId) + "&";
        if (replenishmentShelfId === null)
            throw new Error("The parameter 'replenishmentShelfId' cannot be null.");
        else if (replenishmentShelfId !== undefined)
            url_ += "replenishmentShelfId=" + encodeURIComponent("" + replenishmentShelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReplenishmentWorkAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReplenishmentWorkAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateReplenishmentWorkAction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getWorkActitivtyDetailToCollectProductForReplenishment(activityId: number | undefined): Observable<WorkActivityDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActitivtyDetailToCollectProductForReplenishment?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActitivtyDetailToCollectProductForReplenishment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActitivtyDetailToCollectProductForReplenishment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDetailDto[]>;
        }));
    }

    protected processGetWorkActitivtyDetailToCollectProductForReplenishment(response: HttpResponseBase): Observable<WorkActivityDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDetailDto[]>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getWorkActivityDetailToCollectProductForReplenishmentForPda(activityId: number | undefined): Observable<WorkActivityDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActivityDetailToCollectProductForReplenishmentForPda?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActivityDetailToCollectProductForReplenishmentForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActivityDetailToCollectProductForReplenishmentForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDetailDto[]>;
        }));
    }

    protected processGetWorkActivityDetailToCollectProductForReplenishmentForPda(response: HttpResponseBase): Observable<WorkActivityDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDetailDto[]>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    finishProductShelfWorkActivity(workActivityId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/FinishProductShelfWorkActivity?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishProductShelfWorkActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishProductShelfWorkActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishProductShelfWorkActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getReplenishmentWorkActivityDetailListByWorkActivityId(workActivityId: number | undefined): Observable<WorkActivityDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetReplenishmentWorkActivityDetailListByWorkActivityId?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReplenishmentWorkActivityDetailListByWorkActivityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReplenishmentWorkActivityDetailListByWorkActivityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDetailDto[]>;
        }));
    }

    protected processGetReplenishmentWorkActivityDetailListByWorkActivityId(response: HttpResponseBase): Observable<WorkActivityDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDetailDto[]>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getReplenishmentWorkActionList(workActivityId: number | undefined): Observable<WorkActionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetReplenishmentWorkActionList?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReplenishmentWorkActionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReplenishmentWorkActionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionDto[]>;
        }));
    }

    protected processGetReplenishmentWorkActionList(response: HttpResponseBase): Observable<WorkActionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionDto[]>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getReplenishmentWorkActionProcessListByWorkActivityId(workActivityId: number | undefined): Observable<WorkActionProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetReplenishmentWorkActionProcessListByWorkActivityId?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReplenishmentWorkActionProcessListByWorkActivityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReplenishmentWorkActionProcessListByWorkActivityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionProcessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionProcessDto[]>;
        }));
    }

    protected processGetReplenishmentWorkActionProcessListByWorkActivityId(response: HttpResponseBase): Observable<WorkActionProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActionProcessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionProcessDto[]>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getIfWorkActivityAssignedToUser(workActivityId: number | undefined): Observable<WorkActionDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetIfWorkActivityAssignedToUser?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIfWorkActivityAssignedToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIfWorkActivityAssignedToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionDto>;
        }));
    }

    protected processGetIfWorkActivityAssignedToUser(response: HttpResponseBase): Observable<WorkActionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionDto>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getReplenishmentWorkActionProcessDistinctProduct(workActivityId: number | undefined): Observable<WorkActionProcessReplenishmentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetReplenishmentWorkActionProcessDistinctProduct?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReplenishmentWorkActionProcessDistinctProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReplenishmentWorkActionProcessDistinctProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionProcessReplenishmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionProcessReplenishmentDto[]>;
        }));
    }

    protected processGetReplenishmentWorkActionProcessDistinctProduct(response: HttpResponseBase): Observable<WorkActionProcessReplenishmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActionProcessReplenishmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionProcessReplenishmentDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityCode (optional) 
     * @param workActivityStatusId (optional) 
     * @param varietyShelfId (optional) 
     * @param productId (optional) 
     * @param processUserId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReplenishmentMovementListPaged(companyId: number | undefined, warehouseId: number | undefined, workActivityCode: string | null | undefined, workActivityStatusId: number | undefined, varietyShelfId: number | undefined, productId: number | undefined, processUserId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WorkActionProcessReplenishmentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetReplenishmentMovementListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityCode !== undefined && workActivityCode !== null)
            url_ += "WorkActivityCode=" + encodeURIComponent("" + workActivityCode) + "&";
        if (workActivityStatusId === null)
            throw new Error("The parameter 'workActivityStatusId' cannot be null.");
        else if (workActivityStatusId !== undefined)
            url_ += "WorkActivityStatusId=" + encodeURIComponent("" + workActivityStatusId) + "&";
        if (varietyShelfId === null)
            throw new Error("The parameter 'varietyShelfId' cannot be null.");
        else if (varietyShelfId !== undefined)
            url_ += "VarietyShelfId=" + encodeURIComponent("" + varietyShelfId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (processUserId === null)
            throw new Error("The parameter 'processUserId' cannot be null.");
        else if (processUserId !== undefined)
            url_ += "ProcessUserId=" + encodeURIComponent("" + processUserId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReplenishmentMovementListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReplenishmentMovementListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionProcessReplenishmentDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionProcessReplenishmentDtoPagedResultDto>;
        }));
    }

    protected processGetReplenishmentMovementListPaged(response: HttpResponseBase): Observable<WorkActionProcessReplenishmentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActionProcessReplenishmentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionProcessReplenishmentDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityTypeId (optional) 
     * @param creationDate (optional) 
     * @param startDate (optional) 
     * @param finishDate (optional) 
     * @param clientId (optional) 
     * @return Success
     */
    getWorkActivityList(companyId: number | undefined, warehouseId: number | undefined, workActivityTypeId: number | undefined, creationDate: Date | null | undefined, startDate: Date | null | undefined, finishDate: Date | null | undefined, clientId: number | undefined): Observable<WorkActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActivityList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityTypeId === null)
            throw new Error("The parameter 'workActivityTypeId' cannot be null.");
        else if (workActivityTypeId !== undefined)
            url_ += "workActivityTypeId=" + encodeURIComponent("" + workActivityTypeId) + "&";
        if (creationDate !== undefined && creationDate !== null)
            url_ += "creationDate=" + encodeURIComponent(creationDate ? "" + creationDate.toISOString() : "") + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (finishDate !== undefined && finishDate !== null)
            url_ += "finishDate=" + encodeURIComponent(finishDate ? "" + finishDate.toISOString() : "") + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActivityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActivityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto[]>;
        }));
    }

    protected processGetWorkActivityList(response: HttpResponseBase): Observable<WorkActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityTypeId (optional) 
     * @param creationDate (optional) 
     * @param startDate (optional) 
     * @param finishDate (optional) 
     * @param status (optional) 
     * @param clientId (optional) 
     * @param code (optional) 
     * @param sortActive (optional) 
     * @param sortDirection (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWorkActivityListPaged(companyId: number | undefined, warehouseId: number | undefined, workActivityTypeId: number | undefined, creationDate: Date | null | undefined, startDate: Date | null | undefined, finishDate: Date | null | undefined, status: number | undefined, clientId: number | undefined, code: string | null | undefined, sortActive: string | null | undefined, sortDirection: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WorkActivityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActivityListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityTypeId === null)
            throw new Error("The parameter 'workActivityTypeId' cannot be null.");
        else if (workActivityTypeId !== undefined)
            url_ += "WorkActivityTypeId=" + encodeURIComponent("" + workActivityTypeId) + "&";
        if (creationDate !== undefined && creationDate !== null)
            url_ += "CreationDate=" + encodeURIComponent(creationDate ? "" + creationDate.toISOString() : "") + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (finishDate !== undefined && finishDate !== null)
            url_ += "FinishDate=" + encodeURIComponent(finishDate ? "" + finishDate.toISOString() : "") + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (sortActive !== undefined && sortActive !== null)
            url_ += "sortActive=" + encodeURIComponent("" + sortActive) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActivityListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActivityListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDtoPagedResultDto>;
        }));
    }

    protected processGetWorkActivityListPaged(response: HttpResponseBase): Observable<WorkActivityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActivityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getWorkActivityListAll(): Observable<WorkActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActivityListAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActivityListAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActivityListAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto[]>;
        }));
    }

    protected processGetWorkActivityListAll(response: HttpResponseBase): Observable<WorkActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto[]>(null as any);
    }

    /**
     * @param activityTypeId (optional) 
     * @param status (optional) 
     * @return Success
     */
    getWorkActivityListByActionStatus(activityTypeId: number | undefined, status: number | undefined): Observable<WorkActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActivityListByActionStatus?";
        if (activityTypeId === null)
            throw new Error("The parameter 'activityTypeId' cannot be null.");
        else if (activityTypeId !== undefined)
            url_ += "activityTypeId=" + encodeURIComponent("" + activityTypeId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActivityListByActionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActivityListByActionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto[]>;
        }));
    }

    protected processGetWorkActivityListByActionStatus(response: HttpResponseBase): Observable<WorkActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getReceivingWorkActivityListForPdaControl(companyId: number | undefined, warehouseId: number | undefined): Observable<WorkActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetReceivingWorkActivityListForPdaControl?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceivingWorkActivityListForPdaControl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceivingWorkActivityListForPdaControl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto[]>;
        }));
    }

    protected processGetReceivingWorkActivityListForPdaControl(response: HttpResponseBase): Observable<WorkActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getReceivingWorkActivityListForPdaControlNew(companyId: number | undefined, warehouseId: number | undefined): Observable<WorkActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetReceivingWorkActivityListForPdaControlNew?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceivingWorkActivityListForPdaControlNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceivingWorkActivityListForPdaControlNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto[]>;
        }));
    }

    protected processGetReceivingWorkActivityListForPdaControlNew(response: HttpResponseBase): Observable<WorkActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getReceivingWorkActivityListForPdaPlacement(companyId: number | undefined, warehouseId: number | undefined): Observable<WorkActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetReceivingWorkActivityListForPdaPlacement?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceivingWorkActivityListForPdaPlacement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceivingWorkActivityListForPdaPlacement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto[]>;
        }));
    }

    protected processGetReceivingWorkActivityListForPdaPlacement(response: HttpResponseBase): Observable<WorkActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getShippingWorkActivityListForPdaPicking(companyId: number | undefined, warehouseId: number | undefined): Observable<WorkActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetShippingWorkActivityListForPdaPicking?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShippingWorkActivityListForPdaPicking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShippingWorkActivityListForPdaPicking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto[]>;
        }));
    }

    protected processGetShippingWorkActivityListForPdaPicking(response: HttpResponseBase): Observable<WorkActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getStockTakingWorkActivityListForPda(companyId: number | undefined, warehouseId: number | undefined): Observable<WorkActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetStockTakingWorkActivityListForPda?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingWorkActivityListForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingWorkActivityListForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto[]>;
        }));
    }

    protected processGetStockTakingWorkActivityListForPda(response: HttpResponseBase): Observable<WorkActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getStockTakingWorkActivityList(companyId: number | undefined, warehouseId: number | undefined): Observable<WorkActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetStockTakingWorkActivityList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTakingWorkActivityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTakingWorkActivityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto[]>;
        }));
    }

    protected processGetStockTakingWorkActivityList(response: HttpResponseBase): Observable<WorkActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityTypeId (optional) 
     * @param creationDate (optional) 
     * @param workActivityStatusId (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param workActivityCode (optional) 
     * @param sortActive (optional) 
     * @param sortDirection (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCancelOrderPlacementWorkActivityList(companyId: number | undefined, warehouseId: number | undefined, workActivityTypeId: number | undefined, creationDate: Date | null | undefined, workActivityStatusId: number | undefined, startTime: Date | null | undefined, endTime: Date | null | undefined, workActivityCode: string | null | undefined, sortActive: string | null | undefined, sortDirection: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WorkActivityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetCancelOrderPlacementWorkActivityList?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityTypeId === null)
            throw new Error("The parameter 'workActivityTypeId' cannot be null.");
        else if (workActivityTypeId !== undefined)
            url_ += "WorkActivityTypeId=" + encodeURIComponent("" + workActivityTypeId) + "&";
        if (creationDate !== undefined && creationDate !== null)
            url_ += "CreationDate=" + encodeURIComponent(creationDate ? "" + creationDate.toISOString() : "") + "&";
        if (workActivityStatusId === null)
            throw new Error("The parameter 'workActivityStatusId' cannot be null.");
        else if (workActivityStatusId !== undefined)
            url_ += "WorkActivityStatusId=" + encodeURIComponent("" + workActivityStatusId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (workActivityCode !== undefined && workActivityCode !== null)
            url_ += "WorkActivityCode=" + encodeURIComponent("" + workActivityCode) + "&";
        if (sortActive !== undefined && sortActive !== null)
            url_ += "sortActive=" + encodeURIComponent("" + sortActive) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCancelOrderPlacementWorkActivityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCancelOrderPlacementWorkActivityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDtoPagedResultDto>;
        }));
    }

    protected processGetCancelOrderPlacementWorkActivityList(response: HttpResponseBase): Observable<WorkActivityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActivityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDtoPagedResultDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    getCancelOrderPlacementWorkActivityListFroPda(companyId: number | undefined, warehouseId: number | undefined): Observable<WorkActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetCancelOrderPlacementWorkActivityListFroPda?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCancelOrderPlacementWorkActivityListFroPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCancelOrderPlacementWorkActivityListFroPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto[]>;
        }));
    }

    protected processGetCancelOrderPlacementWorkActivityListFroPda(response: HttpResponseBase): Observable<WorkActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityTypeId (optional) 
     * @param creationDate (optional) 
     * @param workActivityStatusId (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param workActivityCode (optional) 
     * @param sortActive (optional) 
     * @param sortDirection (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOrderWorkActivityListPaged(companyId: number | undefined, warehouseId: number | undefined, workActivityTypeId: number | undefined, creationDate: Date | null | undefined, workActivityStatusId: number | undefined, startTime: Date | null | undefined, endTime: Date | null | undefined, workActivityCode: string | null | undefined, sortActive: string | null | undefined, sortDirection: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WorkActivityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetOrderWorkActivityListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityTypeId === null)
            throw new Error("The parameter 'workActivityTypeId' cannot be null.");
        else if (workActivityTypeId !== undefined)
            url_ += "WorkActivityTypeId=" + encodeURIComponent("" + workActivityTypeId) + "&";
        if (creationDate !== undefined && creationDate !== null)
            url_ += "CreationDate=" + encodeURIComponent(creationDate ? "" + creationDate.toISOString() : "") + "&";
        if (workActivityStatusId === null)
            throw new Error("The parameter 'workActivityStatusId' cannot be null.");
        else if (workActivityStatusId !== undefined)
            url_ += "WorkActivityStatusId=" + encodeURIComponent("" + workActivityStatusId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (workActivityCode !== undefined && workActivityCode !== null)
            url_ += "WorkActivityCode=" + encodeURIComponent("" + workActivityCode) + "&";
        if (sortActive !== undefined && sortActive !== null)
            url_ += "sortActive=" + encodeURIComponent("" + sortActive) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderWorkActivityListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderWorkActivityListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDtoPagedResultDto>;
        }));
    }

    protected processGetOrderWorkActivityListPaged(response: HttpResponseBase): Observable<WorkActivityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActivityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getWorkActivity(id: number | undefined): Observable<WorkActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActivity?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto>;
        }));
    }

    protected processGetWorkActivity(response: HttpResponseBase): Observable<WorkActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkActivity(body: WorkActivityDto | undefined): Observable<WorkActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/UpdateWorkActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto>;
        }));
    }

    protected processUpdateWorkActivity(response: HttpResponseBase): Observable<WorkActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto>(null as any);
    }

    /**
     * @param activityTypeCode (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    createWorkActivity(activityTypeCode: string | null | undefined, companyId: number | undefined, warehouseId: number | undefined): Observable<WorkActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateWorkActivity?";
        if (activityTypeCode !== undefined && activityTypeCode !== null)
            url_ += "activityTypeCode=" + encodeURIComponent("" + activityTypeCode) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto>;
        }));
    }

    protected processCreateWorkActivity(response: HttpResponseBase): Observable<WorkActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    finishWorkActivity(activityId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/FinishWorkActivity?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishWorkActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishWorkActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishWorkActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    checkWorkActivityIsStarted(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Work/CheckWorkActivityIsStarted?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckWorkActivityIsStarted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckWorkActivityIsStarted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckWorkActivityIsStarted(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    checkWorkActivityIsReadyToFinish(activityId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Work/CheckWorkActivityIsReadyToFinish?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckWorkActivityIsReadyToFinish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckWorkActivityIsReadyToFinish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckWorkActivityIsReadyToFinish(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isLocked (optional) 
     * @return Success
     */
    updateWorkActivityLocked(id: number | undefined, isLocked: boolean | undefined): Observable<WorkActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/UpdateWorkActivityLocked?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isLocked === null)
            throw new Error("The parameter 'isLocked' cannot be null.");
        else if (isLocked !== undefined)
            url_ += "isLocked=" + encodeURIComponent("" + isLocked) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkActivityLocked(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkActivityLocked(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto>;
        }));
    }

    protected processUpdateWorkActivityLocked(response: HttpResponseBase): Observable<WorkActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isLocked (optional) 
     * @return Success
     */
    updateWorkActivityAllowAddDetail(id: number | undefined, isLocked: boolean | undefined): Observable<WorkActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/UpdateWorkActivityAllowAddDetail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isLocked === null)
            throw new Error("The parameter 'isLocked' cannot be null.");
        else if (isLocked !== undefined)
            url_ += "isLocked=" + encodeURIComponent("" + isLocked) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkActivityAllowAddDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkActivityAllowAddDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto>;
        }));
    }

    protected processUpdateWorkActivityAllowAddDetail(response: HttpResponseBase): Observable<WorkActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteWorkActivity(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/DeleteWorkActivity?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWorkActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWorkActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWorkActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isWillBeContinue (optional) 
     * @return Success
     */
    updateWorkActivityWillBeContinue(id: number | undefined, isWillBeContinue: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/UpdateWorkActivityWillBeContinue?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isWillBeContinue === null)
            throw new Error("The parameter 'isWillBeContinue' cannot be null.");
        else if (isWillBeContinue !== undefined)
            url_ += "isWillBeContinue=" + encodeURIComponent("" + isWillBeContinue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkActivityWillBeContinue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkActivityWillBeContinue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateWorkActivityWillBeContinue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getWorkActivityDetailList(activityId: number | undefined): Observable<WorkActivityDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActivityDetailList?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActivityDetailList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActivityDetailList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDetailDto[]>;
        }));
    }

    protected processGetWorkActivityDetailList(response: HttpResponseBase): Observable<WorkActivityDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDetailDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createWorkActivityDetail(body: WorkActivityDetailDto | undefined): Observable<WorkActivityDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateWorkActivityDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkActivityDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkActivityDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDetailDto>;
        }));
    }

    protected processCreateWorkActivityDetail(response: HttpResponseBase): Observable<WorkActivityDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActivityDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createWorkActivityDetailBatchForOrders(body: CreateWorkActivityDetailRequestDto | undefined): Observable<WorkActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateWorkActivityDetailBatchForOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkActivityDetailBatchForOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkActivityDetailBatchForOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto>;
        }));
    }

    protected processCreateWorkActivityDetailBatchForOrders(response: HttpResponseBase): Observable<WorkActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkActivityDetail(body: WorkActivityDetailDto | undefined): Observable<WorkActivityDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/UpdateWorkActivityDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkActivityDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkActivityDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDetailDto>;
        }));
    }

    protected processUpdateWorkActivityDetail(response: HttpResponseBase): Observable<WorkActivityDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActivityDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDetailDto>(null as any);
    }

    /**
     * @param activityDetailId (optional) 
     * @param qtyToAddRemove (optional) 
     * @param checkLimits (optional) 
     * @return Success
     */
    updateWorkActivityDetailProceedQty(activityDetailId: number | undefined, qtyToAddRemove: number | undefined, checkLimits: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/UpdateWorkActivityDetailProceedQty?";
        if (activityDetailId === null)
            throw new Error("The parameter 'activityDetailId' cannot be null.");
        else if (activityDetailId !== undefined)
            url_ += "activityDetailId=" + encodeURIComponent("" + activityDetailId) + "&";
        if (qtyToAddRemove === null)
            throw new Error("The parameter 'qtyToAddRemove' cannot be null.");
        else if (qtyToAddRemove !== undefined)
            url_ += "qtyToAddRemove=" + encodeURIComponent("" + qtyToAddRemove) + "&";
        if (checkLimits === null)
            throw new Error("The parameter 'checkLimits' cannot be null.");
        else if (checkLimits !== undefined)
            url_ += "checkLimits=" + encodeURIComponent("" + checkLimits) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkActivityDetailProceedQty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkActivityDetailProceedQty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateWorkActivityDetailProceedQty(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param wokActivityId (optional) 
     * @param activityDetailId (optional) 
     * @param sourceId (optional) 
     * @param isIntoNewActivity (optional) 
     * @param newActivityId (optional) 
     * @return Success
     */
    splitWorkActivityDetail(wokActivityId: number | undefined, activityDetailId: number | undefined, sourceId: number | undefined, isIntoNewActivity: boolean | undefined, newActivityId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/SplitWorkActivityDetail?";
        if (wokActivityId === null)
            throw new Error("The parameter 'wokActivityId' cannot be null.");
        else if (wokActivityId !== undefined)
            url_ += "wokActivityId=" + encodeURIComponent("" + wokActivityId) + "&";
        if (activityDetailId === null)
            throw new Error("The parameter 'activityDetailId' cannot be null.");
        else if (activityDetailId !== undefined)
            url_ += "activityDetailId=" + encodeURIComponent("" + activityDetailId) + "&";
        if (sourceId === null)
            throw new Error("The parameter 'sourceId' cannot be null.");
        else if (sourceId !== undefined)
            url_ += "sourceId=" + encodeURIComponent("" + sourceId) + "&";
        if (isIntoNewActivity === null)
            throw new Error("The parameter 'isIntoNewActivity' cannot be null.");
        else if (isIntoNewActivity !== undefined)
            url_ += "isIntoNewActivity=" + encodeURIComponent("" + isIntoNewActivity) + "&";
        if (newActivityId === null)
            throw new Error("The parameter 'newActivityId' cannot be null.");
        else if (newActivityId !== undefined)
            url_ += "newActivityId=" + encodeURIComponent("" + newActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSplitWorkActivityDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSplitWorkActivityDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSplitWorkActivityDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @return Success
     */
    splitOrderControlPoint(headerId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/SplitOrderControlPoint?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSplitOrderControlPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSplitOrderControlPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSplitOrderControlPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param wokActivityId (optional) 
     * @param activityDetailId (optional) 
     * @param sourceId (optional) 
     * @return Success
     */
    deleteWorkActivityDetail(wokActivityId: number | undefined, activityDetailId: number | undefined, sourceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/DeleteWorkActivityDetail?";
        if (wokActivityId === null)
            throw new Error("The parameter 'wokActivityId' cannot be null.");
        else if (wokActivityId !== undefined)
            url_ += "wokActivityId=" + encodeURIComponent("" + wokActivityId) + "&";
        if (activityDetailId === null)
            throw new Error("The parameter 'activityDetailId' cannot be null.");
        else if (activityDetailId !== undefined)
            url_ += "activityDetailId=" + encodeURIComponent("" + activityDetailId) + "&";
        if (sourceId === null)
            throw new Error("The parameter 'sourceId' cannot be null.");
        else if (sourceId !== undefined)
            url_ += "sourceId=" + encodeURIComponent("" + sourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWorkActivityDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWorkActivityDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWorkActivityDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getWorkAction(id: number | undefined): Observable<WorkActionDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkAction?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionDto>;
        }));
    }

    protected processGetWorkAction(response: HttpResponseBase): Observable<WorkActionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionDto>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @param actionTypeCode (optional) 
     * @return Success
     */
    createWorkAction(activityId: number | undefined, actionTypeCode: string | null | undefined): Observable<WorkActionDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateWorkAction?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (actionTypeCode !== undefined && actionTypeCode !== null)
            url_ += "actionTypeCode=" + encodeURIComponent("" + actionTypeCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionDto>;
        }));
    }

    protected processCreateWorkAction(response: HttpResponseBase): Observable<WorkActionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionDto>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @param actionTypeCode (optional) 
     * @param startStep (optional) 
     * @return Success
     */
    createWorkActionWithStep(activityId: number | undefined, actionTypeCode: string | null | undefined, startStep: number | undefined): Observable<WorkActionDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateWorkActionWithStep?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (actionTypeCode !== undefined && actionTypeCode !== null)
            url_ += "actionTypeCode=" + encodeURIComponent("" + actionTypeCode) + "&";
        if (startStep === null)
            throw new Error("The parameter 'startStep' cannot be null.");
        else if (startStep !== undefined)
            url_ += "startStep=" + encodeURIComponent("" + startStep) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkActionWithStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkActionWithStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionDto>;
        }));
    }

    protected processCreateWorkActionWithStep(response: HttpResponseBase): Observable<WorkActionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionDto>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @param actionTypeId (optional) 
     * @param processUserId (optional) 
     * @return Success
     */
    createWorkActionWithUser(activityId: number | undefined, actionTypeId: number | undefined, processUserId: number | undefined): Observable<WorkActionDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateWorkActionWithUser?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (actionTypeId === null)
            throw new Error("The parameter 'actionTypeId' cannot be null.");
        else if (actionTypeId !== undefined)
            url_ += "actionTypeId=" + encodeURIComponent("" + actionTypeId) + "&";
        if (processUserId === null)
            throw new Error("The parameter 'processUserId' cannot be null.");
        else if (processUserId !== undefined)
            url_ += "processUserId=" + encodeURIComponent("" + processUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkActionWithUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkActionWithUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionDto>;
        }));
    }

    protected processCreateWorkActionWithUser(response: HttpResponseBase): Observable<WorkActionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionDto>(null as any);
    }

    /**
     * @param actionId (optional) 
     * @return Success
     */
    finishWorkAction(actionId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/FinishWorkAction?";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishWorkAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishWorkAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishWorkAction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param actionId (optional) 
     * @param endStep (optional) 
     * @return Success
     */
    finishWorkActionForStep(actionId: number | undefined, endStep: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/FinishWorkActionForStep?";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        if (endStep === null)
            throw new Error("The parameter 'endStep' cannot be null.");
        else if (endStep !== undefined)
            url_ += "endStep=" + encodeURIComponent("" + endStep) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishWorkActionForStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishWorkActionForStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishWorkActionForStep(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getWorkActionList(activityId: number | undefined): Observable<WorkActionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActionList?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionDto[]>;
        }));
    }

    protected processGetWorkActionList(response: HttpResponseBase): Observable<WorkActionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionDto[]>(null as any);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getWorkActionListForPda(activityId: number | undefined): Observable<WorkActionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActionListForPda?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActionListForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActionListForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionDto[]>;
        }));
    }

    protected processGetWorkActionListForPda(response: HttpResponseBase): Observable<WorkActionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionDto[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getWorkActionListByUserId(userId: number | undefined): Observable<WorkActionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActionListByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActionListByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActionListByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionDto[]>;
        }));
    }

    protected processGetWorkActionListByUserId(response: HttpResponseBase): Observable<WorkActionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionDto[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param waybillId (optional) 
     * @return Success
     */
    getWorkActionListByUserIdAndWaybillId(userId: number | undefined, waybillId: number | undefined): Observable<WorkActionDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActionListByUserIdAndWaybillId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (waybillId === null)
            throw new Error("The parameter 'waybillId' cannot be null.");
        else if (waybillId !== undefined)
            url_ += "waybillId=" + encodeURIComponent("" + waybillId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActionListByUserIdAndWaybillId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActionListByUserIdAndWaybillId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionDto>;
        }));
    }

    protected processGetWorkActionListByUserIdAndWaybillId(response: HttpResponseBase): Observable<WorkActionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param workActivityId (optional) 
     * @param actionTypeId (optional) 
     * @return Success
     */
    getWorkActionForPda(userId: number | undefined, workActivityId: number | undefined, actionTypeId: number | undefined): Observable<WorkActionDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActionForPda?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (actionTypeId === null)
            throw new Error("The parameter 'actionTypeId' cannot be null.");
        else if (actionTypeId !== undefined)
            url_ += "actionTypeId=" + encodeURIComponent("" + actionTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActionForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActionForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionDto>;
        }));
    }

    protected processGetWorkActionForPda(response: HttpResponseBase): Observable<WorkActionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionDto>(null as any);
    }

    /**
     * @return Success
     */
    getWorkActionTypeListAll(): Observable<WorkActionType[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActionTypeListAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActionTypeListAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActionTypeListAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionType[]>;
        }));
    }

    protected processGetWorkActionTypeListAll(response: HttpResponseBase): Observable<WorkActionType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActionType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionType[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param workActivityType (optional) 
     * @param workActionType (optional) 
     * @return Success
     */
    getWorkActionActiveForPda(companyId: number | undefined, warehouseId: number | undefined, workActivityType: string | null | undefined, workActionType: string | null | undefined): Observable<WorkActionDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActionActiveForPda?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (workActivityType !== undefined && workActivityType !== null)
            url_ += "workActivityType=" + encodeURIComponent("" + workActivityType) + "&";
        if (workActionType !== undefined && workActionType !== null)
            url_ += "workActionType=" + encodeURIComponent("" + workActionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActionActiveForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActionActiveForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionDto>;
        }));
    }

    protected processGetWorkActionActiveForPda(response: HttpResponseBase): Observable<WorkActionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param waybillId (optional) 
     * @return Success
     */
    getWorkActionListByUserIdAndWaybillIdForPlacement(userId: number | undefined, waybillId: number | undefined): Observable<WorkActionDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActionListByUserIdAndWaybillIdForPlacement?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (waybillId === null)
            throw new Error("The parameter 'waybillId' cannot be null.");
        else if (waybillId !== undefined)
            url_ += "waybillId=" + encodeURIComponent("" + waybillId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActionListByUserIdAndWaybillIdForPlacement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActionListByUserIdAndWaybillIdForPlacement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionDto>;
        }));
    }

    protected processGetWorkActionListByUserIdAndWaybillIdForPlacement(response: HttpResponseBase): Observable<WorkActionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionDto>(null as any);
    }

    /**
     * @return Success
     */
    getWorkActionListForOperatorReport(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActionListForOperatorReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActionListForOperatorReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActionListForOperatorReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetWorkActionListForOperatorReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param actionId (optional) 
     * @return Success
     */
    getWorkActionDetailList(actionId: number | undefined): Observable<WorkActionDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActionDetailList?";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActionDetailList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActionDetailList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionDetailDto[]>;
        }));
    }

    protected processGetWorkActionDetailList(response: HttpResponseBase): Observable<WorkActionDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActionDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionDetailDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertWorkActionDetail(body: WorkActionDetailDto | undefined): Observable<WorkActionDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/InsertWorkActionDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertWorkActionDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertWorkActionDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionDetailDto>;
        }));
    }

    protected processInsertWorkActionDetail(response: HttpResponseBase): Observable<WorkActionDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActionDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkActionDetail(body: WorkActionDetailDto | undefined): Observable<WorkActionDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/UpdateWorkActionDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkActionDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkActionDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionDetailDto>;
        }));
    }

    protected processUpdateWorkActionDetail(response: HttpResponseBase): Observable<WorkActionDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActionDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionDetailDto>(null as any);
    }

    /**
     * @return Success
     */
    getWorkActivityTypeList(): Observable<WorkActivityType[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActivityTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActivityTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActivityTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityType[]>;
        }));
    }

    protected processGetWorkActivityTypeList(response: HttpResponseBase): Observable<WorkActivityType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityType[]>(null as any);
    }

    /**
     * @return Success
     */
    getWorkActionTypeList(): Observable<WorkActionType[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActionTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActionTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActionTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionType[]>;
        }));
    }

    protected processGetWorkActionTypeList(response: HttpResponseBase): Observable<WorkActionType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActionType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionType[]>(null as any);
    }

    /**
     * @param actionId (optional) 
     * @return Success
     */
    getWorkActionProcessList(actionId: number | undefined): Observable<WorkActionProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActionProcessList?";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActionProcessList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActionProcessList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionProcessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionProcessDto[]>;
        }));
    }

    protected processGetWorkActionProcessList(response: HttpResponseBase): Observable<WorkActionProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActionProcessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionProcessDto[]>(null as any);
    }

    /**
     * @param wActionId (optional) 
     * @param creatorUserId (optional) 
     * @return Success
     */
    createWorkActionProcessFromWorkActionDetailForPda(wActionId: number | undefined, creatorUserId: number | undefined): Observable<WorkActionProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateWorkActionProcessFromWorkActionDetailForPda?";
        if (wActionId === null)
            throw new Error("The parameter 'wActionId' cannot be null.");
        else if (wActionId !== undefined)
            url_ += "wActionId=" + encodeURIComponent("" + wActionId) + "&";
        if (creatorUserId === null)
            throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "creatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkActionProcessFromWorkActionDetailForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkActionProcessFromWorkActionDetailForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionProcessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionProcessDto[]>;
        }));
    }

    protected processCreateWorkActionProcessFromWorkActionDetailForPda(response: HttpResponseBase): Observable<WorkActionProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActionProcessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionProcessDto[]>(null as any);
    }

    /**
     * @param workAcitivtyId (optional) 
     * @param workActionTypeId (optional) 
     * @return Success
     */
    getWorkActionProcessListByWorkActivityId(workAcitivtyId: number | undefined, workActionTypeId: number | undefined): Observable<WorkActionProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActionProcessListByWorkActivityId?";
        if (workAcitivtyId === null)
            throw new Error("The parameter 'workAcitivtyId' cannot be null.");
        else if (workAcitivtyId !== undefined)
            url_ += "workAcitivtyId=" + encodeURIComponent("" + workAcitivtyId) + "&";
        if (workActionTypeId === null)
            throw new Error("The parameter 'workActionTypeId' cannot be null.");
        else if (workActionTypeId !== undefined)
            url_ += "workActionTypeId=" + encodeURIComponent("" + workActionTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActionProcessListByWorkActivityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActionProcessListByWorkActivityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionProcessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionProcessDto[]>;
        }));
    }

    protected processGetWorkActionProcessListByWorkActivityId(response: HttpResponseBase): Observable<WorkActionProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActionProcessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionProcessDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param userId (optional) 
     * @param workActionTypeCode (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getWorkActionProcessForPlacement(companyId: number | undefined, warehouseId: number | undefined, userId: number | undefined, workActionTypeCode: string | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined): Observable<ControllerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActionProcessForPlacement?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (workActionTypeCode !== undefined && workActionTypeCode !== null)
            url_ += "workActionTypeCode=" + encodeURIComponent("" + workActionTypeCode) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActionProcessForPlacement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActionProcessForPlacement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControllerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControllerDto[]>;
        }));
    }

    protected processGetWorkActionProcessForPlacement(response: HttpResponseBase): Observable<ControllerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ControllerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControllerDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param storageIdFrom (optional) 
     * @param storageIdTo (optional) 
     * @param shelfIdTo (optional) 
     * @param shelfIdFrom (optional) 
     * @param transferTypeId (optional) 
     * @param creatorUserId (optional) 
     * @param clientId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWorkActionProcessListPaged(productId: number | undefined, companyId: number | undefined, warehouseId: number | undefined, storageIdFrom: number | undefined, storageIdTo: number | undefined, shelfIdTo: number | undefined, shelfIdFrom: number | undefined, transferTypeId: number | undefined, creatorUserId: number | undefined, clientId: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WorkActionProcessDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetWorkActionProcessListPaged?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (storageIdFrom === null)
            throw new Error("The parameter 'storageIdFrom' cannot be null.");
        else if (storageIdFrom !== undefined)
            url_ += "StorageIdFrom=" + encodeURIComponent("" + storageIdFrom) + "&";
        if (storageIdTo === null)
            throw new Error("The parameter 'storageIdTo' cannot be null.");
        else if (storageIdTo !== undefined)
            url_ += "StorageIdTo=" + encodeURIComponent("" + storageIdTo) + "&";
        if (shelfIdTo === null)
            throw new Error("The parameter 'shelfIdTo' cannot be null.");
        else if (shelfIdTo !== undefined)
            url_ += "ShelfIdTo=" + encodeURIComponent("" + shelfIdTo) + "&";
        if (shelfIdFrom === null)
            throw new Error("The parameter 'shelfIdFrom' cannot be null.");
        else if (shelfIdFrom !== undefined)
            url_ += "ShelfIdFrom=" + encodeURIComponent("" + shelfIdFrom) + "&";
        if (transferTypeId === null)
            throw new Error("The parameter 'transferTypeId' cannot be null.");
        else if (transferTypeId !== undefined)
            url_ += "TransferTypeId=" + encodeURIComponent("" + transferTypeId) + "&";
        if (creatorUserId === null)
            throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkActionProcessListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkActionProcessListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionProcessDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionProcessDtoPagedResultDto>;
        }));
    }

    protected processGetWorkActionProcessListPaged(response: HttpResponseBase): Observable<WorkActionProcessDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActionProcessDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionProcessDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getOrderWorkActivityByWorkActionIdForPda(): Observable<WorkActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetOrderWorkActivityByWorkActionIdForPda";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderWorkActivityByWorkActionIdForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderWorkActivityByWorkActionIdForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto[]>;
        }));
    }

    protected processGetOrderWorkActivityByWorkActionIdForPda(response: HttpResponseBase): Observable<WorkActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActivityDto[]>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @param workActionType (optional) 
     * @return Success
     */
    orderCreateWorkActionForPda(workActivityId: number | undefined, workActionType: number | undefined): Observable<WorkActionDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/OrderCreateWorkActionForPda?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (workActionType === null)
            throw new Error("The parameter 'workActionType' cannot be null.");
        else if (workActionType !== undefined)
            url_ += "workActionType=" + encodeURIComponent("" + workActionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderCreateWorkActionForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderCreateWorkActionForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActionDto>;
        }));
    }

    protected processOrderCreateWorkActionForPda(response: HttpResponseBase): Observable<WorkActionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkActionDto>(null as any);
    }

    /**
     * @param processId (optional) 
     * @param workActionId (optional) 
     * @return Success
     */
    orderDeleteFullWorkActionProcessForPda(processId: number | undefined, workActionId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/OrderDeleteFullWorkActionProcessForPda?";
        if (processId === null)
            throw new Error("The parameter 'processId' cannot be null.");
        else if (processId !== undefined)
            url_ += "processId=" + encodeURIComponent("" + processId) + "&";
        if (workActionId === null)
            throw new Error("The parameter 'workActionId' cannot be null.");
        else if (workActionId !== undefined)
            url_ += "workActionId=" + encodeURIComponent("" + workActionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderDeleteFullWorkActionProcessForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderDeleteFullWorkActionProcessForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrderDeleteFullWorkActionProcessForPda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param processId (optional) 
     * @param productId (optional) 
     * @param quantity (optional) 
     * @return Success
     */
    orderUpdateWorkActionProcessToCorrectQuantityForPda(processId: number | undefined, productId: number | undefined, quantity: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/OrderUpdateWorkActionProcessToCorrectQuantityForPda?";
        if (processId === null)
            throw new Error("The parameter 'processId' cannot be null.");
        else if (processId !== undefined)
            url_ += "processId=" + encodeURIComponent("" + processId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderUpdateWorkActionProcessToCorrectQuantityForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderUpdateWorkActionProcessToCorrectQuantityForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrderUpdateWorkActionProcessToCorrectQuantityForPda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param workActionProcessId (optional) 
     * @param quantity (optional) 
     * @return Success
     */
    workActionProcessAddQuantityForPda(workActionProcessId: number | undefined, quantity: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/WorkActionProcessAddQuantityForPda?";
        if (workActionProcessId === null)
            throw new Error("The parameter 'workActionProcessId' cannot be null.");
        else if (workActionProcessId !== undefined)
            url_ += "workActionProcessId=" + encodeURIComponent("" + workActionProcessId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkActionProcessAddQuantityForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkActionProcessAddQuantityForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWorkActionProcessAddQuantityForPda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    closeWorkActivityAfterOrder(workActivityId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CloseWorkActivityAfterOrder?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseWorkActivityAfterOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseWorkActivityAfterOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCloseWorkActivityAfterOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getOrderHeaderListByWorkActivityId(workActivityId: number | undefined): Observable<OrderHeaderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetOrderHeaderListByWorkActivityId?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderListByWorkActivityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderListByWorkActivityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDto[]>;
        }));
    }

    protected processGetOrderHeaderListByWorkActivityId(response: HttpResponseBase): Observable<OrderHeaderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderHeaderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDto[]>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getOrderDetailListByWorkActivityId(workActivityId: number | undefined): Observable<OrderDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetOrderDetailListByWorkActivityId?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailListByWorkActivityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailListByWorkActivityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailDto[]>;
        }));
    }

    protected processGetOrderDetailListByWorkActivityId(response: HttpResponseBase): Observable<OrderDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailDto[]>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @return Success
     */
    getOrderDetailListByWorkActivityIdForPartlyCancelOrder(workActivityId: number | undefined): Observable<OrderDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetOrderDetailListByWorkActivityIdForPartlyCancelOrder?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetailListByWorkActivityIdForPartlyCancelOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailListByWorkActivityIdForPartlyCancelOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailDto[]>;
        }));
    }

    protected processGetOrderDetailListByWorkActivityIdForPartlyCancelOrder(response: HttpResponseBase): Observable<OrderDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderDetailDto[]>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param documentNo (optional) 
     * @param documentNo2 (optional) 
     * @param warehouseId (optional) 
     * @param shippingTypeId (optional) 
     * @param shippingTypeStatusId (optional) 
     * @param clientId (optional) 
     * @param orderHeaderStatusId (optional) 
     * @param productId (optional) 
     * @param workActivityCode (optional) 
     * @param country (optional) 
     * @param city (optional) 
     * @param town (optional) 
     * @param shippingTypeIdList (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param orderType (optional) 
     * @param cityList (optional) 
     * @param orderPlace (optional) 
     * @param sortActive (optional) 
     * @param sortDirection (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOrderHeaderListByShippingTypeId(companyId: number | undefined, documentNo: string | null | undefined, documentNo2: string | null | undefined, warehouseId: number | undefined, shippingTypeId: number | undefined, shippingTypeStatusId: number | undefined, clientId: number | undefined, orderHeaderStatusId: number | undefined, productId: number | undefined, workActivityCode: string | null | undefined, country: string | null | undefined, city: string | null | undefined, town: string | null | undefined, shippingTypeIdList: number[] | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, orderType: number | undefined, cityList: string[] | null | undefined, orderPlace: number | undefined, sortActive: string | null | undefined, sortDirection: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrderHeaderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetOrderHeaderListByShippingTypeId?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (documentNo !== undefined && documentNo !== null)
            url_ += "DocumentNo=" + encodeURIComponent("" + documentNo) + "&";
        if (documentNo2 !== undefined && documentNo2 !== null)
            url_ += "DocumentNo2=" + encodeURIComponent("" + documentNo2) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "ShippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (shippingTypeStatusId === null)
            throw new Error("The parameter 'shippingTypeStatusId' cannot be null.");
        else if (shippingTypeStatusId !== undefined)
            url_ += "ShippingTypeStatusId=" + encodeURIComponent("" + shippingTypeStatusId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (orderHeaderStatusId === null)
            throw new Error("The parameter 'orderHeaderStatusId' cannot be null.");
        else if (orderHeaderStatusId !== undefined)
            url_ += "OrderHeaderStatusId=" + encodeURIComponent("" + orderHeaderStatusId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (workActivityCode !== undefined && workActivityCode !== null)
            url_ += "WorkActivityCode=" + encodeURIComponent("" + workActivityCode) + "&";
        if (country !== undefined && country !== null)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (city !== undefined && city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (town !== undefined && town !== null)
            url_ += "Town=" + encodeURIComponent("" + town) + "&";
        if (shippingTypeIdList !== undefined && shippingTypeIdList !== null)
            shippingTypeIdList && shippingTypeIdList.forEach(item => { url_ += "ShippingTypeIdList=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (orderType === null)
            throw new Error("The parameter 'orderType' cannot be null.");
        else if (orderType !== undefined)
            url_ += "OrderType=" + encodeURIComponent("" + orderType) + "&";
        if (cityList !== undefined && cityList !== null)
            cityList && cityList.forEach(item => { url_ += "CityList=" + encodeURIComponent("" + item) + "&"; });
        if (orderPlace === null)
            throw new Error("The parameter 'orderPlace' cannot be null.");
        else if (orderPlace !== undefined)
            url_ += "OrderPlace=" + encodeURIComponent("" + orderPlace) + "&";
        if (sortActive !== undefined && sortActive !== null)
            url_ += "sortActive=" + encodeURIComponent("" + sortActive) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHeaderListByShippingTypeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHeaderListByShippingTypeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderHeaderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderHeaderDtoPagedResultDto>;
        }));
    }

    protected processGetOrderHeaderListByShippingTypeId(response: HttpResponseBase): Observable<OrderHeaderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderHeaderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderHeaderDtoPagedResultDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param shelfIdTo (optional) 
     * @param shelfIdFrom (optional) 
     * @param quantity (optional) 
     * @param changeSpecialShelf (optional) 
     * @return Success
     */
    createShelfMovement(productId: number | undefined, shelfIdTo: number | undefined, shelfIdFrom: number | undefined, quantity: number | undefined, changeSpecialShelf: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateShelfMovement?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (shelfIdTo === null)
            throw new Error("The parameter 'shelfIdTo' cannot be null.");
        else if (shelfIdTo !== undefined)
            url_ += "shelfIdTo=" + encodeURIComponent("" + shelfIdTo) + "&";
        if (shelfIdFrom === null)
            throw new Error("The parameter 'shelfIdFrom' cannot be null.");
        else if (shelfIdFrom !== undefined)
            url_ += "shelfIdFrom=" + encodeURIComponent("" + shelfIdFrom) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (changeSpecialShelf === null)
            throw new Error("The parameter 'changeSpecialShelf' cannot be null.");
        else if (changeSpecialShelf !== undefined)
            url_ += "changeSpecialShelf=" + encodeURIComponent("" + changeSpecialShelf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShelfMovement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShelfMovement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateShelfMovement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createShelfMovementBatch(body: BatchShelfMovementInsertDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateShelfMovementBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShelfMovementBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShelfMovementBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateShelfMovementBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param storageIdTo (optional) 
     * @param storageIdFrom (optional) 
     * @param shelfIdTo (optional) 
     * @param shelfIdFrom (optional) 
     * @param quantity (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    createStorageMovement(productId: number | undefined, storageIdTo: number | undefined, storageIdFrom: number | undefined, shelfIdTo: number | undefined, shelfIdFrom: number | undefined, quantity: number | undefined, warehouseId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateStorageMovement?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (storageIdTo === null)
            throw new Error("The parameter 'storageIdTo' cannot be null.");
        else if (storageIdTo !== undefined)
            url_ += "storageIdTo=" + encodeURIComponent("" + storageIdTo) + "&";
        if (storageIdFrom === null)
            throw new Error("The parameter 'storageIdFrom' cannot be null.");
        else if (storageIdFrom !== undefined)
            url_ += "StorageIdFrom=" + encodeURIComponent("" + storageIdFrom) + "&";
        if (shelfIdTo === null)
            throw new Error("The parameter 'shelfIdTo' cannot be null.");
        else if (shelfIdTo !== undefined)
            url_ += "shelfIdTo=" + encodeURIComponent("" + shelfIdTo) + "&";
        if (shelfIdFrom === null)
            throw new Error("The parameter 'shelfIdFrom' cannot be null.");
        else if (shelfIdFrom !== undefined)
            url_ += "shelfIdFrom=" + encodeURIComponent("" + shelfIdFrom) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStorageMovement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStorageMovement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateStorageMovement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTransferStorageBatch(body: BatchTransferStorageInsertDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateTransferStorageBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTransferStorageBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTransferStorageBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTransferStorageBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param warehouseIdTo (optional) 
     * @param storageIdTo (optional) 
     * @param storageIdFrom (optional) 
     * @param warehouseIdFrom (optional) 
     * @param quantity (optional) 
     * @return Success
     */
    createWarehouseMovement(productId: number | undefined, warehouseIdTo: number | undefined, storageIdTo: number | undefined, storageIdFrom: number | undefined, warehouseIdFrom: number | undefined, quantity: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateWarehouseMovement?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (warehouseIdTo === null)
            throw new Error("The parameter 'warehouseIdTo' cannot be null.");
        else if (warehouseIdTo !== undefined)
            url_ += "warehouseIdTo=" + encodeURIComponent("" + warehouseIdTo) + "&";
        if (storageIdTo === null)
            throw new Error("The parameter 'storageIdTo' cannot be null.");
        else if (storageIdTo !== undefined)
            url_ += "storageIdTo=" + encodeURIComponent("" + storageIdTo) + "&";
        if (storageIdFrom === null)
            throw new Error("The parameter 'storageIdFrom' cannot be null.");
        else if (storageIdFrom !== undefined)
            url_ += "storageIdFrom=" + encodeURIComponent("" + storageIdFrom) + "&";
        if (warehouseIdFrom === null)
            throw new Error("The parameter 'warehouseIdFrom' cannot be null.");
        else if (warehouseIdFrom !== undefined)
            url_ += "warehouseIdFrom=" + encodeURIComponent("" + warehouseIdFrom) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWarehouseMovement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWarehouseMovement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateWarehouseMovement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param type (optional) 
     * @param isProcToErp (optional) 
     * @param storageId (optional) 
     * @param shelfId (optional) 
     * @param productId (optional) 
     * @param quantity (optional) 
     * @param price (optional) 
     * @param notes (optional) 
     * @return Success
     */
    createStockCorrectionStorage(type: number | undefined, isProcToErp: boolean | undefined, storageId: number | undefined, shelfId: number | undefined, productId: number | undefined, quantity: number | undefined, price: number | undefined, notes: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateStockCorrectionStorage?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (isProcToErp === null)
            throw new Error("The parameter 'isProcToErp' cannot be null.");
        else if (isProcToErp !== undefined)
            url_ += "isProcToErp=" + encodeURIComponent("" + isProcToErp) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (price === null)
            throw new Error("The parameter 'price' cannot be null.");
        else if (price !== undefined)
            url_ += "price=" + encodeURIComponent("" + price) + "&";
        if (notes !== undefined && notes !== null)
            url_ += "notes=" + encodeURIComponent("" + notes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStockCorrectionStorage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStockCorrectionStorage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateStockCorrectionStorage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param type (optional) 
     * @param isProcToErp (optional) 
     * @param storageId (optional) 
     * @param shelfId (optional) 
     * @param productId (optional) 
     * @param quantity (optional) 
     * @param price (optional) 
     * @param notes (optional) 
     * @return Success
     */
    createStockCorrectionShelf(type: number | undefined, isProcToErp: boolean | undefined, storageId: number | undefined, shelfId: number | undefined, productId: number | undefined, quantity: number | undefined, price: number | undefined, notes: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateStockCorrectionShelf?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (isProcToErp === null)
            throw new Error("The parameter 'isProcToErp' cannot be null.");
        else if (isProcToErp !== undefined)
            url_ += "isProcToErp=" + encodeURIComponent("" + isProcToErp) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (price === null)
            throw new Error("The parameter 'price' cannot be null.");
        else if (price !== undefined)
            url_ += "price=" + encodeURIComponent("" + price) + "&";
        if (notes !== undefined && notes !== null)
            url_ += "notes=" + encodeURIComponent("" + notes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStockCorrectionShelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStockCorrectionShelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateStockCorrectionShelf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param type (optional) 
     * @param storageId (optional) 
     * @param shelfId (optional) 
     * @param productId (optional) 
     * @param quantity (optional) 
     * @param notes (optional) 
     * @param price (optional) 
     * @param isProcToErp (optional) 
     * @return Success
     */
    createStockCorrection(type: number | undefined, storageId: number | undefined, shelfId: number | undefined, productId: number | undefined, quantity: number | undefined, notes: string | null | undefined, price: number | undefined, isProcToErp: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateStockCorrection?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (storageId === null)
            throw new Error("The parameter 'storageId' cannot be null.");
        else if (storageId !== undefined)
            url_ += "storageId=" + encodeURIComponent("" + storageId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (notes !== undefined && notes !== null)
            url_ += "notes=" + encodeURIComponent("" + notes) + "&";
        if (price === null)
            throw new Error("The parameter 'price' cannot be null.");
        else if (price !== undefined)
            url_ += "price=" + encodeURIComponent("" + price) + "&";
        if (isProcToErp === null)
            throw new Error("The parameter 'isProcToErp' cannot be null.");
        else if (isProcToErp !== undefined)
            url_ += "isProcToErp=" + encodeURIComponent("" + isProcToErp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStockCorrection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStockCorrection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateStockCorrection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param type (optional) 
     * @param isProcToErp (optional) 
     * @param shelfId (optional) 
     * @param productId (optional) 
     * @param quantity (optional) 
     * @param notes (optional) 
     * @return Success
     */
    createShelfCorrection(type: number | undefined, isProcToErp: boolean | undefined, shelfId: number | undefined, productId: number | undefined, quantity: number | undefined, notes: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateShelfCorrection?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (isProcToErp === null)
            throw new Error("The parameter 'isProcToErp' cannot be null.");
        else if (isProcToErp !== undefined)
            url_ += "isProcToErp=" + encodeURIComponent("" + isProcToErp) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (notes !== undefined && notes !== null)
            url_ += "notes=" + encodeURIComponent("" + notes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShelfCorrection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShelfCorrection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateShelfCorrection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param workActivityId (optional) 
     * @param productId (optional) 
     * @param shelfIdTo (optional) 
     * @param shelfIdFrom (optional) 
     * @param quantity (optional) 
     * @return Success
     */
    createShelfMovementForReplenishment(workActivityId: number | undefined, productId: number | undefined, shelfIdTo: number | undefined, shelfIdFrom: number | undefined, quantity: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateShelfMovementForReplenishment?";
        if (workActivityId === null)
            throw new Error("The parameter 'workActivityId' cannot be null.");
        else if (workActivityId !== undefined)
            url_ += "workActivityId=" + encodeURIComponent("" + workActivityId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (shelfIdTo === null)
            throw new Error("The parameter 'shelfIdTo' cannot be null.");
        else if (shelfIdTo !== undefined)
            url_ += "shelfIdTo=" + encodeURIComponent("" + shelfIdTo) + "&";
        if (shelfIdFrom === null)
            throw new Error("The parameter 'shelfIdFrom' cannot be null.");
        else if (shelfIdFrom !== undefined)
            url_ += "shelfIdFrom=" + encodeURIComponent("" + shelfIdFrom) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShelfMovementForReplenishment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShelfMovementForReplenishment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateShelfMovementForReplenishment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param oldShelf (optional) 
     * @param newShelf (optional) 
     * @return Success
     */
    createBatchShelfMovement(companyId: number | undefined, warehouseId: number | undefined, oldShelf: number | undefined, newShelf: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateBatchShelfMovement?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (oldShelf === null)
            throw new Error("The parameter 'oldShelf' cannot be null.");
        else if (oldShelf !== undefined)
            url_ += "oldShelf=" + encodeURIComponent("" + oldShelf) + "&";
        if (newShelf === null)
            throw new Error("The parameter 'newShelf' cannot be null.");
        else if (newShelf !== undefined)
            url_ += "newShelf=" + encodeURIComponent("" + newShelf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBatchShelfMovement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBatchShelfMovement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateBatchShelfMovement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseId (optional) 
     * @param oldShelf (optional) 
     * @param newShelf (optional) 
     * @param changeVariety (optional) 
     * @return Success
     */
    createBatchShelfMovementForPda(companyId: number | undefined, warehouseId: number | undefined, oldShelf: number | undefined, newShelf: number | undefined, changeVariety: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateBatchShelfMovementForPda?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (oldShelf === null)
            throw new Error("The parameter 'oldShelf' cannot be null.");
        else if (oldShelf !== undefined)
            url_ += "oldShelf=" + encodeURIComponent("" + oldShelf) + "&";
        if (newShelf === null)
            throw new Error("The parameter 'newShelf' cannot be null.");
        else if (newShelf !== undefined)
            url_ += "newShelf=" + encodeURIComponent("" + newShelf) + "&";
        if (changeVariety === null)
            throw new Error("The parameter 'changeVariety' cannot be null.");
        else if (changeVariety !== undefined)
            url_ += "changeVariety=" + encodeURIComponent("" + changeVariety) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBatchShelfMovementForPda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBatchShelfMovementForPda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateBatchShelfMovementForPda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseIdFrom (optional) 
     * @param warehouseIdTo (optional) 
     * @param shippingType (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getTransferRequestHeaderListPaged(companyId: number | undefined, warehouseIdFrom: number | undefined, warehouseIdTo: number | undefined, shippingType: string | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TransferHeaderRequestDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferRequestHeaderListPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseIdFrom === null)
            throw new Error("The parameter 'warehouseIdFrom' cannot be null.");
        else if (warehouseIdFrom !== undefined)
            url_ += "WarehouseIdFrom=" + encodeURIComponent("" + warehouseIdFrom) + "&";
        if (warehouseIdTo === null)
            throw new Error("The parameter 'warehouseIdTo' cannot be null.");
        else if (warehouseIdTo !== undefined)
            url_ += "WarehouseIdTo=" + encodeURIComponent("" + warehouseIdTo) + "&";
        if (shippingType !== undefined && shippingType !== null)
            url_ += "ShippingType=" + encodeURIComponent("" + shippingType) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferRequestHeaderListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferRequestHeaderListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferHeaderRequestDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferHeaderRequestDtoPagedResultDto>;
        }));
    }

    protected processGetTransferRequestHeaderListPaged(response: HttpResponseBase): Observable<TransferHeaderRequestDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferHeaderRequestDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferHeaderRequestDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTransferRequestDetailListPaged(id: number | undefined): Observable<TransferRequestDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferRequestDetailListPaged?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferRequestDetailListPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferRequestDetailListPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferRequestDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferRequestDetailDto[]>;
        }));
    }

    protected processGetTransferRequestDetailListPaged(response: HttpResponseBase): Observable<TransferRequestDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransferRequestDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferRequestDetailDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTransferRequestHeader(id: number | undefined): Observable<TransferHeaderRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/GetTransferRequestHeader?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferRequestHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferRequestHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferHeaderRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferHeaderRequestDto>;
        }));
    }

    protected processGetTransferRequestHeader(response: HttpResponseBase): Observable<TransferHeaderRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferHeaderRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferHeaderRequestDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param warehouseIdFrom (optional) 
     * @param warehouseIdTo (optional) 
     * @param shippingType (optional) 
     * @param note (optional) 
     * @param plannedSendDate (optional) 
     * @param controlPointId (optional) 
     * @return Success
     */
    createTransferHeaderRequest(companyId: number | undefined, warehouseIdFrom: number | undefined, warehouseIdTo: number | undefined, shippingType: string | null | undefined, note: string | null | undefined, plannedSendDate: Date | null | undefined, controlPointId: number | undefined): Observable<TransferHeaderRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateTransferHeaderRequest?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (warehouseIdFrom === null)
            throw new Error("The parameter 'warehouseIdFrom' cannot be null.");
        else if (warehouseIdFrom !== undefined)
            url_ += "warehouseIdFrom=" + encodeURIComponent("" + warehouseIdFrom) + "&";
        if (warehouseIdTo === null)
            throw new Error("The parameter 'warehouseIdTo' cannot be null.");
        else if (warehouseIdTo !== undefined)
            url_ += "warehouseIdTo=" + encodeURIComponent("" + warehouseIdTo) + "&";
        if (shippingType !== undefined && shippingType !== null)
            url_ += "shippingType=" + encodeURIComponent("" + shippingType) + "&";
        if (note !== undefined && note !== null)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        if (plannedSendDate !== undefined && plannedSendDate !== null)
            url_ += "plannedSendDate=" + encodeURIComponent(plannedSendDate ? "" + plannedSendDate.toISOString() : "") + "&";
        if (controlPointId === null)
            throw new Error("The parameter 'controlPointId' cannot be null.");
        else if (controlPointId !== undefined)
            url_ += "controlPointId=" + encodeURIComponent("" + controlPointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTransferHeaderRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTransferHeaderRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferHeaderRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferHeaderRequestDto>;
        }));
    }

    protected processCreateTransferHeaderRequest(response: HttpResponseBase): Observable<TransferHeaderRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferHeaderRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransferHeaderRequestDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTransferRequestHeader(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/DeleteTransferRequestHeader?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTransferRequestHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTransferRequestHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTransferRequestHeader(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param headerId (optional) 
     * @param productId (optional) 
     * @param quantity (optional) 
     * @return Success
     */
    createTransferRequestDetail(headerId: number | undefined, productId: number | undefined, quantity: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Work/CreateTransferRequestDetail?";
        if (headerId === null)
            throw new Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTransferRequestDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTransferRequestDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTransferRequestDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class Company implements ICompany {
    code: string | undefined;
    definition: string | undefined;
    orderingNo: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orderingNo = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.orderingNo = _data["orderingNo"] !== undefined ? _data["orderingNo"] : 0;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["orderingNo"] = this.orderingNo;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Company {
        const json = this.toJSON();
        let result = new Company();
        result.init(json);
        return result;
    }
}

export interface ICompany {
    code: string | undefined;
    definition: string | undefined;
    orderingNo: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class Warehouse implements IWarehouse {
    code: string;
    name: string;
    orderingNo: number;
    erpEntegreId: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IWarehouse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orderingNo = 0;
            this.erpEntegreId = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.orderingNo = _data["orderingNo"] !== undefined ? _data["orderingNo"] : 0;
            this.erpEntegreId = _data["erpEntegreId"] !== undefined ? _data["erpEntegreId"] : "";
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Warehouse {
        data = typeof data === 'object' ? data : {};
        let result = new Warehouse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["orderingNo"] = this.orderingNo;
        data["erpEntegreId"] = this.erpEntegreId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Warehouse {
        const json = this.toJSON();
        let result = new Warehouse();
        result.init(json);
        return result;
    }
}

export interface IWarehouse {
    code: string;
    name: string;
    orderingNo: number;
    erpEntegreId: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class ShippingCompany implements IShippingCompany {
    code: string | undefined;
    definition: string | undefined;
    id: number;

    constructor(data?: IShippingCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.code = "";
            this.definition = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : "";
            this.definition = _data["definition"] !== undefined ? _data["definition"] : "";
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShippingCompany {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["id"] = this.id;
        return data;
    }

    clone(): ShippingCompany {
        const json = this.toJSON();
        let result = new ShippingCompany();
        result.init(json);
        return result;
    }
}

export interface IShippingCompany {
    code: string | undefined;
    definition: string | undefined;
    id: number;
}

export class ShippingType implements IShippingType {
    warehouse: Warehouse;
    warehouseId: number;
    code: string;
    definition: string;
    shortCode: string | undefined;
    isAlwaysHavePriorty: boolean;
    priority: number;
    isHasShippingCost: boolean;
    minimumShippingCost: number;
    isShippingCompanyIntegration: boolean;
    shippingCompany: ShippingCompany;
    shippingCompanyId: number | undefined;
    isD2DIntegration: boolean;
    id: number;

    constructor(data?: IShippingType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.warehouse = new Warehouse();
            this.shortCode = "";
            this.isAlwaysHavePriorty = false;
            this.priority = 0;
            this.isHasShippingCost = false;
            this.isShippingCompanyIntegration = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.warehouseId = _data["warehouseId"];
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.shortCode = _data["shortCode"] !== undefined ? _data["shortCode"] : "";
            this.isAlwaysHavePriorty = _data["isAlwaysHavePriorty"] !== undefined ? _data["isAlwaysHavePriorty"] : false;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : 0;
            this.isHasShippingCost = _data["isHasShippingCost"] !== undefined ? _data["isHasShippingCost"] : false;
            this.minimumShippingCost = _data["minimumShippingCost"];
            this.isShippingCompanyIntegration = _data["isShippingCompanyIntegration"] !== undefined ? _data["isShippingCompanyIntegration"] : false;
            this.shippingCompany = _data["shippingCompany"] ? ShippingCompany.fromJS(_data["shippingCompany"]) : <any>undefined;
            this.shippingCompanyId = _data["shippingCompanyId"];
            this.isD2DIntegration = _data["isD2DIntegration"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShippingType {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["shortCode"] = this.shortCode;
        data["isAlwaysHavePriorty"] = this.isAlwaysHavePriorty;
        data["priority"] = this.priority;
        data["isHasShippingCost"] = this.isHasShippingCost;
        data["minimumShippingCost"] = this.minimumShippingCost;
        data["isShippingCompanyIntegration"] = this.isShippingCompanyIntegration;
        data["shippingCompany"] = this.shippingCompany ? this.shippingCompany.toJSON() : <any>undefined;
        data["shippingCompanyId"] = this.shippingCompanyId;
        data["isD2DIntegration"] = this.isD2DIntegration;
        data["id"] = this.id;
        return data;
    }

    clone(): ShippingType {
        const json = this.toJSON();
        let result = new ShippingType();
        result.init(json);
        return result;
    }
}

export interface IShippingType {
    warehouse: Warehouse;
    warehouseId: number;
    code: string;
    definition: string;
    shortCode: string | undefined;
    isAlwaysHavePriorty: boolean;
    priority: number;
    isHasShippingCost: boolean;
    minimumShippingCost: number;
    isShippingCompanyIntegration: boolean;
    shippingCompany: ShippingCompany;
    shippingCompanyId: number | undefined;
    isD2DIntegration: boolean;
    id: number;
}

export class ShippingTypeArea implements IShippingTypeArea {
    warehouse: Warehouse;
    code: string;
    shippingType: ShippingType;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IShippingTypeArea) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.warehouse = new Warehouse();
            this.shippingType = new ShippingType();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.code = _data["code"];
            this.shippingType = _data["shippingType"] ? ShippingType.fromJS(_data["shippingType"]) : new ShippingType();
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShippingTypeArea {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingTypeArea();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ShippingTypeArea {
        const json = this.toJSON();
        let result = new ShippingTypeArea();
        result.init(json);
        return result;
    }
}

export interface IShippingTypeArea {
    warehouse: Warehouse;
    code: string;
    shippingType: ShippingType;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class ClientDto implements IClientDto {
    company: Company;
    shippingType: string | undefined;
    code: string | undefined;
    name: string | undefined;
    taxOffice: string | undefined;
    taxNumber: string | undefined;
    tel1: string | undefined;
    tel2: string | undefined;
    country: string | undefined;
    city: string | undefined;
    town: string | undefined;
    address: string | undefined;
    isDeleted: boolean;
    isEnteredShippingCost: boolean;
    combinableOrderCount: number;
    shippingTypeArea: ShippingTypeArea;
    id: number;

    constructor(data?: IClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.shippingType = _data["shippingType"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.taxOffice = _data["taxOffice"];
            this.taxNumber = _data["taxNumber"];
            this.tel1 = _data["tel1"];
            this.tel2 = _data["tel2"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.town = _data["town"];
            this.address = _data["address"];
            this.isDeleted = _data["isDeleted"];
            this.isEnteredShippingCost = _data["isEnteredShippingCost"];
            this.combinableOrderCount = _data["combinableOrderCount"];
            this.shippingTypeArea = _data["shippingTypeArea"] ? ShippingTypeArea.fromJS(_data["shippingTypeArea"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["shippingType"] = this.shippingType;
        data["code"] = this.code;
        data["name"] = this.name;
        data["taxOffice"] = this.taxOffice;
        data["taxNumber"] = this.taxNumber;
        data["tel1"] = this.tel1;
        data["tel2"] = this.tel2;
        data["country"] = this.country;
        data["city"] = this.city;
        data["town"] = this.town;
        data["address"] = this.address;
        data["isDeleted"] = this.isDeleted;
        data["isEnteredShippingCost"] = this.isEnteredShippingCost;
        data["combinableOrderCount"] = this.combinableOrderCount;
        data["shippingTypeArea"] = this.shippingTypeArea ? this.shippingTypeArea.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): ClientDto {
        const json = this.toJSON();
        let result = new ClientDto();
        result.init(json);
        return result;
    }
}

export interface IClientDto {
    company: Company;
    shippingType: string | undefined;
    code: string | undefined;
    name: string | undefined;
    taxOffice: string | undefined;
    taxNumber: string | undefined;
    tel1: string | undefined;
    tel2: string | undefined;
    country: string | undefined;
    city: string | undefined;
    town: string | undefined;
    address: string | undefined;
    isDeleted: boolean;
    isEnteredShippingCost: boolean;
    combinableOrderCount: number;
    shippingTypeArea: ShippingTypeArea;
    id: number;
}

export class CityLogisticCode implements ICityLogisticCode {
    city: string | undefined;
    town: string | undefined;
    townCode: string | undefined;
    cityCode: string | undefined;
    id: number;

    constructor(data?: ICityLogisticCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.city = "";
            this.town = "";
            this.townCode = "";
            this.cityCode = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"] !== undefined ? _data["city"] : "";
            this.town = _data["town"] !== undefined ? _data["town"] : "";
            this.townCode = _data["townCode"] !== undefined ? _data["townCode"] : "";
            this.cityCode = _data["cityCode"] !== undefined ? _data["cityCode"] : "";
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CityLogisticCode {
        data = typeof data === 'object' ? data : {};
        let result = new CityLogisticCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city;
        data["town"] = this.town;
        data["townCode"] = this.townCode;
        data["cityCode"] = this.cityCode;
        data["id"] = this.id;
        return data;
    }

    clone(): CityLogisticCode {
        const json = this.toJSON();
        let result = new CityLogisticCode();
        result.init(json);
        return result;
    }
}

export interface ICityLogisticCode {
    city: string | undefined;
    town: string | undefined;
    townCode: string | undefined;
    cityCode: string | undefined;
    id: number;
}

export class Branch implements IBranch {
    clientId: number;
    branchCode: string;
    cityLogisticCode: CityLogisticCode;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IBranch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.branchCode = _data["branchCode"];
            this.cityLogisticCode = _data["cityLogisticCode"] ? CityLogisticCode.fromJS(_data["cityLogisticCode"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Branch {
        data = typeof data === 'object' ? data : {};
        let result = new Branch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["branchCode"] = this.branchCode;
        data["cityLogisticCode"] = this.cityLogisticCode ? this.cityLogisticCode.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Branch {
        const json = this.toJSON();
        let result = new Branch();
        result.init(json);
        return result;
    }
}

export interface IBranch {
    clientId: number;
    branchCode: string;
    cityLogisticCode: CityLogisticCode;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class ClientSmallDto implements IClientSmallDto {
    code: string | undefined;
    name: string | undefined;
    id: number;

    constructor(data?: IClientSmallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClientSmallDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientSmallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): ClientSmallDto {
        const json = this.toJSON();
        let result = new ClientSmallDto();
        result.init(json);
        return result;
    }
}

export interface IClientSmallDto {
    code: string | undefined;
    name: string | undefined;
    id: number;
}

export class ClientDtoPagedResultDto implements IClientDtoPagedResultDto {
    totalCount: number;
    items: ClientDto[] | undefined;

    constructor(data?: IClientDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ClientDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ClientDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ClientDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IClientDtoPagedResultDto {
    totalCount: number;
    items: ClientDto[] | undefined;
}

export class ClientExtendedDto implements IClientExtendedDto {
    company: Company;
    code: string | undefined;
    name: string | undefined;
    taxOffice: string | undefined;
    taxNumber: string | undefined;
    email: string | undefined;
    country: string | undefined;
    city: string | undefined;
    town: string | undefined;
    groupCode: string | undefined;
    speCode1: string | undefined;
    speCode2: string | undefined;
    speCode3: string | undefined;
    speCode4: string | undefined;
    speCode5: string | undefined;
    isEInvoice: boolean;
    isDeleted: boolean;
    isEnteredShippingCost: boolean;
    id: number;

    constructor(data?: IClientExtendedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.code = _data["code"];
            this.name = _data["name"];
            this.taxOffice = _data["taxOffice"];
            this.taxNumber = _data["taxNumber"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.town = _data["town"];
            this.groupCode = _data["groupCode"];
            this.speCode1 = _data["speCode1"];
            this.speCode2 = _data["speCode2"];
            this.speCode3 = _data["speCode3"];
            this.speCode4 = _data["speCode4"];
            this.speCode5 = _data["speCode5"];
            this.isEInvoice = _data["isEInvoice"];
            this.isDeleted = _data["isDeleted"];
            this.isEnteredShippingCost = _data["isEnteredShippingCost"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClientExtendedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientExtendedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["name"] = this.name;
        data["taxOffice"] = this.taxOffice;
        data["taxNumber"] = this.taxNumber;
        data["email"] = this.email;
        data["country"] = this.country;
        data["city"] = this.city;
        data["town"] = this.town;
        data["groupCode"] = this.groupCode;
        data["speCode1"] = this.speCode1;
        data["speCode2"] = this.speCode2;
        data["speCode3"] = this.speCode3;
        data["speCode4"] = this.speCode4;
        data["speCode5"] = this.speCode5;
        data["isEInvoice"] = this.isEInvoice;
        data["isDeleted"] = this.isDeleted;
        data["isEnteredShippingCost"] = this.isEnteredShippingCost;
        data["id"] = this.id;
        return data;
    }

    clone(): ClientExtendedDto {
        const json = this.toJSON();
        let result = new ClientExtendedDto();
        result.init(json);
        return result;
    }
}

export interface IClientExtendedDto {
    company: Company;
    code: string | undefined;
    name: string | undefined;
    taxOffice: string | undefined;
    taxNumber: string | undefined;
    email: string | undefined;
    country: string | undefined;
    city: string | undefined;
    town: string | undefined;
    groupCode: string | undefined;
    speCode1: string | undefined;
    speCode2: string | undefined;
    speCode3: string | undefined;
    speCode4: string | undefined;
    speCode5: string | undefined;
    isEInvoice: boolean;
    isDeleted: boolean;
    isEnteredShippingCost: boolean;
    id: number;
}

export class BatchClientInsertDto implements IBatchClientInsertDto {
    clientCodeList: string[] | undefined;
    clientNameList: string[] | undefined;
    clientTaxNumberList: string[] | undefined;
    clientTaxOfficeList: string[] | undefined;
    clientCityList: string[] | undefined;
    clientCountryList: string[] | undefined;
    clientTownList: string[] | undefined;
    clientAddressList: string[] | undefined;
    clientErpEntegreIdList: string[] | undefined;
    clientIsEInvoiceList: string[] | undefined;
    companyId: number;

    constructor(data?: IBatchClientInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clientCodeList"])) {
                this.clientCodeList = [] as any;
                for (let item of _data["clientCodeList"])
                    this.clientCodeList.push(item);
            }
            if (Array.isArray(_data["clientNameList"])) {
                this.clientNameList = [] as any;
                for (let item of _data["clientNameList"])
                    this.clientNameList.push(item);
            }
            if (Array.isArray(_data["clientTaxNumberList"])) {
                this.clientTaxNumberList = [] as any;
                for (let item of _data["clientTaxNumberList"])
                    this.clientTaxNumberList.push(item);
            }
            if (Array.isArray(_data["clientTaxOfficeList"])) {
                this.clientTaxOfficeList = [] as any;
                for (let item of _data["clientTaxOfficeList"])
                    this.clientTaxOfficeList.push(item);
            }
            if (Array.isArray(_data["clientCityList"])) {
                this.clientCityList = [] as any;
                for (let item of _data["clientCityList"])
                    this.clientCityList.push(item);
            }
            if (Array.isArray(_data["clientCountryList"])) {
                this.clientCountryList = [] as any;
                for (let item of _data["clientCountryList"])
                    this.clientCountryList.push(item);
            }
            if (Array.isArray(_data["clientTownList"])) {
                this.clientTownList = [] as any;
                for (let item of _data["clientTownList"])
                    this.clientTownList.push(item);
            }
            if (Array.isArray(_data["clientAddressList"])) {
                this.clientAddressList = [] as any;
                for (let item of _data["clientAddressList"])
                    this.clientAddressList.push(item);
            }
            if (Array.isArray(_data["clientErpEntegreIdList"])) {
                this.clientErpEntegreIdList = [] as any;
                for (let item of _data["clientErpEntegreIdList"])
                    this.clientErpEntegreIdList.push(item);
            }
            if (Array.isArray(_data["clientIsEInvoiceList"])) {
                this.clientIsEInvoiceList = [] as any;
                for (let item of _data["clientIsEInvoiceList"])
                    this.clientIsEInvoiceList.push(item);
            }
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): BatchClientInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchClientInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clientCodeList)) {
            data["clientCodeList"] = [];
            for (let item of this.clientCodeList)
                data["clientCodeList"].push(item);
        }
        if (Array.isArray(this.clientNameList)) {
            data["clientNameList"] = [];
            for (let item of this.clientNameList)
                data["clientNameList"].push(item);
        }
        if (Array.isArray(this.clientTaxNumberList)) {
            data["clientTaxNumberList"] = [];
            for (let item of this.clientTaxNumberList)
                data["clientTaxNumberList"].push(item);
        }
        if (Array.isArray(this.clientTaxOfficeList)) {
            data["clientTaxOfficeList"] = [];
            for (let item of this.clientTaxOfficeList)
                data["clientTaxOfficeList"].push(item);
        }
        if (Array.isArray(this.clientCityList)) {
            data["clientCityList"] = [];
            for (let item of this.clientCityList)
                data["clientCityList"].push(item);
        }
        if (Array.isArray(this.clientCountryList)) {
            data["clientCountryList"] = [];
            for (let item of this.clientCountryList)
                data["clientCountryList"].push(item);
        }
        if (Array.isArray(this.clientTownList)) {
            data["clientTownList"] = [];
            for (let item of this.clientTownList)
                data["clientTownList"].push(item);
        }
        if (Array.isArray(this.clientAddressList)) {
            data["clientAddressList"] = [];
            for (let item of this.clientAddressList)
                data["clientAddressList"].push(item);
        }
        if (Array.isArray(this.clientErpEntegreIdList)) {
            data["clientErpEntegreIdList"] = [];
            for (let item of this.clientErpEntegreIdList)
                data["clientErpEntegreIdList"].push(item);
        }
        if (Array.isArray(this.clientIsEInvoiceList)) {
            data["clientIsEInvoiceList"] = [];
            for (let item of this.clientIsEInvoiceList)
                data["clientIsEInvoiceList"].push(item);
        }
        data["companyId"] = this.companyId;
        return data;
    }

    clone(): BatchClientInsertDto {
        const json = this.toJSON();
        let result = new BatchClientInsertDto();
        result.init(json);
        return result;
    }
}

export interface IBatchClientInsertDto {
    clientCodeList: string[] | undefined;
    clientNameList: string[] | undefined;
    clientTaxNumberList: string[] | undefined;
    clientTaxOfficeList: string[] | undefined;
    clientCityList: string[] | undefined;
    clientCountryList: string[] | undefined;
    clientTownList: string[] | undefined;
    clientAddressList: string[] | undefined;
    clientErpEntegreIdList: string[] | undefined;
    clientIsEInvoiceList: string[] | undefined;
    companyId: number;
}

export class ShippingRoute implements IShippingRoute {
    code: string;
    warehouse: Warehouse;
    warehouseId: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IShippingRoute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.warehouse = new Warehouse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.warehouseId = _data["warehouseId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShippingRoute {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingRoute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ShippingRoute {
        const json = this.toJSON();
        let result = new ShippingRoute();
        result.init(json);
        return result;
    }
}

export interface IShippingRoute {
    code: string;
    warehouse: Warehouse;
    warehouseId: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class Client implements IClient {
    company: Company;
    companyId: number;
    erpEntegreId: string;
    code: string;
    name: string | undefined;
    salesman: string | undefined;
    taxOffice: string | undefined;
    taxNumber: string | undefined;
    email: string | undefined;
    groupCode: string | undefined;
    speCode1: string | undefined;
    speCode2: string | undefined;
    speCode3: string | undefined;
    speCode4: string | undefined;
    speCode5: string | undefined;
    isEInvoice: boolean;
    address: string | undefined;
    country: string | undefined;
    city: string | undefined;
    town: string | undefined;
    tel1: string | undefined;
    tel2: string | undefined;
    gsm1: string | undefined;
    gsm2: string | undefined;
    fax: string | undefined;
    isEnteredShippingCost: boolean;
    invoiceType: string | undefined;
    shippingTypeArea: ShippingTypeArea;
    shippingRoute: ShippingRoute;
    shippingRouteId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.company = new Company();
            this.name = "";
            this.salesman = "";
            this.taxOffice = "";
            this.taxNumber = "";
            this.email = "";
            this.groupCode = "";
            this.speCode1 = "";
            this.speCode2 = "";
            this.speCode3 = "";
            this.speCode4 = "";
            this.speCode5 = "";
            this.isEInvoice = false;
            this.address = "";
            this.country = "";
            this.city = "";
            this.town = "";
            this.tel1 = "";
            this.tel2 = "";
            this.gsm1 = "";
            this.gsm2 = "";
            this.fax = "";
            this.isEnteredShippingCost = true;
            this.invoiceType = "0";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.companyId = _data["companyId"];
            this.erpEntegreId = _data["erpEntegreId"];
            this.code = _data["code"];
            this.name = _data["name"] !== undefined ? _data["name"] : "";
            this.salesman = _data["salesman"] !== undefined ? _data["salesman"] : "";
            this.taxOffice = _data["taxOffice"] !== undefined ? _data["taxOffice"] : "";
            this.taxNumber = _data["taxNumber"] !== undefined ? _data["taxNumber"] : "";
            this.email = _data["email"] !== undefined ? _data["email"] : "";
            this.groupCode = _data["groupCode"] !== undefined ? _data["groupCode"] : "";
            this.speCode1 = _data["speCode1"] !== undefined ? _data["speCode1"] : "";
            this.speCode2 = _data["speCode2"] !== undefined ? _data["speCode2"] : "";
            this.speCode3 = _data["speCode3"] !== undefined ? _data["speCode3"] : "";
            this.speCode4 = _data["speCode4"] !== undefined ? _data["speCode4"] : "";
            this.speCode5 = _data["speCode5"] !== undefined ? _data["speCode5"] : "";
            this.isEInvoice = _data["isEInvoice"] !== undefined ? _data["isEInvoice"] : false;
            this.address = _data["address"] !== undefined ? _data["address"] : "";
            this.country = _data["country"] !== undefined ? _data["country"] : "";
            this.city = _data["city"] !== undefined ? _data["city"] : "";
            this.town = _data["town"] !== undefined ? _data["town"] : "";
            this.tel1 = _data["tel1"] !== undefined ? _data["tel1"] : "";
            this.tel2 = _data["tel2"] !== undefined ? _data["tel2"] : "";
            this.gsm1 = _data["gsm1"] !== undefined ? _data["gsm1"] : "";
            this.gsm2 = _data["gsm2"] !== undefined ? _data["gsm2"] : "";
            this.fax = _data["fax"] !== undefined ? _data["fax"] : "";
            this.isEnteredShippingCost = _data["isEnteredShippingCost"] !== undefined ? _data["isEnteredShippingCost"] : true;
            this.invoiceType = _data["invoiceType"] !== undefined ? _data["invoiceType"] : "0";
            this.shippingTypeArea = _data["shippingTypeArea"] ? ShippingTypeArea.fromJS(_data["shippingTypeArea"]) : <any>undefined;
            this.shippingRoute = _data["shippingRoute"] ? ShippingRoute.fromJS(_data["shippingRoute"]) : <any>undefined;
            this.shippingRouteId = _data["shippingRouteId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Client {
        data = typeof data === 'object' ? data : {};
        let result = new Client();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["erpEntegreId"] = this.erpEntegreId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["salesman"] = this.salesman;
        data["taxOffice"] = this.taxOffice;
        data["taxNumber"] = this.taxNumber;
        data["email"] = this.email;
        data["groupCode"] = this.groupCode;
        data["speCode1"] = this.speCode1;
        data["speCode2"] = this.speCode2;
        data["speCode3"] = this.speCode3;
        data["speCode4"] = this.speCode4;
        data["speCode5"] = this.speCode5;
        data["isEInvoice"] = this.isEInvoice;
        data["address"] = this.address;
        data["country"] = this.country;
        data["city"] = this.city;
        data["town"] = this.town;
        data["tel1"] = this.tel1;
        data["tel2"] = this.tel2;
        data["gsm1"] = this.gsm1;
        data["gsm2"] = this.gsm2;
        data["fax"] = this.fax;
        data["isEnteredShippingCost"] = this.isEnteredShippingCost;
        data["invoiceType"] = this.invoiceType;
        data["shippingTypeArea"] = this.shippingTypeArea ? this.shippingTypeArea.toJSON() : <any>undefined;
        data["shippingRoute"] = this.shippingRoute ? this.shippingRoute.toJSON() : <any>undefined;
        data["shippingRouteId"] = this.shippingRouteId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Client {
        const json = this.toJSON();
        let result = new Client();
        result.init(json);
        return result;
    }
}

export interface IClient {
    company: Company;
    companyId: number;
    erpEntegreId: string;
    code: string;
    name: string | undefined;
    salesman: string | undefined;
    taxOffice: string | undefined;
    taxNumber: string | undefined;
    email: string | undefined;
    groupCode: string | undefined;
    speCode1: string | undefined;
    speCode2: string | undefined;
    speCode3: string | undefined;
    speCode4: string | undefined;
    speCode5: string | undefined;
    isEInvoice: boolean;
    address: string | undefined;
    country: string | undefined;
    city: string | undefined;
    town: string | undefined;
    tel1: string | undefined;
    tel2: string | undefined;
    gsm1: string | undefined;
    gsm2: string | undefined;
    fax: string | undefined;
    isEnteredShippingCost: boolean;
    invoiceType: string | undefined;
    shippingTypeArea: ShippingTypeArea;
    shippingRoute: ShippingRoute;
    shippingRouteId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class CommonSetting implements ICommonSetting {
    name: string;
    value: string | undefined;
    id: number;

    constructor(data?: ICommonSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CommonSetting {
        data = typeof data === 'object' ? data : {};
        let result = new CommonSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }

    clone(): CommonSetting {
        const json = this.toJSON();
        let result = new CommonSetting();
        result.init(json);
        return result;
    }
}

export interface ICommonSetting {
    name: string;
    value: string | undefined;
    id: number;
}

export class PdaVersion implements IPdaVersion {
    version: string;
    downloadLink: string;
    id: number;

    constructor(data?: IPdaVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.version = "";
            this.downloadLink = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] !== undefined ? _data["version"] : "";
            this.downloadLink = _data["downloadLink"] !== undefined ? _data["downloadLink"] : "";
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PdaVersion {
        data = typeof data === 'object' ? data : {};
        let result = new PdaVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["downloadLink"] = this.downloadLink;
        data["id"] = this.id;
        return data;
    }

    clone(): PdaVersion {
        const json = this.toJSON();
        let result = new PdaVersion();
        result.init(json);
        return result;
    }
}

export interface IPdaVersion {
    version: string;
    downloadLink: string;
    id: number;
}

export class GeoLocationDto implements IGeoLocationDto {
    country: string | undefined;
    city: string | undefined;
    town: string | undefined;
    id: number;

    constructor(data?: IGeoLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.city = _data["city"];
            this.town = _data["town"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GeoLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeoLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["city"] = this.city;
        data["town"] = this.town;
        data["id"] = this.id;
        return data;
    }

    clone(): GeoLocationDto {
        const json = this.toJSON();
        let result = new GeoLocationDto();
        result.init(json);
        return result;
    }
}

export interface IGeoLocationDto {
    country: string | undefined;
    city: string | undefined;
    town: string | undefined;
    id: number;
}

export class CompanyDto implements ICompanyDto {
    code: string | undefined;
    definition: string | undefined;
    id: number;

    constructor(data?: ICompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["id"] = this.id;
        return data;
    }

    clone(): CompanyDto {
        const json = this.toJSON();
        let result = new CompanyDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyDto {
    code: string | undefined;
    definition: string | undefined;
    id: number;
}

export class ErpType implements IErpType {
    code: string | undefined;
    definition: string | undefined;
    id: number;

    constructor(data?: IErpType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ErpType {
        data = typeof data === 'object' ? data : {};
        let result = new ErpType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["id"] = this.id;
        return data;
    }

    clone(): ErpType {
        const json = this.toJSON();
        let result = new ErpType();
        result.init(json);
        return result;
    }
}

export interface IErpType {
    code: string | undefined;
    definition: string | undefined;
    id: number;
}

export class CompanyDataSource implements ICompanyDataSource {
    company: Company;
    companyId: number;
    erpType: ErpType;
    erpTypeId: number;
    name: string | undefined;
    url: string | undefined;
    apiKey: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICompanyDataSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.company = new Company();
            this.erpType = new ErpType();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.companyId = _data["companyId"];
            this.erpType = _data["erpType"] ? ErpType.fromJS(_data["erpType"]) : new ErpType();
            this.erpTypeId = _data["erpTypeId"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.apiKey = _data["apiKey"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CompanyDataSource {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDataSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["erpType"] = this.erpType ? this.erpType.toJSON() : <any>undefined;
        data["erpTypeId"] = this.erpTypeId;
        data["name"] = this.name;
        data["url"] = this.url;
        data["apiKey"] = this.apiKey;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CompanyDataSource {
        const json = this.toJSON();
        let result = new CompanyDataSource();
        result.init(json);
        return result;
    }
}

export interface ICompanyDataSource {
    company: Company;
    companyId: number;
    erpType: ErpType;
    erpTypeId: number;
    name: string | undefined;
    url: string | undefined;
    apiKey: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export enum ErpDbType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class ErpDbConnection implements IErpDbConnection {
    companyDataSource: CompanyDataSource;
    name: string | undefined;
    ip: string | undefined;
    userName: string | undefined;
    password: string | undefined;
    port: number;
    database: string | undefined;
    encoding: string | undefined;
    type: ErpDbType;
    netsisBranchCode: number;
    logoCompany: number;
    logoTerm: number;
    erpServiceUrl: string | undefined;
    erpUser: string | undefined;
    erpPassword: string | undefined;
    isLogoGo: boolean;
    readonly connectionString: string | undefined;
    id: number;

    constructor(data?: IErpDbConnection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.companyDataSource = new CompanyDataSource();
            this.isLogoGo = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyDataSource = _data["companyDataSource"] ? CompanyDataSource.fromJS(_data["companyDataSource"]) : new CompanyDataSource();
            this.name = _data["name"];
            this.ip = _data["ip"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.port = _data["port"];
            this.database = _data["database"];
            this.encoding = _data["encoding"];
            this.type = _data["type"];
            this.netsisBranchCode = _data["netsisBranchCode"];
            this.logoCompany = _data["logoCompany"];
            this.logoTerm = _data["logoTerm"];
            this.erpServiceUrl = _data["erpServiceUrl"];
            this.erpUser = _data["erpUser"];
            this.erpPassword = _data["erpPassword"];
            this.isLogoGo = _data["isLogoGo"] !== undefined ? _data["isLogoGo"] : false;
            (<any>this).connectionString = _data["connectionString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ErpDbConnection {
        data = typeof data === 'object' ? data : {};
        let result = new ErpDbConnection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyDataSource"] = this.companyDataSource ? this.companyDataSource.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["ip"] = this.ip;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["port"] = this.port;
        data["database"] = this.database;
        data["encoding"] = this.encoding;
        data["type"] = this.type;
        data["netsisBranchCode"] = this.netsisBranchCode;
        data["logoCompany"] = this.logoCompany;
        data["logoTerm"] = this.logoTerm;
        data["erpServiceUrl"] = this.erpServiceUrl;
        data["erpUser"] = this.erpUser;
        data["erpPassword"] = this.erpPassword;
        data["isLogoGo"] = this.isLogoGo;
        data["connectionString"] = this.connectionString;
        data["id"] = this.id;
        return data;
    }

    clone(): ErpDbConnection {
        const json = this.toJSON();
        let result = new ErpDbConnection();
        result.init(json);
        return result;
    }
}

export interface IErpDbConnection {
    companyDataSource: CompanyDataSource;
    name: string | undefined;
    ip: string | undefined;
    userName: string | undefined;
    password: string | undefined;
    port: number;
    database: string | undefined;
    encoding: string | undefined;
    type: ErpDbType;
    netsisBranchCode: number;
    logoCompany: number;
    logoTerm: number;
    erpServiceUrl: string | undefined;
    erpUser: string | undefined;
    erpPassword: string | undefined;
    isLogoGo: boolean;
    connectionString: string | undefined;
    id: number;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class DashWaybillHeaderCountDto implements IDashWaybillHeaderCountDto {
    startedCount: number;
    finishedCount: number;
    totalCount: number;
    quantityProduct: number;
    readonly diffCount: number;
    quantityProductPlacement: number;
    quantityProductControl: number;
    quantityPlacementWaybill: number;
    quantityPlacementWaybillDetail: number;
    quantityControlWaybill: number;
    quantityControlWaybillDetail: number;
    startDate: Date | undefined;
    endDate: Date | undefined;

    constructor(data?: IDashWaybillHeaderCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startedCount = _data["startedCount"];
            this.finishedCount = _data["finishedCount"];
            this.totalCount = _data["totalCount"];
            this.quantityProduct = _data["quantityProduct"];
            (<any>this).diffCount = _data["diffCount"];
            this.quantityProductPlacement = _data["quantityProductPlacement"];
            this.quantityProductControl = _data["quantityProductControl"];
            this.quantityPlacementWaybill = _data["quantityPlacementWaybill"];
            this.quantityPlacementWaybillDetail = _data["quantityPlacementWaybillDetail"];
            this.quantityControlWaybill = _data["quantityControlWaybill"];
            this.quantityControlWaybillDetail = _data["quantityControlWaybillDetail"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DashWaybillHeaderCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashWaybillHeaderCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startedCount"] = this.startedCount;
        data["finishedCount"] = this.finishedCount;
        data["totalCount"] = this.totalCount;
        data["quantityProduct"] = this.quantityProduct;
        data["diffCount"] = this.diffCount;
        data["quantityProductPlacement"] = this.quantityProductPlacement;
        data["quantityProductControl"] = this.quantityProductControl;
        data["quantityPlacementWaybill"] = this.quantityPlacementWaybill;
        data["quantityPlacementWaybillDetail"] = this.quantityPlacementWaybillDetail;
        data["quantityControlWaybill"] = this.quantityControlWaybill;
        data["quantityControlWaybillDetail"] = this.quantityControlWaybillDetail;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): DashWaybillHeaderCountDto {
        const json = this.toJSON();
        let result = new DashWaybillHeaderCountDto();
        result.init(json);
        return result;
    }
}

export interface IDashWaybillHeaderCountDto {
    startedCount: number;
    finishedCount: number;
    totalCount: number;
    quantityProduct: number;
    diffCount: number;
    quantityProductPlacement: number;
    quantityProductControl: number;
    quantityPlacementWaybill: number;
    quantityPlacementWaybillDetail: number;
    quantityControlWaybill: number;
    quantityControlWaybillDetail: number;
    startDate: Date | undefined;
    endDate: Date | undefined;
}

export enum OrderType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class StorageType implements IStorageType {
    code: string;
    definition: string;
    id: number;

    constructor(data?: IStorageType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StorageType {
        data = typeof data === 'object' ? data : {};
        let result = new StorageType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["id"] = this.id;
        return data;
    }

    clone(): StorageType {
        const json = this.toJSON();
        let result = new StorageType();
        result.init(json);
        return result;
    }
}

export interface IStorageType {
    code: string;
    definition: string;
    id: number;
}

export class Storage implements IStorage {
    warehouse: Warehouse;
    warehouseId: number;
    code: string;
    definition: string;
    storageType: StorageType;
    storageTypeId: number;
    erpEntegreId: string | undefined;
    dispatchStorage: Storage;
    dispatchStorageId: number | undefined;
    id: number;

    constructor(data?: IStorage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.warehouse = new Warehouse();
            this.storageType = new StorageType();
            this.erpEntegreId = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.warehouseId = _data["warehouseId"];
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.storageType = _data["storageType"] ? StorageType.fromJS(_data["storageType"]) : new StorageType();
            this.storageTypeId = _data["storageTypeId"];
            this.erpEntegreId = _data["erpEntegreId"] !== undefined ? _data["erpEntegreId"] : "";
            this.dispatchStorage = _data["dispatchStorage"] ? Storage.fromJS(_data["dispatchStorage"]) : <any>undefined;
            this.dispatchStorageId = _data["dispatchStorageId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Storage {
        data = typeof data === 'object' ? data : {};
        let result = new Storage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["storageType"] = this.storageType ? this.storageType.toJSON() : <any>undefined;
        data["storageTypeId"] = this.storageTypeId;
        data["erpEntegreId"] = this.erpEntegreId;
        data["dispatchStorage"] = this.dispatchStorage ? this.dispatchStorage.toJSON() : <any>undefined;
        data["dispatchStorageId"] = this.dispatchStorageId;
        data["id"] = this.id;
        return data;
    }

    clone(): Storage {
        const json = this.toJSON();
        let result = new Storage();
        result.init(json);
        return result;
    }
}

export interface IStorage {
    warehouse: Warehouse;
    warehouseId: number;
    code: string;
    definition: string;
    storageType: StorageType;
    storageTypeId: number;
    erpEntegreId: string | undefined;
    dispatchStorage: Storage;
    dispatchStorageId: number | undefined;
    id: number;
}

export enum ControlPointType {
    _1 = 1,
    _2 = 2,
}

export class ControlPoint implements IControlPoint {
    warehouse: Warehouse;
    warehouseId: number;
    code: string;
    definition: string;
    count: number;
    type: ControlPointType;
    id: number;

    constructor(data?: IControlPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.warehouse = new Warehouse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.warehouseId = _data["warehouseId"];
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.count = _data["count"];
            this.type = _data["type"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ControlPoint {
        data = typeof data === 'object' ? data : {};
        let result = new ControlPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["count"] = this.count;
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }

    clone(): ControlPoint {
        const json = this.toJSON();
        let result = new ControlPoint();
        result.init(json);
        return result;
    }
}

export interface IControlPoint {
    warehouse: Warehouse;
    warehouseId: number;
    code: string;
    definition: string;
    count: number;
    type: ControlPointType;
    id: number;
}

export class WorkActivityType implements IWorkActivityType {
    code: string | undefined;
    definition: string | undefined;
    id: number;

    constructor(data?: IWorkActivityType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WorkActivityType {
        data = typeof data === 'object' ? data : {};
        let result = new WorkActivityType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["id"] = this.id;
        return data;
    }

    clone(): WorkActivityType {
        const json = this.toJSON();
        let result = new WorkActivityType();
        result.init(json);
        return result;
    }
}

export interface IWorkActivityType {
    code: string | undefined;
    definition: string | undefined;
    id: number;
}

export class ShelfType implements IShelfType {
    code: string | undefined;
    definition: string | undefined;
    priority: number;
    id: number;

    constructor(data?: IShelfType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.priority = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.priority = _data["priority"] !== undefined ? _data["priority"] : 0;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShelfType {
        data = typeof data === 'object' ? data : {};
        let result = new ShelfType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["priority"] = this.priority;
        data["id"] = this.id;
        return data;
    }

    clone(): ShelfType {
        const json = this.toJSON();
        let result = new ShelfType();
        result.init(json);
        return result;
    }
}

export interface IShelfType {
    code: string | undefined;
    definition: string | undefined;
    priority: number;
    id: number;
}

export class Shelf implements IShelf {
    storage: Storage;
    storageId: number;
    region: string;
    street: number;
    apartment: string;
    apartmentNo: number;
    floor: string;
    floorNo: number;
    sequence: string;
    sequenceNo: number;
    isActive: boolean;
    isBlocked: boolean;
    width: number;
    length: number;
    height: number;
    hasPriority: boolean;
    shelfType: ShelfType;
    shelfTypeId: number;
    weight: number;
    fullAddress: string | undefined;
    shelfUserType: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IShelf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.storage = new Storage();
            this.apartment = "A";
            this.floor = "K";
            this.sequence = "S";
            this.isActive = true;
            this.isBlocked = false;
            this.width = 0;
            this.length = 0;
            this.height = 0;
            this.hasPriority = false;
            this.shelfType = new ShelfType();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storage = _data["storage"] ? Storage.fromJS(_data["storage"]) : new Storage();
            this.storageId = _data["storageId"];
            this.region = _data["region"];
            this.street = _data["street"];
            this.apartment = _data["apartment"] !== undefined ? _data["apartment"] : "A";
            this.apartmentNo = _data["apartmentNo"];
            this.floor = _data["floor"] !== undefined ? _data["floor"] : "K";
            this.floorNo = _data["floorNo"];
            this.sequence = _data["sequence"] !== undefined ? _data["sequence"] : "S";
            this.sequenceNo = _data["sequenceNo"];
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : true;
            this.isBlocked = _data["isBlocked"] !== undefined ? _data["isBlocked"] : false;
            this.width = _data["width"] !== undefined ? _data["width"] : 0;
            this.length = _data["length"] !== undefined ? _data["length"] : 0;
            this.height = _data["height"] !== undefined ? _data["height"] : 0;
            this.hasPriority = _data["hasPriority"] !== undefined ? _data["hasPriority"] : false;
            this.shelfType = _data["shelfType"] ? ShelfType.fromJS(_data["shelfType"]) : new ShelfType();
            this.shelfTypeId = _data["shelfTypeId"];
            this.weight = _data["weight"];
            this.fullAddress = _data["fullAddress"];
            this.shelfUserType = _data["shelfUserType"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Shelf {
        data = typeof data === 'object' ? data : {};
        let result = new Shelf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["storageId"] = this.storageId;
        data["region"] = this.region;
        data["street"] = this.street;
        data["apartment"] = this.apartment;
        data["apartmentNo"] = this.apartmentNo;
        data["floor"] = this.floor;
        data["floorNo"] = this.floorNo;
        data["sequence"] = this.sequence;
        data["sequenceNo"] = this.sequenceNo;
        data["isActive"] = this.isActive;
        data["isBlocked"] = this.isBlocked;
        data["width"] = this.width;
        data["length"] = this.length;
        data["height"] = this.height;
        data["hasPriority"] = this.hasPriority;
        data["shelfType"] = this.shelfType ? this.shelfType.toJSON() : <any>undefined;
        data["shelfTypeId"] = this.shelfTypeId;
        data["weight"] = this.weight;
        data["fullAddress"] = this.fullAddress;
        data["shelfUserType"] = this.shelfUserType;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Shelf {
        const json = this.toJSON();
        let result = new Shelf();
        result.init(json);
        return result;
    }
}

export interface IShelf {
    storage: Storage;
    storageId: number;
    region: string;
    street: number;
    apartment: string;
    apartmentNo: number;
    floor: string;
    floorNo: number;
    sequence: string;
    sequenceNo: number;
    isActive: boolean;
    isBlocked: boolean;
    width: number;
    length: number;
    height: number;
    hasPriority: boolean;
    shelfType: ShelfType;
    shelfTypeId: number;
    weight: number;
    fullAddress: string | undefined;
    shelfUserType: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export enum WaybillType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class WorkActivity implements IWorkActivity {
    code: string | undefined;
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    storage: Storage;
    storageId: number | undefined;
    client: Client;
    clientId: number | undefined;
    workActivityType: WorkActivityType;
    workActivityTypeId: number;
    startTime: Date | undefined;
    finishTime: Date | undefined;
    isStarted: boolean;
    isFinished: boolean;
    isLocked: boolean;
    isAllowAddDetail: boolean;
    isInspected: boolean;
    isAllowRemoveDetail: boolean;
    hasPriority: boolean;
    isWillBeContinue: boolean;
    willBeContinueCreateTime: Date | undefined;
    willBeContinueUserId: number | undefined;
    replenishmentShelf: Shelf;
    replenishmentShelfId: number | undefined;
    acceptWaybillType: WaybillType;
    shippingType: ShippingType;
    notes: string | undefined;
    weight: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IWorkActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.company = new Company();
            this.warehouse = new Warehouse();
            this.workActivityType = new WorkActivityType();
            this.isStarted = false;
            this.isFinished = false;
            this.isLocked = false;
            this.isAllowAddDetail = true;
            this.isInspected = false;
            this.isAllowRemoveDetail = true;
            this.hasPriority = false;
            this.isWillBeContinue = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.companyId = _data["companyId"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.warehouseId = _data["warehouseId"];
            this.storage = _data["storage"] ? Storage.fromJS(_data["storage"]) : <any>undefined;
            this.storageId = _data["storageId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>undefined;
            this.clientId = _data["clientId"];
            this.workActivityType = _data["workActivityType"] ? WorkActivityType.fromJS(_data["workActivityType"]) : new WorkActivityType();
            this.workActivityTypeId = _data["workActivityTypeId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : <any>undefined;
            this.isStarted = _data["isStarted"] !== undefined ? _data["isStarted"] : false;
            this.isFinished = _data["isFinished"] !== undefined ? _data["isFinished"] : false;
            this.isLocked = _data["isLocked"] !== undefined ? _data["isLocked"] : false;
            this.isAllowAddDetail = _data["isAllowAddDetail"] !== undefined ? _data["isAllowAddDetail"] : true;
            this.isInspected = _data["isInspected"] !== undefined ? _data["isInspected"] : false;
            this.isAllowRemoveDetail = _data["isAllowRemoveDetail"] !== undefined ? _data["isAllowRemoveDetail"] : true;
            this.hasPriority = _data["hasPriority"] !== undefined ? _data["hasPriority"] : false;
            this.isWillBeContinue = _data["isWillBeContinue"] !== undefined ? _data["isWillBeContinue"] : false;
            this.willBeContinueCreateTime = _data["willBeContinueCreateTime"] ? new Date(_data["willBeContinueCreateTime"].toString()) : <any>undefined;
            this.willBeContinueUserId = _data["willBeContinueUserId"];
            this.replenishmentShelf = _data["replenishmentShelf"] ? Shelf.fromJS(_data["replenishmentShelf"]) : <any>undefined;
            this.replenishmentShelfId = _data["replenishmentShelfId"];
            this.acceptWaybillType = _data["acceptWaybillType"];
            this.shippingType = _data["shippingType"] ? ShippingType.fromJS(_data["shippingType"]) : <any>undefined;
            this.notes = _data["notes"];
            this.weight = _data["weight"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WorkActivity {
        data = typeof data === 'object' ? data : {};
        let result = new WorkActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["storageId"] = this.storageId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["workActivityType"] = this.workActivityType ? this.workActivityType.toJSON() : <any>undefined;
        data["workActivityTypeId"] = this.workActivityTypeId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["isLocked"] = this.isLocked;
        data["isAllowAddDetail"] = this.isAllowAddDetail;
        data["isInspected"] = this.isInspected;
        data["isAllowRemoveDetail"] = this.isAllowRemoveDetail;
        data["hasPriority"] = this.hasPriority;
        data["isWillBeContinue"] = this.isWillBeContinue;
        data["willBeContinueCreateTime"] = this.willBeContinueCreateTime ? this.willBeContinueCreateTime.toISOString() : <any>undefined;
        data["willBeContinueUserId"] = this.willBeContinueUserId;
        data["replenishmentShelf"] = this.replenishmentShelf ? this.replenishmentShelf.toJSON() : <any>undefined;
        data["replenishmentShelfId"] = this.replenishmentShelfId;
        data["acceptWaybillType"] = this.acceptWaybillType;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : <any>undefined;
        data["notes"] = this.notes;
        data["weight"] = this.weight;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): WorkActivity {
        const json = this.toJSON();
        let result = new WorkActivity();
        result.init(json);
        return result;
    }
}

export interface IWorkActivity {
    code: string | undefined;
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    storage: Storage;
    storageId: number | undefined;
    client: Client;
    clientId: number | undefined;
    workActivityType: WorkActivityType;
    workActivityTypeId: number;
    startTime: Date | undefined;
    finishTime: Date | undefined;
    isStarted: boolean;
    isFinished: boolean;
    isLocked: boolean;
    isAllowAddDetail: boolean;
    isInspected: boolean;
    isAllowRemoveDetail: boolean;
    hasPriority: boolean;
    isWillBeContinue: boolean;
    willBeContinueCreateTime: Date | undefined;
    willBeContinueUserId: number | undefined;
    replenishmentShelf: Shelf;
    replenishmentShelfId: number | undefined;
    acceptWaybillType: WaybillType;
    shippingType: ShippingType;
    notes: string | undefined;
    weight: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class UserToken implements IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: Date | undefined;
    id: number;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? new Date(_data["expireDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: Date | undefined;
    id: number;
}

export class UserLogin implements IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["id"] = this.id;
        return data;
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;
}

export class UserRole implements IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class UserClaim implements IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UserPermissionSetting {
        const json = this.toJSON();
        let result = new UserPermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class Setting implements ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class User implements IUser {
    companyId: number;
    warehouseId: number;
    printPointName: string | undefined;
    isChangeWarehouse: boolean;
    isChangeCompany: boolean;
    acceptWaybillType: WaybillType;
    userShelfType: string | undefined;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    readonly fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: Date | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.companyId = 0;
            this.warehouseId = 0;
            this.printPointName = "";
            this.isChangeWarehouse = true;
            this.isChangeCompany = true;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"] !== undefined ? _data["companyId"] : 0;
            this.warehouseId = _data["warehouseId"] !== undefined ? _data["warehouseId"] : 0;
            this.printPointName = _data["printPointName"] !== undefined ? _data["printPointName"] : "";
            this.isChangeWarehouse = _data["isChangeWarehouse"] !== undefined ? _data["isChangeWarehouse"] : true;
            this.isChangeCompany = _data["isChangeCompany"] !== undefined ? _data["isChangeCompany"] : true;
            this.acceptWaybillType = _data["acceptWaybillType"];
            this.userShelfType = _data["userShelfType"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            (<any>this).fullName = _data["fullName"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? new Date(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["warehouseId"] = this.warehouseId;
        data["printPointName"] = this.printPointName;
        data["isChangeWarehouse"] = this.isChangeWarehouse;
        data["isChangeCompany"] = this.isChangeCompany;
        data["acceptWaybillType"] = this.acceptWaybillType;
        data["userShelfType"] = this.userShelfType;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    companyId: number;
    warehouseId: number;
    printPointName: string | undefined;
    isChangeWarehouse: boolean;
    isChangeCompany: boolean;
    acceptWaybillType: WaybillType;
    userShelfType: string | undefined;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: Date | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class GeoLocation_CityLojistik implements IGeoLocation_CityLojistik {
    cityCode: number;
    townCode: number;
    city: string | undefined;
    town: string | undefined;
    id: number;

    constructor(data?: IGeoLocation_CityLojistik) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityCode = _data["cityCode"];
            this.townCode = _data["townCode"];
            this.city = _data["city"];
            this.town = _data["town"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GeoLocation_CityLojistik {
        data = typeof data === 'object' ? data : {};
        let result = new GeoLocation_CityLojistik();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityCode"] = this.cityCode;
        data["townCode"] = this.townCode;
        data["city"] = this.city;
        data["town"] = this.town;
        data["id"] = this.id;
        return data;
    }

    clone(): GeoLocation_CityLojistik {
        const json = this.toJSON();
        let result = new GeoLocation_CityLojistik();
        result.init(json);
        return result;
    }
}

export interface IGeoLocation_CityLojistik {
    cityCode: number;
    townCode: number;
    city: string | undefined;
    town: string | undefined;
    id: number;
}

export class ClientAddress implements IClientAddress {
    client: Client;
    clientId: number;
    no: number;
    code: number;
    definition: string | undefined;
    name: string | undefined;
    address: string | undefined;
    town: string | undefined;
    city: string | undefined;
    country: string | undefined;
    postalCode: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    notes: string | undefined;
    isDefault: boolean;
    geoLocation_CityLojistik: GeoLocation_CityLojistik;
    geoLocation_CityLojistikId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IClientAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.client = new Client();
            this.definition = "";
            this.name = "";
            this.address = "";
            this.town = "";
            this.city = "";
            this.country = "";
            this.postalCode = "";
            this.phone = "";
            this.email = "";
            this.notes = "";
            this.isDefault = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : new Client();
            this.clientId = _data["clientId"];
            this.no = _data["no"];
            this.code = _data["code"];
            this.definition = _data["definition"] !== undefined ? _data["definition"] : "";
            this.name = _data["name"] !== undefined ? _data["name"] : "";
            this.address = _data["address"] !== undefined ? _data["address"] : "";
            this.town = _data["town"] !== undefined ? _data["town"] : "";
            this.city = _data["city"] !== undefined ? _data["city"] : "";
            this.country = _data["country"] !== undefined ? _data["country"] : "";
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : "";
            this.phone = _data["phone"] !== undefined ? _data["phone"] : "";
            this.email = _data["email"] !== undefined ? _data["email"] : "";
            this.notes = _data["notes"] !== undefined ? _data["notes"] : "";
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : false;
            this.geoLocation_CityLojistik = _data["geoLocation_CityLojistik"] ? GeoLocation_CityLojistik.fromJS(_data["geoLocation_CityLojistik"]) : <any>undefined;
            this.geoLocation_CityLojistikId = _data["geoLocation_CityLojistikId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClientAddress {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["no"] = this.no;
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["name"] = this.name;
        data["address"] = this.address;
        data["town"] = this.town;
        data["city"] = this.city;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["notes"] = this.notes;
        data["isDefault"] = this.isDefault;
        data["geoLocation_CityLojistik"] = this.geoLocation_CityLojistik ? this.geoLocation_CityLojistik.toJSON() : <any>undefined;
        data["geoLocation_CityLojistikId"] = this.geoLocation_CityLojistikId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ClientAddress {
        const json = this.toJSON();
        let result = new ClientAddress();
        result.init(json);
        return result;
    }
}

export interface IClientAddress {
    client: Client;
    clientId: number;
    no: number;
    code: number;
    definition: string | undefined;
    name: string | undefined;
    address: string | undefined;
    town: string | undefined;
    city: string | undefined;
    country: string | undefined;
    postalCode: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    notes: string | undefined;
    isDefault: boolean;
    geoLocation_CityLojistik: GeoLocation_CityLojistik;
    geoLocation_CityLojistikId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class DeliveryHeader implements IDeliveryHeader {
    company: Company;
    companyId: number | undefined;
    warehouse: Warehouse;
    warehouseId: number;
    shippingType: ShippingType;
    shippingTypeId: number | undefined;
    receiver: string | undefined;
    receiverTel: string | undefined;
    licensePlate: string | undefined;
    documentNo: string | undefined;
    isStarted: boolean;
    isFinished: boolean;
    startTime: Date | undefined;
    finishTime: Date | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IDeliveryHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.warehouse = new Warehouse();
            this.receiver = "";
            this.receiverTel = "";
            this.licensePlate = "";
            this.documentNo = "";
            this.isStarted = false;
            this.isFinished = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.companyId = _data["companyId"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.warehouseId = _data["warehouseId"];
            this.shippingType = _data["shippingType"] ? ShippingType.fromJS(_data["shippingType"]) : <any>undefined;
            this.shippingTypeId = _data["shippingTypeId"];
            this.receiver = _data["receiver"] !== undefined ? _data["receiver"] : "";
            this.receiverTel = _data["receiverTel"] !== undefined ? _data["receiverTel"] : "";
            this.licensePlate = _data["licensePlate"] !== undefined ? _data["licensePlate"] : "";
            this.documentNo = _data["documentNo"] !== undefined ? _data["documentNo"] : "";
            this.isStarted = _data["isStarted"] !== undefined ? _data["isStarted"] : false;
            this.isFinished = _data["isFinished"] !== undefined ? _data["isFinished"] : false;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeliveryHeader {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : <any>undefined;
        data["shippingTypeId"] = this.shippingTypeId;
        data["receiver"] = this.receiver;
        data["receiverTel"] = this.receiverTel;
        data["licensePlate"] = this.licensePlate;
        data["documentNo"] = this.documentNo;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): DeliveryHeader {
        const json = this.toJSON();
        let result = new DeliveryHeader();
        result.init(json);
        return result;
    }
}

export interface IDeliveryHeader {
    company: Company;
    companyId: number | undefined;
    warehouse: Warehouse;
    warehouseId: number;
    shippingType: ShippingType;
    shippingTypeId: number | undefined;
    receiver: string | undefined;
    receiverTel: string | undefined;
    licensePlate: string | undefined;
    documentNo: string | undefined;
    isStarted: boolean;
    isFinished: boolean;
    startTime: Date | undefined;
    finishTime: Date | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export enum EDocumentType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class OrderHeader implements IOrderHeader {
    erpEntegreId: string | undefined;
    type: OrderType;
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    storage: Storage;
    storageId: number;
    client: Client;
    clientId: number;
    shippingType: ShippingType;
    shippingTypeId: number | undefined;
    shippingRoute: ShippingRoute;
    shippingRouteId: number | undefined;
    controlPoint: ControlPoint;
    controlPointId: number | undefined;
    companyDataSource: CompanyDataSource;
    companyDataSourceId: number;
    documentNo: string | undefined;
    documentNo2: string | undefined;
    documentDate: Date;
    shipmentDate: Date;
    notes: string | undefined;
    deliveryAdress1: string | undefined;
    deliveryAdress2: string | undefined;
    workActivity: WorkActivity;
    workActivityId: number | undefined;
    startDate: Date | undefined;
    finishDate: Date | undefined;
    isStarted: boolean;
    isFinished: boolean;
    isLocked: boolean;
    collectPoint: string | undefined;
    isShipped: boolean;
    shippingDate: Date | undefined;
    isCancelled: boolean;
    cancelDate: Date | undefined;
    cancelReason: string | undefined;
    shippingCost: number;
    shippingCostQuantity: number;
    isShippingPaymentByCustomer: boolean;
    cargoEntegrationResult: string | undefined;
    isInvoicePrinted: boolean;
    invoicePrintTime: Date | undefined;
    isReplacement: boolean;
    invoiceSend: boolean;
    picker: User;
    pickerId: number | undefined;
    controller: User;
    controllerId: number | undefined;
    shipper: User;
    shipperId: number | undefined;
    documentNo_Seri: string | undefined;
    documentNo_Sira: string | undefined;
    b2BDocumentNo: string | undefined;
    warrantyNo: string | undefined;
    salesmanNot: string | undefined;
    shippingName: string | undefined;
    shippingAddress: string | undefined;
    shippingAddress2: string | undefined;
    shippingCountry: string | undefined;
    shippingCity: string | undefined;
    shippingTown: string | undefined;
    clientAddress: ClientAddress;
    clientAddressId: number | undefined;
    shippingCompany: ShippingCompany;
    shippingCompanyId: number | undefined;
    shippingCompanyBarcodes: string | undefined;
    printPointNameInvoice: string | undefined;
    invoicePrintQuantity: number;
    controlStartTime: Date | undefined;
    controlFinishTime: Date | undefined;
    canceledShippingCostReason: string | undefined;
    canceledShippingCostUser: User;
    deci: number;
    kg: number;
    deciForEachPackage: string | undefined;
    hasPriority: boolean;
    weight: number;
    isManuel: boolean;
    listForPicking: boolean;
    quantityPackage: number;
    quantityBundle: number;
    quantityPalette: number;
    quantityPackTotal: number;
    isExport: boolean;
    willBeShippingCost: boolean;
    shippingCostCanChange: boolean;
    deliveryHeader: DeliveryHeader;
    deliveryHeaderId: number | undefined;
    willBeInvoiced: boolean;
    isInvoicing: boolean;
    invoicingStartTime: Date | undefined;
    isInvoiced: boolean;
    invoiceDate: Date | undefined;
    invoiceNo: string | undefined;
    invoiceType: EDocumentType;
    invoiceNoGib: string | undefined;
    waybillNo: string | undefined;
    waybillNoGib: string | undefined;
    invoiceTotalPrice: number;
    invoiceTotalPriceWithVat: number;
    rowCount: number;
    productCount: number;
    quantityCount: number;
    shippedProductCount: number;
    shippedQuantityCount: number;
    quantityRow: number;
    quantityTotal: number;
    isInvoiceCombined: boolean;
    invoiceLater: boolean;
    combinedOrdersHeaderId: number;
    shippingTypeArea: ShippingTypeArea;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.erpEntegreId = "";
            this.company = new Company();
            this.warehouse = new Warehouse();
            this.storage = new Storage();
            this.client = new Client();
            this.companyDataSource = new CompanyDataSource();
            this.documentNo = "";
            this.documentNo2 = "";
            this.notes = "";
            this.deliveryAdress1 = "";
            this.deliveryAdress2 = "";
            this.isStarted = false;
            this.isFinished = false;
            this.isLocked = false;
            this.isShipped = false;
            this.isCancelled = false;
            this.cancelReason = "";
            this.shippingCost = 0;
            this.shippingCostQuantity = 0;
            this.isShippingPaymentByCustomer = false;
            this.cargoEntegrationResult = "";
            this.isInvoicePrinted = false;
            this.isReplacement = false;
            this.b2BDocumentNo = "";
            this.warrantyNo = "";
            this.shippingName = "";
            this.shippingAddress = "";
            this.shippingCountry = "";
            this.shippingCity = "";
            this.shippingTown = "";
            this.printPointNameInvoice = "";
            this.invoicePrintQuantity = 0;
            this.hasPriority = false;
            this.isManuel = false;
            this.listForPicking = true;
            this.quantityPackage = 0;
            this.quantityBundle = 0;
            this.quantityPalette = 0;
            this.isExport = false;
            this.willBeShippingCost = false;
            this.shippingCostCanChange = false;
            this.willBeInvoiced = true;
            this.isInvoicing = false;
            this.isInvoiced = false;
            this.invoiceNo = "";
            this.invoiceNoGib = "";
            this.waybillNo = "";
            this.waybillNoGib = "";
            this.invoiceTotalPrice = 0;
            this.invoiceTotalPriceWithVat = 0;
            this.quantityRow = 0;
            this.quantityTotal = 0;
            this.isInvoiceCombined = false;
            this.invoiceLater = false;
            this.combinedOrdersHeaderId = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.erpEntegreId = _data["erpEntegreId"] !== undefined ? _data["erpEntegreId"] : "";
            this.type = _data["type"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.companyId = _data["companyId"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.warehouseId = _data["warehouseId"];
            this.storage = _data["storage"] ? Storage.fromJS(_data["storage"]) : new Storage();
            this.storageId = _data["storageId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : new Client();
            this.clientId = _data["clientId"];
            this.shippingType = _data["shippingType"] ? ShippingType.fromJS(_data["shippingType"]) : <any>undefined;
            this.shippingTypeId = _data["shippingTypeId"];
            this.shippingRoute = _data["shippingRoute"] ? ShippingRoute.fromJS(_data["shippingRoute"]) : <any>undefined;
            this.shippingRouteId = _data["shippingRouteId"];
            this.controlPoint = _data["controlPoint"] ? ControlPoint.fromJS(_data["controlPoint"]) : <any>undefined;
            this.controlPointId = _data["controlPointId"];
            this.companyDataSource = _data["companyDataSource"] ? CompanyDataSource.fromJS(_data["companyDataSource"]) : new CompanyDataSource();
            this.companyDataSourceId = _data["companyDataSourceId"];
            this.documentNo = _data["documentNo"] !== undefined ? _data["documentNo"] : "";
            this.documentNo2 = _data["documentNo2"] !== undefined ? _data["documentNo2"] : "";
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.shipmentDate = _data["shipmentDate"] ? new Date(_data["shipmentDate"].toString()) : <any>undefined;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : "";
            this.deliveryAdress1 = _data["deliveryAdress1"] !== undefined ? _data["deliveryAdress1"] : "";
            this.deliveryAdress2 = _data["deliveryAdress2"] !== undefined ? _data["deliveryAdress2"] : "";
            this.workActivity = _data["workActivity"] ? WorkActivity.fromJS(_data["workActivity"]) : <any>undefined;
            this.workActivityId = _data["workActivityId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.finishDate = _data["finishDate"] ? new Date(_data["finishDate"].toString()) : <any>undefined;
            this.isStarted = _data["isStarted"] !== undefined ? _data["isStarted"] : false;
            this.isFinished = _data["isFinished"] !== undefined ? _data["isFinished"] : false;
            this.isLocked = _data["isLocked"] !== undefined ? _data["isLocked"] : false;
            this.collectPoint = _data["collectPoint"];
            this.isShipped = _data["isShipped"] !== undefined ? _data["isShipped"] : false;
            this.shippingDate = _data["shippingDate"] ? new Date(_data["shippingDate"].toString()) : <any>undefined;
            this.isCancelled = _data["isCancelled"] !== undefined ? _data["isCancelled"] : false;
            this.cancelDate = _data["cancelDate"] ? new Date(_data["cancelDate"].toString()) : <any>undefined;
            this.cancelReason = _data["cancelReason"] !== undefined ? _data["cancelReason"] : "";
            this.shippingCost = _data["shippingCost"] !== undefined ? _data["shippingCost"] : 0;
            this.shippingCostQuantity = _data["shippingCostQuantity"] !== undefined ? _data["shippingCostQuantity"] : 0;
            this.isShippingPaymentByCustomer = _data["isShippingPaymentByCustomer"] !== undefined ? _data["isShippingPaymentByCustomer"] : false;
            this.cargoEntegrationResult = _data["cargoEntegrationResult"] !== undefined ? _data["cargoEntegrationResult"] : "";
            this.isInvoicePrinted = _data["isInvoicePrinted"] !== undefined ? _data["isInvoicePrinted"] : false;
            this.invoicePrintTime = _data["invoicePrintTime"] ? new Date(_data["invoicePrintTime"].toString()) : <any>undefined;
            this.isReplacement = _data["isReplacement"] !== undefined ? _data["isReplacement"] : false;
            this.invoiceSend = _data["invoiceSend"];
            this.picker = _data["picker"] ? User.fromJS(_data["picker"]) : <any>undefined;
            this.pickerId = _data["pickerId"];
            this.controller = _data["controller"] ? User.fromJS(_data["controller"]) : <any>undefined;
            this.controllerId = _data["controllerId"];
            this.shipper = _data["shipper"] ? User.fromJS(_data["shipper"]) : <any>undefined;
            this.shipperId = _data["shipperId"];
            this.documentNo_Seri = _data["documentNo_Seri"];
            this.documentNo_Sira = _data["documentNo_Sira"];
            this.b2BDocumentNo = _data["b2BDocumentNo"] !== undefined ? _data["b2BDocumentNo"] : "";
            this.warrantyNo = _data["warrantyNo"] !== undefined ? _data["warrantyNo"] : "";
            this.salesmanNot = _data["salesmanNot"];
            this.shippingName = _data["shippingName"] !== undefined ? _data["shippingName"] : "";
            this.shippingAddress = _data["shippingAddress"] !== undefined ? _data["shippingAddress"] : "";
            this.shippingAddress2 = _data["shippingAddress2"];
            this.shippingCountry = _data["shippingCountry"] !== undefined ? _data["shippingCountry"] : "";
            this.shippingCity = _data["shippingCity"] !== undefined ? _data["shippingCity"] : "";
            this.shippingTown = _data["shippingTown"] !== undefined ? _data["shippingTown"] : "";
            this.clientAddress = _data["clientAddress"] ? ClientAddress.fromJS(_data["clientAddress"]) : <any>undefined;
            this.clientAddressId = _data["clientAddressId"];
            this.shippingCompany = _data["shippingCompany"] ? ShippingCompany.fromJS(_data["shippingCompany"]) : <any>undefined;
            this.shippingCompanyId = _data["shippingCompanyId"];
            this.shippingCompanyBarcodes = _data["shippingCompanyBarcodes"];
            this.printPointNameInvoice = _data["printPointNameInvoice"] !== undefined ? _data["printPointNameInvoice"] : "";
            this.invoicePrintQuantity = _data["invoicePrintQuantity"] !== undefined ? _data["invoicePrintQuantity"] : 0;
            this.controlStartTime = _data["controlStartTime"] ? new Date(_data["controlStartTime"].toString()) : <any>undefined;
            this.controlFinishTime = _data["controlFinishTime"] ? new Date(_data["controlFinishTime"].toString()) : <any>undefined;
            this.canceledShippingCostReason = _data["canceledShippingCostReason"];
            this.canceledShippingCostUser = _data["canceledShippingCostUser"] ? User.fromJS(_data["canceledShippingCostUser"]) : <any>undefined;
            this.deci = _data["deci"];
            this.kg = _data["kg"];
            this.deciForEachPackage = _data["deciForEachPackage"];
            this.hasPriority = _data["hasPriority"] !== undefined ? _data["hasPriority"] : false;
            this.weight = _data["weight"];
            this.isManuel = _data["isManuel"] !== undefined ? _data["isManuel"] : false;
            this.listForPicking = _data["listForPicking"] !== undefined ? _data["listForPicking"] : true;
            this.quantityPackage = _data["quantityPackage"] !== undefined ? _data["quantityPackage"] : 0;
            this.quantityBundle = _data["quantityBundle"] !== undefined ? _data["quantityBundle"] : 0;
            this.quantityPalette = _data["quantityPalette"] !== undefined ? _data["quantityPalette"] : 0;
            this.quantityPackTotal = _data["quantityPackTotal"];
            this.isExport = _data["isExport"] !== undefined ? _data["isExport"] : false;
            this.willBeShippingCost = _data["willBeShippingCost"] !== undefined ? _data["willBeShippingCost"] : false;
            this.shippingCostCanChange = _data["shippingCostCanChange"] !== undefined ? _data["shippingCostCanChange"] : false;
            this.deliveryHeader = _data["deliveryHeader"] ? DeliveryHeader.fromJS(_data["deliveryHeader"]) : <any>undefined;
            this.deliveryHeaderId = _data["deliveryHeaderId"];
            this.willBeInvoiced = _data["willBeInvoiced"] !== undefined ? _data["willBeInvoiced"] : true;
            this.isInvoicing = _data["isInvoicing"] !== undefined ? _data["isInvoicing"] : false;
            this.invoicingStartTime = _data["invoicingStartTime"] ? new Date(_data["invoicingStartTime"].toString()) : <any>undefined;
            this.isInvoiced = _data["isInvoiced"] !== undefined ? _data["isInvoiced"] : false;
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            this.invoiceNo = _data["invoiceNo"] !== undefined ? _data["invoiceNo"] : "";
            this.invoiceType = _data["invoiceType"];
            this.invoiceNoGib = _data["invoiceNoGib"] !== undefined ? _data["invoiceNoGib"] : "";
            this.waybillNo = _data["waybillNo"] !== undefined ? _data["waybillNo"] : "";
            this.waybillNoGib = _data["waybillNoGib"] !== undefined ? _data["waybillNoGib"] : "";
            this.invoiceTotalPrice = _data["invoiceTotalPrice"] !== undefined ? _data["invoiceTotalPrice"] : 0;
            this.invoiceTotalPriceWithVat = _data["invoiceTotalPriceWithVat"] !== undefined ? _data["invoiceTotalPriceWithVat"] : 0;
            this.rowCount = _data["rowCount"];
            this.productCount = _data["productCount"];
            this.quantityCount = _data["quantityCount"];
            this.shippedProductCount = _data["shippedProductCount"];
            this.shippedQuantityCount = _data["shippedQuantityCount"];
            this.quantityRow = _data["quantityRow"] !== undefined ? _data["quantityRow"] : 0;
            this.quantityTotal = _data["quantityTotal"] !== undefined ? _data["quantityTotal"] : 0;
            this.isInvoiceCombined = _data["isInvoiceCombined"] !== undefined ? _data["isInvoiceCombined"] : false;
            this.invoiceLater = _data["invoiceLater"] !== undefined ? _data["invoiceLater"] : false;
            this.combinedOrdersHeaderId = _data["combinedOrdersHeaderId"] !== undefined ? _data["combinedOrdersHeaderId"] : 0;
            this.shippingTypeArea = _data["shippingTypeArea"] ? ShippingTypeArea.fromJS(_data["shippingTypeArea"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderHeader {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["erpEntegreId"] = this.erpEntegreId;
        data["type"] = this.type;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["storageId"] = this.storageId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : <any>undefined;
        data["shippingTypeId"] = this.shippingTypeId;
        data["shippingRoute"] = this.shippingRoute ? this.shippingRoute.toJSON() : <any>undefined;
        data["shippingRouteId"] = this.shippingRouteId;
        data["controlPoint"] = this.controlPoint ? this.controlPoint.toJSON() : <any>undefined;
        data["controlPointId"] = this.controlPointId;
        data["companyDataSource"] = this.companyDataSource ? this.companyDataSource.toJSON() : <any>undefined;
        data["companyDataSourceId"] = this.companyDataSourceId;
        data["documentNo"] = this.documentNo;
        data["documentNo2"] = this.documentNo2;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["deliveryAdress1"] = this.deliveryAdress1;
        data["deliveryAdress2"] = this.deliveryAdress2;
        data["workActivity"] = this.workActivity ? this.workActivity.toJSON() : <any>undefined;
        data["workActivityId"] = this.workActivityId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["finishDate"] = this.finishDate ? this.finishDate.toISOString() : <any>undefined;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["isLocked"] = this.isLocked;
        data["collectPoint"] = this.collectPoint;
        data["isShipped"] = this.isShipped;
        data["shippingDate"] = this.shippingDate ? this.shippingDate.toISOString() : <any>undefined;
        data["isCancelled"] = this.isCancelled;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["cancelReason"] = this.cancelReason;
        data["shippingCost"] = this.shippingCost;
        data["shippingCostQuantity"] = this.shippingCostQuantity;
        data["isShippingPaymentByCustomer"] = this.isShippingPaymentByCustomer;
        data["cargoEntegrationResult"] = this.cargoEntegrationResult;
        data["isInvoicePrinted"] = this.isInvoicePrinted;
        data["invoicePrintTime"] = this.invoicePrintTime ? this.invoicePrintTime.toISOString() : <any>undefined;
        data["isReplacement"] = this.isReplacement;
        data["invoiceSend"] = this.invoiceSend;
        data["picker"] = this.picker ? this.picker.toJSON() : <any>undefined;
        data["pickerId"] = this.pickerId;
        data["controller"] = this.controller ? this.controller.toJSON() : <any>undefined;
        data["controllerId"] = this.controllerId;
        data["shipper"] = this.shipper ? this.shipper.toJSON() : <any>undefined;
        data["shipperId"] = this.shipperId;
        data["documentNo_Seri"] = this.documentNo_Seri;
        data["documentNo_Sira"] = this.documentNo_Sira;
        data["b2BDocumentNo"] = this.b2BDocumentNo;
        data["warrantyNo"] = this.warrantyNo;
        data["salesmanNot"] = this.salesmanNot;
        data["shippingName"] = this.shippingName;
        data["shippingAddress"] = this.shippingAddress;
        data["shippingAddress2"] = this.shippingAddress2;
        data["shippingCountry"] = this.shippingCountry;
        data["shippingCity"] = this.shippingCity;
        data["shippingTown"] = this.shippingTown;
        data["clientAddress"] = this.clientAddress ? this.clientAddress.toJSON() : <any>undefined;
        data["clientAddressId"] = this.clientAddressId;
        data["shippingCompany"] = this.shippingCompany ? this.shippingCompany.toJSON() : <any>undefined;
        data["shippingCompanyId"] = this.shippingCompanyId;
        data["shippingCompanyBarcodes"] = this.shippingCompanyBarcodes;
        data["printPointNameInvoice"] = this.printPointNameInvoice;
        data["invoicePrintQuantity"] = this.invoicePrintQuantity;
        data["controlStartTime"] = this.controlStartTime ? this.controlStartTime.toISOString() : <any>undefined;
        data["controlFinishTime"] = this.controlFinishTime ? this.controlFinishTime.toISOString() : <any>undefined;
        data["canceledShippingCostReason"] = this.canceledShippingCostReason;
        data["canceledShippingCostUser"] = this.canceledShippingCostUser ? this.canceledShippingCostUser.toJSON() : <any>undefined;
        data["deci"] = this.deci;
        data["kg"] = this.kg;
        data["deciForEachPackage"] = this.deciForEachPackage;
        data["hasPriority"] = this.hasPriority;
        data["weight"] = this.weight;
        data["isManuel"] = this.isManuel;
        data["listForPicking"] = this.listForPicking;
        data["quantityPackage"] = this.quantityPackage;
        data["quantityBundle"] = this.quantityBundle;
        data["quantityPalette"] = this.quantityPalette;
        data["quantityPackTotal"] = this.quantityPackTotal;
        data["isExport"] = this.isExport;
        data["willBeShippingCost"] = this.willBeShippingCost;
        data["shippingCostCanChange"] = this.shippingCostCanChange;
        data["deliveryHeader"] = this.deliveryHeader ? this.deliveryHeader.toJSON() : <any>undefined;
        data["deliveryHeaderId"] = this.deliveryHeaderId;
        data["willBeInvoiced"] = this.willBeInvoiced;
        data["isInvoicing"] = this.isInvoicing;
        data["invoicingStartTime"] = this.invoicingStartTime ? this.invoicingStartTime.toISOString() : <any>undefined;
        data["isInvoiced"] = this.isInvoiced;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceType"] = this.invoiceType;
        data["invoiceNoGib"] = this.invoiceNoGib;
        data["waybillNo"] = this.waybillNo;
        data["waybillNoGib"] = this.waybillNoGib;
        data["invoiceTotalPrice"] = this.invoiceTotalPrice;
        data["invoiceTotalPriceWithVat"] = this.invoiceTotalPriceWithVat;
        data["rowCount"] = this.rowCount;
        data["productCount"] = this.productCount;
        data["quantityCount"] = this.quantityCount;
        data["shippedProductCount"] = this.shippedProductCount;
        data["shippedQuantityCount"] = this.shippedQuantityCount;
        data["quantityRow"] = this.quantityRow;
        data["quantityTotal"] = this.quantityTotal;
        data["isInvoiceCombined"] = this.isInvoiceCombined;
        data["invoiceLater"] = this.invoiceLater;
        data["combinedOrdersHeaderId"] = this.combinedOrdersHeaderId;
        data["shippingTypeArea"] = this.shippingTypeArea ? this.shippingTypeArea.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderHeader {
        const json = this.toJSON();
        let result = new OrderHeader();
        result.init(json);
        return result;
    }
}

export interface IOrderHeader {
    erpEntegreId: string | undefined;
    type: OrderType;
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    storage: Storage;
    storageId: number;
    client: Client;
    clientId: number;
    shippingType: ShippingType;
    shippingTypeId: number | undefined;
    shippingRoute: ShippingRoute;
    shippingRouteId: number | undefined;
    controlPoint: ControlPoint;
    controlPointId: number | undefined;
    companyDataSource: CompanyDataSource;
    companyDataSourceId: number;
    documentNo: string | undefined;
    documentNo2: string | undefined;
    documentDate: Date;
    shipmentDate: Date;
    notes: string | undefined;
    deliveryAdress1: string | undefined;
    deliveryAdress2: string | undefined;
    workActivity: WorkActivity;
    workActivityId: number | undefined;
    startDate: Date | undefined;
    finishDate: Date | undefined;
    isStarted: boolean;
    isFinished: boolean;
    isLocked: boolean;
    collectPoint: string | undefined;
    isShipped: boolean;
    shippingDate: Date | undefined;
    isCancelled: boolean;
    cancelDate: Date | undefined;
    cancelReason: string | undefined;
    shippingCost: number;
    shippingCostQuantity: number;
    isShippingPaymentByCustomer: boolean;
    cargoEntegrationResult: string | undefined;
    isInvoicePrinted: boolean;
    invoicePrintTime: Date | undefined;
    isReplacement: boolean;
    invoiceSend: boolean;
    picker: User;
    pickerId: number | undefined;
    controller: User;
    controllerId: number | undefined;
    shipper: User;
    shipperId: number | undefined;
    documentNo_Seri: string | undefined;
    documentNo_Sira: string | undefined;
    b2BDocumentNo: string | undefined;
    warrantyNo: string | undefined;
    salesmanNot: string | undefined;
    shippingName: string | undefined;
    shippingAddress: string | undefined;
    shippingAddress2: string | undefined;
    shippingCountry: string | undefined;
    shippingCity: string | undefined;
    shippingTown: string | undefined;
    clientAddress: ClientAddress;
    clientAddressId: number | undefined;
    shippingCompany: ShippingCompany;
    shippingCompanyId: number | undefined;
    shippingCompanyBarcodes: string | undefined;
    printPointNameInvoice: string | undefined;
    invoicePrintQuantity: number;
    controlStartTime: Date | undefined;
    controlFinishTime: Date | undefined;
    canceledShippingCostReason: string | undefined;
    canceledShippingCostUser: User;
    deci: number;
    kg: number;
    deciForEachPackage: string | undefined;
    hasPriority: boolean;
    weight: number;
    isManuel: boolean;
    listForPicking: boolean;
    quantityPackage: number;
    quantityBundle: number;
    quantityPalette: number;
    quantityPackTotal: number;
    isExport: boolean;
    willBeShippingCost: boolean;
    shippingCostCanChange: boolean;
    deliveryHeader: DeliveryHeader;
    deliveryHeaderId: number | undefined;
    willBeInvoiced: boolean;
    isInvoicing: boolean;
    invoicingStartTime: Date | undefined;
    isInvoiced: boolean;
    invoiceDate: Date | undefined;
    invoiceNo: string | undefined;
    invoiceType: EDocumentType;
    invoiceNoGib: string | undefined;
    waybillNo: string | undefined;
    waybillNoGib: string | undefined;
    invoiceTotalPrice: number;
    invoiceTotalPriceWithVat: number;
    rowCount: number;
    productCount: number;
    quantityCount: number;
    shippedProductCount: number;
    shippedQuantityCount: number;
    quantityRow: number;
    quantityTotal: number;
    isInvoiceCombined: boolean;
    invoiceLater: boolean;
    combinedOrdersHeaderId: number;
    shippingTypeArea: ShippingTypeArea;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class DashOrderHeaderCountDto implements IDashOrderHeaderCountDto {
    startedCount: number;
    finishedCount: number;
    totalCount: number;
    quantityProduct: number;
    quantityOrderCollected: number;
    quantityProductCollected: number;
    lastOrderHeader: OrderHeader;
    quantityPickingProductPerHour: number;
    quantityPickingOrderPerHour: number;
    quantityPickingOrderDetailPerHour: number;
    orderDetailQuantity: number;
    quantityOrderShippedList: number[] | undefined;
    totalOrderHeader: number;
    creationTime: Date;
    lastOrderHeaderControlFinishTime: Date | undefined;
    readonly diffCount: number;
    startDate: Date | undefined;
    endDate: Date | undefined;

    constructor(data?: IDashOrderHeaderCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startedCount = _data["startedCount"];
            this.finishedCount = _data["finishedCount"];
            this.totalCount = _data["totalCount"];
            this.quantityProduct = _data["quantityProduct"];
            this.quantityOrderCollected = _data["quantityOrderCollected"];
            this.quantityProductCollected = _data["quantityProductCollected"];
            this.lastOrderHeader = _data["lastOrderHeader"] ? OrderHeader.fromJS(_data["lastOrderHeader"]) : <any>undefined;
            this.quantityPickingProductPerHour = _data["quantityPickingProductPerHour"];
            this.quantityPickingOrderPerHour = _data["quantityPickingOrderPerHour"];
            this.quantityPickingOrderDetailPerHour = _data["quantityPickingOrderDetailPerHour"];
            this.orderDetailQuantity = _data["orderDetailQuantity"];
            if (Array.isArray(_data["quantityOrderShippedList"])) {
                this.quantityOrderShippedList = [] as any;
                for (let item of _data["quantityOrderShippedList"])
                    this.quantityOrderShippedList.push(item);
            }
            this.totalOrderHeader = _data["totalOrderHeader"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastOrderHeaderControlFinishTime = _data["lastOrderHeaderControlFinishTime"] ? new Date(_data["lastOrderHeaderControlFinishTime"].toString()) : <any>undefined;
            (<any>this).diffCount = _data["diffCount"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DashOrderHeaderCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashOrderHeaderCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startedCount"] = this.startedCount;
        data["finishedCount"] = this.finishedCount;
        data["totalCount"] = this.totalCount;
        data["quantityProduct"] = this.quantityProduct;
        data["quantityOrderCollected"] = this.quantityOrderCollected;
        data["quantityProductCollected"] = this.quantityProductCollected;
        data["lastOrderHeader"] = this.lastOrderHeader ? this.lastOrderHeader.toJSON() : <any>undefined;
        data["quantityPickingProductPerHour"] = this.quantityPickingProductPerHour;
        data["quantityPickingOrderPerHour"] = this.quantityPickingOrderPerHour;
        data["quantityPickingOrderDetailPerHour"] = this.quantityPickingOrderDetailPerHour;
        data["orderDetailQuantity"] = this.orderDetailQuantity;
        if (Array.isArray(this.quantityOrderShippedList)) {
            data["quantityOrderShippedList"] = [];
            for (let item of this.quantityOrderShippedList)
                data["quantityOrderShippedList"].push(item);
        }
        data["totalOrderHeader"] = this.totalOrderHeader;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastOrderHeaderControlFinishTime"] = this.lastOrderHeaderControlFinishTime ? this.lastOrderHeaderControlFinishTime.toISOString() : <any>undefined;
        data["diffCount"] = this.diffCount;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): DashOrderHeaderCountDto {
        const json = this.toJSON();
        let result = new DashOrderHeaderCountDto();
        result.init(json);
        return result;
    }
}

export interface IDashOrderHeaderCountDto {
    startedCount: number;
    finishedCount: number;
    totalCount: number;
    quantityProduct: number;
    quantityOrderCollected: number;
    quantityProductCollected: number;
    lastOrderHeader: OrderHeader;
    quantityPickingProductPerHour: number;
    quantityPickingOrderPerHour: number;
    quantityPickingOrderDetailPerHour: number;
    orderDetailQuantity: number;
    quantityOrderShippedList: number[] | undefined;
    totalOrderHeader: number;
    creationTime: Date;
    lastOrderHeaderControlFinishTime: Date | undefined;
    diffCount: number;
    startDate: Date | undefined;
    endDate: Date | undefined;
}

export class DashOrderHeaderPickingPerformanceDto implements IDashOrderHeaderPickingPerformanceDto {
    quantityPickingProductPerHour: number;
    quantityPickingOrderPerHour: number;
    quantityPickingOrderDetailPerHour: number;
    quantityPickingProductShiftHour: number;
    quantityPickingOrderShiftHour: number;
    quantityPickingOrderDetailShiftHour: number;
    startDate: Date;
    endDate: Date;
    dateAverage: number;
    quantityPickingProduct: number;
    quantityPickingOrder: number;
    quantityPickingOrderDetail: number;
    quantityPickingProductForShift: number;
    quantityPickingOrderForShift: number;
    quantityPickingOrderDetailForShift: number;

    constructor(data?: IDashOrderHeaderPickingPerformanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantityPickingProductPerHour = _data["quantityPickingProductPerHour"];
            this.quantityPickingOrderPerHour = _data["quantityPickingOrderPerHour"];
            this.quantityPickingOrderDetailPerHour = _data["quantityPickingOrderDetailPerHour"];
            this.quantityPickingProductShiftHour = _data["quantityPickingProductShiftHour"];
            this.quantityPickingOrderShiftHour = _data["quantityPickingOrderShiftHour"];
            this.quantityPickingOrderDetailShiftHour = _data["quantityPickingOrderDetailShiftHour"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.dateAverage = _data["dateAverage"];
            this.quantityPickingProduct = _data["quantityPickingProduct"];
            this.quantityPickingOrder = _data["quantityPickingOrder"];
            this.quantityPickingOrderDetail = _data["quantityPickingOrderDetail"];
            this.quantityPickingProductForShift = _data["quantityPickingProductForShift"];
            this.quantityPickingOrderForShift = _data["quantityPickingOrderForShift"];
            this.quantityPickingOrderDetailForShift = _data["quantityPickingOrderDetailForShift"];
        }
    }

    static fromJS(data: any): DashOrderHeaderPickingPerformanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashOrderHeaderPickingPerformanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantityPickingProductPerHour"] = this.quantityPickingProductPerHour;
        data["quantityPickingOrderPerHour"] = this.quantityPickingOrderPerHour;
        data["quantityPickingOrderDetailPerHour"] = this.quantityPickingOrderDetailPerHour;
        data["quantityPickingProductShiftHour"] = this.quantityPickingProductShiftHour;
        data["quantityPickingOrderShiftHour"] = this.quantityPickingOrderShiftHour;
        data["quantityPickingOrderDetailShiftHour"] = this.quantityPickingOrderDetailShiftHour;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["dateAverage"] = this.dateAverage;
        data["quantityPickingProduct"] = this.quantityPickingProduct;
        data["quantityPickingOrder"] = this.quantityPickingOrder;
        data["quantityPickingOrderDetail"] = this.quantityPickingOrderDetail;
        data["quantityPickingProductForShift"] = this.quantityPickingProductForShift;
        data["quantityPickingOrderForShift"] = this.quantityPickingOrderForShift;
        data["quantityPickingOrderDetailForShift"] = this.quantityPickingOrderDetailForShift;
        return data;
    }

    clone(): DashOrderHeaderPickingPerformanceDto {
        const json = this.toJSON();
        let result = new DashOrderHeaderPickingPerformanceDto();
        result.init(json);
        return result;
    }
}

export interface IDashOrderHeaderPickingPerformanceDto {
    quantityPickingProductPerHour: number;
    quantityPickingOrderPerHour: number;
    quantityPickingOrderDetailPerHour: number;
    quantityPickingProductShiftHour: number;
    quantityPickingOrderShiftHour: number;
    quantityPickingOrderDetailShiftHour: number;
    startDate: Date;
    endDate: Date;
    dateAverage: number;
    quantityPickingProduct: number;
    quantityPickingOrder: number;
    quantityPickingOrderDetail: number;
    quantityPickingProductForShift: number;
    quantityPickingOrderForShift: number;
    quantityPickingOrderDetailForShift: number;
}

export class DashControlPointCountDto implements IDashControlPointCountDto {
    loadedCount: number;
    totalCount: number;
    readonly emptyCount: number;

    constructor(data?: IDashControlPointCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loadedCount = _data["loadedCount"];
            this.totalCount = _data["totalCount"];
            (<any>this).emptyCount = _data["emptyCount"];
        }
    }

    static fromJS(data: any): DashControlPointCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashControlPointCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loadedCount"] = this.loadedCount;
        data["totalCount"] = this.totalCount;
        data["emptyCount"] = this.emptyCount;
        return data;
    }

    clone(): DashControlPointCountDto {
        const json = this.toJSON();
        let result = new DashControlPointCountDto();
        result.init(json);
        return result;
    }
}

export interface IDashControlPointCountDto {
    loadedCount: number;
    totalCount: number;
    emptyCount: number;
}

export class DashInAndOutOrderHeaderCountDto implements IDashInAndOutOrderHeaderCountDto {
    finishedOrderHeaderCount: number[] | undefined;
    notFinishedOrderHeaderCount: number[] | undefined;
    totalOrderHeaderCount: number[] | undefined;
    finishedDetailCount: number[] | undefined;
    notFinishedDetailCount: number[] | undefined;
    totalDetailCount: number[] | undefined;
    finishedProductCount: number[] | undefined;
    notFinishedProductCount: number[] | undefined;
    totaldProductCount: number[] | undefined;
    dates: string[] | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;

    constructor(data?: IDashInAndOutOrderHeaderCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["finishedOrderHeaderCount"])) {
                this.finishedOrderHeaderCount = [] as any;
                for (let item of _data["finishedOrderHeaderCount"])
                    this.finishedOrderHeaderCount.push(item);
            }
            if (Array.isArray(_data["notFinishedOrderHeaderCount"])) {
                this.notFinishedOrderHeaderCount = [] as any;
                for (let item of _data["notFinishedOrderHeaderCount"])
                    this.notFinishedOrderHeaderCount.push(item);
            }
            if (Array.isArray(_data["totalOrderHeaderCount"])) {
                this.totalOrderHeaderCount = [] as any;
                for (let item of _data["totalOrderHeaderCount"])
                    this.totalOrderHeaderCount.push(item);
            }
            if (Array.isArray(_data["finishedDetailCount"])) {
                this.finishedDetailCount = [] as any;
                for (let item of _data["finishedDetailCount"])
                    this.finishedDetailCount.push(item);
            }
            if (Array.isArray(_data["notFinishedDetailCount"])) {
                this.notFinishedDetailCount = [] as any;
                for (let item of _data["notFinishedDetailCount"])
                    this.notFinishedDetailCount.push(item);
            }
            if (Array.isArray(_data["totalDetailCount"])) {
                this.totalDetailCount = [] as any;
                for (let item of _data["totalDetailCount"])
                    this.totalDetailCount.push(item);
            }
            if (Array.isArray(_data["finishedProductCount"])) {
                this.finishedProductCount = [] as any;
                for (let item of _data["finishedProductCount"])
                    this.finishedProductCount.push(item);
            }
            if (Array.isArray(_data["notFinishedProductCount"])) {
                this.notFinishedProductCount = [] as any;
                for (let item of _data["notFinishedProductCount"])
                    this.notFinishedProductCount.push(item);
            }
            if (Array.isArray(_data["totaldProductCount"])) {
                this.totaldProductCount = [] as any;
                for (let item of _data["totaldProductCount"])
                    this.totaldProductCount.push(item);
            }
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DashInAndOutOrderHeaderCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashInAndOutOrderHeaderCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.finishedOrderHeaderCount)) {
            data["finishedOrderHeaderCount"] = [];
            for (let item of this.finishedOrderHeaderCount)
                data["finishedOrderHeaderCount"].push(item);
        }
        if (Array.isArray(this.notFinishedOrderHeaderCount)) {
            data["notFinishedOrderHeaderCount"] = [];
            for (let item of this.notFinishedOrderHeaderCount)
                data["notFinishedOrderHeaderCount"].push(item);
        }
        if (Array.isArray(this.totalOrderHeaderCount)) {
            data["totalOrderHeaderCount"] = [];
            for (let item of this.totalOrderHeaderCount)
                data["totalOrderHeaderCount"].push(item);
        }
        if (Array.isArray(this.finishedDetailCount)) {
            data["finishedDetailCount"] = [];
            for (let item of this.finishedDetailCount)
                data["finishedDetailCount"].push(item);
        }
        if (Array.isArray(this.notFinishedDetailCount)) {
            data["notFinishedDetailCount"] = [];
            for (let item of this.notFinishedDetailCount)
                data["notFinishedDetailCount"].push(item);
        }
        if (Array.isArray(this.totalDetailCount)) {
            data["totalDetailCount"] = [];
            for (let item of this.totalDetailCount)
                data["totalDetailCount"].push(item);
        }
        if (Array.isArray(this.finishedProductCount)) {
            data["finishedProductCount"] = [];
            for (let item of this.finishedProductCount)
                data["finishedProductCount"].push(item);
        }
        if (Array.isArray(this.notFinishedProductCount)) {
            data["notFinishedProductCount"] = [];
            for (let item of this.notFinishedProductCount)
                data["notFinishedProductCount"].push(item);
        }
        if (Array.isArray(this.totaldProductCount)) {
            data["totaldProductCount"] = [];
            for (let item of this.totaldProductCount)
                data["totaldProductCount"].push(item);
        }
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): DashInAndOutOrderHeaderCountDto {
        const json = this.toJSON();
        let result = new DashInAndOutOrderHeaderCountDto();
        result.init(json);
        return result;
    }
}

export interface IDashInAndOutOrderHeaderCountDto {
    finishedOrderHeaderCount: number[] | undefined;
    notFinishedOrderHeaderCount: number[] | undefined;
    totalOrderHeaderCount: number[] | undefined;
    finishedDetailCount: number[] | undefined;
    notFinishedDetailCount: number[] | undefined;
    totalDetailCount: number[] | undefined;
    finishedProductCount: number[] | undefined;
    notFinishedProductCount: number[] | undefined;
    totaldProductCount: number[] | undefined;
    dates: string[] | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
}

export class DashWastedTimeOrderHeaderDto implements IDashWastedTimeOrderHeaderDto {
    wastedTimeForCreatingWorkActivity: number[] | undefined;
    wastedTimeForGetter: number[] | undefined;
    wastedTimeForControl: number[] | undefined;
    dates: string[] | undefined;

    constructor(data?: IDashWastedTimeOrderHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["wastedTimeForCreatingWorkActivity"])) {
                this.wastedTimeForCreatingWorkActivity = [] as any;
                for (let item of _data["wastedTimeForCreatingWorkActivity"])
                    this.wastedTimeForCreatingWorkActivity.push(item);
            }
            if (Array.isArray(_data["wastedTimeForGetter"])) {
                this.wastedTimeForGetter = [] as any;
                for (let item of _data["wastedTimeForGetter"])
                    this.wastedTimeForGetter.push(item);
            }
            if (Array.isArray(_data["wastedTimeForControl"])) {
                this.wastedTimeForControl = [] as any;
                for (let item of _data["wastedTimeForControl"])
                    this.wastedTimeForControl.push(item);
            }
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates.push(item);
            }
        }
    }

    static fromJS(data: any): DashWastedTimeOrderHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashWastedTimeOrderHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.wastedTimeForCreatingWorkActivity)) {
            data["wastedTimeForCreatingWorkActivity"] = [];
            for (let item of this.wastedTimeForCreatingWorkActivity)
                data["wastedTimeForCreatingWorkActivity"].push(item);
        }
        if (Array.isArray(this.wastedTimeForGetter)) {
            data["wastedTimeForGetter"] = [];
            for (let item of this.wastedTimeForGetter)
                data["wastedTimeForGetter"].push(item);
        }
        if (Array.isArray(this.wastedTimeForControl)) {
            data["wastedTimeForControl"] = [];
            for (let item of this.wastedTimeForControl)
                data["wastedTimeForControl"].push(item);
        }
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item);
        }
        return data;
    }

    clone(): DashWastedTimeOrderHeaderDto {
        const json = this.toJSON();
        let result = new DashWastedTimeOrderHeaderDto();
        result.init(json);
        return result;
    }
}

export interface IDashWastedTimeOrderHeaderDto {
    wastedTimeForCreatingWorkActivity: number[] | undefined;
    wastedTimeForGetter: number[] | undefined;
    wastedTimeForControl: number[] | undefined;
    dates: string[] | undefined;
}

export class DashControlType1Dto implements IDashControlType1Dto {
    name: string | undefined;
    value: number;

    constructor(data?: IDashControlType1Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DashControlType1Dto {
        data = typeof data === 'object' ? data : {};
        let result = new DashControlType1Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): DashControlType1Dto {
        const json = this.toJSON();
        let result = new DashControlType1Dto();
        result.init(json);
        return result;
    }
}

export interface IDashControlType1Dto {
    name: string | undefined;
    value: number;
}

export class DashControlBestSalesDto implements IDashControlBestSalesDto {
    day: number;
    products: DashControlType1Dto[] | undefined;

    constructor(data?: IDashControlBestSalesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(DashControlType1Dto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashControlBestSalesDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashControlBestSalesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }

    clone(): DashControlBestSalesDto {
        const json = this.toJSON();
        let result = new DashControlBestSalesDto();
        result.init(json);
        return result;
    }
}

export interface IDashControlBestSalesDto {
    day: number;
    products: DashControlType1Dto[] | undefined;
}

export class DashboardChartOrderDapperDto implements IDashboardChartOrderDapperDto {
    productQuantity: number;
    finishOrderQuantity: number;
    notFinishOrderQuantity: number;
    creationTime: Date;
    totalOrderQuantity: number;

    constructor(data?: IDashboardChartOrderDapperDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productQuantity = _data["productQuantity"];
            this.finishOrderQuantity = _data["finishOrderQuantity"];
            this.notFinishOrderQuantity = _data["notFinishOrderQuantity"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.totalOrderQuantity = _data["totalOrderQuantity"];
        }
    }

    static fromJS(data: any): DashboardChartOrderDapperDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardChartOrderDapperDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productQuantity"] = this.productQuantity;
        data["finishOrderQuantity"] = this.finishOrderQuantity;
        data["notFinishOrderQuantity"] = this.notFinishOrderQuantity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["totalOrderQuantity"] = this.totalOrderQuantity;
        return data;
    }

    clone(): DashboardChartOrderDapperDto {
        const json = this.toJSON();
        let result = new DashboardChartOrderDapperDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardChartOrderDapperDto {
    productQuantity: number;
    finishOrderQuantity: number;
    notFinishOrderQuantity: number;
    creationTime: Date;
    totalOrderQuantity: number;
}

export class DashboardWaybillDapperDto implements IDashboardWaybillDapperDto {
    productQuantity: number;
    finishWaybillQuantity: number;
    notFinishWaybillQuantity: number;
    totalWaybillQuantity: number;
    creationTime: Date;

    constructor(data?: IDashboardWaybillDapperDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productQuantity = _data["productQuantity"];
            this.finishWaybillQuantity = _data["finishWaybillQuantity"];
            this.notFinishWaybillQuantity = _data["notFinishWaybillQuantity"];
            this.totalWaybillQuantity = _data["totalWaybillQuantity"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardWaybillDapperDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardWaybillDapperDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productQuantity"] = this.productQuantity;
        data["finishWaybillQuantity"] = this.finishWaybillQuantity;
        data["notFinishWaybillQuantity"] = this.notFinishWaybillQuantity;
        data["totalWaybillQuantity"] = this.totalWaybillQuantity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): DashboardWaybillDapperDto {
        const json = this.toJSON();
        let result = new DashboardWaybillDapperDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardWaybillDapperDto {
    productQuantity: number;
    finishWaybillQuantity: number;
    notFinishWaybillQuantity: number;
    totalWaybillQuantity: number;
    creationTime: Date;
}

export class DashboardChartCountDto implements IDashboardChartCountDto {
    totalOrderQuantity: number;
    orderList: DashboardChartOrderDapperDto[] | undefined;
    totalWaybillQuantity: number;
    waybillList: DashboardWaybillDapperDto[] | undefined;
    totalControlPoint: number;
    fullControlPoint: number;
    emptyControlPoint: number;

    constructor(data?: IDashboardChartCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalOrderQuantity = _data["totalOrderQuantity"];
            if (Array.isArray(_data["orderList"])) {
                this.orderList = [] as any;
                for (let item of _data["orderList"])
                    this.orderList.push(DashboardChartOrderDapperDto.fromJS(item));
            }
            this.totalWaybillQuantity = _data["totalWaybillQuantity"];
            if (Array.isArray(_data["waybillList"])) {
                this.waybillList = [] as any;
                for (let item of _data["waybillList"])
                    this.waybillList.push(DashboardWaybillDapperDto.fromJS(item));
            }
            this.totalControlPoint = _data["totalControlPoint"];
            this.fullControlPoint = _data["fullControlPoint"];
            this.emptyControlPoint = _data["emptyControlPoint"];
        }
    }

    static fromJS(data: any): DashboardChartCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardChartCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalOrderQuantity"] = this.totalOrderQuantity;
        if (Array.isArray(this.orderList)) {
            data["orderList"] = [];
            for (let item of this.orderList)
                data["orderList"].push(item.toJSON());
        }
        data["totalWaybillQuantity"] = this.totalWaybillQuantity;
        if (Array.isArray(this.waybillList)) {
            data["waybillList"] = [];
            for (let item of this.waybillList)
                data["waybillList"].push(item.toJSON());
        }
        data["totalControlPoint"] = this.totalControlPoint;
        data["fullControlPoint"] = this.fullControlPoint;
        data["emptyControlPoint"] = this.emptyControlPoint;
        return data;
    }

    clone(): DashboardChartCountDto {
        const json = this.toJSON();
        let result = new DashboardChartCountDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardChartCountDto {
    totalOrderQuantity: number;
    orderList: DashboardChartOrderDapperDto[] | undefined;
    totalWaybillQuantity: number;
    waybillList: DashboardWaybillDapperDto[] | undefined;
    totalControlPoint: number;
    fullControlPoint: number;
    emptyControlPoint: number;
}

export class DashboardClientSalesTopDapperDto implements IDashboardClientSalesTopDapperDto {
    sales: number;
    code: string | undefined;
    name: string | undefined;

    constructor(data?: IDashboardClientSalesTopDapperDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sales = _data["sales"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DashboardClientSalesTopDapperDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardClientSalesTopDapperDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sales"] = this.sales;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }

    clone(): DashboardClientSalesTopDapperDto {
        const json = this.toJSON();
        let result = new DashboardClientSalesTopDapperDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardClientSalesTopDapperDto {
    sales: number;
    code: string | undefined;
    name: string | undefined;
}

export class DashboardProductSalesTopDapperDto implements IDashboardProductSalesTopDapperDto {
    productQuantity: number;
    code: string | undefined;
    definition: string | undefined;

    constructor(data?: IDashboardProductSalesTopDapperDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productQuantity = _data["productQuantity"];
            this.code = _data["code"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): DashboardProductSalesTopDapperDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardProductSalesTopDapperDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productQuantity"] = this.productQuantity;
        data["code"] = this.code;
        data["definition"] = this.definition;
        return data;
    }

    clone(): DashboardProductSalesTopDapperDto {
        const json = this.toJSON();
        let result = new DashboardProductSalesTopDapperDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardProductSalesTopDapperDto {
    productQuantity: number;
    code: string | undefined;
    definition: string | undefined;
}

export class ShippingTypeDto implements IShippingTypeDto {
    code: string | undefined;
    definition: string | undefined;
    shortCode: string | undefined;
    id: number;

    constructor(data?: IShippingTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.shortCode = _data["shortCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShippingTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["shortCode"] = this.shortCode;
        data["id"] = this.id;
        return data;
    }

    clone(): ShippingTypeDto {
        const json = this.toJSON();
        let result = new ShippingTypeDto();
        result.init(json);
        return result;
    }
}

export interface IShippingTypeDto {
    code: string | undefined;
    definition: string | undefined;
    shortCode: string | undefined;
    id: number;
}

export class DeliveryHeaderDto implements IDeliveryHeaderDto {
    company: Company;
    warehouse: Warehouse;
    shippingType: ShippingTypeDto;
    receiver: string | undefined;
    receiverTel: string | undefined;
    documentNo: string | undefined;
    licensePlate: string | undefined;
    isStarted: boolean;
    isFinished: boolean;
    isDeleted: boolean;
    startTime: Date;
    finishTime: Date;
    id: number;

    constructor(data?: IDeliveryHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.shippingType = _data["shippingType"] ? ShippingTypeDto.fromJS(_data["shippingType"]) : <any>undefined;
            this.receiver = _data["receiver"];
            this.receiverTel = _data["receiverTel"];
            this.documentNo = _data["documentNo"];
            this.licensePlate = _data["licensePlate"];
            this.isStarted = _data["isStarted"];
            this.isFinished = _data["isFinished"];
            this.isDeleted = _data["isDeleted"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeliveryHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : <any>undefined;
        data["receiver"] = this.receiver;
        data["receiverTel"] = this.receiverTel;
        data["documentNo"] = this.documentNo;
        data["licensePlate"] = this.licensePlate;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["isDeleted"] = this.isDeleted;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): DeliveryHeaderDto {
        const json = this.toJSON();
        let result = new DeliveryHeaderDto();
        result.init(json);
        return result;
    }
}

export interface IDeliveryHeaderDto {
    company: Company;
    warehouse: Warehouse;
    shippingType: ShippingTypeDto;
    receiver: string | undefined;
    receiverTel: string | undefined;
    documentNo: string | undefined;
    licensePlate: string | undefined;
    isStarted: boolean;
    isFinished: boolean;
    isDeleted: boolean;
    startTime: Date;
    finishTime: Date;
    id: number;
}

export class DeliveryHeaderDtoPagedResultDto implements IDeliveryHeaderDtoPagedResultDto {
    totalCount: number;
    items: DeliveryHeaderDto[] | undefined;

    constructor(data?: IDeliveryHeaderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DeliveryHeaderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeliveryHeaderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryHeaderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): DeliveryHeaderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DeliveryHeaderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDeliveryHeaderDtoPagedResultDto {
    totalCount: number;
    items: DeliveryHeaderDto[] | undefined;
}

export class WarehouseDto implements IWarehouseDto {
    code: string | undefined;
    name: string | undefined;
    id: number;

    constructor(data?: IWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): WarehouseDto {
        const json = this.toJSON();
        let result = new WarehouseDto();
        result.init(json);
        return result;
    }
}

export interface IWarehouseDto {
    code: string | undefined;
    name: string | undefined;
    id: number;
}

export class UserDto implements IUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    isDeleted: boolean;
    fullName: string | undefined;
    lastLoginTime: Date | undefined;
    creationTime: Date;
    roleNames: string[] | undefined;
    permissionNames: string[] | undefined;
    company: CompanyDto;
    companyId: number;
    warehouse: WarehouseDto;
    warehouseId: number;
    printPointName: string | undefined;
    acceptWaybillType: WaybillType;
    isChangeWarehouse: boolean;
    isChangeCompany: boolean;
    id: number;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? new Date(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            if (Array.isArray(_data["permissionNames"])) {
                this.permissionNames = [] as any;
                for (let item of _data["permissionNames"])
                    this.permissionNames.push(item);
            }
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.companyId = _data["companyId"];
            this.warehouse = _data["warehouse"] ? WarehouseDto.fromJS(_data["warehouse"]) : <any>undefined;
            this.warehouseId = _data["warehouseId"];
            this.printPointName = _data["printPointName"];
            this.acceptWaybillType = _data["acceptWaybillType"];
            this.isChangeWarehouse = _data["isChangeWarehouse"];
            this.isChangeCompany = _data["isChangeCompany"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        if (Array.isArray(this.permissionNames)) {
            data["permissionNames"] = [];
            for (let item of this.permissionNames)
                data["permissionNames"].push(item);
        }
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["printPointName"] = this.printPointName;
        data["acceptWaybillType"] = this.acceptWaybillType;
        data["isChangeWarehouse"] = this.isChangeWarehouse;
        data["isChangeCompany"] = this.isChangeCompany;
        data["id"] = this.id;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    isDeleted: boolean;
    fullName: string | undefined;
    lastLoginTime: Date | undefined;
    creationTime: Date;
    roleNames: string[] | undefined;
    permissionNames: string[] | undefined;
    company: CompanyDto;
    companyId: number;
    warehouse: WarehouseDto;
    warehouseId: number;
    printPointName: string | undefined;
    acceptWaybillType: WaybillType;
    isChangeWarehouse: boolean;
    isChangeCompany: boolean;
    id: number;
}

export class WorkActivityDto implements IWorkActivityDto {
    code: string | undefined;
    company: Company;
    warehouse: Warehouse;
    workActivityType: WorkActivityType;
    client: ClientSmallDto;
    startTime: Date;
    finishTime: Date;
    creationTime: Date;
    creatorUser: UserDto;
    documentNoStr: string | undefined;
    isStarted: boolean;
    isFinished: boolean;
    isDeleted: boolean;
    isLocked: boolean;
    isAllowAddDetail: boolean;
    isAllowRemoveDetail: boolean;
    notes: string | undefined;
    replenishmentShelf: Shelf;
    shippingType: ShippingTypeDto;
    id: number;

    constructor(data?: IWorkActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.workActivityType = _data["workActivityType"] ? WorkActivityType.fromJS(_data["workActivityType"]) : <any>undefined;
            this.client = _data["client"] ? ClientSmallDto.fromJS(_data["client"]) : <any>undefined;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? UserDto.fromJS(_data["creatorUser"]) : <any>undefined;
            this.documentNoStr = _data["documentNoStr"];
            this.isStarted = _data["isStarted"];
            this.isFinished = _data["isFinished"];
            this.isDeleted = _data["isDeleted"];
            this.isLocked = _data["isLocked"];
            this.isAllowAddDetail = _data["isAllowAddDetail"];
            this.isAllowRemoveDetail = _data["isAllowRemoveDetail"];
            this.notes = _data["notes"];
            this.replenishmentShelf = _data["replenishmentShelf"] ? Shelf.fromJS(_data["replenishmentShelf"]) : <any>undefined;
            this.shippingType = _data["shippingType"] ? ShippingTypeDto.fromJS(_data["shippingType"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WorkActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["workActivityType"] = this.workActivityType ? this.workActivityType.toJSON() : <any>undefined;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["documentNoStr"] = this.documentNoStr;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["isDeleted"] = this.isDeleted;
        data["isLocked"] = this.isLocked;
        data["isAllowAddDetail"] = this.isAllowAddDetail;
        data["isAllowRemoveDetail"] = this.isAllowRemoveDetail;
        data["notes"] = this.notes;
        data["replenishmentShelf"] = this.replenishmentShelf ? this.replenishmentShelf.toJSON() : <any>undefined;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): WorkActivityDto {
        const json = this.toJSON();
        let result = new WorkActivityDto();
        result.init(json);
        return result;
    }
}

export interface IWorkActivityDto {
    code: string | undefined;
    company: Company;
    warehouse: Warehouse;
    workActivityType: WorkActivityType;
    client: ClientSmallDto;
    startTime: Date;
    finishTime: Date;
    creationTime: Date;
    creatorUser: UserDto;
    documentNoStr: string | undefined;
    isStarted: boolean;
    isFinished: boolean;
    isDeleted: boolean;
    isLocked: boolean;
    isAllowAddDetail: boolean;
    isAllowRemoveDetail: boolean;
    notes: string | undefined;
    replenishmentShelf: Shelf;
    shippingType: ShippingTypeDto;
    id: number;
}

export class OrderHeaderDto implements IOrderHeaderDto {
    company: Company;
    companyId: number;
    type: OrderType;
    client: ClientDto;
    clientId: number;
    warehouse: Warehouse;
    warehouseId: number;
    storage: Storage;
    storageId: number;
    companyDataSourceId: number;
    orderHeaderNo: string | undefined;
    workActivity: WorkActivityDto;
    orderDocumentNo: string | undefined;
    orderDocumentDate: Date;
    orderDeadlineDate: Date;
    documentNo: string | undefined;
    documentNo2: string | undefined;
    documentDate: Date;
    deadlineDate: Date;
    notes: string | undefined;
    documentNo_Seri: string | undefined;
    cargoEntegrationResult: string | undefined;
    startDate: Date;
    finishDate: Date;
    isStarted: boolean;
    isFinished: boolean;
    isShipped: boolean;
    isCrossDock: boolean;
    shippingCostCanChange: boolean;
    isLocked: boolean;
    isDeleted: boolean;
    isCancelled: boolean;
    quantity: number;
    quantityOrder: number;
    quantityPackage: number;
    readonly quantityPercent: number;
    quantityOrderType: number;
    quantityReplacement: number;
    readonly isSelected: boolean;
    shippingType: ShippingType;
    shippingRoute: ShippingRoute;
    controlPoint: ControlPoint;
    status: string | undefined;
    statusInt: number;
    collectPoint: string | undefined;
    shippingCost: number;
    quantityBundle: number;
    quantityPalette: number;
    cancelReason: string | undefined;
    isReplacement: boolean;
    userName: string | undefined;
    shippingName: string | undefined;
    shippingAddress: string | undefined;
    shippingAddress2: string | undefined;
    shippingCountry: string | undefined;
    shippingCity: string | undefined;
    shippingTown: string | undefined;
    picker: UserDto;
    controller: UserDto;
    shipper: UserDto;
    controlStartTime: Date;
    controlFinishTime: Date;
    readonly controlTimeDiff: number;
    willBeInvoiced: boolean;
    isInvoiced: boolean;
    invoiceNo: string | undefined;
    invoiceNoGib: string | undefined;
    isInvoicing: boolean;
    invoiceDate: Date | undefined;
    readonly quantityBundlePackageSum: number;
    quantityTotalBundlePackage: number;
    hasPriority: boolean;
    creationTime: Date;
    orderType: OrderType;
    isInvoicePrinted: boolean;
    willBeShippingCost: boolean;
    shippingCompanyBarcodes: string | undefined;
    isManuel: boolean;
    listForPicking: boolean;
    isExport: boolean;
    rowCount: number;
    productCount: number;
    quantityCount: number;
    shippedProductCount: number;
    shippedQuantityCount: number;
    deci: number;
    kg: number;
    detailquantitychanged: boolean;
    shippingTypeArea: ShippingTypeArea;
    id: number;

    constructor(data?: IOrderHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.companyId = _data["companyId"];
            this.type = _data["type"];
            this.client = _data["client"] ? ClientDto.fromJS(_data["client"]) : <any>undefined;
            this.clientId = _data["clientId"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.warehouseId = _data["warehouseId"];
            this.storage = _data["storage"] ? Storage.fromJS(_data["storage"]) : <any>undefined;
            this.storageId = _data["storageId"];
            this.companyDataSourceId = _data["companyDataSourceId"];
            this.orderHeaderNo = _data["orderHeaderNo"];
            this.workActivity = _data["workActivity"] ? WorkActivityDto.fromJS(_data["workActivity"]) : <any>undefined;
            this.orderDocumentNo = _data["orderDocumentNo"];
            this.orderDocumentDate = _data["orderDocumentDate"] ? new Date(_data["orderDocumentDate"].toString()) : <any>undefined;
            this.orderDeadlineDate = _data["orderDeadlineDate"] ? new Date(_data["orderDeadlineDate"].toString()) : <any>undefined;
            this.documentNo = _data["documentNo"];
            this.documentNo2 = _data["documentNo2"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.deadlineDate = _data["deadlineDate"] ? new Date(_data["deadlineDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.documentNo_Seri = _data["documentNo_Seri"];
            this.cargoEntegrationResult = _data["cargoEntegrationResult"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.finishDate = _data["finishDate"] ? new Date(_data["finishDate"].toString()) : <any>undefined;
            this.isStarted = _data["isStarted"];
            this.isFinished = _data["isFinished"];
            this.isShipped = _data["isShipped"];
            this.isCrossDock = _data["isCrossDock"];
            this.shippingCostCanChange = _data["shippingCostCanChange"];
            this.isLocked = _data["isLocked"];
            this.isDeleted = _data["isDeleted"];
            this.isCancelled = _data["isCancelled"];
            this.quantity = _data["quantity"];
            this.quantityOrder = _data["quantityOrder"];
            this.quantityPackage = _data["quantityPackage"];
            (<any>this).quantityPercent = _data["quantityPercent"];
            this.quantityOrderType = _data["quantityOrderType"];
            this.quantityReplacement = _data["quantityReplacement"];
            (<any>this).isSelected = _data["isSelected"];
            this.shippingType = _data["shippingType"] ? ShippingType.fromJS(_data["shippingType"]) : <any>undefined;
            this.shippingRoute = _data["shippingRoute"] ? ShippingRoute.fromJS(_data["shippingRoute"]) : <any>undefined;
            this.controlPoint = _data["controlPoint"] ? ControlPoint.fromJS(_data["controlPoint"]) : <any>undefined;
            this.status = _data["status"];
            this.statusInt = _data["statusInt"];
            this.collectPoint = _data["collectPoint"];
            this.shippingCost = _data["shippingCost"];
            this.quantityBundle = _data["quantityBundle"];
            this.quantityPalette = _data["quantityPalette"];
            this.cancelReason = _data["cancelReason"];
            this.isReplacement = _data["isReplacement"];
            this.userName = _data["userName"];
            this.shippingName = _data["shippingName"];
            this.shippingAddress = _data["shippingAddress"];
            this.shippingAddress2 = _data["shippingAddress2"];
            this.shippingCountry = _data["shippingCountry"];
            this.shippingCity = _data["shippingCity"];
            this.shippingTown = _data["shippingTown"];
            this.picker = _data["picker"] ? UserDto.fromJS(_data["picker"]) : <any>undefined;
            this.controller = _data["controller"] ? UserDto.fromJS(_data["controller"]) : <any>undefined;
            this.shipper = _data["shipper"] ? UserDto.fromJS(_data["shipper"]) : <any>undefined;
            this.controlStartTime = _data["controlStartTime"] ? new Date(_data["controlStartTime"].toString()) : <any>undefined;
            this.controlFinishTime = _data["controlFinishTime"] ? new Date(_data["controlFinishTime"].toString()) : <any>undefined;
            (<any>this).controlTimeDiff = _data["controlTimeDiff"];
            this.willBeInvoiced = _data["willBeInvoiced"];
            this.isInvoiced = _data["isInvoiced"];
            this.invoiceNo = _data["invoiceNo"];
            this.invoiceNoGib = _data["invoiceNoGib"];
            this.isInvoicing = _data["isInvoicing"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            (<any>this).quantityBundlePackageSum = _data["quantityBundlePackageSum"];
            this.quantityTotalBundlePackage = _data["quantityTotalBundlePackage"];
            this.hasPriority = _data["hasPriority"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.orderType = _data["orderType"];
            this.isInvoicePrinted = _data["isInvoicePrinted"];
            this.willBeShippingCost = _data["willBeShippingCost"];
            this.shippingCompanyBarcodes = _data["shippingCompanyBarcodes"];
            this.isManuel = _data["isManuel"];
            this.listForPicking = _data["listForPicking"];
            this.isExport = _data["isExport"];
            this.rowCount = _data["rowCount"];
            this.productCount = _data["productCount"];
            this.quantityCount = _data["quantityCount"];
            this.shippedProductCount = _data["shippedProductCount"];
            this.shippedQuantityCount = _data["shippedQuantityCount"];
            this.deci = _data["deci"];
            this.kg = _data["kg"];
            this.detailquantitychanged = _data["detailquantitychanged"];
            this.shippingTypeArea = _data["shippingTypeArea"] ? ShippingTypeArea.fromJS(_data["shippingTypeArea"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["type"] = this.type;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["storageId"] = this.storageId;
        data["companyDataSourceId"] = this.companyDataSourceId;
        data["orderHeaderNo"] = this.orderHeaderNo;
        data["workActivity"] = this.workActivity ? this.workActivity.toJSON() : <any>undefined;
        data["orderDocumentNo"] = this.orderDocumentNo;
        data["orderDocumentDate"] = this.orderDocumentDate ? this.orderDocumentDate.toISOString() : <any>undefined;
        data["orderDeadlineDate"] = this.orderDeadlineDate ? this.orderDeadlineDate.toISOString() : <any>undefined;
        data["documentNo"] = this.documentNo;
        data["documentNo2"] = this.documentNo2;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["deadlineDate"] = this.deadlineDate ? this.deadlineDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["documentNo_Seri"] = this.documentNo_Seri;
        data["cargoEntegrationResult"] = this.cargoEntegrationResult;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["finishDate"] = this.finishDate ? this.finishDate.toISOString() : <any>undefined;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["isShipped"] = this.isShipped;
        data["isCrossDock"] = this.isCrossDock;
        data["shippingCostCanChange"] = this.shippingCostCanChange;
        data["isLocked"] = this.isLocked;
        data["isDeleted"] = this.isDeleted;
        data["isCancelled"] = this.isCancelled;
        data["quantity"] = this.quantity;
        data["quantityOrder"] = this.quantityOrder;
        data["quantityPackage"] = this.quantityPackage;
        data["quantityPercent"] = this.quantityPercent;
        data["quantityOrderType"] = this.quantityOrderType;
        data["quantityReplacement"] = this.quantityReplacement;
        data["isSelected"] = this.isSelected;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : <any>undefined;
        data["shippingRoute"] = this.shippingRoute ? this.shippingRoute.toJSON() : <any>undefined;
        data["controlPoint"] = this.controlPoint ? this.controlPoint.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["statusInt"] = this.statusInt;
        data["collectPoint"] = this.collectPoint;
        data["shippingCost"] = this.shippingCost;
        data["quantityBundle"] = this.quantityBundle;
        data["quantityPalette"] = this.quantityPalette;
        data["cancelReason"] = this.cancelReason;
        data["isReplacement"] = this.isReplacement;
        data["userName"] = this.userName;
        data["shippingName"] = this.shippingName;
        data["shippingAddress"] = this.shippingAddress;
        data["shippingAddress2"] = this.shippingAddress2;
        data["shippingCountry"] = this.shippingCountry;
        data["shippingCity"] = this.shippingCity;
        data["shippingTown"] = this.shippingTown;
        data["picker"] = this.picker ? this.picker.toJSON() : <any>undefined;
        data["controller"] = this.controller ? this.controller.toJSON() : <any>undefined;
        data["shipper"] = this.shipper ? this.shipper.toJSON() : <any>undefined;
        data["controlStartTime"] = this.controlStartTime ? this.controlStartTime.toISOString() : <any>undefined;
        data["controlFinishTime"] = this.controlFinishTime ? this.controlFinishTime.toISOString() : <any>undefined;
        data["controlTimeDiff"] = this.controlTimeDiff;
        data["willBeInvoiced"] = this.willBeInvoiced;
        data["isInvoiced"] = this.isInvoiced;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceNoGib"] = this.invoiceNoGib;
        data["isInvoicing"] = this.isInvoicing;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["quantityBundlePackageSum"] = this.quantityBundlePackageSum;
        data["quantityTotalBundlePackage"] = this.quantityTotalBundlePackage;
        data["hasPriority"] = this.hasPriority;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["orderType"] = this.orderType;
        data["isInvoicePrinted"] = this.isInvoicePrinted;
        data["willBeShippingCost"] = this.willBeShippingCost;
        data["shippingCompanyBarcodes"] = this.shippingCompanyBarcodes;
        data["isManuel"] = this.isManuel;
        data["listForPicking"] = this.listForPicking;
        data["isExport"] = this.isExport;
        data["rowCount"] = this.rowCount;
        data["productCount"] = this.productCount;
        data["quantityCount"] = this.quantityCount;
        data["shippedProductCount"] = this.shippedProductCount;
        data["shippedQuantityCount"] = this.shippedQuantityCount;
        data["deci"] = this.deci;
        data["kg"] = this.kg;
        data["detailquantitychanged"] = this.detailquantitychanged;
        data["shippingTypeArea"] = this.shippingTypeArea ? this.shippingTypeArea.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderHeaderDto {
        const json = this.toJSON();
        let result = new OrderHeaderDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderDto {
    company: Company;
    companyId: number;
    type: OrderType;
    client: ClientDto;
    clientId: number;
    warehouse: Warehouse;
    warehouseId: number;
    storage: Storage;
    storageId: number;
    companyDataSourceId: number;
    orderHeaderNo: string | undefined;
    workActivity: WorkActivityDto;
    orderDocumentNo: string | undefined;
    orderDocumentDate: Date;
    orderDeadlineDate: Date;
    documentNo: string | undefined;
    documentNo2: string | undefined;
    documentDate: Date;
    deadlineDate: Date;
    notes: string | undefined;
    documentNo_Seri: string | undefined;
    cargoEntegrationResult: string | undefined;
    startDate: Date;
    finishDate: Date;
    isStarted: boolean;
    isFinished: boolean;
    isShipped: boolean;
    isCrossDock: boolean;
    shippingCostCanChange: boolean;
    isLocked: boolean;
    isDeleted: boolean;
    isCancelled: boolean;
    quantity: number;
    quantityOrder: number;
    quantityPackage: number;
    quantityPercent: number;
    quantityOrderType: number;
    quantityReplacement: number;
    isSelected: boolean;
    shippingType: ShippingType;
    shippingRoute: ShippingRoute;
    controlPoint: ControlPoint;
    status: string | undefined;
    statusInt: number;
    collectPoint: string | undefined;
    shippingCost: number;
    quantityBundle: number;
    quantityPalette: number;
    cancelReason: string | undefined;
    isReplacement: boolean;
    userName: string | undefined;
    shippingName: string | undefined;
    shippingAddress: string | undefined;
    shippingAddress2: string | undefined;
    shippingCountry: string | undefined;
    shippingCity: string | undefined;
    shippingTown: string | undefined;
    picker: UserDto;
    controller: UserDto;
    shipper: UserDto;
    controlStartTime: Date;
    controlFinishTime: Date;
    controlTimeDiff: number;
    willBeInvoiced: boolean;
    isInvoiced: boolean;
    invoiceNo: string | undefined;
    invoiceNoGib: string | undefined;
    isInvoicing: boolean;
    invoiceDate: Date | undefined;
    quantityBundlePackageSum: number;
    quantityTotalBundlePackage: number;
    hasPriority: boolean;
    creationTime: Date;
    orderType: OrderType;
    isInvoicePrinted: boolean;
    willBeShippingCost: boolean;
    shippingCompanyBarcodes: string | undefined;
    isManuel: boolean;
    listForPicking: boolean;
    isExport: boolean;
    rowCount: number;
    productCount: number;
    quantityCount: number;
    shippedProductCount: number;
    shippedQuantityCount: number;
    deci: number;
    kg: number;
    detailquantitychanged: boolean;
    shippingTypeArea: ShippingTypeArea;
    id: number;
}

export class DeliveryDetailDto implements IDeliveryDetailDto {
    company: Company;
    warehouse: Warehouse;
    deliveryHeader: DeliveryHeaderDto;
    barcode: string | undefined;
    orderHeader: OrderHeaderDto;
    no: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IDeliveryDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.deliveryHeader = _data["deliveryHeader"] ? DeliveryHeaderDto.fromJS(_data["deliveryHeader"]) : <any>undefined;
            this.barcode = _data["barcode"];
            this.orderHeader = _data["orderHeader"] ? OrderHeaderDto.fromJS(_data["orderHeader"]) : <any>undefined;
            this.no = _data["no"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeliveryDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["deliveryHeader"] = this.deliveryHeader ? this.deliveryHeader.toJSON() : <any>undefined;
        data["barcode"] = this.barcode;
        data["orderHeader"] = this.orderHeader ? this.orderHeader.toJSON() : <any>undefined;
        data["no"] = this.no;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): DeliveryDetailDto {
        const json = this.toJSON();
        let result = new DeliveryDetailDto();
        result.init(json);
        return result;
    }
}

export interface IDeliveryDetailDto {
    company: Company;
    warehouse: Warehouse;
    deliveryHeader: DeliveryHeaderDto;
    barcode: string | undefined;
    orderHeader: OrderHeaderDto;
    no: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class DeliveryDetailDtoPagedResultDto implements IDeliveryDetailDtoPagedResultDto {
    totalCount: number;
    items: DeliveryDetailDto[] | undefined;

    constructor(data?: IDeliveryDetailDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DeliveryDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeliveryDetailDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryDetailDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): DeliveryDetailDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DeliveryDetailDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDeliveryDetailDtoPagedResultDto {
    totalCount: number;
    items: DeliveryDetailDto[] | undefined;
}

export class ErpSyncTransferType implements IErpSyncTransferType {
    code: string | undefined;
    definition: string | undefined;
    id: number;

    constructor(data?: IErpSyncTransferType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ErpSyncTransferType {
        data = typeof data === 'object' ? data : {};
        let result = new ErpSyncTransferType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["id"] = this.id;
        return data;
    }

    clone(): ErpSyncTransferType {
        const json = this.toJSON();
        let result = new ErpSyncTransferType();
        result.init(json);
        return result;
    }
}

export interface IErpSyncTransferType {
    code: string | undefined;
    definition: string | undefined;
    id: number;
}

export class ErpSyncSetting implements IErpSyncSetting {
    company: Company;
    companyId: number;
    companyDataSource: CompanyDataSource;
    companyDataSourceId: number;
    erpSyncTransferType: ErpSyncTransferType;
    erpSyncTransferTypeId: number;
    startHour: number;
    startMinute: number;
    endHour: number;
    endMinute: number;
    interval: number;
    exportView: string | undefined;
    isActive: boolean;
    notes: string | undefined;
    erpUrl: string | undefined;
    exportViewType: number;
    beforeErpProcedureType: number;
    afterErpProcedureType: number;
    lastStartTime: Date;
    lastEndTime: Date;
    isRunning: boolean;
    isFinished: boolean;
    readonly isRunningTime: boolean;
    id: number;

    constructor(data?: IErpSyncSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.company = new Company();
            this.companyDataSource = new CompanyDataSource();
            this.erpSyncTransferType = new ErpSyncTransferType();
            this.startHour = 7;
            this.startMinute = 59;
            this.endHour = 20;
            this.endMinute = 59;
            this.interval = 5;
            this.erpUrl = "";
            this.isRunning = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.companyId = _data["companyId"];
            this.companyDataSource = _data["companyDataSource"] ? CompanyDataSource.fromJS(_data["companyDataSource"]) : new CompanyDataSource();
            this.companyDataSourceId = _data["companyDataSourceId"];
            this.erpSyncTransferType = _data["erpSyncTransferType"] ? ErpSyncTransferType.fromJS(_data["erpSyncTransferType"]) : new ErpSyncTransferType();
            this.erpSyncTransferTypeId = _data["erpSyncTransferTypeId"];
            this.startHour = _data["startHour"] !== undefined ? _data["startHour"] : 7;
            this.startMinute = _data["startMinute"] !== undefined ? _data["startMinute"] : 59;
            this.endHour = _data["endHour"] !== undefined ? _data["endHour"] : 20;
            this.endMinute = _data["endMinute"] !== undefined ? _data["endMinute"] : 59;
            this.interval = _data["interval"] !== undefined ? _data["interval"] : 5;
            this.exportView = _data["exportView"];
            this.isActive = _data["isActive"];
            this.notes = _data["notes"];
            this.erpUrl = _data["erpUrl"] !== undefined ? _data["erpUrl"] : "";
            this.exportViewType = _data["exportViewType"];
            this.beforeErpProcedureType = _data["beforeErpProcedureType"];
            this.afterErpProcedureType = _data["afterErpProcedureType"];
            this.lastStartTime = _data["lastStartTime"] ? new Date(_data["lastStartTime"].toString()) : <any>undefined;
            this.lastEndTime = _data["lastEndTime"] ? new Date(_data["lastEndTime"].toString()) : <any>undefined;
            this.isRunning = _data["isRunning"] !== undefined ? _data["isRunning"] : false;
            this.isFinished = _data["isFinished"];
            (<any>this).isRunningTime = _data["isRunningTime"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ErpSyncSetting {
        data = typeof data === 'object' ? data : {};
        let result = new ErpSyncSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["companyDataSource"] = this.companyDataSource ? this.companyDataSource.toJSON() : <any>undefined;
        data["companyDataSourceId"] = this.companyDataSourceId;
        data["erpSyncTransferType"] = this.erpSyncTransferType ? this.erpSyncTransferType.toJSON() : <any>undefined;
        data["erpSyncTransferTypeId"] = this.erpSyncTransferTypeId;
        data["startHour"] = this.startHour;
        data["startMinute"] = this.startMinute;
        data["endHour"] = this.endHour;
        data["endMinute"] = this.endMinute;
        data["interval"] = this.interval;
        data["exportView"] = this.exportView;
        data["isActive"] = this.isActive;
        data["notes"] = this.notes;
        data["erpUrl"] = this.erpUrl;
        data["exportViewType"] = this.exportViewType;
        data["beforeErpProcedureType"] = this.beforeErpProcedureType;
        data["afterErpProcedureType"] = this.afterErpProcedureType;
        data["lastStartTime"] = this.lastStartTime ? this.lastStartTime.toISOString() : <any>undefined;
        data["lastEndTime"] = this.lastEndTime ? this.lastEndTime.toISOString() : <any>undefined;
        data["isRunning"] = this.isRunning;
        data["isFinished"] = this.isFinished;
        data["isRunningTime"] = this.isRunningTime;
        data["id"] = this.id;
        return data;
    }

    clone(): ErpSyncSetting {
        const json = this.toJSON();
        let result = new ErpSyncSetting();
        result.init(json);
        return result;
    }
}

export interface IErpSyncSetting {
    company: Company;
    companyId: number;
    companyDataSource: CompanyDataSource;
    companyDataSourceId: number;
    erpSyncTransferType: ErpSyncTransferType;
    erpSyncTransferTypeId: number;
    startHour: number;
    startMinute: number;
    endHour: number;
    endMinute: number;
    interval: number;
    exportView: string | undefined;
    isActive: boolean;
    notes: string | undefined;
    erpUrl: string | undefined;
    exportViewType: number;
    beforeErpProcedureType: number;
    afterErpProcedureType: number;
    lastStartTime: Date;
    lastEndTime: Date;
    isRunning: boolean;
    isFinished: boolean;
    isRunningTime: boolean;
    id: number;
}

export class ErpSyncSettingDto implements IErpSyncSettingDto {
    company: Company;
    erpSyncTransferType: ErpSyncTransferType;
    companyDataSource: CompanyDataSource;
    erpDbConnection: ErpDbConnection;
    startHour: number;
    startMinute: number;
    endHour: number;
    endMinute: number;
    interval: number;
    exportView: string | undefined;
    insertTable: string | undefined;
    syncProcedureName: string | undefined;
    beforeErpProcedure: string | undefined;
    afterErpProcedure: string | undefined;
    solr: string | undefined;
    isActive: boolean;
    isFirst: boolean;
    endCount: number;
    sendedCount: number;
    notes: string | undefined;
    exportViewType: number;
    beforeErpProcedureType: number;
    afterErpProcedureType: number;
    lastStartTime: Date;
    lastEndTime: Date;
    isRunning: boolean;
    id: number;

    constructor(data?: IErpSyncSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.erpSyncTransferType = _data["erpSyncTransferType"] ? ErpSyncTransferType.fromJS(_data["erpSyncTransferType"]) : <any>undefined;
            this.companyDataSource = _data["companyDataSource"] ? CompanyDataSource.fromJS(_data["companyDataSource"]) : <any>undefined;
            this.erpDbConnection = _data["erpDbConnection"] ? ErpDbConnection.fromJS(_data["erpDbConnection"]) : <any>undefined;
            this.startHour = _data["startHour"];
            this.startMinute = _data["startMinute"];
            this.endHour = _data["endHour"];
            this.endMinute = _data["endMinute"];
            this.interval = _data["interval"];
            this.exportView = _data["exportView"];
            this.insertTable = _data["insertTable"];
            this.syncProcedureName = _data["syncProcedureName"];
            this.beforeErpProcedure = _data["beforeErpProcedure"];
            this.afterErpProcedure = _data["afterErpProcedure"];
            this.solr = _data["solr"];
            this.isActive = _data["isActive"];
            this.isFirst = _data["isFirst"];
            this.endCount = _data["endCount"];
            this.sendedCount = _data["sendedCount"];
            this.notes = _data["notes"];
            this.exportViewType = _data["exportViewType"];
            this.beforeErpProcedureType = _data["beforeErpProcedureType"];
            this.afterErpProcedureType = _data["afterErpProcedureType"];
            this.lastStartTime = _data["lastStartTime"] ? new Date(_data["lastStartTime"].toString()) : <any>undefined;
            this.lastEndTime = _data["lastEndTime"] ? new Date(_data["lastEndTime"].toString()) : <any>undefined;
            this.isRunning = _data["isRunning"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ErpSyncSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErpSyncSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["erpSyncTransferType"] = this.erpSyncTransferType ? this.erpSyncTransferType.toJSON() : <any>undefined;
        data["companyDataSource"] = this.companyDataSource ? this.companyDataSource.toJSON() : <any>undefined;
        data["erpDbConnection"] = this.erpDbConnection ? this.erpDbConnection.toJSON() : <any>undefined;
        data["startHour"] = this.startHour;
        data["startMinute"] = this.startMinute;
        data["endHour"] = this.endHour;
        data["endMinute"] = this.endMinute;
        data["interval"] = this.interval;
        data["exportView"] = this.exportView;
        data["insertTable"] = this.insertTable;
        data["syncProcedureName"] = this.syncProcedureName;
        data["beforeErpProcedure"] = this.beforeErpProcedure;
        data["afterErpProcedure"] = this.afterErpProcedure;
        data["solr"] = this.solr;
        data["isActive"] = this.isActive;
        data["isFirst"] = this.isFirst;
        data["endCount"] = this.endCount;
        data["sendedCount"] = this.sendedCount;
        data["notes"] = this.notes;
        data["exportViewType"] = this.exportViewType;
        data["beforeErpProcedureType"] = this.beforeErpProcedureType;
        data["afterErpProcedureType"] = this.afterErpProcedureType;
        data["lastStartTime"] = this.lastStartTime ? this.lastStartTime.toISOString() : <any>undefined;
        data["lastEndTime"] = this.lastEndTime ? this.lastEndTime.toISOString() : <any>undefined;
        data["isRunning"] = this.isRunning;
        data["id"] = this.id;
        return data;
    }

    clone(): ErpSyncSettingDto {
        const json = this.toJSON();
        let result = new ErpSyncSettingDto();
        result.init(json);
        return result;
    }
}

export interface IErpSyncSettingDto {
    company: Company;
    erpSyncTransferType: ErpSyncTransferType;
    companyDataSource: CompanyDataSource;
    erpDbConnection: ErpDbConnection;
    startHour: number;
    startMinute: number;
    endHour: number;
    endMinute: number;
    interval: number;
    exportView: string | undefined;
    insertTable: string | undefined;
    syncProcedureName: string | undefined;
    beforeErpProcedure: string | undefined;
    afterErpProcedure: string | undefined;
    solr: string | undefined;
    isActive: boolean;
    isFirst: boolean;
    endCount: number;
    sendedCount: number;
    notes: string | undefined;
    exportViewType: number;
    beforeErpProcedureType: number;
    afterErpProcedureType: number;
    lastStartTime: Date;
    lastEndTime: Date;
    isRunning: boolean;
    id: number;
}

export class Erp2Wms_OrderHeader implements IErp2Wms_OrderHeader {
    erpEntegreId: string | undefined;
    documentNo: string | undefined;
    documentNo2: string | undefined;
    documentDate: Date;
    shipmentDate: Date;
    salesmanNot: string | undefined;
    warehouseCode: string | undefined;
    storageCode: string | undefined;
    deliveryAdress1: string | undefined;
    deliveryAdress2: string | undefined;
    type: string | undefined;
    clientErpEntegreId: string | undefined;
    clientCode: string | undefined;
    clientName: string | undefined;
    notes: string | undefined;
    detailCount: string | undefined;
    shippingName: string | undefined;
    shippingAddress: string | undefined;
    shippingAddress2: string | undefined;
    shippingCity: string | undefined;
    shippingTown: string | undefined;
    shippingTypeFromErp: string | undefined;
    shippingTypeAreaFromErp: string | undefined;
    isExport: boolean;
    willBeInvoiced: boolean;
    willBeShippingCost: boolean;
    shippingCostCanChange: boolean;
    shippingCost: number;
    shippingCostQuantity: number;
    invoiceSend: boolean;
    documentNo_Seri: string | undefined;
    documentNo_Sira: string | undefined;
    b2BDocumentNo: string | undefined;

    constructor(data?: IErp2Wms_OrderHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.erpEntegreId = _data["erpEntegreId"];
            this.documentNo = _data["documentNo"];
            this.documentNo2 = _data["documentNo2"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.shipmentDate = _data["shipmentDate"] ? new Date(_data["shipmentDate"].toString()) : <any>undefined;
            this.salesmanNot = _data["salesmanNot"];
            this.warehouseCode = _data["warehouseCode"];
            this.storageCode = _data["storageCode"];
            this.deliveryAdress1 = _data["deliveryAdress1"];
            this.deliveryAdress2 = _data["deliveryAdress2"];
            this.type = _data["type"];
            this.clientErpEntegreId = _data["clientErpEntegreId"];
            this.clientCode = _data["clientCode"];
            this.clientName = _data["clientName"];
            this.notes = _data["notes"];
            this.detailCount = _data["detailCount"];
            this.shippingName = _data["shippingName"];
            this.shippingAddress = _data["shippingAddress"];
            this.shippingAddress2 = _data["shippingAddress2"];
            this.shippingCity = _data["shippingCity"];
            this.shippingTown = _data["shippingTown"];
            this.shippingTypeFromErp = _data["shippingTypeFromErp"];
            this.shippingTypeAreaFromErp = _data["shippingTypeAreaFromErp"];
            this.isExport = _data["isExport"];
            this.willBeInvoiced = _data["willBeInvoiced"];
            this.willBeShippingCost = _data["willBeShippingCost"];
            this.shippingCostCanChange = _data["shippingCostCanChange"];
            this.shippingCost = _data["shippingCost"];
            this.shippingCostQuantity = _data["shippingCostQuantity"];
            this.invoiceSend = _data["invoiceSend"];
            this.documentNo_Seri = _data["documentNo_Seri"];
            this.documentNo_Sira = _data["documentNo_Sira"];
            this.b2BDocumentNo = _data["b2BDocumentNo"];
        }
    }

    static fromJS(data: any): Erp2Wms_OrderHeader {
        data = typeof data === 'object' ? data : {};
        let result = new Erp2Wms_OrderHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["erpEntegreId"] = this.erpEntegreId;
        data["documentNo"] = this.documentNo;
        data["documentNo2"] = this.documentNo2;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : <any>undefined;
        data["salesmanNot"] = this.salesmanNot;
        data["warehouseCode"] = this.warehouseCode;
        data["storageCode"] = this.storageCode;
        data["deliveryAdress1"] = this.deliveryAdress1;
        data["deliveryAdress2"] = this.deliveryAdress2;
        data["type"] = this.type;
        data["clientErpEntegreId"] = this.clientErpEntegreId;
        data["clientCode"] = this.clientCode;
        data["clientName"] = this.clientName;
        data["notes"] = this.notes;
        data["detailCount"] = this.detailCount;
        data["shippingName"] = this.shippingName;
        data["shippingAddress"] = this.shippingAddress;
        data["shippingAddress2"] = this.shippingAddress2;
        data["shippingCity"] = this.shippingCity;
        data["shippingTown"] = this.shippingTown;
        data["shippingTypeFromErp"] = this.shippingTypeFromErp;
        data["shippingTypeAreaFromErp"] = this.shippingTypeAreaFromErp;
        data["isExport"] = this.isExport;
        data["willBeInvoiced"] = this.willBeInvoiced;
        data["willBeShippingCost"] = this.willBeShippingCost;
        data["shippingCostCanChange"] = this.shippingCostCanChange;
        data["shippingCost"] = this.shippingCost;
        data["shippingCostQuantity"] = this.shippingCostQuantity;
        data["invoiceSend"] = this.invoiceSend;
        data["documentNo_Seri"] = this.documentNo_Seri;
        data["documentNo_Sira"] = this.documentNo_Sira;
        data["b2BDocumentNo"] = this.b2BDocumentNo;
        return data;
    }

    clone(): Erp2Wms_OrderHeader {
        const json = this.toJSON();
        let result = new Erp2Wms_OrderHeader();
        result.init(json);
        return result;
    }
}

export interface IErp2Wms_OrderHeader {
    erpEntegreId: string | undefined;
    documentNo: string | undefined;
    documentNo2: string | undefined;
    documentDate: Date;
    shipmentDate: Date;
    salesmanNot: string | undefined;
    warehouseCode: string | undefined;
    storageCode: string | undefined;
    deliveryAdress1: string | undefined;
    deliveryAdress2: string | undefined;
    type: string | undefined;
    clientErpEntegreId: string | undefined;
    clientCode: string | undefined;
    clientName: string | undefined;
    notes: string | undefined;
    detailCount: string | undefined;
    shippingName: string | undefined;
    shippingAddress: string | undefined;
    shippingAddress2: string | undefined;
    shippingCity: string | undefined;
    shippingTown: string | undefined;
    shippingTypeFromErp: string | undefined;
    shippingTypeAreaFromErp: string | undefined;
    isExport: boolean;
    willBeInvoiced: boolean;
    willBeShippingCost: boolean;
    shippingCostCanChange: boolean;
    shippingCost: number;
    shippingCostQuantity: number;
    invoiceSend: boolean;
    documentNo_Seri: string | undefined;
    documentNo_Sira: string | undefined;
    b2BDocumentNo: string | undefined;
}

export class Erp2Wms_WaybillHeader implements IErp2Wms_WaybillHeader {
    erpEntegreId: string | undefined;
    documentNo: string | undefined;
    documentNo2: string | undefined;
    documentDate: Date;
    deadlineDate: Date;
    warehouseCode: string | undefined;
    storageCode: string | undefined;
    type: string | undefined;
    clientErpEntegreId: string | undefined;
    clientCode: string | undefined;
    clientName: string | undefined;
    notes: string | undefined;
    detailCount: string | undefined;

    constructor(data?: IErp2Wms_WaybillHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.erpEntegreId = _data["erpEntegreId"];
            this.documentNo = _data["documentNo"];
            this.documentNo2 = _data["documentNo2"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.deadlineDate = _data["deadlineDate"] ? new Date(_data["deadlineDate"].toString()) : <any>undefined;
            this.warehouseCode = _data["warehouseCode"];
            this.storageCode = _data["storageCode"];
            this.type = _data["type"];
            this.clientErpEntegreId = _data["clientErpEntegreId"];
            this.clientCode = _data["clientCode"];
            this.clientName = _data["clientName"];
            this.notes = _data["notes"];
            this.detailCount = _data["detailCount"];
        }
    }

    static fromJS(data: any): Erp2Wms_WaybillHeader {
        data = typeof data === 'object' ? data : {};
        let result = new Erp2Wms_WaybillHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["erpEntegreId"] = this.erpEntegreId;
        data["documentNo"] = this.documentNo;
        data["documentNo2"] = this.documentNo2;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["deadlineDate"] = this.deadlineDate ? this.deadlineDate.toISOString() : <any>undefined;
        data["warehouseCode"] = this.warehouseCode;
        data["storageCode"] = this.storageCode;
        data["type"] = this.type;
        data["clientErpEntegreId"] = this.clientErpEntegreId;
        data["clientCode"] = this.clientCode;
        data["clientName"] = this.clientName;
        data["notes"] = this.notes;
        data["detailCount"] = this.detailCount;
        return data;
    }

    clone(): Erp2Wms_WaybillHeader {
        const json = this.toJSON();
        let result = new Erp2Wms_WaybillHeader();
        result.init(json);
        return result;
    }
}

export interface IErp2Wms_WaybillHeader {
    erpEntegreId: string | undefined;
    documentNo: string | undefined;
    documentNo2: string | undefined;
    documentDate: Date;
    deadlineDate: Date;
    warehouseCode: string | undefined;
    storageCode: string | undefined;
    type: string | undefined;
    clientErpEntegreId: string | undefined;
    clientCode: string | undefined;
    clientName: string | undefined;
    notes: string | undefined;
    detailCount: string | undefined;
}

export class ErpProcessType implements IErpProcessType {
    code: string | undefined;
    definition: string | undefined;
    priority: number;
    id: number;

    constructor(data?: IErpProcessType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.priority = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.priority = _data["priority"] !== undefined ? _data["priority"] : 0;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ErpProcessType {
        data = typeof data === 'object' ? data : {};
        let result = new ErpProcessType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["priority"] = this.priority;
        data["id"] = this.id;
        return data;
    }

    clone(): ErpProcessType {
        const json = this.toJSON();
        let result = new ErpProcessType();
        result.init(json);
        return result;
    }
}

export interface IErpProcessType {
    code: string | undefined;
    definition: string | undefined;
    priority: number;
    id: number;
}

export enum ErpProcessSourceType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class ErpProcessHeader implements IErpProcessHeader {
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    type: ErpProcessType;
    typeId: number;
    reference: string | undefined;
    sourceId: number;
    sourceType: ErpProcessSourceType;
    companyDataSourceId: number;
    erpDocumentNo: string | undefined;
    warehouseCode: string | undefined;
    warehouseFrom: Warehouse;
    warehouseFromId: number | undefined;
    warehouseTo: Warehouse;
    warehouseToId: number | undefined;
    client: Client;
    clientId: number | undefined;
    storageFrom: Storage;
    storageFromId: number | undefined;
    storageTo: Storage;
    storageToId: number | undefined;
    isLocal: boolean;
    tryCount: number;
    isTransfered: boolean;
    transferTime: Date | undefined;
    errorMessage: string | undefined;
    isTransfering: boolean;
    transferingStartTime: Date | undefined;
    transferingFinishTime: Date | undefined;
    notes: string | undefined;
    readonly explanation: string | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IErpProcessHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.company = new Company();
            this.warehouse = new Warehouse();
            this.type = new ErpProcessType();
            this.sourceId = 0;
            this.companyDataSourceId = 0;
            this.isLocal = false;
            this.isTransfered = false;
            this.isTransfering = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.companyId = _data["companyId"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.warehouseId = _data["warehouseId"];
            this.type = _data["type"] ? ErpProcessType.fromJS(_data["type"]) : new ErpProcessType();
            this.typeId = _data["typeId"];
            this.reference = _data["reference"];
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : 0;
            this.sourceType = _data["sourceType"];
            this.companyDataSourceId = _data["companyDataSourceId"] !== undefined ? _data["companyDataSourceId"] : 0;
            this.erpDocumentNo = _data["erpDocumentNo"];
            this.warehouseCode = _data["warehouseCode"];
            this.warehouseFrom = _data["warehouseFrom"] ? Warehouse.fromJS(_data["warehouseFrom"]) : <any>undefined;
            this.warehouseFromId = _data["warehouseFromId"];
            this.warehouseTo = _data["warehouseTo"] ? Warehouse.fromJS(_data["warehouseTo"]) : <any>undefined;
            this.warehouseToId = _data["warehouseToId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>undefined;
            this.clientId = _data["clientId"];
            this.storageFrom = _data["storageFrom"] ? Storage.fromJS(_data["storageFrom"]) : <any>undefined;
            this.storageFromId = _data["storageFromId"];
            this.storageTo = _data["storageTo"] ? Storage.fromJS(_data["storageTo"]) : <any>undefined;
            this.storageToId = _data["storageToId"];
            this.isLocal = _data["isLocal"] !== undefined ? _data["isLocal"] : false;
            this.tryCount = _data["tryCount"];
            this.isTransfered = _data["isTransfered"] !== undefined ? _data["isTransfered"] : false;
            this.transferTime = _data["transferTime"] ? new Date(_data["transferTime"].toString()) : <any>undefined;
            this.errorMessage = _data["errorMessage"];
            this.isTransfering = _data["isTransfering"] !== undefined ? _data["isTransfering"] : false;
            this.transferingStartTime = _data["transferingStartTime"] ? new Date(_data["transferingStartTime"].toString()) : <any>undefined;
            this.transferingFinishTime = _data["transferingFinishTime"] ? new Date(_data["transferingFinishTime"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            (<any>this).explanation = _data["explanation"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ErpProcessHeader {
        data = typeof data === 'object' ? data : {};
        let result = new ErpProcessHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["reference"] = this.reference;
        data["sourceId"] = this.sourceId;
        data["sourceType"] = this.sourceType;
        data["companyDataSourceId"] = this.companyDataSourceId;
        data["erpDocumentNo"] = this.erpDocumentNo;
        data["warehouseCode"] = this.warehouseCode;
        data["warehouseFrom"] = this.warehouseFrom ? this.warehouseFrom.toJSON() : <any>undefined;
        data["warehouseFromId"] = this.warehouseFromId;
        data["warehouseTo"] = this.warehouseTo ? this.warehouseTo.toJSON() : <any>undefined;
        data["warehouseToId"] = this.warehouseToId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["storageFrom"] = this.storageFrom ? this.storageFrom.toJSON() : <any>undefined;
        data["storageFromId"] = this.storageFromId;
        data["storageTo"] = this.storageTo ? this.storageTo.toJSON() : <any>undefined;
        data["storageToId"] = this.storageToId;
        data["isLocal"] = this.isLocal;
        data["tryCount"] = this.tryCount;
        data["isTransfered"] = this.isTransfered;
        data["transferTime"] = this.transferTime ? this.transferTime.toISOString() : <any>undefined;
        data["errorMessage"] = this.errorMessage;
        data["isTransfering"] = this.isTransfering;
        data["transferingStartTime"] = this.transferingStartTime ? this.transferingStartTime.toISOString() : <any>undefined;
        data["transferingFinishTime"] = this.transferingFinishTime ? this.transferingFinishTime.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["explanation"] = this.explanation;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ErpProcessHeader {
        const json = this.toJSON();
        let result = new ErpProcessHeader();
        result.init(json);
        return result;
    }
}

export interface IErpProcessHeader {
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    type: ErpProcessType;
    typeId: number;
    reference: string | undefined;
    sourceId: number;
    sourceType: ErpProcessSourceType;
    companyDataSourceId: number;
    erpDocumentNo: string | undefined;
    warehouseCode: string | undefined;
    warehouseFrom: Warehouse;
    warehouseFromId: number | undefined;
    warehouseTo: Warehouse;
    warehouseToId: number | undefined;
    client: Client;
    clientId: number | undefined;
    storageFrom: Storage;
    storageFromId: number | undefined;
    storageTo: Storage;
    storageToId: number | undefined;
    isLocal: boolean;
    tryCount: number;
    isTransfered: boolean;
    transferTime: Date | undefined;
    errorMessage: string | undefined;
    isTransfering: boolean;
    transferingStartTime: Date | undefined;
    transferingFinishTime: Date | undefined;
    notes: string | undefined;
    explanation: string | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class ErpProcessHeaderPagedResultDto implements IErpProcessHeaderPagedResultDto {
    totalCount: number;
    items: ErpProcessHeader[] | undefined;

    constructor(data?: IErpProcessHeaderPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ErpProcessHeader.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ErpProcessHeaderPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErpProcessHeaderPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ErpProcessHeaderPagedResultDto {
        const json = this.toJSON();
        let result = new ErpProcessHeaderPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IErpProcessHeaderPagedResultDto {
    totalCount: number;
    items: ErpProcessHeader[] | undefined;
}

export class Country implements ICountry {
    name: string | undefined;
    nameEn: string | undefined;
    alpha2Code: string | undefined;
    alpha3Code: string | undefined;
    numericCode: string | undefined;
    showForExport: boolean;
    id: number;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.showForExport = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameEn = _data["nameEn"];
            this.alpha2Code = _data["alpha2Code"];
            this.alpha3Code = _data["alpha3Code"];
            this.numericCode = _data["numericCode"];
            this.showForExport = _data["showForExport"] !== undefined ? _data["showForExport"] : false;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameEn"] = this.nameEn;
        data["alpha2Code"] = this.alpha2Code;
        data["alpha3Code"] = this.alpha3Code;
        data["numericCode"] = this.numericCode;
        data["showForExport"] = this.showForExport;
        data["id"] = this.id;
        return data;
    }

    clone(): Country {
        const json = this.toJSON();
        let result = new Country();
        result.init(json);
        return result;
    }
}

export interface ICountry {
    name: string | undefined;
    nameEn: string | undefined;
    alpha2Code: string | undefined;
    alpha3Code: string | undefined;
    numericCode: string | undefined;
    showForExport: boolean;
    id: number;
}

export class Product implements IProduct {
    company: Company;
    companyId: number;
    erpEntegreId: string;
    code: string;
    definition: string | undefined;
    definition2: string | undefined;
    manufacturer: string | undefined;
    manufacturerCode: string | undefined;
    oeCode: string | undefined;
    unit: string | undefined;
    groupCode: string | undefined;
    group1: string | undefined;
    group2: string | undefined;
    group3: string | undefined;
    sizeWidth: number;
    sizeLength: number;
    sizeHeight: number;
    weight: number;
    volume: number;
    hasSerial: boolean;
    salesPrice: number;
    salesCurrency: string | undefined;
    purchasePrice: number;
    purchaseCurrency: string | undefined;
    taxRate: number;
    origin: Country;
    originStr: string | undefined;
    isFifo: boolean;
    natraShelf: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.company = new Company();
            this.definition = "";
            this.definition2 = "";
            this.manufacturer = "";
            this.manufacturerCode = "";
            this.oeCode = "";
            this.unit = "";
            this.groupCode = "";
            this.group1 = "";
            this.group2 = "";
            this.group3 = "";
            this.sizeWidth = 0;
            this.sizeLength = 0;
            this.sizeHeight = 0;
            this.weight = 0;
            this.volume = 0;
            this.hasSerial = false;
            this.salesPrice = 0;
            this.salesCurrency = "";
            this.purchasePrice = 0;
            this.purchaseCurrency = "";
            this.taxRate = 0;
            this.isFifo = false;
            this.natraShelf = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.companyId = _data["companyId"];
            this.erpEntegreId = _data["erpEntegreId"];
            this.code = _data["code"];
            this.definition = _data["definition"] !== undefined ? _data["definition"] : "";
            this.definition2 = _data["definition2"] !== undefined ? _data["definition2"] : "";
            this.manufacturer = _data["manufacturer"] !== undefined ? _data["manufacturer"] : "";
            this.manufacturerCode = _data["manufacturerCode"] !== undefined ? _data["manufacturerCode"] : "";
            this.oeCode = _data["oeCode"] !== undefined ? _data["oeCode"] : "";
            this.unit = _data["unit"] !== undefined ? _data["unit"] : "";
            this.groupCode = _data["groupCode"] !== undefined ? _data["groupCode"] : "";
            this.group1 = _data["group1"] !== undefined ? _data["group1"] : "";
            this.group2 = _data["group2"] !== undefined ? _data["group2"] : "";
            this.group3 = _data["group3"] !== undefined ? _data["group3"] : "";
            this.sizeWidth = _data["sizeWidth"] !== undefined ? _data["sizeWidth"] : 0;
            this.sizeLength = _data["sizeLength"] !== undefined ? _data["sizeLength"] : 0;
            this.sizeHeight = _data["sizeHeight"] !== undefined ? _data["sizeHeight"] : 0;
            this.weight = _data["weight"] !== undefined ? _data["weight"] : 0;
            this.volume = _data["volume"] !== undefined ? _data["volume"] : 0;
            this.hasSerial = _data["hasSerial"] !== undefined ? _data["hasSerial"] : false;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : 0;
            this.salesCurrency = _data["salesCurrency"] !== undefined ? _data["salesCurrency"] : "";
            this.purchasePrice = _data["purchasePrice"] !== undefined ? _data["purchasePrice"] : 0;
            this.purchaseCurrency = _data["purchaseCurrency"] !== undefined ? _data["purchaseCurrency"] : "";
            this.taxRate = _data["taxRate"] !== undefined ? _data["taxRate"] : 0;
            this.origin = _data["origin"] ? Country.fromJS(_data["origin"]) : <any>undefined;
            this.originStr = _data["originStr"];
            this.isFifo = _data["isFifo"] !== undefined ? _data["isFifo"] : false;
            this.natraShelf = _data["natraShelf"] !== undefined ? _data["natraShelf"] : "";
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["erpEntegreId"] = this.erpEntegreId;
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["definition2"] = this.definition2;
        data["manufacturer"] = this.manufacturer;
        data["manufacturerCode"] = this.manufacturerCode;
        data["oeCode"] = this.oeCode;
        data["unit"] = this.unit;
        data["groupCode"] = this.groupCode;
        data["group1"] = this.group1;
        data["group2"] = this.group2;
        data["group3"] = this.group3;
        data["sizeWidth"] = this.sizeWidth;
        data["sizeLength"] = this.sizeLength;
        data["sizeHeight"] = this.sizeHeight;
        data["weight"] = this.weight;
        data["volume"] = this.volume;
        data["hasSerial"] = this.hasSerial;
        data["salesPrice"] = this.salesPrice;
        data["salesCurrency"] = this.salesCurrency;
        data["purchasePrice"] = this.purchasePrice;
        data["purchaseCurrency"] = this.purchaseCurrency;
        data["taxRate"] = this.taxRate;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["originStr"] = this.originStr;
        data["isFifo"] = this.isFifo;
        data["natraShelf"] = this.natraShelf;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Product {
        const json = this.toJSON();
        let result = new Product();
        result.init(json);
        return result;
    }
}

export interface IProduct {
    company: Company;
    companyId: number;
    erpEntegreId: string;
    code: string;
    definition: string | undefined;
    definition2: string | undefined;
    manufacturer: string | undefined;
    manufacturerCode: string | undefined;
    oeCode: string | undefined;
    unit: string | undefined;
    groupCode: string | undefined;
    group1: string | undefined;
    group2: string | undefined;
    group3: string | undefined;
    sizeWidth: number;
    sizeLength: number;
    sizeHeight: number;
    weight: number;
    volume: number;
    hasSerial: boolean;
    salesPrice: number;
    salesCurrency: string | undefined;
    purchasePrice: number;
    purchaseCurrency: string | undefined;
    taxRate: number;
    origin: Country;
    originStr: string | undefined;
    isFifo: boolean;
    natraShelf: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export enum MovementType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ErpProcessDetail implements IErpProcessDetail {
    erpProcessHeader: ErpProcessHeader;
    erpProcessHeaderId: number;
    sourceId: number;
    product: Product;
    productId: number | undefined;
    quantity: number;
    price: number;
    errorMessage: string | undefined;
    isTransfered: boolean;
    movementType: MovementType;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IErpProcessDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.erpProcessHeader = new ErpProcessHeader();
            this.sourceId = 0;
            this.quantity = 0;
            this.price = 0;
            this.errorMessage = "";
            this.isTransfered = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.erpProcessHeader = _data["erpProcessHeader"] ? ErpProcessHeader.fromJS(_data["erpProcessHeader"]) : new ErpProcessHeader();
            this.erpProcessHeaderId = _data["erpProcessHeaderId"];
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : 0;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.productId = _data["productId"];
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : 0;
            this.price = _data["price"] !== undefined ? _data["price"] : 0;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : "";
            this.isTransfered = _data["isTransfered"] !== undefined ? _data["isTransfered"] : false;
            this.movementType = _data["movementType"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ErpProcessDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ErpProcessDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["erpProcessHeader"] = this.erpProcessHeader ? this.erpProcessHeader.toJSON() : <any>undefined;
        data["erpProcessHeaderId"] = this.erpProcessHeaderId;
        data["sourceId"] = this.sourceId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["errorMessage"] = this.errorMessage;
        data["isTransfered"] = this.isTransfered;
        data["movementType"] = this.movementType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ErpProcessDetail {
        const json = this.toJSON();
        let result = new ErpProcessDetail();
        result.init(json);
        return result;
    }
}

export interface IErpProcessDetail {
    erpProcessHeader: ErpProcessHeader;
    erpProcessHeaderId: number;
    sourceId: number;
    product: Product;
    productId: number | undefined;
    quantity: number;
    price: number;
    errorMessage: string | undefined;
    isTransfered: boolean;
    movementType: MovementType;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class ZeusSetupSqlScripts implements IZeusSetupSqlScripts {
    erpType: ErpType;
    command: string | undefined;
    type: number;
    commandType: number;
    isComplated: boolean;
    definition: string | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IZeusSetupSqlScripts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.erpType = _data["erpType"] ? ErpType.fromJS(_data["erpType"]) : <any>undefined;
            this.command = _data["command"];
            this.type = _data["type"];
            this.commandType = _data["commandType"];
            this.isComplated = _data["isComplated"];
            this.definition = _data["definition"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ZeusSetupSqlScripts {
        data = typeof data === 'object' ? data : {};
        let result = new ZeusSetupSqlScripts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["erpType"] = this.erpType ? this.erpType.toJSON() : <any>undefined;
        data["command"] = this.command;
        data["type"] = this.type;
        data["commandType"] = this.commandType;
        data["isComplated"] = this.isComplated;
        data["definition"] = this.definition;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ZeusSetupSqlScripts {
        const json = this.toJSON();
        let result = new ZeusSetupSqlScripts();
        result.init(json);
        return result;
    }
}

export interface IZeusSetupSqlScripts {
    erpType: ErpType;
    command: string | undefined;
    type: number;
    commandType: number;
    isComplated: boolean;
    definition: string | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class PagedGetImagerUrlResponseDto implements IPagedGetImagerUrlResponseDto {
    url: string | undefined;
    clientName: string | undefined;
    userFullName: string | undefined;
    fileName: string | undefined;
    documentNo: string | undefined;
    productCode: string | undefined;
    productDefinition: string | undefined;
    creationTime: Date;
    base64: string | undefined;

    constructor(data?: IPagedGetImagerUrlResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.clientName = _data["clientName"];
            this.userFullName = _data["userFullName"];
            this.fileName = _data["fileName"];
            this.documentNo = _data["documentNo"];
            this.productCode = _data["productCode"];
            this.productDefinition = _data["productDefinition"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): PagedGetImagerUrlResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedGetImagerUrlResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["clientName"] = this.clientName;
        data["userFullName"] = this.userFullName;
        data["fileName"] = this.fileName;
        data["documentNo"] = this.documentNo;
        data["productCode"] = this.productCode;
        data["productDefinition"] = this.productDefinition;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["base64"] = this.base64;
        return data;
    }

    clone(): PagedGetImagerUrlResponseDto {
        const json = this.toJSON();
        let result = new PagedGetImagerUrlResponseDto();
        result.init(json);
        return result;
    }
}

export interface IPagedGetImagerUrlResponseDto {
    url: string | undefined;
    clientName: string | undefined;
    userFullName: string | undefined;
    fileName: string | undefined;
    documentNo: string | undefined;
    productCode: string | undefined;
    productDefinition: string | undefined;
    creationTime: Date;
    base64: string | undefined;
}

export class PagedGetImagerUrlResponseDtoPagedResultDto implements IPagedGetImagerUrlResponseDtoPagedResultDto {
    totalCount: number;
    items: PagedGetImagerUrlResponseDto[] | undefined;

    constructor(data?: IPagedGetImagerUrlResponseDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PagedGetImagerUrlResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedGetImagerUrlResponseDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedGetImagerUrlResponseDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedGetImagerUrlResponseDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PagedGetImagerUrlResponseDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPagedGetImagerUrlResponseDtoPagedResultDto {
    totalCount: number;
    items: PagedGetImagerUrlResponseDto[] | undefined;
}

export enum FileType {
    _1 = 1,
}

export class File implements IFile {
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    sourceId: number;
    url: string;
    fileName: string | undefined;
    type: FileType;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.company = new Company();
            this.warehouse = new Warehouse();
            this.sourceId = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.companyId = _data["companyId"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.warehouseId = _data["warehouseId"];
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : 0;
            this.url = _data["url"];
            this.fileName = _data["fileName"];
            this.type = _data["type"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): File {
        data = typeof data === 'object' ? data : {};
        let result = new File();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["sourceId"] = this.sourceId;
        data["url"] = this.url;
        data["fileName"] = this.fileName;
        data["type"] = this.type;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): File {
        const json = this.toJSON();
        let result = new File();
        result.init(json);
        return result;
    }
}

export interface IFile {
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    sourceId: number;
    url: string;
    fileName: string | undefined;
    type: FileType;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class PhotoForWaybillDto implements IPhotoForWaybillDto {
    url: string | undefined;
    fileName: string | undefined;
    id: number;

    constructor(data?: IPhotoForWaybillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.fileName = _data["fileName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PhotoForWaybillDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoForWaybillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["fileName"] = this.fileName;
        data["id"] = this.id;
        return data;
    }

    clone(): PhotoForWaybillDto {
        const json = this.toJSON();
        let result = new PhotoForWaybillDto();
        result.init(json);
        return result;
    }
}

export interface IPhotoForWaybillDto {
    url: string | undefined;
    fileName: string | undefined;
    id: number;
}

export class InvoiceDetail implements IInvoiceDetail {
    erpEntegreId: string | undefined;
    productCode: string | undefined;
    productName: string | undefined;
    productUnit: string | undefined;
    productTaxRate: number;
    product: Product;
    quantity: number;
    price: number;
    priceNet: number;
    total: number;
    totalNet: number;
    totalDiscount: number;
    totalTax: number;
    taxRate: number;
    readonly amount: number;
    disc1: number;
    disc2: number;
    disc3: number;
    disc4: number;
    disc5: number;
    disc6: number;
    readonly discStr: string | undefined;
    currency: string | undefined;
    currencyRate: number;

    constructor(data?: IInvoiceDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.erpEntegreId = _data["erpEntegreId"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.productUnit = _data["productUnit"];
            this.productTaxRate = _data["productTaxRate"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.priceNet = _data["priceNet"];
            this.total = _data["total"];
            this.totalNet = _data["totalNet"];
            this.totalDiscount = _data["totalDiscount"];
            this.totalTax = _data["totalTax"];
            this.taxRate = _data["taxRate"];
            (<any>this).amount = _data["amount"];
            this.disc1 = _data["disc1"];
            this.disc2 = _data["disc2"];
            this.disc3 = _data["disc3"];
            this.disc4 = _data["disc4"];
            this.disc5 = _data["disc5"];
            this.disc6 = _data["disc6"];
            (<any>this).discStr = _data["discStr"];
            this.currency = _data["currency"];
            this.currencyRate = _data["currencyRate"];
        }
    }

    static fromJS(data: any): InvoiceDetail {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["erpEntegreId"] = this.erpEntegreId;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productUnit"] = this.productUnit;
        data["productTaxRate"] = this.productTaxRate;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["priceNet"] = this.priceNet;
        data["total"] = this.total;
        data["totalNet"] = this.totalNet;
        data["totalDiscount"] = this.totalDiscount;
        data["totalTax"] = this.totalTax;
        data["taxRate"] = this.taxRate;
        data["amount"] = this.amount;
        data["disc1"] = this.disc1;
        data["disc2"] = this.disc2;
        data["disc3"] = this.disc3;
        data["disc4"] = this.disc4;
        data["disc5"] = this.disc5;
        data["disc6"] = this.disc6;
        data["discStr"] = this.discStr;
        data["currency"] = this.currency;
        data["currencyRate"] = this.currencyRate;
        return data;
    }

    clone(): InvoiceDetail {
        const json = this.toJSON();
        let result = new InvoiceDetail();
        result.init(json);
        return result;
    }
}

export interface IInvoiceDetail {
    erpEntegreId: string | undefined;
    productCode: string | undefined;
    productName: string | undefined;
    productUnit: string | undefined;
    productTaxRate: number;
    product: Product;
    quantity: number;
    price: number;
    priceNet: number;
    total: number;
    totalNet: number;
    totalDiscount: number;
    totalTax: number;
    taxRate: number;
    amount: number;
    disc1: number;
    disc2: number;
    disc3: number;
    disc4: number;
    disc5: number;
    disc6: number;
    discStr: string | undefined;
    currency: string | undefined;
    currencyRate: number;
}

export class InvoiceHeader implements IInvoiceHeader {
    erpEntegreId: string | undefined;
    branchName: string | undefined;
    type: number;
    ettn: string | undefined;
    isEInvoice: boolean;
    eDocumentType: EDocumentType;
    clientCode: string | undefined;
    client: Client;
    documentDate: Date;
    documentNo: string | undefined;
    notes: string | undefined;
    scenario: string | undefined;
    invoiceTypeStr: string | undefined;
    clientName: string | undefined;
    clientAddress: string | undefined;
    clientAddressTown: string | undefined;
    clientAddressCity: string | undefined;
    clientAddressCountry: string | undefined;
    clientTel1: string | undefined;
    clientTel2: string | undefined;
    clientFax: string | undefined;
    clientGsm1: string | undefined;
    clientGsm2: string | undefined;
    clientFinanceBalance: number;
    clientTaxOffice: string | undefined;
    clientTaxNumber: string | undefined;
    documentCurrency: string | undefined;
    documentCurrencyRate: number;
    shippingCost: number;
    shipAgentName: string | undefined;
    shipAgentTaxNumber: string | undefined;
    detailList: InvoiceDetail[] | undefined;
    totalPackage: number;

    constructor(data?: IInvoiceHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.erpEntegreId = _data["erpEntegreId"];
            this.branchName = _data["branchName"];
            this.type = _data["type"];
            this.ettn = _data["ettn"];
            this.isEInvoice = _data["isEInvoice"];
            this.eDocumentType = _data["eDocumentType"];
            this.clientCode = _data["clientCode"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>undefined;
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.documentNo = _data["documentNo"];
            this.notes = _data["notes"];
            this.scenario = _data["scenario"];
            this.invoiceTypeStr = _data["invoiceTypeStr"];
            this.clientName = _data["clientName"];
            this.clientAddress = _data["clientAddress"];
            this.clientAddressTown = _data["clientAddressTown"];
            this.clientAddressCity = _data["clientAddressCity"];
            this.clientAddressCountry = _data["clientAddressCountry"];
            this.clientTel1 = _data["clientTel1"];
            this.clientTel2 = _data["clientTel2"];
            this.clientFax = _data["clientFax"];
            this.clientGsm1 = _data["clientGsm1"];
            this.clientGsm2 = _data["clientGsm2"];
            this.clientFinanceBalance = _data["clientFinanceBalance"];
            this.clientTaxOffice = _data["clientTaxOffice"];
            this.clientTaxNumber = _data["clientTaxNumber"];
            this.documentCurrency = _data["documentCurrency"];
            this.documentCurrencyRate = _data["documentCurrencyRate"];
            this.shippingCost = _data["shippingCost"];
            this.shipAgentName = _data["shipAgentName"];
            this.shipAgentTaxNumber = _data["shipAgentTaxNumber"];
            if (Array.isArray(_data["detailList"])) {
                this.detailList = [] as any;
                for (let item of _data["detailList"])
                    this.detailList.push(InvoiceDetail.fromJS(item));
            }
            this.totalPackage = _data["totalPackage"];
        }
    }

    static fromJS(data: any): InvoiceHeader {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["erpEntegreId"] = this.erpEntegreId;
        data["branchName"] = this.branchName;
        data["type"] = this.type;
        data["ettn"] = this.ettn;
        data["isEInvoice"] = this.isEInvoice;
        data["eDocumentType"] = this.eDocumentType;
        data["clientCode"] = this.clientCode;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["documentNo"] = this.documentNo;
        data["notes"] = this.notes;
        data["scenario"] = this.scenario;
        data["invoiceTypeStr"] = this.invoiceTypeStr;
        data["clientName"] = this.clientName;
        data["clientAddress"] = this.clientAddress;
        data["clientAddressTown"] = this.clientAddressTown;
        data["clientAddressCity"] = this.clientAddressCity;
        data["clientAddressCountry"] = this.clientAddressCountry;
        data["clientTel1"] = this.clientTel1;
        data["clientTel2"] = this.clientTel2;
        data["clientFax"] = this.clientFax;
        data["clientGsm1"] = this.clientGsm1;
        data["clientGsm2"] = this.clientGsm2;
        data["clientFinanceBalance"] = this.clientFinanceBalance;
        data["clientTaxOffice"] = this.clientTaxOffice;
        data["clientTaxNumber"] = this.clientTaxNumber;
        data["documentCurrency"] = this.documentCurrency;
        data["documentCurrencyRate"] = this.documentCurrencyRate;
        data["shippingCost"] = this.shippingCost;
        data["shipAgentName"] = this.shipAgentName;
        data["shipAgentTaxNumber"] = this.shipAgentTaxNumber;
        if (Array.isArray(this.detailList)) {
            data["detailList"] = [];
            for (let item of this.detailList)
                data["detailList"].push(item.toJSON());
        }
        data["totalPackage"] = this.totalPackage;
        return data;
    }

    clone(): InvoiceHeader {
        const json = this.toJSON();
        let result = new InvoiceHeader();
        result.init(json);
        return result;
    }
}

export interface IInvoiceHeader {
    erpEntegreId: string | undefined;
    branchName: string | undefined;
    type: number;
    ettn: string | undefined;
    isEInvoice: boolean;
    eDocumentType: EDocumentType;
    clientCode: string | undefined;
    client: Client;
    documentDate: Date;
    documentNo: string | undefined;
    notes: string | undefined;
    scenario: string | undefined;
    invoiceTypeStr: string | undefined;
    clientName: string | undefined;
    clientAddress: string | undefined;
    clientAddressTown: string | undefined;
    clientAddressCity: string | undefined;
    clientAddressCountry: string | undefined;
    clientTel1: string | undefined;
    clientTel2: string | undefined;
    clientFax: string | undefined;
    clientGsm1: string | undefined;
    clientGsm2: string | undefined;
    clientFinanceBalance: number;
    clientTaxOffice: string | undefined;
    clientTaxNumber: string | undefined;
    documentCurrency: string | undefined;
    documentCurrencyRate: number;
    shippingCost: number;
    shipAgentName: string | undefined;
    shipAgentTaxNumber: string | undefined;
    detailList: InvoiceDetail[] | undefined;
    totalPackage: number;
}

export enum NotificationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum UserNotificationState {
    _0 = 0,
    _1 = 1,
}

export class NotificationData implements INotificationData {
    readonly type: string | undefined;
    properties: { [key: string]: any; } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).type = _data["type"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)[key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key];
            }
        }
        return data;
    }

    clone(): NotificationData {
        const json = this.toJSON();
        let result = new NotificationData();
        result.init(json);
        return result;
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string]: any; } | undefined;
}

export enum MemberTypes {
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _191 = 191,
}

export enum MethodAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _1024 = 1024,
    _2048 = 2048,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _53248 = 53248,
}

export enum MethodImplAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _4096 = 4096,
    _65535 = 65535,
}

export enum CallingConventions {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _32 = 32,
    _64 = 64,
}

export class IntPtr implements IIntPtr {

    constructor(data?: IIntPtr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IntPtr {
        data = typeof data === 'object' ? data : {};
        let result = new IntPtr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): IntPtr {
        const json = this.toJSON();
        let result = new IntPtr();
        result.init(json);
        return result;
    }
}

export interface IIntPtr {
}

export class RuntimeMethodHandle implements IRuntimeMethodHandle {
    value: IntPtr;

    constructor(data?: IRuntimeMethodHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeMethodHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeMethodHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }

    clone(): RuntimeMethodHandle {
        const json = this.toJSON();
        let result = new RuntimeMethodHandle();
        result.init(json);
        return result;
    }
}

export interface IRuntimeMethodHandle {
    value: IntPtr;
}

export class ModuleHandle implements IModuleHandle {
    readonly mdStreamVersion: number;

    constructor(data?: IModuleHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).mdStreamVersion = _data["mdStreamVersion"];
        }
    }

    static fromJS(data: any): ModuleHandle {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mdStreamVersion"] = this.mdStreamVersion;
        return data;
    }

    clone(): ModuleHandle {
        const json = this.toJSON();
        let result = new ModuleHandle();
        result.init(json);
        return result;
    }
}

export interface IModuleHandle {
    mdStreamVersion: number;
}

export class CustomAttributeTypedArgument implements ICustomAttributeTypedArgument {
    argumentType: Type;
    readonly value: any | undefined;

    constructor(data?: ICustomAttributeTypedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argumentType = _data["argumentType"] ? Type.fromJS(_data["argumentType"]) : <any>undefined;
            (<any>this).value = _data["value"];
        }
    }

    static fromJS(data: any): CustomAttributeTypedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeTypedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType ? this.argumentType.toJSON() : <any>undefined;
        data["value"] = this.value;
        return data;
    }

    clone(): CustomAttributeTypedArgument {
        const json = this.toJSON();
        let result = new CustomAttributeTypedArgument();
        result.init(json);
        return result;
    }
}

export interface ICustomAttributeTypedArgument {
    argumentType: Type;
    value: any | undefined;
}

export class MemberInfo implements IMemberInfo {
    memberType: MemberTypes;
    declaringType: Type;
    reflectedType: Type;
    readonly name: string | undefined;
    module: Module;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly isCollectible: boolean;
    readonly metadataToken: number;

    constructor(data?: IMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            (<any>this).name = _data["name"];
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }

    clone(): MemberInfo {
        const json = this.toJSON();
        let result = new MemberInfo();
        result.init(json);
        return result;
    }
}

export interface IMemberInfo {
    memberType: MemberTypes;
    declaringType: Type;
    reflectedType: Type;
    name: string | undefined;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export class CustomAttributeNamedArgument implements ICustomAttributeNamedArgument {
    memberInfo: MemberInfo;
    typedValue: CustomAttributeTypedArgument;
    readonly memberName: string | undefined;
    readonly isField: boolean;

    constructor(data?: ICustomAttributeNamedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberInfo = _data["memberInfo"] ? MemberInfo.fromJS(_data["memberInfo"]) : <any>undefined;
            this.typedValue = _data["typedValue"] ? CustomAttributeTypedArgument.fromJS(_data["typedValue"]) : <any>undefined;
            (<any>this).memberName = _data["memberName"];
            (<any>this).isField = _data["isField"];
        }
    }

    static fromJS(data: any): CustomAttributeNamedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeNamedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberInfo"] = this.memberInfo ? this.memberInfo.toJSON() : <any>undefined;
        data["typedValue"] = this.typedValue ? this.typedValue.toJSON() : <any>undefined;
        data["memberName"] = this.memberName;
        data["isField"] = this.isField;
        return data;
    }

    clone(): CustomAttributeNamedArgument {
        const json = this.toJSON();
        let result = new CustomAttributeNamedArgument();
        result.init(json);
        return result;
    }
}

export interface ICustomAttributeNamedArgument {
    memberInfo: MemberInfo;
    typedValue: CustomAttributeTypedArgument;
    memberName: string | undefined;
    isField: boolean;
}

export class CustomAttributeData implements ICustomAttributeData {
    attributeType: Type;
    constructor_: ConstructorInfo;
    readonly constructorArguments: CustomAttributeTypedArgument[] | undefined;
    readonly namedArguments: CustomAttributeNamedArgument[] | undefined;

    constructor(data?: ICustomAttributeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeType = _data["attributeType"] ? Type.fromJS(_data["attributeType"]) : <any>undefined;
            this.constructor_ = _data["constructor"] ? ConstructorInfo.fromJS(_data["constructor"]) : <any>undefined;
            if (Array.isArray(_data["constructorArguments"])) {
                (<any>this).constructorArguments = [] as any;
                for (let item of _data["constructorArguments"])
                    (<any>this).constructorArguments.push(CustomAttributeTypedArgument.fromJS(item));
            }
            if (Array.isArray(_data["namedArguments"])) {
                (<any>this).namedArguments = [] as any;
                for (let item of _data["namedArguments"])
                    (<any>this).namedArguments.push(CustomAttributeNamedArgument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomAttributeData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType ? this.attributeType.toJSON() : <any>undefined;
        data["constructor"] = this.constructor_ ? this.constructor_.toJSON() : <any>undefined;
        if (Array.isArray(this.constructorArguments)) {
            data["constructorArguments"] = [];
            for (let item of this.constructorArguments)
                data["constructorArguments"].push(item.toJSON());
        }
        if (Array.isArray(this.namedArguments)) {
            data["namedArguments"] = [];
            for (let item of this.namedArguments)
                data["namedArguments"].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomAttributeData {
        const json = this.toJSON();
        let result = new CustomAttributeData();
        result.init(json);
        return result;
    }
}

export interface ICustomAttributeData {
    attributeType: Type;
    constructor_: ConstructorInfo;
    constructorArguments: CustomAttributeTypedArgument[] | undefined;
    namedArguments: CustomAttributeNamedArgument[] | undefined;
}

export class Module implements IModule {
    assembly: Assembly;
    readonly fullyQualifiedName: string | undefined;
    readonly name: string | undefined;
    readonly mdStreamVersion: number;
    readonly moduleVersionId: string;
    readonly scopeName: string | undefined;
    moduleHandle: ModuleHandle;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly metadataToken: number;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            (<any>this).fullyQualifiedName = _data["fullyQualifiedName"];
            (<any>this).name = _data["name"];
            (<any>this).mdStreamVersion = _data["mdStreamVersion"];
            (<any>this).moduleVersionId = _data["moduleVersionId"];
            (<any>this).scopeName = _data["scopeName"];
            this.moduleHandle = _data["moduleHandle"] ? ModuleHandle.fromJS(_data["moduleHandle"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["fullyQualifiedName"] = this.fullyQualifiedName;
        data["name"] = this.name;
        data["mdStreamVersion"] = this.mdStreamVersion;
        data["moduleVersionId"] = this.moduleVersionId;
        data["scopeName"] = this.scopeName;
        data["moduleHandle"] = this.moduleHandle ? this.moduleHandle.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }

    clone(): Module {
        const json = this.toJSON();
        let result = new Module();
        result.init(json);
        return result;
    }
}

export interface IModule {
    assembly: Assembly;
    fullyQualifiedName: string | undefined;
    name: string | undefined;
    mdStreamVersion: number;
    moduleVersionId: string;
    scopeName: string | undefined;
    moduleHandle: ModuleHandle;
    customAttributes: CustomAttributeData[] | undefined;
    metadataToken: number;
}

export class ConstructorInfo implements IConstructorInfo {
    memberType: MemberTypes;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    readonly isAbstract: boolean;
    readonly isConstructor: boolean;
    readonly isFinal: boolean;
    readonly isHideBySig: boolean;
    readonly isSpecialName: boolean;
    readonly isStatic: boolean;
    readonly isVirtual: boolean;
    readonly isAssembly: boolean;
    readonly isFamily: boolean;
    readonly isFamilyAndAssembly: boolean;
    readonly isFamilyOrAssembly: boolean;
    readonly isPrivate: boolean;
    readonly isPublic: boolean;
    readonly isConstructedGenericMethod: boolean;
    readonly isGenericMethod: boolean;
    readonly isGenericMethodDefinition: boolean;
    readonly containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    readonly isSecurityCritical: boolean;
    readonly isSecuritySafeCritical: boolean;
    readonly isSecurityTransparent: boolean;
    readonly name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly isCollectible: boolean;
    readonly metadataToken: number;

    constructor(data?: IConstructorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): ConstructorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }

    clone(): ConstructorInfo {
        const json = this.toJSON();
        let result = new ConstructorInfo();
        result.init(json);
        return result;
    }
}

export interface IConstructorInfo {
    memberType: MemberTypes;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export enum EventAttributes {
    _0 = 0,
    _512 = 512,
    _1024 = 1024,
}

export enum ParameterAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _61440 = 61440,
}

export class ParameterInfo implements IParameterInfo {
    attributes: ParameterAttributes;
    member: MemberInfo;
    readonly name: string | undefined;
    parameterType: Type;
    readonly position: number;
    readonly isIn: boolean;
    readonly isLcid: boolean;
    readonly isOptional: boolean;
    readonly isOut: boolean;
    readonly isRetval: boolean;
    readonly defaultValue: any | undefined;
    readonly rawDefaultValue: any | undefined;
    readonly hasDefaultValue: boolean;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly metadataToken: number;

    constructor(data?: IParameterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributes = _data["attributes"];
            this.member = _data["member"] ? MemberInfo.fromJS(_data["member"]) : <any>undefined;
            (<any>this).name = _data["name"];
            this.parameterType = _data["parameterType"] ? Type.fromJS(_data["parameterType"]) : <any>undefined;
            (<any>this).position = _data["position"];
            (<any>this).isIn = _data["isIn"];
            (<any>this).isLcid = _data["isLcid"];
            (<any>this).isOptional = _data["isOptional"];
            (<any>this).isOut = _data["isOut"];
            (<any>this).isRetval = _data["isRetval"];
            (<any>this).defaultValue = _data["defaultValue"];
            (<any>this).rawDefaultValue = _data["rawDefaultValue"];
            (<any>this).hasDefaultValue = _data["hasDefaultValue"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): ParameterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType ? this.parameterType.toJSON() : <any>undefined;
        data["position"] = this.position;
        data["isIn"] = this.isIn;
        data["isLcid"] = this.isLcid;
        data["isOptional"] = this.isOptional;
        data["isOut"] = this.isOut;
        data["isRetval"] = this.isRetval;
        data["defaultValue"] = this.defaultValue;
        data["rawDefaultValue"] = this.rawDefaultValue;
        data["hasDefaultValue"] = this.hasDefaultValue;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }

    clone(): ParameterInfo {
        const json = this.toJSON();
        let result = new ParameterInfo();
        result.init(json);
        return result;
    }
}

export interface IParameterInfo {
    attributes: ParameterAttributes;
    member: MemberInfo;
    name: string | undefined;
    parameterType: Type;
    position: number;
    isIn: boolean;
    isLcid: boolean;
    isOptional: boolean;
    isOut: boolean;
    isRetval: boolean;
    defaultValue: any | undefined;
    rawDefaultValue: any | undefined;
    hasDefaultValue: boolean;
    customAttributes: CustomAttributeData[] | undefined;
    metadataToken: number;
}

export class ICustomAttributeProvider implements IICustomAttributeProvider {

    constructor(data?: IICustomAttributeProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ICustomAttributeProvider {
        data = typeof data === 'object' ? data : {};
        let result = new ICustomAttributeProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ICustomAttributeProvider {
        const json = this.toJSON();
        let result = new ICustomAttributeProvider();
        result.init(json);
        return result;
    }
}

export interface IICustomAttributeProvider {
}

export class MethodInfo implements IMethodInfo {
    memberType: MemberTypes;
    returnParameter: ParameterInfo;
    returnType: Type;
    returnTypeCustomAttributes: ICustomAttributeProvider;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    readonly isAbstract: boolean;
    readonly isConstructor: boolean;
    readonly isFinal: boolean;
    readonly isHideBySig: boolean;
    readonly isSpecialName: boolean;
    readonly isStatic: boolean;
    readonly isVirtual: boolean;
    readonly isAssembly: boolean;
    readonly isFamily: boolean;
    readonly isFamilyAndAssembly: boolean;
    readonly isFamilyOrAssembly: boolean;
    readonly isPrivate: boolean;
    readonly isPublic: boolean;
    readonly isConstructedGenericMethod: boolean;
    readonly isGenericMethod: boolean;
    readonly isGenericMethodDefinition: boolean;
    readonly containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    readonly isSecurityCritical: boolean;
    readonly isSecuritySafeCritical: boolean;
    readonly isSecurityTransparent: boolean;
    readonly name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly isCollectible: boolean;
    readonly metadataToken: number;

    constructor(data?: IMethodInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            this.returnParameter = _data["returnParameter"] ? ParameterInfo.fromJS(_data["returnParameter"]) : <any>undefined;
            this.returnType = _data["returnType"] ? Type.fromJS(_data["returnType"]) : <any>undefined;
            this.returnTypeCustomAttributes = _data["returnTypeCustomAttributes"] ? ICustomAttributeProvider.fromJS(_data["returnTypeCustomAttributes"]) : <any>undefined;
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MethodInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MethodInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["returnParameter"] = this.returnParameter ? this.returnParameter.toJSON() : <any>undefined;
        data["returnType"] = this.returnType ? this.returnType.toJSON() : <any>undefined;
        data["returnTypeCustomAttributes"] = this.returnTypeCustomAttributes ? this.returnTypeCustomAttributes.toJSON() : <any>undefined;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }

    clone(): MethodInfo {
        const json = this.toJSON();
        let result = new MethodInfo();
        result.init(json);
        return result;
    }
}

export interface IMethodInfo {
    memberType: MemberTypes;
    returnParameter: ParameterInfo;
    returnType: Type;
    returnTypeCustomAttributes: ICustomAttributeProvider;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export class EventInfo implements IEventInfo {
    memberType: MemberTypes;
    attributes: EventAttributes;
    readonly isSpecialName: boolean;
    addMethod: MethodInfo;
    removeMethod: MethodInfo;
    raiseMethod: MethodInfo;
    readonly isMulticast: boolean;
    eventHandlerType: Type;
    readonly name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly isCollectible: boolean;
    readonly metadataToken: number;

    constructor(data?: IEventInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            this.addMethod = _data["addMethod"] ? MethodInfo.fromJS(_data["addMethod"]) : <any>undefined;
            this.removeMethod = _data["removeMethod"] ? MethodInfo.fromJS(_data["removeMethod"]) : <any>undefined;
            this.raiseMethod = _data["raiseMethod"] ? MethodInfo.fromJS(_data["raiseMethod"]) : <any>undefined;
            (<any>this).isMulticast = _data["isMulticast"];
            this.eventHandlerType = _data["eventHandlerType"] ? Type.fromJS(_data["eventHandlerType"]) : <any>undefined;
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): EventInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EventInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["addMethod"] = this.addMethod ? this.addMethod.toJSON() : <any>undefined;
        data["removeMethod"] = this.removeMethod ? this.removeMethod.toJSON() : <any>undefined;
        data["raiseMethod"] = this.raiseMethod ? this.raiseMethod.toJSON() : <any>undefined;
        data["isMulticast"] = this.isMulticast;
        data["eventHandlerType"] = this.eventHandlerType ? this.eventHandlerType.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }

    clone(): EventInfo {
        const json = this.toJSON();
        let result = new EventInfo();
        result.init(json);
        return result;
    }
}

export interface IEventInfo {
    memberType: MemberTypes;
    attributes: EventAttributes;
    isSpecialName: boolean;
    addMethod: MethodInfo;
    removeMethod: MethodInfo;
    raiseMethod: MethodInfo;
    isMulticast: boolean;
    eventHandlerType: Type;
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export enum FieldAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _1024 = 1024,
    _4096 = 4096,
    _8192 = 8192,
    _32768 = 32768,
    _38144 = 38144,
}

export class RuntimeFieldHandle implements IRuntimeFieldHandle {
    value: IntPtr;

    constructor(data?: IRuntimeFieldHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeFieldHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeFieldHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }

    clone(): RuntimeFieldHandle {
        const json = this.toJSON();
        let result = new RuntimeFieldHandle();
        result.init(json);
        return result;
    }
}

export interface IRuntimeFieldHandle {
    value: IntPtr;
}

export class FieldInfo implements IFieldInfo {
    memberType: MemberTypes;
    attributes: FieldAttributes;
    fieldType: Type;
    readonly isInitOnly: boolean;
    readonly isLiteral: boolean;
    readonly isNotSerialized: boolean;
    readonly isPinvokeImpl: boolean;
    readonly isSpecialName: boolean;
    readonly isStatic: boolean;
    readonly isAssembly: boolean;
    readonly isFamily: boolean;
    readonly isFamilyAndAssembly: boolean;
    readonly isFamilyOrAssembly: boolean;
    readonly isPrivate: boolean;
    readonly isPublic: boolean;
    readonly isSecurityCritical: boolean;
    readonly isSecuritySafeCritical: boolean;
    readonly isSecurityTransparent: boolean;
    fieldHandle: RuntimeFieldHandle;
    readonly name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly isCollectible: boolean;
    readonly metadataToken: number;

    constructor(data?: IFieldInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            this.fieldType = _data["fieldType"] ? Type.fromJS(_data["fieldType"]) : <any>undefined;
            (<any>this).isInitOnly = _data["isInitOnly"];
            (<any>this).isLiteral = _data["isLiteral"];
            (<any>this).isNotSerialized = _data["isNotSerialized"];
            (<any>this).isPinvokeImpl = _data["isPinvokeImpl"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.fieldHandle = _data["fieldHandle"] ? RuntimeFieldHandle.fromJS(_data["fieldHandle"]) : <any>undefined;
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): FieldInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FieldInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["fieldType"] = this.fieldType ? this.fieldType.toJSON() : <any>undefined;
        data["isInitOnly"] = this.isInitOnly;
        data["isLiteral"] = this.isLiteral;
        data["isNotSerialized"] = this.isNotSerialized;
        data["isPinvokeImpl"] = this.isPinvokeImpl;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["fieldHandle"] = this.fieldHandle ? this.fieldHandle.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }

    clone(): FieldInfo {
        const json = this.toJSON();
        let result = new FieldInfo();
        result.init(json);
        return result;
    }
}

export interface IFieldInfo {
    memberType: MemberTypes;
    attributes: FieldAttributes;
    fieldType: Type;
    isInitOnly: boolean;
    isLiteral: boolean;
    isNotSerialized: boolean;
    isPinvokeImpl: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    fieldHandle: RuntimeFieldHandle;
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export enum PropertyAttributes {
    _0 = 0,
    _512 = 512,
    _1024 = 1024,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _62464 = 62464,
}

export class PropertyInfo implements IPropertyInfo {
    memberType: MemberTypes;
    propertyType: Type;
    attributes: PropertyAttributes;
    readonly isSpecialName: boolean;
    readonly canRead: boolean;
    readonly canWrite: boolean;
    getMethod: MethodInfo;
    setMethod: MethodInfo;
    readonly name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly isCollectible: boolean;
    readonly metadataToken: number;

    constructor(data?: IPropertyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            this.propertyType = _data["propertyType"] ? Type.fromJS(_data["propertyType"]) : <any>undefined;
            this.attributes = _data["attributes"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).canRead = _data["canRead"];
            (<any>this).canWrite = _data["canWrite"];
            this.getMethod = _data["getMethod"] ? MethodInfo.fromJS(_data["getMethod"]) : <any>undefined;
            this.setMethod = _data["setMethod"] ? MethodInfo.fromJS(_data["setMethod"]) : <any>undefined;
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): PropertyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["propertyType"] = this.propertyType ? this.propertyType.toJSON() : <any>undefined;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["getMethod"] = this.getMethod ? this.getMethod.toJSON() : <any>undefined;
        data["setMethod"] = this.setMethod ? this.setMethod.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }

    clone(): PropertyInfo {
        const json = this.toJSON();
        let result = new PropertyInfo();
        result.init(json);
        return result;
    }
}

export interface IPropertyInfo {
    memberType: MemberTypes;
    propertyType: Type;
    attributes: PropertyAttributes;
    isSpecialName: boolean;
    canRead: boolean;
    canWrite: boolean;
    getMethod: MethodInfo;
    setMethod: MethodInfo;
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export class MethodBase implements IMethodBase {
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    readonly isAbstract: boolean;
    readonly isConstructor: boolean;
    readonly isFinal: boolean;
    readonly isHideBySig: boolean;
    readonly isSpecialName: boolean;
    readonly isStatic: boolean;
    readonly isVirtual: boolean;
    readonly isAssembly: boolean;
    readonly isFamily: boolean;
    readonly isFamilyAndAssembly: boolean;
    readonly isFamilyOrAssembly: boolean;
    readonly isPrivate: boolean;
    readonly isPublic: boolean;
    readonly isConstructedGenericMethod: boolean;
    readonly isGenericMethod: boolean;
    readonly isGenericMethodDefinition: boolean;
    readonly containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    readonly isSecurityCritical: boolean;
    readonly isSecuritySafeCritical: boolean;
    readonly isSecurityTransparent: boolean;
    memberType: MemberTypes;
    readonly name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly isCollectible: boolean;
    readonly metadataToken: number;

    constructor(data?: IMethodBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.memberType = _data["memberType"];
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MethodBase {
        data = typeof data === 'object' ? data : {};
        let result = new MethodBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }

    clone(): MethodBase {
        const json = this.toJSON();
        let result = new MethodBase();
        result.init(json);
        return result;
    }
}

export interface IMethodBase {
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    memberType: MemberTypes;
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export enum GenericParameterAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _28 = 28,
}

export enum TypeAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _16 = 16,
    _24 = 24,
    _32 = 32,
    _128 = 128,
    _256 = 256,
    _1024 = 1024,
    _2048 = 2048,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _65536 = 65536,
    _131072 = 131072,
    _196608 = 196608,
    _262144 = 262144,
    _264192 = 264192,
    _1048576 = 1048576,
    _12582912 = 12582912,
}

export enum LayoutKind {
    _0 = 0,
    _2 = 2,
    _3 = 3,
}

export class StructLayoutAttribute implements IStructLayoutAttribute {
    value: LayoutKind;
    readonly typeId: any | undefined;

    constructor(data?: IStructLayoutAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            (<any>this).typeId = _data["typeId"];
        }
    }

    static fromJS(data: any): StructLayoutAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new StructLayoutAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["typeId"] = this.typeId;
        return data;
    }

    clone(): StructLayoutAttribute {
        const json = this.toJSON();
        let result = new StructLayoutAttribute();
        result.init(json);
        return result;
    }
}

export interface IStructLayoutAttribute {
    value: LayoutKind;
    typeId: any | undefined;
}

export class RuntimeTypeHandle implements IRuntimeTypeHandle {
    value: IntPtr;

    constructor(data?: IRuntimeTypeHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeTypeHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeTypeHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }

    clone(): RuntimeTypeHandle {
        const json = this.toJSON();
        let result = new RuntimeTypeHandle();
        result.init(json);
        return result;
    }
}

export interface IRuntimeTypeHandle {
    value: IntPtr;
}

export class TypeInfo implements ITypeInfo {
    readonly genericTypeParameters: Type[] | undefined;
    readonly declaredConstructors: ConstructorInfo[] | undefined;
    readonly declaredEvents: EventInfo[] | undefined;
    readonly declaredFields: FieldInfo[] | undefined;
    readonly declaredMembers: MemberInfo[] | undefined;
    readonly declaredMethods: MethodInfo[] | undefined;
    readonly declaredNestedTypes: TypeInfo[] | undefined;
    readonly declaredProperties: PropertyInfo[] | undefined;
    readonly implementedInterfaces: Type[] | undefined;
    readonly isInterface: boolean;
    memberType: MemberTypes;
    readonly namespace: string | undefined;
    readonly assemblyQualifiedName: string | undefined;
    readonly fullName: string | undefined;
    assembly: Assembly;
    module: Module;
    readonly isNested: boolean;
    declaringType: Type;
    declaringMethod: MethodBase;
    reflectedType: Type;
    underlyingSystemType: Type;
    readonly isTypeDefinition: boolean;
    readonly isArray: boolean;
    readonly isByRef: boolean;
    readonly isPointer: boolean;
    readonly isConstructedGenericType: boolean;
    readonly isGenericParameter: boolean;
    readonly isGenericTypeParameter: boolean;
    readonly isGenericMethodParameter: boolean;
    readonly isGenericType: boolean;
    readonly isGenericTypeDefinition: boolean;
    readonly isSZArray: boolean;
    readonly isVariableBoundArray: boolean;
    readonly isByRefLike: boolean;
    readonly hasElementType: boolean;
    readonly genericTypeArguments: Type[] | undefined;
    readonly genericParameterPosition: number;
    genericParameterAttributes: GenericParameterAttributes;
    attributes: TypeAttributes;
    readonly isAbstract: boolean;
    readonly isImport: boolean;
    readonly isSealed: boolean;
    readonly isSpecialName: boolean;
    readonly isClass: boolean;
    readonly isNestedAssembly: boolean;
    readonly isNestedFamANDAssem: boolean;
    readonly isNestedFamily: boolean;
    readonly isNestedFamORAssem: boolean;
    readonly isNestedPrivate: boolean;
    readonly isNestedPublic: boolean;
    readonly isNotPublic: boolean;
    readonly isPublic: boolean;
    readonly isAutoLayout: boolean;
    readonly isExplicitLayout: boolean;
    readonly isLayoutSequential: boolean;
    readonly isAnsiClass: boolean;
    readonly isAutoClass: boolean;
    readonly isUnicodeClass: boolean;
    readonly isCOMObject: boolean;
    readonly isContextful: boolean;
    readonly isEnum: boolean;
    readonly isMarshalByRef: boolean;
    readonly isPrimitive: boolean;
    readonly isValueType: boolean;
    readonly isSignatureType: boolean;
    readonly isSecurityCritical: boolean;
    readonly isSecuritySafeCritical: boolean;
    readonly isSecurityTransparent: boolean;
    structLayoutAttribute: StructLayoutAttribute;
    typeInitializer: ConstructorInfo;
    typeHandle: RuntimeTypeHandle;
    readonly guid: string;
    baseType: Type;
    readonly isSerializable: boolean;
    readonly containsGenericParameters: boolean;
    readonly isVisible: boolean;
    readonly name: string | undefined;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly isCollectible: boolean;
    readonly metadataToken: number;

    constructor(data?: ITypeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["genericTypeParameters"])) {
                (<any>this).genericTypeParameters = [] as any;
                for (let item of _data["genericTypeParameters"])
                    (<any>this).genericTypeParameters.push(Type.fromJS(item));
            }
            if (Array.isArray(_data["declaredConstructors"])) {
                (<any>this).declaredConstructors = [] as any;
                for (let item of _data["declaredConstructors"])
                    (<any>this).declaredConstructors.push(ConstructorInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredEvents"])) {
                (<any>this).declaredEvents = [] as any;
                for (let item of _data["declaredEvents"])
                    (<any>this).declaredEvents.push(EventInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredFields"])) {
                (<any>this).declaredFields = [] as any;
                for (let item of _data["declaredFields"])
                    (<any>this).declaredFields.push(FieldInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredMembers"])) {
                (<any>this).declaredMembers = [] as any;
                for (let item of _data["declaredMembers"])
                    (<any>this).declaredMembers.push(MemberInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredMethods"])) {
                (<any>this).declaredMethods = [] as any;
                for (let item of _data["declaredMethods"])
                    (<any>this).declaredMethods.push(MethodInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredNestedTypes"])) {
                (<any>this).declaredNestedTypes = [] as any;
                for (let item of _data["declaredNestedTypes"])
                    (<any>this).declaredNestedTypes.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredProperties"])) {
                (<any>this).declaredProperties = [] as any;
                for (let item of _data["declaredProperties"])
                    (<any>this).declaredProperties.push(PropertyInfo.fromJS(item));
            }
            if (Array.isArray(_data["implementedInterfaces"])) {
                (<any>this).implementedInterfaces = [] as any;
                for (let item of _data["implementedInterfaces"])
                    (<any>this).implementedInterfaces.push(Type.fromJS(item));
            }
            (<any>this).isInterface = _data["isInterface"];
            this.memberType = _data["memberType"];
            (<any>this).namespace = _data["namespace"];
            (<any>this).assemblyQualifiedName = _data["assemblyQualifiedName"];
            (<any>this).fullName = _data["fullName"];
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            (<any>this).isNested = _data["isNested"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.declaringMethod = _data["declaringMethod"] ? MethodBase.fromJS(_data["declaringMethod"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.underlyingSystemType = _data["underlyingSystemType"] ? Type.fromJS(_data["underlyingSystemType"]) : <any>undefined;
            (<any>this).isTypeDefinition = _data["isTypeDefinition"];
            (<any>this).isArray = _data["isArray"];
            (<any>this).isByRef = _data["isByRef"];
            (<any>this).isPointer = _data["isPointer"];
            (<any>this).isConstructedGenericType = _data["isConstructedGenericType"];
            (<any>this).isGenericParameter = _data["isGenericParameter"];
            (<any>this).isGenericTypeParameter = _data["isGenericTypeParameter"];
            (<any>this).isGenericMethodParameter = _data["isGenericMethodParameter"];
            (<any>this).isGenericType = _data["isGenericType"];
            (<any>this).isGenericTypeDefinition = _data["isGenericTypeDefinition"];
            (<any>this).isSZArray = _data["isSZArray"];
            (<any>this).isVariableBoundArray = _data["isVariableBoundArray"];
            (<any>this).isByRefLike = _data["isByRefLike"];
            (<any>this).hasElementType = _data["hasElementType"];
            if (Array.isArray(_data["genericTypeArguments"])) {
                (<any>this).genericTypeArguments = [] as any;
                for (let item of _data["genericTypeArguments"])
                    (<any>this).genericTypeArguments.push(Type.fromJS(item));
            }
            (<any>this).genericParameterPosition = _data["genericParameterPosition"];
            this.genericParameterAttributes = _data["genericParameterAttributes"];
            this.attributes = _data["attributes"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isImport = _data["isImport"];
            (<any>this).isSealed = _data["isSealed"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isClass = _data["isClass"];
            (<any>this).isNestedAssembly = _data["isNestedAssembly"];
            (<any>this).isNestedFamANDAssem = _data["isNestedFamANDAssem"];
            (<any>this).isNestedFamily = _data["isNestedFamily"];
            (<any>this).isNestedFamORAssem = _data["isNestedFamORAssem"];
            (<any>this).isNestedPrivate = _data["isNestedPrivate"];
            (<any>this).isNestedPublic = _data["isNestedPublic"];
            (<any>this).isNotPublic = _data["isNotPublic"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isAutoLayout = _data["isAutoLayout"];
            (<any>this).isExplicitLayout = _data["isExplicitLayout"];
            (<any>this).isLayoutSequential = _data["isLayoutSequential"];
            (<any>this).isAnsiClass = _data["isAnsiClass"];
            (<any>this).isAutoClass = _data["isAutoClass"];
            (<any>this).isUnicodeClass = _data["isUnicodeClass"];
            (<any>this).isCOMObject = _data["isCOMObject"];
            (<any>this).isContextful = _data["isContextful"];
            (<any>this).isEnum = _data["isEnum"];
            (<any>this).isMarshalByRef = _data["isMarshalByRef"];
            (<any>this).isPrimitive = _data["isPrimitive"];
            (<any>this).isValueType = _data["isValueType"];
            (<any>this).isSignatureType = _data["isSignatureType"];
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.structLayoutAttribute = _data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(_data["structLayoutAttribute"]) : <any>undefined;
            this.typeInitializer = _data["typeInitializer"] ? ConstructorInfo.fromJS(_data["typeInitializer"]) : <any>undefined;
            this.typeHandle = _data["typeHandle"] ? RuntimeTypeHandle.fromJS(_data["typeHandle"]) : <any>undefined;
            (<any>this).guid = _data["guid"];
            this.baseType = _data["baseType"] ? Type.fromJS(_data["baseType"]) : <any>undefined;
            (<any>this).isSerializable = _data["isSerializable"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            (<any>this).isVisible = _data["isVisible"];
            (<any>this).name = _data["name"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): TypeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TypeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.genericTypeParameters)) {
            data["genericTypeParameters"] = [];
            for (let item of this.genericTypeParameters)
                data["genericTypeParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredConstructors)) {
            data["declaredConstructors"] = [];
            for (let item of this.declaredConstructors)
                data["declaredConstructors"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredEvents)) {
            data["declaredEvents"] = [];
            for (let item of this.declaredEvents)
                data["declaredEvents"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredFields)) {
            data["declaredFields"] = [];
            for (let item of this.declaredFields)
                data["declaredFields"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredMembers)) {
            data["declaredMembers"] = [];
            for (let item of this.declaredMembers)
                data["declaredMembers"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredMethods)) {
            data["declaredMethods"] = [];
            for (let item of this.declaredMethods)
                data["declaredMethods"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredNestedTypes)) {
            data["declaredNestedTypes"] = [];
            for (let item of this.declaredNestedTypes)
                data["declaredNestedTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredProperties)) {
            data["declaredProperties"] = [];
            for (let item of this.declaredProperties)
                data["declaredProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.implementedInterfaces)) {
            data["implementedInterfaces"] = [];
            for (let item of this.implementedInterfaces)
                data["implementedInterfaces"].push(item.toJSON());
        }
        data["isInterface"] = this.isInterface;
        data["memberType"] = this.memberType;
        data["namespace"] = this.namespace;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName;
        data["fullName"] = this.fullName;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["isNested"] = this.isNested;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : <any>undefined;
        data["isTypeDefinition"] = this.isTypeDefinition;
        data["isArray"] = this.isArray;
        data["isByRef"] = this.isByRef;
        data["isPointer"] = this.isPointer;
        data["isConstructedGenericType"] = this.isConstructedGenericType;
        data["isGenericParameter"] = this.isGenericParameter;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter;
        data["isGenericType"] = this.isGenericType;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition;
        data["isSZArray"] = this.isSZArray;
        data["isVariableBoundArray"] = this.isVariableBoundArray;
        data["isByRefLike"] = this.isByRefLike;
        data["hasElementType"] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (let item of this.genericTypeArguments)
                data["genericTypeArguments"].push(item.toJSON());
        }
        data["genericParameterPosition"] = this.genericParameterPosition;
        data["genericParameterAttributes"] = this.genericParameterAttributes;
        data["attributes"] = this.attributes;
        data["isAbstract"] = this.isAbstract;
        data["isImport"] = this.isImport;
        data["isSealed"] = this.isSealed;
        data["isSpecialName"] = this.isSpecialName;
        data["isClass"] = this.isClass;
        data["isNestedAssembly"] = this.isNestedAssembly;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem;
        data["isNestedFamily"] = this.isNestedFamily;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem;
        data["isNestedPrivate"] = this.isNestedPrivate;
        data["isNestedPublic"] = this.isNestedPublic;
        data["isNotPublic"] = this.isNotPublic;
        data["isPublic"] = this.isPublic;
        data["isAutoLayout"] = this.isAutoLayout;
        data["isExplicitLayout"] = this.isExplicitLayout;
        data["isLayoutSequential"] = this.isLayoutSequential;
        data["isAnsiClass"] = this.isAnsiClass;
        data["isAutoClass"] = this.isAutoClass;
        data["isUnicodeClass"] = this.isUnicodeClass;
        data["isCOMObject"] = this.isCOMObject;
        data["isContextful"] = this.isContextful;
        data["isEnum"] = this.isEnum;
        data["isMarshalByRef"] = this.isMarshalByRef;
        data["isPrimitive"] = this.isPrimitive;
        data["isValueType"] = this.isValueType;
        data["isSignatureType"] = this.isSignatureType;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : <any>undefined;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : <any>undefined;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : <any>undefined;
        data["guid"] = this.guid;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : <any>undefined;
        data["isSerializable"] = this.isSerializable;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isVisible"] = this.isVisible;
        data["name"] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }

    clone(): TypeInfo {
        const json = this.toJSON();
        let result = new TypeInfo();
        result.init(json);
        return result;
    }
}

export interface ITypeInfo {
    genericTypeParameters: Type[] | undefined;
    declaredConstructors: ConstructorInfo[] | undefined;
    declaredEvents: EventInfo[] | undefined;
    declaredFields: FieldInfo[] | undefined;
    declaredMembers: MemberInfo[] | undefined;
    declaredMethods: MethodInfo[] | undefined;
    declaredNestedTypes: TypeInfo[] | undefined;
    declaredProperties: PropertyInfo[] | undefined;
    implementedInterfaces: Type[] | undefined;
    isInterface: boolean;
    memberType: MemberTypes;
    namespace: string | undefined;
    assemblyQualifiedName: string | undefined;
    fullName: string | undefined;
    assembly: Assembly;
    module: Module;
    isNested: boolean;
    declaringType: Type;
    declaringMethod: MethodBase;
    reflectedType: Type;
    underlyingSystemType: Type;
    isTypeDefinition: boolean;
    isArray: boolean;
    isByRef: boolean;
    isPointer: boolean;
    isConstructedGenericType: boolean;
    isGenericParameter: boolean;
    isGenericTypeParameter: boolean;
    isGenericMethodParameter: boolean;
    isGenericType: boolean;
    isGenericTypeDefinition: boolean;
    isSZArray: boolean;
    isVariableBoundArray: boolean;
    isByRefLike: boolean;
    hasElementType: boolean;
    genericTypeArguments: Type[] | undefined;
    genericParameterPosition: number;
    genericParameterAttributes: GenericParameterAttributes;
    attributes: TypeAttributes;
    isAbstract: boolean;
    isImport: boolean;
    isSealed: boolean;
    isSpecialName: boolean;
    isClass: boolean;
    isNestedAssembly: boolean;
    isNestedFamANDAssem: boolean;
    isNestedFamily: boolean;
    isNestedFamORAssem: boolean;
    isNestedPrivate: boolean;
    isNestedPublic: boolean;
    isNotPublic: boolean;
    isPublic: boolean;
    isAutoLayout: boolean;
    isExplicitLayout: boolean;
    isLayoutSequential: boolean;
    isAnsiClass: boolean;
    isAutoClass: boolean;
    isUnicodeClass: boolean;
    isCOMObject: boolean;
    isContextful: boolean;
    isEnum: boolean;
    isMarshalByRef: boolean;
    isPrimitive: boolean;
    isValueType: boolean;
    isSignatureType: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    structLayoutAttribute: StructLayoutAttribute;
    typeInitializer: ConstructorInfo;
    typeHandle: RuntimeTypeHandle;
    guid: string;
    baseType: Type;
    isSerializable: boolean;
    containsGenericParameters: boolean;
    isVisible: boolean;
    name: string | undefined;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export enum SecurityRuleSet {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class Assembly implements IAssembly {
    readonly definedTypes: TypeInfo[] | undefined;
    readonly exportedTypes: Type[] | undefined;
    readonly codeBase: string | undefined;
    entryPoint: MethodInfo;
    readonly fullName: string | undefined;
    readonly imageRuntimeVersion: string | undefined;
    readonly isDynamic: boolean;
    readonly location: string | undefined;
    readonly reflectionOnly: boolean;
    readonly isCollectible: boolean;
    readonly isFullyTrusted: boolean;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly escapedCodeBase: string | undefined;
    manifestModule: Module;
    readonly modules: Module[] | undefined;
    readonly globalAssemblyCache: boolean;
    readonly hostContext: number;
    securityRuleSet: SecurityRuleSet;

    constructor(data?: IAssembly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["definedTypes"])) {
                (<any>this).definedTypes = [] as any;
                for (let item of _data["definedTypes"])
                    (<any>this).definedTypes.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data["exportedTypes"])) {
                (<any>this).exportedTypes = [] as any;
                for (let item of _data["exportedTypes"])
                    (<any>this).exportedTypes.push(Type.fromJS(item));
            }
            (<any>this).codeBase = _data["codeBase"];
            this.entryPoint = _data["entryPoint"] ? MethodInfo.fromJS(_data["entryPoint"]) : <any>undefined;
            (<any>this).fullName = _data["fullName"];
            (<any>this).imageRuntimeVersion = _data["imageRuntimeVersion"];
            (<any>this).isDynamic = _data["isDynamic"];
            (<any>this).location = _data["location"];
            (<any>this).reflectionOnly = _data["reflectionOnly"];
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).isFullyTrusted = _data["isFullyTrusted"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).escapedCodeBase = _data["escapedCodeBase"];
            this.manifestModule = _data["manifestModule"] ? Module.fromJS(_data["manifestModule"]) : <any>undefined;
            if (Array.isArray(_data["modules"])) {
                (<any>this).modules = [] as any;
                for (let item of _data["modules"])
                    (<any>this).modules.push(Module.fromJS(item));
            }
            (<any>this).globalAssemblyCache = _data["globalAssemblyCache"];
            (<any>this).hostContext = _data["hostContext"];
            this.securityRuleSet = _data["securityRuleSet"];
        }
    }

    static fromJS(data: any): Assembly {
        data = typeof data === 'object' ? data : {};
        let result = new Assembly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data["definedTypes"] = [];
            for (let item of this.definedTypes)
                data["definedTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.exportedTypes)) {
            data["exportedTypes"] = [];
            for (let item of this.exportedTypes)
                data["exportedTypes"].push(item.toJSON());
        }
        data["codeBase"] = this.codeBase;
        data["entryPoint"] = this.entryPoint ? this.entryPoint.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        data["imageRuntimeVersion"] = this.imageRuntimeVersion;
        data["isDynamic"] = this.isDynamic;
        data["location"] = this.location;
        data["reflectionOnly"] = this.reflectionOnly;
        data["isCollectible"] = this.isCollectible;
        data["isFullyTrusted"] = this.isFullyTrusted;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["escapedCodeBase"] = this.escapedCodeBase;
        data["manifestModule"] = this.manifestModule ? this.manifestModule.toJSON() : <any>undefined;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        data["globalAssemblyCache"] = this.globalAssemblyCache;
        data["hostContext"] = this.hostContext;
        data["securityRuleSet"] = this.securityRuleSet;
        return data;
    }

    clone(): Assembly {
        const json = this.toJSON();
        let result = new Assembly();
        result.init(json);
        return result;
    }
}

export interface IAssembly {
    definedTypes: TypeInfo[] | undefined;
    exportedTypes: Type[] | undefined;
    codeBase: string | undefined;
    entryPoint: MethodInfo;
    fullName: string | undefined;
    imageRuntimeVersion: string | undefined;
    isDynamic: boolean;
    location: string | undefined;
    reflectionOnly: boolean;
    isCollectible: boolean;
    isFullyTrusted: boolean;
    customAttributes: CustomAttributeData[] | undefined;
    escapedCodeBase: string | undefined;
    manifestModule: Module;
    modules: Module[] | undefined;
    globalAssemblyCache: boolean;
    hostContext: number;
    securityRuleSet: SecurityRuleSet;
}

export class Type implements IType {
    readonly isInterface: boolean;
    memberType: MemberTypes;
    readonly namespace: string | undefined;
    readonly assemblyQualifiedName: string | undefined;
    readonly fullName: string | undefined;
    assembly: Assembly;
    module: Module;
    readonly isNested: boolean;
    declaringType: Type;
    declaringMethod: MethodBase;
    reflectedType: Type;
    underlyingSystemType: Type;
    readonly isTypeDefinition: boolean;
    readonly isArray: boolean;
    readonly isByRef: boolean;
    readonly isPointer: boolean;
    readonly isConstructedGenericType: boolean;
    readonly isGenericParameter: boolean;
    readonly isGenericTypeParameter: boolean;
    readonly isGenericMethodParameter: boolean;
    readonly isGenericType: boolean;
    readonly isGenericTypeDefinition: boolean;
    readonly isSZArray: boolean;
    readonly isVariableBoundArray: boolean;
    readonly isByRefLike: boolean;
    readonly hasElementType: boolean;
    readonly genericTypeArguments: Type[] | undefined;
    readonly genericParameterPosition: number;
    genericParameterAttributes: GenericParameterAttributes;
    attributes: TypeAttributes;
    readonly isAbstract: boolean;
    readonly isImport: boolean;
    readonly isSealed: boolean;
    readonly isSpecialName: boolean;
    readonly isClass: boolean;
    readonly isNestedAssembly: boolean;
    readonly isNestedFamANDAssem: boolean;
    readonly isNestedFamily: boolean;
    readonly isNestedFamORAssem: boolean;
    readonly isNestedPrivate: boolean;
    readonly isNestedPublic: boolean;
    readonly isNotPublic: boolean;
    readonly isPublic: boolean;
    readonly isAutoLayout: boolean;
    readonly isExplicitLayout: boolean;
    readonly isLayoutSequential: boolean;
    readonly isAnsiClass: boolean;
    readonly isAutoClass: boolean;
    readonly isUnicodeClass: boolean;
    readonly isCOMObject: boolean;
    readonly isContextful: boolean;
    readonly isEnum: boolean;
    readonly isMarshalByRef: boolean;
    readonly isPrimitive: boolean;
    readonly isValueType: boolean;
    readonly isSignatureType: boolean;
    readonly isSecurityCritical: boolean;
    readonly isSecuritySafeCritical: boolean;
    readonly isSecurityTransparent: boolean;
    structLayoutAttribute: StructLayoutAttribute;
    typeInitializer: ConstructorInfo;
    typeHandle: RuntimeTypeHandle;
    readonly guid: string;
    baseType: Type;
    readonly isSerializable: boolean;
    readonly containsGenericParameters: boolean;
    readonly isVisible: boolean;
    readonly name: string | undefined;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly isCollectible: boolean;
    readonly metadataToken: number;

    constructor(data?: IType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isInterface = _data["isInterface"];
            this.memberType = _data["memberType"];
            (<any>this).namespace = _data["namespace"];
            (<any>this).assemblyQualifiedName = _data["assemblyQualifiedName"];
            (<any>this).fullName = _data["fullName"];
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            (<any>this).isNested = _data["isNested"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.declaringMethod = _data["declaringMethod"] ? MethodBase.fromJS(_data["declaringMethod"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.underlyingSystemType = _data["underlyingSystemType"] ? Type.fromJS(_data["underlyingSystemType"]) : <any>undefined;
            (<any>this).isTypeDefinition = _data["isTypeDefinition"];
            (<any>this).isArray = _data["isArray"];
            (<any>this).isByRef = _data["isByRef"];
            (<any>this).isPointer = _data["isPointer"];
            (<any>this).isConstructedGenericType = _data["isConstructedGenericType"];
            (<any>this).isGenericParameter = _data["isGenericParameter"];
            (<any>this).isGenericTypeParameter = _data["isGenericTypeParameter"];
            (<any>this).isGenericMethodParameter = _data["isGenericMethodParameter"];
            (<any>this).isGenericType = _data["isGenericType"];
            (<any>this).isGenericTypeDefinition = _data["isGenericTypeDefinition"];
            (<any>this).isSZArray = _data["isSZArray"];
            (<any>this).isVariableBoundArray = _data["isVariableBoundArray"];
            (<any>this).isByRefLike = _data["isByRefLike"];
            (<any>this).hasElementType = _data["hasElementType"];
            if (Array.isArray(_data["genericTypeArguments"])) {
                (<any>this).genericTypeArguments = [] as any;
                for (let item of _data["genericTypeArguments"])
                    (<any>this).genericTypeArguments.push(Type.fromJS(item));
            }
            (<any>this).genericParameterPosition = _data["genericParameterPosition"];
            this.genericParameterAttributes = _data["genericParameterAttributes"];
            this.attributes = _data["attributes"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isImport = _data["isImport"];
            (<any>this).isSealed = _data["isSealed"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isClass = _data["isClass"];
            (<any>this).isNestedAssembly = _data["isNestedAssembly"];
            (<any>this).isNestedFamANDAssem = _data["isNestedFamANDAssem"];
            (<any>this).isNestedFamily = _data["isNestedFamily"];
            (<any>this).isNestedFamORAssem = _data["isNestedFamORAssem"];
            (<any>this).isNestedPrivate = _data["isNestedPrivate"];
            (<any>this).isNestedPublic = _data["isNestedPublic"];
            (<any>this).isNotPublic = _data["isNotPublic"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isAutoLayout = _data["isAutoLayout"];
            (<any>this).isExplicitLayout = _data["isExplicitLayout"];
            (<any>this).isLayoutSequential = _data["isLayoutSequential"];
            (<any>this).isAnsiClass = _data["isAnsiClass"];
            (<any>this).isAutoClass = _data["isAutoClass"];
            (<any>this).isUnicodeClass = _data["isUnicodeClass"];
            (<any>this).isCOMObject = _data["isCOMObject"];
            (<any>this).isContextful = _data["isContextful"];
            (<any>this).isEnum = _data["isEnum"];
            (<any>this).isMarshalByRef = _data["isMarshalByRef"];
            (<any>this).isPrimitive = _data["isPrimitive"];
            (<any>this).isValueType = _data["isValueType"];
            (<any>this).isSignatureType = _data["isSignatureType"];
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.structLayoutAttribute = _data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(_data["structLayoutAttribute"]) : <any>undefined;
            this.typeInitializer = _data["typeInitializer"] ? ConstructorInfo.fromJS(_data["typeInitializer"]) : <any>undefined;
            this.typeHandle = _data["typeHandle"] ? RuntimeTypeHandle.fromJS(_data["typeHandle"]) : <any>undefined;
            (<any>this).guid = _data["guid"];
            this.baseType = _data["baseType"] ? Type.fromJS(_data["baseType"]) : <any>undefined;
            (<any>this).isSerializable = _data["isSerializable"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            (<any>this).isVisible = _data["isVisible"];
            (<any>this).name = _data["name"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): Type {
        data = typeof data === 'object' ? data : {};
        let result = new Type();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isInterface"] = this.isInterface;
        data["memberType"] = this.memberType;
        data["namespace"] = this.namespace;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName;
        data["fullName"] = this.fullName;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["isNested"] = this.isNested;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : <any>undefined;
        data["isTypeDefinition"] = this.isTypeDefinition;
        data["isArray"] = this.isArray;
        data["isByRef"] = this.isByRef;
        data["isPointer"] = this.isPointer;
        data["isConstructedGenericType"] = this.isConstructedGenericType;
        data["isGenericParameter"] = this.isGenericParameter;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter;
        data["isGenericType"] = this.isGenericType;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition;
        data["isSZArray"] = this.isSZArray;
        data["isVariableBoundArray"] = this.isVariableBoundArray;
        data["isByRefLike"] = this.isByRefLike;
        data["hasElementType"] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (let item of this.genericTypeArguments)
                data["genericTypeArguments"].push(item.toJSON());
        }
        data["genericParameterPosition"] = this.genericParameterPosition;
        data["genericParameterAttributes"] = this.genericParameterAttributes;
        data["attributes"] = this.attributes;
        data["isAbstract"] = this.isAbstract;
        data["isImport"] = this.isImport;
        data["isSealed"] = this.isSealed;
        data["isSpecialName"] = this.isSpecialName;
        data["isClass"] = this.isClass;
        data["isNestedAssembly"] = this.isNestedAssembly;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem;
        data["isNestedFamily"] = this.isNestedFamily;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem;
        data["isNestedPrivate"] = this.isNestedPrivate;
        data["isNestedPublic"] = this.isNestedPublic;
        data["isNotPublic"] = this.isNotPublic;
        data["isPublic"] = this.isPublic;
        data["isAutoLayout"] = this.isAutoLayout;
        data["isExplicitLayout"] = this.isExplicitLayout;
        data["isLayoutSequential"] = this.isLayoutSequential;
        data["isAnsiClass"] = this.isAnsiClass;
        data["isAutoClass"] = this.isAutoClass;
        data["isUnicodeClass"] = this.isUnicodeClass;
        data["isCOMObject"] = this.isCOMObject;
        data["isContextful"] = this.isContextful;
        data["isEnum"] = this.isEnum;
        data["isMarshalByRef"] = this.isMarshalByRef;
        data["isPrimitive"] = this.isPrimitive;
        data["isValueType"] = this.isValueType;
        data["isSignatureType"] = this.isSignatureType;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : <any>undefined;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : <any>undefined;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : <any>undefined;
        data["guid"] = this.guid;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : <any>undefined;
        data["isSerializable"] = this.isSerializable;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isVisible"] = this.isVisible;
        data["name"] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }

    clone(): Type {
        const json = this.toJSON();
        let result = new Type();
        result.init(json);
        return result;
    }
}

export interface IType {
    isInterface: boolean;
    memberType: MemberTypes;
    namespace: string | undefined;
    assemblyQualifiedName: string | undefined;
    fullName: string | undefined;
    assembly: Assembly;
    module: Module;
    isNested: boolean;
    declaringType: Type;
    declaringMethod: MethodBase;
    reflectedType: Type;
    underlyingSystemType: Type;
    isTypeDefinition: boolean;
    isArray: boolean;
    isByRef: boolean;
    isPointer: boolean;
    isConstructedGenericType: boolean;
    isGenericParameter: boolean;
    isGenericTypeParameter: boolean;
    isGenericMethodParameter: boolean;
    isGenericType: boolean;
    isGenericTypeDefinition: boolean;
    isSZArray: boolean;
    isVariableBoundArray: boolean;
    isByRefLike: boolean;
    hasElementType: boolean;
    genericTypeArguments: Type[] | undefined;
    genericParameterPosition: number;
    genericParameterAttributes: GenericParameterAttributes;
    attributes: TypeAttributes;
    isAbstract: boolean;
    isImport: boolean;
    isSealed: boolean;
    isSpecialName: boolean;
    isClass: boolean;
    isNestedAssembly: boolean;
    isNestedFamANDAssem: boolean;
    isNestedFamily: boolean;
    isNestedFamORAssem: boolean;
    isNestedPrivate: boolean;
    isNestedPublic: boolean;
    isNotPublic: boolean;
    isPublic: boolean;
    isAutoLayout: boolean;
    isExplicitLayout: boolean;
    isLayoutSequential: boolean;
    isAnsiClass: boolean;
    isAutoClass: boolean;
    isUnicodeClass: boolean;
    isCOMObject: boolean;
    isContextful: boolean;
    isEnum: boolean;
    isMarshalByRef: boolean;
    isPrimitive: boolean;
    isValueType: boolean;
    isSignatureType: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    structLayoutAttribute: StructLayoutAttribute;
    typeInitializer: ConstructorInfo;
    typeHandle: RuntimeTypeHandle;
    guid: string;
    baseType: Type;
    isSerializable: boolean;
    containsGenericParameters: boolean;
    isVisible: boolean;
    name: string | undefined;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export enum NotificationSeverity {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class TenantNotification implements ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: Type;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: Date;
    id: string;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.notificationName = _data["notificationName"];
            this.data = _data["data"] ? NotificationData.fromJS(_data["data"]) : <any>undefined;
            this.entityType = _data["entityType"] ? Type.fromJS(_data["entityType"]) : <any>undefined;
            this.entityTypeName = _data["entityTypeName"];
            this.entityId = _data["entityId"];
            this.severity = _data["severity"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : <any>undefined;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): TenantNotification {
        const json = this.toJSON();
        let result = new TenantNotification();
        result.init(json);
        return result;
    }
}

export interface ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: Type;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: Date;
    id: string;
}

export class UserNotification implements IUserNotification {
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    id: string;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.state = _data["state"];
            this.notification = _data["notification"] ? TenantNotification.fromJS(_data["notification"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): UserNotification {
        const json = this.toJSON();
        let result = new UserNotification();
        result.init(json);
        return result;
    }
}

export interface IUserNotification {
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    id: string;
}

export class UserNotificationPagedResultDto implements IUserNotificationPagedResultDto {
    totalCount: number;
    items: UserNotification[] | undefined;

    constructor(data?: IUserNotificationPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserNotificationPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserNotificationPagedResultDto {
        const json = this.toJSON();
        let result = new UserNotificationPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserNotificationPagedResultDto {
    totalCount: number;
    items: UserNotification[] | undefined;
}

export class NotificationGroup implements INotificationGroup {
    name: string | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: INotificationGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NotificationGroup {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): NotificationGroup {
        const json = this.toJSON();
        let result = new NotificationGroup();
        result.init(json);
        return result;
    }
}

export interface INotificationGroup {
    name: string | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class NotificationGroupMemberBatchInsertRequestDto implements INotificationGroupMemberBatchInsertRequestDto {
    userIdList: number[] | undefined;
    notificationGroupId: number;

    constructor(data?: INotificationGroupMemberBatchInsertRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIdList"])) {
                this.userIdList = [] as any;
                for (let item of _data["userIdList"])
                    this.userIdList.push(item);
            }
            this.notificationGroupId = _data["notificationGroupId"];
        }
    }

    static fromJS(data: any): NotificationGroupMemberBatchInsertRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationGroupMemberBatchInsertRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIdList)) {
            data["userIdList"] = [];
            for (let item of this.userIdList)
                data["userIdList"].push(item);
        }
        data["notificationGroupId"] = this.notificationGroupId;
        return data;
    }

    clone(): NotificationGroupMemberBatchInsertRequestDto {
        const json = this.toJSON();
        let result = new NotificationGroupMemberBatchInsertRequestDto();
        result.init(json);
        return result;
    }
}

export interface INotificationGroupMemberBatchInsertRequestDto {
    userIdList: number[] | undefined;
    notificationGroupId: number;
}

export class NotificationGroupPagedResultDto implements INotificationGroupPagedResultDto {
    totalCount: number;
    items: NotificationGroup[] | undefined;

    constructor(data?: INotificationGroupPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NotificationGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationGroupPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationGroupPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): NotificationGroupPagedResultDto {
        const json = this.toJSON();
        let result = new NotificationGroupPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INotificationGroupPagedResultDto {
    totalCount: number;
    items: NotificationGroup[] | undefined;
}

export class NotificationGroupMember implements INotificationGroupMember {
    notificationGroup: NotificationGroup;
    notificationGroupId: number;
    user: User;
    userId: number;
    id: number;

    constructor(data?: INotificationGroupMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.notificationGroup = new NotificationGroup();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationGroup = _data["notificationGroup"] ? NotificationGroup.fromJS(_data["notificationGroup"]) : new NotificationGroup();
            this.notificationGroupId = _data["notificationGroupId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NotificationGroupMember {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationGroupMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationGroup"] = this.notificationGroup ? this.notificationGroup.toJSON() : <any>undefined;
        data["notificationGroupId"] = this.notificationGroupId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["id"] = this.id;
        return data;
    }

    clone(): NotificationGroupMember {
        const json = this.toJSON();
        let result = new NotificationGroupMember();
        result.init(json);
        return result;
    }
}

export interface INotificationGroupMember {
    notificationGroup: NotificationGroup;
    notificationGroupId: number;
    user: User;
    userId: number;
    id: number;
}

export class NotificationGroupMemberPagedResultDto implements INotificationGroupMemberPagedResultDto {
    totalCount: number;
    items: NotificationGroupMember[] | undefined;

    constructor(data?: INotificationGroupMemberPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NotificationGroupMember.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationGroupMemberPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationGroupMemberPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): NotificationGroupMemberPagedResultDto {
        const json = this.toJSON();
        let result = new NotificationGroupMemberPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INotificationGroupMemberPagedResultDto {
    totalCount: number;
    items: NotificationGroupMember[] | undefined;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    totalCount: number;
    items: UserDto[] | undefined;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    totalCount: number;
    items: UserDto[] | undefined;
}

export class OrderHeaderRouteDetailDto implements IOrderHeaderRouteDetailDto {
    code: string | undefined;

    constructor(data?: IOrderHeaderRouteDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): OrderHeaderRouteDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderRouteDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }

    clone(): OrderHeaderRouteDetailDto {
        const json = this.toJSON();
        let result = new OrderHeaderRouteDetailDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderRouteDetailDto {
    code: string | undefined;
}

export class ProductSimpleDto implements IProductSimpleDto {
    code: string | undefined;
    definition: string | undefined;
    manufacturer: string | undefined;
    id: number;

    constructor(data?: IProductSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.manufacturer = _data["manufacturer"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["manufacturer"] = this.manufacturer;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductSimpleDto {
        const json = this.toJSON();
        let result = new ProductSimpleDto();
        result.init(json);
        return result;
    }
}

export interface IProductSimpleDto {
    code: string | undefined;
    definition: string | undefined;
    manufacturer: string | undefined;
    id: number;
}

export class OrderDetailForRouteDto implements IOrderDetailForRouteDto {
    quantity: number;
    quantityShipped: number;
    quantityCollected: number;
    product: ProductSimpleDto;
    id: number;

    constructor(data?: IOrderDetailForRouteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.quantityShipped = _data["quantityShipped"];
            this.quantityCollected = _data["quantityCollected"];
            this.product = _data["product"] ? ProductSimpleDto.fromJS(_data["product"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDetailForRouteDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailForRouteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["quantityShipped"] = this.quantityShipped;
        data["quantityCollected"] = this.quantityCollected;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderDetailForRouteDto {
        const json = this.toJSON();
        let result = new OrderDetailForRouteDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailForRouteDto {
    quantity: number;
    quantityShipped: number;
    quantityCollected: number;
    product: ProductSimpleDto;
    id: number;
}

export enum RouteType {
    _1 = 1,
    _2 = 2,
}

export class OrderHeaderRouteDto implements IOrderHeaderRouteDto {
    documentNo: string | undefined;
    clientName: string | undefined;
    clientCode: string | undefined;
    orderHeaderId: number;
    quantityPackTotal: number;
    quantityLoadPack: number;
    quantityUnLoadPack: number;
    shippingRoute: ShippingRoute;
    shippingRouteId: number;
    deliveredPerson: string | undefined;
    routeType: RouteType;

    constructor(data?: IOrderHeaderRouteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNo = _data["documentNo"];
            this.clientName = _data["clientName"];
            this.clientCode = _data["clientCode"];
            this.orderHeaderId = _data["orderHeaderId"];
            this.quantityPackTotal = _data["quantityPackTotal"];
            this.quantityLoadPack = _data["quantityLoadPack"];
            this.quantityUnLoadPack = _data["quantityUnLoadPack"];
            this.shippingRoute = _data["shippingRoute"] ? ShippingRoute.fromJS(_data["shippingRoute"]) : <any>undefined;
            this.shippingRouteId = _data["shippingRouteId"];
            this.deliveredPerson = _data["deliveredPerson"];
            this.routeType = _data["routeType"];
        }
    }

    static fromJS(data: any): OrderHeaderRouteDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderRouteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNo"] = this.documentNo;
        data["clientName"] = this.clientName;
        data["clientCode"] = this.clientCode;
        data["orderHeaderId"] = this.orderHeaderId;
        data["quantityPackTotal"] = this.quantityPackTotal;
        data["quantityLoadPack"] = this.quantityLoadPack;
        data["quantityUnLoadPack"] = this.quantityUnLoadPack;
        data["shippingRoute"] = this.shippingRoute ? this.shippingRoute.toJSON() : <any>undefined;
        data["shippingRouteId"] = this.shippingRouteId;
        data["deliveredPerson"] = this.deliveredPerson;
        data["routeType"] = this.routeType;
        return data;
    }

    clone(): OrderHeaderRouteDto {
        const json = this.toJSON();
        let result = new OrderHeaderRouteDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderRouteDto {
    documentNo: string | undefined;
    clientName: string | undefined;
    clientCode: string | undefined;
    orderHeaderId: number;
    quantityPackTotal: number;
    quantityLoadPack: number;
    quantityUnLoadPack: number;
    shippingRoute: ShippingRoute;
    shippingRouteId: number;
    deliveredPerson: string | undefined;
    routeType: RouteType;
}

export class ReportsGeoMapDto implements IReportsGeoMapDto {
    fullAddress: string | undefined;
    region: string | undefined;
    sequence: number;
    floor: number;
    count: number;

    constructor(data?: IReportsGeoMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullAddress = _data["fullAddress"];
            this.region = _data["region"];
            this.sequence = _data["sequence"];
            this.floor = _data["floor"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ReportsGeoMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportsGeoMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullAddress"] = this.fullAddress;
        data["region"] = this.region;
        data["sequence"] = this.sequence;
        data["floor"] = this.floor;
        data["count"] = this.count;
        return data;
    }

    clone(): ReportsGeoMapDto {
        const json = this.toJSON();
        let result = new ReportsGeoMapDto();
        result.init(json);
        return result;
    }
}

export interface IReportsGeoMapDto {
    fullAddress: string | undefined;
    region: string | undefined;
    sequence: number;
    floor: number;
    count: number;
}

export class ShippingTypePagedResultDto implements IShippingTypePagedResultDto {
    totalCount: number;
    items: ShippingType[] | undefined;

    constructor(data?: IShippingTypePagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ShippingType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShippingTypePagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingTypePagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ShippingTypePagedResultDto {
        const json = this.toJSON();
        let result = new ShippingTypePagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IShippingTypePagedResultDto {
    totalCount: number;
    items: ShippingType[] | undefined;
}

export class StorageDto implements IStorageDto {
    warehouse: Warehouse;
    code: string | undefined;
    definition: string | undefined;
    storageType: StorageType;
    id: number;

    constructor(data?: IStorageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.storageType = _data["storageType"] ? StorageType.fromJS(_data["storageType"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StorageDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["storageType"] = this.storageType ? this.storageType.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): StorageDto {
        const json = this.toJSON();
        let result = new StorageDto();
        result.init(json);
        return result;
    }
}

export interface IStorageDto {
    warehouse: Warehouse;
    code: string | undefined;
    definition: string | undefined;
    storageType: StorageType;
    id: number;
}

export class OrderHeaderForWorkAkctivityDto implements IOrderHeaderForWorkAkctivityDto {
    creationTime: Date;
    client: ClientExtendedDto;
    storage: StorageDto;
    companyDataSourceId: number;
    erpEntegreId: string | undefined;
    documentNo: string | undefined;
    documentNo2: string | undefined;
    documentDate: Date;
    deadlineDate: Date;
    notes: string | undefined;
    productCount: number;
    quantityCount: number;
    quantityInStorage: number;
    quantityAffordablePercent: number;
    controlPointId: number;
    readonly isSelected: boolean;
    shippingTypeId: number | undefined;
    shippingCost: number;
    shippingName: string | undefined;
    shippingAddress: string | undefined;
    shippingCountry: string | undefined;
    shippingCity: string | undefined;
    shippingTown: string | undefined;
    isExport: boolean;
    quantityOrder: number;
    quantityOrderType: number;
    id: number;

    constructor(data?: IOrderHeaderForWorkAkctivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.client = _data["client"] ? ClientExtendedDto.fromJS(_data["client"]) : <any>undefined;
            this.storage = _data["storage"] ? StorageDto.fromJS(_data["storage"]) : <any>undefined;
            this.companyDataSourceId = _data["companyDataSourceId"];
            this.erpEntegreId = _data["erpEntegreId"];
            this.documentNo = _data["documentNo"];
            this.documentNo2 = _data["documentNo2"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.deadlineDate = _data["deadlineDate"] ? new Date(_data["deadlineDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.productCount = _data["productCount"];
            this.quantityCount = _data["quantityCount"];
            this.quantityInStorage = _data["quantityInStorage"];
            this.quantityAffordablePercent = _data["quantityAffordablePercent"];
            this.controlPointId = _data["controlPointId"];
            (<any>this).isSelected = _data["isSelected"];
            this.shippingTypeId = _data["shippingTypeId"];
            this.shippingCost = _data["shippingCost"];
            this.shippingName = _data["shippingName"];
            this.shippingAddress = _data["shippingAddress"];
            this.shippingCountry = _data["shippingCountry"];
            this.shippingCity = _data["shippingCity"];
            this.shippingTown = _data["shippingTown"];
            this.isExport = _data["isExport"];
            this.quantityOrder = _data["quantityOrder"];
            this.quantityOrderType = _data["quantityOrderType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderHeaderForWorkAkctivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderForWorkAkctivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["companyDataSourceId"] = this.companyDataSourceId;
        data["erpEntegreId"] = this.erpEntegreId;
        data["documentNo"] = this.documentNo;
        data["documentNo2"] = this.documentNo2;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["deadlineDate"] = this.deadlineDate ? this.deadlineDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["productCount"] = this.productCount;
        data["quantityCount"] = this.quantityCount;
        data["quantityInStorage"] = this.quantityInStorage;
        data["quantityAffordablePercent"] = this.quantityAffordablePercent;
        data["controlPointId"] = this.controlPointId;
        data["isSelected"] = this.isSelected;
        data["shippingTypeId"] = this.shippingTypeId;
        data["shippingCost"] = this.shippingCost;
        data["shippingName"] = this.shippingName;
        data["shippingAddress"] = this.shippingAddress;
        data["shippingCountry"] = this.shippingCountry;
        data["shippingCity"] = this.shippingCity;
        data["shippingTown"] = this.shippingTown;
        data["isExport"] = this.isExport;
        data["quantityOrder"] = this.quantityOrder;
        data["quantityOrderType"] = this.quantityOrderType;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderHeaderForWorkAkctivityDto {
        const json = this.toJSON();
        let result = new OrderHeaderForWorkAkctivityDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderForWorkAkctivityDto {
    creationTime: Date;
    client: ClientExtendedDto;
    storage: StorageDto;
    companyDataSourceId: number;
    erpEntegreId: string | undefined;
    documentNo: string | undefined;
    documentNo2: string | undefined;
    documentDate: Date;
    deadlineDate: Date;
    notes: string | undefined;
    productCount: number;
    quantityCount: number;
    quantityInStorage: number;
    quantityAffordablePercent: number;
    controlPointId: number;
    isSelected: boolean;
    shippingTypeId: number | undefined;
    shippingCost: number;
    shippingName: string | undefined;
    shippingAddress: string | undefined;
    shippingCountry: string | undefined;
    shippingCity: string | undefined;
    shippingTown: string | undefined;
    isExport: boolean;
    quantityOrder: number;
    quantityOrderType: number;
    id: number;
}

export class OrderHeaderForWorkAkctivityDtoPagedResultDto implements IOrderHeaderForWorkAkctivityDtoPagedResultDto {
    totalCount: number;
    items: OrderHeaderForWorkAkctivityDto[] | undefined;

    constructor(data?: IOrderHeaderForWorkAkctivityDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderHeaderForWorkAkctivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderHeaderForWorkAkctivityDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderForWorkAkctivityDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderHeaderForWorkAkctivityDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderHeaderForWorkAkctivityDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderForWorkAkctivityDtoPagedResultDto {
    totalCount: number;
    items: OrderHeaderForWorkAkctivityDto[] | undefined;
}

export class OrderHeaderWorkActivityDtoDapper implements IOrderHeaderWorkActivityDtoDapper {
    companyName: string | undefined;
    clientCode: string | undefined;
    clientName: string | undefined;
    city: string | undefined;
    town: string | undefined;
    warehouse: string | undefined;
    documentNo: string | undefined;
    orderType: string | undefined;
    orderHeaderId: number;
    shippingType: string | undefined;
    shippingAddress: string | undefined;
    shippingCompany: string | undefined;
    documentDate: Date;
    creationTime: Date;
    shipmentDate: Date;
    isExport: boolean;
    notes: string | undefined;
    quantityOrder: number;
    quantityOrderType: number;
    quantity: number;
    readonly isSelected: boolean;
    controlPointId: number;
    shippingTypeId: number;
    quantityInStorage: number;
    quantityAffordablePercent: number;
    overall_count: number;

    constructor(data?: IOrderHeaderWorkActivityDtoDapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.clientCode = _data["clientCode"];
            this.clientName = _data["clientName"];
            this.city = _data["city"];
            this.town = _data["town"];
            this.warehouse = _data["warehouse"];
            this.documentNo = _data["documentNo"];
            this.orderType = _data["orderType"];
            this.orderHeaderId = _data["orderHeaderId"];
            this.shippingType = _data["shippingType"];
            this.shippingAddress = _data["shippingAddress"];
            this.shippingCompany = _data["shippingCompany"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.shipmentDate = _data["shipmentDate"] ? new Date(_data["shipmentDate"].toString()) : <any>undefined;
            this.isExport = _data["isExport"];
            this.notes = _data["notes"];
            this.quantityOrder = _data["quantityOrder"];
            this.quantityOrderType = _data["quantityOrderType"];
            this.quantity = _data["quantity"];
            (<any>this).isSelected = _data["isSelected"];
            this.controlPointId = _data["controlPointId"];
            this.shippingTypeId = _data["shippingTypeId"];
            this.quantityInStorage = _data["quantityInStorage"];
            this.quantityAffordablePercent = _data["quantityAffordablePercent"];
            this.overall_count = _data["overall_count"];
        }
    }

    static fromJS(data: any): OrderHeaderWorkActivityDtoDapper {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderWorkActivityDtoDapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["clientCode"] = this.clientCode;
        data["clientName"] = this.clientName;
        data["city"] = this.city;
        data["town"] = this.town;
        data["warehouse"] = this.warehouse;
        data["documentNo"] = this.documentNo;
        data["orderType"] = this.orderType;
        data["orderHeaderId"] = this.orderHeaderId;
        data["shippingType"] = this.shippingType;
        data["shippingAddress"] = this.shippingAddress;
        data["shippingCompany"] = this.shippingCompany;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : <any>undefined;
        data["isExport"] = this.isExport;
        data["notes"] = this.notes;
        data["quantityOrder"] = this.quantityOrder;
        data["quantityOrderType"] = this.quantityOrderType;
        data["quantity"] = this.quantity;
        data["isSelected"] = this.isSelected;
        data["controlPointId"] = this.controlPointId;
        data["shippingTypeId"] = this.shippingTypeId;
        data["quantityInStorage"] = this.quantityInStorage;
        data["quantityAffordablePercent"] = this.quantityAffordablePercent;
        data["overall_count"] = this.overall_count;
        return data;
    }

    clone(): OrderHeaderWorkActivityDtoDapper {
        const json = this.toJSON();
        let result = new OrderHeaderWorkActivityDtoDapper();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderWorkActivityDtoDapper {
    companyName: string | undefined;
    clientCode: string | undefined;
    clientName: string | undefined;
    city: string | undefined;
    town: string | undefined;
    warehouse: string | undefined;
    documentNo: string | undefined;
    orderType: string | undefined;
    orderHeaderId: number;
    shippingType: string | undefined;
    shippingAddress: string | undefined;
    shippingCompany: string | undefined;
    documentDate: Date;
    creationTime: Date;
    shipmentDate: Date;
    isExport: boolean;
    notes: string | undefined;
    quantityOrder: number;
    quantityOrderType: number;
    quantity: number;
    isSelected: boolean;
    controlPointId: number;
    shippingTypeId: number;
    quantityInStorage: number;
    quantityAffordablePercent: number;
    overall_count: number;
}

export class OrderHeaderWorkActivityDtoDapperPagedResultDto implements IOrderHeaderWorkActivityDtoDapperPagedResultDto {
    totalCount: number;
    items: OrderHeaderWorkActivityDtoDapper[] | undefined;

    constructor(data?: IOrderHeaderWorkActivityDtoDapperPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderHeaderWorkActivityDtoDapper.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderHeaderWorkActivityDtoDapperPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderWorkActivityDtoDapperPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderHeaderWorkActivityDtoDapperPagedResultDto {
        const json = this.toJSON();
        let result = new OrderHeaderWorkActivityDtoDapperPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderWorkActivityDtoDapperPagedResultDto {
    totalCount: number;
    items: OrderHeaderWorkActivityDtoDapper[] | undefined;
}

export class ProductDto implements IProductDto {
    company: Company;
    code: string | undefined;
    definition: string | undefined;
    definition2: string | undefined;
    manufacturer: string | undefined;
    manufacturerCode: string | undefined;
    unit: string | undefined;
    natraShelf: string | undefined;
    group3: string | undefined;
    sizeWidth: number;
    sizeLength: number;
    sizeHeight: number;
    weight: number;
    volume: number;
    hasSerial: boolean;
    isDeleted: boolean;
    purchasePrice: number;
    isFifo: boolean;
    id: number;

    constructor(data?: IProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.definition2 = _data["definition2"];
            this.manufacturer = _data["manufacturer"];
            this.manufacturerCode = _data["manufacturerCode"];
            this.unit = _data["unit"];
            this.natraShelf = _data["natraShelf"];
            this.group3 = _data["group3"];
            this.sizeWidth = _data["sizeWidth"];
            this.sizeLength = _data["sizeLength"];
            this.sizeHeight = _data["sizeHeight"];
            this.weight = _data["weight"];
            this.volume = _data["volume"];
            this.hasSerial = _data["hasSerial"];
            this.isDeleted = _data["isDeleted"];
            this.purchasePrice = _data["purchasePrice"];
            this.isFifo = _data["isFifo"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["definition2"] = this.definition2;
        data["manufacturer"] = this.manufacturer;
        data["manufacturerCode"] = this.manufacturerCode;
        data["unit"] = this.unit;
        data["natraShelf"] = this.natraShelf;
        data["group3"] = this.group3;
        data["sizeWidth"] = this.sizeWidth;
        data["sizeLength"] = this.sizeLength;
        data["sizeHeight"] = this.sizeHeight;
        data["weight"] = this.weight;
        data["volume"] = this.volume;
        data["hasSerial"] = this.hasSerial;
        data["isDeleted"] = this.isDeleted;
        data["purchasePrice"] = this.purchasePrice;
        data["isFifo"] = this.isFifo;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductDto {
        const json = this.toJSON();
        let result = new ProductDto();
        result.init(json);
        return result;
    }
}

export interface IProductDto {
    company: Company;
    code: string | undefined;
    definition: string | undefined;
    definition2: string | undefined;
    manufacturer: string | undefined;
    manufacturerCode: string | undefined;
    unit: string | undefined;
    natraShelf: string | undefined;
    group3: string | undefined;
    sizeWidth: number;
    sizeLength: number;
    sizeHeight: number;
    weight: number;
    volume: number;
    hasSerial: boolean;
    isDeleted: boolean;
    purchasePrice: number;
    isFifo: boolean;
    id: number;
}

export class Container implements IContainer {
    client: Client;
    product: Product;
    entryDate: Date;
    quantity: number;
    quantityRemaining: number;
    shelf: Shelf;
    printed: boolean;
    readonly priority: number;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IContainer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.client = new Client();
            this.product = new Product();
            this.printed = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : new Client();
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : new Product();
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.quantity = _data["quantity"];
            this.quantityRemaining = _data["quantityRemaining"];
            this.shelf = _data["shelf"] ? Shelf.fromJS(_data["shelf"]) : <any>undefined;
            this.printed = _data["printed"] !== undefined ? _data["printed"] : false;
            (<any>this).priority = _data["priority"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Container {
        data = typeof data === 'object' ? data : {};
        let result = new Container();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["quantityRemaining"] = this.quantityRemaining;
        data["shelf"] = this.shelf ? this.shelf.toJSON() : <any>undefined;
        data["printed"] = this.printed;
        data["priority"] = this.priority;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Container {
        const json = this.toJSON();
        let result = new Container();
        result.init(json);
        return result;
    }
}

export interface IContainer {
    client: Client;
    product: Product;
    entryDate: Date;
    quantity: number;
    quantityRemaining: number;
    shelf: Shelf;
    printed: boolean;
    priority: number;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class UserStepAction implements IUserStepAction {
    startStep: number;
    endStep: number;
    totalStepCount: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserStepAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.startStep = 0;
            this.endStep = 0;
            this.totalStepCount = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startStep = _data["startStep"] !== undefined ? _data["startStep"] : 0;
            this.endStep = _data["endStep"] !== undefined ? _data["endStep"] : 0;
            this.totalStepCount = _data["totalStepCount"] !== undefined ? _data["totalStepCount"] : 0;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserStepAction {
        data = typeof data === 'object' ? data : {};
        let result = new UserStepAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startStep"] = this.startStep;
        data["endStep"] = this.endStep;
        data["totalStepCount"] = this.totalStepCount;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UserStepAction {
        const json = this.toJSON();
        let result = new UserStepAction();
        result.init(json);
        return result;
    }
}

export interface IUserStepAction {
    startStep: number;
    endStep: number;
    totalStepCount: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class WorkActionType implements IWorkActionType {
    code: string | undefined;
    definition: string | undefined;
    id: number;

    constructor(data?: IWorkActionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WorkActionType {
        data = typeof data === 'object' ? data : {};
        let result = new WorkActionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["id"] = this.id;
        return data;
    }

    clone(): WorkActionType {
        const json = this.toJSON();
        let result = new WorkActionType();
        result.init(json);
        return result;
    }
}

export interface IWorkActionType {
    code: string | undefined;
    definition: string | undefined;
    id: number;
}

export class WorkAction implements IWorkAction {
    workActivity: WorkActivity;
    workActivityId: number;
    userStepAction: UserStepAction;
    userStepActionId: number | undefined;
    workActionType: WorkActionType;
    workActionTypeId: number;
    startTime: Date;
    finishTime: Date;
    processUser: User;
    processUserId: number;
    isFinished: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IWorkAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.workActivity = new WorkActivity();
            this.workActionType = new WorkActionType();
            this.processUser = new User();
            this.isFinished = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workActivity = _data["workActivity"] ? WorkActivity.fromJS(_data["workActivity"]) : new WorkActivity();
            this.workActivityId = _data["workActivityId"];
            this.userStepAction = _data["userStepAction"] ? UserStepAction.fromJS(_data["userStepAction"]) : <any>undefined;
            this.userStepActionId = _data["userStepActionId"];
            this.workActionType = _data["workActionType"] ? WorkActionType.fromJS(_data["workActionType"]) : new WorkActionType();
            this.workActionTypeId = _data["workActionTypeId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : <any>undefined;
            this.processUser = _data["processUser"] ? User.fromJS(_data["processUser"]) : new User();
            this.processUserId = _data["processUserId"];
            this.isFinished = _data["isFinished"] !== undefined ? _data["isFinished"] : false;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WorkAction {
        data = typeof data === 'object' ? data : {};
        let result = new WorkAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workActivity"] = this.workActivity ? this.workActivity.toJSON() : <any>undefined;
        data["workActivityId"] = this.workActivityId;
        data["userStepAction"] = this.userStepAction ? this.userStepAction.toJSON() : <any>undefined;
        data["userStepActionId"] = this.userStepActionId;
        data["workActionType"] = this.workActionType ? this.workActionType.toJSON() : <any>undefined;
        data["workActionTypeId"] = this.workActionTypeId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["processUser"] = this.processUser ? this.processUser.toJSON() : <any>undefined;
        data["processUserId"] = this.processUserId;
        data["isFinished"] = this.isFinished;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): WorkAction {
        const json = this.toJSON();
        let result = new WorkAction();
        result.init(json);
        return result;
    }
}

export interface IWorkAction {
    workActivity: WorkActivity;
    workActivityId: number;
    userStepAction: UserStepAction;
    userStepActionId: number | undefined;
    workActionType: WorkActionType;
    workActionTypeId: number;
    startTime: Date;
    finishTime: Date;
    processUser: User;
    processUserId: number;
    isFinished: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class StockMovementType implements IStockMovementType {
    code: string | undefined;
    definition: string | undefined;
    type: number;
    id: number;

    constructor(data?: IStockMovementType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.code = "";
            this.definition = "";
            this.type = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : "";
            this.definition = _data["definition"] !== undefined ? _data["definition"] : "";
            this.type = _data["type"] !== undefined ? _data["type"] : 0;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StockMovementType {
        data = typeof data === 'object' ? data : {};
        let result = new StockMovementType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }

    clone(): StockMovementType {
        const json = this.toJSON();
        let result = new StockMovementType();
        result.init(json);
        return result;
    }
}

export interface IStockMovementType {
    code: string | undefined;
    definition: string | undefined;
    type: number;
    id: number;
}

export class TransferType implements ITransferType {
    code: string | undefined;
    definition: string | undefined;
    id: number;

    constructor(data?: ITransferType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.code = "";
            this.definition = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : "";
            this.definition = _data["definition"] !== undefined ? _data["definition"] : "";
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TransferType {
        data = typeof data === 'object' ? data : {};
        let result = new TransferType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["id"] = this.id;
        return data;
    }

    clone(): TransferType {
        const json = this.toJSON();
        let result = new TransferType();
        result.init(json);
        return result;
    }
}

export interface ITransferType {
    code: string | undefined;
    definition: string | undefined;
    id: number;
}

export class TransferHeader implements ITransferHeader {
    code: string;
    movementType: MovementType;
    company: Company;
    companyId: number;
    transferType: TransferType;
    transferTypeId: number;
    warehouse: Warehouse;
    warehouseId: number | undefined;
    warehouseFrom: Warehouse;
    warehouseFromId: number | undefined;
    warehouseTo: Warehouse;
    warehouseToId: number | undefined;
    storage: Storage;
    storageId: number | undefined;
    storageFrom: Storage;
    storageFromId: number | undefined;
    storageTo: Storage;
    storageToId: number | undefined;
    client: Client;
    clientId: number | undefined;
    sourceId: number;
    sourceCode: string | undefined;
    creatorUser: User;
    notes: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITransferHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.code = "";
            this.company = new Company();
            this.transferType = new TransferType();
            this.sourceId = 0;
            this.sourceCode = "";
            this.notes = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : "";
            this.movementType = _data["movementType"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.companyId = _data["companyId"];
            this.transferType = _data["transferType"] ? TransferType.fromJS(_data["transferType"]) : new TransferType();
            this.transferTypeId = _data["transferTypeId"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.warehouseId = _data["warehouseId"];
            this.warehouseFrom = _data["warehouseFrom"] ? Warehouse.fromJS(_data["warehouseFrom"]) : <any>undefined;
            this.warehouseFromId = _data["warehouseFromId"];
            this.warehouseTo = _data["warehouseTo"] ? Warehouse.fromJS(_data["warehouseTo"]) : <any>undefined;
            this.warehouseToId = _data["warehouseToId"];
            this.storage = _data["storage"] ? Storage.fromJS(_data["storage"]) : <any>undefined;
            this.storageId = _data["storageId"];
            this.storageFrom = _data["storageFrom"] ? Storage.fromJS(_data["storageFrom"]) : <any>undefined;
            this.storageFromId = _data["storageFromId"];
            this.storageTo = _data["storageTo"] ? Storage.fromJS(_data["storageTo"]) : <any>undefined;
            this.storageToId = _data["storageToId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>undefined;
            this.clientId = _data["clientId"];
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : 0;
            this.sourceCode = _data["sourceCode"] !== undefined ? _data["sourceCode"] : "";
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : "";
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TransferHeader {
        data = typeof data === 'object' ? data : {};
        let result = new TransferHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["movementType"] = this.movementType;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["transferType"] = this.transferType ? this.transferType.toJSON() : <any>undefined;
        data["transferTypeId"] = this.transferTypeId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["warehouseFrom"] = this.warehouseFrom ? this.warehouseFrom.toJSON() : <any>undefined;
        data["warehouseFromId"] = this.warehouseFromId;
        data["warehouseTo"] = this.warehouseTo ? this.warehouseTo.toJSON() : <any>undefined;
        data["warehouseToId"] = this.warehouseToId;
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["storageId"] = this.storageId;
        data["storageFrom"] = this.storageFrom ? this.storageFrom.toJSON() : <any>undefined;
        data["storageFromId"] = this.storageFromId;
        data["storageTo"] = this.storageTo ? this.storageTo.toJSON() : <any>undefined;
        data["storageToId"] = this.storageToId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["sourceId"] = this.sourceId;
        data["sourceCode"] = this.sourceCode;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["notes"] = this.notes;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): TransferHeader {
        const json = this.toJSON();
        let result = new TransferHeader();
        result.init(json);
        return result;
    }
}

export interface ITransferHeader {
    code: string;
    movementType: MovementType;
    company: Company;
    companyId: number;
    transferType: TransferType;
    transferTypeId: number;
    warehouse: Warehouse;
    warehouseId: number | undefined;
    warehouseFrom: Warehouse;
    warehouseFromId: number | undefined;
    warehouseTo: Warehouse;
    warehouseToId: number | undefined;
    storage: Storage;
    storageId: number | undefined;
    storageFrom: Storage;
    storageFromId: number | undefined;
    storageTo: Storage;
    storageToId: number | undefined;
    client: Client;
    clientId: number | undefined;
    sourceId: number;
    sourceCode: string | undefined;
    creatorUser: User;
    notes: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class StockMovementShelf implements IStockMovementShelf {
    company: Company;
    companyId: number;
    type: MovementType;
    product: Product;
    productId: number;
    quantity: number;
    quantityIn: number;
    quantityOut: number;
    shelf: Shelf;
    shelfId: number;
    explanation: string | undefined;
    container: Container;
    containerId: number | undefined;
    workActivity: WorkActivity;
    workActivityId: number | undefined;
    workAction: WorkAction;
    workActionId: number | undefined;
    stockMovementType: StockMovementType;
    stockMovementTypeId: number;
    client: Client;
    clientId: number | undefined;
    sourceId: number;
    waybillHeaderId: number | undefined;
    waybillDetailId: number | undefined;
    orderHeaderId: number | undefined;
    orderDetailId: number | undefined;
    transferRequestHeaderId: number | undefined;
    transferRequestDetailId: number | undefined;
    productionHeaderId: number | undefined;
    productionDetailId: number | undefined;
    transferHeader: TransferHeader;
    transferHeaderId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IStockMovementShelf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.company = new Company();
            this.product = new Product();
            this.shelf = new Shelf();
            this.stockMovementType = new StockMovementType();
            this.sourceId = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.companyId = _data["companyId"];
            this.type = _data["type"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : new Product();
            this.productId = _data["productId"];
            this.quantity = _data["quantity"];
            this.quantityIn = _data["quantityIn"];
            this.quantityOut = _data["quantityOut"];
            this.shelf = _data["shelf"] ? Shelf.fromJS(_data["shelf"]) : new Shelf();
            this.shelfId = _data["shelfId"];
            this.explanation = _data["explanation"];
            this.container = _data["container"] ? Container.fromJS(_data["container"]) : <any>undefined;
            this.containerId = _data["containerId"];
            this.workActivity = _data["workActivity"] ? WorkActivity.fromJS(_data["workActivity"]) : <any>undefined;
            this.workActivityId = _data["workActivityId"];
            this.workAction = _data["workAction"] ? WorkAction.fromJS(_data["workAction"]) : <any>undefined;
            this.workActionId = _data["workActionId"];
            this.stockMovementType = _data["stockMovementType"] ? StockMovementType.fromJS(_data["stockMovementType"]) : new StockMovementType();
            this.stockMovementTypeId = _data["stockMovementTypeId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>undefined;
            this.clientId = _data["clientId"];
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : 0;
            this.waybillHeaderId = _data["waybillHeaderId"];
            this.waybillDetailId = _data["waybillDetailId"];
            this.orderHeaderId = _data["orderHeaderId"];
            this.orderDetailId = _data["orderDetailId"];
            this.transferRequestHeaderId = _data["transferRequestHeaderId"];
            this.transferRequestDetailId = _data["transferRequestDetailId"];
            this.productionHeaderId = _data["productionHeaderId"];
            this.productionDetailId = _data["productionDetailId"];
            this.transferHeader = _data["transferHeader"] ? TransferHeader.fromJS(_data["transferHeader"]) : <any>undefined;
            this.transferHeaderId = _data["transferHeaderId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StockMovementShelf {
        data = typeof data === 'object' ? data : {};
        let result = new StockMovementShelf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["type"] = this.type;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["quantityIn"] = this.quantityIn;
        data["quantityOut"] = this.quantityOut;
        data["shelf"] = this.shelf ? this.shelf.toJSON() : <any>undefined;
        data["shelfId"] = this.shelfId;
        data["explanation"] = this.explanation;
        data["container"] = this.container ? this.container.toJSON() : <any>undefined;
        data["containerId"] = this.containerId;
        data["workActivity"] = this.workActivity ? this.workActivity.toJSON() : <any>undefined;
        data["workActivityId"] = this.workActivityId;
        data["workAction"] = this.workAction ? this.workAction.toJSON() : <any>undefined;
        data["workActionId"] = this.workActionId;
        data["stockMovementType"] = this.stockMovementType ? this.stockMovementType.toJSON() : <any>undefined;
        data["stockMovementTypeId"] = this.stockMovementTypeId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["sourceId"] = this.sourceId;
        data["waybillHeaderId"] = this.waybillHeaderId;
        data["waybillDetailId"] = this.waybillDetailId;
        data["orderHeaderId"] = this.orderHeaderId;
        data["orderDetailId"] = this.orderDetailId;
        data["transferRequestHeaderId"] = this.transferRequestHeaderId;
        data["transferRequestDetailId"] = this.transferRequestDetailId;
        data["productionHeaderId"] = this.productionHeaderId;
        data["productionDetailId"] = this.productionDetailId;
        data["transferHeader"] = this.transferHeader ? this.transferHeader.toJSON() : <any>undefined;
        data["transferHeaderId"] = this.transferHeaderId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): StockMovementShelf {
        const json = this.toJSON();
        let result = new StockMovementShelf();
        result.init(json);
        return result;
    }
}

export interface IStockMovementShelf {
    company: Company;
    companyId: number;
    type: MovementType;
    product: Product;
    productId: number;
    quantity: number;
    quantityIn: number;
    quantityOut: number;
    shelf: Shelf;
    shelfId: number;
    explanation: string | undefined;
    container: Container;
    containerId: number | undefined;
    workActivity: WorkActivity;
    workActivityId: number | undefined;
    workAction: WorkAction;
    workActionId: number | undefined;
    stockMovementType: StockMovementType;
    stockMovementTypeId: number;
    client: Client;
    clientId: number | undefined;
    sourceId: number;
    waybillHeaderId: number | undefined;
    waybillDetailId: number | undefined;
    orderHeaderId: number | undefined;
    orderDetailId: number | undefined;
    transferRequestHeaderId: number | undefined;
    transferRequestDetailId: number | undefined;
    productionHeaderId: number | undefined;
    productionDetailId: number | undefined;
    transferHeader: TransferHeader;
    transferHeaderId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderDetailDto implements IOrderDetailDto {
    product: ProductDto;
    productId: number;
    productionRecipeCode: string | undefined;
    productionRecipeDefinition: string | undefined;
    productionRecipeHeaderId: number | undefined;
    orderHeader: OrderHeaderDto;
    stockMovementShelves: StockMovementShelf[] | undefined;
    quantity: number;
    quantityShipped: number;
    quantityCollected: number;
    isLocked: boolean;
    quantityInStorage: number;
    noteDeficiency: string | undefined;
    quantityReplacement: number;
    noteDeficiencyUser: UserDto;
    quantityForReplace: number;
    quantityReplaced: number;
    quantityOrj: number;
    readonly quantityErpDiff: boolean;
    readonly quantityDiff: number;
    readonly quantityDiffShipped: number;
    readonly quantityNeedToCollect: number;
    isStarted: boolean;
    isFinished: boolean;
    isDeleted: boolean;
    crossDockRequestId: number;
    creationTime: Date;
    packageNo: string[] | undefined;
    priceNet: number;
    currency: string | undefined;
    readonly priceTotalForShipped: number;
    id: number;

    constructor(data?: IOrderDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.productId = _data["productId"];
            this.productionRecipeCode = _data["productionRecipeCode"];
            this.productionRecipeDefinition = _data["productionRecipeDefinition"];
            this.productionRecipeHeaderId = _data["productionRecipeHeaderId"];
            this.orderHeader = _data["orderHeader"] ? OrderHeaderDto.fromJS(_data["orderHeader"]) : <any>undefined;
            if (Array.isArray(_data["stockMovementShelves"])) {
                this.stockMovementShelves = [] as any;
                for (let item of _data["stockMovementShelves"])
                    this.stockMovementShelves.push(StockMovementShelf.fromJS(item));
            }
            this.quantity = _data["quantity"];
            this.quantityShipped = _data["quantityShipped"];
            this.quantityCollected = _data["quantityCollected"];
            this.isLocked = _data["isLocked"];
            this.quantityInStorage = _data["quantityInStorage"];
            this.noteDeficiency = _data["noteDeficiency"];
            this.quantityReplacement = _data["quantityReplacement"];
            this.noteDeficiencyUser = _data["noteDeficiencyUser"] ? UserDto.fromJS(_data["noteDeficiencyUser"]) : <any>undefined;
            this.quantityForReplace = _data["quantityForReplace"];
            this.quantityReplaced = _data["quantityReplaced"];
            this.quantityOrj = _data["quantityOrj"];
            (<any>this).quantityErpDiff = _data["quantityErpDiff"];
            (<any>this).quantityDiff = _data["quantityDiff"];
            (<any>this).quantityDiffShipped = _data["quantityDiffShipped"];
            (<any>this).quantityNeedToCollect = _data["quantityNeedToCollect"];
            this.isStarted = _data["isStarted"];
            this.isFinished = _data["isFinished"];
            this.isDeleted = _data["isDeleted"];
            this.crossDockRequestId = _data["crossDockRequestId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["packageNo"])) {
                this.packageNo = [] as any;
                for (let item of _data["packageNo"])
                    this.packageNo.push(item);
            }
            this.priceNet = _data["priceNet"];
            this.currency = _data["currency"];
            (<any>this).priceTotalForShipped = _data["priceTotalForShipped"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["productionRecipeCode"] = this.productionRecipeCode;
        data["productionRecipeDefinition"] = this.productionRecipeDefinition;
        data["productionRecipeHeaderId"] = this.productionRecipeHeaderId;
        data["orderHeader"] = this.orderHeader ? this.orderHeader.toJSON() : <any>undefined;
        if (Array.isArray(this.stockMovementShelves)) {
            data["stockMovementShelves"] = [];
            for (let item of this.stockMovementShelves)
                data["stockMovementShelves"].push(item.toJSON());
        }
        data["quantity"] = this.quantity;
        data["quantityShipped"] = this.quantityShipped;
        data["quantityCollected"] = this.quantityCollected;
        data["isLocked"] = this.isLocked;
        data["quantityInStorage"] = this.quantityInStorage;
        data["noteDeficiency"] = this.noteDeficiency;
        data["quantityReplacement"] = this.quantityReplacement;
        data["noteDeficiencyUser"] = this.noteDeficiencyUser ? this.noteDeficiencyUser.toJSON() : <any>undefined;
        data["quantityForReplace"] = this.quantityForReplace;
        data["quantityReplaced"] = this.quantityReplaced;
        data["quantityOrj"] = this.quantityOrj;
        data["quantityErpDiff"] = this.quantityErpDiff;
        data["quantityDiff"] = this.quantityDiff;
        data["quantityDiffShipped"] = this.quantityDiffShipped;
        data["quantityNeedToCollect"] = this.quantityNeedToCollect;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["isDeleted"] = this.isDeleted;
        data["crossDockRequestId"] = this.crossDockRequestId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.packageNo)) {
            data["packageNo"] = [];
            for (let item of this.packageNo)
                data["packageNo"].push(item);
        }
        data["priceNet"] = this.priceNet;
        data["currency"] = this.currency;
        data["priceTotalForShipped"] = this.priceTotalForShipped;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderDetailDto {
        const json = this.toJSON();
        let result = new OrderDetailDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailDto {
    product: ProductDto;
    productId: number;
    productionRecipeCode: string | undefined;
    productionRecipeDefinition: string | undefined;
    productionRecipeHeaderId: number | undefined;
    orderHeader: OrderHeaderDto;
    stockMovementShelves: StockMovementShelf[] | undefined;
    quantity: number;
    quantityShipped: number;
    quantityCollected: number;
    isLocked: boolean;
    quantityInStorage: number;
    noteDeficiency: string | undefined;
    quantityReplacement: number;
    noteDeficiencyUser: UserDto;
    quantityForReplace: number;
    quantityReplaced: number;
    quantityOrj: number;
    quantityErpDiff: boolean;
    quantityDiff: number;
    quantityDiffShipped: number;
    quantityNeedToCollect: number;
    isStarted: boolean;
    isFinished: boolean;
    isDeleted: boolean;
    crossDockRequestId: number;
    creationTime: Date;
    packageNo: string[] | undefined;
    priceNet: number;
    currency: string | undefined;
    priceTotalForShipped: number;
    id: number;
}

export class InstantOrderTrackingReport implements IInstantOrderTrackingReport {
    warehouseName: string | undefined;
    controlPoint: string | undefined;
    workActivityCode: string | undefined;
    orderHeaderDocumentNo: string | undefined;
    orderHeaderCreationTime: Date | undefined;
    workActivityStartTime: Date | undefined;
    fullName: string | undefined;
    clientInfo: string | undefined;
    totalQuantity: number;
    collectedQuantity: number;
    diffQuantity: number;

    constructor(data?: IInstantOrderTrackingReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseName = _data["warehouseName"];
            this.controlPoint = _data["controlPoint"];
            this.workActivityCode = _data["workActivityCode"];
            this.orderHeaderDocumentNo = _data["orderHeaderDocumentNo"];
            this.orderHeaderCreationTime = _data["orderHeaderCreationTime"] ? new Date(_data["orderHeaderCreationTime"].toString()) : <any>undefined;
            this.workActivityStartTime = _data["workActivityStartTime"] ? new Date(_data["workActivityStartTime"].toString()) : <any>undefined;
            this.fullName = _data["fullName"];
            this.clientInfo = _data["clientInfo"];
            this.totalQuantity = _data["totalQuantity"];
            this.collectedQuantity = _data["collectedQuantity"];
            this.diffQuantity = _data["diffQuantity"];
        }
    }

    static fromJS(data: any): InstantOrderTrackingReport {
        data = typeof data === 'object' ? data : {};
        let result = new InstantOrderTrackingReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseName"] = this.warehouseName;
        data["controlPoint"] = this.controlPoint;
        data["workActivityCode"] = this.workActivityCode;
        data["orderHeaderDocumentNo"] = this.orderHeaderDocumentNo;
        data["orderHeaderCreationTime"] = this.orderHeaderCreationTime ? this.orderHeaderCreationTime.toISOString() : <any>undefined;
        data["workActivityStartTime"] = this.workActivityStartTime ? this.workActivityStartTime.toISOString() : <any>undefined;
        data["fullName"] = this.fullName;
        data["clientInfo"] = this.clientInfo;
        data["totalQuantity"] = this.totalQuantity;
        data["collectedQuantity"] = this.collectedQuantity;
        data["diffQuantity"] = this.diffQuantity;
        return data;
    }

    clone(): InstantOrderTrackingReport {
        const json = this.toJSON();
        let result = new InstantOrderTrackingReport();
        result.init(json);
        return result;
    }
}

export interface IInstantOrderTrackingReport {
    warehouseName: string | undefined;
    controlPoint: string | undefined;
    workActivityCode: string | undefined;
    orderHeaderDocumentNo: string | undefined;
    orderHeaderCreationTime: Date | undefined;
    workActivityStartTime: Date | undefined;
    fullName: string | undefined;
    clientInfo: string | undefined;
    totalQuantity: number;
    collectedQuantity: number;
    diffQuantity: number;
}

export class OrderHeaderPdaDto implements IOrderHeaderPdaDto {
    company: CompanyDto;
    client: ClientSmallDto;
    warehouse: WarehouseDto;
    documentNo: string | undefined;
    documentDate: Date;
    notes: string | undefined;
    detailCount: number;
    isLocked: boolean;
    quantityPackage: number;
    shippingType: ShippingType;
    controlPoint: ControlPoint;
    collectPoint: string | undefined;
    id: number;

    constructor(data?: IOrderHeaderPdaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.client = _data["client"] ? ClientSmallDto.fromJS(_data["client"]) : <any>undefined;
            this.warehouse = _data["warehouse"] ? WarehouseDto.fromJS(_data["warehouse"]) : <any>undefined;
            this.documentNo = _data["documentNo"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.detailCount = _data["detailCount"];
            this.isLocked = _data["isLocked"];
            this.quantityPackage = _data["quantityPackage"];
            this.shippingType = _data["shippingType"] ? ShippingType.fromJS(_data["shippingType"]) : <any>undefined;
            this.controlPoint = _data["controlPoint"] ? ControlPoint.fromJS(_data["controlPoint"]) : <any>undefined;
            this.collectPoint = _data["collectPoint"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderHeaderPdaDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderPdaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["documentNo"] = this.documentNo;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["detailCount"] = this.detailCount;
        data["isLocked"] = this.isLocked;
        data["quantityPackage"] = this.quantityPackage;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : <any>undefined;
        data["controlPoint"] = this.controlPoint ? this.controlPoint.toJSON() : <any>undefined;
        data["collectPoint"] = this.collectPoint;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderHeaderPdaDto {
        const json = this.toJSON();
        let result = new OrderHeaderPdaDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderPdaDto {
    company: CompanyDto;
    client: ClientSmallDto;
    warehouse: WarehouseDto;
    documentNo: string | undefined;
    documentDate: Date;
    notes: string | undefined;
    detailCount: number;
    isLocked: boolean;
    quantityPackage: number;
    shippingType: ShippingType;
    controlPoint: ControlPoint;
    collectPoint: string | undefined;
    id: number;
}

export class CrossDockCheckResponseDto implements ICrossDockCheckResponseDto {
    quantity: number;
    orderHeader: OrderHeaderPdaDto;
    id: number;

    constructor(data?: ICrossDockCheckResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.orderHeader = _data["orderHeader"] ? OrderHeaderPdaDto.fromJS(_data["orderHeader"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CrossDockCheckResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CrossDockCheckResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["orderHeader"] = this.orderHeader ? this.orderHeader.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): CrossDockCheckResponseDto {
        const json = this.toJSON();
        let result = new CrossDockCheckResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICrossDockCheckResponseDto {
    quantity: number;
    orderHeader: OrderHeaderPdaDto;
    id: number;
}

export class OrderFinishedCountForCtrlPntDto implements IOrderFinishedCountForCtrlPntDto {
    totalQuantity: number;
    totalRows: number;
    orderCount: number;

    constructor(data?: IOrderFinishedCountForCtrlPntDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalQuantity = _data["totalQuantity"];
            this.totalRows = _data["totalRows"];
            this.orderCount = _data["orderCount"];
        }
    }

    static fromJS(data: any): OrderFinishedCountForCtrlPntDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFinishedCountForCtrlPntDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalQuantity"] = this.totalQuantity;
        data["totalRows"] = this.totalRows;
        data["orderCount"] = this.orderCount;
        return data;
    }

    clone(): OrderFinishedCountForCtrlPntDto {
        const json = this.toJSON();
        let result = new OrderFinishedCountForCtrlPntDto();
        result.init(json);
        return result;
    }
}

export interface IOrderFinishedCountForCtrlPntDto {
    totalQuantity: number;
    totalRows: number;
    orderCount: number;
}

export class ProductionRecipeHeader implements IProductionRecipeHeader {
    company: Company;
    companyId: number;
    code: string;
    definition: string;
    explanation: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProductionRecipeHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.company = new Company();
            this.code = "";
            this.definition = "";
            this.explanation = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.companyId = _data["companyId"];
            this.code = _data["code"] !== undefined ? _data["code"] : "";
            this.definition = _data["definition"] !== undefined ? _data["definition"] : "";
            this.explanation = _data["explanation"] !== undefined ? _data["explanation"] : "";
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductionRecipeHeader {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionRecipeHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["explanation"] = this.explanation;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductionRecipeHeader {
        const json = this.toJSON();
        let result = new ProductionRecipeHeader();
        result.init(json);
        return result;
    }
}

export interface IProductionRecipeHeader {
    company: Company;
    companyId: number;
    code: string;
    definition: string;
    explanation: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderDetail implements IOrderDetail {
    erpEntegreId: string | undefined;
    orderHeader: OrderHeader;
    orderHeaderId: number;
    product: Product;
    productId: number;
    productionRecipeHeader: ProductionRecipeHeader;
    productionRecipeHeaderId: number | undefined;
    productCode: string | undefined;
    quantity: number;
    quantityKit: number;
    quantityOrj: number;
    quantityCollected: number;
    quantityShipped: number;
    isLocked: boolean;
    controlDoubleClick: boolean;
    noteDeficiency: string | undefined;
    crossDockRequestId: number;
    quantityForReplace: number;
    quantityReplaced: number;
    priceNet: number;
    currency: string | undefined;
    currencyRate: number;
    noteDeficiencyUser: User;
    firstPickTime: Date | undefined;
    lastPickTime: Date | undefined;
    firstControlTime: Date | undefined;
    lastControlTime: Date | undefined;
    isCompletedCollect: boolean;
    quantityDiff: number;
    quantityNeedToCollect: number;
    isCompletedShipment: boolean;
    quantityForControl: number;
    quantityNeedToReplace: number;
    isCompletedReplacement: boolean;
    totalPickMinute: number;
    totalControlMinute: number;
    totalProcessMinute: number;
    isShattered: boolean;
    shatteredOrderDetailId: number | undefined;
    workActivityId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orderHeader = new OrderHeader();
            this.product = new Product();
            this.productCode = "";
            this.quantityCollected = 0;
            this.quantityShipped = 0;
            this.isLocked = false;
            this.controlDoubleClick = false;
            this.crossDockRequestId = 0;
            this.quantityForReplace = 0;
            this.quantityReplaced = 0;
            this.priceNet = 0;
            this.currency = "";
            this.currencyRate = 1;
            this.isShattered = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.erpEntegreId = _data["erpEntegreId"];
            this.orderHeader = _data["orderHeader"] ? OrderHeader.fromJS(_data["orderHeader"]) : new OrderHeader();
            this.orderHeaderId = _data["orderHeaderId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : new Product();
            this.productId = _data["productId"];
            this.productionRecipeHeader = _data["productionRecipeHeader"] ? ProductionRecipeHeader.fromJS(_data["productionRecipeHeader"]) : <any>undefined;
            this.productionRecipeHeaderId = _data["productionRecipeHeaderId"];
            this.productCode = _data["productCode"] !== undefined ? _data["productCode"] : "";
            this.quantity = _data["quantity"];
            this.quantityKit = _data["quantityKit"];
            this.quantityOrj = _data["quantityOrj"];
            this.quantityCollected = _data["quantityCollected"] !== undefined ? _data["quantityCollected"] : 0;
            this.quantityShipped = _data["quantityShipped"] !== undefined ? _data["quantityShipped"] : 0;
            this.isLocked = _data["isLocked"] !== undefined ? _data["isLocked"] : false;
            this.controlDoubleClick = _data["controlDoubleClick"] !== undefined ? _data["controlDoubleClick"] : false;
            this.noteDeficiency = _data["noteDeficiency"];
            this.crossDockRequestId = _data["crossDockRequestId"] !== undefined ? _data["crossDockRequestId"] : 0;
            this.quantityForReplace = _data["quantityForReplace"] !== undefined ? _data["quantityForReplace"] : 0;
            this.quantityReplaced = _data["quantityReplaced"] !== undefined ? _data["quantityReplaced"] : 0;
            this.priceNet = _data["priceNet"] !== undefined ? _data["priceNet"] : 0;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : "";
            this.currencyRate = _data["currencyRate"] !== undefined ? _data["currencyRate"] : 1;
            this.noteDeficiencyUser = _data["noteDeficiencyUser"] ? User.fromJS(_data["noteDeficiencyUser"]) : <any>undefined;
            this.firstPickTime = _data["firstPickTime"] ? new Date(_data["firstPickTime"].toString()) : <any>undefined;
            this.lastPickTime = _data["lastPickTime"] ? new Date(_data["lastPickTime"].toString()) : <any>undefined;
            this.firstControlTime = _data["firstControlTime"] ? new Date(_data["firstControlTime"].toString()) : <any>undefined;
            this.lastControlTime = _data["lastControlTime"] ? new Date(_data["lastControlTime"].toString()) : <any>undefined;
            this.isCompletedCollect = _data["isCompletedCollect"];
            this.quantityDiff = _data["quantityDiff"];
            this.quantityNeedToCollect = _data["quantityNeedToCollect"];
            this.isCompletedShipment = _data["isCompletedShipment"];
            this.quantityForControl = _data["quantityForControl"];
            this.quantityNeedToReplace = _data["quantityNeedToReplace"];
            this.isCompletedReplacement = _data["isCompletedReplacement"];
            this.totalPickMinute = _data["totalPickMinute"];
            this.totalControlMinute = _data["totalControlMinute"];
            this.totalProcessMinute = _data["totalProcessMinute"];
            this.isShattered = _data["isShattered"] !== undefined ? _data["isShattered"] : false;
            this.shatteredOrderDetailId = _data["shatteredOrderDetailId"];
            this.workActivityId = _data["workActivityId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDetail {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["erpEntegreId"] = this.erpEntegreId;
        data["orderHeader"] = this.orderHeader ? this.orderHeader.toJSON() : <any>undefined;
        data["orderHeaderId"] = this.orderHeaderId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["productionRecipeHeader"] = this.productionRecipeHeader ? this.productionRecipeHeader.toJSON() : <any>undefined;
        data["productionRecipeHeaderId"] = this.productionRecipeHeaderId;
        data["productCode"] = this.productCode;
        data["quantity"] = this.quantity;
        data["quantityKit"] = this.quantityKit;
        data["quantityOrj"] = this.quantityOrj;
        data["quantityCollected"] = this.quantityCollected;
        data["quantityShipped"] = this.quantityShipped;
        data["isLocked"] = this.isLocked;
        data["controlDoubleClick"] = this.controlDoubleClick;
        data["noteDeficiency"] = this.noteDeficiency;
        data["crossDockRequestId"] = this.crossDockRequestId;
        data["quantityForReplace"] = this.quantityForReplace;
        data["quantityReplaced"] = this.quantityReplaced;
        data["priceNet"] = this.priceNet;
        data["currency"] = this.currency;
        data["currencyRate"] = this.currencyRate;
        data["noteDeficiencyUser"] = this.noteDeficiencyUser ? this.noteDeficiencyUser.toJSON() : <any>undefined;
        data["firstPickTime"] = this.firstPickTime ? this.firstPickTime.toISOString() : <any>undefined;
        data["lastPickTime"] = this.lastPickTime ? this.lastPickTime.toISOString() : <any>undefined;
        data["firstControlTime"] = this.firstControlTime ? this.firstControlTime.toISOString() : <any>undefined;
        data["lastControlTime"] = this.lastControlTime ? this.lastControlTime.toISOString() : <any>undefined;
        data["isCompletedCollect"] = this.isCompletedCollect;
        data["quantityDiff"] = this.quantityDiff;
        data["quantityNeedToCollect"] = this.quantityNeedToCollect;
        data["isCompletedShipment"] = this.isCompletedShipment;
        data["quantityForControl"] = this.quantityForControl;
        data["quantityNeedToReplace"] = this.quantityNeedToReplace;
        data["isCompletedReplacement"] = this.isCompletedReplacement;
        data["totalPickMinute"] = this.totalPickMinute;
        data["totalControlMinute"] = this.totalControlMinute;
        data["totalProcessMinute"] = this.totalProcessMinute;
        data["isShattered"] = this.isShattered;
        data["shatteredOrderDetailId"] = this.shatteredOrderDetailId;
        data["workActivityId"] = this.workActivityId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderDetail {
        const json = this.toJSON();
        let result = new OrderDetail();
        result.init(json);
        return result;
    }
}

export interface IOrderDetail {
    erpEntegreId: string | undefined;
    orderHeader: OrderHeader;
    orderHeaderId: number;
    product: Product;
    productId: number;
    productionRecipeHeader: ProductionRecipeHeader;
    productionRecipeHeaderId: number | undefined;
    productCode: string | undefined;
    quantity: number;
    quantityKit: number;
    quantityOrj: number;
    quantityCollected: number;
    quantityShipped: number;
    isLocked: boolean;
    controlDoubleClick: boolean;
    noteDeficiency: string | undefined;
    crossDockRequestId: number;
    quantityForReplace: number;
    quantityReplaced: number;
    priceNet: number;
    currency: string | undefined;
    currencyRate: number;
    noteDeficiencyUser: User;
    firstPickTime: Date | undefined;
    lastPickTime: Date | undefined;
    firstControlTime: Date | undefined;
    lastControlTime: Date | undefined;
    isCompletedCollect: boolean;
    quantityDiff: number;
    quantityNeedToCollect: number;
    isCompletedShipment: boolean;
    quantityForControl: number;
    quantityNeedToReplace: number;
    isCompletedReplacement: boolean;
    totalPickMinute: number;
    totalControlMinute: number;
    totalProcessMinute: number;
    isShattered: boolean;
    shatteredOrderDetailId: number | undefined;
    workActivityId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class CrossDockRequest implements ICrossDockRequest {
    orderDetail: OrderDetail;
    orderDetailId: number;
    quantity: number;
    quantityProcessed: number;
    isFinished: boolean;
    quantityNeed: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICrossDockRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orderDetail = new OrderDetail();
            this.quantityProcessed = 0;
            this.isFinished = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderDetail = _data["orderDetail"] ? OrderDetail.fromJS(_data["orderDetail"]) : new OrderDetail();
            this.orderDetailId = _data["orderDetailId"];
            this.quantity = _data["quantity"];
            this.quantityProcessed = _data["quantityProcessed"] !== undefined ? _data["quantityProcessed"] : 0;
            this.isFinished = _data["isFinished"] !== undefined ? _data["isFinished"] : false;
            this.quantityNeed = _data["quantityNeed"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CrossDockRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CrossDockRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderDetail"] = this.orderDetail ? this.orderDetail.toJSON() : <any>undefined;
        data["orderDetailId"] = this.orderDetailId;
        data["quantity"] = this.quantity;
        data["quantityProcessed"] = this.quantityProcessed;
        data["isFinished"] = this.isFinished;
        data["quantityNeed"] = this.quantityNeed;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CrossDockRequest {
        const json = this.toJSON();
        let result = new CrossDockRequest();
        result.init(json);
        return result;
    }
}

export interface ICrossDockRequest {
    orderDetail: OrderDetail;
    orderDetailId: number;
    quantity: number;
    quantityProcessed: number;
    isFinished: boolean;
    quantityNeed: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class CrossDockRequestDto implements ICrossDockRequestDto {
    orderDetail: OrderDetail;
    quantity: number;
    quantityProcessed: number;
    isFinished: boolean;
    readonly quantityNeed: number;
    quantityStorage: number;
    id: number;

    constructor(data?: ICrossDockRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderDetail = _data["orderDetail"] ? OrderDetail.fromJS(_data["orderDetail"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.quantityProcessed = _data["quantityProcessed"];
            this.isFinished = _data["isFinished"];
            (<any>this).quantityNeed = _data["quantityNeed"];
            this.quantityStorage = _data["quantityStorage"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CrossDockRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CrossDockRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderDetail"] = this.orderDetail ? this.orderDetail.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["quantityProcessed"] = this.quantityProcessed;
        data["isFinished"] = this.isFinished;
        data["quantityNeed"] = this.quantityNeed;
        data["quantityStorage"] = this.quantityStorage;
        data["id"] = this.id;
        return data;
    }

    clone(): CrossDockRequestDto {
        const json = this.toJSON();
        let result = new CrossDockRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICrossDockRequestDto {
    orderDetail: OrderDetail;
    quantity: number;
    quantityProcessed: number;
    isFinished: boolean;
    quantityNeed: number;
    quantityStorage: number;
    id: number;
}

export class CrossDockRequestDtoPagedResultDto implements ICrossDockRequestDtoPagedResultDto {
    totalCount: number;
    items: CrossDockRequestDto[] | undefined;

    constructor(data?: ICrossDockRequestDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CrossDockRequestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CrossDockRequestDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CrossDockRequestDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CrossDockRequestDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CrossDockRequestDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICrossDockRequestDtoPagedResultDto {
    totalCount: number;
    items: CrossDockRequestDto[] | undefined;
}

export class OrderHeaderPendingDto implements IOrderHeaderPendingDto {
    client: Client;
    product: Product;
    productId: number;
    quantityOrderHeader: number;
    quantityOrderDetail: number;
    quantityProduct: number;
    quantityShipped: number;
    readonly quantityDiff: number;
    transferType: string | undefined;
    readonly quantityProductPerOrderHeader: number;
    quantityApprovedOrderDetail: number;
    totalQuantityOrderHeader: number;
    totalQuantityOrderDetail: number;
    totalQuantityProduct: number;

    constructor(data?: IOrderHeaderPendingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.productId = _data["productId"];
            this.quantityOrderHeader = _data["quantityOrderHeader"];
            this.quantityOrderDetail = _data["quantityOrderDetail"];
            this.quantityProduct = _data["quantityProduct"];
            this.quantityShipped = _data["quantityShipped"];
            (<any>this).quantityDiff = _data["quantityDiff"];
            this.transferType = _data["transferType"];
            (<any>this).quantityProductPerOrderHeader = _data["quantityProductPerOrderHeader"];
            this.quantityApprovedOrderDetail = _data["quantityApprovedOrderDetail"];
            this.totalQuantityOrderHeader = _data["totalQuantityOrderHeader"];
            this.totalQuantityOrderDetail = _data["totalQuantityOrderDetail"];
            this.totalQuantityProduct = _data["totalQuantityProduct"];
        }
    }

    static fromJS(data: any): OrderHeaderPendingDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderPendingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["quantityOrderHeader"] = this.quantityOrderHeader;
        data["quantityOrderDetail"] = this.quantityOrderDetail;
        data["quantityProduct"] = this.quantityProduct;
        data["quantityShipped"] = this.quantityShipped;
        data["quantityDiff"] = this.quantityDiff;
        data["transferType"] = this.transferType;
        data["quantityProductPerOrderHeader"] = this.quantityProductPerOrderHeader;
        data["quantityApprovedOrderDetail"] = this.quantityApprovedOrderDetail;
        data["totalQuantityOrderHeader"] = this.totalQuantityOrderHeader;
        data["totalQuantityOrderDetail"] = this.totalQuantityOrderDetail;
        data["totalQuantityProduct"] = this.totalQuantityProduct;
        return data;
    }

    clone(): OrderHeaderPendingDto {
        const json = this.toJSON();
        let result = new OrderHeaderPendingDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderPendingDto {
    client: Client;
    product: Product;
    productId: number;
    quantityOrderHeader: number;
    quantityOrderDetail: number;
    quantityProduct: number;
    quantityShipped: number;
    quantityDiff: number;
    transferType: string | undefined;
    quantityProductPerOrderHeader: number;
    quantityApprovedOrderDetail: number;
    totalQuantityOrderHeader: number;
    totalQuantityOrderDetail: number;
    totalQuantityProduct: number;
}

export class OrderHeaderPendingDtoPagedResultDto implements IOrderHeaderPendingDtoPagedResultDto {
    totalCount: number;
    items: OrderHeaderPendingDto[] | undefined;

    constructor(data?: IOrderHeaderPendingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderHeaderPendingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderHeaderPendingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderPendingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderHeaderPendingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderHeaderPendingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderPendingDtoPagedResultDto {
    totalCount: number;
    items: OrderHeaderPendingDto[] | undefined;
}

export class ProductTransferListDapper implements IProductTransferListDapper {
    manufacturerCode: string | undefined;
    productCode: string | undefined;
    transferType: string | undefined;
    quantityProduct: number;
    overall_count: number;

    constructor(data?: IProductTransferListDapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerCode = _data["manufacturerCode"];
            this.productCode = _data["productCode"];
            this.transferType = _data["transferType"];
            this.quantityProduct = _data["quantityProduct"];
            this.overall_count = _data["overall_count"];
        }
    }

    static fromJS(data: any): ProductTransferListDapper {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTransferListDapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerCode"] = this.manufacturerCode;
        data["productCode"] = this.productCode;
        data["transferType"] = this.transferType;
        data["quantityProduct"] = this.quantityProduct;
        data["overall_count"] = this.overall_count;
        return data;
    }

    clone(): ProductTransferListDapper {
        const json = this.toJSON();
        let result = new ProductTransferListDapper();
        result.init(json);
        return result;
    }
}

export interface IProductTransferListDapper {
    manufacturerCode: string | undefined;
    productCode: string | undefined;
    transferType: string | undefined;
    quantityProduct: number;
    overall_count: number;
}

export class ProductTransferListDapperPagedResultDto implements IProductTransferListDapperPagedResultDto {
    totalCount: number;
    items: ProductTransferListDapper[] | undefined;

    constructor(data?: IProductTransferListDapperPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductTransferListDapper.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductTransferListDapperPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTransferListDapperPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductTransferListDapperPagedResultDto {
        const json = this.toJSON();
        let result = new ProductTransferListDapperPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductTransferListDapperPagedResultDto {
    totalCount: number;
    items: ProductTransferListDapper[] | undefined;
}

export class OrderDetailListClientDapper implements IOrderDetailListClientDapper {
    productCode: string | undefined;
    clientCode: string | undefined;
    manufacturerCode: string | undefined;
    clientName: string | undefined;
    quantityShipped: number;
    quantityProduct: number;
    overall_count: number;
    readonly quantityDiff: number;

    constructor(data?: IOrderDetailListClientDapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.clientCode = _data["clientCode"];
            this.manufacturerCode = _data["manufacturerCode"];
            this.clientName = _data["clientName"];
            this.quantityShipped = _data["quantityShipped"];
            this.quantityProduct = _data["quantityProduct"];
            this.overall_count = _data["overall_count"];
            (<any>this).quantityDiff = _data["quantityDiff"];
        }
    }

    static fromJS(data: any): OrderDetailListClientDapper {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailListClientDapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["clientCode"] = this.clientCode;
        data["manufacturerCode"] = this.manufacturerCode;
        data["clientName"] = this.clientName;
        data["quantityShipped"] = this.quantityShipped;
        data["quantityProduct"] = this.quantityProduct;
        data["overall_count"] = this.overall_count;
        data["quantityDiff"] = this.quantityDiff;
        return data;
    }

    clone(): OrderDetailListClientDapper {
        const json = this.toJSON();
        let result = new OrderDetailListClientDapper();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailListClientDapper {
    productCode: string | undefined;
    clientCode: string | undefined;
    manufacturerCode: string | undefined;
    clientName: string | undefined;
    quantityShipped: number;
    quantityProduct: number;
    overall_count: number;
    quantityDiff: number;
}

export class OrderDetailListClientDapperPagedResultDto implements IOrderDetailListClientDapperPagedResultDto {
    totalCount: number;
    items: OrderDetailListClientDapper[] | undefined;

    constructor(data?: IOrderDetailListClientDapperPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderDetailListClientDapper.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderDetailListClientDapperPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailListClientDapperPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderDetailListClientDapperPagedResultDto {
        const json = this.toJSON();
        let result = new OrderDetailListClientDapperPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailListClientDapperPagedResultDto {
    totalCount: number;
    items: OrderDetailListClientDapper[] | undefined;
}

export class ClientTransferListDapper implements IClientTransferListDapper {
    clientId: number;
    clientCode: string | undefined;
    transferType: string | undefined;
    clientName: string | undefined;
    quantityShipped: number;
    quantityProduct: number;
    overall_count: number;
    readonly quantityDiff: number;

    constructor(data?: IClientTransferListDapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientCode = _data["clientCode"];
            this.transferType = _data["transferType"];
            this.clientName = _data["clientName"];
            this.quantityShipped = _data["quantityShipped"];
            this.quantityProduct = _data["quantityProduct"];
            this.overall_count = _data["overall_count"];
            (<any>this).quantityDiff = _data["quantityDiff"];
        }
    }

    static fromJS(data: any): ClientTransferListDapper {
        data = typeof data === 'object' ? data : {};
        let result = new ClientTransferListDapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientCode"] = this.clientCode;
        data["transferType"] = this.transferType;
        data["clientName"] = this.clientName;
        data["quantityShipped"] = this.quantityShipped;
        data["quantityProduct"] = this.quantityProduct;
        data["overall_count"] = this.overall_count;
        data["quantityDiff"] = this.quantityDiff;
        return data;
    }

    clone(): ClientTransferListDapper {
        const json = this.toJSON();
        let result = new ClientTransferListDapper();
        result.init(json);
        return result;
    }
}

export interface IClientTransferListDapper {
    clientId: number;
    clientCode: string | undefined;
    transferType: string | undefined;
    clientName: string | undefined;
    quantityShipped: number;
    quantityProduct: number;
    overall_count: number;
    quantityDiff: number;
}

export class ClientTransferListDapperPagedResultDto implements IClientTransferListDapperPagedResultDto {
    totalCount: number;
    items: ClientTransferListDapper[] | undefined;

    constructor(data?: IClientTransferListDapperPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ClientTransferListDapper.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientTransferListDapperPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientTransferListDapperPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ClientTransferListDapperPagedResultDto {
        const json = this.toJSON();
        let result = new ClientTransferListDapperPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IClientTransferListDapperPagedResultDto {
    totalCount: number;
    items: ClientTransferListDapper[] | undefined;
}

export class OrderHeaderPendingReportDto implements IOrderHeaderPendingReportDto {
    productCode: string | undefined;
    productId: number;
    quantityOrderHeader: number;
    quantityOrderDetail: number;
    quantityProduct: number;
    quantityShipped: number;
    readonly quantityDiff: number;
    transferType: string | undefined;
    readonly quantityProductPerOrderHeader: number;
    quantityApprovedOrderDetail: number;
    totalQuantityOrderHeader: number;
    totalQuantityOrderDetail: number;
    totalQuantityProduct: number;

    constructor(data?: IOrderHeaderPendingReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productId = _data["productId"];
            this.quantityOrderHeader = _data["quantityOrderHeader"];
            this.quantityOrderDetail = _data["quantityOrderDetail"];
            this.quantityProduct = _data["quantityProduct"];
            this.quantityShipped = _data["quantityShipped"];
            (<any>this).quantityDiff = _data["quantityDiff"];
            this.transferType = _data["transferType"];
            (<any>this).quantityProductPerOrderHeader = _data["quantityProductPerOrderHeader"];
            this.quantityApprovedOrderDetail = _data["quantityApprovedOrderDetail"];
            this.totalQuantityOrderHeader = _data["totalQuantityOrderHeader"];
            this.totalQuantityOrderDetail = _data["totalQuantityOrderDetail"];
            this.totalQuantityProduct = _data["totalQuantityProduct"];
        }
    }

    static fromJS(data: any): OrderHeaderPendingReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderPendingReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productId"] = this.productId;
        data["quantityOrderHeader"] = this.quantityOrderHeader;
        data["quantityOrderDetail"] = this.quantityOrderDetail;
        data["quantityProduct"] = this.quantityProduct;
        data["quantityShipped"] = this.quantityShipped;
        data["quantityDiff"] = this.quantityDiff;
        data["transferType"] = this.transferType;
        data["quantityProductPerOrderHeader"] = this.quantityProductPerOrderHeader;
        data["quantityApprovedOrderDetail"] = this.quantityApprovedOrderDetail;
        data["totalQuantityOrderHeader"] = this.totalQuantityOrderHeader;
        data["totalQuantityOrderDetail"] = this.totalQuantityOrderDetail;
        data["totalQuantityProduct"] = this.totalQuantityProduct;
        return data;
    }

    clone(): OrderHeaderPendingReportDto {
        const json = this.toJSON();
        let result = new OrderHeaderPendingReportDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderPendingReportDto {
    productCode: string | undefined;
    productId: number;
    quantityOrderHeader: number;
    quantityOrderDetail: number;
    quantityProduct: number;
    quantityShipped: number;
    quantityDiff: number;
    transferType: string | undefined;
    quantityProductPerOrderHeader: number;
    quantityApprovedOrderDetail: number;
    totalQuantityOrderHeader: number;
    totalQuantityOrderDetail: number;
    totalQuantityProduct: number;
}

export class OrderHeaderPendingReportDtoPagedResultDto implements IOrderHeaderPendingReportDtoPagedResultDto {
    totalCount: number;
    items: OrderHeaderPendingReportDto[] | undefined;

    constructor(data?: IOrderHeaderPendingReportDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderHeaderPendingReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderHeaderPendingReportDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderPendingReportDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderHeaderPendingReportDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderHeaderPendingReportDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderPendingReportDtoPagedResultDto {
    totalCount: number;
    items: OrderHeaderPendingReportDto[] | undefined;
}

export class OrderHeaderCollectedDto implements IOrderHeaderCollectedDto {
    company: Company;
    client: ClientDto;
    warehouse: Warehouse;
    companyDataSourceId: number;
    orderHeaderNo: string | undefined;
    workActivity: WorkActivityDto;
    orderDocumentNo: string | undefined;
    documentNo: string | undefined;
    documentDate: Date;
    startDate: Date;
    finishDate: Date;
    creationTime: Date;
    isStarted: boolean;
    isFinished: boolean;
    isShipped: boolean;
    quantity: number;
    quantityOrderDetail: number;
    quantityOrderDetailCollected: number;
    quantityCollected: number;
    readonly quantityOrderDetailDiff: number;
    readonly quantityCollctedDiff: number;
    id: number;

    constructor(data?: IOrderHeaderCollectedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.client = _data["client"] ? ClientDto.fromJS(_data["client"]) : <any>undefined;
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.companyDataSourceId = _data["companyDataSourceId"];
            this.orderHeaderNo = _data["orderHeaderNo"];
            this.workActivity = _data["workActivity"] ? WorkActivityDto.fromJS(_data["workActivity"]) : <any>undefined;
            this.orderDocumentNo = _data["orderDocumentNo"];
            this.documentNo = _data["documentNo"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.finishDate = _data["finishDate"] ? new Date(_data["finishDate"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.isStarted = _data["isStarted"];
            this.isFinished = _data["isFinished"];
            this.isShipped = _data["isShipped"];
            this.quantity = _data["quantity"];
            this.quantityOrderDetail = _data["quantityOrderDetail"];
            this.quantityOrderDetailCollected = _data["quantityOrderDetailCollected"];
            this.quantityCollected = _data["quantityCollected"];
            (<any>this).quantityOrderDetailDiff = _data["quantityOrderDetailDiff"];
            (<any>this).quantityCollctedDiff = _data["quantityCollctedDiff"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderHeaderCollectedDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderCollectedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["companyDataSourceId"] = this.companyDataSourceId;
        data["orderHeaderNo"] = this.orderHeaderNo;
        data["workActivity"] = this.workActivity ? this.workActivity.toJSON() : <any>undefined;
        data["orderDocumentNo"] = this.orderDocumentNo;
        data["documentNo"] = this.documentNo;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["finishDate"] = this.finishDate ? this.finishDate.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["isShipped"] = this.isShipped;
        data["quantity"] = this.quantity;
        data["quantityOrderDetail"] = this.quantityOrderDetail;
        data["quantityOrderDetailCollected"] = this.quantityOrderDetailCollected;
        data["quantityCollected"] = this.quantityCollected;
        data["quantityOrderDetailDiff"] = this.quantityOrderDetailDiff;
        data["quantityCollctedDiff"] = this.quantityCollctedDiff;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderHeaderCollectedDto {
        const json = this.toJSON();
        let result = new OrderHeaderCollectedDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderCollectedDto {
    company: Company;
    client: ClientDto;
    warehouse: Warehouse;
    companyDataSourceId: number;
    orderHeaderNo: string | undefined;
    workActivity: WorkActivityDto;
    orderDocumentNo: string | undefined;
    documentNo: string | undefined;
    documentDate: Date;
    startDate: Date;
    finishDate: Date;
    creationTime: Date;
    isStarted: boolean;
    isFinished: boolean;
    isShipped: boolean;
    quantity: number;
    quantityOrderDetail: number;
    quantityOrderDetailCollected: number;
    quantityCollected: number;
    quantityOrderDetailDiff: number;
    quantityCollctedDiff: number;
    id: number;
}

export class OrderHeaderCollectedDtoPagedResultDto implements IOrderHeaderCollectedDtoPagedResultDto {
    totalCount: number;
    items: OrderHeaderCollectedDto[] | undefined;

    constructor(data?: IOrderHeaderCollectedDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderHeaderCollectedDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderHeaderCollectedDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderCollectedDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderHeaderCollectedDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderHeaderCollectedDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderCollectedDtoPagedResultDto {
    totalCount: number;
    items: OrderHeaderCollectedDto[] | undefined;
}

export class OrderDetailDtoPagedResultDto implements IOrderDetailDtoPagedResultDto {
    totalCount: number;
    items: OrderDetailDto[] | undefined;

    constructor(data?: IOrderDetailDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderDetailDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderDetailDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderDetailDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailDtoPagedResultDto {
    totalCount: number;
    items: OrderDetailDto[] | undefined;
}

export class OrderHeaderInvoiceDto implements IOrderHeaderInvoiceDto {
    orderHeader: OrderHeaderDto;
    message: string | undefined;
    id: number;

    constructor(data?: IOrderHeaderInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderHeader = _data["orderHeader"] ? OrderHeaderDto.fromJS(_data["orderHeader"]) : <any>undefined;
            this.message = _data["message"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderHeaderInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderHeader"] = this.orderHeader ? this.orderHeader.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderHeaderInvoiceDto {
        const json = this.toJSON();
        let result = new OrderHeaderInvoiceDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderInvoiceDto {
    orderHeader: OrderHeaderDto;
    message: string | undefined;
    id: number;
}

export class OrderHeaderInvoiceDtoPagedResultDto implements IOrderHeaderInvoiceDtoPagedResultDto {
    totalCount: number;
    items: OrderHeaderInvoiceDto[] | undefined;

    constructor(data?: IOrderHeaderInvoiceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderHeaderInvoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderHeaderInvoiceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderInvoiceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderHeaderInvoiceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderHeaderInvoiceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderInvoiceDtoPagedResultDto {
    totalCount: number;
    items: OrderHeaderInvoiceDto[] | undefined;
}

export class OrderCountByDate implements IOrderCountByDate {
    date: Date;
    count: number;

    constructor(data?: IOrderCountByDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): OrderCountByDate {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCountByDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["count"] = this.count;
        return data;
    }

    clone(): OrderCountByDate {
        const json = this.toJSON();
        let result = new OrderCountByDate();
        result.init(json);
        return result;
    }
}

export interface IOrderCountByDate {
    date: Date;
    count: number;
}

export class OrderHeaderDtoPagedResultDto implements IOrderHeaderDtoPagedResultDto {
    totalCount: number;
    items: OrderHeaderDto[] | undefined;

    constructor(data?: IOrderHeaderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderHeaderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderHeaderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderHeaderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderHeaderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderDtoPagedResultDto {
    totalCount: number;
    items: OrderHeaderDto[] | undefined;
}

export class ShippingTypePriority implements IShippingTypePriority {
    shippingType: ShippingType;
    shippingTypeId: number;
    startHour: number;
    startMinute: number;
    finishHour: number;
    finishMinute: number;
    priority: number;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IShippingTypePriority) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.shippingType = new ShippingType();
            this.priority = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shippingType = _data["shippingType"] ? ShippingType.fromJS(_data["shippingType"]) : new ShippingType();
            this.shippingTypeId = _data["shippingTypeId"];
            this.startHour = _data["startHour"];
            this.startMinute = _data["startMinute"];
            this.finishHour = _data["finishHour"];
            this.finishMinute = _data["finishMinute"];
            this.priority = _data["priority"] !== undefined ? _data["priority"] : 0;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShippingTypePriority {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingTypePriority();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : <any>undefined;
        data["shippingTypeId"] = this.shippingTypeId;
        data["startHour"] = this.startHour;
        data["startMinute"] = this.startMinute;
        data["finishHour"] = this.finishHour;
        data["finishMinute"] = this.finishMinute;
        data["priority"] = this.priority;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ShippingTypePriority {
        const json = this.toJSON();
        let result = new ShippingTypePriority();
        result.init(json);
        return result;
    }
}

export interface IShippingTypePriority {
    shippingType: ShippingType;
    shippingTypeId: number;
    startHour: number;
    startMinute: number;
    finishHour: number;
    finishMinute: number;
    priority: number;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class ShippingTypePriorityPagedResultDto implements IShippingTypePriorityPagedResultDto {
    totalCount: number;
    items: ShippingTypePriority[] | undefined;

    constructor(data?: IShippingTypePriorityPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ShippingTypePriority.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShippingTypePriorityPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingTypePriorityPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ShippingTypePriorityPagedResultDto {
        const json = this.toJSON();
        let result = new ShippingTypePriorityPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IShippingTypePriorityPagedResultDto {
    totalCount: number;
    items: ShippingTypePriority[] | undefined;
}

export class Erp2Wms_BackOrder implements IErp2Wms_BackOrder {
    erpEntegreId: string | undefined;
    clientCode: string | undefined;
    clientName: string | undefined;
    addressNo: number;
    addressLocation: string | undefined;
    orderDate: Date;
    orderNo: string | undefined;
    productCode: string | undefined;
    productName: string | undefined;
    quantiy: number;
    quantityRemaining: number;
    recCount: number;
    id: number;
    isSelected: boolean;
    quantityStorage: number;
    readonly quantityPercent: number;

    constructor(data?: IErp2Wms_BackOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.erpEntegreId = _data["erpEntegreId"];
            this.clientCode = _data["clientCode"];
            this.clientName = _data["clientName"];
            this.addressNo = _data["addressNo"];
            this.addressLocation = _data["addressLocation"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.orderNo = _data["orderNo"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.quantiy = _data["quantiy"];
            this.quantityRemaining = _data["quantityRemaining"];
            this.recCount = _data["recCount"];
            this.id = _data["id"];
            this.isSelected = _data["isSelected"];
            this.quantityStorage = _data["quantityStorage"];
            (<any>this).quantityPercent = _data["quantityPercent"];
        }
    }

    static fromJS(data: any): Erp2Wms_BackOrder {
        data = typeof data === 'object' ? data : {};
        let result = new Erp2Wms_BackOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["erpEntegreId"] = this.erpEntegreId;
        data["clientCode"] = this.clientCode;
        data["clientName"] = this.clientName;
        data["addressNo"] = this.addressNo;
        data["addressLocation"] = this.addressLocation;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["orderNo"] = this.orderNo;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["quantiy"] = this.quantiy;
        data["quantityRemaining"] = this.quantityRemaining;
        data["recCount"] = this.recCount;
        data["id"] = this.id;
        data["isSelected"] = this.isSelected;
        data["quantityStorage"] = this.quantityStorage;
        data["quantityPercent"] = this.quantityPercent;
        return data;
    }

    clone(): Erp2Wms_BackOrder {
        const json = this.toJSON();
        let result = new Erp2Wms_BackOrder();
        result.init(json);
        return result;
    }
}

export interface IErp2Wms_BackOrder {
    erpEntegreId: string | undefined;
    clientCode: string | undefined;
    clientName: string | undefined;
    addressNo: number;
    addressLocation: string | undefined;
    orderDate: Date;
    orderNo: string | undefined;
    productCode: string | undefined;
    productName: string | undefined;
    quantiy: number;
    quantityRemaining: number;
    recCount: number;
    id: number;
    isSelected: boolean;
    quantityStorage: number;
    quantityPercent: number;
}

export class PickingCart implements IPickingCart {
    warehouse: Warehouse;
    warehouseId: number;
    code: string;
    definition: string;
    isInUse: boolean;
    id: number;

    constructor(data?: IPickingCart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.warehouse = new Warehouse();
            this.code = "";
            this.definition = "";
            this.isInUse = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.warehouseId = _data["warehouseId"];
            this.code = _data["code"] !== undefined ? _data["code"] : "";
            this.definition = _data["definition"] !== undefined ? _data["definition"] : "";
            this.isInUse = _data["isInUse"] !== undefined ? _data["isInUse"] : false;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PickingCart {
        data = typeof data === 'object' ? data : {};
        let result = new PickingCart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["isInUse"] = this.isInUse;
        data["id"] = this.id;
        return data;
    }

    clone(): PickingCart {
        const json = this.toJSON();
        let result = new PickingCart();
        result.init(json);
        return result;
    }
}

export interface IPickingCart {
    warehouse: Warehouse;
    warehouseId: number;
    code: string;
    definition: string;
    isInUse: boolean;
    id: number;
}

export class PickingCartConnection implements IPickingCartConnection {
    pickingCart: PickingCart;
    pickingCartId: number;
    warehouse: Warehouse;
    warehouseId: number;
    workAction: WorkAction;
    workActionId: number;
    finishTime: Date | undefined;
    floor: string | undefined;
    isStarted: boolean;
    isFinished: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPickingCartConnection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pickingCart = new PickingCart();
            this.warehouse = new Warehouse();
            this.workAction = new WorkAction();
            this.isStarted = false;
            this.isFinished = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pickingCart = _data["pickingCart"] ? PickingCart.fromJS(_data["pickingCart"]) : new PickingCart();
            this.pickingCartId = _data["pickingCartId"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.warehouseId = _data["warehouseId"];
            this.workAction = _data["workAction"] ? WorkAction.fromJS(_data["workAction"]) : new WorkAction();
            this.workActionId = _data["workActionId"];
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : <any>undefined;
            this.floor = _data["floor"];
            this.isStarted = _data["isStarted"] !== undefined ? _data["isStarted"] : false;
            this.isFinished = _data["isFinished"] !== undefined ? _data["isFinished"] : false;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PickingCartConnection {
        data = typeof data === 'object' ? data : {};
        let result = new PickingCartConnection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pickingCart"] = this.pickingCart ? this.pickingCart.toJSON() : <any>undefined;
        data["pickingCartId"] = this.pickingCartId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["workAction"] = this.workAction ? this.workAction.toJSON() : <any>undefined;
        data["workActionId"] = this.workActionId;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["floor"] = this.floor;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): PickingCartConnection {
        const json = this.toJSON();
        let result = new PickingCartConnection();
        result.init(json);
        return result;
    }
}

export interface IPickingCartConnection {
    pickingCart: PickingCart;
    pickingCartId: number;
    warehouse: Warehouse;
    warehouseId: number;
    workAction: WorkAction;
    workActionId: number;
    finishTime: Date | undefined;
    floor: string | undefined;
    isStarted: boolean;
    isFinished: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class PickingCartConnectionProcess implements IPickingCartConnectionProcess {
    warehouse: Warehouse;
    warehouseId: number;
    pickingCartConnection: PickingCartConnection;
    pickingCartConnectionId: number;
    orderDetail: OrderDetail;
    orderDetailId: number;
    quantity: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPickingCartConnectionProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.warehouse = new Warehouse();
            this.pickingCartConnection = new PickingCartConnection();
            this.orderDetail = new OrderDetail();
            this.quantity = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.warehouseId = _data["warehouseId"];
            this.pickingCartConnection = _data["pickingCartConnection"] ? PickingCartConnection.fromJS(_data["pickingCartConnection"]) : new PickingCartConnection();
            this.pickingCartConnectionId = _data["pickingCartConnectionId"];
            this.orderDetail = _data["orderDetail"] ? OrderDetail.fromJS(_data["orderDetail"]) : new OrderDetail();
            this.orderDetailId = _data["orderDetailId"];
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : 0;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PickingCartConnectionProcess {
        data = typeof data === 'object' ? data : {};
        let result = new PickingCartConnectionProcess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["pickingCartConnection"] = this.pickingCartConnection ? this.pickingCartConnection.toJSON() : <any>undefined;
        data["pickingCartConnectionId"] = this.pickingCartConnectionId;
        data["orderDetail"] = this.orderDetail ? this.orderDetail.toJSON() : <any>undefined;
        data["orderDetailId"] = this.orderDetailId;
        data["quantity"] = this.quantity;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): PickingCartConnectionProcess {
        const json = this.toJSON();
        let result = new PickingCartConnectionProcess();
        result.init(json);
        return result;
    }
}

export interface IPickingCartConnectionProcess {
    warehouse: Warehouse;
    warehouseId: number;
    pickingCartConnection: PickingCartConnection;
    pickingCartConnectionId: number;
    orderDetail: OrderDetail;
    orderDetailId: number;
    quantity: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class PickingCartDto implements IPickingCartDto {
    code: string | undefined;
    isInUse: boolean;
    id: number;

    constructor(data?: IPickingCartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.isInUse = _data["isInUse"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PickingCartDto {
        data = typeof data === 'object' ? data : {};
        let result = new PickingCartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["isInUse"] = this.isInUse;
        data["id"] = this.id;
        return data;
    }

    clone(): PickingCartDto {
        const json = this.toJSON();
        let result = new PickingCartDto();
        result.init(json);
        return result;
    }
}

export interface IPickingCartDto {
    code: string | undefined;
    isInUse: boolean;
    id: number;
}

export class PickingCartDtoPagedResultDto implements IPickingCartDtoPagedResultDto {
    totalCount: number;
    items: PickingCartDto[] | undefined;

    constructor(data?: IPickingCartDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PickingCartDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PickingCartDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PickingCartDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PickingCartDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PickingCartDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPickingCartDtoPagedResultDto {
    totalCount: number;
    items: PickingCartDto[] | undefined;
}

export enum Floor {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class PickingCartConnectionDto implements IPickingCartConnectionDto {
    pickingCart: PickingCart;
    workAction: WorkAction;
    floor: Floor;
    finishDate: Date;
    isStarted: boolean;
    isFinished: boolean;
    id: number;

    constructor(data?: IPickingCartConnectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pickingCart = _data["pickingCart"] ? PickingCart.fromJS(_data["pickingCart"]) : <any>undefined;
            this.workAction = _data["workAction"] ? WorkAction.fromJS(_data["workAction"]) : <any>undefined;
            this.floor = _data["floor"];
            this.finishDate = _data["finishDate"] ? new Date(_data["finishDate"].toString()) : <any>undefined;
            this.isStarted = _data["isStarted"];
            this.isFinished = _data["isFinished"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PickingCartConnectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PickingCartConnectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pickingCart"] = this.pickingCart ? this.pickingCart.toJSON() : <any>undefined;
        data["workAction"] = this.workAction ? this.workAction.toJSON() : <any>undefined;
        data["floor"] = this.floor;
        data["finishDate"] = this.finishDate ? this.finishDate.toISOString() : <any>undefined;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["id"] = this.id;
        return data;
    }

    clone(): PickingCartConnectionDto {
        const json = this.toJSON();
        let result = new PickingCartConnectionDto();
        result.init(json);
        return result;
    }
}

export interface IPickingCartConnectionDto {
    pickingCart: PickingCart;
    workAction: WorkAction;
    floor: Floor;
    finishDate: Date;
    isStarted: boolean;
    isFinished: boolean;
    id: number;
}

export class PickingCartConnectionDtoPagedResultDto implements IPickingCartConnectionDtoPagedResultDto {
    totalCount: number;
    items: PickingCartConnectionDto[] | undefined;

    constructor(data?: IPickingCartConnectionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PickingCartConnectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PickingCartConnectionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PickingCartConnectionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PickingCartConnectionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PickingCartConnectionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPickingCartConnectionDtoPagedResultDto {
    totalCount: number;
    items: PickingCartConnectionDto[] | undefined;
}

export enum ParamType {
    _0 = 0,
    _1 = 1,
}

export class Parameter implements IParameter {
    code: string;
    value: string | undefined;
    type: ParamType;
    description: string | undefined;
    warehouse: Warehouse;
    visible: boolean;
    id: number;

    constructor(data?: IParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.value = _data["value"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.visible = _data["visible"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Parameter {
        data = typeof data === 'object' ? data : {};
        let result = new Parameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["value"] = this.value;
        data["type"] = this.type;
        data["description"] = this.description;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["visible"] = this.visible;
        data["id"] = this.id;
        return data;
    }

    clone(): Parameter {
        const json = this.toJSON();
        let result = new Parameter();
        result.init(json);
        return result;
    }
}

export interface IParameter {
    code: string;
    value: string | undefined;
    type: ParamType;
    description: string | undefined;
    warehouse: Warehouse;
    visible: boolean;
    id: number;
}

export class ControlPointScreenDapperDto implements IControlPointScreenDapperDto {
    id: number;
    code: string | undefined;
    definition: string | undefined;
    status: string | undefined;
    pickerUsers: string | undefined;
    shippingTypes: string | undefined;
    clientNames: string | undefined;
    quantityPercent: number;

    constructor(data?: IControlPointScreenDapperDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.status = _data["status"];
            this.pickerUsers = _data["pickerUsers"];
            this.shippingTypes = _data["shippingTypes"];
            this.clientNames = _data["clientNames"];
            this.quantityPercent = _data["quantityPercent"];
        }
    }

    static fromJS(data: any): ControlPointScreenDapperDto {
        data = typeof data === 'object' ? data : {};
        let result = new ControlPointScreenDapperDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["status"] = this.status;
        data["pickerUsers"] = this.pickerUsers;
        data["shippingTypes"] = this.shippingTypes;
        data["clientNames"] = this.clientNames;
        data["quantityPercent"] = this.quantityPercent;
        return data;
    }

    clone(): ControlPointScreenDapperDto {
        const json = this.toJSON();
        let result = new ControlPointScreenDapperDto();
        result.init(json);
        return result;
    }
}

export interface IControlPointScreenDapperDto {
    id: number;
    code: string | undefined;
    definition: string | undefined;
    status: string | undefined;
    pickerUsers: string | undefined;
    shippingTypes: string | undefined;
    clientNames: string | undefined;
    quantityPercent: number;
}

export class ControlPointEmptyDapper implements IControlPointEmptyDapper {
    id: number;
    code: string | undefined;
    definition: string | undefined;

    constructor(data?: IControlPointEmptyDapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): ControlPointEmptyDapper {
        data = typeof data === 'object' ? data : {};
        let result = new ControlPointEmptyDapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["definition"] = this.definition;
        return data;
    }

    clone(): ControlPointEmptyDapper {
        const json = this.toJSON();
        let result = new ControlPointEmptyDapper();
        result.init(json);
        return result;
    }
}

export interface IControlPointEmptyDapper {
    id: number;
    code: string | undefined;
    definition: string | undefined;
}

export class CombinedOrdersHeader implements ICombinedOrdersHeader {
    documentNo: string | undefined;
    client: Client;
    clientId: number;
    deciForPackage: number;
    deciForPalette: number;
    deciForBundle: number;
    quantityPackage: number;
    quantityBundle: number;
    quantityPalette: number;
    isInvoicing: boolean;
    invoicingStartTime: Date | undefined;
    isInvoiced: boolean;
    invoiceDate: Date | undefined;
    invoiceNo: string | undefined;
    invoiceNoGib: string | undefined;
    willBeShippingCost: boolean;
    shippingCost: number;
    invoiceType: EDocumentType;
    printPointName: string | undefined;
    isInvoicePrinted: boolean;
    invoicePrintTime: Date | undefined;
    cargoEntegrationResult: string | undefined;
    invoiceSend: boolean;
    shippingType: ShippingType;
    shippingTypeId: number | undefined;
    deci: number;
    kg: number;
    id: number;

    constructor(data?: ICombinedOrdersHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documentNo = "";
            this.client = new Client();
            this.deciForPackage = 0;
            this.deciForPalette = 0;
            this.deciForBundle = 0;
            this.quantityPackage = 0;
            this.quantityBundle = 0;
            this.quantityPalette = 0;
            this.isInvoicing = false;
            this.isInvoiced = false;
            this.invoiceNo = "";
            this.invoiceNoGib = "";
            this.willBeShippingCost = false;
            this.shippingCost = 0;
            this.printPointName = "";
            this.isInvoicePrinted = false;
            this.cargoEntegrationResult = "";
            this.deci = 0;
            this.kg = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNo = _data["documentNo"] !== undefined ? _data["documentNo"] : "";
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : new Client();
            this.clientId = _data["clientId"];
            this.deciForPackage = _data["deciForPackage"] !== undefined ? _data["deciForPackage"] : 0;
            this.deciForPalette = _data["deciForPalette"] !== undefined ? _data["deciForPalette"] : 0;
            this.deciForBundle = _data["deciForBundle"] !== undefined ? _data["deciForBundle"] : 0;
            this.quantityPackage = _data["quantityPackage"] !== undefined ? _data["quantityPackage"] : 0;
            this.quantityBundle = _data["quantityBundle"] !== undefined ? _data["quantityBundle"] : 0;
            this.quantityPalette = _data["quantityPalette"] !== undefined ? _data["quantityPalette"] : 0;
            this.isInvoicing = _data["isInvoicing"] !== undefined ? _data["isInvoicing"] : false;
            this.invoicingStartTime = _data["invoicingStartTime"] ? new Date(_data["invoicingStartTime"].toString()) : <any>undefined;
            this.isInvoiced = _data["isInvoiced"] !== undefined ? _data["isInvoiced"] : false;
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            this.invoiceNo = _data["invoiceNo"] !== undefined ? _data["invoiceNo"] : "";
            this.invoiceNoGib = _data["invoiceNoGib"] !== undefined ? _data["invoiceNoGib"] : "";
            this.willBeShippingCost = _data["willBeShippingCost"] !== undefined ? _data["willBeShippingCost"] : false;
            this.shippingCost = _data["shippingCost"] !== undefined ? _data["shippingCost"] : 0;
            this.invoiceType = _data["invoiceType"];
            this.printPointName = _data["printPointName"] !== undefined ? _data["printPointName"] : "";
            this.isInvoicePrinted = _data["isInvoicePrinted"] !== undefined ? _data["isInvoicePrinted"] : false;
            this.invoicePrintTime = _data["invoicePrintTime"] ? new Date(_data["invoicePrintTime"].toString()) : <any>undefined;
            this.cargoEntegrationResult = _data["cargoEntegrationResult"] !== undefined ? _data["cargoEntegrationResult"] : "";
            this.invoiceSend = _data["invoiceSend"];
            this.shippingType = _data["shippingType"] ? ShippingType.fromJS(_data["shippingType"]) : <any>undefined;
            this.shippingTypeId = _data["shippingTypeId"];
            this.deci = _data["deci"] !== undefined ? _data["deci"] : 0;
            this.kg = _data["kg"] !== undefined ? _data["kg"] : 0;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CombinedOrdersHeader {
        data = typeof data === 'object' ? data : {};
        let result = new CombinedOrdersHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNo"] = this.documentNo;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["deciForPackage"] = this.deciForPackage;
        data["deciForPalette"] = this.deciForPalette;
        data["deciForBundle"] = this.deciForBundle;
        data["quantityPackage"] = this.quantityPackage;
        data["quantityBundle"] = this.quantityBundle;
        data["quantityPalette"] = this.quantityPalette;
        data["isInvoicing"] = this.isInvoicing;
        data["invoicingStartTime"] = this.invoicingStartTime ? this.invoicingStartTime.toISOString() : <any>undefined;
        data["isInvoiced"] = this.isInvoiced;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceNoGib"] = this.invoiceNoGib;
        data["willBeShippingCost"] = this.willBeShippingCost;
        data["shippingCost"] = this.shippingCost;
        data["invoiceType"] = this.invoiceType;
        data["printPointName"] = this.printPointName;
        data["isInvoicePrinted"] = this.isInvoicePrinted;
        data["invoicePrintTime"] = this.invoicePrintTime ? this.invoicePrintTime.toISOString() : <any>undefined;
        data["cargoEntegrationResult"] = this.cargoEntegrationResult;
        data["invoiceSend"] = this.invoiceSend;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : <any>undefined;
        data["shippingTypeId"] = this.shippingTypeId;
        data["deci"] = this.deci;
        data["kg"] = this.kg;
        data["id"] = this.id;
        return data;
    }

    clone(): CombinedOrdersHeader {
        const json = this.toJSON();
        let result = new CombinedOrdersHeader();
        result.init(json);
        return result;
    }
}

export interface ICombinedOrdersHeader {
    documentNo: string | undefined;
    client: Client;
    clientId: number;
    deciForPackage: number;
    deciForPalette: number;
    deciForBundle: number;
    quantityPackage: number;
    quantityBundle: number;
    quantityPalette: number;
    isInvoicing: boolean;
    invoicingStartTime: Date | undefined;
    isInvoiced: boolean;
    invoiceDate: Date | undefined;
    invoiceNo: string | undefined;
    invoiceNoGib: string | undefined;
    willBeShippingCost: boolean;
    shippingCost: number;
    invoiceType: EDocumentType;
    printPointName: string | undefined;
    isInvoicePrinted: boolean;
    invoicePrintTime: Date | undefined;
    cargoEntegrationResult: string | undefined;
    invoiceSend: boolean;
    shippingType: ShippingType;
    shippingTypeId: number | undefined;
    deci: number;
    kg: number;
    id: number;
}

export class CombinedOrdersHeaderInvoiceDto implements ICombinedOrdersHeaderInvoiceDto {
    combinedOrdersHeader: CombinedOrdersHeader;
    message: string | undefined;

    constructor(data?: ICombinedOrdersHeaderInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.combinedOrdersHeader = _data["combinedOrdersHeader"] ? CombinedOrdersHeader.fromJS(_data["combinedOrdersHeader"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CombinedOrdersHeaderInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CombinedOrdersHeaderInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["combinedOrdersHeader"] = this.combinedOrdersHeader ? this.combinedOrdersHeader.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }

    clone(): CombinedOrdersHeaderInvoiceDto {
        const json = this.toJSON();
        let result = new CombinedOrdersHeaderInvoiceDto();
        result.init(json);
        return result;
    }
}

export interface ICombinedOrdersHeaderInvoiceDto {
    combinedOrdersHeader: CombinedOrdersHeader;
    message: string | undefined;
}

export class CombinedOrdersHeaderInvoiceDtoPagedResultDto implements ICombinedOrdersHeaderInvoiceDtoPagedResultDto {
    totalCount: number;
    items: CombinedOrdersHeaderInvoiceDto[] | undefined;

    constructor(data?: ICombinedOrdersHeaderInvoiceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CombinedOrdersHeaderInvoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CombinedOrdersHeaderInvoiceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CombinedOrdersHeaderInvoiceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CombinedOrdersHeaderInvoiceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CombinedOrdersHeaderInvoiceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICombinedOrdersHeaderInvoiceDtoPagedResultDto {
    totalCount: number;
    items: CombinedOrdersHeaderInvoiceDto[] | undefined;
}

export class CombinableQuantityDto implements ICombinableQuantityDto {
    quantityPalette: number;
    quantityBundle: number;
    quantityPackage: number;
    deciForPackage: number;
    kgForPackage: number;
    shippingCostPackage: number;
    shippingCostCanChange: boolean;

    constructor(data?: ICombinableQuantityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantityPalette = _data["quantityPalette"];
            this.quantityBundle = _data["quantityBundle"];
            this.quantityPackage = _data["quantityPackage"];
            this.deciForPackage = _data["deciForPackage"];
            this.kgForPackage = _data["kgForPackage"];
            this.shippingCostPackage = _data["shippingCostPackage"];
            this.shippingCostCanChange = _data["shippingCostCanChange"];
        }
    }

    static fromJS(data: any): CombinableQuantityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableQuantityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantityPalette"] = this.quantityPalette;
        data["quantityBundle"] = this.quantityBundle;
        data["quantityPackage"] = this.quantityPackage;
        data["deciForPackage"] = this.deciForPackage;
        data["kgForPackage"] = this.kgForPackage;
        data["shippingCostPackage"] = this.shippingCostPackage;
        data["shippingCostCanChange"] = this.shippingCostCanChange;
        return data;
    }

    clone(): CombinableQuantityDto {
        const json = this.toJSON();
        let result = new CombinableQuantityDto();
        result.init(json);
        return result;
    }
}

export interface ICombinableQuantityDto {
    quantityPalette: number;
    quantityBundle: number;
    quantityPackage: number;
    deciForPackage: number;
    kgForPackage: number;
    shippingCostPackage: number;
    shippingCostCanChange: boolean;
}

export class CreateCombinableOrdersAndInvoiceRequestDto implements ICreateCombinableOrdersAndInvoiceRequestDto {
    companyId: number;
    warehouseId: number;
    orderHeaderIdList: number[] | undefined;
    deciForPackage: number;
    deciForPalette: number;
    deciForBundle: number;
    quantityPackage: number;
    quantityBundle: number;
    quantityPalette: number;
    printPointName: string | undefined;
    willBeShippingCost: boolean;
    shippingCost: number;

    constructor(data?: ICreateCombinableOrdersAndInvoiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.warehouseId = _data["warehouseId"];
            if (Array.isArray(_data["orderHeaderIdList"])) {
                this.orderHeaderIdList = [] as any;
                for (let item of _data["orderHeaderIdList"])
                    this.orderHeaderIdList.push(item);
            }
            this.deciForPackage = _data["deciForPackage"];
            this.deciForPalette = _data["deciForPalette"];
            this.deciForBundle = _data["deciForBundle"];
            this.quantityPackage = _data["quantityPackage"];
            this.quantityBundle = _data["quantityBundle"];
            this.quantityPalette = _data["quantityPalette"];
            this.printPointName = _data["printPointName"];
            this.willBeShippingCost = _data["willBeShippingCost"];
            this.shippingCost = _data["shippingCost"];
        }
    }

    static fromJS(data: any): CreateCombinableOrdersAndInvoiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCombinableOrdersAndInvoiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["warehouseId"] = this.warehouseId;
        if (Array.isArray(this.orderHeaderIdList)) {
            data["orderHeaderIdList"] = [];
            for (let item of this.orderHeaderIdList)
                data["orderHeaderIdList"].push(item);
        }
        data["deciForPackage"] = this.deciForPackage;
        data["deciForPalette"] = this.deciForPalette;
        data["deciForBundle"] = this.deciForBundle;
        data["quantityPackage"] = this.quantityPackage;
        data["quantityBundle"] = this.quantityBundle;
        data["quantityPalette"] = this.quantityPalette;
        data["printPointName"] = this.printPointName;
        data["willBeShippingCost"] = this.willBeShippingCost;
        data["shippingCost"] = this.shippingCost;
        return data;
    }

    clone(): CreateCombinableOrdersAndInvoiceRequestDto {
        const json = this.toJSON();
        let result = new CreateCombinableOrdersAndInvoiceRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCombinableOrdersAndInvoiceRequestDto {
    companyId: number;
    warehouseId: number;
    orderHeaderIdList: number[] | undefined;
    deciForPackage: number;
    deciForPalette: number;
    deciForBundle: number;
    quantityPackage: number;
    quantityBundle: number;
    quantityPalette: number;
    printPointName: string | undefined;
    willBeShippingCost: boolean;
    shippingCost: number;
}

export class ShippingTypeAreaPagedResultDto implements IShippingTypeAreaPagedResultDto {
    totalCount: number;
    items: ShippingTypeArea[] | undefined;

    constructor(data?: IShippingTypeAreaPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ShippingTypeArea.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShippingTypeAreaPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingTypeAreaPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ShippingTypeAreaPagedResultDto {
        const json = this.toJSON();
        let result = new ShippingTypeAreaPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IShippingTypeAreaPagedResultDto {
    totalCount: number;
    items: ShippingTypeArea[] | undefined;
}

export class NotErpProcessHeaderRequestDto implements INotErpProcessHeaderRequestDto {
    companyId: number;
    warehouseId: number;
    documentNo: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: INotErpProcessHeaderRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.warehouseId = _data["warehouseId"];
            this.documentNo = _data["documentNo"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): NotErpProcessHeaderRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotErpProcessHeaderRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["warehouseId"] = this.warehouseId;
        data["documentNo"] = this.documentNo;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }

    clone(): NotErpProcessHeaderRequestDto {
        const json = this.toJSON();
        let result = new NotErpProcessHeaderRequestDto();
        result.init(json);
        return result;
    }
}

export interface INotErpProcessHeaderRequestDto {
    companyId: number;
    warehouseId: number;
    documentNo: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class NotErpProcessHeaderForOrder implements INotErpProcessHeaderForOrder {
    orderheaderId: number;
    documentNo: string | undefined;
    clientCode: string | undefined;
    clientName: string | undefined;
    creationTime: Date;

    constructor(data?: INotErpProcessHeaderForOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderheaderId = _data["orderheaderId"];
            this.documentNo = _data["documentNo"];
            this.clientCode = _data["clientCode"];
            this.clientName = _data["clientName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NotErpProcessHeaderForOrder {
        data = typeof data === 'object' ? data : {};
        let result = new NotErpProcessHeaderForOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderheaderId"] = this.orderheaderId;
        data["documentNo"] = this.documentNo;
        data["clientCode"] = this.clientCode;
        data["clientName"] = this.clientName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): NotErpProcessHeaderForOrder {
        const json = this.toJSON();
        let result = new NotErpProcessHeaderForOrder();
        result.init(json);
        return result;
    }
}

export interface INotErpProcessHeaderForOrder {
    orderheaderId: number;
    documentNo: string | undefined;
    clientCode: string | undefined;
    clientName: string | undefined;
    creationTime: Date;
}

export class NotErpProcessHeaderForOrderPagedResultDto implements INotErpProcessHeaderForOrderPagedResultDto {
    totalCount: number;
    items: NotErpProcessHeaderForOrder[] | undefined;

    constructor(data?: INotErpProcessHeaderForOrderPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NotErpProcessHeaderForOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotErpProcessHeaderForOrderPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotErpProcessHeaderForOrderPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): NotErpProcessHeaderForOrderPagedResultDto {
        const json = this.toJSON();
        let result = new NotErpProcessHeaderForOrderPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INotErpProcessHeaderForOrderPagedResultDto {
    totalCount: number;
    items: NotErpProcessHeaderForOrder[] | undefined;
}

export class ShippingRoutePagedResultDto implements IShippingRoutePagedResultDto {
    totalCount: number;
    items: ShippingRoute[] | undefined;

    constructor(data?: IShippingRoutePagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ShippingRoute.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShippingRoutePagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingRoutePagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ShippingRoutePagedResultDto {
        const json = this.toJSON();
        let result = new ShippingRoutePagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IShippingRoutePagedResultDto {
    totalCount: number;
    items: ShippingRoute[] | undefined;
}

export class CombinedOrdersHeaderDto implements ICombinedOrdersHeaderDto {
    client: ClientDto;
    quantityPackage: number;
    quantityBundle: number;
    quantityPalette: number;
    shippingCompanyBarcodes: string | undefined;
    documentNo: string | undefined;
    quantityRow: number;
    quantityTotal: number;
    shippingType: ShippingType;
    id: number;

    constructor(data?: ICombinedOrdersHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.client = _data["client"] ? ClientDto.fromJS(_data["client"]) : <any>undefined;
            this.quantityPackage = _data["quantityPackage"];
            this.quantityBundle = _data["quantityBundle"];
            this.quantityPalette = _data["quantityPalette"];
            this.shippingCompanyBarcodes = _data["shippingCompanyBarcodes"];
            this.documentNo = _data["documentNo"];
            this.quantityRow = _data["quantityRow"];
            this.quantityTotal = _data["quantityTotal"];
            this.shippingType = _data["shippingType"] ? ShippingType.fromJS(_data["shippingType"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CombinedOrdersHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CombinedOrdersHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["quantityPackage"] = this.quantityPackage;
        data["quantityBundle"] = this.quantityBundle;
        data["quantityPalette"] = this.quantityPalette;
        data["shippingCompanyBarcodes"] = this.shippingCompanyBarcodes;
        data["documentNo"] = this.documentNo;
        data["quantityRow"] = this.quantityRow;
        data["quantityTotal"] = this.quantityTotal;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): CombinedOrdersHeaderDto {
        const json = this.toJSON();
        let result = new CombinedOrdersHeaderDto();
        result.init(json);
        return result;
    }
}

export interface ICombinedOrdersHeaderDto {
    client: ClientDto;
    quantityPackage: number;
    quantityBundle: number;
    quantityPalette: number;
    shippingCompanyBarcodes: string | undefined;
    documentNo: string | undefined;
    quantityRow: number;
    quantityTotal: number;
    shippingType: ShippingType;
    id: number;
}

export class FinishedOrderListItemDto implements IFinishedOrderListItemDto {
    finishDate: Date | undefined;
    documentNo: string | undefined;
    deci: number;
    shippingTypeCode: string | undefined;

    constructor(data?: IFinishedOrderListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.finishDate = _data["finishDate"] ? new Date(_data["finishDate"].toString()) : <any>undefined;
            this.documentNo = _data["documentNo"];
            this.deci = _data["deci"];
            this.shippingTypeCode = _data["shippingTypeCode"];
        }
    }

    static fromJS(data: any): FinishedOrderListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinishedOrderListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finishDate"] = this.finishDate ? this.finishDate.toISOString() : <any>undefined;
        data["documentNo"] = this.documentNo;
        data["deci"] = this.deci;
        data["shippingTypeCode"] = this.shippingTypeCode;
        return data;
    }

    clone(): FinishedOrderListItemDto {
        const json = this.toJSON();
        let result = new FinishedOrderListItemDto();
        result.init(json);
        return result;
    }
}

export interface IFinishedOrderListItemDto {
    finishDate: Date | undefined;
    documentNo: string | undefined;
    deci: number;
    shippingTypeCode: string | undefined;
}

export class FinishedOrderListItemDtoPagedResultDto implements IFinishedOrderListItemDtoPagedResultDto {
    totalCount: number;
    items: FinishedOrderListItemDto[] | undefined;

    constructor(data?: IFinishedOrderListItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(FinishedOrderListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FinishedOrderListItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinishedOrderListItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): FinishedOrderListItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FinishedOrderListItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFinishedOrderListItemDtoPagedResultDto {
    totalCount: number;
    items: FinishedOrderListItemDto[] | undefined;
}

export class FinishedWarrantyOrderListItemDto implements IFinishedWarrantyOrderListItemDto {
    finishDate: Date | undefined;
    documentNo: string | undefined;
    deci: number;
    warrantyNo: string | undefined;
    clientCode: string | undefined;
    clientName: string | undefined;
    shippingTypeCode: string | undefined;

    constructor(data?: IFinishedWarrantyOrderListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.finishDate = _data["finishDate"] ? new Date(_data["finishDate"].toString()) : <any>undefined;
            this.documentNo = _data["documentNo"];
            this.deci = _data["deci"];
            this.warrantyNo = _data["warrantyNo"];
            this.clientCode = _data["clientCode"];
            this.clientName = _data["clientName"];
            this.shippingTypeCode = _data["shippingTypeCode"];
        }
    }

    static fromJS(data: any): FinishedWarrantyOrderListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinishedWarrantyOrderListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finishDate"] = this.finishDate ? this.finishDate.toISOString() : <any>undefined;
        data["documentNo"] = this.documentNo;
        data["deci"] = this.deci;
        data["warrantyNo"] = this.warrantyNo;
        data["clientCode"] = this.clientCode;
        data["clientName"] = this.clientName;
        data["shippingTypeCode"] = this.shippingTypeCode;
        return data;
    }

    clone(): FinishedWarrantyOrderListItemDto {
        const json = this.toJSON();
        let result = new FinishedWarrantyOrderListItemDto();
        result.init(json);
        return result;
    }
}

export interface IFinishedWarrantyOrderListItemDto {
    finishDate: Date | undefined;
    documentNo: string | undefined;
    deci: number;
    warrantyNo: string | undefined;
    clientCode: string | undefined;
    clientName: string | undefined;
    shippingTypeCode: string | undefined;
}

export class FinishedWarrantyOrderListItemDtoPagedResultDto implements IFinishedWarrantyOrderListItemDtoPagedResultDto {
    totalCount: number;
    items: FinishedWarrantyOrderListItemDto[] | undefined;

    constructor(data?: IFinishedWarrantyOrderListItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(FinishedWarrantyOrderListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FinishedWarrantyOrderListItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinishedWarrantyOrderListItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): FinishedWarrantyOrderListItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FinishedWarrantyOrderListItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFinishedWarrantyOrderListItemDtoPagedResultDto {
    totalCount: number;
    items: FinishedWarrantyOrderListItemDto[] | undefined;
}

export class FinishOrderHeaderWithAllParametersRequestDto implements IFinishOrderHeaderWithAllParametersRequestDto {
    orderHeaderId: number;
    qtyPackage: number;
    qtyBundle: number;
    qtyPalette: number;
    shippingTypeId: number;
    shippingRouteId: number;
    shippingCity: string | undefined;
    shippingTown: string | undefined;
    deci: number;
    kg: number;
    isPrintInvoice: boolean;
    invoicePrintPointName: string | undefined;
    invoicePrintQuantity: number;
    invoiceShippingCost: number;
    isPrintShippingLabel: boolean;
    shippingLabelPrintPointName: string | undefined;
    isPrintPackingLabel: boolean;
    packingLabelPrintPointName: string | undefined;
    headerInvoiceStatus: boolean;
    isDispatch: boolean;
    isWarranty: boolean;
    warrantyNo: string | undefined;

    constructor(data?: IFinishOrderHeaderWithAllParametersRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderHeaderId = _data["orderHeaderId"];
            this.qtyPackage = _data["qtyPackage"];
            this.qtyBundle = _data["qtyBundle"];
            this.qtyPalette = _data["qtyPalette"];
            this.shippingTypeId = _data["shippingTypeId"];
            this.shippingRouteId = _data["shippingRouteId"];
            this.shippingCity = _data["shippingCity"];
            this.shippingTown = _data["shippingTown"];
            this.deci = _data["deci"];
            this.kg = _data["kg"];
            this.isPrintInvoice = _data["isPrintInvoice"];
            this.invoicePrintPointName = _data["invoicePrintPointName"];
            this.invoicePrintQuantity = _data["invoicePrintQuantity"];
            this.invoiceShippingCost = _data["invoiceShippingCost"];
            this.isPrintShippingLabel = _data["isPrintShippingLabel"];
            this.shippingLabelPrintPointName = _data["shippingLabelPrintPointName"];
            this.isPrintPackingLabel = _data["isPrintPackingLabel"];
            this.packingLabelPrintPointName = _data["packingLabelPrintPointName"];
            this.headerInvoiceStatus = _data["headerInvoiceStatus"];
            this.isDispatch = _data["isDispatch"];
            this.isWarranty = _data["isWarranty"];
            this.warrantyNo = _data["warrantyNo"];
        }
    }

    static fromJS(data: any): FinishOrderHeaderWithAllParametersRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinishOrderHeaderWithAllParametersRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderHeaderId"] = this.orderHeaderId;
        data["qtyPackage"] = this.qtyPackage;
        data["qtyBundle"] = this.qtyBundle;
        data["qtyPalette"] = this.qtyPalette;
        data["shippingTypeId"] = this.shippingTypeId;
        data["shippingRouteId"] = this.shippingRouteId;
        data["shippingCity"] = this.shippingCity;
        data["shippingTown"] = this.shippingTown;
        data["deci"] = this.deci;
        data["kg"] = this.kg;
        data["isPrintInvoice"] = this.isPrintInvoice;
        data["invoicePrintPointName"] = this.invoicePrintPointName;
        data["invoicePrintQuantity"] = this.invoicePrintQuantity;
        data["invoiceShippingCost"] = this.invoiceShippingCost;
        data["isPrintShippingLabel"] = this.isPrintShippingLabel;
        data["shippingLabelPrintPointName"] = this.shippingLabelPrintPointName;
        data["isPrintPackingLabel"] = this.isPrintPackingLabel;
        data["packingLabelPrintPointName"] = this.packingLabelPrintPointName;
        data["headerInvoiceStatus"] = this.headerInvoiceStatus;
        data["isDispatch"] = this.isDispatch;
        data["isWarranty"] = this.isWarranty;
        data["warrantyNo"] = this.warrantyNo;
        return data;
    }

    clone(): FinishOrderHeaderWithAllParametersRequestDto {
        const json = this.toJSON();
        let result = new FinishOrderHeaderWithAllParametersRequestDto();
        result.init(json);
        return result;
    }
}

export interface IFinishOrderHeaderWithAllParametersRequestDto {
    orderHeaderId: number;
    qtyPackage: number;
    qtyBundle: number;
    qtyPalette: number;
    shippingTypeId: number;
    shippingRouteId: number;
    shippingCity: string | undefined;
    shippingTown: string | undefined;
    deci: number;
    kg: number;
    isPrintInvoice: boolean;
    invoicePrintPointName: string | undefined;
    invoicePrintQuantity: number;
    invoiceShippingCost: number;
    isPrintShippingLabel: boolean;
    shippingLabelPrintPointName: string | undefined;
    isPrintPackingLabel: boolean;
    packingLabelPrintPointName: string | undefined;
    headerInvoiceStatus: boolean;
    isDispatch: boolean;
    isWarranty: boolean;
    warrantyNo: string | undefined;
}

export class ShelfDto implements IShelfDto {
    warehouse: Warehouse;
    region: string | undefined;
    street: number;
    apartment: string | undefined;
    apartmentNo: number;
    floor: string | undefined;
    floorNo: number;
    sequence: string | undefined;
    sequenceNo: number;
    isActive: boolean;
    isBlocked: boolean;
    width: number;
    length: number;
    height: number;
    shelfType: ShelfType;
    hasPriority: boolean;
    fullAddress: string | undefined;
    weight: number;
    id: number;

    constructor(data?: IShelfDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.region = _data["region"];
            this.street = _data["street"];
            this.apartment = _data["apartment"];
            this.apartmentNo = _data["apartmentNo"];
            this.floor = _data["floor"];
            this.floorNo = _data["floorNo"];
            this.sequence = _data["sequence"];
            this.sequenceNo = _data["sequenceNo"];
            this.isActive = _data["isActive"];
            this.isBlocked = _data["isBlocked"];
            this.width = _data["width"];
            this.length = _data["length"];
            this.height = _data["height"];
            this.shelfType = _data["shelfType"] ? ShelfType.fromJS(_data["shelfType"]) : <any>undefined;
            this.hasPriority = _data["hasPriority"];
            this.fullAddress = _data["fullAddress"];
            this.weight = _data["weight"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShelfDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShelfDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["region"] = this.region;
        data["street"] = this.street;
        data["apartment"] = this.apartment;
        data["apartmentNo"] = this.apartmentNo;
        data["floor"] = this.floor;
        data["floorNo"] = this.floorNo;
        data["sequence"] = this.sequence;
        data["sequenceNo"] = this.sequenceNo;
        data["isActive"] = this.isActive;
        data["isBlocked"] = this.isBlocked;
        data["width"] = this.width;
        data["length"] = this.length;
        data["height"] = this.height;
        data["shelfType"] = this.shelfType ? this.shelfType.toJSON() : <any>undefined;
        data["hasPriority"] = this.hasPriority;
        data["fullAddress"] = this.fullAddress;
        data["weight"] = this.weight;
        data["id"] = this.id;
        return data;
    }

    clone(): ShelfDto {
        const json = this.toJSON();
        let result = new ShelfDto();
        result.init(json);
        return result;
    }
}

export interface IShelfDto {
    warehouse: Warehouse;
    region: string | undefined;
    street: number;
    apartment: string | undefined;
    apartmentNo: number;
    floor: string | undefined;
    floorNo: number;
    sequence: string | undefined;
    sequenceNo: number;
    isActive: boolean;
    isBlocked: boolean;
    width: number;
    length: number;
    height: number;
    shelfType: ShelfType;
    hasPriority: boolean;
    fullAddress: string | undefined;
    weight: number;
    id: number;
}

export class Erp2Wms_ClientPayBack implements IErp2Wms_ClientPayBack {
    fark: string | undefined;

    constructor(data?: IErp2Wms_ClientPayBack) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fark = _data["fark"];
        }
    }

    static fromJS(data: any): Erp2Wms_ClientPayBack {
        data = typeof data === 'object' ? data : {};
        let result = new Erp2Wms_ClientPayBack();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fark"] = this.fark;
        return data;
    }

    clone(): Erp2Wms_ClientPayBack {
        const json = this.toJSON();
        let result = new Erp2Wms_ClientPayBack();
        result.init(json);
        return result;
    }
}

export interface IErp2Wms_ClientPayBack {
    fark: string | undefined;
}

export class OrderHeaderStatsDto implements IOrderHeaderStatsDto {
    quantityWorking: number;
    quantityDeleted: number;
    quantityFinished: number;
    quantityNotStarted: number;
    quantityWaiting: number;
    quantityTotal: number;

    constructor(data?: IOrderHeaderStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantityWorking = _data["quantityWorking"];
            this.quantityDeleted = _data["quantityDeleted"];
            this.quantityFinished = _data["quantityFinished"];
            this.quantityNotStarted = _data["quantityNotStarted"];
            this.quantityWaiting = _data["quantityWaiting"];
            this.quantityTotal = _data["quantityTotal"];
        }
    }

    static fromJS(data: any): OrderHeaderStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantityWorking"] = this.quantityWorking;
        data["quantityDeleted"] = this.quantityDeleted;
        data["quantityFinished"] = this.quantityFinished;
        data["quantityNotStarted"] = this.quantityNotStarted;
        data["quantityWaiting"] = this.quantityWaiting;
        data["quantityTotal"] = this.quantityTotal;
        return data;
    }

    clone(): OrderHeaderStatsDto {
        const json = this.toJSON();
        let result = new OrderHeaderStatsDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderStatsDto {
    quantityWorking: number;
    quantityDeleted: number;
    quantityFinished: number;
    quantityNotStarted: number;
    quantityWaiting: number;
    quantityTotal: number;
}

export class OrderHeaderCountPerHourDto implements IOrderHeaderCountPerHourDto {
    orderHeaderCountPerHour: number;
    timeRange: string | undefined;

    constructor(data?: IOrderHeaderCountPerHourDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderHeaderCountPerHour = _data["orderHeaderCountPerHour"];
            this.timeRange = _data["timeRange"];
        }
    }

    static fromJS(data: any): OrderHeaderCountPerHourDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderCountPerHourDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderHeaderCountPerHour"] = this.orderHeaderCountPerHour;
        data["timeRange"] = this.timeRange;
        return data;
    }

    clone(): OrderHeaderCountPerHourDto {
        const json = this.toJSON();
        let result = new OrderHeaderCountPerHourDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderCountPerHourDto {
    orderHeaderCountPerHour: number;
    timeRange: string | undefined;
}

export class OrderHeaderFinishedCountPerHourDto implements IOrderHeaderFinishedCountPerHourDto {
    lastOrderHeaderControlFinishTime: Date | undefined;
    totalCount: number;
    orderHeaderCountPerHour: OrderHeaderCountPerHourDto[] | undefined;

    constructor(data?: IOrderHeaderFinishedCountPerHourDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastOrderHeaderControlFinishTime = _data["lastOrderHeaderControlFinishTime"] ? new Date(_data["lastOrderHeaderControlFinishTime"].toString()) : <any>undefined;
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["orderHeaderCountPerHour"])) {
                this.orderHeaderCountPerHour = [] as any;
                for (let item of _data["orderHeaderCountPerHour"])
                    this.orderHeaderCountPerHour.push(OrderHeaderCountPerHourDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderHeaderFinishedCountPerHourDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeaderFinishedCountPerHourDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastOrderHeaderControlFinishTime"] = this.lastOrderHeaderControlFinishTime ? this.lastOrderHeaderControlFinishTime.toISOString() : <any>undefined;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.orderHeaderCountPerHour)) {
            data["orderHeaderCountPerHour"] = [];
            for (let item of this.orderHeaderCountPerHour)
                data["orderHeaderCountPerHour"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderHeaderFinishedCountPerHourDto {
        const json = this.toJSON();
        let result = new OrderHeaderFinishedCountPerHourDto();
        result.init(json);
        return result;
    }
}

export interface IOrderHeaderFinishedCountPerHourDto {
    lastOrderHeaderControlFinishTime: Date | undefined;
    totalCount: number;
    orderHeaderCountPerHour: OrderHeaderCountPerHourDto[] | undefined;
}

export class CreateWorkActivityDetailRequestDto implements ICreateWorkActivityDetailRequestDto {
    workActivityId: number;
    orderHeaderIdList: number[] | undefined;
    shippingTypeIdList: number[] | undefined;
    controlPointIdList: number[] | undefined;
    collectPointList: string[] | undefined;
    erpEntegreId: string[] | undefined;
    companyId: number;
    warehouseId: number;
    clientCode: string | undefined;
    adresNo: number;

    constructor(data?: ICreateWorkActivityDetailRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workActivityId = _data["workActivityId"];
            if (Array.isArray(_data["orderHeaderIdList"])) {
                this.orderHeaderIdList = [] as any;
                for (let item of _data["orderHeaderIdList"])
                    this.orderHeaderIdList.push(item);
            }
            if (Array.isArray(_data["shippingTypeIdList"])) {
                this.shippingTypeIdList = [] as any;
                for (let item of _data["shippingTypeIdList"])
                    this.shippingTypeIdList.push(item);
            }
            if (Array.isArray(_data["controlPointIdList"])) {
                this.controlPointIdList = [] as any;
                for (let item of _data["controlPointIdList"])
                    this.controlPointIdList.push(item);
            }
            if (Array.isArray(_data["collectPointList"])) {
                this.collectPointList = [] as any;
                for (let item of _data["collectPointList"])
                    this.collectPointList.push(item);
            }
            if (Array.isArray(_data["erpEntegreId"])) {
                this.erpEntegreId = [] as any;
                for (let item of _data["erpEntegreId"])
                    this.erpEntegreId.push(item);
            }
            this.companyId = _data["companyId"];
            this.warehouseId = _data["warehouseId"];
            this.clientCode = _data["clientCode"];
            this.adresNo = _data["adresNo"];
        }
    }

    static fromJS(data: any): CreateWorkActivityDetailRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkActivityDetailRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workActivityId"] = this.workActivityId;
        if (Array.isArray(this.orderHeaderIdList)) {
            data["orderHeaderIdList"] = [];
            for (let item of this.orderHeaderIdList)
                data["orderHeaderIdList"].push(item);
        }
        if (Array.isArray(this.shippingTypeIdList)) {
            data["shippingTypeIdList"] = [];
            for (let item of this.shippingTypeIdList)
                data["shippingTypeIdList"].push(item);
        }
        if (Array.isArray(this.controlPointIdList)) {
            data["controlPointIdList"] = [];
            for (let item of this.controlPointIdList)
                data["controlPointIdList"].push(item);
        }
        if (Array.isArray(this.collectPointList)) {
            data["collectPointList"] = [];
            for (let item of this.collectPointList)
                data["collectPointList"].push(item);
        }
        if (Array.isArray(this.erpEntegreId)) {
            data["erpEntegreId"] = [];
            for (let item of this.erpEntegreId)
                data["erpEntegreId"].push(item);
        }
        data["companyId"] = this.companyId;
        data["warehouseId"] = this.warehouseId;
        data["clientCode"] = this.clientCode;
        data["adresNo"] = this.adresNo;
        return data;
    }

    clone(): CreateWorkActivityDetailRequestDto {
        const json = this.toJSON();
        let result = new CreateWorkActivityDetailRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICreateWorkActivityDetailRequestDto {
    workActivityId: number;
    orderHeaderIdList: number[] | undefined;
    shippingTypeIdList: number[] | undefined;
    controlPointIdList: number[] | undefined;
    collectPointList: string[] | undefined;
    erpEntegreId: string[] | undefined;
    companyId: number;
    warehouseId: number;
    clientCode: string | undefined;
    adresNo: number;
}

export class ProductSmallDto implements IProductSmallDto {
    code: string | undefined;
    definition: string | undefined;
    definition2: string | undefined;
    manufacturer: string | undefined;
    isFifo: boolean;
    natraShelf: string | undefined;
    company: CompanyDto;
    id: number;

    constructor(data?: IProductSmallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.definition2 = _data["definition2"];
            this.manufacturer = _data["manufacturer"];
            this.isFifo = _data["isFifo"];
            this.natraShelf = _data["natraShelf"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductSmallDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSmallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["definition2"] = this.definition2;
        data["manufacturer"] = this.manufacturer;
        data["isFifo"] = this.isFifo;
        data["natraShelf"] = this.natraShelf;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductSmallDto {
        const json = this.toJSON();
        let result = new ProductSmallDto();
        result.init(json);
        return result;
    }
}

export interface IProductSmallDto {
    code: string | undefined;
    definition: string | undefined;
    definition2: string | undefined;
    manufacturer: string | undefined;
    isFifo: boolean;
    natraShelf: string | undefined;
    company: CompanyDto;
    id: number;
}

export class OrderDetailPdaDto implements IOrderDetailPdaDto {
    orderHeader: OrderHeaderPdaDto;
    product: ProductSmallDto;
    quantity: number;
    quantityShipped: number;
    quantityCollected: number;
    quantityReplacement: number;
    quantityNeedToCollect: number;
    quantityDiff: number;
    id: number;

    constructor(data?: IOrderDetailPdaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderHeader = _data["orderHeader"] ? OrderHeaderPdaDto.fromJS(_data["orderHeader"]) : <any>undefined;
            this.product = _data["product"] ? ProductSmallDto.fromJS(_data["product"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.quantityShipped = _data["quantityShipped"];
            this.quantityCollected = _data["quantityCollected"];
            this.quantityReplacement = _data["quantityReplacement"];
            this.quantityNeedToCollect = _data["quantityNeedToCollect"];
            this.quantityDiff = _data["quantityDiff"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderDetailPdaDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailPdaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderHeader"] = this.orderHeader ? this.orderHeader.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["quantityShipped"] = this.quantityShipped;
        data["quantityCollected"] = this.quantityCollected;
        data["quantityReplacement"] = this.quantityReplacement;
        data["quantityNeedToCollect"] = this.quantityNeedToCollect;
        data["quantityDiff"] = this.quantityDiff;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderDetailPdaDto {
        const json = this.toJSON();
        let result = new OrderDetailPdaDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailPdaDto {
    orderHeader: OrderHeaderPdaDto;
    product: ProductSmallDto;
    quantity: number;
    quantityShipped: number;
    quantityCollected: number;
    quantityReplacement: number;
    quantityNeedToCollect: number;
    quantityDiff: number;
    id: number;
}

export class ShelfSimpleDto implements IShelfSimpleDto {
    fullAddress: string | undefined;
    weight: number;
    id: number;

    constructor(data?: IShelfSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullAddress = _data["fullAddress"];
            this.weight = _data["weight"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShelfSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShelfSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullAddress"] = this.fullAddress;
        data["weight"] = this.weight;
        data["id"] = this.id;
        return data;
    }

    clone(): ShelfSimpleDto {
        const json = this.toJSON();
        let result = new ShelfSimpleDto();
        result.init(json);
        return result;
    }
}

export interface IShelfSimpleDto {
    fullAddress: string | undefined;
    weight: number;
    id: number;
}

export class StockShelfQuantityDto implements IStockShelfQuantityDto {
    shelf: ShelfSimpleDto;
    quantity: number;

    constructor(data?: IStockShelfQuantityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shelf = _data["shelf"] ? ShelfSimpleDto.fromJS(_data["shelf"]) : <any>undefined;
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): StockShelfQuantityDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockShelfQuantityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shelf"] = this.shelf ? this.shelf.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): StockShelfQuantityDto {
        const json = this.toJSON();
        let result = new StockShelfQuantityDto();
        result.init(json);
        return result;
    }
}

export interface IStockShelfQuantityDto {
    shelf: ShelfSimpleDto;
    quantity: number;
}

export class PickingSuggestionDto implements IPickingSuggestionDto {
    product: ProductDto;
    shelfForPicking: StockShelfQuantityDto;
    quantityWillBePicked: number;
    sourceId: number;
    controlPoint: ControlPoint;
    collectPoint: string | undefined;

    constructor(data?: IPickingSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.shelfForPicking = _data["shelfForPicking"] ? StockShelfQuantityDto.fromJS(_data["shelfForPicking"]) : <any>undefined;
            this.quantityWillBePicked = _data["quantityWillBePicked"];
            this.sourceId = _data["sourceId"];
            this.controlPoint = _data["controlPoint"] ? ControlPoint.fromJS(_data["controlPoint"]) : <any>undefined;
            this.collectPoint = _data["collectPoint"];
        }
    }

    static fromJS(data: any): PickingSuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PickingSuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["shelfForPicking"] = this.shelfForPicking ? this.shelfForPicking.toJSON() : <any>undefined;
        data["quantityWillBePicked"] = this.quantityWillBePicked;
        data["sourceId"] = this.sourceId;
        data["controlPoint"] = this.controlPoint ? this.controlPoint.toJSON() : <any>undefined;
        data["collectPoint"] = this.collectPoint;
        return data;
    }

    clone(): PickingSuggestionDto {
        const json = this.toJSON();
        let result = new PickingSuggestionDto();
        result.init(json);
        return result;
    }
}

export interface IPickingSuggestionDto {
    product: ProductDto;
    shelfForPicking: StockShelfQuantityDto;
    quantityWillBePicked: number;
    sourceId: number;
    controlPoint: ControlPoint;
    collectPoint: string | undefined;
}

export class OrderPickingDto implements IOrderPickingDto {
    orderDetailList: OrderDetailPdaDto[] | undefined;
    pickingSuggestionList: PickingSuggestionDto[] | undefined;

    constructor(data?: IOrderPickingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderDetailList"])) {
                this.orderDetailList = [] as any;
                for (let item of _data["orderDetailList"])
                    this.orderDetailList.push(OrderDetailPdaDto.fromJS(item));
            }
            if (Array.isArray(_data["pickingSuggestionList"])) {
                this.pickingSuggestionList = [] as any;
                for (let item of _data["pickingSuggestionList"])
                    this.pickingSuggestionList.push(PickingSuggestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderPickingDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPickingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderDetailList)) {
            data["orderDetailList"] = [];
            for (let item of this.orderDetailList)
                data["orderDetailList"].push(item.toJSON());
        }
        if (Array.isArray(this.pickingSuggestionList)) {
            data["pickingSuggestionList"] = [];
            for (let item of this.pickingSuggestionList)
                data["pickingSuggestionList"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderPickingDto {
        const json = this.toJSON();
        let result = new OrderPickingDto();
        result.init(json);
        return result;
    }
}

export interface IOrderPickingDto {
    orderDetailList: OrderDetailPdaDto[] | undefined;
    pickingSuggestionList: PickingSuggestionDto[] | undefined;
}

export class OrderCancelReplacementDto implements IOrderCancelReplacementDto {
    orderDetailId: number;
    product: ProductDto;
    quantityForReplacement: number;
    quantityReplaced: number;
    readonly isFinished: boolean;

    constructor(data?: IOrderCancelReplacementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderDetailId = _data["orderDetailId"];
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.quantityForReplacement = _data["quantityForReplacement"];
            this.quantityReplaced = _data["quantityReplaced"];
            (<any>this).isFinished = _data["isFinished"];
        }
    }

    static fromJS(data: any): OrderCancelReplacementDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCancelReplacementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderDetailId"] = this.orderDetailId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantityForReplacement"] = this.quantityForReplacement;
        data["quantityReplaced"] = this.quantityReplaced;
        data["isFinished"] = this.isFinished;
        return data;
    }

    clone(): OrderCancelReplacementDto {
        const json = this.toJSON();
        let result = new OrderCancelReplacementDto();
        result.init(json);
        return result;
    }
}

export interface IOrderCancelReplacementDto {
    orderDetailId: number;
    product: ProductDto;
    quantityForReplacement: number;
    quantityReplaced: number;
    isFinished: boolean;
}

export class InvoiceTotalByDate implements IInvoiceTotalByDate {
    date: Date;
    totalPrice: number;

    constructor(data?: IInvoiceTotalByDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): InvoiceTotalByDate {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceTotalByDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["totalPrice"] = this.totalPrice;
        return data;
    }

    clone(): InvoiceTotalByDate {
        const json = this.toJSON();
        let result = new InvoiceTotalByDate();
        result.init(json);
        return result;
    }
}

export interface IInvoiceTotalByDate {
    date: Date;
    totalPrice: number;
}

export class WorkActionDto implements IWorkActionDto {
    workActivity: WorkActivityDto;
    workActionType: WorkActionType;
    startTime: Date;
    finishTime: Date;
    processUser: UserDto;
    isFinished: boolean;
    isDeleted: boolean;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    id: number;

    constructor(data?: IWorkActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workActivity = _data["workActivity"] ? WorkActivityDto.fromJS(_data["workActivity"]) : <any>undefined;
            this.workActionType = _data["workActionType"] ? WorkActionType.fromJS(_data["workActionType"]) : <any>undefined;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : <any>undefined;
            this.processUser = _data["processUser"] ? UserDto.fromJS(_data["processUser"]) : <any>undefined;
            this.isFinished = _data["isFinished"];
            this.isDeleted = _data["isDeleted"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WorkActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workActivity"] = this.workActivity ? this.workActivity.toJSON() : <any>undefined;
        data["workActionType"] = this.workActionType ? this.workActionType.toJSON() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["processUser"] = this.processUser ? this.processUser.toJSON() : <any>undefined;
        data["isFinished"] = this.isFinished;
        data["isDeleted"] = this.isDeleted;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): WorkActionDto {
        const json = this.toJSON();
        let result = new WorkActionDto();
        result.init(json);
        return result;
    }
}

export interface IWorkActionDto {
    workActivity: WorkActivityDto;
    workActionType: WorkActionType;
    startTime: Date;
    finishTime: Date;
    processUser: UserDto;
    isFinished: boolean;
    isDeleted: boolean;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    id: number;
}

export class WorkActionProcessDto implements IWorkActionProcessDto {
    workAction: WorkActionDto;
    sourceId: number;
    product: Product;
    quantity: number;
    container: Container;
    shelfFrom: Shelf;
    shelfTo: Shelf;
    stCurrentQuantity: number;
    stShelf: Shelf;
    currentQuantity: number;
    id: number;
    quantityCollected: number;
    user: UserDto;
    creatorUserId: number;
    readonly isSelected: boolean;
    creationTime: Date;

    constructor(data?: IWorkActionProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workAction = _data["workAction"] ? WorkActionDto.fromJS(_data["workAction"]) : <any>undefined;
            this.sourceId = _data["sourceId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.container = _data["container"] ? Container.fromJS(_data["container"]) : <any>undefined;
            this.shelfFrom = _data["shelfFrom"] ? Shelf.fromJS(_data["shelfFrom"]) : <any>undefined;
            this.shelfTo = _data["shelfTo"] ? Shelf.fromJS(_data["shelfTo"]) : <any>undefined;
            this.stCurrentQuantity = _data["stCurrentQuantity"];
            this.stShelf = _data["stShelf"] ? Shelf.fromJS(_data["stShelf"]) : <any>undefined;
            this.currentQuantity = _data["currentQuantity"];
            this.id = _data["id"];
            this.quantityCollected = _data["quantityCollected"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            (<any>this).isSelected = _data["isSelected"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkActionProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkActionProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workAction"] = this.workAction ? this.workAction.toJSON() : <any>undefined;
        data["sourceId"] = this.sourceId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["container"] = this.container ? this.container.toJSON() : <any>undefined;
        data["shelfFrom"] = this.shelfFrom ? this.shelfFrom.toJSON() : <any>undefined;
        data["shelfTo"] = this.shelfTo ? this.shelfTo.toJSON() : <any>undefined;
        data["stCurrentQuantity"] = this.stCurrentQuantity;
        data["stShelf"] = this.stShelf ? this.stShelf.toJSON() : <any>undefined;
        data["currentQuantity"] = this.currentQuantity;
        data["id"] = this.id;
        data["quantityCollected"] = this.quantityCollected;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["isSelected"] = this.isSelected;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): WorkActionProcessDto {
        const json = this.toJSON();
        let result = new WorkActionProcessDto();
        result.init(json);
        return result;
    }
}

export interface IWorkActionProcessDto {
    workAction: WorkActionDto;
    sourceId: number;
    product: Product;
    quantity: number;
    container: Container;
    shelfFrom: Shelf;
    shelfTo: Shelf;
    stCurrentQuantity: number;
    stShelf: Shelf;
    currentQuantity: number;
    id: number;
    quantityCollected: number;
    user: UserDto;
    creatorUserId: number;
    isSelected: boolean;
    creationTime: Date;
}

export class Package implements IPackage {
    company: Company;
    warehouse: Warehouse;
    orderHeader: OrderHeader;
    client: Client;
    sizeWidth: number;
    sizeLength: number;
    sizeHeight: number;
    deci: number;
    tareWeight: number;
    no: string | undefined;
    readonly measure: string | undefined;
    readonly volume: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.company = new Company();
            this.warehouse = new Warehouse();
            this.orderHeader = new OrderHeader();
            this.client = new Client();
            this.sizeWidth = 0;
            this.sizeLength = 0;
            this.sizeHeight = 0;
            this.deci = 0;
            this.tareWeight = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.orderHeader = _data["orderHeader"] ? OrderHeader.fromJS(_data["orderHeader"]) : new OrderHeader();
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : new Client();
            this.sizeWidth = _data["sizeWidth"] !== undefined ? _data["sizeWidth"] : 0;
            this.sizeLength = _data["sizeLength"] !== undefined ? _data["sizeLength"] : 0;
            this.sizeHeight = _data["sizeHeight"] !== undefined ? _data["sizeHeight"] : 0;
            this.deci = _data["deci"] !== undefined ? _data["deci"] : 0;
            this.tareWeight = _data["tareWeight"] !== undefined ? _data["tareWeight"] : 0;
            this.no = _data["no"];
            (<any>this).measure = _data["measure"];
            (<any>this).volume = _data["volume"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Package {
        data = typeof data === 'object' ? data : {};
        let result = new Package();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["orderHeader"] = this.orderHeader ? this.orderHeader.toJSON() : <any>undefined;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["sizeWidth"] = this.sizeWidth;
        data["sizeLength"] = this.sizeLength;
        data["sizeHeight"] = this.sizeHeight;
        data["deci"] = this.deci;
        data["tareWeight"] = this.tareWeight;
        data["no"] = this.no;
        data["measure"] = this.measure;
        data["volume"] = this.volume;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Package {
        const json = this.toJSON();
        let result = new Package();
        result.init(json);
        return result;
    }
}

export interface IPackage {
    company: Company;
    warehouse: Warehouse;
    orderHeader: OrderHeader;
    client: Client;
    sizeWidth: number;
    sizeLength: number;
    sizeHeight: number;
    deci: number;
    tareWeight: number;
    no: string | undefined;
    measure: string | undefined;
    volume: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class PackageDetail implements IPackageDetail {
    package: Package;
    product: Product;
    quantity: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPackageDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.package = new Package();
            this.product = new Product();
            this.quantity = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.package = _data["package"] ? Package.fromJS(_data["package"]) : new Package();
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : new Product();
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : 0;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PackageDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PackageDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["package"] = this.package ? this.package.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): PackageDetail {
        const json = this.toJSON();
        let result = new PackageDetail();
        result.init(json);
        return result;
    }
}

export interface IPackageDetail {
    package: Package;
    product: Product;
    quantity: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class ControllerDto implements IControllerDto {
    controller: UserDto;
    quantityOrderControl: number;
    quantityOrderDetailControl: number;
    quantityProductControl: number;
    sourceIdList: number[] | undefined;

    constructor(data?: IControllerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.controller = _data["controller"] ? UserDto.fromJS(_data["controller"]) : <any>undefined;
            this.quantityOrderControl = _data["quantityOrderControl"];
            this.quantityOrderDetailControl = _data["quantityOrderDetailControl"];
            this.quantityProductControl = _data["quantityProductControl"];
            if (Array.isArray(_data["sourceIdList"])) {
                this.sourceIdList = [] as any;
                for (let item of _data["sourceIdList"])
                    this.sourceIdList.push(item);
            }
        }
    }

    static fromJS(data: any): ControllerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ControllerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controller"] = this.controller ? this.controller.toJSON() : <any>undefined;
        data["quantityOrderControl"] = this.quantityOrderControl;
        data["quantityOrderDetailControl"] = this.quantityOrderDetailControl;
        data["quantityProductControl"] = this.quantityProductControl;
        if (Array.isArray(this.sourceIdList)) {
            data["sourceIdList"] = [];
            for (let item of this.sourceIdList)
                data["sourceIdList"].push(item);
        }
        return data;
    }

    clone(): ControllerDto {
        const json = this.toJSON();
        let result = new ControllerDto();
        result.init(json);
        return result;
    }
}

export interface IControllerDto {
    controller: UserDto;
    quantityOrderControl: number;
    quantityOrderDetailControl: number;
    quantityProductControl: number;
    sourceIdList: number[] | undefined;
}

export class QuantityControlPerHourDto implements IQuantityControlPerHourDto {
    quantityOrderDetailControlPerHour: number;
    quantityOrderHeaderControlPerHour: number;
    quantityProductControlPerHour: number;
    timeRange: string | undefined;

    constructor(data?: IQuantityControlPerHourDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantityOrderDetailControlPerHour = _data["quantityOrderDetailControlPerHour"];
            this.quantityOrderHeaderControlPerHour = _data["quantityOrderHeaderControlPerHour"];
            this.quantityProductControlPerHour = _data["quantityProductControlPerHour"];
            this.timeRange = _data["timeRange"];
        }
    }

    static fromJS(data: any): QuantityControlPerHourDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuantityControlPerHourDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantityOrderDetailControlPerHour"] = this.quantityOrderDetailControlPerHour;
        data["quantityOrderHeaderControlPerHour"] = this.quantityOrderHeaderControlPerHour;
        data["quantityProductControlPerHour"] = this.quantityProductControlPerHour;
        data["timeRange"] = this.timeRange;
        return data;
    }

    clone(): QuantityControlPerHourDto {
        const json = this.toJSON();
        let result = new QuantityControlPerHourDto();
        result.init(json);
        return result;
    }
}

export interface IQuantityControlPerHourDto {
    quantityOrderDetailControlPerHour: number;
    quantityOrderHeaderControlPerHour: number;
    quantityProductControlPerHour: number;
    timeRange: string | undefined;
}

export class ControllerPerHourDto implements IControllerPerHourDto {
    controller: UserDto;
    quantityOrderHeaderControl: number;
    quantityOrderDetailControl: number;
    quantityProductControl: number;
    sourceIdList: number[] | undefined;
    quantityControlPerHour: QuantityControlPerHourDto[] | undefined;

    constructor(data?: IControllerPerHourDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.controller = _data["controller"] ? UserDto.fromJS(_data["controller"]) : <any>undefined;
            this.quantityOrderHeaderControl = _data["quantityOrderHeaderControl"];
            this.quantityOrderDetailControl = _data["quantityOrderDetailControl"];
            this.quantityProductControl = _data["quantityProductControl"];
            if (Array.isArray(_data["sourceIdList"])) {
                this.sourceIdList = [] as any;
                for (let item of _data["sourceIdList"])
                    this.sourceIdList.push(item);
            }
            if (Array.isArray(_data["quantityControlPerHour"])) {
                this.quantityControlPerHour = [] as any;
                for (let item of _data["quantityControlPerHour"])
                    this.quantityControlPerHour.push(QuantityControlPerHourDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ControllerPerHourDto {
        data = typeof data === 'object' ? data : {};
        let result = new ControllerPerHourDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controller"] = this.controller ? this.controller.toJSON() : <any>undefined;
        data["quantityOrderHeaderControl"] = this.quantityOrderHeaderControl;
        data["quantityOrderDetailControl"] = this.quantityOrderDetailControl;
        data["quantityProductControl"] = this.quantityProductControl;
        if (Array.isArray(this.sourceIdList)) {
            data["sourceIdList"] = [];
            for (let item of this.sourceIdList)
                data["sourceIdList"].push(item);
        }
        if (Array.isArray(this.quantityControlPerHour)) {
            data["quantityControlPerHour"] = [];
            for (let item of this.quantityControlPerHour)
                data["quantityControlPerHour"].push(item.toJSON());
        }
        return data;
    }

    clone(): ControllerPerHourDto {
        const json = this.toJSON();
        let result = new ControllerPerHourDto();
        result.init(json);
        return result;
    }
}

export interface IControllerPerHourDto {
    controller: UserDto;
    quantityOrderHeaderControl: number;
    quantityOrderDetailControl: number;
    quantityProductControl: number;
    sourceIdList: number[] | undefined;
    quantityControlPerHour: QuantityControlPerHourDto[] | undefined;
}

export class TableDto implements ITableDto {
    tableName: string | undefined;
    tableData: string | undefined;

    constructor(data?: ITableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tableName = _data["tableName"];
            this.tableData = _data["tableData"];
        }
    }

    static fromJS(data: any): TableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["tableData"] = this.tableData;
        return data;
    }

    clone(): TableDto {
        const json = this.toJSON();
        let result = new TableDto();
        result.init(json);
        return result;
    }
}

export interface ITableDto {
    tableName: string | undefined;
    tableData: string | undefined;
}

export class PrintRequestFromPrintingDto implements IPrintRequestFromPrintingDto {
    xmlDesignBase64String: string | undefined;
    hdr: any | undefined;
    tableDto: TableDto[] | undefined;
    type: number;
    printRequestId: number;
    warehouseId: number;
    printerName: string | undefined;

    constructor(data?: IPrintRequestFromPrintingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.xmlDesignBase64String = _data["xmlDesignBase64String"];
            this.hdr = _data["hdr"];
            if (Array.isArray(_data["tableDto"])) {
                this.tableDto = [] as any;
                for (let item of _data["tableDto"])
                    this.tableDto.push(TableDto.fromJS(item));
            }
            this.type = _data["type"];
            this.printRequestId = _data["printRequestId"];
            this.warehouseId = _data["warehouseId"];
            this.printerName = _data["printerName"];
        }
    }

    static fromJS(data: any): PrintRequestFromPrintingDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrintRequestFromPrintingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["xmlDesignBase64String"] = this.xmlDesignBase64String;
        data["hdr"] = this.hdr;
        if (Array.isArray(this.tableDto)) {
            data["tableDto"] = [];
            for (let item of this.tableDto)
                data["tableDto"].push(item.toJSON());
        }
        data["type"] = this.type;
        data["printRequestId"] = this.printRequestId;
        data["warehouseId"] = this.warehouseId;
        data["printerName"] = this.printerName;
        return data;
    }

    clone(): PrintRequestFromPrintingDto {
        const json = this.toJSON();
        let result = new PrintRequestFromPrintingDto();
        result.init(json);
        return result;
    }
}

export interface IPrintRequestFromPrintingDto {
    xmlDesignBase64String: string | undefined;
    hdr: any | undefined;
    tableDto: TableDto[] | undefined;
    type: number;
    printRequestId: number;
    warehouseId: number;
    printerName: string | undefined;
}

export enum PrintType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
}

export class PrintRequest implements IPrintRequest {
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    type: PrintType;
    objectId: number;
    code: string | undefined;
    quantity: number;
    printSize: string | undefined;
    isPrinted: boolean;
    printDate: Date | undefined;
    companyDataSourceId: number;
    userId: number;
    printPointName: string | undefined;
    eDocumentType: EDocumentType;
    isPrinting: boolean;
    printingDate: Date | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPrintRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.company = new Company();
            this.warehouse = new Warehouse();
            this.objectId = 0;
            this.quantity = 1;
            this.isPrinted = false;
            this.companyDataSourceId = 0;
            this.userId = 0;
            this.isPrinting = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.companyId = _data["companyId"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.warehouseId = _data["warehouseId"];
            this.type = _data["type"];
            this.objectId = _data["objectId"] !== undefined ? _data["objectId"] : 0;
            this.code = _data["code"];
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : 1;
            this.printSize = _data["printSize"];
            this.isPrinted = _data["isPrinted"] !== undefined ? _data["isPrinted"] : false;
            this.printDate = _data["printDate"] ? new Date(_data["printDate"].toString()) : <any>undefined;
            this.companyDataSourceId = _data["companyDataSourceId"] !== undefined ? _data["companyDataSourceId"] : 0;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : 0;
            this.printPointName = _data["printPointName"];
            this.eDocumentType = _data["eDocumentType"];
            this.isPrinting = _data["isPrinting"] !== undefined ? _data["isPrinting"] : false;
            this.printingDate = _data["printingDate"] ? new Date(_data["printingDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PrintRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PrintRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["type"] = this.type;
        data["objectId"] = this.objectId;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        data["printSize"] = this.printSize;
        data["isPrinted"] = this.isPrinted;
        data["printDate"] = this.printDate ? this.printDate.toISOString() : <any>undefined;
        data["companyDataSourceId"] = this.companyDataSourceId;
        data["userId"] = this.userId;
        data["printPointName"] = this.printPointName;
        data["eDocumentType"] = this.eDocumentType;
        data["isPrinting"] = this.isPrinting;
        data["printingDate"] = this.printingDate ? this.printingDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): PrintRequest {
        const json = this.toJSON();
        let result = new PrintRequest();
        result.init(json);
        return result;
    }
}

export interface IPrintRequest {
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    type: PrintType;
    objectId: number;
    code: string | undefined;
    quantity: number;
    printSize: string | undefined;
    isPrinted: boolean;
    printDate: Date | undefined;
    companyDataSourceId: number;
    userId: number;
    printPointName: string | undefined;
    eDocumentType: EDocumentType;
    isPrinting: boolean;
    printingDate: Date | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class PrintRequestDto implements IPrintRequestDto {
    companyId: number;
    warehouseId: number;
    type: PrintType;
    objectId: number;
    code: string | undefined;
    quantity: number;
    printSize: string | undefined;
    isPrinted: boolean;
    printDate: Date | undefined;
    printPointName: string | undefined;
    eDocumentType: EDocumentType;
    isPrinting: boolean;
    id: number;

    constructor(data?: IPrintRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.warehouseId = _data["warehouseId"];
            this.type = _data["type"];
            this.objectId = _data["objectId"];
            this.code = _data["code"];
            this.quantity = _data["quantity"];
            this.printSize = _data["printSize"];
            this.isPrinted = _data["isPrinted"];
            this.printDate = _data["printDate"] ? new Date(_data["printDate"].toString()) : <any>undefined;
            this.printPointName = _data["printPointName"];
            this.eDocumentType = _data["eDocumentType"];
            this.isPrinting = _data["isPrinting"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PrintRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrintRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["warehouseId"] = this.warehouseId;
        data["type"] = this.type;
        data["objectId"] = this.objectId;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        data["printSize"] = this.printSize;
        data["isPrinted"] = this.isPrinted;
        data["printDate"] = this.printDate ? this.printDate.toISOString() : <any>undefined;
        data["printPointName"] = this.printPointName;
        data["eDocumentType"] = this.eDocumentType;
        data["isPrinting"] = this.isPrinting;
        data["id"] = this.id;
        return data;
    }

    clone(): PrintRequestDto {
        const json = this.toJSON();
        let result = new PrintRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPrintRequestDto {
    companyId: number;
    warehouseId: number;
    type: PrintType;
    objectId: number;
    code: string | undefined;
    quantity: number;
    printSize: string | undefined;
    isPrinted: boolean;
    printDate: Date | undefined;
    printPointName: string | undefined;
    eDocumentType: EDocumentType;
    isPrinting: boolean;
    id: number;
}

export class BatchPrintRequestDto implements IBatchPrintRequestDto {
    fullAddressList: string[] | undefined;
    companyId: number;
    warehouseId: number;
    type: number;
    objectId: number;
    quantity: number;
    printSize: string | undefined;
    printPointName: string | undefined;

    constructor(data?: IBatchPrintRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fullAddressList"])) {
                this.fullAddressList = [] as any;
                for (let item of _data["fullAddressList"])
                    this.fullAddressList.push(item);
            }
            this.companyId = _data["companyId"];
            this.warehouseId = _data["warehouseId"];
            this.type = _data["type"];
            this.objectId = _data["objectId"];
            this.quantity = _data["quantity"];
            this.printSize = _data["printSize"];
            this.printPointName = _data["printPointName"];
        }
    }

    static fromJS(data: any): BatchPrintRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchPrintRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fullAddressList)) {
            data["fullAddressList"] = [];
            for (let item of this.fullAddressList)
                data["fullAddressList"].push(item);
        }
        data["companyId"] = this.companyId;
        data["warehouseId"] = this.warehouseId;
        data["type"] = this.type;
        data["objectId"] = this.objectId;
        data["quantity"] = this.quantity;
        data["printSize"] = this.printSize;
        data["printPointName"] = this.printPointName;
        return data;
    }

    clone(): BatchPrintRequestDto {
        const json = this.toJSON();
        let result = new BatchPrintRequestDto();
        result.init(json);
        return result;
    }
}

export interface IBatchPrintRequestDto {
    fullAddressList: string[] | undefined;
    companyId: number;
    warehouseId: number;
    type: number;
    objectId: number;
    quantity: number;
    printSize: string | undefined;
    printPointName: string | undefined;
}

export class BatchBarcodePrintRequestDto implements IBatchBarcodePrintRequestDto {
    barcodeList: string[] | undefined;
    sizeList: string[] | undefined;
    companyId: number;
    warehouseId: number;
    type: number;
    printPointName: string | undefined;

    constructor(data?: IBatchBarcodePrintRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["barcodeList"])) {
                this.barcodeList = [] as any;
                for (let item of _data["barcodeList"])
                    this.barcodeList.push(item);
            }
            if (Array.isArray(_data["sizeList"])) {
                this.sizeList = [] as any;
                for (let item of _data["sizeList"])
                    this.sizeList.push(item);
            }
            this.companyId = _data["companyId"];
            this.warehouseId = _data["warehouseId"];
            this.type = _data["type"];
            this.printPointName = _data["printPointName"];
        }
    }

    static fromJS(data: any): BatchBarcodePrintRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchBarcodePrintRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.barcodeList)) {
            data["barcodeList"] = [];
            for (let item of this.barcodeList)
                data["barcodeList"].push(item);
        }
        if (Array.isArray(this.sizeList)) {
            data["sizeList"] = [];
            for (let item of this.sizeList)
                data["sizeList"].push(item);
        }
        data["companyId"] = this.companyId;
        data["warehouseId"] = this.warehouseId;
        data["type"] = this.type;
        data["printPointName"] = this.printPointName;
        return data;
    }

    clone(): BatchBarcodePrintRequestDto {
        const json = this.toJSON();
        let result = new BatchBarcodePrintRequestDto();
        result.init(json);
        return result;
    }
}

export interface IBatchBarcodePrintRequestDto {
    barcodeList: string[] | undefined;
    sizeList: string[] | undefined;
    companyId: number;
    warehouseId: number;
    type: number;
    printPointName: string | undefined;
}

export class PrintPoint implements IPrintPoint {
    warehouse: Warehouse;
    warehouseId: number;
    name: string;
    id: number;

    constructor(data?: IPrintPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.warehouse = new Warehouse();
            this.name = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.warehouseId = _data["warehouseId"];
            this.name = _data["name"] !== undefined ? _data["name"] : "";
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PrintPoint {
        data = typeof data === 'object' ? data : {};
        let result = new PrintPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): PrintPoint {
        const json = this.toJSON();
        let result = new PrintPoint();
        result.init(json);
        return result;
    }
}

export interface IPrintPoint {
    warehouse: Warehouse;
    warehouseId: number;
    name: string;
    id: number;
}

export class PrintSize implements IPrintSize {
    type: PrintType;
    size: string | undefined;
    id: number;

    constructor(data?: IPrintSize) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.size = _data["size"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PrintSize {
        data = typeof data === 'object' ? data : {};
        let result = new PrintSize();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["size"] = this.size;
        data["id"] = this.id;
        return data;
    }

    clone(): PrintSize {
        const json = this.toJSON();
        let result = new PrintSize();
        result.init(json);
        return result;
    }
}

export interface IPrintSize {
    type: PrintType;
    size: string | undefined;
    id: number;
}

export class ProductQuantityWarehouseDifferenceDapper implements IProductQuantityWarehouseDifferenceDapper {
    overall_count: number;
    productCode: string | undefined;
    wms_Quantity_DEPO1: number;
    wms_Quantity_DEPO2: number;
    productId: number;

    constructor(data?: IProductQuantityWarehouseDifferenceDapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overall_count = _data["overall_count"];
            this.productCode = _data["productCode"];
            this.wms_Quantity_DEPO1 = _data["wms_Quantity_DEPO1"];
            this.wms_Quantity_DEPO2 = _data["wms_Quantity_DEPO2"];
            this.productId = _data["productId"];
        }
    }

    static fromJS(data: any): ProductQuantityWarehouseDifferenceDapper {
        data = typeof data === 'object' ? data : {};
        let result = new ProductQuantityWarehouseDifferenceDapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overall_count"] = this.overall_count;
        data["productCode"] = this.productCode;
        data["wms_Quantity_DEPO1"] = this.wms_Quantity_DEPO1;
        data["wms_Quantity_DEPO2"] = this.wms_Quantity_DEPO2;
        data["productId"] = this.productId;
        return data;
    }

    clone(): ProductQuantityWarehouseDifferenceDapper {
        const json = this.toJSON();
        let result = new ProductQuantityWarehouseDifferenceDapper();
        result.init(json);
        return result;
    }
}

export interface IProductQuantityWarehouseDifferenceDapper {
    overall_count: number;
    productCode: string | undefined;
    wms_Quantity_DEPO1: number;
    wms_Quantity_DEPO2: number;
    productId: number;
}

export class ProductQuantityWarehouseDifferenceDapperPagedResultDto implements IProductQuantityWarehouseDifferenceDapperPagedResultDto {
    totalCount: number;
    items: ProductQuantityWarehouseDifferenceDapper[] | undefined;

    constructor(data?: IProductQuantityWarehouseDifferenceDapperPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductQuantityWarehouseDifferenceDapper.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductQuantityWarehouseDifferenceDapperPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductQuantityWarehouseDifferenceDapperPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductQuantityWarehouseDifferenceDapperPagedResultDto {
        const json = this.toJSON();
        let result = new ProductQuantityWarehouseDifferenceDapperPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductQuantityWarehouseDifferenceDapperPagedResultDto {
    totalCount: number;
    items: ProductQuantityWarehouseDifferenceDapper[] | undefined;
}

export class ReportProductQuantityDiffDto implements IReportProductQuantityDiffDto {
    productId: number;
    productCode: string | undefined;
    productName: string | undefined;
    productManufacturer: string | undefined;
    companyId: number;
    companyCode: string | undefined;
    warehouseId: number;
    warehouseCode: string | undefined;
    warehouseName: string | undefined;
    storageId: number;
    storageCode: string | undefined;
    storageDefinition: string | undefined;
    quantity: number;
    quantityErp: number;
    shelfAddress: string | undefined;

    constructor(data?: IReportProductQuantityDiffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.productManufacturer = _data["productManufacturer"];
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseCode = _data["warehouseCode"];
            this.warehouseName = _data["warehouseName"];
            this.storageId = _data["storageId"];
            this.storageCode = _data["storageCode"];
            this.storageDefinition = _data["storageDefinition"];
            this.quantity = _data["quantity"];
            this.quantityErp = _data["quantityErp"];
            this.shelfAddress = _data["shelfAddress"];
        }
    }

    static fromJS(data: any): ReportProductQuantityDiffDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportProductQuantityDiffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productManufacturer"] = this.productManufacturer;
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        data["warehouseId"] = this.warehouseId;
        data["warehouseCode"] = this.warehouseCode;
        data["warehouseName"] = this.warehouseName;
        data["storageId"] = this.storageId;
        data["storageCode"] = this.storageCode;
        data["storageDefinition"] = this.storageDefinition;
        data["quantity"] = this.quantity;
        data["quantityErp"] = this.quantityErp;
        data["shelfAddress"] = this.shelfAddress;
        return data;
    }

    clone(): ReportProductQuantityDiffDto {
        const json = this.toJSON();
        let result = new ReportProductQuantityDiffDto();
        result.init(json);
        return result;
    }
}

export interface IReportProductQuantityDiffDto {
    productId: number;
    productCode: string | undefined;
    productName: string | undefined;
    productManufacturer: string | undefined;
    companyId: number;
    companyCode: string | undefined;
    warehouseId: number;
    warehouseCode: string | undefined;
    warehouseName: string | undefined;
    storageId: number;
    storageCode: string | undefined;
    storageDefinition: string | undefined;
    quantity: number;
    quantityErp: number;
    shelfAddress: string | undefined;
}

export class ReportProductQuantityDiffDtoPagedResultDto implements IReportProductQuantityDiffDtoPagedResultDto {
    totalCount: number;
    items: ReportProductQuantityDiffDto[] | undefined;

    constructor(data?: IReportProductQuantityDiffDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ReportProductQuantityDiffDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportProductQuantityDiffDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportProductQuantityDiffDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ReportProductQuantityDiffDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReportProductQuantityDiffDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReportProductQuantityDiffDtoPagedResultDto {
    totalCount: number;
    items: ReportProductQuantityDiffDto[] | undefined;
}

export class ContainerDto implements IContainerDto {
    client: ClientDto;
    product: ProductDto;
    entryDate: Date;
    quantity: number;
    quantityRemaining: number;
    shelf: Shelf;
    printed: boolean;
    readonly code: string | undefined;
    id: number;

    constructor(data?: IContainerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.client = _data["client"] ? ClientDto.fromJS(_data["client"]) : <any>undefined;
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.quantity = _data["quantity"];
            this.quantityRemaining = _data["quantityRemaining"];
            this.shelf = _data["shelf"] ? Shelf.fromJS(_data["shelf"]) : <any>undefined;
            this.printed = _data["printed"];
            (<any>this).code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ContainerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["quantityRemaining"] = this.quantityRemaining;
        data["shelf"] = this.shelf ? this.shelf.toJSON() : <any>undefined;
        data["printed"] = this.printed;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }

    clone(): ContainerDto {
        const json = this.toJSON();
        let result = new ContainerDto();
        result.init(json);
        return result;
    }
}

export interface IContainerDto {
    client: ClientDto;
    product: ProductDto;
    entryDate: Date;
    quantity: number;
    quantityRemaining: number;
    shelf: Shelf;
    printed: boolean;
    code: string | undefined;
    id: number;
}

export class StockMovementShelfDto implements IStockMovementShelfDto {
    company: CompanyDto;
    type: MovementType;
    product: ProductSmallDto;
    quantity: number;
    readonly quantityIn: number;
    readonly quantityOut: number;
    user: UserDto;
    shelf: Shelf;
    container: ContainerDto;
    creatorUserId: number;
    stockMovementType: StockMovementType;
    client: Client;
    creationTime: Date;
    documentNo: string | undefined;
    workActivity: WorkActivity;
    id: number;

    constructor(data?: IStockMovementShelfDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.type = _data["type"];
            this.product = _data["product"] ? ProductSmallDto.fromJS(_data["product"]) : <any>undefined;
            this.quantity = _data["quantity"];
            (<any>this).quantityIn = _data["quantityIn"];
            (<any>this).quantityOut = _data["quantityOut"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.shelf = _data["shelf"] ? Shelf.fromJS(_data["shelf"]) : <any>undefined;
            this.container = _data["container"] ? ContainerDto.fromJS(_data["container"]) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.stockMovementType = _data["stockMovementType"] ? StockMovementType.fromJS(_data["stockMovementType"]) : <any>undefined;
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.documentNo = _data["documentNo"];
            this.workActivity = _data["workActivity"] ? WorkActivity.fromJS(_data["workActivity"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StockMovementShelfDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockMovementShelfDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["quantityIn"] = this.quantityIn;
        data["quantityOut"] = this.quantityOut;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["shelf"] = this.shelf ? this.shelf.toJSON() : <any>undefined;
        data["container"] = this.container ? this.container.toJSON() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["stockMovementType"] = this.stockMovementType ? this.stockMovementType.toJSON() : <any>undefined;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["documentNo"] = this.documentNo;
        data["workActivity"] = this.workActivity ? this.workActivity.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): StockMovementShelfDto {
        const json = this.toJSON();
        let result = new StockMovementShelfDto();
        result.init(json);
        return result;
    }
}

export interface IStockMovementShelfDto {
    company: CompanyDto;
    type: MovementType;
    product: ProductSmallDto;
    quantity: number;
    quantityIn: number;
    quantityOut: number;
    user: UserDto;
    shelf: Shelf;
    container: ContainerDto;
    creatorUserId: number;
    stockMovementType: StockMovementType;
    client: Client;
    creationTime: Date;
    documentNo: string | undefined;
    workActivity: WorkActivity;
    id: number;
}

export class StockMovementShelfDtoPagedResultDto implements IStockMovementShelfDtoPagedResultDto {
    totalCount: number;
    items: StockMovementShelfDto[] | undefined;

    constructor(data?: IStockMovementShelfDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StockMovementShelfDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockMovementShelfDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockMovementShelfDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): StockMovementShelfDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StockMovementShelfDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStockMovementShelfDtoPagedResultDto {
    totalCount: number;
    items: StockMovementShelfDto[] | undefined;
}

export class ProductQuantityShelf implements IProductQuantityShelf {
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    storage: Storage;
    storageId: number;
    shelf: Shelf;
    shelfId: number;
    product: Product;
    productId: number;
    quantity: number;
    quantityIn: number;
    quantityOut: number;
    id: number;

    constructor(data?: IProductQuantityShelf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.companyId = _data["companyId"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.warehouseId = _data["warehouseId"];
            this.storage = _data["storage"] ? Storage.fromJS(_data["storage"]) : <any>undefined;
            this.storageId = _data["storageId"];
            this.shelf = _data["shelf"] ? Shelf.fromJS(_data["shelf"]) : <any>undefined;
            this.shelfId = _data["shelfId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.productId = _data["productId"];
            this.quantity = _data["quantity"];
            this.quantityIn = _data["quantityIn"];
            this.quantityOut = _data["quantityOut"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductQuantityShelf {
        data = typeof data === 'object' ? data : {};
        let result = new ProductQuantityShelf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["storageId"] = this.storageId;
        data["shelf"] = this.shelf ? this.shelf.toJSON() : <any>undefined;
        data["shelfId"] = this.shelfId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["quantityIn"] = this.quantityIn;
        data["quantityOut"] = this.quantityOut;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductQuantityShelf {
        const json = this.toJSON();
        let result = new ProductQuantityShelf();
        result.init(json);
        return result;
    }
}

export interface IProductQuantityShelf {
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    storage: Storage;
    storageId: number;
    shelf: Shelf;
    shelfId: number;
    product: Product;
    productId: number;
    quantity: number;
    quantityIn: number;
    quantityOut: number;
    id: number;
}

export class ProductQuantityShelfPagedResultDto implements IProductQuantityShelfPagedResultDto {
    totalCount: number;
    items: ProductQuantityShelf[] | undefined;

    constructor(data?: IProductQuantityShelfPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductQuantityShelf.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductQuantityShelfPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductQuantityShelfPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductQuantityShelfPagedResultDto {
        const json = this.toJSON();
        let result = new ProductQuantityShelfPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductQuantityShelfPagedResultDto {
    totalCount: number;
    items: ProductQuantityShelf[] | undefined;
}

export class EmptyShelfDto implements IEmptyShelfDto {
    companyCode: string | undefined;
    warehouseName: string | undefined;
    storageName: string | undefined;
    shelfAddress: string | undefined;

    constructor(data?: IEmptyShelfDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.warehouseName = _data["warehouseName"];
            this.storageName = _data["storageName"];
            this.shelfAddress = _data["shelfAddress"];
        }
    }

    static fromJS(data: any): EmptyShelfDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyShelfDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["warehouseName"] = this.warehouseName;
        data["storageName"] = this.storageName;
        data["shelfAddress"] = this.shelfAddress;
        return data;
    }

    clone(): EmptyShelfDto {
        const json = this.toJSON();
        let result = new EmptyShelfDto();
        result.init(json);
        return result;
    }
}

export interface IEmptyShelfDto {
    companyCode: string | undefined;
    warehouseName: string | undefined;
    storageName: string | undefined;
    shelfAddress: string | undefined;
}

export class EmptyShelfDtoPagedResultDto implements IEmptyShelfDtoPagedResultDto {
    totalCount: number;
    items: EmptyShelfDto[] | undefined;

    constructor(data?: IEmptyShelfDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmptyShelfDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmptyShelfDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyShelfDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): EmptyShelfDtoPagedResultDto {
        const json = this.toJSON();
        let result = new EmptyShelfDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEmptyShelfDtoPagedResultDto {
    totalCount: number;
    items: EmptyShelfDto[] | undefined;
}

export class FullShelfDto implements IFullShelfDto {
    companyCode: string | undefined;
    warehouseName: string | undefined;
    storageName: string | undefined;
    shelfAddress: string | undefined;

    constructor(data?: IFullShelfDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.warehouseName = _data["warehouseName"];
            this.storageName = _data["storageName"];
            this.shelfAddress = _data["shelfAddress"];
        }
    }

    static fromJS(data: any): FullShelfDto {
        data = typeof data === 'object' ? data : {};
        let result = new FullShelfDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["warehouseName"] = this.warehouseName;
        data["storageName"] = this.storageName;
        data["shelfAddress"] = this.shelfAddress;
        return data;
    }

    clone(): FullShelfDto {
        const json = this.toJSON();
        let result = new FullShelfDto();
        result.init(json);
        return result;
    }
}

export interface IFullShelfDto {
    companyCode: string | undefined;
    warehouseName: string | undefined;
    storageName: string | undefined;
    shelfAddress: string | undefined;
}

export class FullShelfDtoPagedResultDto implements IFullShelfDtoPagedResultDto {
    totalCount: number;
    items: FullShelfDto[] | undefined;

    constructor(data?: IFullShelfDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(FullShelfDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FullShelfDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FullShelfDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): FullShelfDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FullShelfDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFullShelfDtoPagedResultDto {
    totalCount: number;
    items: FullShelfDto[] | undefined;
}

export class StockOutDto implements IStockOutDto {
    product: Product;
    shelf: Shelf;
    isControlled: boolean;
    quantityInStorage: number;
    creatorUserId: number;
    user: UserDto;
    id: number;

    constructor(data?: IStockOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.shelf = _data["shelf"] ? Shelf.fromJS(_data["shelf"]) : <any>undefined;
            this.isControlled = _data["isControlled"];
            this.quantityInStorage = _data["quantityInStorage"];
            this.creatorUserId = _data["creatorUserId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StockOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["shelf"] = this.shelf ? this.shelf.toJSON() : <any>undefined;
        data["isControlled"] = this.isControlled;
        data["quantityInStorage"] = this.quantityInStorage;
        data["creatorUserId"] = this.creatorUserId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): StockOutDto {
        const json = this.toJSON();
        let result = new StockOutDto();
        result.init(json);
        return result;
    }
}

export interface IStockOutDto {
    product: Product;
    shelf: Shelf;
    isControlled: boolean;
    quantityInStorage: number;
    creatorUserId: number;
    user: UserDto;
    id: number;
}

export class StockOutDtoPagedResultDto implements IStockOutDtoPagedResultDto {
    totalCount: number;
    items: StockOutDto[] | undefined;

    constructor(data?: IStockOutDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StockOutDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockOutDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): StockOutDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StockOutDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStockOutDtoPagedResultDto {
    totalCount: number;
    items: StockOutDto[] | undefined;
}

export class TransferHeaderDto implements ITransferHeaderDto {
    code: string | undefined;
    movementType: MovementType;
    company: Company;
    transferType: TransferType;
    warehouse: Warehouse;
    warehouseFrom: Warehouse;
    warehouseTo: Warehouse;
    storage: Storage;
    storageFrom: Storage;
    storageTo: Storage;
    client: Client;
    sourceId: number;
    sourceCode: string | undefined;
    creationTime: Date;
    creatorUser: UserDto;
    notes: string | undefined;
    id: number;

    constructor(data?: ITransferHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.company = new Company();
            this.transferType = new TransferType();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.movementType = _data["movementType"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.transferType = _data["transferType"] ? TransferType.fromJS(_data["transferType"]) : new TransferType();
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.warehouseFrom = _data["warehouseFrom"] ? Warehouse.fromJS(_data["warehouseFrom"]) : <any>undefined;
            this.warehouseTo = _data["warehouseTo"] ? Warehouse.fromJS(_data["warehouseTo"]) : <any>undefined;
            this.storage = _data["storage"] ? Storage.fromJS(_data["storage"]) : <any>undefined;
            this.storageFrom = _data["storageFrom"] ? Storage.fromJS(_data["storageFrom"]) : <any>undefined;
            this.storageTo = _data["storageTo"] ? Storage.fromJS(_data["storageTo"]) : <any>undefined;
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>undefined;
            this.sourceId = _data["sourceId"];
            this.sourceCode = _data["sourceCode"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? UserDto.fromJS(_data["creatorUser"]) : <any>undefined;
            this.notes = _data["notes"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TransferHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["movementType"] = this.movementType;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["transferType"] = this.transferType ? this.transferType.toJSON() : <any>undefined;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseFrom"] = this.warehouseFrom ? this.warehouseFrom.toJSON() : <any>undefined;
        data["warehouseTo"] = this.warehouseTo ? this.warehouseTo.toJSON() : <any>undefined;
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["storageFrom"] = this.storageFrom ? this.storageFrom.toJSON() : <any>undefined;
        data["storageTo"] = this.storageTo ? this.storageTo.toJSON() : <any>undefined;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["sourceId"] = this.sourceId;
        data["sourceCode"] = this.sourceCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["notes"] = this.notes;
        data["id"] = this.id;
        return data;
    }

    clone(): TransferHeaderDto {
        const json = this.toJSON();
        let result = new TransferHeaderDto();
        result.init(json);
        return result;
    }
}

export interface ITransferHeaderDto {
    code: string | undefined;
    movementType: MovementType;
    company: Company;
    transferType: TransferType;
    warehouse: Warehouse;
    warehouseFrom: Warehouse;
    warehouseTo: Warehouse;
    storage: Storage;
    storageFrom: Storage;
    storageTo: Storage;
    client: Client;
    sourceId: number;
    sourceCode: string | undefined;
    creationTime: Date;
    creatorUser: UserDto;
    notes: string | undefined;
    id: number;
}

export class TransferDetailDto implements ITransferDetailDto {
    transferHeader: TransferHeaderDto;
    product: Product;
    quantity: number;
    shelfFrom: Shelf;
    shelfTo: Shelf;
    price: number;
    creationTime: Date;
    id: number;

    constructor(data?: ITransferDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.product = new Product();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transferHeader = _data["transferHeader"] ? TransferHeaderDto.fromJS(_data["transferHeader"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : new Product();
            this.quantity = _data["quantity"];
            this.shelfFrom = _data["shelfFrom"] ? Shelf.fromJS(_data["shelfFrom"]) : <any>undefined;
            this.shelfTo = _data["shelfTo"] ? Shelf.fromJS(_data["shelfTo"]) : <any>undefined;
            this.price = _data["price"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TransferDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transferHeader"] = this.transferHeader ? this.transferHeader.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["shelfFrom"] = this.shelfFrom ? this.shelfFrom.toJSON() : <any>undefined;
        data["shelfTo"] = this.shelfTo ? this.shelfTo.toJSON() : <any>undefined;
        data["price"] = this.price;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): TransferDetailDto {
        const json = this.toJSON();
        let result = new TransferDetailDto();
        result.init(json);
        return result;
    }
}

export interface ITransferDetailDto {
    transferHeader: TransferHeaderDto;
    product: Product;
    quantity: number;
    shelfFrom: Shelf;
    shelfTo: Shelf;
    price: number;
    creationTime: Date;
    id: number;
}

export class TransferDetailDtoPagedResultDto implements ITransferDetailDtoPagedResultDto {
    totalCount: number;
    items: TransferDetailDto[] | undefined;

    constructor(data?: ITransferDetailDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TransferDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransferDetailDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferDetailDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): TransferDetailDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TransferDetailDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITransferDetailDtoPagedResultDto {
    totalCount: number;
    items: TransferDetailDto[] | undefined;
}

export class TransferDetail implements ITransferDetail {
    transferHeader: TransferHeader;
    transferHeaderId: number;
    product: Product;
    productId: number;
    quantity: number;
    shelfFrom: Shelf;
    shelfFromId: number | undefined;
    shelfTo: Shelf;
    shelfToId: number | undefined;
    price: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITransferDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.transferHeader = new TransferHeader();
            this.product = new Product();
            this.quantity = 1;
            this.price = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transferHeader = _data["transferHeader"] ? TransferHeader.fromJS(_data["transferHeader"]) : new TransferHeader();
            this.transferHeaderId = _data["transferHeaderId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : new Product();
            this.productId = _data["productId"];
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : 1;
            this.shelfFrom = _data["shelfFrom"] ? Shelf.fromJS(_data["shelfFrom"]) : <any>undefined;
            this.shelfFromId = _data["shelfFromId"];
            this.shelfTo = _data["shelfTo"] ? Shelf.fromJS(_data["shelfTo"]) : <any>undefined;
            this.shelfToId = _data["shelfToId"];
            this.price = _data["price"] !== undefined ? _data["price"] : 0;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TransferDetail {
        data = typeof data === 'object' ? data : {};
        let result = new TransferDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transferHeader"] = this.transferHeader ? this.transferHeader.toJSON() : <any>undefined;
        data["transferHeaderId"] = this.transferHeaderId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["shelfFrom"] = this.shelfFrom ? this.shelfFrom.toJSON() : <any>undefined;
        data["shelfFromId"] = this.shelfFromId;
        data["shelfTo"] = this.shelfTo ? this.shelfTo.toJSON() : <any>undefined;
        data["shelfToId"] = this.shelfToId;
        data["price"] = this.price;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): TransferDetail {
        const json = this.toJSON();
        let result = new TransferDetail();
        result.init(json);
        return result;
    }
}

export interface ITransferDetail {
    transferHeader: TransferHeader;
    transferHeaderId: number;
    product: Product;
    productId: number;
    quantity: number;
    shelfFrom: Shelf;
    shelfFromId: number | undefined;
    shelfTo: Shelf;
    shelfToId: number | undefined;
    price: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class TransferDetailPagedResultDto implements ITransferDetailPagedResultDto {
    totalCount: number;
    items: TransferDetail[] | undefined;

    constructor(data?: ITransferDetailPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TransferDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransferDetailPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferDetailPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): TransferDetailPagedResultDto {
        const json = this.toJSON();
        let result = new TransferDetailPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITransferDetailPagedResultDto {
    totalCount: number;
    items: TransferDetail[] | undefined;
}

export class TransferListByTypeDapper implements ITransferListByTypeDapper {
    company: string | undefined;
    warehouse: string | undefined;
    userName: string | undefined;
    transferType: string | undefined;
    productCount: number;
    productQuantity: number;
    clientCount: number;
    overall_count: number;

    constructor(data?: ITransferListByTypeDapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"];
            this.warehouse = _data["warehouse"];
            this.userName = _data["userName"];
            this.transferType = _data["transferType"];
            this.productCount = _data["productCount"];
            this.productQuantity = _data["productQuantity"];
            this.clientCount = _data["clientCount"];
            this.overall_count = _data["overall_count"];
        }
    }

    static fromJS(data: any): TransferListByTypeDapper {
        data = typeof data === 'object' ? data : {};
        let result = new TransferListByTypeDapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["warehouse"] = this.warehouse;
        data["userName"] = this.userName;
        data["transferType"] = this.transferType;
        data["productCount"] = this.productCount;
        data["productQuantity"] = this.productQuantity;
        data["clientCount"] = this.clientCount;
        data["overall_count"] = this.overall_count;
        return data;
    }

    clone(): TransferListByTypeDapper {
        const json = this.toJSON();
        let result = new TransferListByTypeDapper();
        result.init(json);
        return result;
    }
}

export interface ITransferListByTypeDapper {
    company: string | undefined;
    warehouse: string | undefined;
    userName: string | undefined;
    transferType: string | undefined;
    productCount: number;
    productQuantity: number;
    clientCount: number;
    overall_count: number;
}

export class TransferListByTypeDapperPagedResultDto implements ITransferListByTypeDapperPagedResultDto {
    totalCount: number;
    items: TransferListByTypeDapper[] | undefined;

    constructor(data?: ITransferListByTypeDapperPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TransferListByTypeDapper.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransferListByTypeDapperPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferListByTypeDapperPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): TransferListByTypeDapperPagedResultDto {
        const json = this.toJSON();
        let result = new TransferListByTypeDapperPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITransferListByTypeDapperPagedResultDto {
    totalCount: number;
    items: TransferListByTypeDapper[] | undefined;
}

export class BatchCorrectionInsertDto implements IBatchCorrectionInsertDto {
    productCodeList: string[] | undefined;
    quantityList: number[] | undefined;
    shelfCodeList: string[] | undefined;
    costList: number[] | undefined;
    notes: string[] | undefined;
    processType: number;
    warehouseId: number;
    storageId: number;
    companyId: number;
    isProcToErp: boolean;

    constructor(data?: IBatchCorrectionInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productCodeList"])) {
                this.productCodeList = [] as any;
                for (let item of _data["productCodeList"])
                    this.productCodeList.push(item);
            }
            if (Array.isArray(_data["quantityList"])) {
                this.quantityList = [] as any;
                for (let item of _data["quantityList"])
                    this.quantityList.push(item);
            }
            if (Array.isArray(_data["shelfCodeList"])) {
                this.shelfCodeList = [] as any;
                for (let item of _data["shelfCodeList"])
                    this.shelfCodeList.push(item);
            }
            if (Array.isArray(_data["costList"])) {
                this.costList = [] as any;
                for (let item of _data["costList"])
                    this.costList.push(item);
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes.push(item);
            }
            this.processType = _data["processType"];
            this.warehouseId = _data["warehouseId"];
            this.storageId = _data["storageId"];
            this.companyId = _data["companyId"];
            this.isProcToErp = _data["isProcToErp"];
        }
    }

    static fromJS(data: any): BatchCorrectionInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchCorrectionInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productCodeList)) {
            data["productCodeList"] = [];
            for (let item of this.productCodeList)
                data["productCodeList"].push(item);
        }
        if (Array.isArray(this.quantityList)) {
            data["quantityList"] = [];
            for (let item of this.quantityList)
                data["quantityList"].push(item);
        }
        if (Array.isArray(this.shelfCodeList)) {
            data["shelfCodeList"] = [];
            for (let item of this.shelfCodeList)
                data["shelfCodeList"].push(item);
        }
        if (Array.isArray(this.costList)) {
            data["costList"] = [];
            for (let item of this.costList)
                data["costList"].push(item);
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item);
        }
        data["processType"] = this.processType;
        data["warehouseId"] = this.warehouseId;
        data["storageId"] = this.storageId;
        data["companyId"] = this.companyId;
        data["isProcToErp"] = this.isProcToErp;
        return data;
    }

    clone(): BatchCorrectionInsertDto {
        const json = this.toJSON();
        let result = new BatchCorrectionInsertDto();
        result.init(json);
        return result;
    }
}

export interface IBatchCorrectionInsertDto {
    productCodeList: string[] | undefined;
    quantityList: number[] | undefined;
    shelfCodeList: string[] | undefined;
    costList: number[] | undefined;
    notes: string[] | undefined;
    processType: number;
    warehouseId: number;
    storageId: number;
    companyId: number;
    isProcToErp: boolean;
}

export class BatchCorrectionOutput implements IBatchCorrectionOutput {
    errorProduct: string | undefined;
    errorShelf: string | undefined;
    errorQuantity: number;
    errorMaliyet: number;
    errorNote: string | undefined;
    message: string | undefined;

    constructor(data?: IBatchCorrectionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorProduct = _data["errorProduct"];
            this.errorShelf = _data["errorShelf"];
            this.errorQuantity = _data["errorQuantity"];
            this.errorMaliyet = _data["errorMaliyet"];
            this.errorNote = _data["errorNote"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): BatchCorrectionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new BatchCorrectionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorProduct"] = this.errorProduct;
        data["errorShelf"] = this.errorShelf;
        data["errorQuantity"] = this.errorQuantity;
        data["errorMaliyet"] = this.errorMaliyet;
        data["errorNote"] = this.errorNote;
        data["message"] = this.message;
        return data;
    }

    clone(): BatchCorrectionOutput {
        const json = this.toJSON();
        let result = new BatchCorrectionOutput();
        result.init(json);
        return result;
    }
}

export interface IBatchCorrectionOutput {
    errorProduct: string | undefined;
    errorShelf: string | undefined;
    errorQuantity: number;
    errorMaliyet: number;
    errorNote: string | undefined;
    message: string | undefined;
}

export class BatchCorrectionOutputDto implements IBatchCorrectionOutputDto {
    output: BatchCorrectionOutput[] | undefined;

    constructor(data?: IBatchCorrectionOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["output"])) {
                this.output = [] as any;
                for (let item of _data["output"])
                    this.output.push(BatchCorrectionOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchCorrectionOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchCorrectionOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.output)) {
            data["output"] = [];
            for (let item of this.output)
                data["output"].push(item.toJSON());
        }
        return data;
    }

    clone(): BatchCorrectionOutputDto {
        const json = this.toJSON();
        let result = new BatchCorrectionOutputDto();
        result.init(json);
        return result;
    }
}

export interface IBatchCorrectionOutputDto {
    output: BatchCorrectionOutput[] | undefined;
}

export class ProductExtendedDto implements IProductExtendedDto {
    group1: string | undefined;
    group2: string | undefined;
    group3: string | undefined;
    sizeWidth: number;
    sizeLength: number;
    sizeHeight: number;
    weight: number;
    volume: number;
    company: Company;
    code: string | undefined;
    definition: string | undefined;
    definition2: string | undefined;
    manufacturer: string | undefined;
    manufacturerCode: string | undefined;
    unit: string | undefined;
    natraShelf: string | undefined;
    hasSerial: boolean;
    isDeleted: boolean;
    purchasePrice: number;
    isFifo: boolean;
    id: number;

    constructor(data?: IProductExtendedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group1 = _data["group1"];
            this.group2 = _data["group2"];
            this.group3 = _data["group3"];
            this.sizeWidth = _data["sizeWidth"];
            this.sizeLength = _data["sizeLength"];
            this.sizeHeight = _data["sizeHeight"];
            this.weight = _data["weight"];
            this.volume = _data["volume"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.definition2 = _data["definition2"];
            this.manufacturer = _data["manufacturer"];
            this.manufacturerCode = _data["manufacturerCode"];
            this.unit = _data["unit"];
            this.natraShelf = _data["natraShelf"];
            this.hasSerial = _data["hasSerial"];
            this.isDeleted = _data["isDeleted"];
            this.purchasePrice = _data["purchasePrice"];
            this.isFifo = _data["isFifo"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductExtendedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductExtendedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group1"] = this.group1;
        data["group2"] = this.group2;
        data["group3"] = this.group3;
        data["sizeWidth"] = this.sizeWidth;
        data["sizeLength"] = this.sizeLength;
        data["sizeHeight"] = this.sizeHeight;
        data["weight"] = this.weight;
        data["volume"] = this.volume;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["definition2"] = this.definition2;
        data["manufacturer"] = this.manufacturer;
        data["manufacturerCode"] = this.manufacturerCode;
        data["unit"] = this.unit;
        data["natraShelf"] = this.natraShelf;
        data["hasSerial"] = this.hasSerial;
        data["isDeleted"] = this.isDeleted;
        data["purchasePrice"] = this.purchasePrice;
        data["isFifo"] = this.isFifo;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductExtendedDto {
        const json = this.toJSON();
        let result = new ProductExtendedDto();
        result.init(json);
        return result;
    }
}

export interface IProductExtendedDto {
    group1: string | undefined;
    group2: string | undefined;
    group3: string | undefined;
    sizeWidth: number;
    sizeLength: number;
    sizeHeight: number;
    weight: number;
    volume: number;
    company: Company;
    code: string | undefined;
    definition: string | undefined;
    definition2: string | undefined;
    manufacturer: string | undefined;
    manufacturerCode: string | undefined;
    unit: string | undefined;
    natraShelf: string | undefined;
    hasSerial: boolean;
    isDeleted: boolean;
    purchasePrice: number;
    isFifo: boolean;
    id: number;
}

export class ProductDtoPagedResultDto implements IProductDtoPagedResultDto {
    totalCount: number;
    items: ProductDto[] | undefined;

    constructor(data?: IProductDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProductDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductDtoPagedResultDto {
    totalCount: number;
    items: ProductDto[] | undefined;
}

export class BatchProductInsertDto implements IBatchProductInsertDto {
    productCodeList: string[] | undefined;
    productDefinitionList: string[] | undefined;
    productManufacturerList: string[] | undefined;
    productGroup1List: string[] | undefined;
    productErpEntegreIdList: string[] | undefined;
    isActive: boolean[] | undefined;
    companyId: number;

    constructor(data?: IBatchProductInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productCodeList"])) {
                this.productCodeList = [] as any;
                for (let item of _data["productCodeList"])
                    this.productCodeList.push(item);
            }
            if (Array.isArray(_data["productDefinitionList"])) {
                this.productDefinitionList = [] as any;
                for (let item of _data["productDefinitionList"])
                    this.productDefinitionList.push(item);
            }
            if (Array.isArray(_data["productManufacturerList"])) {
                this.productManufacturerList = [] as any;
                for (let item of _data["productManufacturerList"])
                    this.productManufacturerList.push(item);
            }
            if (Array.isArray(_data["productGroup1List"])) {
                this.productGroup1List = [] as any;
                for (let item of _data["productGroup1List"])
                    this.productGroup1List.push(item);
            }
            if (Array.isArray(_data["productErpEntegreIdList"])) {
                this.productErpEntegreIdList = [] as any;
                for (let item of _data["productErpEntegreIdList"])
                    this.productErpEntegreIdList.push(item);
            }
            if (Array.isArray(_data["isActive"])) {
                this.isActive = [] as any;
                for (let item of _data["isActive"])
                    this.isActive.push(item);
            }
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): BatchProductInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchProductInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productCodeList)) {
            data["productCodeList"] = [];
            for (let item of this.productCodeList)
                data["productCodeList"].push(item);
        }
        if (Array.isArray(this.productDefinitionList)) {
            data["productDefinitionList"] = [];
            for (let item of this.productDefinitionList)
                data["productDefinitionList"].push(item);
        }
        if (Array.isArray(this.productManufacturerList)) {
            data["productManufacturerList"] = [];
            for (let item of this.productManufacturerList)
                data["productManufacturerList"].push(item);
        }
        if (Array.isArray(this.productGroup1List)) {
            data["productGroup1List"] = [];
            for (let item of this.productGroup1List)
                data["productGroup1List"].push(item);
        }
        if (Array.isArray(this.productErpEntegreIdList)) {
            data["productErpEntegreIdList"] = [];
            for (let item of this.productErpEntegreIdList)
                data["productErpEntegreIdList"].push(item);
        }
        if (Array.isArray(this.isActive)) {
            data["isActive"] = [];
            for (let item of this.isActive)
                data["isActive"].push(item);
        }
        data["companyId"] = this.companyId;
        return data;
    }

    clone(): BatchProductInsertDto {
        const json = this.toJSON();
        let result = new BatchProductInsertDto();
        result.init(json);
        return result;
    }
}

export interface IBatchProductInsertDto {
    productCodeList: string[] | undefined;
    productDefinitionList: string[] | undefined;
    productManufacturerList: string[] | undefined;
    productGroup1List: string[] | undefined;
    productErpEntegreIdList: string[] | undefined;
    isActive: boolean[] | undefined;
    companyId: number;
}

export class ProductNoBarcodeDapper implements IProductNoBarcodeDapper {
    overall_count: number;
    code: string | undefined;
    manufacturer: string | undefined;

    constructor(data?: IProductNoBarcodeDapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overall_count = _data["overall_count"];
            this.code = _data["code"];
            this.manufacturer = _data["manufacturer"];
        }
    }

    static fromJS(data: any): ProductNoBarcodeDapper {
        data = typeof data === 'object' ? data : {};
        let result = new ProductNoBarcodeDapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overall_count"] = this.overall_count;
        data["code"] = this.code;
        data["manufacturer"] = this.manufacturer;
        return data;
    }

    clone(): ProductNoBarcodeDapper {
        const json = this.toJSON();
        let result = new ProductNoBarcodeDapper();
        result.init(json);
        return result;
    }
}

export interface IProductNoBarcodeDapper {
    overall_count: number;
    code: string | undefined;
    manufacturer: string | undefined;
}

export class ProductNoBarcodeDapperPagedResultDto implements IProductNoBarcodeDapperPagedResultDto {
    totalCount: number;
    items: ProductNoBarcodeDapper[] | undefined;

    constructor(data?: IProductNoBarcodeDapperPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductNoBarcodeDapper.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductNoBarcodeDapperPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductNoBarcodeDapperPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductNoBarcodeDapperPagedResultDto {
        const json = this.toJSON();
        let result = new ProductNoBarcodeDapperPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductNoBarcodeDapperPagedResultDto {
    totalCount: number;
    items: ProductNoBarcodeDapper[] | undefined;
}

export class ProductDuplicateBarcodeDapper implements IProductDuplicateBarcodeDapper {
    overall_count: number;
    productCode: string | undefined;
    manufacturer: string | undefined;
    barcode: string | undefined;

    constructor(data?: IProductDuplicateBarcodeDapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overall_count = _data["overall_count"];
            this.productCode = _data["productCode"];
            this.manufacturer = _data["manufacturer"];
            this.barcode = _data["barcode"];
        }
    }

    static fromJS(data: any): ProductDuplicateBarcodeDapper {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDuplicateBarcodeDapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overall_count"] = this.overall_count;
        data["productCode"] = this.productCode;
        data["manufacturer"] = this.manufacturer;
        data["barcode"] = this.barcode;
        return data;
    }

    clone(): ProductDuplicateBarcodeDapper {
        const json = this.toJSON();
        let result = new ProductDuplicateBarcodeDapper();
        result.init(json);
        return result;
    }
}

export interface IProductDuplicateBarcodeDapper {
    overall_count: number;
    productCode: string | undefined;
    manufacturer: string | undefined;
    barcode: string | undefined;
}

export class ProductDuplicateBarcodeDapperPagedResultDto implements IProductDuplicateBarcodeDapperPagedResultDto {
    totalCount: number;
    items: ProductDuplicateBarcodeDapper[] | undefined;

    constructor(data?: IProductDuplicateBarcodeDapperPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductDuplicateBarcodeDapper.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductDuplicateBarcodeDapperPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDuplicateBarcodeDapperPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductDuplicateBarcodeDapperPagedResultDto {
        const json = this.toJSON();
        let result = new ProductDuplicateBarcodeDapperPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductDuplicateBarcodeDapperPagedResultDto {
    totalCount: number;
    items: ProductDuplicateBarcodeDapper[] | undefined;
}

export class Manufacturer implements IManufacturer {
    name: string | undefined;

    constructor(data?: IManufacturer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Manufacturer {
        data = typeof data === 'object' ? data : {};
        let result = new Manufacturer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): Manufacturer {
        const json = this.toJSON();
        let result = new Manufacturer();
        result.init(json);
        return result;
    }
}

export interface IManufacturer {
    name: string | undefined;
}

export class BatchProductStockResetRequestDto implements IBatchProductStockResetRequestDto {
    companyId: number;
    productId: number;
    productCodeList: string[] | undefined;
    warehouseId: number;
    storageId: number;

    constructor(data?: IBatchProductStockResetRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.productId = _data["productId"];
            if (Array.isArray(_data["productCodeList"])) {
                this.productCodeList = [] as any;
                for (let item of _data["productCodeList"])
                    this.productCodeList.push(item);
            }
            this.warehouseId = _data["warehouseId"];
            this.storageId = _data["storageId"];
        }
    }

    static fromJS(data: any): BatchProductStockResetRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchProductStockResetRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["productId"] = this.productId;
        if (Array.isArray(this.productCodeList)) {
            data["productCodeList"] = [];
            for (let item of this.productCodeList)
                data["productCodeList"].push(item);
        }
        data["warehouseId"] = this.warehouseId;
        data["storageId"] = this.storageId;
        return data;
    }

    clone(): BatchProductStockResetRequestDto {
        const json = this.toJSON();
        let result = new BatchProductStockResetRequestDto();
        result.init(json);
        return result;
    }
}

export interface IBatchProductStockResetRequestDto {
    companyId: number;
    productId: number;
    productCodeList: string[] | undefined;
    warehouseId: number;
    storageId: number;
}

export class BarcodeDto implements IBarcodeDto {
    product: ProductDto;
    code: string | undefined;
    quantity: number;
    id: number;

    constructor(data?: IBarcodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.code = _data["code"];
            this.quantity = _data["quantity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BarcodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarcodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data;
    }

    clone(): BarcodeDto {
        const json = this.toJSON();
        let result = new BarcodeDto();
        result.init(json);
        return result;
    }
}

export interface IBarcodeDto {
    product: ProductDto;
    code: string | undefined;
    quantity: number;
    id: number;
}

export class BarcodeInsertDto implements IBarcodeInsertDto {
    productId: number;
    companyId: number;
    code: string;
    quantity: number;

    constructor(data?: IBarcodeInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.companyId = _data["companyId"];
            this.code = _data["code"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): BarcodeInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarcodeInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["companyId"] = this.companyId;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): BarcodeInsertDto {
        const json = this.toJSON();
        let result = new BarcodeInsertDto();
        result.init(json);
        return result;
    }
}

export interface IBarcodeInsertDto {
    productId: number;
    companyId: number;
    code: string;
    quantity: number;
}

export class BarcodeUpdateDto implements IBarcodeUpdateDto {
    id: number;
    code: string;
    quantity: number;

    constructor(data?: IBarcodeUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): BarcodeUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarcodeUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): BarcodeUpdateDto {
        const json = this.toJSON();
        let result = new BarcodeUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IBarcodeUpdateDto {
    id: number;
    code: string;
    quantity: number;
}

export class BatchBarcodeInsertDto implements IBatchBarcodeInsertDto {
    productCodeList: string[] | undefined;
    barcodeList: string[] | undefined;
    quantityList: number[] | undefined;
    companyId: number;

    constructor(data?: IBatchBarcodeInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productCodeList"])) {
                this.productCodeList = [] as any;
                for (let item of _data["productCodeList"])
                    this.productCodeList.push(item);
            }
            if (Array.isArray(_data["barcodeList"])) {
                this.barcodeList = [] as any;
                for (let item of _data["barcodeList"])
                    this.barcodeList.push(item);
            }
            if (Array.isArray(_data["quantityList"])) {
                this.quantityList = [] as any;
                for (let item of _data["quantityList"])
                    this.quantityList.push(item);
            }
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): BatchBarcodeInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchBarcodeInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productCodeList)) {
            data["productCodeList"] = [];
            for (let item of this.productCodeList)
                data["productCodeList"].push(item);
        }
        if (Array.isArray(this.barcodeList)) {
            data["barcodeList"] = [];
            for (let item of this.barcodeList)
                data["barcodeList"].push(item);
        }
        if (Array.isArray(this.quantityList)) {
            data["quantityList"] = [];
            for (let item of this.quantityList)
                data["quantityList"].push(item);
        }
        data["companyId"] = this.companyId;
        return data;
    }

    clone(): BatchBarcodeInsertDto {
        const json = this.toJSON();
        let result = new BatchBarcodeInsertDto();
        result.init(json);
        return result;
    }
}

export interface IBatchBarcodeInsertDto {
    productCodeList: string[] | undefined;
    barcodeList: string[] | undefined;
    quantityList: number[] | undefined;
    companyId: number;
}

export class BatchProductRecodeRequestDto implements IBatchProductRecodeRequestDto {
    oldProductList: string[] | undefined;
    newProductList: string[] | undefined;
    isProcToErp: boolean;
    companyId: number;
    barcodeMovement: boolean;
    onlyCode: boolean;

    constructor(data?: IBatchProductRecodeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["oldProductList"])) {
                this.oldProductList = [] as any;
                for (let item of _data["oldProductList"])
                    this.oldProductList.push(item);
            }
            if (Array.isArray(_data["newProductList"])) {
                this.newProductList = [] as any;
                for (let item of _data["newProductList"])
                    this.newProductList.push(item);
            }
            this.isProcToErp = _data["isProcToErp"];
            this.companyId = _data["companyId"];
            this.barcodeMovement = _data["barcodeMovement"];
            this.onlyCode = _data["onlyCode"];
        }
    }

    static fromJS(data: any): BatchProductRecodeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchProductRecodeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.oldProductList)) {
            data["oldProductList"] = [];
            for (let item of this.oldProductList)
                data["oldProductList"].push(item);
        }
        if (Array.isArray(this.newProductList)) {
            data["newProductList"] = [];
            for (let item of this.newProductList)
                data["newProductList"].push(item);
        }
        data["isProcToErp"] = this.isProcToErp;
        data["companyId"] = this.companyId;
        data["barcodeMovement"] = this.barcodeMovement;
        data["onlyCode"] = this.onlyCode;
        return data;
    }

    clone(): BatchProductRecodeRequestDto {
        const json = this.toJSON();
        let result = new BatchProductRecodeRequestDto();
        result.init(json);
        return result;
    }
}

export interface IBatchProductRecodeRequestDto {
    oldProductList: string[] | undefined;
    newProductList: string[] | undefined;
    isProcToErp: boolean;
    companyId: number;
    barcodeMovement: boolean;
    onlyCode: boolean;
}

export class BatchShelfInsertDto implements IBatchShelfInsertDto {
    fullAddressList: string[] | undefined;
    shelfTypeCodeList: string[] | undefined;
    storageId: number;

    constructor(data?: IBatchShelfInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fullAddressList"])) {
                this.fullAddressList = [] as any;
                for (let item of _data["fullAddressList"])
                    this.fullAddressList.push(item);
            }
            if (Array.isArray(_data["shelfTypeCodeList"])) {
                this.shelfTypeCodeList = [] as any;
                for (let item of _data["shelfTypeCodeList"])
                    this.shelfTypeCodeList.push(item);
            }
            this.storageId = _data["storageId"];
        }
    }

    static fromJS(data: any): BatchShelfInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchShelfInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fullAddressList)) {
            data["fullAddressList"] = [];
            for (let item of this.fullAddressList)
                data["fullAddressList"].push(item);
        }
        if (Array.isArray(this.shelfTypeCodeList)) {
            data["shelfTypeCodeList"] = [];
            for (let item of this.shelfTypeCodeList)
                data["shelfTypeCodeList"].push(item);
        }
        data["storageId"] = this.storageId;
        return data;
    }

    clone(): BatchShelfInsertDto {
        const json = this.toJSON();
        let result = new BatchShelfInsertDto();
        result.init(json);
        return result;
    }
}

export interface IBatchShelfInsertDto {
    fullAddressList: string[] | undefined;
    shelfTypeCodeList: string[] | undefined;
    storageId: number;
}

export class ShelfPdaDto implements IShelfPdaDto {
    storage: Storage;
    storageId: number;
    region: string;
    street: number;
    apartment: string;
    apartmentNo: number;
    floor: string;
    floorNo: number;
    sequence: string;
    sequenceNo: number;
    isActive: boolean;
    isBlocked: boolean;
    width: number;
    length: number;
    height: number;
    hasPriority: boolean;
    shelfType: ShelfType;
    shelfTypeId: number;
    weight: number;
    fullAddress: string | undefined;
    shelfUserType: string | undefined;
    quantity: number;
    id: number;

    constructor(data?: IShelfPdaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.storage = new Storage();
            this.apartment = "A";
            this.floor = "K";
            this.sequence = "S";
            this.isActive = true;
            this.isBlocked = false;
            this.width = 0;
            this.length = 0;
            this.height = 0;
            this.hasPriority = false;
            this.shelfType = new ShelfType();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storage = _data["storage"] ? Storage.fromJS(_data["storage"]) : new Storage();
            this.storageId = _data["storageId"];
            this.region = _data["region"];
            this.street = _data["street"];
            this.apartment = _data["apartment"] !== undefined ? _data["apartment"] : "A";
            this.apartmentNo = _data["apartmentNo"];
            this.floor = _data["floor"] !== undefined ? _data["floor"] : "K";
            this.floorNo = _data["floorNo"];
            this.sequence = _data["sequence"] !== undefined ? _data["sequence"] : "S";
            this.sequenceNo = _data["sequenceNo"];
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : true;
            this.isBlocked = _data["isBlocked"] !== undefined ? _data["isBlocked"] : false;
            this.width = _data["width"] !== undefined ? _data["width"] : 0;
            this.length = _data["length"] !== undefined ? _data["length"] : 0;
            this.height = _data["height"] !== undefined ? _data["height"] : 0;
            this.hasPriority = _data["hasPriority"] !== undefined ? _data["hasPriority"] : false;
            this.shelfType = _data["shelfType"] ? ShelfType.fromJS(_data["shelfType"]) : new ShelfType();
            this.shelfTypeId = _data["shelfTypeId"];
            this.weight = _data["weight"];
            this.fullAddress = _data["fullAddress"];
            this.shelfUserType = _data["shelfUserType"];
            this.quantity = _data["quantity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShelfPdaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShelfPdaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["storageId"] = this.storageId;
        data["region"] = this.region;
        data["street"] = this.street;
        data["apartment"] = this.apartment;
        data["apartmentNo"] = this.apartmentNo;
        data["floor"] = this.floor;
        data["floorNo"] = this.floorNo;
        data["sequence"] = this.sequence;
        data["sequenceNo"] = this.sequenceNo;
        data["isActive"] = this.isActive;
        data["isBlocked"] = this.isBlocked;
        data["width"] = this.width;
        data["length"] = this.length;
        data["height"] = this.height;
        data["hasPriority"] = this.hasPriority;
        data["shelfType"] = this.shelfType ? this.shelfType.toJSON() : <any>undefined;
        data["shelfTypeId"] = this.shelfTypeId;
        data["weight"] = this.weight;
        data["fullAddress"] = this.fullAddress;
        data["shelfUserType"] = this.shelfUserType;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data;
    }

    clone(): ShelfPdaDto {
        const json = this.toJSON();
        let result = new ShelfPdaDto();
        result.init(json);
        return result;
    }
}

export interface IShelfPdaDto {
    storage: Storage;
    storageId: number;
    region: string;
    street: number;
    apartment: string;
    apartmentNo: number;
    floor: string;
    floorNo: number;
    sequence: string;
    sequenceNo: number;
    isActive: boolean;
    isBlocked: boolean;
    width: number;
    length: number;
    height: number;
    hasPriority: boolean;
    shelfType: ShelfType;
    shelfTypeId: number;
    weight: number;
    fullAddress: string | undefined;
    shelfUserType: string | undefined;
    quantity: number;
    id: number;
}

export class ShelfPagedResultDto implements IShelfPagedResultDto {
    totalCount: number;
    items: Shelf[] | undefined;

    constructor(data?: IShelfPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(Shelf.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShelfPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShelfPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ShelfPagedResultDto {
        const json = this.toJSON();
        let result = new ShelfPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IShelfPagedResultDto {
    totalCount: number;
    items: Shelf[] | undefined;
}

export class BarcodeDtoPagedResultDto implements IBarcodeDtoPagedResultDto {
    totalCount: number;
    items: BarcodeDto[] | undefined;

    constructor(data?: IBarcodeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BarcodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BarcodeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarcodeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): BarcodeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new BarcodeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBarcodeDtoPagedResultDto {
    totalCount: number;
    items: BarcodeDto[] | undefined;
}

export class ProductSpecialShelfDto implements IProductSpecialShelfDto {
    product: ProductDto;
    shelf: Shelf;
    quantity: number;
    safetyPercent: number;
    maxQuantity: number;
    shelfType: ShelfType;
    minQuantity: number;
    currentPercent: number;
    replenishmentStatus: string | undefined;
    replenishmentStatusCssId: string | undefined;
    anyAlternativeShelfForProductAtMainStock: boolean;
    mainStockProductQtyExcludingVarietyShelf: number;
    id: number;

    constructor(data?: IProductSpecialShelfDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.safetyPercent = 0;
            this.maxQuantity = 0;
            this.shelfType = new ShelfType();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.shelf = _data["shelf"] ? Shelf.fromJS(_data["shelf"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.safetyPercent = _data["safetyPercent"] !== undefined ? _data["safetyPercent"] : 0;
            this.maxQuantity = _data["maxQuantity"] !== undefined ? _data["maxQuantity"] : 0;
            this.shelfType = _data["shelfType"] ? ShelfType.fromJS(_data["shelfType"]) : new ShelfType();
            this.minQuantity = _data["minQuantity"];
            this.currentPercent = _data["currentPercent"];
            this.replenishmentStatus = _data["replenishmentStatus"];
            this.replenishmentStatusCssId = _data["replenishmentStatusCssId"];
            this.anyAlternativeShelfForProductAtMainStock = _data["anyAlternativeShelfForProductAtMainStock"];
            this.mainStockProductQtyExcludingVarietyShelf = _data["mainStockProductQtyExcludingVarietyShelf"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductSpecialShelfDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSpecialShelfDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["shelf"] = this.shelf ? this.shelf.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["safetyPercent"] = this.safetyPercent;
        data["maxQuantity"] = this.maxQuantity;
        data["shelfType"] = this.shelfType ? this.shelfType.toJSON() : <any>undefined;
        data["minQuantity"] = this.minQuantity;
        data["currentPercent"] = this.currentPercent;
        data["replenishmentStatus"] = this.replenishmentStatus;
        data["replenishmentStatusCssId"] = this.replenishmentStatusCssId;
        data["anyAlternativeShelfForProductAtMainStock"] = this.anyAlternativeShelfForProductAtMainStock;
        data["mainStockProductQtyExcludingVarietyShelf"] = this.mainStockProductQtyExcludingVarietyShelf;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductSpecialShelfDto {
        const json = this.toJSON();
        let result = new ProductSpecialShelfDto();
        result.init(json);
        return result;
    }
}

export interface IProductSpecialShelfDto {
    product: ProductDto;
    shelf: Shelf;
    quantity: number;
    safetyPercent: number;
    maxQuantity: number;
    shelfType: ShelfType;
    minQuantity: number;
    currentPercent: number;
    replenishmentStatus: string | undefined;
    replenishmentStatusCssId: string | undefined;
    anyAlternativeShelfForProductAtMainStock: boolean;
    mainStockProductQtyExcludingVarietyShelf: number;
    id: number;
}

export class ProductQuantityShelfDapper implements IProductQuantityShelfDapper {
    id: number;
    overall_count: number;
    productId: number;
    productCode: string | undefined;
    productName: string | undefined;
    productManufacturer: string | undefined;
    companyId: number;
    companyCode: string | undefined;
    warehouseId: number;
    warehouseCode: string | undefined;
    warehouseName: string | undefined;
    storageId: number;
    storageCode: string | undefined;
    storageName: string | undefined;
    shelfId: number;
    shelfAddress: string | undefined;
    shelfTypePriority: number;
    shelfUserType: string | undefined;
    shelfRegion: string | undefined;
    shelfFloorNo: number;
    shelfSequenceNo: number;
    quantity: number;
    quantityIn: number;
    quantityOut: number;

    constructor(data?: IProductQuantityShelfDapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.overall_count = _data["overall_count"];
            this.productId = _data["productId"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.productManufacturer = _data["productManufacturer"];
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseCode = _data["warehouseCode"];
            this.warehouseName = _data["warehouseName"];
            this.storageId = _data["storageId"];
            this.storageCode = _data["storageCode"];
            this.storageName = _data["storageName"];
            this.shelfId = _data["shelfId"];
            this.shelfAddress = _data["shelfAddress"];
            this.shelfTypePriority = _data["shelfTypePriority"];
            this.shelfUserType = _data["shelfUserType"];
            this.shelfRegion = _data["shelfRegion"];
            this.shelfFloorNo = _data["shelfFloorNo"];
            this.shelfSequenceNo = _data["shelfSequenceNo"];
            this.quantity = _data["quantity"];
            this.quantityIn = _data["quantityIn"];
            this.quantityOut = _data["quantityOut"];
        }
    }

    static fromJS(data: any): ProductQuantityShelfDapper {
        data = typeof data === 'object' ? data : {};
        let result = new ProductQuantityShelfDapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["overall_count"] = this.overall_count;
        data["productId"] = this.productId;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productManufacturer"] = this.productManufacturer;
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        data["warehouseId"] = this.warehouseId;
        data["warehouseCode"] = this.warehouseCode;
        data["warehouseName"] = this.warehouseName;
        data["storageId"] = this.storageId;
        data["storageCode"] = this.storageCode;
        data["storageName"] = this.storageName;
        data["shelfId"] = this.shelfId;
        data["shelfAddress"] = this.shelfAddress;
        data["shelfTypePriority"] = this.shelfTypePriority;
        data["shelfUserType"] = this.shelfUserType;
        data["shelfRegion"] = this.shelfRegion;
        data["shelfFloorNo"] = this.shelfFloorNo;
        data["shelfSequenceNo"] = this.shelfSequenceNo;
        data["quantity"] = this.quantity;
        data["quantityIn"] = this.quantityIn;
        data["quantityOut"] = this.quantityOut;
        return data;
    }

    clone(): ProductQuantityShelfDapper {
        const json = this.toJSON();
        let result = new ProductQuantityShelfDapper();
        result.init(json);
        return result;
    }
}

export interface IProductQuantityShelfDapper {
    id: number;
    overall_count: number;
    productId: number;
    productCode: string | undefined;
    productName: string | undefined;
    productManufacturer: string | undefined;
    companyId: number;
    companyCode: string | undefined;
    warehouseId: number;
    warehouseCode: string | undefined;
    warehouseName: string | undefined;
    storageId: number;
    storageCode: string | undefined;
    storageName: string | undefined;
    shelfId: number;
    shelfAddress: string | undefined;
    shelfTypePriority: number;
    shelfUserType: string | undefined;
    shelfRegion: string | undefined;
    shelfFloorNo: number;
    shelfSequenceNo: number;
    quantity: number;
    quantityIn: number;
    quantityOut: number;
}

export class ProductShelfVarietyDto implements IProductShelfVarietyDto {
    warehouse: Warehouse;
    productShelfDto: ProductSpecialShelfDto;

    constructor(data?: IProductShelfVarietyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.productShelfDto = _data["productShelfDto"] ? ProductSpecialShelfDto.fromJS(_data["productShelfDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductShelfVarietyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductShelfVarietyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["productShelfDto"] = this.productShelfDto ? this.productShelfDto.toJSON() : <any>undefined;
        return data;
    }

    clone(): ProductShelfVarietyDto {
        const json = this.toJSON();
        let result = new ProductShelfVarietyDto();
        result.init(json);
        return result;
    }
}

export interface IProductShelfVarietyDto {
    warehouse: Warehouse;
    productShelfDto: ProductSpecialShelfDto;
}

export class ProductSpecialShelfDtoPagedResultDto implements IProductSpecialShelfDtoPagedResultDto {
    totalCount: number;
    items: ProductSpecialShelfDto[] | undefined;

    constructor(data?: IProductSpecialShelfDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductSpecialShelfDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductSpecialShelfDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSpecialShelfDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductSpecialShelfDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProductSpecialShelfDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductSpecialShelfDtoPagedResultDto {
    totalCount: number;
    items: ProductSpecialShelfDto[] | undefined;
}

export class BatchProductShelfInsertDto implements IBatchProductShelfInsertDto {
    productCodeList: string[] | undefined;
    fullAddressList: string[] | undefined;
    safetyPercentList: number[] | undefined;
    maxQuantityList: number[] | undefined;
    companyId: number;
    warehouseId: number;
    storageId: number;

    constructor(data?: IBatchProductShelfInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productCodeList"])) {
                this.productCodeList = [] as any;
                for (let item of _data["productCodeList"])
                    this.productCodeList.push(item);
            }
            if (Array.isArray(_data["fullAddressList"])) {
                this.fullAddressList = [] as any;
                for (let item of _data["fullAddressList"])
                    this.fullAddressList.push(item);
            }
            if (Array.isArray(_data["safetyPercentList"])) {
                this.safetyPercentList = [] as any;
                for (let item of _data["safetyPercentList"])
                    this.safetyPercentList.push(item);
            }
            if (Array.isArray(_data["maxQuantityList"])) {
                this.maxQuantityList = [] as any;
                for (let item of _data["maxQuantityList"])
                    this.maxQuantityList.push(item);
            }
            this.companyId = _data["companyId"];
            this.warehouseId = _data["warehouseId"];
            this.storageId = _data["storageId"];
        }
    }

    static fromJS(data: any): BatchProductShelfInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchProductShelfInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productCodeList)) {
            data["productCodeList"] = [];
            for (let item of this.productCodeList)
                data["productCodeList"].push(item);
        }
        if (Array.isArray(this.fullAddressList)) {
            data["fullAddressList"] = [];
            for (let item of this.fullAddressList)
                data["fullAddressList"].push(item);
        }
        if (Array.isArray(this.safetyPercentList)) {
            data["safetyPercentList"] = [];
            for (let item of this.safetyPercentList)
                data["safetyPercentList"].push(item);
        }
        if (Array.isArray(this.maxQuantityList)) {
            data["maxQuantityList"] = [];
            for (let item of this.maxQuantityList)
                data["maxQuantityList"].push(item);
        }
        data["companyId"] = this.companyId;
        data["warehouseId"] = this.warehouseId;
        data["storageId"] = this.storageId;
        return data;
    }

    clone(): BatchProductShelfInsertDto {
        const json = this.toJSON();
        let result = new BatchProductShelfInsertDto();
        result.init(json);
        return result;
    }
}

export interface IBatchProductShelfInsertDto {
    productCodeList: string[] | undefined;
    fullAddressList: string[] | undefined;
    safetyPercentList: number[] | undefined;
    maxQuantityList: number[] | undefined;
    companyId: number;
    warehouseId: number;
    storageId: number;
}

export class ProductShelfInsertDto implements IProductShelfInsertDto {
    productId: number;
    shelfId: number;
    safetyPercent: number;
    maxQuantity: number;

    constructor(data?: IProductShelfInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.safetyPercent = 10;
            this.maxQuantity = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.shelfId = _data["shelfId"];
            this.safetyPercent = _data["safetyPercent"] !== undefined ? _data["safetyPercent"] : 10;
            this.maxQuantity = _data["maxQuantity"] !== undefined ? _data["maxQuantity"] : 0;
        }
    }

    static fromJS(data: any): ProductShelfInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductShelfInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["shelfId"] = this.shelfId;
        data["safetyPercent"] = this.safetyPercent;
        data["maxQuantity"] = this.maxQuantity;
        return data;
    }

    clone(): ProductShelfInsertDto {
        const json = this.toJSON();
        let result = new ProductShelfInsertDto();
        result.init(json);
        return result;
    }
}

export interface IProductShelfInsertDto {
    productId: number;
    shelfId: number;
    safetyPercent: number;
    maxQuantity: number;
}

export class ProductShelfUpdateDto implements IProductShelfUpdateDto {
    productShelfId: number;
    safetyPercent: number;
    maxQuantity: number;

    constructor(data?: IProductShelfUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productShelfId = _data["productShelfId"];
            this.safetyPercent = _data["safetyPercent"];
            this.maxQuantity = _data["maxQuantity"];
        }
    }

    static fromJS(data: any): ProductShelfUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductShelfUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productShelfId"] = this.productShelfId;
        data["safetyPercent"] = this.safetyPercent;
        data["maxQuantity"] = this.maxQuantity;
        return data;
    }

    clone(): ProductShelfUpdateDto {
        const json = this.toJSON();
        let result = new ProductShelfUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IProductShelfUpdateDto {
    productShelfId: number;
    safetyPercent: number;
    maxQuantity: number;
}

export class ErpProcessHeaderFailDapper implements IErpProcessHeaderFailDapper {
    sourceDocumentNo: string | undefined;
    id: number;
    notes: string | undefined;
    typeId: number | undefined;
    definition: string | undefined;
    errorMessage: string | undefined;
    isTransfered: boolean;
    transferingStartTime: Date | undefined;
    creationTime: Date | undefined;

    constructor(data?: IErpProcessHeaderFailDapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceDocumentNo = _data["sourceDocumentNo"];
            this.id = _data["id"];
            this.notes = _data["notes"];
            this.typeId = _data["typeId"];
            this.definition = _data["definition"];
            this.errorMessage = _data["errorMessage"];
            this.isTransfered = _data["isTransfered"];
            this.transferingStartTime = _data["transferingStartTime"] ? new Date(_data["transferingStartTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ErpProcessHeaderFailDapper {
        data = typeof data === 'object' ? data : {};
        let result = new ErpProcessHeaderFailDapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceDocumentNo"] = this.sourceDocumentNo;
        data["id"] = this.id;
        data["notes"] = this.notes;
        data["typeId"] = this.typeId;
        data["definition"] = this.definition;
        data["errorMessage"] = this.errorMessage;
        data["isTransfered"] = this.isTransfered;
        data["transferingStartTime"] = this.transferingStartTime ? this.transferingStartTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ErpProcessHeaderFailDapper {
        const json = this.toJSON();
        let result = new ErpProcessHeaderFailDapper();
        result.init(json);
        return result;
    }
}

export interface IErpProcessHeaderFailDapper {
    sourceDocumentNo: string | undefined;
    id: number;
    notes: string | undefined;
    typeId: number | undefined;
    definition: string | undefined;
    errorMessage: string | undefined;
    isTransfered: boolean;
    transferingStartTime: Date | undefined;
    creationTime: Date | undefined;
}

export class ErpProcessHeaderFailDapperPagedResultDto implements IErpProcessHeaderFailDapperPagedResultDto {
    totalCount: number;
    items: ErpProcessHeaderFailDapper[] | undefined;

    constructor(data?: IErpProcessHeaderFailDapperPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ErpProcessHeaderFailDapper.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ErpProcessHeaderFailDapperPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErpProcessHeaderFailDapperPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ErpProcessHeaderFailDapperPagedResultDto {
        const json = this.toJSON();
        let result = new ErpProcessHeaderFailDapperPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IErpProcessHeaderFailDapperPagedResultDto {
    totalCount: number;
    items: ErpProcessHeaderFailDapper[] | undefined;
}

export class ProductShelfFromViewDto implements IProductShelfFromViewDto {
    id: number;
    product: Product;
    shelf: Shelf;
    maxQuantity: number;
    safetyPercent: number;
    minQuantity: number;
    currentPercent: number;
    shelfType: ShelfType;
    instantQuantity: number;
    alternativeStockQuantity: number;
    anyAlternativeShelfForProductAtMainStock: boolean;
    replenishmentStatus: string | undefined;
    replenishmentStatusCssId: string | undefined;

    constructor(data?: IProductShelfFromViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.shelf = _data["shelf"] ? Shelf.fromJS(_data["shelf"]) : <any>undefined;
            this.maxQuantity = _data["maxQuantity"];
            this.safetyPercent = _data["safetyPercent"];
            this.minQuantity = _data["minQuantity"];
            this.currentPercent = _data["currentPercent"];
            this.shelfType = _data["shelfType"] ? ShelfType.fromJS(_data["shelfType"]) : <any>undefined;
            this.instantQuantity = _data["instantQuantity"];
            this.alternativeStockQuantity = _data["alternativeStockQuantity"];
            this.anyAlternativeShelfForProductAtMainStock = _data["anyAlternativeShelfForProductAtMainStock"];
            this.replenishmentStatus = _data["replenishmentStatus"];
            this.replenishmentStatusCssId = _data["replenishmentStatusCssId"];
        }
    }

    static fromJS(data: any): ProductShelfFromViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductShelfFromViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["shelf"] = this.shelf ? this.shelf.toJSON() : <any>undefined;
        data["maxQuantity"] = this.maxQuantity;
        data["safetyPercent"] = this.safetyPercent;
        data["minQuantity"] = this.minQuantity;
        data["currentPercent"] = this.currentPercent;
        data["shelfType"] = this.shelfType ? this.shelfType.toJSON() : <any>undefined;
        data["instantQuantity"] = this.instantQuantity;
        data["alternativeStockQuantity"] = this.alternativeStockQuantity;
        data["anyAlternativeShelfForProductAtMainStock"] = this.anyAlternativeShelfForProductAtMainStock;
        data["replenishmentStatus"] = this.replenishmentStatus;
        data["replenishmentStatusCssId"] = this.replenishmentStatusCssId;
        return data;
    }

    clone(): ProductShelfFromViewDto {
        const json = this.toJSON();
        let result = new ProductShelfFromViewDto();
        result.init(json);
        return result;
    }
}

export interface IProductShelfFromViewDto {
    id: number;
    product: Product;
    shelf: Shelf;
    maxQuantity: number;
    safetyPercent: number;
    minQuantity: number;
    currentPercent: number;
    shelfType: ShelfType;
    instantQuantity: number;
    alternativeStockQuantity: number;
    anyAlternativeShelfForProductAtMainStock: boolean;
    replenishmentStatus: string | undefined;
    replenishmentStatusCssId: string | undefined;
}

export class ProductQuantityStorageDto implements IProductQuantityStorageDto {
    product: ProductSimpleDto;
    company: CompanyDto;
    warehouse: WarehouseDto;
    storage: StorageDto;
    quantity: number;
    id: number;

    constructor(data?: IProductQuantityStorageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductSimpleDto.fromJS(_data["product"]) : <any>undefined;
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.warehouse = _data["warehouse"] ? WarehouseDto.fromJS(_data["warehouse"]) : <any>undefined;
            this.storage = _data["storage"] ? StorageDto.fromJS(_data["storage"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductQuantityStorageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductQuantityStorageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductQuantityStorageDto {
        const json = this.toJSON();
        let result = new ProductQuantityStorageDto();
        result.init(json);
        return result;
    }
}

export interface IProductQuantityStorageDto {
    product: ProductSimpleDto;
    company: CompanyDto;
    warehouse: WarehouseDto;
    storage: StorageDto;
    quantity: number;
    id: number;
}

export class ProductQuantityShelfDto implements IProductQuantityShelfDto {
    product: ProductSimpleDto;
    company: CompanyDto;
    warehouse: WarehouseDto;
    storage: StorageDto;
    shelf: ShelfSimpleDto;
    quantity: number;
    id: number;

    constructor(data?: IProductQuantityShelfDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductSimpleDto.fromJS(_data["product"]) : <any>undefined;
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.warehouse = _data["warehouse"] ? WarehouseDto.fromJS(_data["warehouse"]) : <any>undefined;
            this.storage = _data["storage"] ? StorageDto.fromJS(_data["storage"]) : <any>undefined;
            this.shelf = _data["shelf"] ? ShelfSimpleDto.fromJS(_data["shelf"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductQuantityShelfDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductQuantityShelfDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["shelf"] = this.shelf ? this.shelf.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductQuantityShelfDto {
        const json = this.toJSON();
        let result = new ProductQuantityShelfDto();
        result.init(json);
        return result;
    }
}

export interface IProductQuantityShelfDto {
    product: ProductSimpleDto;
    company: CompanyDto;
    warehouse: WarehouseDto;
    storage: StorageDto;
    shelf: ShelfSimpleDto;
    quantity: number;
    id: number;
}

export class ProductQuantityWarehouseDto implements IProductQuantityWarehouseDto {
    product: ProductSimpleDto;
    company: CompanyDto;
    warehouse: WarehouseDto;
    quantity: number;
    id: number;

    constructor(data?: IProductQuantityWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductSimpleDto.fromJS(_data["product"]) : <any>undefined;
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.warehouse = _data["warehouse"] ? WarehouseDto.fromJS(_data["warehouse"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductQuantityWarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductQuantityWarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductQuantityWarehouseDto {
        const json = this.toJSON();
        let result = new ProductQuantityWarehouseDto();
        result.init(json);
        return result;
    }
}

export interface IProductQuantityWarehouseDto {
    product: ProductSimpleDto;
    company: CompanyDto;
    warehouse: WarehouseDto;
    quantity: number;
    id: number;
}

export class ProductShelfStorageQuantityDifferenceDapper implements IProductShelfStorageQuantityDifferenceDapper {
    overall_count: number;
    productCode: string | undefined;
    companyName: string | undefined;
    warehouseName: string | undefined;
    storageDefinition: string | undefined;
    storageQuantity: number;
    shelfQuantity: number;

    constructor(data?: IProductShelfStorageQuantityDifferenceDapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overall_count = _data["overall_count"];
            this.productCode = _data["productCode"];
            this.companyName = _data["companyName"];
            this.warehouseName = _data["warehouseName"];
            this.storageDefinition = _data["storageDefinition"];
            this.storageQuantity = _data["storageQuantity"];
            this.shelfQuantity = _data["shelfQuantity"];
        }
    }

    static fromJS(data: any): ProductShelfStorageQuantityDifferenceDapper {
        data = typeof data === 'object' ? data : {};
        let result = new ProductShelfStorageQuantityDifferenceDapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overall_count"] = this.overall_count;
        data["productCode"] = this.productCode;
        data["companyName"] = this.companyName;
        data["warehouseName"] = this.warehouseName;
        data["storageDefinition"] = this.storageDefinition;
        data["storageQuantity"] = this.storageQuantity;
        data["shelfQuantity"] = this.shelfQuantity;
        return data;
    }

    clone(): ProductShelfStorageQuantityDifferenceDapper {
        const json = this.toJSON();
        let result = new ProductShelfStorageQuantityDifferenceDapper();
        result.init(json);
        return result;
    }
}

export interface IProductShelfStorageQuantityDifferenceDapper {
    overall_count: number;
    productCode: string | undefined;
    companyName: string | undefined;
    warehouseName: string | undefined;
    storageDefinition: string | undefined;
    storageQuantity: number;
    shelfQuantity: number;
}

export class ProductShelfStorageQuantityDifferenceDapperPagedResultDto implements IProductShelfStorageQuantityDifferenceDapperPagedResultDto {
    totalCount: number;
    items: ProductShelfStorageQuantityDifferenceDapper[] | undefined;

    constructor(data?: IProductShelfStorageQuantityDifferenceDapperPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductShelfStorageQuantityDifferenceDapper.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductShelfStorageQuantityDifferenceDapperPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductShelfStorageQuantityDifferenceDapperPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductShelfStorageQuantityDifferenceDapperPagedResultDto {
        const json = this.toJSON();
        let result = new ProductShelfStorageQuantityDifferenceDapperPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductShelfStorageQuantityDifferenceDapperPagedResultDto {
    totalCount: number;
    items: ProductShelfStorageQuantityDifferenceDapper[] | undefined;
}

export class ProductShelfQuantityDto implements IProductShelfQuantityDto {
    product: ProductDto;
    company: Company;
    warehouse: Warehouse;
    storage: Storage;
    shelf: Shelf;
    quantity: number;
    quantityIn: number;
    quantityOut: number;

    constructor(data?: IProductShelfQuantityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.storage = _data["storage"] ? Storage.fromJS(_data["storage"]) : <any>undefined;
            this.shelf = _data["shelf"] ? Shelf.fromJS(_data["shelf"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.quantityIn = _data["quantityIn"];
            this.quantityOut = _data["quantityOut"];
        }
    }

    static fromJS(data: any): ProductShelfQuantityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductShelfQuantityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["shelf"] = this.shelf ? this.shelf.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["quantityIn"] = this.quantityIn;
        data["quantityOut"] = this.quantityOut;
        return data;
    }

    clone(): ProductShelfQuantityDto {
        const json = this.toJSON();
        let result = new ProductShelfQuantityDto();
        result.init(json);
        return result;
    }
}

export interface IProductShelfQuantityDto {
    product: ProductDto;
    company: Company;
    warehouse: Warehouse;
    storage: Storage;
    shelf: Shelf;
    quantity: number;
    quantityIn: number;
    quantityOut: number;
}

export class ProductQuantityStorage implements IProductQuantityStorage {
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    storage: Storage;
    storageId: number;
    product: Product;
    productId: number;
    quantity: number;
    quantityIn: number;
    quantityOut: number;
    id: number;

    constructor(data?: IProductQuantityStorage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.companyId = _data["companyId"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.warehouseId = _data["warehouseId"];
            this.storage = _data["storage"] ? Storage.fromJS(_data["storage"]) : <any>undefined;
            this.storageId = _data["storageId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.productId = _data["productId"];
            this.quantity = _data["quantity"];
            this.quantityIn = _data["quantityIn"];
            this.quantityOut = _data["quantityOut"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductQuantityStorage {
        data = typeof data === 'object' ? data : {};
        let result = new ProductQuantityStorage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["storageId"] = this.storageId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["quantityIn"] = this.quantityIn;
        data["quantityOut"] = this.quantityOut;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductQuantityStorage {
        const json = this.toJSON();
        let result = new ProductQuantityStorage();
        result.init(json);
        return result;
    }
}

export interface IProductQuantityStorage {
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    storage: Storage;
    storageId: number;
    product: Product;
    productId: number;
    quantity: number;
    quantityIn: number;
    quantityOut: number;
    id: number;
}

export class ProductQuantityStoragePagedResultDto implements IProductQuantityStoragePagedResultDto {
    totalCount: number;
    items: ProductQuantityStorage[] | undefined;

    constructor(data?: IProductQuantityStoragePagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductQuantityStorage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductQuantityStoragePagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductQuantityStoragePagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductQuantityStoragePagedResultDto {
        const json = this.toJSON();
        let result = new ProductQuantityStoragePagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductQuantityStoragePagedResultDto {
    totalCount: number;
    items: ProductQuantityStorage[] | undefined;
}

export class ProductQuantityWarehouse implements IProductQuantityWarehouse {
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    product: Product;
    productId: number;
    quantity: number;
    quantityIn: number;
    quantityOut: number;
    id: number;

    constructor(data?: IProductQuantityWarehouse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.companyId = _data["companyId"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.warehouseId = _data["warehouseId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.productId = _data["productId"];
            this.quantity = _data["quantity"];
            this.quantityIn = _data["quantityIn"];
            this.quantityOut = _data["quantityOut"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductQuantityWarehouse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductQuantityWarehouse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["quantityIn"] = this.quantityIn;
        data["quantityOut"] = this.quantityOut;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductQuantityWarehouse {
        const json = this.toJSON();
        let result = new ProductQuantityWarehouse();
        result.init(json);
        return result;
    }
}

export interface IProductQuantityWarehouse {
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    product: Product;
    productId: number;
    quantity: number;
    quantityIn: number;
    quantityOut: number;
    id: number;
}

export class ProductQuantityWarehousePagedResultDto implements IProductQuantityWarehousePagedResultDto {
    totalCount: number;
    items: ProductQuantityWarehouse[] | undefined;

    constructor(data?: IProductQuantityWarehousePagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductQuantityWarehouse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductQuantityWarehousePagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductQuantityWarehousePagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductQuantityWarehousePagedResultDto {
        const json = this.toJSON();
        let result = new ProductQuantityWarehousePagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductQuantityWarehousePagedResultDto {
    totalCount: number;
    items: ProductQuantityWarehouse[] | undefined;
}

export class ContainerDtoPagedResultDto implements IContainerDtoPagedResultDto {
    totalCount: number;
    items: ContainerDto[] | undefined;

    constructor(data?: IContainerDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ContainerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContainerDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ContainerDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ContainerDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IContainerDtoPagedResultDto {
    totalCount: number;
    items: ContainerDto[] | undefined;
}

export class StockMovementDto implements IStockMovementDto {
    company: Company;
    warehouse: Warehouse;
    storage: Storage;
    type: MovementType;
    product: ProductDto;
    quantity: number;
    readonly quantityIn: number;
    readonly quantityOut: number;
    quantityErp: number;
    client: ClientDto;
    stockMovementType: StockMovementType;
    creationTime: Date;
    id: number;

    constructor(data?: IStockMovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.storage = _data["storage"] ? Storage.fromJS(_data["storage"]) : <any>undefined;
            this.type = _data["type"];
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.quantity = _data["quantity"];
            (<any>this).quantityIn = _data["quantityIn"];
            (<any>this).quantityOut = _data["quantityOut"];
            this.quantityErp = _data["quantityErp"];
            this.client = _data["client"] ? ClientDto.fromJS(_data["client"]) : <any>undefined;
            this.stockMovementType = _data["stockMovementType"] ? StockMovementType.fromJS(_data["stockMovementType"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StockMovementDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockMovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["quantityIn"] = this.quantityIn;
        data["quantityOut"] = this.quantityOut;
        data["quantityErp"] = this.quantityErp;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["stockMovementType"] = this.stockMovementType ? this.stockMovementType.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): StockMovementDto {
        const json = this.toJSON();
        let result = new StockMovementDto();
        result.init(json);
        return result;
    }
}

export interface IStockMovementDto {
    company: Company;
    warehouse: Warehouse;
    storage: Storage;
    type: MovementType;
    product: ProductDto;
    quantity: number;
    quantityIn: number;
    quantityOut: number;
    quantityErp: number;
    client: ClientDto;
    stockMovementType: StockMovementType;
    creationTime: Date;
    id: number;
}

export class StockMovementDtoPagedResultDto implements IStockMovementDtoPagedResultDto {
    totalCount: number;
    items: StockMovementDto[] | undefined;

    constructor(data?: IStockMovementDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StockMovementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockMovementDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockMovementDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): StockMovementDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StockMovementDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStockMovementDtoPagedResultDto {
    totalCount: number;
    items: StockMovementDto[] | undefined;
}

export class ProductionHeaderDto implements IProductionHeaderDto {
    code: string | undefined;
    company: Company;
    warehouse: Warehouse;
    startDate: Date;
    isCancelled: boolean;
    isDeleted: boolean;
    isFinished: boolean;
    isStarted: boolean;
    id: number;

    constructor(data?: IProductionHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.isCancelled = _data["isCancelled"];
            this.isDeleted = _data["isDeleted"];
            this.isFinished = _data["isFinished"];
            this.isStarted = _data["isStarted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductionHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["isCancelled"] = this.isCancelled;
        data["isDeleted"] = this.isDeleted;
        data["isFinished"] = this.isFinished;
        data["isStarted"] = this.isStarted;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductionHeaderDto {
        const json = this.toJSON();
        let result = new ProductionHeaderDto();
        result.init(json);
        return result;
    }
}

export interface IProductionHeaderDto {
    code: string | undefined;
    company: Company;
    warehouse: Warehouse;
    startDate: Date;
    isCancelled: boolean;
    isDeleted: boolean;
    isFinished: boolean;
    isStarted: boolean;
    id: number;
}

export class ProductionHeaderDtoPagedResultDto implements IProductionHeaderDtoPagedResultDto {
    totalCount: number;
    items: ProductionHeaderDto[] | undefined;

    constructor(data?: IProductionHeaderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductionHeaderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductionHeaderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionHeaderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductionHeaderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProductionHeaderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductionHeaderDtoPagedResultDto {
    totalCount: number;
    items: ProductionHeaderDto[] | undefined;
}

export class ProductionHeader implements IProductionHeader {
    code: string;
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    isStarted: boolean;
    startTime: Date | undefined;
    isFinished: boolean;
    finishTime: Date | undefined;
    isCancelled: boolean;
    cancelTime: Date | undefined;
    cancelReason: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProductionHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.code = "";
            this.company = new Company();
            this.warehouse = new Warehouse();
            this.isStarted = false;
            this.isFinished = false;
            this.isCancelled = false;
            this.cancelReason = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : "";
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.companyId = _data["companyId"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.warehouseId = _data["warehouseId"];
            this.isStarted = _data["isStarted"] !== undefined ? _data["isStarted"] : false;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.isFinished = _data["isFinished"] !== undefined ? _data["isFinished"] : false;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : <any>undefined;
            this.isCancelled = _data["isCancelled"] !== undefined ? _data["isCancelled"] : false;
            this.cancelTime = _data["cancelTime"] ? new Date(_data["cancelTime"].toString()) : <any>undefined;
            this.cancelReason = _data["cancelReason"] !== undefined ? _data["cancelReason"] : "";
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductionHeader {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["isStarted"] = this.isStarted;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["isFinished"] = this.isFinished;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["isCancelled"] = this.isCancelled;
        data["cancelTime"] = this.cancelTime ? this.cancelTime.toISOString() : <any>undefined;
        data["cancelReason"] = this.cancelReason;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductionHeader {
        const json = this.toJSON();
        let result = new ProductionHeader();
        result.init(json);
        return result;
    }
}

export interface IProductionHeader {
    code: string;
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    isStarted: boolean;
    startTime: Date | undefined;
    isFinished: boolean;
    finishTime: Date | undefined;
    isCancelled: boolean;
    cancelTime: Date | undefined;
    cancelReason: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class ProductionDetail implements IProductionDetail {
    productionHeader: ProductionHeader;
    productionHeaderId: number;
    product: Product;
    productId: number;
    quantity: number;
    movementType: MovementType;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProductionDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productionHeader = new ProductionHeader();
            this.product = new Product();
            this.quantity = 1;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productionHeader = _data["productionHeader"] ? ProductionHeader.fromJS(_data["productionHeader"]) : new ProductionHeader();
            this.productionHeaderId = _data["productionHeaderId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : new Product();
            this.productId = _data["productId"];
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : 1;
            this.movementType = _data["movementType"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductionDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productionHeader"] = this.productionHeader ? this.productionHeader.toJSON() : <any>undefined;
        data["productionHeaderId"] = this.productionHeaderId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["movementType"] = this.movementType;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductionDetail {
        const json = this.toJSON();
        let result = new ProductionDetail();
        result.init(json);
        return result;
    }
}

export interface IProductionDetail {
    productionHeader: ProductionHeader;
    productionHeaderId: number;
    product: Product;
    productId: number;
    quantity: number;
    movementType: MovementType;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class ProductionDetailDto implements IProductionDetailDto {
    productionHeader: ProductionHeader;
    product: Product;
    quantity: number;
    movementType: MovementType;
    id: number;

    constructor(data?: IProductionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productionHeader = _data["productionHeader"] ? ProductionHeader.fromJS(_data["productionHeader"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.movementType = _data["movementType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productionHeader"] = this.productionHeader ? this.productionHeader.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["movementType"] = this.movementType;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductionDetailDto {
        const json = this.toJSON();
        let result = new ProductionDetailDto();
        result.init(json);
        return result;
    }
}

export interface IProductionDetailDto {
    productionHeader: ProductionHeader;
    product: Product;
    quantity: number;
    movementType: MovementType;
    id: number;
}

export class BatchProductionInsertDto implements IBatchProductionInsertDto {
    productCodeList: string[] | undefined;
    productQuantityList: string[] | undefined;
    typeList: string[] | undefined;
    companyId: number;
    warehouseId: number;
    productionHeaderId: number;

    constructor(data?: IBatchProductionInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productCodeList"])) {
                this.productCodeList = [] as any;
                for (let item of _data["productCodeList"])
                    this.productCodeList.push(item);
            }
            if (Array.isArray(_data["productQuantityList"])) {
                this.productQuantityList = [] as any;
                for (let item of _data["productQuantityList"])
                    this.productQuantityList.push(item);
            }
            if (Array.isArray(_data["typeList"])) {
                this.typeList = [] as any;
                for (let item of _data["typeList"])
                    this.typeList.push(item);
            }
            this.companyId = _data["companyId"];
            this.warehouseId = _data["warehouseId"];
            this.productionHeaderId = _data["productionHeaderId"];
        }
    }

    static fromJS(data: any): BatchProductionInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchProductionInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productCodeList)) {
            data["productCodeList"] = [];
            for (let item of this.productCodeList)
                data["productCodeList"].push(item);
        }
        if (Array.isArray(this.productQuantityList)) {
            data["productQuantityList"] = [];
            for (let item of this.productQuantityList)
                data["productQuantityList"].push(item);
        }
        if (Array.isArray(this.typeList)) {
            data["typeList"] = [];
            for (let item of this.typeList)
                data["typeList"].push(item);
        }
        data["companyId"] = this.companyId;
        data["warehouseId"] = this.warehouseId;
        data["productionHeaderId"] = this.productionHeaderId;
        return data;
    }

    clone(): BatchProductionInsertDto {
        const json = this.toJSON();
        let result = new BatchProductionInsertDto();
        result.init(json);
        return result;
    }
}

export interface IBatchProductionInsertDto {
    productCodeList: string[] | undefined;
    productQuantityList: string[] | undefined;
    typeList: string[] | undefined;
    companyId: number;
    warehouseId: number;
    productionHeaderId: number;
}

export class ProductionRecipeHeaderDto implements IProductionRecipeHeaderDto {
    code: string | undefined;
    definition: string | undefined;
    warehouse: Warehouse;
    creationTime: Date;
    isDeleted: boolean;
    id: number;

    constructor(data?: IProductionRecipeHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductionRecipeHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionRecipeHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductionRecipeHeaderDto {
        const json = this.toJSON();
        let result = new ProductionRecipeHeaderDto();
        result.init(json);
        return result;
    }
}

export interface IProductionRecipeHeaderDto {
    code: string | undefined;
    definition: string | undefined;
    warehouse: Warehouse;
    creationTime: Date;
    isDeleted: boolean;
    id: number;
}

export class ProductionRecipeHeaderDtoPagedResultDto implements IProductionRecipeHeaderDtoPagedResultDto {
    totalCount: number;
    items: ProductionRecipeHeaderDto[] | undefined;

    constructor(data?: IProductionRecipeHeaderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductionRecipeHeaderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductionRecipeHeaderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionRecipeHeaderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductionRecipeHeaderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProductionRecipeHeaderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductionRecipeHeaderDtoPagedResultDto {
    totalCount: number;
    items: ProductionRecipeHeaderDto[] | undefined;
}

export class ProductionRecipeDetailDto implements IProductionRecipeDetailDto {
    productionRecipeHeader: ProductionRecipeHeader;
    product: Product;
    quantity: number;
    movementType: MovementType;
    id: number;

    constructor(data?: IProductionRecipeDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productionRecipeHeader = _data["productionRecipeHeader"] ? ProductionRecipeHeader.fromJS(_data["productionRecipeHeader"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.movementType = _data["movementType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductionRecipeDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionRecipeDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productionRecipeHeader"] = this.productionRecipeHeader ? this.productionRecipeHeader.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["movementType"] = this.movementType;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductionRecipeDetailDto {
        const json = this.toJSON();
        let result = new ProductionRecipeDetailDto();
        result.init(json);
        return result;
    }
}

export interface IProductionRecipeDetailDto {
    productionRecipeHeader: ProductionRecipeHeader;
    product: Product;
    quantity: number;
    movementType: MovementType;
    id: number;
}

export class BatchProductionRecipeInsertDto implements IBatchProductionRecipeInsertDto {
    productCodeList: string[] | undefined;
    productQuantityList: string[] | undefined;
    typeList: string[] | undefined;
    companyId: number;
    warehouseId: number;
    productionRecipeHeaderId: number;

    constructor(data?: IBatchProductionRecipeInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productCodeList"])) {
                this.productCodeList = [] as any;
                for (let item of _data["productCodeList"])
                    this.productCodeList.push(item);
            }
            if (Array.isArray(_data["productQuantityList"])) {
                this.productQuantityList = [] as any;
                for (let item of _data["productQuantityList"])
                    this.productQuantityList.push(item);
            }
            if (Array.isArray(_data["typeList"])) {
                this.typeList = [] as any;
                for (let item of _data["typeList"])
                    this.typeList.push(item);
            }
            this.companyId = _data["companyId"];
            this.warehouseId = _data["warehouseId"];
            this.productionRecipeHeaderId = _data["productionRecipeHeaderId"];
        }
    }

    static fromJS(data: any): BatchProductionRecipeInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchProductionRecipeInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productCodeList)) {
            data["productCodeList"] = [];
            for (let item of this.productCodeList)
                data["productCodeList"].push(item);
        }
        if (Array.isArray(this.productQuantityList)) {
            data["productQuantityList"] = [];
            for (let item of this.productQuantityList)
                data["productQuantityList"].push(item);
        }
        if (Array.isArray(this.typeList)) {
            data["typeList"] = [];
            for (let item of this.typeList)
                data["typeList"].push(item);
        }
        data["companyId"] = this.companyId;
        data["warehouseId"] = this.warehouseId;
        data["productionRecipeHeaderId"] = this.productionRecipeHeaderId;
        return data;
    }

    clone(): BatchProductionRecipeInsertDto {
        const json = this.toJSON();
        let result = new BatchProductionRecipeInsertDto();
        result.init(json);
        return result;
    }
}

export interface IBatchProductionRecipeInsertDto {
    productCodeList: string[] | undefined;
    productQuantityList: string[] | undefined;
    typeList: string[] | undefined;
    companyId: number;
    warehouseId: number;
    productionRecipeHeaderId: number;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDto implements IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    isDeleted: boolean;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    id: number;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.isDeleted = _data["isDeleted"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["isDeleted"] = this.isDeleted;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    isDeleted: boolean;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    id: number;
}

export class RoleListDto implements IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: Date;
    id: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: Date;
    id: number;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class PermissionDto implements IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
    id: number;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        data["id"] = this.id;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
    id: number;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    totalCount: number;
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    totalCount: number;
    items: RoleDto[] | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    params: Parameter[] | undefined;
    version: string | undefined;
    releaseDate: Date;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["params"])) {
                this.params = [] as any;
                for (let item of _data["params"])
                    this.params.push(Parameter.fromJS(item));
            }
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.params)) {
            data["params"] = [];
            for (let item of this.params)
                data["params"].push(item.toJSON());
        }
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = this.features[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    params: Parameter[] | undefined;
    version: string | undefined;
    releaseDate: Date;
    features: { [key: string]: boolean; } | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    companyId: number;
    warehouseId: number;
    printPointName: string | undefined;
    roleList: string[] | undefined;
    permissionList: PermissionDto[] | undefined;
    userShelfType: string | undefined;
    id: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.companyId = _data["companyId"];
            this.warehouseId = _data["warehouseId"];
            this.printPointName = _data["printPointName"];
            if (Array.isArray(_data["roleList"])) {
                this.roleList = [] as any;
                for (let item of _data["roleList"])
                    this.roleList.push(item);
            }
            if (Array.isArray(_data["permissionList"])) {
                this.permissionList = [] as any;
                for (let item of _data["permissionList"])
                    this.permissionList.push(PermissionDto.fromJS(item));
            }
            this.userShelfType = _data["userShelfType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["companyId"] = this.companyId;
        data["warehouseId"] = this.warehouseId;
        data["printPointName"] = this.printPointName;
        if (Array.isArray(this.roleList)) {
            data["roleList"] = [];
            for (let item of this.roleList)
                data["roleList"].push(item);
        }
        if (Array.isArray(this.permissionList)) {
            data["permissionList"] = [];
            for (let item of this.permissionList)
                data["permissionList"].push(item.toJSON());
        }
        data["userShelfType"] = this.userShelfType;
        data["id"] = this.id;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    companyId: number;
    warehouseId: number;
    printPointName: string | undefined;
    roleList: string[] | undefined;
    permissionList: PermissionDto[] | undefined;
    userShelfType: string | undefined;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    id: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    id: number;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    checkMessage: string | undefined;
    paymentLink: string | undefined;
    isShow: boolean;
    closed: boolean;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
            this.checkMessage = _data["checkMessage"];
            this.paymentLink = _data["paymentLink"];
            this.isShow = _data["isShow"];
            this.closed = _data["closed"];
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["checkMessage"] = this.checkMessage;
        data["paymentLink"] = this.paymentLink;
        data["isShow"] = this.isShow;
        data["closed"] = this.closed;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    checkMessage: string | undefined;
    paymentLink: string | undefined;
    isShow: boolean;
    closed: boolean;
}

export class CreateStepCountRequestDto implements ICreateStepCountRequestDto {
    stepCount: number;

    constructor(data?: ICreateStepCountRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepCount = _data["stepCount"];
        }
    }

    static fromJS(data: any): CreateStepCountRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStepCountRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepCount"] = this.stepCount;
        return data;
    }

    clone(): CreateStepCountRequestDto {
        const json = this.toJSON();
        let result = new CreateStepCountRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICreateStepCountRequestDto {
    stepCount: number;
}

export class BatchSupervisorListCreationSTAPDto implements IBatchSupervisorListCreationSTAPDto {
    stapIdList: number[] | undefined;
    productIdList: number[] | undefined;
    stShelfIdList: number[] | undefined;
    addToSupervisorList: number[] | undefined;

    constructor(data?: IBatchSupervisorListCreationSTAPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stapIdList"])) {
                this.stapIdList = [] as any;
                for (let item of _data["stapIdList"])
                    this.stapIdList.push(item);
            }
            if (Array.isArray(_data["productIdList"])) {
                this.productIdList = [] as any;
                for (let item of _data["productIdList"])
                    this.productIdList.push(item);
            }
            if (Array.isArray(_data["stShelfIdList"])) {
                this.stShelfIdList = [] as any;
                for (let item of _data["stShelfIdList"])
                    this.stShelfIdList.push(item);
            }
            if (Array.isArray(_data["addToSupervisorList"])) {
                this.addToSupervisorList = [] as any;
                for (let item of _data["addToSupervisorList"])
                    this.addToSupervisorList.push(item);
            }
        }
    }

    static fromJS(data: any): BatchSupervisorListCreationSTAPDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchSupervisorListCreationSTAPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stapIdList)) {
            data["stapIdList"] = [];
            for (let item of this.stapIdList)
                data["stapIdList"].push(item);
        }
        if (Array.isArray(this.productIdList)) {
            data["productIdList"] = [];
            for (let item of this.productIdList)
                data["productIdList"].push(item);
        }
        if (Array.isArray(this.stShelfIdList)) {
            data["stShelfIdList"] = [];
            for (let item of this.stShelfIdList)
                data["stShelfIdList"].push(item);
        }
        if (Array.isArray(this.addToSupervisorList)) {
            data["addToSupervisorList"] = [];
            for (let item of this.addToSupervisorList)
                data["addToSupervisorList"].push(item);
        }
        return data;
    }

    clone(): BatchSupervisorListCreationSTAPDto {
        const json = this.toJSON();
        let result = new BatchSupervisorListCreationSTAPDto();
        result.init(json);
        return result;
    }
}

export interface IBatchSupervisorListCreationSTAPDto {
    stapIdList: number[] | undefined;
    productIdList: number[] | undefined;
    stShelfIdList: number[] | undefined;
    addToSupervisorList: number[] | undefined;
}

export class StockTakingHeaderDto implements IStockTakingHeaderDto {
    company: Company;
    warehouse: Warehouse;
    storage: Storage;
    workActivity: WorkActivity;
    stockTakingType: WorkActivityType;
    plannedStartDate: Date;
    plannedFinishDate: Date;
    actualStartTime: Date;
    actualFinishTime: Date;
    creationTime: Date;
    isStarted: boolean;
    isFinished: boolean;
    isDeleted: boolean;
    lastErpUploadDate: Date | undefined;
    id: number;

    constructor(data?: IStockTakingHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.storage = _data["storage"] ? Storage.fromJS(_data["storage"]) : <any>undefined;
            this.workActivity = _data["workActivity"] ? WorkActivity.fromJS(_data["workActivity"]) : <any>undefined;
            this.stockTakingType = _data["stockTakingType"] ? WorkActivityType.fromJS(_data["stockTakingType"]) : <any>undefined;
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : <any>undefined;
            this.plannedFinishDate = _data["plannedFinishDate"] ? new Date(_data["plannedFinishDate"].toString()) : <any>undefined;
            this.actualStartTime = _data["actualStartTime"] ? new Date(_data["actualStartTime"].toString()) : <any>undefined;
            this.actualFinishTime = _data["actualFinishTime"] ? new Date(_data["actualFinishTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.isStarted = _data["isStarted"];
            this.isFinished = _data["isFinished"];
            this.isDeleted = _data["isDeleted"];
            this.lastErpUploadDate = _data["lastErpUploadDate"] ? new Date(_data["lastErpUploadDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StockTakingHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockTakingHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["workActivity"] = this.workActivity ? this.workActivity.toJSON() : <any>undefined;
        data["stockTakingType"] = this.stockTakingType ? this.stockTakingType.toJSON() : <any>undefined;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : <any>undefined;
        data["plannedFinishDate"] = this.plannedFinishDate ? this.plannedFinishDate.toISOString() : <any>undefined;
        data["actualStartTime"] = this.actualStartTime ? this.actualStartTime.toISOString() : <any>undefined;
        data["actualFinishTime"] = this.actualFinishTime ? this.actualFinishTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["isDeleted"] = this.isDeleted;
        data["lastErpUploadDate"] = this.lastErpUploadDate ? this.lastErpUploadDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): StockTakingHeaderDto {
        const json = this.toJSON();
        let result = new StockTakingHeaderDto();
        result.init(json);
        return result;
    }
}

export interface IStockTakingHeaderDto {
    company: Company;
    warehouse: Warehouse;
    storage: Storage;
    workActivity: WorkActivity;
    stockTakingType: WorkActivityType;
    plannedStartDate: Date;
    plannedFinishDate: Date;
    actualStartTime: Date;
    actualFinishTime: Date;
    creationTime: Date;
    isStarted: boolean;
    isFinished: boolean;
    isDeleted: boolean;
    lastErpUploadDate: Date | undefined;
    id: number;
}

export class StockTakingHeader implements IStockTakingHeader {
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    storage: Storage;
    storageId: number;
    workActivity: WorkActivity;
    workActivityId: number | undefined;
    stockTakingType: WorkActivityType;
    stockTakingTypeId: number;
    plannedStartDate: Date;
    plannedFinishDate: Date;
    actualStartTime: Date | undefined;
    actualFinishTime: Date | undefined;
    isStarted: boolean;
    isFinished: boolean;
    isAllowAddDetail: boolean;
    isAllowRemoveDetail: boolean;
    lastErpUploadDate: Date | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IStockTakingHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.company = new Company();
            this.warehouse = new Warehouse();
            this.storage = new Storage();
            this.stockTakingType = new WorkActivityType();
            this.isStarted = false;
            this.isFinished = false;
            this.isAllowAddDetail = true;
            this.isAllowRemoveDetail = true;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.companyId = _data["companyId"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.warehouseId = _data["warehouseId"];
            this.storage = _data["storage"] ? Storage.fromJS(_data["storage"]) : new Storage();
            this.storageId = _data["storageId"];
            this.workActivity = _data["workActivity"] ? WorkActivity.fromJS(_data["workActivity"]) : <any>undefined;
            this.workActivityId = _data["workActivityId"];
            this.stockTakingType = _data["stockTakingType"] ? WorkActivityType.fromJS(_data["stockTakingType"]) : new WorkActivityType();
            this.stockTakingTypeId = _data["stockTakingTypeId"];
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : <any>undefined;
            this.plannedFinishDate = _data["plannedFinishDate"] ? new Date(_data["plannedFinishDate"].toString()) : <any>undefined;
            this.actualStartTime = _data["actualStartTime"] ? new Date(_data["actualStartTime"].toString()) : <any>undefined;
            this.actualFinishTime = _data["actualFinishTime"] ? new Date(_data["actualFinishTime"].toString()) : <any>undefined;
            this.isStarted = _data["isStarted"] !== undefined ? _data["isStarted"] : false;
            this.isFinished = _data["isFinished"] !== undefined ? _data["isFinished"] : false;
            this.isAllowAddDetail = _data["isAllowAddDetail"] !== undefined ? _data["isAllowAddDetail"] : true;
            this.isAllowRemoveDetail = _data["isAllowRemoveDetail"] !== undefined ? _data["isAllowRemoveDetail"] : true;
            this.lastErpUploadDate = _data["lastErpUploadDate"] ? new Date(_data["lastErpUploadDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StockTakingHeader {
        data = typeof data === 'object' ? data : {};
        let result = new StockTakingHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["storageId"] = this.storageId;
        data["workActivity"] = this.workActivity ? this.workActivity.toJSON() : <any>undefined;
        data["workActivityId"] = this.workActivityId;
        data["stockTakingType"] = this.stockTakingType ? this.stockTakingType.toJSON() : <any>undefined;
        data["stockTakingTypeId"] = this.stockTakingTypeId;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : <any>undefined;
        data["plannedFinishDate"] = this.plannedFinishDate ? this.plannedFinishDate.toISOString() : <any>undefined;
        data["actualStartTime"] = this.actualStartTime ? this.actualStartTime.toISOString() : <any>undefined;
        data["actualFinishTime"] = this.actualFinishTime ? this.actualFinishTime.toISOString() : <any>undefined;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["isAllowAddDetail"] = this.isAllowAddDetail;
        data["isAllowRemoveDetail"] = this.isAllowRemoveDetail;
        data["lastErpUploadDate"] = this.lastErpUploadDate ? this.lastErpUploadDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): StockTakingHeader {
        const json = this.toJSON();
        let result = new StockTakingHeader();
        result.init(json);
        return result;
    }
}

export interface IStockTakingHeader {
    company: Company;
    companyId: number;
    warehouse: Warehouse;
    warehouseId: number;
    storage: Storage;
    storageId: number;
    workActivity: WorkActivity;
    workActivityId: number | undefined;
    stockTakingType: WorkActivityType;
    stockTakingTypeId: number;
    plannedStartDate: Date;
    plannedFinishDate: Date;
    actualStartTime: Date | undefined;
    actualFinishTime: Date | undefined;
    isStarted: boolean;
    isFinished: boolean;
    isAllowAddDetail: boolean;
    isAllowRemoveDetail: boolean;
    lastErpUploadDate: Date | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class StockTakingDetailDto implements IStockTakingDetailDto {
    stockTakingHeader: StockTakingHeader;
    stockTakingActionType: WorkActionType;
    startTime: Date;
    finishTime: Date;
    startedUser: UserDto;
    finishedUser: UserDto;
    assignedUser: UserDto;
    isStarted: boolean;
    isFinished: boolean;
    isDeleted: boolean;
    assignedShelf: Shelf;
    isShelfReCounted: boolean;
    detailGroup: string | undefined;
    id: number;

    constructor(data?: IStockTakingDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockTakingHeader = _data["stockTakingHeader"] ? StockTakingHeader.fromJS(_data["stockTakingHeader"]) : <any>undefined;
            this.stockTakingActionType = _data["stockTakingActionType"] ? WorkActionType.fromJS(_data["stockTakingActionType"]) : <any>undefined;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : <any>undefined;
            this.startedUser = _data["startedUser"] ? UserDto.fromJS(_data["startedUser"]) : <any>undefined;
            this.finishedUser = _data["finishedUser"] ? UserDto.fromJS(_data["finishedUser"]) : <any>undefined;
            this.assignedUser = _data["assignedUser"] ? UserDto.fromJS(_data["assignedUser"]) : <any>undefined;
            this.isStarted = _data["isStarted"];
            this.isFinished = _data["isFinished"];
            this.isDeleted = _data["isDeleted"];
            this.assignedShelf = _data["assignedShelf"] ? Shelf.fromJS(_data["assignedShelf"]) : <any>undefined;
            this.isShelfReCounted = _data["isShelfReCounted"];
            this.detailGroup = _data["detailGroup"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StockTakingDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockTakingDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockTakingHeader"] = this.stockTakingHeader ? this.stockTakingHeader.toJSON() : <any>undefined;
        data["stockTakingActionType"] = this.stockTakingActionType ? this.stockTakingActionType.toJSON() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["startedUser"] = this.startedUser ? this.startedUser.toJSON() : <any>undefined;
        data["finishedUser"] = this.finishedUser ? this.finishedUser.toJSON() : <any>undefined;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["isDeleted"] = this.isDeleted;
        data["assignedShelf"] = this.assignedShelf ? this.assignedShelf.toJSON() : <any>undefined;
        data["isShelfReCounted"] = this.isShelfReCounted;
        data["detailGroup"] = this.detailGroup;
        data["id"] = this.id;
        return data;
    }

    clone(): StockTakingDetailDto {
        const json = this.toJSON();
        let result = new StockTakingDetailDto();
        result.init(json);
        return result;
    }
}

export interface IStockTakingDetailDto {
    stockTakingHeader: StockTakingHeader;
    stockTakingActionType: WorkActionType;
    startTime: Date;
    finishTime: Date;
    startedUser: UserDto;
    finishedUser: UserDto;
    assignedUser: UserDto;
    isStarted: boolean;
    isFinished: boolean;
    isDeleted: boolean;
    assignedShelf: Shelf;
    isShelfReCounted: boolean;
    detailGroup: string | undefined;
    id: number;
}

export class ErpProductQuantityDto implements IErpProductQuantityDto {
    stockTakingHeader: StockTakingHeader;
    product: Product;
    erpPrdQuantity: number;
    warehouse: Warehouse;
    storage: Storage;
    creationTime: Date;
    id: number;

    constructor(data?: IErpProductQuantityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockTakingHeader = _data["stockTakingHeader"] ? StockTakingHeader.fromJS(_data["stockTakingHeader"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.erpPrdQuantity = _data["erpPrdQuantity"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.storage = _data["storage"] ? Storage.fromJS(_data["storage"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ErpProductQuantityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErpProductQuantityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockTakingHeader"] = this.stockTakingHeader ? this.stockTakingHeader.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["erpPrdQuantity"] = this.erpPrdQuantity;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): ErpProductQuantityDto {
        const json = this.toJSON();
        let result = new ErpProductQuantityDto();
        result.init(json);
        return result;
    }
}

export interface IErpProductQuantityDto {
    stockTakingHeader: StockTakingHeader;
    product: Product;
    erpPrdQuantity: number;
    warehouse: Warehouse;
    storage: Storage;
    creationTime: Date;
    id: number;
}

export class ReportingStockTakingDetailPerUserDto implements IReportingStockTakingDetailPerUserDto {
    stockTakingHeader: StockTakingHeader;
    stockTakingActionType: WorkActionType;
    assignedUser: UserDto;
    totalNumberOfShelfAssignedtoUser: number;
    totalNumberOfCountedShelvestoUser: number;
    totalNumberOfOngoingShelvestoUser: number;
    totalNumberOfUncountedShelvestoUser: number;
    isShelfReCounted: boolean;
    assignedShelvesListPerUSer: ShelfDto[] | undefined;

    constructor(data?: IReportingStockTakingDetailPerUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockTakingHeader = _data["stockTakingHeader"] ? StockTakingHeader.fromJS(_data["stockTakingHeader"]) : <any>undefined;
            this.stockTakingActionType = _data["stockTakingActionType"] ? WorkActionType.fromJS(_data["stockTakingActionType"]) : <any>undefined;
            this.assignedUser = _data["assignedUser"] ? UserDto.fromJS(_data["assignedUser"]) : <any>undefined;
            this.totalNumberOfShelfAssignedtoUser = _data["totalNumberOfShelfAssignedtoUser"];
            this.totalNumberOfCountedShelvestoUser = _data["totalNumberOfCountedShelvestoUser"];
            this.totalNumberOfOngoingShelvestoUser = _data["totalNumberOfOngoingShelvestoUser"];
            this.totalNumberOfUncountedShelvestoUser = _data["totalNumberOfUncountedShelvestoUser"];
            this.isShelfReCounted = _data["isShelfReCounted"];
            if (Array.isArray(_data["assignedShelvesListPerUSer"])) {
                this.assignedShelvesListPerUSer = [] as any;
                for (let item of _data["assignedShelvesListPerUSer"])
                    this.assignedShelvesListPerUSer.push(ShelfDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportingStockTakingDetailPerUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingStockTakingDetailPerUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockTakingHeader"] = this.stockTakingHeader ? this.stockTakingHeader.toJSON() : <any>undefined;
        data["stockTakingActionType"] = this.stockTakingActionType ? this.stockTakingActionType.toJSON() : <any>undefined;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["totalNumberOfShelfAssignedtoUser"] = this.totalNumberOfShelfAssignedtoUser;
        data["totalNumberOfCountedShelvestoUser"] = this.totalNumberOfCountedShelvestoUser;
        data["totalNumberOfOngoingShelvestoUser"] = this.totalNumberOfOngoingShelvestoUser;
        data["totalNumberOfUncountedShelvestoUser"] = this.totalNumberOfUncountedShelvestoUser;
        data["isShelfReCounted"] = this.isShelfReCounted;
        if (Array.isArray(this.assignedShelvesListPerUSer)) {
            data["assignedShelvesListPerUSer"] = [];
            for (let item of this.assignedShelvesListPerUSer)
                data["assignedShelvesListPerUSer"].push(item.toJSON());
        }
        return data;
    }

    clone(): ReportingStockTakingDetailPerUserDto {
        const json = this.toJSON();
        let result = new ReportingStockTakingDetailPerUserDto();
        result.init(json);
        return result;
    }
}

export interface IReportingStockTakingDetailPerUserDto {
    stockTakingHeader: StockTakingHeader;
    stockTakingActionType: WorkActionType;
    assignedUser: UserDto;
    totalNumberOfShelfAssignedtoUser: number;
    totalNumberOfCountedShelvestoUser: number;
    totalNumberOfOngoingShelvestoUser: number;
    totalNumberOfUncountedShelvestoUser: number;
    isShelfReCounted: boolean;
    assignedShelvesListPerUSer: ShelfDto[] | undefined;
}

export class StockTakingDetail implements IStockTakingDetail {
    stockTakingHeader: StockTakingHeader;
    stockTakingHeaderId: number;
    stockTakingActionType: WorkActionType;
    stockTakingActionTypeId: number;
    startTime: Date | undefined;
    finishTime: Date | undefined;
    startedUser: User;
    startedUserId: number | undefined;
    finishedUser: User;
    finishedUserId: number | undefined;
    assignedUser: User;
    assignedUserId: number | undefined;
    isStarted: boolean;
    isFinished: boolean;
    assignedShelf: Shelf;
    assignedShelfId: number | undefined;
    detailGroup: string | undefined;
    isShelfReCounted: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IStockTakingDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.stockTakingHeader = new StockTakingHeader();
            this.stockTakingActionType = new WorkActionType();
            this.isStarted = false;
            this.isFinished = false;
            this.isShelfReCounted = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockTakingHeader = _data["stockTakingHeader"] ? StockTakingHeader.fromJS(_data["stockTakingHeader"]) : new StockTakingHeader();
            this.stockTakingHeaderId = _data["stockTakingHeaderId"];
            this.stockTakingActionType = _data["stockTakingActionType"] ? WorkActionType.fromJS(_data["stockTakingActionType"]) : new WorkActionType();
            this.stockTakingActionTypeId = _data["stockTakingActionTypeId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : <any>undefined;
            this.startedUser = _data["startedUser"] ? User.fromJS(_data["startedUser"]) : <any>undefined;
            this.startedUserId = _data["startedUserId"];
            this.finishedUser = _data["finishedUser"] ? User.fromJS(_data["finishedUser"]) : <any>undefined;
            this.finishedUserId = _data["finishedUserId"];
            this.assignedUser = _data["assignedUser"] ? User.fromJS(_data["assignedUser"]) : <any>undefined;
            this.assignedUserId = _data["assignedUserId"];
            this.isStarted = _data["isStarted"] !== undefined ? _data["isStarted"] : false;
            this.isFinished = _data["isFinished"] !== undefined ? _data["isFinished"] : false;
            this.assignedShelf = _data["assignedShelf"] ? Shelf.fromJS(_data["assignedShelf"]) : <any>undefined;
            this.assignedShelfId = _data["assignedShelfId"];
            this.detailGroup = _data["detailGroup"];
            this.isShelfReCounted = _data["isShelfReCounted"] !== undefined ? _data["isShelfReCounted"] : false;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StockTakingDetail {
        data = typeof data === 'object' ? data : {};
        let result = new StockTakingDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockTakingHeader"] = this.stockTakingHeader ? this.stockTakingHeader.toJSON() : <any>undefined;
        data["stockTakingHeaderId"] = this.stockTakingHeaderId;
        data["stockTakingActionType"] = this.stockTakingActionType ? this.stockTakingActionType.toJSON() : <any>undefined;
        data["stockTakingActionTypeId"] = this.stockTakingActionTypeId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["startedUser"] = this.startedUser ? this.startedUser.toJSON() : <any>undefined;
        data["startedUserId"] = this.startedUserId;
        data["finishedUser"] = this.finishedUser ? this.finishedUser.toJSON() : <any>undefined;
        data["finishedUserId"] = this.finishedUserId;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["assignedUserId"] = this.assignedUserId;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["assignedShelf"] = this.assignedShelf ? this.assignedShelf.toJSON() : <any>undefined;
        data["assignedShelfId"] = this.assignedShelfId;
        data["detailGroup"] = this.detailGroup;
        data["isShelfReCounted"] = this.isShelfReCounted;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): StockTakingDetail {
        const json = this.toJSON();
        let result = new StockTakingDetail();
        result.init(json);
        return result;
    }
}

export interface IStockTakingDetail {
    stockTakingHeader: StockTakingHeader;
    stockTakingHeaderId: number;
    stockTakingActionType: WorkActionType;
    stockTakingActionTypeId: number;
    startTime: Date | undefined;
    finishTime: Date | undefined;
    startedUser: User;
    startedUserId: number | undefined;
    finishedUser: User;
    finishedUserId: number | undefined;
    assignedUser: User;
    assignedUserId: number | undefined;
    isStarted: boolean;
    isFinished: boolean;
    assignedShelf: Shelf;
    assignedShelfId: number | undefined;
    detailGroup: string | undefined;
    isShelfReCounted: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class StockTakingActionProcess implements IStockTakingActionProcess {
    stockTakingDetail: StockTakingDetail;
    stockTakingDetailId: number;
    product: Product;
    productId: number | undefined;
    startTime: Date | undefined;
    finishTime: Date | undefined;
    isStarted: boolean;
    isFinished: boolean;
    isEmpty: boolean;
    isCounted: boolean;
    isControlFinished: boolean;
    isSVApproved: boolean;
    isOnControlList: boolean;
    shelfCurrentQuantity: number;
    stockQuantity: number;
    stControlCount: number;
    stSupervisorCount: number;
    stShelf: Shelf;
    stShelfId: number;
    stControlTime: Date | undefined;
    stSupervisorTime: Date | undefined;
    stControlUser: User;
    stControlUserId: number | undefined;
    stSupervisorUser: User;
    stSupervisorUserId: number | undefined;
    isControlStarted: boolean;
    stControlFinishTime: Date | undefined;
    isOnSupervisorControlList: boolean;
    isSupervisorControlStarted: boolean;
    isSupervisorControlFinished: boolean;
    stSupervisorFinishTime: Date | undefined;
    assignedControlUser: User;
    assignedControlUserId: number | undefined;
    controlGroup: number;
    erpStorageQuantity: number;
    wmsStorageQuantity: number;
    wmsShelfQuantity: number;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IStockTakingActionProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.stockTakingDetail = new StockTakingDetail();
            this.isStarted = false;
            this.isFinished = false;
            this.isEmpty = false;
            this.isCounted = false;
            this.isControlFinished = false;
            this.isSVApproved = false;
            this.isOnControlList = false;
            this.shelfCurrentQuantity = 0;
            this.stockQuantity = 0;
            this.stControlCount = 0;
            this.stSupervisorCount = 0;
            this.isControlStarted = false;
            this.isOnSupervisorControlList = false;
            this.isSupervisorControlStarted = false;
            this.isSupervisorControlFinished = false;
            this.controlGroup = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockTakingDetail = _data["stockTakingDetail"] ? StockTakingDetail.fromJS(_data["stockTakingDetail"]) : new StockTakingDetail();
            this.stockTakingDetailId = _data["stockTakingDetailId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.productId = _data["productId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : <any>undefined;
            this.isStarted = _data["isStarted"] !== undefined ? _data["isStarted"] : false;
            this.isFinished = _data["isFinished"] !== undefined ? _data["isFinished"] : false;
            this.isEmpty = _data["isEmpty"] !== undefined ? _data["isEmpty"] : false;
            this.isCounted = _data["isCounted"] !== undefined ? _data["isCounted"] : false;
            this.isControlFinished = _data["isControlFinished"] !== undefined ? _data["isControlFinished"] : false;
            this.isSVApproved = _data["isSVApproved"] !== undefined ? _data["isSVApproved"] : false;
            this.isOnControlList = _data["isOnControlList"] !== undefined ? _data["isOnControlList"] : false;
            this.shelfCurrentQuantity = _data["shelfCurrentQuantity"] !== undefined ? _data["shelfCurrentQuantity"] : 0;
            this.stockQuantity = _data["stockQuantity"] !== undefined ? _data["stockQuantity"] : 0;
            this.stControlCount = _data["stControlCount"] !== undefined ? _data["stControlCount"] : 0;
            this.stSupervisorCount = _data["stSupervisorCount"] !== undefined ? _data["stSupervisorCount"] : 0;
            this.stShelf = _data["stShelf"] ? Shelf.fromJS(_data["stShelf"]) : <any>undefined;
            this.stShelfId = _data["stShelfId"];
            this.stControlTime = _data["stControlTime"] ? new Date(_data["stControlTime"].toString()) : <any>undefined;
            this.stSupervisorTime = _data["stSupervisorTime"] ? new Date(_data["stSupervisorTime"].toString()) : <any>undefined;
            this.stControlUser = _data["stControlUser"] ? User.fromJS(_data["stControlUser"]) : <any>undefined;
            this.stControlUserId = _data["stControlUserId"];
            this.stSupervisorUser = _data["stSupervisorUser"] ? User.fromJS(_data["stSupervisorUser"]) : <any>undefined;
            this.stSupervisorUserId = _data["stSupervisorUserId"];
            this.isControlStarted = _data["isControlStarted"] !== undefined ? _data["isControlStarted"] : false;
            this.stControlFinishTime = _data["stControlFinishTime"] ? new Date(_data["stControlFinishTime"].toString()) : <any>undefined;
            this.isOnSupervisorControlList = _data["isOnSupervisorControlList"] !== undefined ? _data["isOnSupervisorControlList"] : false;
            this.isSupervisorControlStarted = _data["isSupervisorControlStarted"] !== undefined ? _data["isSupervisorControlStarted"] : false;
            this.isSupervisorControlFinished = _data["isSupervisorControlFinished"] !== undefined ? _data["isSupervisorControlFinished"] : false;
            this.stSupervisorFinishTime = _data["stSupervisorFinishTime"] ? new Date(_data["stSupervisorFinishTime"].toString()) : <any>undefined;
            this.assignedControlUser = _data["assignedControlUser"] ? User.fromJS(_data["assignedControlUser"]) : <any>undefined;
            this.assignedControlUserId = _data["assignedControlUserId"];
            this.controlGroup = _data["controlGroup"] !== undefined ? _data["controlGroup"] : 0;
            this.erpStorageQuantity = _data["erpStorageQuantity"];
            this.wmsStorageQuantity = _data["wmsStorageQuantity"];
            this.wmsShelfQuantity = _data["wmsShelfQuantity"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StockTakingActionProcess {
        data = typeof data === 'object' ? data : {};
        let result = new StockTakingActionProcess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockTakingDetail"] = this.stockTakingDetail ? this.stockTakingDetail.toJSON() : <any>undefined;
        data["stockTakingDetailId"] = this.stockTakingDetailId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["isEmpty"] = this.isEmpty;
        data["isCounted"] = this.isCounted;
        data["isControlFinished"] = this.isControlFinished;
        data["isSVApproved"] = this.isSVApproved;
        data["isOnControlList"] = this.isOnControlList;
        data["shelfCurrentQuantity"] = this.shelfCurrentQuantity;
        data["stockQuantity"] = this.stockQuantity;
        data["stControlCount"] = this.stControlCount;
        data["stSupervisorCount"] = this.stSupervisorCount;
        data["stShelf"] = this.stShelf ? this.stShelf.toJSON() : <any>undefined;
        data["stShelfId"] = this.stShelfId;
        data["stControlTime"] = this.stControlTime ? this.stControlTime.toISOString() : <any>undefined;
        data["stSupervisorTime"] = this.stSupervisorTime ? this.stSupervisorTime.toISOString() : <any>undefined;
        data["stControlUser"] = this.stControlUser ? this.stControlUser.toJSON() : <any>undefined;
        data["stControlUserId"] = this.stControlUserId;
        data["stSupervisorUser"] = this.stSupervisorUser ? this.stSupervisorUser.toJSON() : <any>undefined;
        data["stSupervisorUserId"] = this.stSupervisorUserId;
        data["isControlStarted"] = this.isControlStarted;
        data["stControlFinishTime"] = this.stControlFinishTime ? this.stControlFinishTime.toISOString() : <any>undefined;
        data["isOnSupervisorControlList"] = this.isOnSupervisorControlList;
        data["isSupervisorControlStarted"] = this.isSupervisorControlStarted;
        data["isSupervisorControlFinished"] = this.isSupervisorControlFinished;
        data["stSupervisorFinishTime"] = this.stSupervisorFinishTime ? this.stSupervisorFinishTime.toISOString() : <any>undefined;
        data["assignedControlUser"] = this.assignedControlUser ? this.assignedControlUser.toJSON() : <any>undefined;
        data["assignedControlUserId"] = this.assignedControlUserId;
        data["controlGroup"] = this.controlGroup;
        data["erpStorageQuantity"] = this.erpStorageQuantity;
        data["wmsStorageQuantity"] = this.wmsStorageQuantity;
        data["wmsShelfQuantity"] = this.wmsShelfQuantity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): StockTakingActionProcess {
        const json = this.toJSON();
        let result = new StockTakingActionProcess();
        result.init(json);
        return result;
    }
}

export interface IStockTakingActionProcess {
    stockTakingDetail: StockTakingDetail;
    stockTakingDetailId: number;
    product: Product;
    productId: number | undefined;
    startTime: Date | undefined;
    finishTime: Date | undefined;
    isStarted: boolean;
    isFinished: boolean;
    isEmpty: boolean;
    isCounted: boolean;
    isControlFinished: boolean;
    isSVApproved: boolean;
    isOnControlList: boolean;
    shelfCurrentQuantity: number;
    stockQuantity: number;
    stControlCount: number;
    stSupervisorCount: number;
    stShelf: Shelf;
    stShelfId: number;
    stControlTime: Date | undefined;
    stSupervisorTime: Date | undefined;
    stControlUser: User;
    stControlUserId: number | undefined;
    stSupervisorUser: User;
    stSupervisorUserId: number | undefined;
    isControlStarted: boolean;
    stControlFinishTime: Date | undefined;
    isOnSupervisorControlList: boolean;
    isSupervisorControlStarted: boolean;
    isSupervisorControlFinished: boolean;
    stSupervisorFinishTime: Date | undefined;
    assignedControlUser: User;
    assignedControlUserId: number | undefined;
    controlGroup: number;
    erpStorageQuantity: number;
    wmsStorageQuantity: number;
    wmsShelfQuantity: number;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class StockTakingHeaderDtoPagedResultDto implements IStockTakingHeaderDtoPagedResultDto {
    totalCount: number;
    items: StockTakingHeaderDto[] | undefined;

    constructor(data?: IStockTakingHeaderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StockTakingHeaderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockTakingHeaderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockTakingHeaderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): StockTakingHeaderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StockTakingHeaderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStockTakingHeaderDtoPagedResultDto {
    totalCount: number;
    items: StockTakingHeaderDto[] | undefined;
}

export class ProductQuantityDto implements IProductQuantityDto {
    product: ProductDto;
    quantity: number;

    constructor(data?: IProductQuantityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): ProductQuantityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductQuantityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): ProductQuantityDto {
        const json = this.toJSON();
        let result = new ProductQuantityDto();
        result.init(json);
        return result;
    }
}

export interface IProductQuantityDto {
    product: ProductDto;
    quantity: number;
}

export class FastCountingProcessDto implements IFastCountingProcessDto {
    shelfId: number;
    productQuantityDtoList: ProductQuantityDto[] | undefined;
    stockTakingDetailId: number;

    constructor(data?: IFastCountingProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shelfId = _data["shelfId"];
            if (Array.isArray(_data["productQuantityDtoList"])) {
                this.productQuantityDtoList = [] as any;
                for (let item of _data["productQuantityDtoList"])
                    this.productQuantityDtoList.push(ProductQuantityDto.fromJS(item));
            }
            this.stockTakingDetailId = _data["stockTakingDetailId"];
        }
    }

    static fromJS(data: any): FastCountingProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new FastCountingProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shelfId"] = this.shelfId;
        if (Array.isArray(this.productQuantityDtoList)) {
            data["productQuantityDtoList"] = [];
            for (let item of this.productQuantityDtoList)
                data["productQuantityDtoList"].push(item.toJSON());
        }
        data["stockTakingDetailId"] = this.stockTakingDetailId;
        return data;
    }

    clone(): FastCountingProcessDto {
        const json = this.toJSON();
        let result = new FastCountingProcessDto();
        result.init(json);
        return result;
    }
}

export interface IFastCountingProcessDto {
    shelfId: number;
    productQuantityDtoList: ProductQuantityDto[] | undefined;
    stockTakingDetailId: number;
}

export class StockTakingDetailDtoPagedResultDto implements IStockTakingDetailDtoPagedResultDto {
    totalCount: number;
    items: StockTakingDetailDto[] | undefined;

    constructor(data?: IStockTakingDetailDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StockTakingDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockTakingDetailDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockTakingDetailDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): StockTakingDetailDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StockTakingDetailDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStockTakingDetailDtoPagedResultDto {
    totalCount: number;
    items: StockTakingDetailDto[] | undefined;
}

export class BatchCreateDetailDto implements IBatchCreateDetailDto {
    stHeaderId: number;
    assignedUserId: number;
    detailGroup: string | undefined;
    stActionTypeId: number;
    shelfIdList: number[] | undefined;
    shelfFullAddressList: string[] | undefined;

    constructor(data?: IBatchCreateDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stHeaderId = _data["stHeaderId"];
            this.assignedUserId = _data["assignedUserId"];
            this.detailGroup = _data["detailGroup"];
            this.stActionTypeId = _data["stActionTypeId"];
            if (Array.isArray(_data["shelfIdList"])) {
                this.shelfIdList = [] as any;
                for (let item of _data["shelfIdList"])
                    this.shelfIdList.push(item);
            }
            if (Array.isArray(_data["shelfFullAddressList"])) {
                this.shelfFullAddressList = [] as any;
                for (let item of _data["shelfFullAddressList"])
                    this.shelfFullAddressList.push(item);
            }
        }
    }

    static fromJS(data: any): BatchCreateDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchCreateDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stHeaderId"] = this.stHeaderId;
        data["assignedUserId"] = this.assignedUserId;
        data["detailGroup"] = this.detailGroup;
        data["stActionTypeId"] = this.stActionTypeId;
        if (Array.isArray(this.shelfIdList)) {
            data["shelfIdList"] = [];
            for (let item of this.shelfIdList)
                data["shelfIdList"].push(item);
        }
        if (Array.isArray(this.shelfFullAddressList)) {
            data["shelfFullAddressList"] = [];
            for (let item of this.shelfFullAddressList)
                data["shelfFullAddressList"].push(item);
        }
        return data;
    }

    clone(): BatchCreateDetailDto {
        const json = this.toJSON();
        let result = new BatchCreateDetailDto();
        result.init(json);
        return result;
    }
}

export interface IBatchCreateDetailDto {
    stHeaderId: number;
    assignedUserId: number;
    detailGroup: string | undefined;
    stActionTypeId: number;
    shelfIdList: number[] | undefined;
    shelfFullAddressList: string[] | undefined;
}

export class BatchUpdateDetailDto implements IBatchUpdateDetailDto {
    stHeaderId: number;
    assignedUserId: number;
    shelfIdList: number[] | undefined;
    shelfFullAddressList: string[] | undefined;
    detailIdList: number[] | undefined;

    constructor(data?: IBatchUpdateDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stHeaderId = _data["stHeaderId"];
            this.assignedUserId = _data["assignedUserId"];
            if (Array.isArray(_data["shelfIdList"])) {
                this.shelfIdList = [] as any;
                for (let item of _data["shelfIdList"])
                    this.shelfIdList.push(item);
            }
            if (Array.isArray(_data["shelfFullAddressList"])) {
                this.shelfFullAddressList = [] as any;
                for (let item of _data["shelfFullAddressList"])
                    this.shelfFullAddressList.push(item);
            }
            if (Array.isArray(_data["detailIdList"])) {
                this.detailIdList = [] as any;
                for (let item of _data["detailIdList"])
                    this.detailIdList.push(item);
            }
        }
    }

    static fromJS(data: any): BatchUpdateDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchUpdateDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stHeaderId"] = this.stHeaderId;
        data["assignedUserId"] = this.assignedUserId;
        if (Array.isArray(this.shelfIdList)) {
            data["shelfIdList"] = [];
            for (let item of this.shelfIdList)
                data["shelfIdList"].push(item);
        }
        if (Array.isArray(this.shelfFullAddressList)) {
            data["shelfFullAddressList"] = [];
            for (let item of this.shelfFullAddressList)
                data["shelfFullAddressList"].push(item);
        }
        if (Array.isArray(this.detailIdList)) {
            data["detailIdList"] = [];
            for (let item of this.detailIdList)
                data["detailIdList"].push(item);
        }
        return data;
    }

    clone(): BatchUpdateDetailDto {
        const json = this.toJSON();
        let result = new BatchUpdateDetailDto();
        result.init(json);
        return result;
    }
}

export interface IBatchUpdateDetailDto {
    stHeaderId: number;
    assignedUserId: number;
    shelfIdList: number[] | undefined;
    shelfFullAddressList: string[] | undefined;
    detailIdList: number[] | undefined;
}

export class DetailGroupDto implements IDetailGroupDto {
    detailGroup: string | undefined;
    detailGroupStatus: string | undefined;

    constructor(data?: IDetailGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.detailGroup = _data["detailGroup"];
            this.detailGroupStatus = _data["detailGroupStatus"];
        }
    }

    static fromJS(data: any): DetailGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new DetailGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailGroup"] = this.detailGroup;
        data["detailGroupStatus"] = this.detailGroupStatus;
        return data;
    }

    clone(): DetailGroupDto {
        const json = this.toJSON();
        let result = new DetailGroupDto();
        result.init(json);
        return result;
    }
}

export interface IDetailGroupDto {
    detailGroup: string | undefined;
    detailGroupStatus: string | undefined;
}

export class StockTakingActionProcessDto implements IStockTakingActionProcessDto {
    stockTakingDetail: StockTakingDetailDto;
    product: Product;
    startTime: Date;
    finishTime: Date;
    isStarted: boolean;
    isFinished: boolean;
    isEmpty: boolean;
    isCounted: boolean;
    isControlFinished: boolean;
    isSVApproved: boolean;
    isOnControlList: boolean;
    shelfCurrentQuantity: number;
    stockQuantity: number;
    stControlCount: number;
    stSupervisorCount: number;
    stShelf: Shelf;
    stControlTime: Date;
    stSupervisorTime: Date;
    stControlUser: UserDto;
    stSupervisorUser: UserDto;
    isControlStarted: boolean;
    stControlFinishTime: Date;
    isOnSupervisorControlList: boolean;
    isSupervisorControlStarted: boolean;
    isSupervisorControlFinished: boolean;
    stSupervisorFinishTime: Date;
    assignedControlUser: UserDto;
    controlGroup: number;
    id: number;

    constructor(data?: IStockTakingActionProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockTakingDetail = _data["stockTakingDetail"] ? StockTakingDetailDto.fromJS(_data["stockTakingDetail"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : <any>undefined;
            this.isStarted = _data["isStarted"];
            this.isFinished = _data["isFinished"];
            this.isEmpty = _data["isEmpty"];
            this.isCounted = _data["isCounted"];
            this.isControlFinished = _data["isControlFinished"];
            this.isSVApproved = _data["isSVApproved"];
            this.isOnControlList = _data["isOnControlList"];
            this.shelfCurrentQuantity = _data["shelfCurrentQuantity"];
            this.stockQuantity = _data["stockQuantity"];
            this.stControlCount = _data["stControlCount"];
            this.stSupervisorCount = _data["stSupervisorCount"];
            this.stShelf = _data["stShelf"] ? Shelf.fromJS(_data["stShelf"]) : <any>undefined;
            this.stControlTime = _data["stControlTime"] ? new Date(_data["stControlTime"].toString()) : <any>undefined;
            this.stSupervisorTime = _data["stSupervisorTime"] ? new Date(_data["stSupervisorTime"].toString()) : <any>undefined;
            this.stControlUser = _data["stControlUser"] ? UserDto.fromJS(_data["stControlUser"]) : <any>undefined;
            this.stSupervisorUser = _data["stSupervisorUser"] ? UserDto.fromJS(_data["stSupervisorUser"]) : <any>undefined;
            this.isControlStarted = _data["isControlStarted"];
            this.stControlFinishTime = _data["stControlFinishTime"] ? new Date(_data["stControlFinishTime"].toString()) : <any>undefined;
            this.isOnSupervisorControlList = _data["isOnSupervisorControlList"];
            this.isSupervisorControlStarted = _data["isSupervisorControlStarted"];
            this.isSupervisorControlFinished = _data["isSupervisorControlFinished"];
            this.stSupervisorFinishTime = _data["stSupervisorFinishTime"] ? new Date(_data["stSupervisorFinishTime"].toString()) : <any>undefined;
            this.assignedControlUser = _data["assignedControlUser"] ? UserDto.fromJS(_data["assignedControlUser"]) : <any>undefined;
            this.controlGroup = _data["controlGroup"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StockTakingActionProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockTakingActionProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockTakingDetail"] = this.stockTakingDetail ? this.stockTakingDetail.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["isEmpty"] = this.isEmpty;
        data["isCounted"] = this.isCounted;
        data["isControlFinished"] = this.isControlFinished;
        data["isSVApproved"] = this.isSVApproved;
        data["isOnControlList"] = this.isOnControlList;
        data["shelfCurrentQuantity"] = this.shelfCurrentQuantity;
        data["stockQuantity"] = this.stockQuantity;
        data["stControlCount"] = this.stControlCount;
        data["stSupervisorCount"] = this.stSupervisorCount;
        data["stShelf"] = this.stShelf ? this.stShelf.toJSON() : <any>undefined;
        data["stControlTime"] = this.stControlTime ? this.stControlTime.toISOString() : <any>undefined;
        data["stSupervisorTime"] = this.stSupervisorTime ? this.stSupervisorTime.toISOString() : <any>undefined;
        data["stControlUser"] = this.stControlUser ? this.stControlUser.toJSON() : <any>undefined;
        data["stSupervisorUser"] = this.stSupervisorUser ? this.stSupervisorUser.toJSON() : <any>undefined;
        data["isControlStarted"] = this.isControlStarted;
        data["stControlFinishTime"] = this.stControlFinishTime ? this.stControlFinishTime.toISOString() : <any>undefined;
        data["isOnSupervisorControlList"] = this.isOnSupervisorControlList;
        data["isSupervisorControlStarted"] = this.isSupervisorControlStarted;
        data["isSupervisorControlFinished"] = this.isSupervisorControlFinished;
        data["stSupervisorFinishTime"] = this.stSupervisorFinishTime ? this.stSupervisorFinishTime.toISOString() : <any>undefined;
        data["assignedControlUser"] = this.assignedControlUser ? this.assignedControlUser.toJSON() : <any>undefined;
        data["controlGroup"] = this.controlGroup;
        data["id"] = this.id;
        return data;
    }

    clone(): StockTakingActionProcessDto {
        const json = this.toJSON();
        let result = new StockTakingActionProcessDto();
        result.init(json);
        return result;
    }
}

export interface IStockTakingActionProcessDto {
    stockTakingDetail: StockTakingDetailDto;
    product: Product;
    startTime: Date;
    finishTime: Date;
    isStarted: boolean;
    isFinished: boolean;
    isEmpty: boolean;
    isCounted: boolean;
    isControlFinished: boolean;
    isSVApproved: boolean;
    isOnControlList: boolean;
    shelfCurrentQuantity: number;
    stockQuantity: number;
    stControlCount: number;
    stSupervisorCount: number;
    stShelf: Shelf;
    stControlTime: Date;
    stSupervisorTime: Date;
    stControlUser: UserDto;
    stSupervisorUser: UserDto;
    isControlStarted: boolean;
    stControlFinishTime: Date;
    isOnSupervisorControlList: boolean;
    isSupervisorControlStarted: boolean;
    isSupervisorControlFinished: boolean;
    stSupervisorFinishTime: Date;
    assignedControlUser: UserDto;
    controlGroup: number;
    id: number;
}

export class StockTakingActionProcessDtoForPda implements IStockTakingActionProcessDtoForPda {
    stockTakingDetail: StockTakingDetailDto;
    product: Product;
    startTime: Date;
    isStarted: boolean;
    isFinished: boolean;
    isEmpty: boolean;
    isControlFinished: boolean;
    shelfCurrentQuantity: number;
    stShelf: Shelf;
    isControlStarted: boolean;
    isSupervisorControlFinished: boolean;
    assignedControlUser: UserDto;
    id: number;

    constructor(data?: IStockTakingActionProcessDtoForPda) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockTakingDetail = _data["stockTakingDetail"] ? StockTakingDetailDto.fromJS(_data["stockTakingDetail"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.isStarted = _data["isStarted"];
            this.isFinished = _data["isFinished"];
            this.isEmpty = _data["isEmpty"];
            this.isControlFinished = _data["isControlFinished"];
            this.shelfCurrentQuantity = _data["shelfCurrentQuantity"];
            this.stShelf = _data["stShelf"] ? Shelf.fromJS(_data["stShelf"]) : <any>undefined;
            this.isControlStarted = _data["isControlStarted"];
            this.isSupervisorControlFinished = _data["isSupervisorControlFinished"];
            this.assignedControlUser = _data["assignedControlUser"] ? UserDto.fromJS(_data["assignedControlUser"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StockTakingActionProcessDtoForPda {
        data = typeof data === 'object' ? data : {};
        let result = new StockTakingActionProcessDtoForPda();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockTakingDetail"] = this.stockTakingDetail ? this.stockTakingDetail.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["isEmpty"] = this.isEmpty;
        data["isControlFinished"] = this.isControlFinished;
        data["shelfCurrentQuantity"] = this.shelfCurrentQuantity;
        data["stShelf"] = this.stShelf ? this.stShelf.toJSON() : <any>undefined;
        data["isControlStarted"] = this.isControlStarted;
        data["isSupervisorControlFinished"] = this.isSupervisorControlFinished;
        data["assignedControlUser"] = this.assignedControlUser ? this.assignedControlUser.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): StockTakingActionProcessDtoForPda {
        const json = this.toJSON();
        let result = new StockTakingActionProcessDtoForPda();
        result.init(json);
        return result;
    }
}

export interface IStockTakingActionProcessDtoForPda {
    stockTakingDetail: StockTakingDetailDto;
    product: Product;
    startTime: Date;
    isStarted: boolean;
    isFinished: boolean;
    isEmpty: boolean;
    isControlFinished: boolean;
    shelfCurrentQuantity: number;
    stShelf: Shelf;
    isControlStarted: boolean;
    isSupervisorControlFinished: boolean;
    assignedControlUser: UserDto;
    id: number;
}

export class StockTakingActionProcessDtoPagedResultDto implements IStockTakingActionProcessDtoPagedResultDto {
    totalCount: number;
    items: StockTakingActionProcessDto[] | undefined;

    constructor(data?: IStockTakingActionProcessDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StockTakingActionProcessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockTakingActionProcessDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockTakingActionProcessDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): StockTakingActionProcessDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StockTakingActionProcessDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStockTakingActionProcessDtoPagedResultDto {
    totalCount: number;
    items: StockTakingActionProcessDto[] | undefined;
}

export class ReportingStockTakingActionProcessDto implements IReportingStockTakingActionProcessDto {
    creatorUserId: number;
    startTime: Date;
    finishTime: Date;
    stockTakingDetail: StockTakingDetailDto;
    product: ProductDto;
    stShelf: ShelfDto;
    stockQuantity: number;
    shelfCurrentQuantity: number;
    isStarted: boolean;
    isFinished: boolean;
    isEmpty: boolean;
    isCounted: boolean;
    isOnControlList: boolean;
    stControlCount: number;
    isControlStarted: boolean;
    isControlFinished: boolean;
    stControlTime: Date;
    stControlFinishTime: Date;
    stControlUser: UserDto;
    isOnSupervisorControlList: boolean;
    stSupervisorCount: number;
    isSupervisorControlStarted: boolean;
    isSupervisorControlFinished: boolean;
    stSupervisorTime: Date;
    stSupervisorFinishTime: Date;
    stSupervisorUser: UserDto;
    isSVApproved: boolean;
    readonly stockShelfQuantityDiff: number;
    readonly stockControlCountQuantityDiff: number;
    readonly stockSupervisorCountQuantityDiff: number;
    erpProductTotalQuantity: number;
    wmsProductTotalQuantity: number;
    wmsProductTotalQuantityAfterControl: number;
    wmsProductTotalQuantityAfterSupervisor: number;
    erpStorageQuantity: number;
    wmsStorageQuantity: number;
    wmsShelfQuantity: number;
    readonly erpWmsProductQuantityDiff: number;
    readonly erpWmsAfterControlProductQuantityDiff: number;
    readonly erpWmsAfterSupervisorProductQuantityDiff: number;
    completionProductTotalQuantity: number;
    completionProductShelfQuantity: number;
    assignedControlUser: UserDto;
    controlGroup: number;
    id: number;

    constructor(data?: IReportingStockTakingActionProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creatorUserId = _data["creatorUserId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : <any>undefined;
            this.stockTakingDetail = _data["stockTakingDetail"] ? StockTakingDetailDto.fromJS(_data["stockTakingDetail"]) : <any>undefined;
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.stShelf = _data["stShelf"] ? ShelfDto.fromJS(_data["stShelf"]) : <any>undefined;
            this.stockQuantity = _data["stockQuantity"];
            this.shelfCurrentQuantity = _data["shelfCurrentQuantity"];
            this.isStarted = _data["isStarted"];
            this.isFinished = _data["isFinished"];
            this.isEmpty = _data["isEmpty"];
            this.isCounted = _data["isCounted"];
            this.isOnControlList = _data["isOnControlList"];
            this.stControlCount = _data["stControlCount"];
            this.isControlStarted = _data["isControlStarted"];
            this.isControlFinished = _data["isControlFinished"];
            this.stControlTime = _data["stControlTime"] ? new Date(_data["stControlTime"].toString()) : <any>undefined;
            this.stControlFinishTime = _data["stControlFinishTime"] ? new Date(_data["stControlFinishTime"].toString()) : <any>undefined;
            this.stControlUser = _data["stControlUser"] ? UserDto.fromJS(_data["stControlUser"]) : <any>undefined;
            this.isOnSupervisorControlList = _data["isOnSupervisorControlList"];
            this.stSupervisorCount = _data["stSupervisorCount"];
            this.isSupervisorControlStarted = _data["isSupervisorControlStarted"];
            this.isSupervisorControlFinished = _data["isSupervisorControlFinished"];
            this.stSupervisorTime = _data["stSupervisorTime"] ? new Date(_data["stSupervisorTime"].toString()) : <any>undefined;
            this.stSupervisorFinishTime = _data["stSupervisorFinishTime"] ? new Date(_data["stSupervisorFinishTime"].toString()) : <any>undefined;
            this.stSupervisorUser = _data["stSupervisorUser"] ? UserDto.fromJS(_data["stSupervisorUser"]) : <any>undefined;
            this.isSVApproved = _data["isSVApproved"];
            (<any>this).stockShelfQuantityDiff = _data["stockShelfQuantityDiff"];
            (<any>this).stockControlCountQuantityDiff = _data["stockControlCountQuantityDiff"];
            (<any>this).stockSupervisorCountQuantityDiff = _data["stockSupervisorCountQuantityDiff"];
            this.erpProductTotalQuantity = _data["erpProductTotalQuantity"];
            this.wmsProductTotalQuantity = _data["wmsProductTotalQuantity"];
            this.wmsProductTotalQuantityAfterControl = _data["wmsProductTotalQuantityAfterControl"];
            this.wmsProductTotalQuantityAfterSupervisor = _data["wmsProductTotalQuantityAfterSupervisor"];
            this.erpStorageQuantity = _data["erpStorageQuantity"];
            this.wmsStorageQuantity = _data["wmsStorageQuantity"];
            this.wmsShelfQuantity = _data["wmsShelfQuantity"];
            (<any>this).erpWmsProductQuantityDiff = _data["erpWmsProductQuantityDiff"];
            (<any>this).erpWmsAfterControlProductQuantityDiff = _data["erpWmsAfterControlProductQuantityDiff"];
            (<any>this).erpWmsAfterSupervisorProductQuantityDiff = _data["erpWmsAfterSupervisorProductQuantityDiff"];
            this.completionProductTotalQuantity = _data["completionProductTotalQuantity"];
            this.completionProductShelfQuantity = _data["completionProductShelfQuantity"];
            this.assignedControlUser = _data["assignedControlUser"] ? UserDto.fromJS(_data["assignedControlUser"]) : <any>undefined;
            this.controlGroup = _data["controlGroup"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReportingStockTakingActionProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingStockTakingActionProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["stockTakingDetail"] = this.stockTakingDetail ? this.stockTakingDetail.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["stShelf"] = this.stShelf ? this.stShelf.toJSON() : <any>undefined;
        data["stockQuantity"] = this.stockQuantity;
        data["shelfCurrentQuantity"] = this.shelfCurrentQuantity;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["isEmpty"] = this.isEmpty;
        data["isCounted"] = this.isCounted;
        data["isOnControlList"] = this.isOnControlList;
        data["stControlCount"] = this.stControlCount;
        data["isControlStarted"] = this.isControlStarted;
        data["isControlFinished"] = this.isControlFinished;
        data["stControlTime"] = this.stControlTime ? this.stControlTime.toISOString() : <any>undefined;
        data["stControlFinishTime"] = this.stControlFinishTime ? this.stControlFinishTime.toISOString() : <any>undefined;
        data["stControlUser"] = this.stControlUser ? this.stControlUser.toJSON() : <any>undefined;
        data["isOnSupervisorControlList"] = this.isOnSupervisorControlList;
        data["stSupervisorCount"] = this.stSupervisorCount;
        data["isSupervisorControlStarted"] = this.isSupervisorControlStarted;
        data["isSupervisorControlFinished"] = this.isSupervisorControlFinished;
        data["stSupervisorTime"] = this.stSupervisorTime ? this.stSupervisorTime.toISOString() : <any>undefined;
        data["stSupervisorFinishTime"] = this.stSupervisorFinishTime ? this.stSupervisorFinishTime.toISOString() : <any>undefined;
        data["stSupervisorUser"] = this.stSupervisorUser ? this.stSupervisorUser.toJSON() : <any>undefined;
        data["isSVApproved"] = this.isSVApproved;
        data["stockShelfQuantityDiff"] = this.stockShelfQuantityDiff;
        data["stockControlCountQuantityDiff"] = this.stockControlCountQuantityDiff;
        data["stockSupervisorCountQuantityDiff"] = this.stockSupervisorCountQuantityDiff;
        data["erpProductTotalQuantity"] = this.erpProductTotalQuantity;
        data["wmsProductTotalQuantity"] = this.wmsProductTotalQuantity;
        data["wmsProductTotalQuantityAfterControl"] = this.wmsProductTotalQuantityAfterControl;
        data["wmsProductTotalQuantityAfterSupervisor"] = this.wmsProductTotalQuantityAfterSupervisor;
        data["erpStorageQuantity"] = this.erpStorageQuantity;
        data["wmsStorageQuantity"] = this.wmsStorageQuantity;
        data["wmsShelfQuantity"] = this.wmsShelfQuantity;
        data["erpWmsProductQuantityDiff"] = this.erpWmsProductQuantityDiff;
        data["erpWmsAfterControlProductQuantityDiff"] = this.erpWmsAfterControlProductQuantityDiff;
        data["erpWmsAfterSupervisorProductQuantityDiff"] = this.erpWmsAfterSupervisorProductQuantityDiff;
        data["completionProductTotalQuantity"] = this.completionProductTotalQuantity;
        data["completionProductShelfQuantity"] = this.completionProductShelfQuantity;
        data["assignedControlUser"] = this.assignedControlUser ? this.assignedControlUser.toJSON() : <any>undefined;
        data["controlGroup"] = this.controlGroup;
        data["id"] = this.id;
        return data;
    }

    clone(): ReportingStockTakingActionProcessDto {
        const json = this.toJSON();
        let result = new ReportingStockTakingActionProcessDto();
        result.init(json);
        return result;
    }
}

export interface IReportingStockTakingActionProcessDto {
    creatorUserId: number;
    startTime: Date;
    finishTime: Date;
    stockTakingDetail: StockTakingDetailDto;
    product: ProductDto;
    stShelf: ShelfDto;
    stockQuantity: number;
    shelfCurrentQuantity: number;
    isStarted: boolean;
    isFinished: boolean;
    isEmpty: boolean;
    isCounted: boolean;
    isOnControlList: boolean;
    stControlCount: number;
    isControlStarted: boolean;
    isControlFinished: boolean;
    stControlTime: Date;
    stControlFinishTime: Date;
    stControlUser: UserDto;
    isOnSupervisorControlList: boolean;
    stSupervisorCount: number;
    isSupervisorControlStarted: boolean;
    isSupervisorControlFinished: boolean;
    stSupervisorTime: Date;
    stSupervisorFinishTime: Date;
    stSupervisorUser: UserDto;
    isSVApproved: boolean;
    stockShelfQuantityDiff: number;
    stockControlCountQuantityDiff: number;
    stockSupervisorCountQuantityDiff: number;
    erpProductTotalQuantity: number;
    wmsProductTotalQuantity: number;
    wmsProductTotalQuantityAfterControl: number;
    wmsProductTotalQuantityAfterSupervisor: number;
    erpStorageQuantity: number;
    wmsStorageQuantity: number;
    wmsShelfQuantity: number;
    erpWmsProductQuantityDiff: number;
    erpWmsAfterControlProductQuantityDiff: number;
    erpWmsAfterSupervisorProductQuantityDiff: number;
    completionProductTotalQuantity: number;
    completionProductShelfQuantity: number;
    assignedControlUser: UserDto;
    controlGroup: number;
    id: number;
}

export class ReportingStockTakingActionProcessDtoPagedResultDto implements IReportingStockTakingActionProcessDtoPagedResultDto {
    totalCount: number;
    items: ReportingStockTakingActionProcessDto[] | undefined;

    constructor(data?: IReportingStockTakingActionProcessDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ReportingStockTakingActionProcessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportingStockTakingActionProcessDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingStockTakingActionProcessDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ReportingStockTakingActionProcessDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReportingStockTakingActionProcessDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReportingStockTakingActionProcessDtoPagedResultDto {
    totalCount: number;
    items: ReportingStockTakingActionProcessDto[] | undefined;
}

export class ReportingCompletionProductTotalQuantityDto implements IReportingCompletionProductTotalQuantityDto {
    stockTakingDetail: StockTakingDetailDto;
    product: Product;
    completionProductTotalQuantity: number;
    id: number;

    constructor(data?: IReportingCompletionProductTotalQuantityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockTakingDetail = _data["stockTakingDetail"] ? StockTakingDetailDto.fromJS(_data["stockTakingDetail"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.completionProductTotalQuantity = _data["completionProductTotalQuantity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReportingCompletionProductTotalQuantityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingCompletionProductTotalQuantityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockTakingDetail"] = this.stockTakingDetail ? this.stockTakingDetail.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["completionProductTotalQuantity"] = this.completionProductTotalQuantity;
        data["id"] = this.id;
        return data;
    }

    clone(): ReportingCompletionProductTotalQuantityDto {
        const json = this.toJSON();
        let result = new ReportingCompletionProductTotalQuantityDto();
        result.init(json);
        return result;
    }
}

export interface IReportingCompletionProductTotalQuantityDto {
    stockTakingDetail: StockTakingDetailDto;
    product: Product;
    completionProductTotalQuantity: number;
    id: number;
}

export class ReportingCompletionProductTotalQuantityDtoPagedResultDto implements IReportingCompletionProductTotalQuantityDtoPagedResultDto {
    totalCount: number;
    items: ReportingCompletionProductTotalQuantityDto[] | undefined;

    constructor(data?: IReportingCompletionProductTotalQuantityDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ReportingCompletionProductTotalQuantityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportingCompletionProductTotalQuantityDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingCompletionProductTotalQuantityDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ReportingCompletionProductTotalQuantityDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReportingCompletionProductTotalQuantityDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReportingCompletionProductTotalQuantityDtoPagedResultDto {
    totalCount: number;
    items: ReportingCompletionProductTotalQuantityDto[] | undefined;
}

export class BatchControlListCreationSTAPDto implements IBatchControlListCreationSTAPDto {
    stapIdList: number[] | undefined;
    productIdList: number[] | undefined;
    stShelfIdList: number[] | undefined;
    addToControlList: boolean[] | undefined;
    controlGroupList: number[] | undefined;

    constructor(data?: IBatchControlListCreationSTAPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stapIdList"])) {
                this.stapIdList = [] as any;
                for (let item of _data["stapIdList"])
                    this.stapIdList.push(item);
            }
            if (Array.isArray(_data["productIdList"])) {
                this.productIdList = [] as any;
                for (let item of _data["productIdList"])
                    this.productIdList.push(item);
            }
            if (Array.isArray(_data["stShelfIdList"])) {
                this.stShelfIdList = [] as any;
                for (let item of _data["stShelfIdList"])
                    this.stShelfIdList.push(item);
            }
            if (Array.isArray(_data["addToControlList"])) {
                this.addToControlList = [] as any;
                for (let item of _data["addToControlList"])
                    this.addToControlList.push(item);
            }
            if (Array.isArray(_data["controlGroupList"])) {
                this.controlGroupList = [] as any;
                for (let item of _data["controlGroupList"])
                    this.controlGroupList.push(item);
            }
        }
    }

    static fromJS(data: any): BatchControlListCreationSTAPDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchControlListCreationSTAPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stapIdList)) {
            data["stapIdList"] = [];
            for (let item of this.stapIdList)
                data["stapIdList"].push(item);
        }
        if (Array.isArray(this.productIdList)) {
            data["productIdList"] = [];
            for (let item of this.productIdList)
                data["productIdList"].push(item);
        }
        if (Array.isArray(this.stShelfIdList)) {
            data["stShelfIdList"] = [];
            for (let item of this.stShelfIdList)
                data["stShelfIdList"].push(item);
        }
        if (Array.isArray(this.addToControlList)) {
            data["addToControlList"] = [];
            for (let item of this.addToControlList)
                data["addToControlList"].push(item);
        }
        if (Array.isArray(this.controlGroupList)) {
            data["controlGroupList"] = [];
            for (let item of this.controlGroupList)
                data["controlGroupList"].push(item);
        }
        return data;
    }

    clone(): BatchControlListCreationSTAPDto {
        const json = this.toJSON();
        let result = new BatchControlListCreationSTAPDto();
        result.init(json);
        return result;
    }
}

export interface IBatchControlListCreationSTAPDto {
    stapIdList: number[] | undefined;
    productIdList: number[] | undefined;
    stShelfIdList: number[] | undefined;
    addToControlList: boolean[] | undefined;
    controlGroupList: number[] | undefined;
}

export class ControlGrouptDto implements IControlGrouptDto {
    controlGroupId: number;
    controlGroupStatus: string | undefined;

    constructor(data?: IControlGrouptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.controlGroupId = _data["controlGroupId"];
            this.controlGroupStatus = _data["controlGroupStatus"];
        }
    }

    static fromJS(data: any): ControlGrouptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ControlGrouptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controlGroupId"] = this.controlGroupId;
        data["controlGroupStatus"] = this.controlGroupStatus;
        return data;
    }

    clone(): ControlGrouptDto {
        const json = this.toJSON();
        let result = new ControlGrouptDto();
        result.init(json);
        return result;
    }
}

export interface IControlGrouptDto {
    controlGroupId: number;
    controlGroupStatus: string | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class TenantDto implements ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean;
    id: number;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean;
    id: number;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    totalCount: number;
    items: TenantDto[] | undefined;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    totalCount: number;
    items: TenantDto[] | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
    companyId: number;
    warehouseId: number;
    printPointName: string | undefined;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
            this.companyId = _data["companyId"];
            this.warehouseId = _data["warehouseId"];
            this.printPointName = _data["printPointName"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        data["companyId"] = this.companyId;
        data["warehouseId"] = this.warehouseId;
        data["printPointName"] = this.printPointName;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
    companyId: number;
    warehouseId: number;
    printPointName: string | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class CreateUserDto implements ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    permissionNames: string[] | undefined;
    password: string;
    companyId: number;
    warehouseId: number;
    printPointName: string | undefined;
    acceptWaybillType: WaybillType;
    isChangeWarehouse: boolean;
    isChangeCompany: boolean;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            if (Array.isArray(_data["permissionNames"])) {
                this.permissionNames = [] as any;
                for (let item of _data["permissionNames"])
                    this.permissionNames.push(item);
            }
            this.password = _data["password"];
            this.companyId = _data["companyId"];
            this.warehouseId = _data["warehouseId"];
            this.printPointName = _data["printPointName"];
            this.acceptWaybillType = _data["acceptWaybillType"];
            this.isChangeWarehouse = _data["isChangeWarehouse"];
            this.isChangeCompany = _data["isChangeCompany"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        if (Array.isArray(this.permissionNames)) {
            data["permissionNames"] = [];
            for (let item of this.permissionNames)
                data["permissionNames"].push(item);
        }
        data["password"] = this.password;
        data["companyId"] = this.companyId;
        data["warehouseId"] = this.warehouseId;
        data["printPointName"] = this.printPointName;
        data["acceptWaybillType"] = this.acceptWaybillType;
        data["isChangeWarehouse"] = this.isChangeWarehouse;
        data["isChangeCompany"] = this.isChangeCompany;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    permissionNames: string[] | undefined;
    password: string;
    companyId: number;
    warehouseId: number;
    printPointName: string | undefined;
    acceptWaybillType: WaybillType;
    isChangeWarehouse: boolean;
    isChangeCompany: boolean;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class TimeSpan implements ITimeSpan {
    readonly ticks: number;
    readonly days: number;
    readonly hours: number;
    readonly milliseconds: number;
    readonly minutes: number;
    readonly seconds: number;
    readonly totalDays: number;
    readonly totalHours: number;
    readonly totalMilliseconds: number;
    readonly totalMinutes: number;
    readonly totalSeconds: number;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).ticks = _data["ticks"];
            (<any>this).days = _data["days"];
            (<any>this).hours = _data["hours"];
            (<any>this).milliseconds = _data["milliseconds"];
            (<any>this).minutes = _data["minutes"];
            (<any>this).seconds = _data["seconds"];
            (<any>this).totalDays = _data["totalDays"];
            (<any>this).totalHours = _data["totalHours"];
            (<any>this).totalMilliseconds = _data["totalMilliseconds"];
            (<any>this).totalMinutes = _data["totalMinutes"];
            (<any>this).totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }

    clone(): TimeSpan {
        const json = this.toJSON();
        let result = new TimeSpan();
        result.init(json);
        return result;
    }
}

export interface ITimeSpan {
    ticks: number;
    days: number;
    hours: number;
    milliseconds: number;
    minutes: number;
    seconds: number;
    totalDays: number;
    totalHours: number;
    totalMilliseconds: number;
    totalMinutes: number;
    totalSeconds: number;
}

export class OnlineUserDto implements IOnlineUserDto {
    userId: number;
    fullName: string | undefined;
    onlineDuration: TimeSpan;

    constructor(data?: IOnlineUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
            this.onlineDuration = _data["onlineDuration"] ? TimeSpan.fromJS(_data["onlineDuration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OnlineUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new OnlineUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        data["onlineDuration"] = this.onlineDuration ? this.onlineDuration.toJSON() : <any>undefined;
        return data;
    }

    clone(): OnlineUserDto {
        const json = this.toJSON();
        let result = new OnlineUserDto();
        result.init(json);
        return result;
    }
}

export interface IOnlineUserDto {
    userId: number;
    fullName: string | undefined;
    onlineDuration: TimeSpan;
}

export class WarehouseDtoPagedResultDto implements IWarehouseDtoPagedResultDto {
    totalCount: number;
    items: WarehouseDto[] | undefined;

    constructor(data?: IWarehouseDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WarehouseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WarehouseDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): WarehouseDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WarehouseDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWarehouseDtoPagedResultDto {
    totalCount: number;
    items: WarehouseDto[] | undefined;
}

export class WarehouseCompanyRelation implements IWarehouseCompanyRelation {
    warehouse: Warehouse;
    warehouseId: number;
    company: Company;
    companyId: number;
    code: string;
    definition: string | undefined;
    clientCode: string | undefined;
    cancelOrderReturnShelf: Shelf;
    cancelOrderReturnShelfId: number | undefined;
    id: number;

    constructor(data?: IWarehouseCompanyRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.warehouse = new Warehouse();
            this.company = new Company();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.warehouseId = _data["warehouseId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.companyId = _data["companyId"];
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.clientCode = _data["clientCode"];
            this.cancelOrderReturnShelf = _data["cancelOrderReturnShelf"] ? Shelf.fromJS(_data["cancelOrderReturnShelf"]) : <any>undefined;
            this.cancelOrderReturnShelfId = _data["cancelOrderReturnShelfId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WarehouseCompanyRelation {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseCompanyRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["clientCode"] = this.clientCode;
        data["cancelOrderReturnShelf"] = this.cancelOrderReturnShelf ? this.cancelOrderReturnShelf.toJSON() : <any>undefined;
        data["cancelOrderReturnShelfId"] = this.cancelOrderReturnShelfId;
        data["id"] = this.id;
        return data;
    }

    clone(): WarehouseCompanyRelation {
        const json = this.toJSON();
        let result = new WarehouseCompanyRelation();
        result.init(json);
        return result;
    }
}

export interface IWarehouseCompanyRelation {
    warehouse: Warehouse;
    warehouseId: number;
    company: Company;
    companyId: number;
    code: string;
    definition: string | undefined;
    clientCode: string | undefined;
    cancelOrderReturnShelf: Shelf;
    cancelOrderReturnShelfId: number | undefined;
    id: number;
}

export class StorageCompanyRelation implements IStorageCompanyRelation {
    storage: Storage;
    storageId: number;
    warehouseCompanyRelation: WarehouseCompanyRelation;
    warehouseCompanyRelationId: number;
    code: string;
    definition: string | undefined;
    order: boolean;
    acceptence: boolean;
    return: boolean;
    id: number;

    constructor(data?: IStorageCompanyRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.storage = new Storage();
            this.warehouseCompanyRelation = new WarehouseCompanyRelation();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storage = _data["storage"] ? Storage.fromJS(_data["storage"]) : new Storage();
            this.storageId = _data["storageId"];
            this.warehouseCompanyRelation = _data["warehouseCompanyRelation"] ? WarehouseCompanyRelation.fromJS(_data["warehouseCompanyRelation"]) : new WarehouseCompanyRelation();
            this.warehouseCompanyRelationId = _data["warehouseCompanyRelationId"];
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.order = _data["order"];
            this.acceptence = _data["acceptence"];
            this.return = _data["return"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StorageCompanyRelation {
        data = typeof data === 'object' ? data : {};
        let result = new StorageCompanyRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["storageId"] = this.storageId;
        data["warehouseCompanyRelation"] = this.warehouseCompanyRelation ? this.warehouseCompanyRelation.toJSON() : <any>undefined;
        data["warehouseCompanyRelationId"] = this.warehouseCompanyRelationId;
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["order"] = this.order;
        data["acceptence"] = this.acceptence;
        data["return"] = this.return;
        data["id"] = this.id;
        return data;
    }

    clone(): StorageCompanyRelation {
        const json = this.toJSON();
        let result = new StorageCompanyRelation();
        result.init(json);
        return result;
    }
}

export interface IStorageCompanyRelation {
    storage: Storage;
    storageId: number;
    warehouseCompanyRelation: WarehouseCompanyRelation;
    warehouseCompanyRelationId: number;
    code: string;
    definition: string | undefined;
    order: boolean;
    acceptence: boolean;
    return: boolean;
    id: number;
}

export class StorageCompanyRelationPagedResultDto implements IStorageCompanyRelationPagedResultDto {
    totalCount: number;
    items: StorageCompanyRelation[] | undefined;

    constructor(data?: IStorageCompanyRelationPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StorageCompanyRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StorageCompanyRelationPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorageCompanyRelationPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): StorageCompanyRelationPagedResultDto {
        const json = this.toJSON();
        let result = new StorageCompanyRelationPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStorageCompanyRelationPagedResultDto {
    totalCount: number;
    items: StorageCompanyRelation[] | undefined;
}

export class ControlPointPagedResultDto implements IControlPointPagedResultDto {
    totalCount: number;
    items: ControlPoint[] | undefined;

    constructor(data?: IControlPointPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ControlPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ControlPointPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ControlPointPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ControlPointPagedResultDto {
        const json = this.toJSON();
        let result = new ControlPointPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IControlPointPagedResultDto {
    totalCount: number;
    items: ControlPoint[] | undefined;
}

export class WaybillHeaderDto implements IWaybillHeaderDto {
    type: WaybillType;
    company: Company;
    warehouse: Warehouse;
    client: ClientDto;
    waybillDetailCount: number;
    companyDataSourceId: number;
    orderHeaderNo: string | undefined;
    workActivityId: number;
    orderDocumentNo: string | undefined;
    orderDocumentDate: Date;
    orderDeadlineDate: Date;
    creationTime: Date;
    documentNo: string | undefined;
    documentNo2: string | undefined;
    documentDate: Date;
    deadlineDate: Date;
    notes: string | undefined;
    detailCount: number;
    quantityWaybill: number;
    startDate: Date;
    finishDate: Date;
    isStarted: boolean;
    isFinished: boolean;
    isLocked: boolean;
    isDeleted: boolean;
    readonly timeDiff: number;
    readonly typeStr: string | undefined;
    id: number;

    constructor(data?: IWaybillHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.client = _data["client"] ? ClientDto.fromJS(_data["client"]) : <any>undefined;
            this.waybillDetailCount = _data["waybillDetailCount"];
            this.companyDataSourceId = _data["companyDataSourceId"];
            this.orderHeaderNo = _data["orderHeaderNo"];
            this.workActivityId = _data["workActivityId"];
            this.orderDocumentNo = _data["orderDocumentNo"];
            this.orderDocumentDate = _data["orderDocumentDate"] ? new Date(_data["orderDocumentDate"].toString()) : <any>undefined;
            this.orderDeadlineDate = _data["orderDeadlineDate"] ? new Date(_data["orderDeadlineDate"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.documentNo = _data["documentNo"];
            this.documentNo2 = _data["documentNo2"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.deadlineDate = _data["deadlineDate"] ? new Date(_data["deadlineDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.detailCount = _data["detailCount"];
            this.quantityWaybill = _data["quantityWaybill"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.finishDate = _data["finishDate"] ? new Date(_data["finishDate"].toString()) : <any>undefined;
            this.isStarted = _data["isStarted"];
            this.isFinished = _data["isFinished"];
            this.isLocked = _data["isLocked"];
            this.isDeleted = _data["isDeleted"];
            (<any>this).timeDiff = _data["timeDiff"];
            (<any>this).typeStr = _data["typeStr"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WaybillHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new WaybillHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["waybillDetailCount"] = this.waybillDetailCount;
        data["companyDataSourceId"] = this.companyDataSourceId;
        data["orderHeaderNo"] = this.orderHeaderNo;
        data["workActivityId"] = this.workActivityId;
        data["orderDocumentNo"] = this.orderDocumentNo;
        data["orderDocumentDate"] = this.orderDocumentDate ? this.orderDocumentDate.toISOString() : <any>undefined;
        data["orderDeadlineDate"] = this.orderDeadlineDate ? this.orderDeadlineDate.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["documentNo"] = this.documentNo;
        data["documentNo2"] = this.documentNo2;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["deadlineDate"] = this.deadlineDate ? this.deadlineDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["detailCount"] = this.detailCount;
        data["quantityWaybill"] = this.quantityWaybill;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["finishDate"] = this.finishDate ? this.finishDate.toISOString() : <any>undefined;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["isLocked"] = this.isLocked;
        data["isDeleted"] = this.isDeleted;
        data["timeDiff"] = this.timeDiff;
        data["typeStr"] = this.typeStr;
        data["id"] = this.id;
        return data;
    }

    clone(): WaybillHeaderDto {
        const json = this.toJSON();
        let result = new WaybillHeaderDto();
        result.init(json);
        return result;
    }
}

export interface IWaybillHeaderDto {
    type: WaybillType;
    company: Company;
    warehouse: Warehouse;
    client: ClientDto;
    waybillDetailCount: number;
    companyDataSourceId: number;
    orderHeaderNo: string | undefined;
    workActivityId: number;
    orderDocumentNo: string | undefined;
    orderDocumentDate: Date;
    orderDeadlineDate: Date;
    creationTime: Date;
    documentNo: string | undefined;
    documentNo2: string | undefined;
    documentDate: Date;
    deadlineDate: Date;
    notes: string | undefined;
    detailCount: number;
    quantityWaybill: number;
    startDate: Date;
    finishDate: Date;
    isStarted: boolean;
    isFinished: boolean;
    isLocked: boolean;
    isDeleted: boolean;
    timeDiff: number;
    typeStr: string | undefined;
    id: number;
}

export class WaybillHeaderDtoPagedResultDto implements IWaybillHeaderDtoPagedResultDto {
    totalCount: number;
    items: WaybillHeaderDto[] | undefined;

    constructor(data?: IWaybillHeaderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WaybillHeaderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WaybillHeaderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WaybillHeaderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): WaybillHeaderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WaybillHeaderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWaybillHeaderDtoPagedResultDto {
    totalCount: number;
    items: WaybillHeaderDto[] | undefined;
}

export class WorkActionProcess implements IWorkActionProcess {
    workAction: WorkAction;
    workActionId: number | undefined;
    sourceId: number;
    product: Product;
    productId: number | undefined;
    quantity: number;
    stCurrentQuantity: number;
    container: Container;
    containerId: number | undefined;
    shelfFrom: Shelf;
    shelfFromId: number | undefined;
    shelfTo: Shelf;
    shelfToId: number | undefined;
    stShelf: Shelf;
    stShelfId: number | undefined;
    orderHeader: OrderHeader;
    orderHeaderId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IWorkActionProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.workAction = new WorkAction();
            this.sourceId = 0;
            this.quantity = 0;
            this.stCurrentQuantity = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workAction = _data["workAction"] ? WorkAction.fromJS(_data["workAction"]) : new WorkAction();
            this.workActionId = _data["workActionId"];
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : 0;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.productId = _data["productId"];
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : 0;
            this.stCurrentQuantity = _data["stCurrentQuantity"] !== undefined ? _data["stCurrentQuantity"] : 0;
            this.container = _data["container"] ? Container.fromJS(_data["container"]) : <any>undefined;
            this.containerId = _data["containerId"];
            this.shelfFrom = _data["shelfFrom"] ? Shelf.fromJS(_data["shelfFrom"]) : <any>undefined;
            this.shelfFromId = _data["shelfFromId"];
            this.shelfTo = _data["shelfTo"] ? Shelf.fromJS(_data["shelfTo"]) : <any>undefined;
            this.shelfToId = _data["shelfToId"];
            this.stShelf = _data["stShelf"] ? Shelf.fromJS(_data["stShelf"]) : <any>undefined;
            this.stShelfId = _data["stShelfId"];
            this.orderHeader = _data["orderHeader"] ? OrderHeader.fromJS(_data["orderHeader"]) : <any>undefined;
            this.orderHeaderId = _data["orderHeaderId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WorkActionProcess {
        data = typeof data === 'object' ? data : {};
        let result = new WorkActionProcess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workAction"] = this.workAction ? this.workAction.toJSON() : <any>undefined;
        data["workActionId"] = this.workActionId;
        data["sourceId"] = this.sourceId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["stCurrentQuantity"] = this.stCurrentQuantity;
        data["container"] = this.container ? this.container.toJSON() : <any>undefined;
        data["containerId"] = this.containerId;
        data["shelfFrom"] = this.shelfFrom ? this.shelfFrom.toJSON() : <any>undefined;
        data["shelfFromId"] = this.shelfFromId;
        data["shelfTo"] = this.shelfTo ? this.shelfTo.toJSON() : <any>undefined;
        data["shelfToId"] = this.shelfToId;
        data["stShelf"] = this.stShelf ? this.stShelf.toJSON() : <any>undefined;
        data["stShelfId"] = this.stShelfId;
        data["orderHeader"] = this.orderHeader ? this.orderHeader.toJSON() : <any>undefined;
        data["orderHeaderId"] = this.orderHeaderId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): WorkActionProcess {
        const json = this.toJSON();
        let result = new WorkActionProcess();
        result.init(json);
        return result;
    }
}

export interface IWorkActionProcess {
    workAction: WorkAction;
    workActionId: number | undefined;
    sourceId: number;
    product: Product;
    productId: number | undefined;
    quantity: number;
    stCurrentQuantity: number;
    container: Container;
    containerId: number | undefined;
    shelfFrom: Shelf;
    shelfFromId: number | undefined;
    shelfTo: Shelf;
    shelfToId: number | undefined;
    stShelf: Shelf;
    stShelfId: number | undefined;
    orderHeader: OrderHeader;
    orderHeaderId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class FifoHeader implements IFifoHeader {
    product: Product;
    entryDate: Date;
    totalQuantity: number;
    quantityRemaining: number;
    printed: boolean;
    code: string | undefined;
    workActivity: WorkActivity;
    detailCount: number;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IFifoHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.product = new Product();
            this.printed = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : new Product();
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.totalQuantity = _data["totalQuantity"];
            this.quantityRemaining = _data["quantityRemaining"];
            this.printed = _data["printed"] !== undefined ? _data["printed"] : false;
            this.code = _data["code"];
            this.workActivity = _data["workActivity"] ? WorkActivity.fromJS(_data["workActivity"]) : <any>undefined;
            this.detailCount = _data["detailCount"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FifoHeader {
        data = typeof data === 'object' ? data : {};
        let result = new FifoHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["totalQuantity"] = this.totalQuantity;
        data["quantityRemaining"] = this.quantityRemaining;
        data["printed"] = this.printed;
        data["code"] = this.code;
        data["workActivity"] = this.workActivity ? this.workActivity.toJSON() : <any>undefined;
        data["detailCount"] = this.detailCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): FifoHeader {
        const json = this.toJSON();
        let result = new FifoHeader();
        result.init(json);
        return result;
    }
}

export interface IFifoHeader {
    product: Product;
    entryDate: Date;
    totalQuantity: number;
    quantityRemaining: number;
    printed: boolean;
    code: string | undefined;
    workActivity: WorkActivity;
    detailCount: number;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class FifoDetail implements IFifoDetail {
    product: Product;
    entryDate: Date;
    quantity: number;
    quantityRemaining: number;
    code: string | undefined;
    workactionProcess: WorkActionProcess;
    shelf: Shelf;
    fifoHeader: FifoHeader;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IFifoDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.product = new Product();
            this.workactionProcess = new WorkActionProcess();
            this.fifoHeader = new FifoHeader();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : new Product();
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.quantity = _data["quantity"];
            this.quantityRemaining = _data["quantityRemaining"];
            this.code = _data["code"];
            this.workactionProcess = _data["workactionProcess"] ? WorkActionProcess.fromJS(_data["workactionProcess"]) : new WorkActionProcess();
            this.shelf = _data["shelf"] ? Shelf.fromJS(_data["shelf"]) : <any>undefined;
            this.fifoHeader = _data["fifoHeader"] ? FifoHeader.fromJS(_data["fifoHeader"]) : new FifoHeader();
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FifoDetail {
        data = typeof data === 'object' ? data : {};
        let result = new FifoDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["quantityRemaining"] = this.quantityRemaining;
        data["code"] = this.code;
        data["workactionProcess"] = this.workactionProcess ? this.workactionProcess.toJSON() : <any>undefined;
        data["shelf"] = this.shelf ? this.shelf.toJSON() : <any>undefined;
        data["fifoHeader"] = this.fifoHeader ? this.fifoHeader.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): FifoDetail {
        const json = this.toJSON();
        let result = new FifoDetail();
        result.init(json);
        return result;
    }
}

export interface IFifoDetail {
    product: Product;
    entryDate: Date;
    quantity: number;
    quantityRemaining: number;
    code: string | undefined;
    workactionProcess: WorkActionProcess;
    shelf: Shelf;
    fifoHeader: FifoHeader;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class WaybillHeader implements IWaybillHeader {
    erpEntegreId: string | undefined;
    type: WaybillType;
    company: Company;
    companyId: number;
    client: Client;
    clientId: number;
    warehouse: Warehouse;
    warehouseId: number;
    storage: Storage;
    storageId: number;
    companyDataSource: CompanyDataSource;
    companyDataSourceId: number | undefined;
    workActivity: WorkActivity;
    workActivityId: number;
    documentNo: string | undefined;
    documentNo2: string | undefined;
    documentDate: Date;
    deadlineDate: Date;
    notes: string | undefined;
    detailCount: number;
    startDate: Date;
    finishDate: Date;
    isStarted: boolean;
    isFinished: boolean;
    isLocked: boolean;
    hasPriority: boolean;
    isInspected: boolean;
    isManuelEntry: boolean;
    manuelEntryTime: Date | undefined;
    manuelEntryUser: User;
    manuelEntryUserId: number | undefined;
    isManuelEntryErpTransfered: boolean;
    manuelEntryErpTransferTime: Date | undefined;
    isImport: boolean;
    forExport: boolean;
    weight: number;
    rowCount: number;
    productCount: number;
    quantityCount: number;
    placedProductCount: number;
    placedQuantityCount: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IWaybillHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.erpEntegreId = "";
            this.company = new Company();
            this.client = new Client();
            this.warehouse = new Warehouse();
            this.storage = new Storage();
            this.workActivityId = 0;
            this.documentNo = "";
            this.documentNo2 = "";
            this.notes = "";
            this.detailCount = 0;
            this.isStarted = false;
            this.isFinished = false;
            this.isLocked = false;
            this.hasPriority = false;
            this.isInspected = false;
            this.isManuelEntry = false;
            this.isManuelEntryErpTransfered = false;
            this.isImport = false;
            this.forExport = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.erpEntegreId = _data["erpEntegreId"] !== undefined ? _data["erpEntegreId"] : "";
            this.type = _data["type"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.companyId = _data["companyId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : new Client();
            this.clientId = _data["clientId"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : new Warehouse();
            this.warehouseId = _data["warehouseId"];
            this.storage = _data["storage"] ? Storage.fromJS(_data["storage"]) : new Storage();
            this.storageId = _data["storageId"];
            this.companyDataSource = _data["companyDataSource"] ? CompanyDataSource.fromJS(_data["companyDataSource"]) : <any>undefined;
            this.companyDataSourceId = _data["companyDataSourceId"];
            this.workActivity = _data["workActivity"] ? WorkActivity.fromJS(_data["workActivity"]) : <any>undefined;
            this.workActivityId = _data["workActivityId"] !== undefined ? _data["workActivityId"] : 0;
            this.documentNo = _data["documentNo"] !== undefined ? _data["documentNo"] : "";
            this.documentNo2 = _data["documentNo2"] !== undefined ? _data["documentNo2"] : "";
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.deadlineDate = _data["deadlineDate"] ? new Date(_data["deadlineDate"].toString()) : <any>undefined;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : "";
            this.detailCount = _data["detailCount"] !== undefined ? _data["detailCount"] : 0;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.finishDate = _data["finishDate"] ? new Date(_data["finishDate"].toString()) : <any>undefined;
            this.isStarted = _data["isStarted"] !== undefined ? _data["isStarted"] : false;
            this.isFinished = _data["isFinished"] !== undefined ? _data["isFinished"] : false;
            this.isLocked = _data["isLocked"] !== undefined ? _data["isLocked"] : false;
            this.hasPriority = _data["hasPriority"] !== undefined ? _data["hasPriority"] : false;
            this.isInspected = _data["isInspected"] !== undefined ? _data["isInspected"] : false;
            this.isManuelEntry = _data["isManuelEntry"] !== undefined ? _data["isManuelEntry"] : false;
            this.manuelEntryTime = _data["manuelEntryTime"] ? new Date(_data["manuelEntryTime"].toString()) : <any>undefined;
            this.manuelEntryUser = _data["manuelEntryUser"] ? User.fromJS(_data["manuelEntryUser"]) : <any>undefined;
            this.manuelEntryUserId = _data["manuelEntryUserId"];
            this.isManuelEntryErpTransfered = _data["isManuelEntryErpTransfered"] !== undefined ? _data["isManuelEntryErpTransfered"] : false;
            this.manuelEntryErpTransferTime = _data["manuelEntryErpTransferTime"] ? new Date(_data["manuelEntryErpTransferTime"].toString()) : <any>undefined;
            this.isImport = _data["isImport"] !== undefined ? _data["isImport"] : false;
            this.forExport = _data["forExport"] !== undefined ? _data["forExport"] : false;
            this.weight = _data["weight"];
            this.rowCount = _data["rowCount"];
            this.productCount = _data["productCount"];
            this.quantityCount = _data["quantityCount"];
            this.placedProductCount = _data["placedProductCount"];
            this.placedQuantityCount = _data["placedQuantityCount"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WaybillHeader {
        data = typeof data === 'object' ? data : {};
        let result = new WaybillHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["erpEntegreId"] = this.erpEntegreId;
        data["type"] = this.type;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["storageId"] = this.storageId;
        data["companyDataSource"] = this.companyDataSource ? this.companyDataSource.toJSON() : <any>undefined;
        data["companyDataSourceId"] = this.companyDataSourceId;
        data["workActivity"] = this.workActivity ? this.workActivity.toJSON() : <any>undefined;
        data["workActivityId"] = this.workActivityId;
        data["documentNo"] = this.documentNo;
        data["documentNo2"] = this.documentNo2;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["deadlineDate"] = this.deadlineDate ? this.deadlineDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["detailCount"] = this.detailCount;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["finishDate"] = this.finishDate ? this.finishDate.toISOString() : <any>undefined;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["isLocked"] = this.isLocked;
        data["hasPriority"] = this.hasPriority;
        data["isInspected"] = this.isInspected;
        data["isManuelEntry"] = this.isManuelEntry;
        data["manuelEntryTime"] = this.manuelEntryTime ? this.manuelEntryTime.toISOString() : <any>undefined;
        data["manuelEntryUser"] = this.manuelEntryUser ? this.manuelEntryUser.toJSON() : <any>undefined;
        data["manuelEntryUserId"] = this.manuelEntryUserId;
        data["isManuelEntryErpTransfered"] = this.isManuelEntryErpTransfered;
        data["manuelEntryErpTransferTime"] = this.manuelEntryErpTransferTime ? this.manuelEntryErpTransferTime.toISOString() : <any>undefined;
        data["isImport"] = this.isImport;
        data["forExport"] = this.forExport;
        data["weight"] = this.weight;
        data["rowCount"] = this.rowCount;
        data["productCount"] = this.productCount;
        data["quantityCount"] = this.quantityCount;
        data["placedProductCount"] = this.placedProductCount;
        data["placedQuantityCount"] = this.placedQuantityCount;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): WaybillHeader {
        const json = this.toJSON();
        let result = new WaybillHeader();
        result.init(json);
        return result;
    }
}

export interface IWaybillHeader {
    erpEntegreId: string | undefined;
    type: WaybillType;
    company: Company;
    companyId: number;
    client: Client;
    clientId: number;
    warehouse: Warehouse;
    warehouseId: number;
    storage: Storage;
    storageId: number;
    companyDataSource: CompanyDataSource;
    companyDataSourceId: number | undefined;
    workActivity: WorkActivity;
    workActivityId: number;
    documentNo: string | undefined;
    documentNo2: string | undefined;
    documentDate: Date;
    deadlineDate: Date;
    notes: string | undefined;
    detailCount: number;
    startDate: Date;
    finishDate: Date;
    isStarted: boolean;
    isFinished: boolean;
    isLocked: boolean;
    hasPriority: boolean;
    isInspected: boolean;
    isManuelEntry: boolean;
    manuelEntryTime: Date | undefined;
    manuelEntryUser: User;
    manuelEntryUserId: number | undefined;
    isManuelEntryErpTransfered: boolean;
    manuelEntryErpTransferTime: Date | undefined;
    isImport: boolean;
    forExport: boolean;
    weight: number;
    rowCount: number;
    productCount: number;
    quantityCount: number;
    placedProductCount: number;
    placedQuantityCount: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    id: number;
}

export class WaybillDetailDto implements IWaybillDetailDto {
    product: ProductDto;
    waybillHeader: WaybillHeader;
    quantity: number;
    quantityOrder: number;
    quantityControlled: number;
    quantityPlaced: number;
    isLocked: boolean;
    quantityDiff: number;
    quantityOrderRemaining: number;
    quantityNeedToControl: number;
    quantityNeedToPlace: number;
    quantityForPlacement: number;
    readonly placedTime: number;
    id: number;

    constructor(data?: IWaybillDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.waybillHeader = _data["waybillHeader"] ? WaybillHeader.fromJS(_data["waybillHeader"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.quantityOrder = _data["quantityOrder"];
            this.quantityControlled = _data["quantityControlled"];
            this.quantityPlaced = _data["quantityPlaced"];
            this.isLocked = _data["isLocked"];
            this.quantityDiff = _data["quantityDiff"];
            this.quantityOrderRemaining = _data["quantityOrderRemaining"];
            this.quantityNeedToControl = _data["quantityNeedToControl"];
            this.quantityNeedToPlace = _data["quantityNeedToPlace"];
            this.quantityForPlacement = _data["quantityForPlacement"];
            (<any>this).placedTime = _data["placedTime"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WaybillDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new WaybillDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["waybillHeader"] = this.waybillHeader ? this.waybillHeader.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["quantityOrder"] = this.quantityOrder;
        data["quantityControlled"] = this.quantityControlled;
        data["quantityPlaced"] = this.quantityPlaced;
        data["isLocked"] = this.isLocked;
        data["quantityDiff"] = this.quantityDiff;
        data["quantityOrderRemaining"] = this.quantityOrderRemaining;
        data["quantityNeedToControl"] = this.quantityNeedToControl;
        data["quantityNeedToPlace"] = this.quantityNeedToPlace;
        data["quantityForPlacement"] = this.quantityForPlacement;
        data["placedTime"] = this.placedTime;
        data["id"] = this.id;
        return data;
    }

    clone(): WaybillDetailDto {
        const json = this.toJSON();
        let result = new WaybillDetailDto();
        result.init(json);
        return result;
    }
}

export interface IWaybillDetailDto {
    product: ProductDto;
    waybillHeader: WaybillHeader;
    quantity: number;
    quantityOrder: number;
    quantityControlled: number;
    quantityPlaced: number;
    isLocked: boolean;
    quantityDiff: number;
    quantityOrderRemaining: number;
    quantityNeedToControl: number;
    quantityNeedToPlace: number;
    quantityForPlacement: number;
    placedTime: number;
    id: number;
}

export class WaybillDetailDtoPagedResultDto implements IWaybillDetailDtoPagedResultDto {
    totalCount: number;
    items: WaybillDetailDto[] | undefined;

    constructor(data?: IWaybillDetailDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WaybillDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WaybillDetailDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WaybillDetailDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): WaybillDetailDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WaybillDetailDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWaybillDetailDtoPagedResultDto {
    totalCount: number;
    items: WaybillDetailDto[] | undefined;
}

export class WaybillDetailTimeBetweenDto implements IWaybillDetailTimeBetweenDto {
    product: ProductDto;
    waybillHeader: WaybillHeader;
    quantity: number;
    quantityOrder: number;
    quantityProcessed: number;
    quantityPlaced: number;
    isLocked: boolean;
    quantityDiff: number;
    quantityOrderRemaining: number;
    quantityNeedToControl: number;
    quantityNeedToPlace: number;
    quantityForPlacement: number;
    readonly placedTime: number;
    firstControlTime: Date | undefined;
    lastControlTime: Date | undefined;
    firstPlacementTime: Date | undefined;
    lastPlacementTime: Date | undefined;

    constructor(data?: IWaybillDetailTimeBetweenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.waybillHeader = _data["waybillHeader"] ? WaybillHeader.fromJS(_data["waybillHeader"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.quantityOrder = _data["quantityOrder"];
            this.quantityProcessed = _data["quantityProcessed"];
            this.quantityPlaced = _data["quantityPlaced"];
            this.isLocked = _data["isLocked"];
            this.quantityDiff = _data["quantityDiff"];
            this.quantityOrderRemaining = _data["quantityOrderRemaining"];
            this.quantityNeedToControl = _data["quantityNeedToControl"];
            this.quantityNeedToPlace = _data["quantityNeedToPlace"];
            this.quantityForPlacement = _data["quantityForPlacement"];
            (<any>this).placedTime = _data["placedTime"];
            this.firstControlTime = _data["firstControlTime"] ? new Date(_data["firstControlTime"].toString()) : <any>undefined;
            this.lastControlTime = _data["lastControlTime"] ? new Date(_data["lastControlTime"].toString()) : <any>undefined;
            this.firstPlacementTime = _data["firstPlacementTime"] ? new Date(_data["firstPlacementTime"].toString()) : <any>undefined;
            this.lastPlacementTime = _data["lastPlacementTime"] ? new Date(_data["lastPlacementTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WaybillDetailTimeBetweenDto {
        data = typeof data === 'object' ? data : {};
        let result = new WaybillDetailTimeBetweenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["waybillHeader"] = this.waybillHeader ? this.waybillHeader.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["quantityOrder"] = this.quantityOrder;
        data["quantityProcessed"] = this.quantityProcessed;
        data["quantityPlaced"] = this.quantityPlaced;
        data["isLocked"] = this.isLocked;
        data["quantityDiff"] = this.quantityDiff;
        data["quantityOrderRemaining"] = this.quantityOrderRemaining;
        data["quantityNeedToControl"] = this.quantityNeedToControl;
        data["quantityNeedToPlace"] = this.quantityNeedToPlace;
        data["quantityForPlacement"] = this.quantityForPlacement;
        data["placedTime"] = this.placedTime;
        data["firstControlTime"] = this.firstControlTime ? this.firstControlTime.toISOString() : <any>undefined;
        data["lastControlTime"] = this.lastControlTime ? this.lastControlTime.toISOString() : <any>undefined;
        data["firstPlacementTime"] = this.firstPlacementTime ? this.firstPlacementTime.toISOString() : <any>undefined;
        data["lastPlacementTime"] = this.lastPlacementTime ? this.lastPlacementTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): WaybillDetailTimeBetweenDto {
        const json = this.toJSON();
        let result = new WaybillDetailTimeBetweenDto();
        result.init(json);
        return result;
    }
}

export interface IWaybillDetailTimeBetweenDto {
    product: ProductDto;
    waybillHeader: WaybillHeader;
    quantity: number;
    quantityOrder: number;
    quantityProcessed: number;
    quantityPlaced: number;
    isLocked: boolean;
    quantityDiff: number;
    quantityOrderRemaining: number;
    quantityNeedToControl: number;
    quantityNeedToPlace: number;
    quantityForPlacement: number;
    placedTime: number;
    firstControlTime: Date | undefined;
    lastControlTime: Date | undefined;
    firstPlacementTime: Date | undefined;
    lastPlacementTime: Date | undefined;
}

export class WaybillDetailTimeBetweenDtoPagedResultDto implements IWaybillDetailTimeBetweenDtoPagedResultDto {
    totalCount: number;
    items: WaybillDetailTimeBetweenDto[] | undefined;

    constructor(data?: IWaybillDetailTimeBetweenDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WaybillDetailTimeBetweenDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WaybillDetailTimeBetweenDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WaybillDetailTimeBetweenDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): WaybillDetailTimeBetweenDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WaybillDetailTimeBetweenDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWaybillDetailTimeBetweenDtoPagedResultDto {
    totalCount: number;
    items: WaybillDetailTimeBetweenDto[] | undefined;
}

export class WaybillDetailReceivingDto implements IWaybillDetailReceivingDto {
    product: ProductSimpleDto;
    quantity: number;
    quantityOrder: number;
    quantityControlled: number;
    quantityPlaced: number;
    id: number;

    constructor(data?: IWaybillDetailReceivingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductSimpleDto.fromJS(_data["product"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.quantityOrder = _data["quantityOrder"];
            this.quantityControlled = _data["quantityControlled"];
            this.quantityPlaced = _data["quantityPlaced"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WaybillDetailReceivingDto {
        data = typeof data === 'object' ? data : {};
        let result = new WaybillDetailReceivingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["quantityOrder"] = this.quantityOrder;
        data["quantityControlled"] = this.quantityControlled;
        data["quantityPlaced"] = this.quantityPlaced;
        data["id"] = this.id;
        return data;
    }

    clone(): WaybillDetailReceivingDto {
        const json = this.toJSON();
        let result = new WaybillDetailReceivingDto();
        result.init(json);
        return result;
    }
}

export interface IWaybillDetailReceivingDto {
    product: ProductSimpleDto;
    quantity: number;
    quantityOrder: number;
    quantityControlled: number;
    quantityPlaced: number;
    id: number;
}

export class WaybillHeaderReportDto implements IWaybillHeaderReportDto {
    orderType: WaybillType;
    company: Company;
    client: ClientSmallDto;
    warehouse: Warehouse;
    orderHeaderNo: string | undefined;
    documentNo: string | undefined;
    documentDate: Date;
    id: number;

    constructor(data?: IWaybillHeaderReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderType = _data["orderType"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.client = _data["client"] ? ClientSmallDto.fromJS(_data["client"]) : <any>undefined;
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.orderHeaderNo = _data["orderHeaderNo"];
            this.documentNo = _data["documentNo"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WaybillHeaderReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new WaybillHeaderReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderType"] = this.orderType;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["orderHeaderNo"] = this.orderHeaderNo;
        data["documentNo"] = this.documentNo;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): WaybillHeaderReportDto {
        const json = this.toJSON();
        let result = new WaybillHeaderReportDto();
        result.init(json);
        return result;
    }
}

export interface IWaybillHeaderReportDto {
    orderType: WaybillType;
    company: Company;
    client: ClientSmallDto;
    warehouse: Warehouse;
    orderHeaderNo: string | undefined;
    documentNo: string | undefined;
    documentDate: Date;
    id: number;
}

export class WaybillDetailReportDto implements IWaybillDetailReportDto {
    waybillHeader: WaybillHeaderReportDto;
    product: ProductSmallDto;
    quantity: number;
    quantityOrder: number;
    quantityControlled: number;
    quantityPlaced: number;
    isLocked: boolean;
    quantityDiff: number;
    quantityOrderRemaining: number;
    quantityNeedToControl: number;
    quantityNeedToPlace: number;
    quantityForPlacement: number;
    id: number;

    constructor(data?: IWaybillDetailReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.waybillHeader = _data["waybillHeader"] ? WaybillHeaderReportDto.fromJS(_data["waybillHeader"]) : <any>undefined;
            this.product = _data["product"] ? ProductSmallDto.fromJS(_data["product"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.quantityOrder = _data["quantityOrder"];
            this.quantityControlled = _data["quantityControlled"];
            this.quantityPlaced = _data["quantityPlaced"];
            this.isLocked = _data["isLocked"];
            this.quantityDiff = _data["quantityDiff"];
            this.quantityOrderRemaining = _data["quantityOrderRemaining"];
            this.quantityNeedToControl = _data["quantityNeedToControl"];
            this.quantityNeedToPlace = _data["quantityNeedToPlace"];
            this.quantityForPlacement = _data["quantityForPlacement"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WaybillDetailReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new WaybillDetailReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waybillHeader"] = this.waybillHeader ? this.waybillHeader.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["quantityOrder"] = this.quantityOrder;
        data["quantityControlled"] = this.quantityControlled;
        data["quantityPlaced"] = this.quantityPlaced;
        data["isLocked"] = this.isLocked;
        data["quantityDiff"] = this.quantityDiff;
        data["quantityOrderRemaining"] = this.quantityOrderRemaining;
        data["quantityNeedToControl"] = this.quantityNeedToControl;
        data["quantityNeedToPlace"] = this.quantityNeedToPlace;
        data["quantityForPlacement"] = this.quantityForPlacement;
        data["id"] = this.id;
        return data;
    }

    clone(): WaybillDetailReportDto {
        const json = this.toJSON();
        let result = new WaybillDetailReportDto();
        result.init(json);
        return result;
    }
}

export interface IWaybillDetailReportDto {
    waybillHeader: WaybillHeaderReportDto;
    product: ProductSmallDto;
    quantity: number;
    quantityOrder: number;
    quantityControlled: number;
    quantityPlaced: number;
    isLocked: boolean;
    quantityDiff: number;
    quantityOrderRemaining: number;
    quantityNeedToControl: number;
    quantityNeedToPlace: number;
    quantityForPlacement: number;
    id: number;
}

export class WaybillDetailReportDtoPagedResultDto implements IWaybillDetailReportDtoPagedResultDto {
    totalCount: number;
    items: WaybillDetailReportDto[] | undefined;

    constructor(data?: IWaybillDetailReportDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WaybillDetailReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WaybillDetailReportDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WaybillDetailReportDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): WaybillDetailReportDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WaybillDetailReportDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWaybillDetailReportDtoPagedResultDto {
    totalCount: number;
    items: WaybillDetailReportDto[] | undefined;
}

export class BatchWaybillInsertDto implements IBatchWaybillInsertDto {
    productCodeList: string[] | undefined;
    quantityList: number[] | undefined;
    companyId: number;
    headerId: number;
    warehouseId: number;

    constructor(data?: IBatchWaybillInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productCodeList"])) {
                this.productCodeList = [] as any;
                for (let item of _data["productCodeList"])
                    this.productCodeList.push(item);
            }
            if (Array.isArray(_data["quantityList"])) {
                this.quantityList = [] as any;
                for (let item of _data["quantityList"])
                    this.quantityList.push(item);
            }
            this.companyId = _data["companyId"];
            this.headerId = _data["headerId"];
            this.warehouseId = _data["warehouseId"];
        }
    }

    static fromJS(data: any): BatchWaybillInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchWaybillInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productCodeList)) {
            data["productCodeList"] = [];
            for (let item of this.productCodeList)
                data["productCodeList"].push(item);
        }
        if (Array.isArray(this.quantityList)) {
            data["quantityList"] = [];
            for (let item of this.quantityList)
                data["quantityList"].push(item);
        }
        data["companyId"] = this.companyId;
        data["headerId"] = this.headerId;
        data["warehouseId"] = this.warehouseId;
        return data;
    }

    clone(): BatchWaybillInsertDto {
        const json = this.toJSON();
        let result = new BatchWaybillInsertDto();
        result.init(json);
        return result;
    }
}

export interface IBatchWaybillInsertDto {
    productCodeList: string[] | undefined;
    quantityList: number[] | undefined;
    companyId: number;
    headerId: number;
    warehouseId: number;
}

export class SelectedStockMovementShelfDto implements ISelectedStockMovementShelfDto {
    quantity: number;
    isSelected: boolean;
    fullAddress: string | undefined;
    shelfId: number;
    selectedQuantityOut: number;

    constructor(data?: ISelectedStockMovementShelfDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.isSelected = _data["isSelected"];
            this.fullAddress = _data["fullAddress"];
            this.shelfId = _data["shelfId"];
            this.selectedQuantityOut = _data["selectedQuantityOut"];
        }
    }

    static fromJS(data: any): SelectedStockMovementShelfDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectedStockMovementShelfDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["isSelected"] = this.isSelected;
        data["fullAddress"] = this.fullAddress;
        data["shelfId"] = this.shelfId;
        data["selectedQuantityOut"] = this.selectedQuantityOut;
        return data;
    }

    clone(): SelectedStockMovementShelfDto {
        const json = this.toJSON();
        let result = new SelectedStockMovementShelfDto();
        result.init(json);
        return result;
    }
}

export interface ISelectedStockMovementShelfDto {
    quantity: number;
    isSelected: boolean;
    fullAddress: string | undefined;
    shelfId: number;
    selectedQuantityOut: number;
}

export class TransferHeaderRequestDto implements ITransferHeaderRequestDto {
    code: string | undefined;
    company: Company;
    warehouseFrom: Warehouse;
    warehouseTo: Warehouse;
    isOpenForAdd: boolean;
    isStarted: boolean;
    isFinished: boolean;
    startTime: Date | undefined;
    finishTime: Date | undefined;
    plannedSendDate: Date;
    isSent: boolean;
    sendingTime: Date | undefined;
    isReceived: boolean;
    receiveTime: Date | undefined;
    shippingType: string | undefined;
    pickingStartTime: Date | undefined;
    pickingFinishTime: Date | undefined;
    picker: UserDto;
    sendingControlStartTime: Date | undefined;
    sendingControlFinishTime: Date | undefined;
    sendingController: UserDto;
    receivingControlStartTime: Date | undefined;
    receivingFinishTime: Date | undefined;
    receivingController: UserDto;
    placementStartTime: Date | undefined;
    placementFinishTime: Date | undefined;
    erpDocumentNo: string | undefined;
    erpDocumentDate: Date | undefined;
    note: string | undefined;
    workActivityForSending: WorkActivityDto;
    workActivityForReceiving: WorkActivityDto;
    barcode: string | undefined;
    isDeleted: boolean;
    isCancelled: boolean;
    cancelDate: Date | undefined;
    cancelReason: string | undefined;
    isReplacement: boolean;
    id: number;

    constructor(data?: ITransferHeaderRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.erpDocumentNo = "";
            this.isCancelled = false;
            this.cancelReason = "";
            this.isReplacement = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.warehouseFrom = _data["warehouseFrom"] ? Warehouse.fromJS(_data["warehouseFrom"]) : <any>undefined;
            this.warehouseTo = _data["warehouseTo"] ? Warehouse.fromJS(_data["warehouseTo"]) : <any>undefined;
            this.isOpenForAdd = _data["isOpenForAdd"];
            this.isStarted = _data["isStarted"];
            this.isFinished = _data["isFinished"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : <any>undefined;
            this.plannedSendDate = _data["plannedSendDate"] ? new Date(_data["plannedSendDate"].toString()) : <any>undefined;
            this.isSent = _data["isSent"];
            this.sendingTime = _data["sendingTime"] ? new Date(_data["sendingTime"].toString()) : <any>undefined;
            this.isReceived = _data["isReceived"];
            this.receiveTime = _data["receiveTime"] ? new Date(_data["receiveTime"].toString()) : <any>undefined;
            this.shippingType = _data["shippingType"];
            this.pickingStartTime = _data["pickingStartTime"] ? new Date(_data["pickingStartTime"].toString()) : <any>undefined;
            this.pickingFinishTime = _data["pickingFinishTime"] ? new Date(_data["pickingFinishTime"].toString()) : <any>undefined;
            this.picker = _data["picker"] ? UserDto.fromJS(_data["picker"]) : <any>undefined;
            this.sendingControlStartTime = _data["sendingControlStartTime"] ? new Date(_data["sendingControlStartTime"].toString()) : <any>undefined;
            this.sendingControlFinishTime = _data["sendingControlFinishTime"] ? new Date(_data["sendingControlFinishTime"].toString()) : <any>undefined;
            this.sendingController = _data["sendingController"] ? UserDto.fromJS(_data["sendingController"]) : <any>undefined;
            this.receivingControlStartTime = _data["receivingControlStartTime"] ? new Date(_data["receivingControlStartTime"].toString()) : <any>undefined;
            this.receivingFinishTime = _data["receivingFinishTime"] ? new Date(_data["receivingFinishTime"].toString()) : <any>undefined;
            this.receivingController = _data["receivingController"] ? UserDto.fromJS(_data["receivingController"]) : <any>undefined;
            this.placementStartTime = _data["placementStartTime"] ? new Date(_data["placementStartTime"].toString()) : <any>undefined;
            this.placementFinishTime = _data["placementFinishTime"] ? new Date(_data["placementFinishTime"].toString()) : <any>undefined;
            this.erpDocumentNo = _data["erpDocumentNo"] !== undefined ? _data["erpDocumentNo"] : "";
            this.erpDocumentDate = _data["erpDocumentDate"] ? new Date(_data["erpDocumentDate"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.workActivityForSending = _data["workActivityForSending"] ? WorkActivityDto.fromJS(_data["workActivityForSending"]) : <any>undefined;
            this.workActivityForReceiving = _data["workActivityForReceiving"] ? WorkActivityDto.fromJS(_data["workActivityForReceiving"]) : <any>undefined;
            this.barcode = _data["barcode"];
            this.isDeleted = _data["isDeleted"];
            this.isCancelled = _data["isCancelled"] !== undefined ? _data["isCancelled"] : false;
            this.cancelDate = _data["cancelDate"] ? new Date(_data["cancelDate"].toString()) : <any>undefined;
            this.cancelReason = _data["cancelReason"] !== undefined ? _data["cancelReason"] : "";
            this.isReplacement = _data["isReplacement"] !== undefined ? _data["isReplacement"] : false;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TransferHeaderRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferHeaderRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["warehouseFrom"] = this.warehouseFrom ? this.warehouseFrom.toJSON() : <any>undefined;
        data["warehouseTo"] = this.warehouseTo ? this.warehouseTo.toJSON() : <any>undefined;
        data["isOpenForAdd"] = this.isOpenForAdd;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["plannedSendDate"] = this.plannedSendDate ? this.plannedSendDate.toISOString() : <any>undefined;
        data["isSent"] = this.isSent;
        data["sendingTime"] = this.sendingTime ? this.sendingTime.toISOString() : <any>undefined;
        data["isReceived"] = this.isReceived;
        data["receiveTime"] = this.receiveTime ? this.receiveTime.toISOString() : <any>undefined;
        data["shippingType"] = this.shippingType;
        data["pickingStartTime"] = this.pickingStartTime ? this.pickingStartTime.toISOString() : <any>undefined;
        data["pickingFinishTime"] = this.pickingFinishTime ? this.pickingFinishTime.toISOString() : <any>undefined;
        data["picker"] = this.picker ? this.picker.toJSON() : <any>undefined;
        data["sendingControlStartTime"] = this.sendingControlStartTime ? this.sendingControlStartTime.toISOString() : <any>undefined;
        data["sendingControlFinishTime"] = this.sendingControlFinishTime ? this.sendingControlFinishTime.toISOString() : <any>undefined;
        data["sendingController"] = this.sendingController ? this.sendingController.toJSON() : <any>undefined;
        data["receivingControlStartTime"] = this.receivingControlStartTime ? this.receivingControlStartTime.toISOString() : <any>undefined;
        data["receivingFinishTime"] = this.receivingFinishTime ? this.receivingFinishTime.toISOString() : <any>undefined;
        data["receivingController"] = this.receivingController ? this.receivingController.toJSON() : <any>undefined;
        data["placementStartTime"] = this.placementStartTime ? this.placementStartTime.toISOString() : <any>undefined;
        data["placementFinishTime"] = this.placementFinishTime ? this.placementFinishTime.toISOString() : <any>undefined;
        data["erpDocumentNo"] = this.erpDocumentNo;
        data["erpDocumentDate"] = this.erpDocumentDate ? this.erpDocumentDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["workActivityForSending"] = this.workActivityForSending ? this.workActivityForSending.toJSON() : <any>undefined;
        data["workActivityForReceiving"] = this.workActivityForReceiving ? this.workActivityForReceiving.toJSON() : <any>undefined;
        data["barcode"] = this.barcode;
        data["isDeleted"] = this.isDeleted;
        data["isCancelled"] = this.isCancelled;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["cancelReason"] = this.cancelReason;
        data["isReplacement"] = this.isReplacement;
        data["id"] = this.id;
        return data;
    }

    clone(): TransferHeaderRequestDto {
        const json = this.toJSON();
        let result = new TransferHeaderRequestDto();
        result.init(json);
        return result;
    }
}

export interface ITransferHeaderRequestDto {
    code: string | undefined;
    company: Company;
    warehouseFrom: Warehouse;
    warehouseTo: Warehouse;
    isOpenForAdd: boolean;
    isStarted: boolean;
    isFinished: boolean;
    startTime: Date | undefined;
    finishTime: Date | undefined;
    plannedSendDate: Date;
    isSent: boolean;
    sendingTime: Date | undefined;
    isReceived: boolean;
    receiveTime: Date | undefined;
    shippingType: string | undefined;
    pickingStartTime: Date | undefined;
    pickingFinishTime: Date | undefined;
    picker: UserDto;
    sendingControlStartTime: Date | undefined;
    sendingControlFinishTime: Date | undefined;
    sendingController: UserDto;
    receivingControlStartTime: Date | undefined;
    receivingFinishTime: Date | undefined;
    receivingController: UserDto;
    placementStartTime: Date | undefined;
    placementFinishTime: Date | undefined;
    erpDocumentNo: string | undefined;
    erpDocumentDate: Date | undefined;
    note: string | undefined;
    workActivityForSending: WorkActivityDto;
    workActivityForReceiving: WorkActivityDto;
    barcode: string | undefined;
    isDeleted: boolean;
    isCancelled: boolean;
    cancelDate: Date | undefined;
    cancelReason: string | undefined;
    isReplacement: boolean;
    id: number;
}

export class BatchTransferRequestDetailInsertDto implements IBatchTransferRequestDetailInsertDto {
    productCodeList: string[] | undefined;
    productQuantityList: string[] | undefined;
    companyId: number;
    transferRequestHeaderId: number;

    constructor(data?: IBatchTransferRequestDetailInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productCodeList"])) {
                this.productCodeList = [] as any;
                for (let item of _data["productCodeList"])
                    this.productCodeList.push(item);
            }
            if (Array.isArray(_data["productQuantityList"])) {
                this.productQuantityList = [] as any;
                for (let item of _data["productQuantityList"])
                    this.productQuantityList.push(item);
            }
            this.companyId = _data["companyId"];
            this.transferRequestHeaderId = _data["transferRequestHeaderId"];
        }
    }

    static fromJS(data: any): BatchTransferRequestDetailInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchTransferRequestDetailInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productCodeList)) {
            data["productCodeList"] = [];
            for (let item of this.productCodeList)
                data["productCodeList"].push(item);
        }
        if (Array.isArray(this.productQuantityList)) {
            data["productQuantityList"] = [];
            for (let item of this.productQuantityList)
                data["productQuantityList"].push(item);
        }
        data["companyId"] = this.companyId;
        data["transferRequestHeaderId"] = this.transferRequestHeaderId;
        return data;
    }

    clone(): BatchTransferRequestDetailInsertDto {
        const json = this.toJSON();
        let result = new BatchTransferRequestDetailInsertDto();
        result.init(json);
        return result;
    }
}

export interface IBatchTransferRequestDetailInsertDto {
    productCodeList: string[] | undefined;
    productQuantityList: string[] | undefined;
    companyId: number;
    transferRequestHeaderId: number;
}

export class TransferRequestDetailDto implements ITransferRequestDetailDto {
    transferRequestHeader: TransferHeaderRequestDto;
    product: ProductDto;
    quantity: number;
    quantityPicked: number;
    shippingQuantityControlled: number;
    receivingQuantityControlled: number;
    quantityPlaced: number;
    quantityForReplace: number;
    quantityReplaced: number;
    noteDeficiency: string | undefined;
    noteDeficiencyUser: UserDto;
    readonly isCompletedCollect: boolean;
    readonly quantityForPicking: number;
    readonly isCompletedShipment: boolean;
    readonly quantityForShipment: number;
    readonly isCompletedPickingControl: boolean;
    readonly isCompletedReceivingControl: boolean;
    readonly quantityForPickingControl: number;
    readonly isCompletedPlacement: boolean;
    readonly quantityForPlacement: number;
    readonly quantityNeedToReplace: number;
    readonly isCompletedReplacement: boolean;
    id: number;

    constructor(data?: ITransferRequestDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.quantityForReplace = 0;
            this.quantityReplaced = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transferRequestHeader = _data["transferRequestHeader"] ? TransferHeaderRequestDto.fromJS(_data["transferRequestHeader"]) : <any>undefined;
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.quantityPicked = _data["quantityPicked"];
            this.shippingQuantityControlled = _data["shippingQuantityControlled"];
            this.receivingQuantityControlled = _data["receivingQuantityControlled"];
            this.quantityPlaced = _data["quantityPlaced"];
            this.quantityForReplace = _data["quantityForReplace"] !== undefined ? _data["quantityForReplace"] : 0;
            this.quantityReplaced = _data["quantityReplaced"] !== undefined ? _data["quantityReplaced"] : 0;
            this.noteDeficiency = _data["noteDeficiency"];
            this.noteDeficiencyUser = _data["noteDeficiencyUser"] ? UserDto.fromJS(_data["noteDeficiencyUser"]) : <any>undefined;
            (<any>this).isCompletedCollect = _data["isCompletedCollect"];
            (<any>this).quantityForPicking = _data["quantityForPicking"];
            (<any>this).isCompletedShipment = _data["isCompletedShipment"];
            (<any>this).quantityForShipment = _data["quantityForShipment"];
            (<any>this).isCompletedPickingControl = _data["isCompletedPickingControl"];
            (<any>this).isCompletedReceivingControl = _data["isCompletedReceivingControl"];
            (<any>this).quantityForPickingControl = _data["quantityForPickingControl"];
            (<any>this).isCompletedPlacement = _data["isCompletedPlacement"];
            (<any>this).quantityForPlacement = _data["quantityForPlacement"];
            (<any>this).quantityNeedToReplace = _data["quantityNeedToReplace"];
            (<any>this).isCompletedReplacement = _data["isCompletedReplacement"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TransferRequestDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferRequestDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transferRequestHeader"] = this.transferRequestHeader ? this.transferRequestHeader.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["quantityPicked"] = this.quantityPicked;
        data["shippingQuantityControlled"] = this.shippingQuantityControlled;
        data["receivingQuantityControlled"] = this.receivingQuantityControlled;
        data["quantityPlaced"] = this.quantityPlaced;
        data["quantityForReplace"] = this.quantityForReplace;
        data["quantityReplaced"] = this.quantityReplaced;
        data["noteDeficiency"] = this.noteDeficiency;
        data["noteDeficiencyUser"] = this.noteDeficiencyUser ? this.noteDeficiencyUser.toJSON() : <any>undefined;
        data["isCompletedCollect"] = this.isCompletedCollect;
        data["quantityForPicking"] = this.quantityForPicking;
        data["isCompletedShipment"] = this.isCompletedShipment;
        data["quantityForShipment"] = this.quantityForShipment;
        data["isCompletedPickingControl"] = this.isCompletedPickingControl;
        data["isCompletedReceivingControl"] = this.isCompletedReceivingControl;
        data["quantityForPickingControl"] = this.quantityForPickingControl;
        data["isCompletedPlacement"] = this.isCompletedPlacement;
        data["quantityForPlacement"] = this.quantityForPlacement;
        data["quantityNeedToReplace"] = this.quantityNeedToReplace;
        data["isCompletedReplacement"] = this.isCompletedReplacement;
        data["id"] = this.id;
        return data;
    }

    clone(): TransferRequestDetailDto {
        const json = this.toJSON();
        let result = new TransferRequestDetailDto();
        result.init(json);
        return result;
    }
}

export interface ITransferRequestDetailDto {
    transferRequestHeader: TransferHeaderRequestDto;
    product: ProductDto;
    quantity: number;
    quantityPicked: number;
    shippingQuantityControlled: number;
    receivingQuantityControlled: number;
    quantityPlaced: number;
    quantityForReplace: number;
    quantityReplaced: number;
    noteDeficiency: string | undefined;
    noteDeficiencyUser: UserDto;
    isCompletedCollect: boolean;
    quantityForPicking: number;
    isCompletedShipment: boolean;
    quantityForShipment: number;
    isCompletedPickingControl: boolean;
    isCompletedReceivingControl: boolean;
    quantityForPickingControl: number;
    isCompletedPlacement: boolean;
    quantityForPlacement: number;
    quantityNeedToReplace: number;
    isCompletedReplacement: boolean;
    id: number;
}

export class TransferRequestHeaderPdaDto implements ITransferRequestHeaderPdaDto {
    company: CompanyDto;
    client: ClientSmallDto;
    warehouseFrom: WarehouseDto;
    note: string | undefined;
    shippingType: string | undefined;
    id: number;

    constructor(data?: ITransferRequestHeaderPdaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.client = _data["client"] ? ClientSmallDto.fromJS(_data["client"]) : <any>undefined;
            this.warehouseFrom = _data["warehouseFrom"] ? WarehouseDto.fromJS(_data["warehouseFrom"]) : <any>undefined;
            this.note = _data["note"];
            this.shippingType = _data["shippingType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TransferRequestHeaderPdaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferRequestHeaderPdaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["warehouseFrom"] = this.warehouseFrom ? this.warehouseFrom.toJSON() : <any>undefined;
        data["note"] = this.note;
        data["shippingType"] = this.shippingType;
        data["id"] = this.id;
        return data;
    }

    clone(): TransferRequestHeaderPdaDto {
        const json = this.toJSON();
        let result = new TransferRequestHeaderPdaDto();
        result.init(json);
        return result;
    }
}

export interface ITransferRequestHeaderPdaDto {
    company: CompanyDto;
    client: ClientSmallDto;
    warehouseFrom: WarehouseDto;
    note: string | undefined;
    shippingType: string | undefined;
    id: number;
}

export class TransferRequestDetailPdaDto implements ITransferRequestDetailPdaDto {
    transferRequestHeader: TransferRequestHeaderPdaDto;
    product: ProductSmallDto;
    quantity: number;
    quantityShipped: number;
    quantityPicked: number;
    quantityReplacement: number;
    readonly quantityDiff: number;
    id: number;

    constructor(data?: ITransferRequestDetailPdaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transferRequestHeader = _data["transferRequestHeader"] ? TransferRequestHeaderPdaDto.fromJS(_data["transferRequestHeader"]) : <any>undefined;
            this.product = _data["product"] ? ProductSmallDto.fromJS(_data["product"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.quantityShipped = _data["quantityShipped"];
            this.quantityPicked = _data["quantityPicked"];
            this.quantityReplacement = _data["quantityReplacement"];
            (<any>this).quantityDiff = _data["quantityDiff"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TransferRequestDetailPdaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferRequestDetailPdaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transferRequestHeader"] = this.transferRequestHeader ? this.transferRequestHeader.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["quantityShipped"] = this.quantityShipped;
        data["quantityPicked"] = this.quantityPicked;
        data["quantityReplacement"] = this.quantityReplacement;
        data["quantityDiff"] = this.quantityDiff;
        data["id"] = this.id;
        return data;
    }

    clone(): TransferRequestDetailPdaDto {
        const json = this.toJSON();
        let result = new TransferRequestDetailPdaDto();
        result.init(json);
        return result;
    }
}

export interface ITransferRequestDetailPdaDto {
    transferRequestHeader: TransferRequestHeaderPdaDto;
    product: ProductSmallDto;
    quantity: number;
    quantityShipped: number;
    quantityPicked: number;
    quantityReplacement: number;
    quantityDiff: number;
    id: number;
}

export class TransferPickingDto implements ITransferPickingDto {
    transferRequestDetailList: TransferRequestDetailPdaDto[] | undefined;
    pickingSuggestionList: PickingSuggestionDto[] | undefined;

    constructor(data?: ITransferPickingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transferRequestDetailList"])) {
                this.transferRequestDetailList = [] as any;
                for (let item of _data["transferRequestDetailList"])
                    this.transferRequestDetailList.push(TransferRequestDetailPdaDto.fromJS(item));
            }
            if (Array.isArray(_data["pickingSuggestionList"])) {
                this.pickingSuggestionList = [] as any;
                for (let item of _data["pickingSuggestionList"])
                    this.pickingSuggestionList.push(PickingSuggestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransferPickingDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferPickingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transferRequestDetailList)) {
            data["transferRequestDetailList"] = [];
            for (let item of this.transferRequestDetailList)
                data["transferRequestDetailList"].push(item.toJSON());
        }
        if (Array.isArray(this.pickingSuggestionList)) {
            data["pickingSuggestionList"] = [];
            for (let item of this.pickingSuggestionList)
                data["pickingSuggestionList"].push(item.toJSON());
        }
        return data;
    }

    clone(): TransferPickingDto {
        const json = this.toJSON();
        let result = new TransferPickingDto();
        result.init(json);
        return result;
    }
}

export interface ITransferPickingDto {
    transferRequestDetailList: TransferRequestDetailPdaDto[] | undefined;
    pickingSuggestionList: PickingSuggestionDto[] | undefined;
}

export class TransferRequestDetailPdaAllDto implements ITransferRequestDetailPdaAllDto {
    transferRequestHeader: TransferRequestHeaderPdaDto;
    quantityShippedAll: number;
    quantityPickedAll: number;
    quantityAll: number;
    transferRequestDetailPdaDto: TransferRequestDetailPdaDto[] | undefined;

    constructor(data?: ITransferRequestDetailPdaAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transferRequestHeader = _data["transferRequestHeader"] ? TransferRequestHeaderPdaDto.fromJS(_data["transferRequestHeader"]) : <any>undefined;
            this.quantityShippedAll = _data["quantityShippedAll"];
            this.quantityPickedAll = _data["quantityPickedAll"];
            this.quantityAll = _data["quantityAll"];
            if (Array.isArray(_data["transferRequestDetailPdaDto"])) {
                this.transferRequestDetailPdaDto = [] as any;
                for (let item of _data["transferRequestDetailPdaDto"])
                    this.transferRequestDetailPdaDto.push(TransferRequestDetailPdaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransferRequestDetailPdaAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferRequestDetailPdaAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transferRequestHeader"] = this.transferRequestHeader ? this.transferRequestHeader.toJSON() : <any>undefined;
        data["quantityShippedAll"] = this.quantityShippedAll;
        data["quantityPickedAll"] = this.quantityPickedAll;
        data["quantityAll"] = this.quantityAll;
        if (Array.isArray(this.transferRequestDetailPdaDto)) {
            data["transferRequestDetailPdaDto"] = [];
            for (let item of this.transferRequestDetailPdaDto)
                data["transferRequestDetailPdaDto"].push(item.toJSON());
        }
        return data;
    }

    clone(): TransferRequestDetailPdaAllDto {
        const json = this.toJSON();
        let result = new TransferRequestDetailPdaAllDto();
        result.init(json);
        return result;
    }
}

export interface ITransferRequestDetailPdaAllDto {
    transferRequestHeader: TransferRequestHeaderPdaDto;
    quantityShippedAll: number;
    quantityPickedAll: number;
    quantityAll: number;
    transferRequestDetailPdaDto: TransferRequestDetailPdaDto[] | undefined;
}

export class ProductShelfWorkActivityDto implements IProductShelfWorkActivityDto {
    companyId: number;
    warehouseId: number;
    storageId: number;
    assignedUserId: number;
    productShelfIdList: number[] | undefined;
    workActivityId: number;

    constructor(data?: IProductShelfWorkActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.warehouseId = _data["warehouseId"];
            this.storageId = _data["storageId"];
            this.assignedUserId = _data["assignedUserId"];
            if (Array.isArray(_data["productShelfIdList"])) {
                this.productShelfIdList = [] as any;
                for (let item of _data["productShelfIdList"])
                    this.productShelfIdList.push(item);
            }
            this.workActivityId = _data["workActivityId"];
        }
    }

    static fromJS(data: any): ProductShelfWorkActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductShelfWorkActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["warehouseId"] = this.warehouseId;
        data["storageId"] = this.storageId;
        data["assignedUserId"] = this.assignedUserId;
        if (Array.isArray(this.productShelfIdList)) {
            data["productShelfIdList"] = [];
            for (let item of this.productShelfIdList)
                data["productShelfIdList"].push(item);
        }
        data["workActivityId"] = this.workActivityId;
        return data;
    }

    clone(): ProductShelfWorkActivityDto {
        const json = this.toJSON();
        let result = new ProductShelfWorkActivityDto();
        result.init(json);
        return result;
    }
}

export interface IProductShelfWorkActivityDto {
    companyId: number;
    warehouseId: number;
    storageId: number;
    assignedUserId: number;
    productShelfIdList: number[] | undefined;
    workActivityId: number;
}

export class WorkActivityDtoPagedResultDto implements IWorkActivityDtoPagedResultDto {
    totalCount: number;
    items: WorkActivityDto[] | undefined;

    constructor(data?: IWorkActivityDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WorkActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkActivityDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkActivityDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): WorkActivityDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WorkActivityDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWorkActivityDtoPagedResultDto {
    totalCount: number;
    items: WorkActivityDto[] | undefined;
}

export class WorkActivityDetailDto implements IWorkActivityDetailDto {
    workActivity: WorkActivityDto;
    sourceId: number;
    product: ProductDto;
    quantity: number;
    oldShelf: Shelf;
    newShelf: Shelf;
    placedReplenishmentQty: number;
    id: number;

    constructor(data?: IWorkActivityDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workActivity = _data["workActivity"] ? WorkActivityDto.fromJS(_data["workActivity"]) : <any>undefined;
            this.sourceId = _data["sourceId"];
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.oldShelf = _data["oldShelf"] ? Shelf.fromJS(_data["oldShelf"]) : <any>undefined;
            this.newShelf = _data["newShelf"] ? Shelf.fromJS(_data["newShelf"]) : <any>undefined;
            this.placedReplenishmentQty = _data["placedReplenishmentQty"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WorkActivityDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkActivityDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workActivity"] = this.workActivity ? this.workActivity.toJSON() : <any>undefined;
        data["sourceId"] = this.sourceId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["oldShelf"] = this.oldShelf ? this.oldShelf.toJSON() : <any>undefined;
        data["newShelf"] = this.newShelf ? this.newShelf.toJSON() : <any>undefined;
        data["placedReplenishmentQty"] = this.placedReplenishmentQty;
        data["id"] = this.id;
        return data;
    }

    clone(): WorkActivityDetailDto {
        const json = this.toJSON();
        let result = new WorkActivityDetailDto();
        result.init(json);
        return result;
    }
}

export interface IWorkActivityDetailDto {
    workActivity: WorkActivityDto;
    sourceId: number;
    product: ProductDto;
    quantity: number;
    oldShelf: Shelf;
    newShelf: Shelf;
    placedReplenishmentQty: number;
    id: number;
}

export class WorkActionProcessReplenishmentDto implements IWorkActionProcessReplenishmentDto {
    workActivity: WorkActivity;
    workAction: WorkAction;
    processUser: UserDto;
    sourceId: number;
    product: Product;
    quantity: number;
    shelfFrom: Shelf;
    shelfTo: Shelf;
    recommendedProductQty: number;
    productQtyTakenFromAlinanShelf: number;
    productQtyTakenOnReplenishmentShelf: number;
    productQtyLeftOnReplenishmentShelf: number;
    productQtyReplenishedToVarietyShelf: number;
    productQtyAvailableForReplenishment: number;
    processCreationTime: Date | undefined;
    varietyShelf: Shelf;

    constructor(data?: IWorkActionProcessReplenishmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workActivity = _data["workActivity"] ? WorkActivity.fromJS(_data["workActivity"]) : <any>undefined;
            this.workAction = _data["workAction"] ? WorkAction.fromJS(_data["workAction"]) : <any>undefined;
            this.processUser = _data["processUser"] ? UserDto.fromJS(_data["processUser"]) : <any>undefined;
            this.sourceId = _data["sourceId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.shelfFrom = _data["shelfFrom"] ? Shelf.fromJS(_data["shelfFrom"]) : <any>undefined;
            this.shelfTo = _data["shelfTo"] ? Shelf.fromJS(_data["shelfTo"]) : <any>undefined;
            this.recommendedProductQty = _data["recommendedProductQty"];
            this.productQtyTakenFromAlinanShelf = _data["productQtyTakenFromAlinanShelf"];
            this.productQtyTakenOnReplenishmentShelf = _data["productQtyTakenOnReplenishmentShelf"];
            this.productQtyLeftOnReplenishmentShelf = _data["productQtyLeftOnReplenishmentShelf"];
            this.productQtyReplenishedToVarietyShelf = _data["productQtyReplenishedToVarietyShelf"];
            this.productQtyAvailableForReplenishment = _data["productQtyAvailableForReplenishment"];
            this.processCreationTime = _data["processCreationTime"] ? new Date(_data["processCreationTime"].toString()) : <any>undefined;
            this.varietyShelf = _data["varietyShelf"] ? Shelf.fromJS(_data["varietyShelf"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkActionProcessReplenishmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkActionProcessReplenishmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workActivity"] = this.workActivity ? this.workActivity.toJSON() : <any>undefined;
        data["workAction"] = this.workAction ? this.workAction.toJSON() : <any>undefined;
        data["processUser"] = this.processUser ? this.processUser.toJSON() : <any>undefined;
        data["sourceId"] = this.sourceId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["shelfFrom"] = this.shelfFrom ? this.shelfFrom.toJSON() : <any>undefined;
        data["shelfTo"] = this.shelfTo ? this.shelfTo.toJSON() : <any>undefined;
        data["recommendedProductQty"] = this.recommendedProductQty;
        data["productQtyTakenFromAlinanShelf"] = this.productQtyTakenFromAlinanShelf;
        data["productQtyTakenOnReplenishmentShelf"] = this.productQtyTakenOnReplenishmentShelf;
        data["productQtyLeftOnReplenishmentShelf"] = this.productQtyLeftOnReplenishmentShelf;
        data["productQtyReplenishedToVarietyShelf"] = this.productQtyReplenishedToVarietyShelf;
        data["productQtyAvailableForReplenishment"] = this.productQtyAvailableForReplenishment;
        data["processCreationTime"] = this.processCreationTime ? this.processCreationTime.toISOString() : <any>undefined;
        data["varietyShelf"] = this.varietyShelf ? this.varietyShelf.toJSON() : <any>undefined;
        return data;
    }

    clone(): WorkActionProcessReplenishmentDto {
        const json = this.toJSON();
        let result = new WorkActionProcessReplenishmentDto();
        result.init(json);
        return result;
    }
}

export interface IWorkActionProcessReplenishmentDto {
    workActivity: WorkActivity;
    workAction: WorkAction;
    processUser: UserDto;
    sourceId: number;
    product: Product;
    quantity: number;
    shelfFrom: Shelf;
    shelfTo: Shelf;
    recommendedProductQty: number;
    productQtyTakenFromAlinanShelf: number;
    productQtyTakenOnReplenishmentShelf: number;
    productQtyLeftOnReplenishmentShelf: number;
    productQtyReplenishedToVarietyShelf: number;
    productQtyAvailableForReplenishment: number;
    processCreationTime: Date | undefined;
    varietyShelf: Shelf;
}

export class WorkActionProcessReplenishmentDtoPagedResultDto implements IWorkActionProcessReplenishmentDtoPagedResultDto {
    totalCount: number;
    items: WorkActionProcessReplenishmentDto[] | undefined;

    constructor(data?: IWorkActionProcessReplenishmentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WorkActionProcessReplenishmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkActionProcessReplenishmentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkActionProcessReplenishmentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): WorkActionProcessReplenishmentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WorkActionProcessReplenishmentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWorkActionProcessReplenishmentDtoPagedResultDto {
    totalCount: number;
    items: WorkActionProcessReplenishmentDto[] | undefined;
}

export class WorkActionDetailDto implements IWorkActionDetailDto {
    workAction: WorkAction;
    isStarted: boolean;
    startedUser: UserDto;
    startTime: Date;
    isFinished: boolean;
    finishedUser: UserDto;
    finishTime: Date;
    sourceId: number;
    id: number;

    constructor(data?: IWorkActionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workAction = _data["workAction"] ? WorkAction.fromJS(_data["workAction"]) : <any>undefined;
            this.isStarted = _data["isStarted"];
            this.startedUser = _data["startedUser"] ? UserDto.fromJS(_data["startedUser"]) : <any>undefined;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.isFinished = _data["isFinished"];
            this.finishedUser = _data["finishedUser"] ? UserDto.fromJS(_data["finishedUser"]) : <any>undefined;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : <any>undefined;
            this.sourceId = _data["sourceId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WorkActionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkActionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workAction"] = this.workAction ? this.workAction.toJSON() : <any>undefined;
        data["isStarted"] = this.isStarted;
        data["startedUser"] = this.startedUser ? this.startedUser.toJSON() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["isFinished"] = this.isFinished;
        data["finishedUser"] = this.finishedUser ? this.finishedUser.toJSON() : <any>undefined;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["sourceId"] = this.sourceId;
        data["id"] = this.id;
        return data;
    }

    clone(): WorkActionDetailDto {
        const json = this.toJSON();
        let result = new WorkActionDetailDto();
        result.init(json);
        return result;
    }
}

export interface IWorkActionDetailDto {
    workAction: WorkAction;
    isStarted: boolean;
    startedUser: UserDto;
    startTime: Date;
    isFinished: boolean;
    finishedUser: UserDto;
    finishTime: Date;
    sourceId: number;
    id: number;
}

export class WorkActionProcessDtoPagedResultDto implements IWorkActionProcessDtoPagedResultDto {
    totalCount: number;
    items: WorkActionProcessDto[] | undefined;

    constructor(data?: IWorkActionProcessDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WorkActionProcessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkActionProcessDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkActionProcessDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): WorkActionProcessDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WorkActionProcessDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWorkActionProcessDtoPagedResultDto {
    totalCount: number;
    items: WorkActionProcessDto[] | undefined;
}

export class BatchShelfMovementInsertDto implements IBatchShelfMovementInsertDto {
    shelfFromCodeList: string[] | undefined;
    shelfToCodeList: string[] | undefined;
    productCodeList: string[] | undefined;
    quantityList: string[] | undefined;
    companyId: number;
    warehouseId: number;

    constructor(data?: IBatchShelfMovementInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shelfFromCodeList"])) {
                this.shelfFromCodeList = [] as any;
                for (let item of _data["shelfFromCodeList"])
                    this.shelfFromCodeList.push(item);
            }
            if (Array.isArray(_data["shelfToCodeList"])) {
                this.shelfToCodeList = [] as any;
                for (let item of _data["shelfToCodeList"])
                    this.shelfToCodeList.push(item);
            }
            if (Array.isArray(_data["productCodeList"])) {
                this.productCodeList = [] as any;
                for (let item of _data["productCodeList"])
                    this.productCodeList.push(item);
            }
            if (Array.isArray(_data["quantityList"])) {
                this.quantityList = [] as any;
                for (let item of _data["quantityList"])
                    this.quantityList.push(item);
            }
            this.companyId = _data["companyId"];
            this.warehouseId = _data["warehouseId"];
        }
    }

    static fromJS(data: any): BatchShelfMovementInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchShelfMovementInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shelfFromCodeList)) {
            data["shelfFromCodeList"] = [];
            for (let item of this.shelfFromCodeList)
                data["shelfFromCodeList"].push(item);
        }
        if (Array.isArray(this.shelfToCodeList)) {
            data["shelfToCodeList"] = [];
            for (let item of this.shelfToCodeList)
                data["shelfToCodeList"].push(item);
        }
        if (Array.isArray(this.productCodeList)) {
            data["productCodeList"] = [];
            for (let item of this.productCodeList)
                data["productCodeList"].push(item);
        }
        if (Array.isArray(this.quantityList)) {
            data["quantityList"] = [];
            for (let item of this.quantityList)
                data["quantityList"].push(item);
        }
        data["companyId"] = this.companyId;
        data["warehouseId"] = this.warehouseId;
        return data;
    }

    clone(): BatchShelfMovementInsertDto {
        const json = this.toJSON();
        let result = new BatchShelfMovementInsertDto();
        result.init(json);
        return result;
    }
}

export interface IBatchShelfMovementInsertDto {
    shelfFromCodeList: string[] | undefined;
    shelfToCodeList: string[] | undefined;
    productCodeList: string[] | undefined;
    quantityList: string[] | undefined;
    companyId: number;
    warehouseId: number;
}

export class BatchTransferStorageInsertDto implements IBatchTransferStorageInsertDto {
    storageFromCodeList: string[] | undefined;
    storageToCodeList: string[] | undefined;
    shelfFromCodeList: string[] | undefined;
    shelfToCodeList: string[] | undefined;
    productCodeList: string[] | undefined;
    quantityList: string[] | undefined;
    companyId: number;
    warehouseId: number;

    constructor(data?: IBatchTransferStorageInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["storageFromCodeList"])) {
                this.storageFromCodeList = [] as any;
                for (let item of _data["storageFromCodeList"])
                    this.storageFromCodeList.push(item);
            }
            if (Array.isArray(_data["storageToCodeList"])) {
                this.storageToCodeList = [] as any;
                for (let item of _data["storageToCodeList"])
                    this.storageToCodeList.push(item);
            }
            if (Array.isArray(_data["shelfFromCodeList"])) {
                this.shelfFromCodeList = [] as any;
                for (let item of _data["shelfFromCodeList"])
                    this.shelfFromCodeList.push(item);
            }
            if (Array.isArray(_data["shelfToCodeList"])) {
                this.shelfToCodeList = [] as any;
                for (let item of _data["shelfToCodeList"])
                    this.shelfToCodeList.push(item);
            }
            if (Array.isArray(_data["productCodeList"])) {
                this.productCodeList = [] as any;
                for (let item of _data["productCodeList"])
                    this.productCodeList.push(item);
            }
            if (Array.isArray(_data["quantityList"])) {
                this.quantityList = [] as any;
                for (let item of _data["quantityList"])
                    this.quantityList.push(item);
            }
            this.companyId = _data["companyId"];
            this.warehouseId = _data["warehouseId"];
        }
    }

    static fromJS(data: any): BatchTransferStorageInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchTransferStorageInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.storageFromCodeList)) {
            data["storageFromCodeList"] = [];
            for (let item of this.storageFromCodeList)
                data["storageFromCodeList"].push(item);
        }
        if (Array.isArray(this.storageToCodeList)) {
            data["storageToCodeList"] = [];
            for (let item of this.storageToCodeList)
                data["storageToCodeList"].push(item);
        }
        if (Array.isArray(this.shelfFromCodeList)) {
            data["shelfFromCodeList"] = [];
            for (let item of this.shelfFromCodeList)
                data["shelfFromCodeList"].push(item);
        }
        if (Array.isArray(this.shelfToCodeList)) {
            data["shelfToCodeList"] = [];
            for (let item of this.shelfToCodeList)
                data["shelfToCodeList"].push(item);
        }
        if (Array.isArray(this.productCodeList)) {
            data["productCodeList"] = [];
            for (let item of this.productCodeList)
                data["productCodeList"].push(item);
        }
        if (Array.isArray(this.quantityList)) {
            data["quantityList"] = [];
            for (let item of this.quantityList)
                data["quantityList"].push(item);
        }
        data["companyId"] = this.companyId;
        data["warehouseId"] = this.warehouseId;
        return data;
    }

    clone(): BatchTransferStorageInsertDto {
        const json = this.toJSON();
        let result = new BatchTransferStorageInsertDto();
        result.init(json);
        return result;
    }
}

export interface IBatchTransferStorageInsertDto {
    storageFromCodeList: string[] | undefined;
    storageToCodeList: string[] | undefined;
    shelfFromCodeList: string[] | undefined;
    shelfToCodeList: string[] | undefined;
    productCodeList: string[] | undefined;
    quantityList: string[] | undefined;
    companyId: number;
    warehouseId: number;
}

export class TransferHeaderRequestDtoPagedResultDto implements ITransferHeaderRequestDtoPagedResultDto {
    totalCount: number;
    items: TransferHeaderRequestDto[] | undefined;

    constructor(data?: ITransferHeaderRequestDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TransferHeaderRequestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransferHeaderRequestDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferHeaderRequestDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): TransferHeaderRequestDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TransferHeaderRequestDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITransferHeaderRequestDtoPagedResultDto {
    totalCount: number;
    items: TransferHeaderRequestDto[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
